(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (!x.$)
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}



// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dr.bt === region.d5.bt)
	{
		return 'on line ' + region.dr.bt;
	}
	return 'on lines ' + region.dr.bt + ' through ' + region.d5.bt;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800)
			+
			String.fromCharCode(code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

var _Json_decodeInt = { $: 2 };
var _Json_decodeBool = { $: 3 };
var _Json_decodeFloat = { $: 4 };
var _Json_decodeValue = { $: 5 };
var _Json_decodeString = { $: 6 };

function _Json_decodeList(decoder) { return { $: 7, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 8, b: decoder }; }

function _Json_decodeNull(value) { return { $: 9, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 10,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 11,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 12,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 13,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 14,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 15,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 3:
			return (typeof value === 'boolean')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a BOOL', value);

		case 2:
			if (typeof value !== 'number') {
				return _Json_expecting('an INT', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return $elm$core$Result$Ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return $elm$core$Result$Ok(value);
			}

			return _Json_expecting('an INT', value);

		case 4:
			return (typeof value === 'number')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a FLOAT', value);

		case 6:
			return (typeof value === 'string')
				? $elm$core$Result$Ok(value)
				: (value instanceof String)
					? $elm$core$Result$Ok(value + '')
					: _Json_expecting('a STRING', value);

		case 9:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 5:
			return $elm$core$Result$Ok(_Json_wrap(value));

		case 7:
			if (!Array.isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 8:
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 10:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 11:
			var index = decoder.e;
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 12:
			if (typeof value !== 'object' || value === null || Array.isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 13:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 14:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 15:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 3:
		case 2:
		case 4:
		case 6:
		case 5:
			return true;

		case 9:
			return x.c === y.c;

		case 7:
		case 8:
		case 12:
			return _Json_equality(x.b, y.b);

		case 10:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 11:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 13:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 14:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 15:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gm,
		impl.hP,
		impl.ht,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		c6: func(record.c6),
		e4: record.e4,
		eI: record.eI
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.c6;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.e4;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.eI) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gm,
		impl.hP,
		impl.ht,
		function(sendToApp, initialModel) {
			var view = impl.hS;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gm,
		impl.hP,
		impl.ht,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dj && impl.dj(sendToApp)
			var view = impl.hS;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bX);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.bO) && (_VirtualDom_doc.title = title = doc.bO);
			});
		}
	);
});



// ANIMATION


var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.g0;
	var onUrlRequest = impl.g1;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dj: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.download)
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eK === next.eK
							&& curr.ei === next.ei
							&& curr.eH.a === next.eH.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		gm: function(flags)
		{
			return A3(impl.gm, flags, _Browser_getUrl(), key);
		},
		hS: impl.hS,
		hP: impl.hP,
		ht: impl.ht
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { bh: 'hidden', a6: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { bh: 'mozHidden', a6: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { bh: 'msHidden', a6: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { bh: 'webkitHidden', a6: 'webkitvisibilitychange' }
		: { bh: 'hidden', a6: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		eW: _Browser_getScene(),
		ff: {
			cC: _Browser_window.pageXOffset,
			cD: _Browser_window.pageYOffset,
			fh: _Browser_doc.documentElement.clientWidth,
			aI: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fh: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		aI: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			eW: {
				fh: node.scrollWidth,
				aI: node.scrollHeight
			},
			ff: {
				cC: node.scrollLeft,
				cD: node.scrollTop,
				fh: node.clientWidth,
				aI: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			eW: _Browser_getScene(),
			ff: {
				cC: x,
				cD: y,
				fh: _Browser_doc.documentElement.clientWidth,
				aI: _Browser_doc.documentElement.clientHeight
			},
			d2: {
				cC: x + rect.left,
				cD: y + rect.top,
				fh: rect.width,
				aI: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.gO) { flags += 'm'; }
	if (options.fA) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// SEND REQUEST

var _Http_toTask = F2(function(request, maybeProgress)
{
	return _Scheduler_binding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		_Http_configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_Scheduler_fail($elm$http$Http$NetworkError));
		});
		xhr.addEventListener('timeout', function() {
			callback(_Scheduler_fail($elm$http$Http$Timeout));
		});
		xhr.addEventListener('load', function() {
			callback(_Http_handleResponse(xhr, request.f1.a));
		});

		try
		{
			xhr.open(request.gM, request.hQ, true);
		}
		catch (e)
		{
			return callback(_Scheduler_fail($elm$http$Http$BadUrl(request.hQ)));
		}

		_Http_configureRequest(xhr, request);

		var body = request.bX;
		xhr.send($elm$http$Http$Internal$isStringBody(body)
			? (xhr.setRequestHeader('Content-Type', body.a), body.b)
			: body.a
		);

		return function() { xhr.abort(); };
	});
});

function _Http_configureProgress(xhr, maybeProgress)
{
	if (!$elm$core$Maybe$isJust(maybeProgress))
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_Scheduler_rawSpawn(maybeProgress.a({
			fw: event.loaded,
			fx: event.total
		}));
	});
}

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ge; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}

	xhr.responseType = request.f1.b;
	xhr.withCredentials = request.hU;

	$elm$core$Maybe$isJust(request.hE) && (xhr.timeout = request.hE.a);
}


// RESPONSES

function _Http_handleResponse(xhr, responseToResult)
{
	var response = _Http_toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _Scheduler_fail($elm$http$Http$BadStatus(response));
	}

	var result = responseToResult(response);

	if ($elm$core$Result$isOk(result))
	{
		return _Scheduler_succeed(result.a);
	}
	else
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(A2($elm$http$Http$BadPayload, result.a, response));
	}
}

function _Http_toResponse(xhr)
{
	return {
		hQ: xhr.responseURL,
		e3: { dN: xhr.status, c6: xhr.statusText },
		ge: _Http_parseHeaders(xhr.getAllResponseHeaders()),
		bX: xhr.response
	};
}

function _Http_parseHeaders(rawHeaders)
{
	var headers = $elm$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function _Http_expectStringResponse(responseToResult)
{
	return {
		$: 0,
		b: 'text',
		a: responseToResult
	};
}

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		b: expect.b,
		a: function(response) {
			var convertedResponse = expect.a(response);
			return A2($elm$core$Result$map, func, convertedResponse);
		}
	};
});


// BODY

function _Http_multipart(parts)
{


	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}

	return $elm$http$Http$Internal$FormDataBody(formData);
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.d$))
		{
			lang = options.d$.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.ga.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.hw,
		breaks: gfm && gfm.fv,
		sanitize: options.hj,
		smartypants: options.hq
	};
}
var $author$project$App$Main$ChangedUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Main$ClickedLink = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.k) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.o);
		} else {
			var treeLen = builder.k * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.k);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.o);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{p: nodeList, k: (len / $elm$core$Array$branchFactor) | 0, o: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ed: fragment, ei: host, eF: path, eH: port_, eK: protocol, hb: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$App$Main$Flags = F3(
	function (cachedUser, uuidPool, accessToken) {
		return {a: accessToken, dI: cachedUser, aA: uuidPool};
	});
var $author$project$App$Main$GetUserResponse = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$App$Main$Blank = {$: 0};
var $author$project$App$Main$Loaded = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$App$Main$defaultModel = F2(
	function (flags, navKey) {
		return {
			a: flags.a,
			cj: navKey,
			l: $author$project$App$Main$Loaded($author$project$App$Main$Blank),
			aU: false,
			X: false,
			Y: A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2($elm$core$Maybe$map, $krisajenkins$remotedata$RemoteData$succeed, flags.dI)),
			cA: $elm$core$Maybe$Nothing,
			aA: flags.aA
		};
	});
var $author$project$Data$User$User = F2(
	function (upn, tenants) {
		return {hB: tenants, fd: upn};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Data$Tenant$Tenant = F5(
	function (id, name, active, read, write) {
		return {aC: active, bj: id, ev: name, eN: read, fi: write};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$UUID$UUID = $elm$core$Basics$identity;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {gl: index, gG: match, ey: number, hs: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{fA: false, gO: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Util$Regex$regex = function (pattern) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString(pattern));
};
var $author$project$Util$Regex$contains = F2(
	function (pattern, haystack) {
		return A2(
			$elm$regex$Regex$contains,
			$author$project$Util$Regex$regex(pattern),
			haystack);
	});
var $author$project$UUID$uuidPattern = '^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{4,4}-[0-9A-Fa-f]{12,12}$';
var $author$project$UUID$isValid = function (str) {
	return A2($author$project$Util$Regex$contains, $author$project$UUID$uuidPattern, str) || (str === '00000000-0000-0000-0000-000000000000');
};
var $author$project$UUID$fromString = function (str) {
	return $author$project$UUID$isValid(str) ? $elm$core$Maybe$Just(str) : $elm$core$Maybe$Nothing;
};
var $author$project$UUID$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$UUID$fromString(str);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Invalid UUID string: \'' + (str + '\''));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Tenant$tenantDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'write',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'read',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$UUID$decoder,
					$elm$json$Json$Decode$succeed($author$project$Data$Tenant$Tenant))))));
var $author$project$Data$User$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tenants',
	$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'upn',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$User$User)));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$App$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accessToken',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uuidPool',
		$elm$json$Json$Decode$list($author$project$UUID$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cachedUser',
			$elm$json$Json$Decode$maybe($author$project$Data$User$decoder),
			$elm$json$Json$Decode$succeed($author$project$App$Main$Flags))));
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$App$Ports$getAccessToken = _Platform_outgoingPort(
	'getAccessToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$App$Main$GetUserSettings = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Data$Locker$LockerItem = F3(
	function (entity, version, value) {
		return {ca: entity, hR: value, dx: version};
	});
var $author$project$Data$Locker$Personal = 1;
var $author$project$Data$Locker$SettingsEntity = 1;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Data$User$defaultUserSettings = {
	gC: $elm$time$Time$millisToPosix(0)
};
var $author$project$Data$Locker$entityToString = function (entity) {
	if (!entity) {
		return 'widget_collection';
	} else {
		return 'settings';
	}
};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Data$Locker$decoder = function (valueDecoder) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		valueDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'version',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'entity',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Locker$LockerItem))));
};
var $elm$http$Http$Internal$EmptyBody = {$: 0};
var $elm$http$Http$emptyBody = $elm$http$Http$Internal$EmptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Internal$FormDataBody = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$Internal$isStringBody = function (body) {
	if (body.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = _Http_expectStringResponse;
var $elm$http$Http$expectJson = function (decoder) {
	return $elm$http$Http$expectStringResponse(
		function (response) {
			var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, response.bX);
			if (_v0.$ === 1) {
				var decodeError = _v0.a;
				return $elm$core$Result$Err(
					$elm$json$Json$Decode$errorToString(decodeError));
			} else {
				var value = _v0.a;
				return $elm$core$Result$Ok(value);
			}
		});
};
var $elm$http$Http$Internal$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Internal$Header;
var $elm$http$Http$Internal$Request = $elm$core$Basics$identity;
var $elm$http$Http$request = $elm$core$Basics$identity;
var $author$project$Request$Locker$urlForOwner = function (owner) {
	return '/gym/lockers/' + function () {
		if (!owner) {
			return 'team';
		} else {
			return 'me';
		}
	}();
};
var $author$project$Request$Locker$fetchItem = F4(
	function (accessToken, entity, owner, itemValueDecoder) {
		var url = $author$project$Request$Locker$urlForOwner(owner) + ('/' + entity);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(
					$author$project$Data$Locker$decoder(itemValueDecoder)),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Util$Http$isResourceNotFound = function (err) {
	if (err.$ === 3) {
		var response = err.a;
		var _v1 = response.e3.dN;
		if (_v1 === 404) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $elm$http$Http$toTask = function (_v0) {
	var request_ = _v0;
	return A2(_Http_toTask, request_, $elm$core$Maybe$Nothing);
};
var $author$project$Data$User$UserSettings = function (lastReadNews) {
	return {gC: lastReadNews};
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{dO: col, f: s0.f, g: s0.g, c: offset, eU: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.eU, s.dO, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Problem = F4(
	function (row, col, problem, contextStack) {
		return {dO: col, fQ: contextStack, g9: problem, eU: row};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$Problem, s.eU, s.dO, x, s.f));
	});
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	return A2(
		$elm$parser$Parser$andThen,
		function (str) {
			if (_Utils_eq(
				$elm$core$String$length(str),
				quantity)) {
				var _v0 = $elm$core$String$toInt(str);
				if (!_v0.$) {
					var intVal = _v0.a;
					return $elm$parser$Parser$succeed(intVal);
				} else {
					return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return $elm$parser$Parser$problem(
					'Expected ' + ($elm$core$String$fromInt(quantity) + (' digits, but got ' + $elm$core$String$fromInt(
						$elm$core$String$length(str)))));
			}
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.eU, s.dO, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dO: newCol, f: s.f, g: s.g, c: newOffset, eU: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4),
					$elm$parser$Parser$symbol('-'))),
			A2(
				$elm$parser$Parser$ignorer,
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
				$elm$parser$Parser$symbol('-'))),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts = F3(
	function (multiplier, hours, minutes) {
		return multiplier * ((hours * 60) + minutes);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts),
						A2(
							$elm$parser$Parser$ignorer,
							$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs,
							$elm$parser$Parser$symbol('T'))),
					A2(
						$elm$parser$Parser$ignorer,
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
						$elm$parser$Parser$symbol(':'))),
				A2(
					$elm$parser$Parser$ignorer,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
					$elm$parser$Parser$symbol(':'))),
			$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('.')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(3)),
					$elm$parser$Parser$succeed(0)
				]))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return 0;
				},
				$elm$parser$Parser$symbol('Z')),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$map,
									function (_v1) {
										return 1;
									},
									$elm$parser$Parser$symbol('+')),
									A2(
									$elm$parser$Parser$map,
									function (_v2) {
										return -1;
									},
									$elm$parser$Parser$symbol('-'))
								]))),
					A2(
						$elm$parser$Parser$ignorer,
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
						$elm$parser$Parser$symbol(':'))),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2))
			])));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dO: col, g9: problem, eU: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.eU, p.dO, p.g9);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dO: 1, f: _List_Nil, g: 1, c: 0, eU: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Util$JsonDecode$posixTime = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (!_v0.$) {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		} else {
			return $elm$json$Json$Decode$fail('could not parse \'' + (str + '\' as an ISO8601 date string'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$User$userSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lastReadNews',
	$author$project$Util$JsonDecode$posixTime,
	$elm$json$Json$Decode$succeed($author$project$Data$User$UserSettings));
var $author$project$Request$User$userSettingsTask = function (accessToken) {
	var entityName = $author$project$Data$Locker$entityToString(1);
	var onLoadFailed = function (error) {
		return $author$project$Util$Http$isResourceNotFound(error) ? $elm$core$Task$succeed(
			A3($author$project$Data$Locker$LockerItem, entityName, 0, $author$project$Data$User$defaultUserSettings)) : $elm$core$Task$fail(error);
	};
	return A2(
		$elm$core$Task$onError,
		onLoadFailed,
		$elm$http$Http$toTask(
			A4($author$project$Request$Locker$fetchItem, accessToken, entityName, 1, $author$project$Data$User$userSettingsDecoder)));
};
var $author$project$App$Main$getUserSettings = function (accessToken) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$App$Main$GetUserSettings,
		A2(
			$elm$core$Task$map,
			function ($) {
				return $.hR;
			},
			$author$project$Request$User$userSettingsTask(accessToken)));
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$App$Route$Home = {$: 0};
var $author$project$App$Route$NotFound = {$: 29};
var $author$project$App$Route$makePathBased = F2(
	function (fragment, url) {
		var _v0 = function () {
			var _v1 = A2($elm$core$String$split, '?', fragment);
			if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
				var before = _v1.a;
				var _v2 = _v1.b;
				var after = _v2.a;
				return _Utils_Tuple2(
					before,
					$elm$core$Maybe$Just(after));
			} else {
				return _Utils_Tuple2(fragment, $elm$core$Maybe$Nothing);
			}
		}();
		var path = _v0.a;
		var query = _v0.b;
		return _Utils_update(
			url,
			{ed: $elm$core$Maybe$Nothing, eF: path, hb: query});
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {ag: frag, ar: params, ad: unvisited, hR: value, aB: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aB;
		var unvisited = _v0.ad;
		var params = _v0.ar;
		var frag = _v0.ag;
		var value = _v0.hR;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aB;
			var unvisited = _v1.ad;
			var params = _v1.ar;
			var frag = _v1.ag;
			var value = _v1.hR;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ad;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.hR);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.hR);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.eF),
					$elm$url$Url$Parser$prepareQuery(url.hb),
					url.ed,
					$elm$core$Basics$identity)));
	});
var $author$project$App$Route$SearchIncidents = function (a) {
	return {$: 1, a: a};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $author$project$UUID$nil = '00000000-0000-0000-0000-000000000000';
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.aB;
		var unvisited = _v1.ad;
		var params = _v1.ar;
		var frag = _v1.ag;
		var value = _v1.hR;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aB;
		var unvisited = _v0.ad;
		var params = _v0.ar;
		var frag = _v0.ag;
		var value = _v0.hR;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$App$Route$uuidQueryParam = function (paramName) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		paramName,
		function (strings) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$UUID$fromString,
				$elm$core$List$head(strings));
		});
};
var $author$project$App$Route$ViewIncident = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$App$Route$viewIncident = function (uuid) {
	return A2($author$project$App$Route$ViewIncident, uuid, $elm$core$Maybe$Nothing);
};
var $author$project$App$Route$parseLegacyUrl = function (url) {
	var legacyInstallIdParser = A2(
		$elm$url$Url$Parser$map,
		$author$project$App$Route$SearchIncidents,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s('incidents'),
			$elm$url$Url$Parser$Query$string('installId')));
	var legacyIncidentParser = A2(
		$elm$url$Url$Parser$map,
		$author$project$App$Route$viewIncident,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s('incidents'),
			A2(
				$elm$url$Url$Parser$Query$map,
				$elm$core$Maybe$withDefault($author$project$UUID$nil),
				$author$project$App$Route$uuidQueryParam('incident'))));
	var route = A2($elm$url$Url$Parser$parse, legacyIncidentParser, url);
	if ((!route.$) && (route.a.$ === 3)) {
		var _v1 = route.a;
		var uuid = _v1.a;
		return _Utils_eq(uuid, $author$project$UUID$nil) ? A2($elm$url$Url$Parser$parse, legacyInstallIdParser, url) : route;
	} else {
		return route;
	}
};
var $author$project$App$Route$Admin = {$: 17};
var $author$project$App$Route$AdvancedSearch = {$: 2};
var $author$project$App$Route$CloneClassifier = function (a) {
	return {$: 9, a: a};
};
var $author$project$App$Route$CloneRemedy = function (a) {
	return {$: 15, a: a};
};
var $author$project$App$Route$CreateGroup = {$: 42};
var $author$project$App$Route$EditCapability = function (a) {
	return {$: 23, a: a};
};
var $author$project$App$Route$EditClassifier = function (a) {
	return {$: 8, a: a};
};
var $author$project$App$Route$EditGroup = function (a) {
	return {$: 43, a: a};
};
var $author$project$App$Route$EditLogConfig = function (a) {
	return {$: 36, a: a};
};
var $author$project$App$Route$EditRemedy = function (a) {
	return {$: 14, a: a};
};
var $author$project$App$Route$EditScrubber = function (a) {
	return {$: 26, a: a};
};
var $author$project$App$Route$EditWidget = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$App$Route$EditWidgetCollection = {$: 18};
var $author$project$App$Route$EditWidgetSection = function (a) {
	return {$: 19, a: a};
};
var $author$project$App$Route$EnterTheBasement = {$: 28};
var $author$project$App$Route$ListCapabilities = {$: 22};
var $author$project$App$Route$ListClassifiers = {$: 6};
var $author$project$App$Route$ListGroups = {$: 40};
var $author$project$App$Route$ListLogConfigs = {$: 34};
var $author$project$App$Route$ListRemedies = {$: 11};
var $author$project$App$Route$ListScrubbers = {$: 25};
var $author$project$App$Route$NewCapability = {$: 24};
var $author$project$App$Route$NewClassifier = function (a) {
	return {$: 10, a: a};
};
var $author$project$App$Route$NewLogConfig = {$: 35};
var $author$project$App$Route$NewRemedy = {$: 16};
var $author$project$App$Route$NewScrubber = {$: 27};
var $author$project$App$Route$NewWidget = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$App$Route$Onboarding = {$: 30};
var $author$project$App$Route$TenantSettings = {$: 38};
var $author$project$App$Route$ViewClassifier = function (a) {
	return {$: 7, a: a};
};
var $author$project$App$Route$ViewClassifierHistory = function (a) {
	return {$: 39, a: a};
};
var $author$project$App$Route$ViewDocs = function (a) {
	return {$: 32, a: a};
};
var $author$project$App$Route$ViewGroup = function (a) {
	return {$: 41, a: a};
};
var $author$project$App$Route$ViewIncidentEasyId = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$Route$ViewLogFile = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$App$Route$ViewNews = {$: 37};
var $author$project$App$Route$ViewRemedy = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$App$Route$ViewRemedyHistory = function (a) {
	return {$: 13, a: a};
};
var $author$project$App$Route$ViewSDKs = {$: 31};
var $author$project$App$Route$ViewTimeline = function (a) {
	return {$: 5, a: a};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aB;
			var unvisited = _v0.ad;
			var params = _v0.ar;
			var frag = _v0.ag;
			var value = _v0.hR;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $author$project$App$Route$encodedUriStringParser = A2($elm$url$Url$Parser$custom, 'URI_ENCODED_STRING', $elm$url$Url$percentDecode);
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Data$Docs$APISection = 14;
var $author$project$Data$Docs$CapabilitySection = 7;
var $author$project$Data$Docs$ClassifierSection = 4;
var $author$project$Data$Docs$ConfigurationSection = 5;
var $author$project$Data$Docs$FileSection = 3;
var $author$project$Data$Docs$GDPRSection = 13;
var $author$project$Data$Docs$GroupSection = 15;
var $author$project$Data$Docs$IncidentSection = 1;
var $author$project$Data$Docs$IntuneSection = 10;
var $author$project$Data$Docs$OnboardingSection = 11;
var $author$project$Data$Docs$RemedySection = 6;
var $author$project$Data$Docs$SDKSection = 12;
var $author$project$Data$Docs$ScrubberSection = 9;
var $author$project$Data$Docs$SupportSection = 0;
var $author$project$Data$Docs$TopicsSection = 2;
var $author$project$Data$Docs$WidgetSection = 8;
var $author$project$Data$Docs$stringToSection = function (s) {
	switch (s) {
		case 'support':
			return $elm$core$Maybe$Just(0);
		case 'topics':
			return $elm$core$Maybe$Just(2);
		case 'incidents':
			return $elm$core$Maybe$Just(1);
		case 'files':
			return $elm$core$Maybe$Just(3);
		case 'classifiers':
			return $elm$core$Maybe$Just(4);
		case 'remedies':
			return $elm$core$Maybe$Just(6);
		case 'capabilities':
			return $elm$core$Maybe$Just(7);
		case 'configurations':
			return $elm$core$Maybe$Just(5);
		case 'widgets':
			return $elm$core$Maybe$Just(8);
		case 'scrubbers':
			return $elm$core$Maybe$Just(9);
		case 'intune':
			return $elm$core$Maybe$Just(10);
		case 'onboarding':
			return $elm$core$Maybe$Just(11);
		case 'sdk':
			return $elm$core$Maybe$Just(12);
		case 'gdpr':
			return $elm$core$Maybe$Just(13);
		case 'api':
			return $elm$core$Maybe$Just(14);
		case 'groups':
			return $elm$core$Maybe$Just(15);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Docs$sectionParser = A2($elm$url$Url$Parser$custom, 'DOCS_SECTION', $author$project$Data$Docs$stringToSection);
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Data$Classifier$Type$Drill2Type = 1;
var $author$project$Data$Classifier$Type$JavascriptType = 0;
var $author$project$Data$Classifier$Type$RandomType = 3;
var $author$project$Data$Classifier$Type$RegexType = 2;
var $author$project$Data$Classifier$Type$typeParser = A2(
	$elm$url$Url$Parser$custom,
	'CLASSIFIER_TYPE',
	function (str) {
		switch (str) {
			case 'javascript':
				return $elm$core$Maybe$Just(0);
			case 'drill2':
				return $elm$core$Maybe$Just(1);
			case 'regex':
				return $elm$core$Maybe$Just(2);
			case 'random':
				return $elm$core$Maybe$Just(3);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Widget$Type$DynamicListType = 1;
var $author$project$Data$Widget$Type$DynamicTableType = 2;
var $author$project$Data$Widget$Type$GenericType = 3;
var $author$project$Data$Widget$Type$StaticTableType = 0;
var $author$project$Data$Widget$Type$stringToType = function (str) {
	switch (str) {
		case 'static_table':
			return $elm$core$Maybe$Just(0);
		case 'dynamic_list':
			return $elm$core$Maybe$Just(1);
		case 'dynamic_table':
			return $elm$core$Maybe$Just(2);
		case 'generic_json':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Widget$Type$typeParser = A2($elm$url$Url$Parser$custom, 'WIDGET_TYPE', $author$project$Data$Widget$Type$stringToType);
var $author$project$UUID$urlParser = A2($elm$url$Url$Parser$custom, 'UUID', $author$project$UUID$fromString);
var $author$project$App$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$App$Route$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$AdvancedSearch,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('search'),
				$elm$url$Url$Parser$s('advanced'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$SearchIncidents,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('incidents'),
				$elm$url$Url$Parser$Query$string('query'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewIncident,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('incidents'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$author$project$UUID$urlParser,
					$elm$url$Url$Parser$Query$string('tab')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewIncidentEasyId,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('incidents'),
				$author$project$App$Route$encodedUriStringParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewTimeline,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('timeline'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListClassifiers,
			$elm$url$Url$Parser$s('classifiers')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewClassifier,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('classifiers'),
				$author$project$UUID$urlParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditClassifier,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('classifiers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('edit'),
					$author$project$UUID$urlParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$CloneClassifier,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('classifiers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('clone'),
					$author$project$UUID$urlParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewClassifier,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('classifiers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new'),
					$author$project$Data$Classifier$Type$typeParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListRemedies,
			$elm$url$Url$Parser$s('remedies')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewRemedy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('remedies'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditRemedy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('remedies'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('edit'),
					$author$project$UUID$urlParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewRemedyHistory,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('remedies'),
				$author$project$UUID$urlParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewRemedy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('remedies'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$UUID$urlParser,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('version'),
						$elm$url$Url$Parser$int)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$CloneRemedy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('remedies'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('clone'),
					$author$project$UUID$urlParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$Admin,
			$elm$url$Url$Parser$s('admin')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditWidgetCollection,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('widgets'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditWidgetSection,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('widgets'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditWidget,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('widgets'),
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $author$project$UUID$urlParser)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewWidget,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('widgets'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('new'),
							$author$project$Data$Widget$Type$typeParser))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListCapabilities,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('capabilities'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditCapability,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('capabilities'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('edit'),
						$author$project$App$Route$encodedUriStringParser)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewCapability,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('capabilities'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListScrubbers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('scrubbers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditScrubber,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('scrubbers'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('edit'),
						$author$project$UUID$urlParser)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewScrubber,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('scrubbers'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EnterTheBasement,
			$elm$url$Url$Parser$s('basement')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$Onboarding,
			$elm$url$Url$Parser$s('onboarding')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewSDKs,
			$elm$url$Url$Parser$s('sdk')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewDocs($elm$core$Maybe$Nothing),
			$elm$url$Url$Parser$s('docs')),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$App$Route$ViewDocs, $elm$core$Maybe$Just),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				$author$project$Data$Docs$sectionParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewLogFile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('incidents'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$UUID$urlParser,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('files'),
						$author$project$App$Route$encodedUriStringParser)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListLogConfigs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('configurations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$NewLogConfig,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('configurations'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditLogConfig,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('configurations'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('edit'),
						$author$project$UUID$urlParser)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewNews,
			$elm$url$Url$Parser$s('news')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$TenantSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('tenant'),
				$elm$url$Url$Parser$s('settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewClassifierHistory,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('classifiers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('history'),
					$author$project$UUID$urlParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ListGroups,
			$elm$url$Url$Parser$s('groups')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$ViewGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('groups'),
				$author$project$UUID$urlParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$CreateGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('groups'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$App$Route$EditGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('groups'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('edit'),
					$author$project$UUID$urlParser)))
		]));
var $author$project$App$Route$fromUrl = function (url) {
	var route = function () {
		var _v0 = url.ed;
		if (_v0.$ === 1) {
			return (url.eF === '/incidents') ? $author$project$App$Route$parseLegacyUrl(url) : A2(
				$elm$url$Url$Parser$parse,
				A2($elm$url$Url$Parser$map, $author$project$App$Route$Home, $elm$url$Url$Parser$top),
				url);
		} else {
			var frag = _v0.a;
			return A2(
				$elm$url$Url$Parser$parse,
				$author$project$App$Route$parser,
				A2($author$project$App$Route$makePathBased, frag, url));
		}
	}();
	return A2($elm$core$Maybe$withDefault, $author$project$App$Route$NotFound, route);
};
var $author$project$Data$Docs$sectionToString = function (section) {
	switch (section) {
		case 0:
			return 'support';
		case 2:
			return 'topics';
		case 1:
			return 'incidents';
		case 3:
			return 'files';
		case 4:
			return 'classifiers';
		case 5:
			return 'configurations';
		case 6:
			return 'remedies';
		case 8:
			return 'widgets';
		case 7:
			return 'capabilities';
		case 9:
			return 'scrubbers';
		case 10:
			return 'intune';
		case 11:
			return 'onboarding';
		case 12:
			return 'sdk';
		case 13:
			return 'gdpr';
		case 14:
			return 'api';
		default:
			return 'groups';
	}
};
var $author$project$App$Route$routeToBreadcrumb = function (route) {
	switch (route.$) {
		case 0:
			return 'Home';
		case 29:
			return 'Not Found';
		case 1:
			return 'Search Incidents';
		case 2:
			return 'Advanced Search';
		case 3:
			return 'Incident';
		case 4:
			return 'Incident';
		case 33:
			return 'Log File';
		case 5:
			return 'Timeline';
		case 6:
			return 'Classifiers';
		case 7:
			return 'View Classifier';
		case 8:
			return 'Edit Classifier';
		case 9:
			return 'Clone Classifier';
		case 10:
			return 'New Classifier';
		case 11:
			return 'Remedies';
		case 13:
			return 'Remedy History';
		case 12:
			var version = route.b;
			return 'Version ' + $elm$core$String$fromInt(version);
		case 14:
			return 'Edit Remedy';
		case 15:
			return 'Clone Remedy';
		case 16:
			return 'New Remedy';
		case 17:
			return 'Admin';
		case 18:
			return 'Incident Display';
		case 19:
			return 'Section';
		case 20:
			return 'Edit Widget';
		case 21:
			return 'New Widget';
		case 22:
			return 'Capabilities';
		case 23:
			return 'Edit Capability';
		case 24:
			return 'New Capability';
		case 25:
			return 'Scrubbers';
		case 26:
			return 'Edit Scrubber';
		case 27:
			return 'New Scrubber';
		case 28:
			return 'Basement';
		case 30:
			return 'Onboarding';
		case 31:
			return 'SDKs';
		case 32:
			var section = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Docs',
				A2($elm$core$Maybe$map, $author$project$Data$Docs$sectionToString, section));
		case 34:
			return 'Configurations';
		case 35:
			return 'New Configuration';
		case 36:
			return 'Edit Configuration';
		case 37:
			return 'News';
		case 38:
			return 'Tenant Info';
		case 39:
			return 'Classifier History';
		case 40:
			return 'Groups';
		case 41:
			return 'View Group';
		case 42:
			return 'New Group';
		default:
			return 'Edit Group';
	}
};
var $author$project$App$Main$AdminLoaded = function (a) {
	return {$: 25, a: a};
};
var $author$project$App$Main$AdvancedSearchLoaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$App$Main$BasementLoaded = function (a) {
	return {$: 33, a: a};
};
var $author$project$App$Main$CapabilitiesLoaded = function (a) {
	return {$: 29, a: a};
};
var $author$project$App$Main$CapabilityEditorLoaded = function (a) {
	return {$: 30, a: a};
};
var $author$project$App$Main$ClassifierEditorLoaded = function (a) {
	return {$: 20, a: a};
};
var $author$project$App$Main$ClassifierViewerLoaded = function (a) {
	return {$: 19, a: a};
};
var $author$project$App$Main$ClassifiersLoaded = function (a) {
	return {$: 18, a: a};
};
var $author$project$App$Main$DocsLoaded = function (a) {
	return {$: 36, a: a};
};
var $author$project$App$Main$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Main$GroupCreatorLoaded = function (a) {
	return {$: 44, a: a};
};
var $author$project$App$Main$GroupEditorLoaded = function (a) {
	return {$: 45, a: a};
};
var $author$project$App$Main$GroupListLoaded = function (a) {
	return {$: 42, a: a};
};
var $author$project$App$Main$GroupViewerLoaded = function (a) {
	return {$: 43, a: a};
};
var $author$project$App$Main$HomeLoaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$App$Main$IncidentLoaded = function (a) {
	return {$: 15, a: a};
};
var $author$project$App$Main$LogConfigEditorLoaded = function (a) {
	return {$: 38, a: a};
};
var $author$project$App$Main$LogConfigsLoaded = function (a) {
	return {$: 37, a: a};
};
var $author$project$App$Main$LogFileLoaded = function (a) {
	return {$: 16, a: a};
};
var $author$project$App$Main$NewsLoaded = function (a) {
	return {$: 39, a: a};
};
var $author$project$App$Main$NotFound = {$: 1};
var $author$project$App$Main$OnboardingLoaded = function (a) {
	return {$: 34, a: a};
};
var $author$project$App$Main$RemediesLoaded = function (a) {
	return {$: 21, a: a};
};
var $author$project$App$Main$RemedyEditorLoaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$App$Main$RemedyHistoryLoaded = function (a) {
	return {$: 24, a: a};
};
var $author$project$App$Main$RemedyViewerLoaded = function (a) {
	return {$: 23, a: a};
};
var $author$project$App$Main$ScrubberEditorLoaded = function (a) {
	return {$: 32, a: a};
};
var $author$project$App$Main$ScrubbersLoaded = function (a) {
	return {$: 31, a: a};
};
var $author$project$App$Main$SdkListLoaded = function (a) {
	return {$: 35, a: a};
};
var $author$project$App$Main$SearchIncidentsLoaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$App$Main$TenantSettingsLoaded = function (a) {
	return {$: 40, a: a};
};
var $author$project$App$Main$TimelineLoaded = function (a) {
	return {$: 17, a: a};
};
var $author$project$App$Main$TransitioningFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Main$ViewClassifierHistoryLoaded = function (a) {
	return {$: 41, a: a};
};
var $author$project$App$Main$WidgetEditorLoaded = function (a) {
	return {$: 28, a: a};
};
var $author$project$App$Main$WidgetSectionsLoaded = function (a) {
	return {$: 27, a: a};
};
var $author$project$App$Main$WidgetsLoaded = function (a) {
	return {$: 26, a: a};
};
var $author$project$App$Main$getPage = function (pageState) {
	if (!pageState.$) {
		var page = pageState.a;
		return page;
	} else {
		var page = pageState.a;
		return page;
	}
};
var $author$project$Page$Admin$init = function () {
	var makeModel = {f$: _List_Nil};
	return $elm$core$Task$succeed(makeModel);
}();
var $author$project$Page$AdvancedSearch$defaultModel = function (accessToken) {
	return {a: accessToken, f$: _List_Nil, bE: '', hg: $elm$core$Maybe$Nothing};
};
var $author$project$Page$AdvancedSearch$init = function (accessToken) {
	return $elm$core$Task$succeed(
		$author$project$Page$AdvancedSearch$defaultModel(accessToken));
};
var $author$project$Page$Basement$defaultModel = function (statsResponse) {
	return {f$: _List_Nil, ds: statsResponse};
};
var $author$project$Data$Home$StatsResponse = F2(
	function (stats, remedyPerformanceChart) {
		return {he: remedyPerformanceChart, hr: stats};
	});
var $author$project$Data$Chart$Chart = F3(
	function (title, timeStamps, dataSets) {
		return {dV: dataSets, du: timeStamps, bO: title};
	});
var $author$project$Data$Chart$DataSet = F2(
	function (label, values) {
		return {eo: label, fe: values};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Data$Chart$dataSetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Chart$DataSet)));
var $author$project$Data$Chart$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dataSets',
	$elm$json$Json$Decode$list($author$project$Data$Chart$dataSetDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timeStamps',
		$elm$json$Json$Decode$list($author$project$Util$JsonDecode$posixTime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Chart$Chart))));
var $author$project$Data$Home$SummaryStats = F3(
	function (numIncidentsIngested, numRemediesIssued, numLogsUploaded) {
		return {gU: numIncidentsIngested, gV: numLogsUploaded, gY: numRemediesIssued};
	});
var $author$project$Data$Home$summaryStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'numLogsUploaded',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numRemediesIssued',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'numIncidentsIngested',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Data$Home$SummaryStats))));
var $author$project$Data$Home$statsResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'remedyPerformanceChart',
	$author$project$Data$Chart$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stats',
		$author$project$Data$Home$summaryStatsDecoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Home$StatsResponse)));
var $author$project$Request$Basement$getStats = function (accessToken) {
	var url = '/gym/stats';
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	var decoder = $author$project$Data$Home$statsResponseDecoder;
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(decoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: url,
			hU: false
		});
};
var $author$project$Page$Error$HttpError = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Error$http = F2(
	function (context, httpError) {
		return A2($author$project$Page$Error$HttpError, context, httpError);
	});
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $author$project$Page$Basement$init = function (accessToken) {
	var loadStats = $elm$http$Http$toTask(
		$author$project$Request$Basement$getStats(accessToken));
	return A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('basement failed'),
		A2($elm$core$Task$map, $author$project$Page$Basement$defaultModel, loadStats));
};
var $author$project$Page$Capability$List$defaultModel = function (capabilities) {
	return {bY: capabilities, f$: _List_Nil};
};
var $author$project$Remedy$CustomCapability$CustomCapability = F6(
	function (id, version, createdAt, actor, description, parameters) {
		return {dy: actor, dT: createdAt, b6: description, bj: id, bB: parameters, dx: version};
	});
var $author$project$Remedy$CustomCapability$Parameter = F2(
	function (name, isOptional) {
		return {cf: isOptional, ev: name};
	});
var $author$project$Remedy$CustomCapability$parameterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'optional',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Remedy$CustomCapability$Parameter)));
var $author$project$Remedy$CustomCapability$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parameters',
	$elm$json$Json$Decode$list($author$project$Remedy$CustomCapability$parameterDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'actor',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createdAt',
				$author$project$Util$JsonDecode$posixTime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Remedy$CustomCapability$CustomCapability)))))));
var $author$project$Request$CustomCapability$list = function (accessToken) {
	var responseDecoder = A2(
		$elm$json$Json$Decode$field,
		'capabilities',
		$elm$json$Json$Decode$list($author$project$Remedy$CustomCapability$decoder));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/remedies/capabilities',
			hU: false
		});
};
var $author$project$Page$Capability$List$init = function (accessToken) {
	var loadCapabilities = $elm$http$Http$toTask(
		$author$project$Request$CustomCapability$list(accessToken));
	return A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('list capabilities failed'),
		A2($elm$core$Task$map, $author$project$Page$Capability$List$defaultModel, loadCapabilities));
};
var $author$project$Data$Classifier$Meta = function (id) {
	return function (version) {
		return function (title) {
			return function (label) {
				return function (actor) {
					return function (enabled) {
						return function (description) {
							return function (createdAt) {
								return function (inputSpec) {
									return function (ema30Day) {
										return function (discardIncidents) {
											return {dy: actor, dT: createdAt, b6: description, cJ: discardIncidents, d4: ema30Day, cM: enabled, bj: id, c_: inputSpec, eo: label, bO: title, dx: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Classifier$FileSpec = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Classifier$IncidentSpec = {$: 0};
var $author$project$Data$Classifier$inputSpecDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'INCIDENT_SPEC':
				return $elm$json$Json$Decode$succeed($author$project$Data$Classifier$IncidentSpec);
			case 'FILE_SPEC':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Classifier$FileSpec,
					A2($elm$json$Json$Decode$field, 'filenamePattern', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('unknown input spec type: ' + typeString);
		}
	},
	A2($elm$json$Json$Decode$field, '@type', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Data$Classifier$metaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'discardIncidents',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ema30Day',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'inputSpec',
			$author$project$Data$Classifier$inputSpecDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createdAt',
				$author$project$Util$JsonDecode$posixTime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'actor',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['config', 'label']),
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'version',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$UUID$decoder,
											$elm$json$Json$Decode$succeed($author$project$Data$Classifier$Meta))))))))))));
var $author$project$Page$Classifier$History$decodeHistoryResponse = A2(
	$elm$json$Json$Decode$field,
	'versions',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$metaDecoder));
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$UUID$toString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Page$Classifier$History$get = F2(
	function (accessToken, uuid) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'classifiers',
					$author$project$UUID$toString(uuid),
					'history'
				]),
			_List_Nil);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Page$Classifier$History$decodeHistoryResponse),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Page$Classifier$History$init = F2(
	function (accessToken, uuid) {
		var sorted = function (versions) {
			return $elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.dx;
					},
					versions));
		};
		var makeModel = function (versions) {
			return {
				bj: uuid,
				ci: sorted(versions)
			};
		};
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$HttpError('Classifier History'),
			A2(
				$elm$core$Task$map,
				makeModel,
				$elm$http$Http$toTask(
					A2($author$project$Page$Classifier$History$get, accessToken, uuid))));
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Page$Classifier$List$EnabledStatus = 1;
var $author$project$Page$Classifier$List$IncidentInputSpec = 1;
var $author$project$Page$Classifier$List$SortByMostActive = 0;
var $author$project$Page$Classifier$List$defaultModel = function (classifiers) {
	return {fJ: classifiers, f$: _List_Nil, bl: 1, ak: false, ap: $elm$core$Maybe$Nothing, bG: '', bJ: 0, bL: 1};
};
var $author$project$Data$Classifier$Classifier = F2(
	function (meta, config) {
		return {fM: config, er: meta};
	});
var $author$project$Data$Classifier$Drill2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Classifier$Javascript = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Classifier$RandomClassifier = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Classifier$RegexClassifier = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Classifier$Unknown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$Classifier$Drill2$Config = F2(
	function (label, matcher) {
		return {eo: label, eq: matcher};
	});
var $author$project$Data$Classifier$Drill2$Matcher = F2(
	function (combiner, queries) {
		return {a7: combiner, de: queries};
	});
var $author$project$Data$Classifier$Drill2$And = 0;
var $author$project$Data$Classifier$Drill2$Or = 1;
var $author$project$Data$Classifier$Drill2$decodeCombiner = function () {
	var get = function (id) {
		switch (id) {
			case 'AND':
				return $elm$json$Json$Decode$succeed(0);
			case 'OR':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('unknown combiner: ' + id);
		}
	};
	return A2($elm$json$Json$Decode$andThen, get, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Classifier$Drill2$Query = F2(
	function (path, conditions) {
		return {dQ: conditions, eF: path};
	});
var $author$project$Data$Classifier$Drill2$Condition = F6(
	function (key, dataType, op, negate, combiner, values) {
		return {a7: combiner, dW: dataType, en: key, ew: negate, eB: op, fe: values};
	});
var $author$project$Data$Classifier$Drill2$Eq = 0;
var $author$project$Data$Classifier$Drill2$Gt = 2;
var $author$project$Data$Classifier$Drill2$IsNull = 3;
var $author$project$Data$Classifier$Drill2$Lt = 1;
var $author$project$Data$Classifier$Drill2$Substring = 4;
var $author$project$Data$Classifier$Drill2$decodeOperand = function () {
	var get = function (id) {
		switch (id) {
			case 'EQ':
				return $elm$json$Json$Decode$succeed(0);
			case 'LT':
				return $elm$json$Json$Decode$succeed(1);
			case 'GT':
				return $elm$json$Json$Decode$succeed(2);
			case 'NULL':
				return $elm$json$Json$Decode$succeed(3);
			case 'SUBSTRING':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('unknown op: ' + id);
		}
	};
	return A2($elm$json$Json$Decode$andThen, get, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Classifier$Drill2$ArraySizeType = 4;
var $author$project$Data$Classifier$Drill2$BoolType = 2;
var $author$project$Data$Classifier$Drill2$NumberType = 0;
var $author$project$Data$Classifier$Drill2$StringType = 1;
var $author$project$Data$Classifier$Drill2$VersionType = 3;
var $author$project$Data$Classifier$Drill2$decodeOperandType = function () {
	var get = function (id) {
		switch (id) {
			case 'number':
				return $elm$json$Json$Decode$succeed(0);
			case 'string':
				return $elm$json$Json$Decode$succeed(1);
			case 'bool':
				return $elm$json$Json$Decode$succeed(2);
			case 'version':
				return $elm$json$Json$Decode$succeed(3);
			case 'array':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('unknown type: ' + id);
		}
	};
	return A2($elm$json$Json$Decode$andThen, get, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Classifier$Drill2$decodeCondition = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'combiner',
		$author$project$Data$Classifier$Drill2$decodeCombiner,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'negate',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'op',
				$author$project$Data$Classifier$Drill2$decodeOperand,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$author$project$Data$Classifier$Drill2$decodeOperandType,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'path',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Classifier$Drill2$Condition)))))));
var $author$project$Data$Classifier$Drill2$decodeQuery = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conditions',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$Drill2$decodeCondition),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Classifier$Drill2$Query)));
var $author$project$Data$Classifier$Drill2$decodeMatcher = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'queries',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$Drill2$decodeQuery),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'combiner',
		$author$project$Data$Classifier$Drill2$decodeCombiner,
		$elm$json$Json$Decode$succeed($author$project$Data$Classifier$Drill2$Matcher)));
var $author$project$Data$Classifier$Drill2$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'matcher',
	$author$project$Data$Classifier$Drill2$decodeMatcher,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Classifier$Drill2$Config)));
var $author$project$Data$Classifier$RandomClassifier$Config = F2(
	function (percentChance, label) {
		return {eo: label, dc: percentChance};
	});
var $author$project$Data$Classifier$RandomClassifier$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'percentChance',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Data$Classifier$RandomClassifier$Config)));
var $author$project$Data$Classifier$RegexClassifier$Config = F3(
	function (pattern, label, confidence) {
		return {cG: confidence, eo: label, db: pattern};
	});
var $author$project$Data$Classifier$RegexClassifier$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'confidence',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pattern',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Classifier$RegexClassifier$Config))));
var $author$project$Data$Classifier$configDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'javascript':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Classifier$Javascript,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['config', 'javaScript']),
						$elm$json$Json$Decode$string));
			case 'drill2':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Classifier$Drill2,
					A2($elm$json$Json$Decode$field, 'config', $author$project$Data$Classifier$Drill2$decode));
			case 'random':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Classifier$RandomClassifier,
					A2($elm$json$Json$Decode$field, 'config', $author$project$Data$Classifier$RandomClassifier$decoder));
			case 'regex':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Classifier$RegexClassifier,
					A2($elm$json$Json$Decode$field, 'config', $author$project$Data$Classifier$RegexClassifier$decoder));
			default:
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$Classifier$Unknown(typeString));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Data$Classifier$decoder = A3($elm$json$Json$Decode$map2, $author$project$Data$Classifier$Classifier, $author$project$Data$Classifier$metaDecoder, $author$project$Data$Classifier$configDecoder);
var $author$project$Request$Classifier$list = function (accessToken) {
	var responseDecoder = A2(
		$elm$json$Json$Decode$field,
		'classifiers',
		$elm$json$Json$Decode$list($author$project$Data$Classifier$decoder));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/classifiers',
			hU: false
		});
};
var $author$project$Page$Classifier$List$init = function (accessToken) {
	var onError = function (error) {
		return A2($author$project$Page$Error$http, 'failed to load classifiers', error);
	};
	var loadClassifiers = $elm$http$Http$toTask(
		$author$project$Request$Classifier$list(accessToken));
	return A2(
		$elm$core$Task$mapError,
		onError,
		A2(
			$elm$core$Task$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function ($) {
						return $.er;
					}),
				$author$project$Page$Classifier$List$defaultModel),
			loadClassifiers));
};
var $author$project$Page$Configuration$List$EnabledStatus = 1;
var $author$project$Page$Configuration$List$SortByNewest = 0;
var $author$project$Page$Configuration$List$defaultModel = function (configurations) {
	return {b2: configurations, f$: _List_Nil, bJ: 0, bL: 1};
};
var $author$project$Data$LogFile$ConfigDef = function (id) {
	return function (version) {
		return function (createdAt) {
			return function (actor) {
				return function (enabled) {
					return function (description) {
						return function (filePatterns) {
							return function (platforms) {
								return function (regex) {
									return function (dateFormat) {
										return function (columns) {
											return {dy: actor, b0: columns, dT: createdAt, b4: dateFormat, b6: description, cM: enabled, cc: filePatterns, bj: id, cn: platforms, cp: regex, dx: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LogFile$Column = F2(
	function (name, widget) {
		return {ev: name, fg: widget};
	});
var $author$project$Data$LogFile$DropDown = 1;
var $author$project$Data$LogFile$None = 3;
var $author$project$Data$LogFile$Search = 2;
var $author$project$Data$LogFile$Time = 0;
var $author$project$Data$LogFile$widgetDecoder = function (widgetType) {
	switch (widgetType) {
		case 'time':
			return $elm$json$Json$Decode$succeed(0);
		case 'dropdown':
			return $elm$json$Json$Decode$succeed(1);
		case 'search':
			return $elm$json$Json$Decode$succeed(2);
		case 'none':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('unknown input spec type: ' + widgetType);
	}
};
var $author$project$Data$LogFile$columnDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'widget',
	A2($elm$json$Json$Decode$andThen, $author$project$Data$LogFile$widgetDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$LogFile$Column)));
var $author$project$Data$LogFile$fullDefDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'columns',
	$elm$json$Json$Decode$list($author$project$Data$LogFile$columnDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dateFormat',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'stringRegex',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'platforms',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filePatterns',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'actor',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									$author$project$Util$JsonDecode$posixTime,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'version',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$UUID$decoder,
											$elm$json$Json$Decode$succeed($author$project$Data$LogFile$ConfigDef))))))))))));
var $author$project$Request$LogFile$listConfigs = function (accessToken) {
	var responseDecoder = A2(
		$elm$json$Json$Decode$field,
		'configurations',
		$elm$json$Json$Decode$list($author$project$Data$LogFile$fullDefDecoder));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/logs/configurations',
			hU: false
		});
};
var $author$project$Page$Configuration$List$init = function (accessToken) {
	var loadConfigurations = $elm$http$Http$toTask(
		$author$project$Request$LogFile$listConfigs(accessToken));
	return A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('list configurations failed'),
		A2($elm$core$Task$map, $author$project$Page$Configuration$List$defaultModel, loadConfigurations));
};
var $author$project$Page$Docs$defaultModel = function (maybeSection) {
	return {f$: _List_Nil, bH: maybeSection};
};
var $author$project$Page$Docs$init = function (maybeSection) {
	return $elm$core$Task$succeed(
		$author$project$Page$Docs$defaultModel(maybeSection));
};
var $author$project$Page$Group$GroupCreator$init = function (accessToken) {
	var onError = function (error) {
		return A2($author$project$Page$Error$http, 'failed to load group editor', error);
	};
	var defaultModel = {a: accessToken, b6: '', cd: $elm$core$Maybe$Nothing, cg: false, ev: ''};
	return A2(
		$elm$core$Task$mapError,
		onError,
		$elm$core$Task$succeed(defaultModel));
};
var $author$project$Data$Group$GroupDetailResponse = function (group) {
	return {gb: group};
};
var $author$project$Data$Group$GroupDTO = F5(
	function (id, name, description, tenants, classifiers) {
		return {fJ: classifiers, b6: description, bj: id, ev: name, hB: tenants};
	});
var $author$project$Data$Classifier$ClassifierCloneSet = F2(
	function (id, classifiers) {
		return {fJ: classifiers, bj: id};
	});
var $author$project$Data$Classifier$ClassifierDefinitionLite = F4(
	function (id, tenant, title, description) {
		return {b6: description, bj: id, hy: tenant, bO: title};
	});
var $author$project$Data$Tenant$TenantLite = F2(
	function (publicId, name) {
		return {ev: name, eL: publicId};
	});
var $author$project$Data$Tenant$tenantLiteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'publicId',
		$author$project$UUID$decoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Tenant$TenantLite)));
var $author$project$Data$Classifier$liteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tenant',
			$author$project$Data$Tenant$tenantLiteDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$UUID$decoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Classifier$ClassifierDefinitionLite)))));
var $author$project$Data$Classifier$cloneSetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classifiers',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$liteDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$UUID$decoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Classifier$ClassifierCloneSet)));
var $author$project$Data$Group$groupDTODecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classifiers',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$cloneSetDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tenants',
		$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantLiteDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$UUID$decoder,
					$elm$json$Json$Decode$succeed($author$project$Data$Group$GroupDTO))))));
var $author$project$Data$Group$groupDetailResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'group',
	$author$project$Data$Group$groupDTODecoder,
	$elm$json$Json$Decode$succeed($author$project$Data$Group$GroupDetailResponse));
var $author$project$Request$Group$get = F2(
	function (accessToken, id) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Data$Group$groupDetailResponseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/groups/' + $author$project$UUID$toString(id),
				hU: false
			});
	});
var $author$project$Request$Tenant$getLiteTenants = function (accessToken) {
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(
				$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantLiteDecoder)),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/tenants/lite',
			hU: false
		});
};
var $author$project$Page$Group$GroupEditor$makeModel = F3(
	function (accessToken, response, allTenants) {
		return {a: accessToken, bW: allTenants, b6: response.gb.b6, gb: response.gb, cd: $elm$core$Maybe$Nothing, cg: false, ev: response.gb.ev, H: _List_Nil};
	});
var $author$project$Page$Group$GroupEditor$init = F2(
	function (accessToken, id) {
		var onError = function (error) {
			return A2($author$project$Page$Error$http, 'failed to load group', error);
		};
		var loadTenants = $elm$http$Http$toTask(
			$author$project$Request$Tenant$getLiteTenants(accessToken));
		var loadGroup = $elm$http$Http$toTask(
			A2($author$project$Request$Group$get, accessToken, id));
		return A2(
			$elm$core$Task$mapError,
			onError,
			A3(
				$elm$core$Task$map2,
				$author$project$Page$Group$GroupEditor$makeModel(accessToken),
				loadGroup,
				loadTenants));
	});
var $author$project$Data$Group$GroupListResponse = F2(
	function (member, nonMember) {
		return {gK: member, gS: nonMember};
	});
var $author$project$Data$Group$groupListResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nonMember',
	$elm$json$Json$Decode$list($author$project$Data$Group$groupDTODecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'member',
		$elm$json$Json$Decode$list($author$project$Data$Group$groupDTODecoder),
		$elm$json$Json$Decode$succeed($author$project$Data$Group$GroupListResponse)));
var $author$project$Request$Group$getAll = function (accessToken) {
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson($author$project$Data$Group$groupListResponseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/groups',
			hU: false
		});
};
var $author$project$Page$Group$GroupList$init = F2(
	function (accessToken, isSystemTenant) {
		var onError = function (error) {
			return A2($author$project$Page$Error$http, 'failed to load groups', error);
		};
		var makeModel = function (response) {
			return {f$: _List_Nil, c1: isSystemTenant, c5: response.gK, c9: response.gS};
		};
		var loadGroups = $elm$http$Http$toTask(
			$author$project$Request$Group$getAll(accessToken));
		return A2(
			$elm$core$Task$mapError,
			onError,
			A2($elm$core$Task$map, makeModel, loadGroups));
	});
var $author$project$Page$Group$GroupViewer$init = F3(
	function (accessToken, isSystemTenant, id) {
		var onError = function (error) {
			return A2(
				$author$project$Page$Error$http,
				'failed to load group ' + $author$project$UUID$toString(id),
				error);
		};
		var makeModel = function (response) {
			return {gb: response.gb, cd: $elm$core$Maybe$Nothing, cg: false, c1: isSystemTenant};
		};
		var loadGroup = $elm$http$Http$toTask(
			A2($author$project$Request$Group$get, accessToken, id));
		return A2(
			$elm$core$Task$mapError,
			onError,
			A2($elm$core$Task$map, makeModel, loadGroup));
	});
var $author$project$Page$Home$defaultModel = F2(
	function (accessToken, comboResponse) {
		return {
			a: accessToken,
			f$: _List_Nil,
			hr: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hu;
				},
				comboResponse)
		};
	});
var $author$project$Data$Home$HomeResponse = function (summaryStats) {
	return {hu: summaryStats};
};
var $author$project$Data$Home$homeResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'summaryStats',
	$author$project$Data$Home$summaryStatsDecoder,
	$elm$json$Json$Decode$succeed($author$project$Data$Home$HomeResponse));
var $author$project$Request$Home$get = function (accessToken) {
	var url = '/gym/combo/home';
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	var decoder = $author$project$Data$Home$homeResponseDecoder;
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(decoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: url,
			hU: false
		});
};
var $author$project$Page$Home$init = function (accessToken) {
	var loadStats = A2(
		$elm$core$Task$map,
		$elm$core$Maybe$Just,
		$elm$http$Http$toTask(
			$author$project$Request$Home$get(accessToken)));
	var degradeGracefully = function (_v0) {
		return $elm$core$Task$succeed(
			A2($author$project$Page$Home$defaultModel, accessToken, $elm$core$Maybe$Nothing));
	};
	return A2(
		$elm$core$Task$onError,
		degradeGracefully,
		A2(
			$elm$core$Task$map,
			$author$project$Page$Home$defaultModel(accessToken),
			loadStats));
};
var $author$project$Page$Incident$LoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Incident$LoadOk = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Incident$NeedsToJoinTenant = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Incident$SwitchActiveTenant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Incident$Diagnostics = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Incident$Files = {$: 0};
var $author$project$Page$Incident$OtherIncidents = {$: 3};
var $author$project$Page$Incident$PowerLiftStuff = {$: 2};
var $author$project$Page$Incident$EntireIncidentSection = {$: 0};
var $author$project$Page$Incident$WidgetsSection = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Incident$defaultDiagnosticsSection = function (sections) {
	return $elm$core$List$isEmpty(sections) ? $author$project$Page$Incident$EntireIncidentSection : $author$project$Page$Incident$WidgetsSection(0);
};
var $author$project$SelectList$SelectList = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$SelectList$fromLists = $author$project$SelectList$SelectList;
var $author$project$JsonTree$View$State = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$JsonTree$View$fullyExpandedState = $elm$core$Set$fromList(_List_Nil);
var $author$project$JsonTree$View$collapse = F2(
	function (keyPath, _v0) {
		var hiddenPaths = _v0;
		return A2($elm$core$Set$insert, keyPath, hiddenPaths);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$JsonTree$View$initExpandedToDepthHelp = F4(
	function (maxDepth, currentDepth, node, state) {
		var descend = function (children) {
			return A3(
				$elm$core$List$foldl,
				A2($author$project$JsonTree$View$initExpandedToDepthHelp, maxDepth, currentDepth + 1),
				(_Utils_cmp(currentDepth, maxDepth) > -1) ? A2($author$project$JsonTree$View$collapse, node.gy, state) : state,
				children);
		};
		var _v0 = node.hR;
		switch (_v0.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return state;
			case 5:
				return state;
			case 3:
				var nodes = _v0.a;
				return descend(nodes);
			default:
				var dict = _v0.a;
				return descend(
					$elm$core$Dict$values(dict));
		}
	});
var $author$project$JsonTree$View$initExpandedToDepth = F2(
	function (maxDepth, tree) {
		return A4($author$project$JsonTree$View$initExpandedToDepthHelp, maxDepth, 0, tree, $author$project$JsonTree$View$fullyExpandedState);
	});
var $author$project$View$Incident$Navigator$DiagnosticsLocation = {$: 2};
var $author$project$View$Incident$Navigator$FileLocation = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Incident$Navigator$FilesLocation = {$: 0};
var $author$project$View$Incident$Navigator$WidgetLocation = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Incident$Navigator$WidgetSectionLocation = function (a) {
	return {$: 4, a: a};
};
var $author$project$FocusList$fromList = function (items) {
	return {
		R: items,
		m: 0,
		ae: A2(
			$elm$core$List$range,
			0,
			$elm$core$List$length(items) - 1)
	};
};
var $author$project$View$Incident$Navigator$init = function (items) {
	return {
		R: $author$project$FocusList$fromList(items),
		hb: ''
	};
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Page$Incident$partitionFiles = F2(
	function (files, selectedIncidentId) {
		var selector = function (file) {
			return _Utils_eq(file.cZ, selectedIncidentId);
		};
		var _v0 = A2($elm$core$List$partition, selector, files);
		var incidentFiles = _v0.a;
		var otherFiles = _v0.b;
		return {cY: incidentFiles, eE: otherFiles};
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Util$Numbers$toMaybe = function (n) {
	return (!n) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(n);
};
var $author$project$Page$Incident$sectionBadgeCount = function (widgetSection) {
	return $author$project$Util$Numbers$toMaybe(
		$elm$core$List$sum(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.dC;
					},
					widgetSection.cB))));
};
var $author$project$Page$Incident$makeNavigator = F2(
	function (widgetSections, parsedIncident) {
		var widgetItems = $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, section) {
						return A2(
							$elm$core$List$cons,
							{
								dC: $author$project$Page$Incident$sectionBadgeCount(section),
								bb: true,
								bu: $author$project$View$Incident$Navigator$WidgetSectionLocation(index),
								ev: section.bO
							},
							($elm$core$List$length(section.cB) === 1) ? _List_Nil : A2(
								$elm$core$List$map,
								function (widget) {
									return {
										dC: widget.dC,
										bb: false,
										bu: $author$project$View$Incident$Navigator$WidgetLocation(widget.bj),
										ev: widget.bO
									};
								},
								section.cB));
					}),
				widgetSections));
		var widgetHeaderItem = {dC: $elm$core$Maybe$Nothing, bb: true, bu: $author$project$View$Incident$Navigator$DiagnosticsLocation, ev: 'Diagnostics'};
		var filesHeaderItem = {dC: $elm$core$Maybe$Nothing, bb: true, bu: $author$project$View$Incident$Navigator$FilesLocation, ev: 'Files'};
		var _v0 = parsedIncident.gj;
		var logMetas = _v0.ep;
		var analyzedIncident = _v0.fp;
		var fileItems = A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, logMeta) {
					return {
						dC: $elm$core$Maybe$Nothing,
						bb: false,
						bu: $author$project$View$Incident$Navigator$FileLocation(idx),
						ev: logMeta.ev
					};
				}),
			A2($author$project$Page$Incident$partitionFiles, logMetas, analyzedIncident.er.bj).cY);
		return $author$project$View$Incident$Navigator$init(
			_Utils_ap(
				_List_fromArray(
					[widgetHeaderItem]),
				_Utils_ap(
					widgetItems,
					_Utils_ap(
						_List_fromArray(
							[filesHeaderItem]),
						fileItems))));
	});
var $author$project$SelectList$selectHelp = F4(
	function (isSelectable, beforeList, selectedElem, afterList) {
		var _v0 = _Utils_Tuple2(beforeList, afterList);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v1 = _v0.b;
				var first = _v1.a;
				var rest = _v1.b;
				if (isSelectable(selectedElem)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(beforeList, selectedElem, afterList));
				} else {
					if (isSelectable(first)) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								_Utils_ap(
									beforeList,
									_List_fromArray(
										[selectedElem])),
								first,
								rest));
					} else {
						var _v2 = A4($author$project$SelectList$selectHelp, isSelectable, _List_Nil, first, rest);
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v3 = _v2.a;
							var newBefore = _v3.a;
							var newSelected = _v3.b;
							var newAfter = _v3.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($elm$core$List$cons, selectedElem, newBefore),
									newSelected,
									newAfter));
						}
					}
				}
			}
		} else {
			var _v4 = _v0.a;
			var first = _v4.a;
			var rest = _v4.b;
			if (isSelectable(first)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						_List_Nil,
						first,
						_Utils_ap(
							rest,
							A2($elm$core$List$cons, selectedElem, afterList))));
			} else {
				var _v5 = A4($author$project$SelectList$selectHelp, isSelectable, rest, selectedElem, afterList);
				if (_v5.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v6 = _v5.a;
					var newBefore = _v6.a;
					var newSelected = _v6.b;
					var newAfter = _v6.c;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							A2($elm$core$List$cons, first, newBefore),
							newSelected,
							newAfter));
				}
			}
		}
	});
var $author$project$SelectList$select = F2(
	function (isSelectable, original) {
		var beforeSel = original.a;
		var sel = original.b;
		var afterSel = original.c;
		var _v0 = A4($author$project$SelectList$selectHelp, isSelectable, beforeSel, sel, afterSel);
		if (_v0.$ === 1) {
			return original;
		} else {
			var _v1 = _v0.a;
			var newBefore = _v1.a;
			var newSel = _v1.b;
			var newAfter = _v1.c;
			return A3($author$project$SelectList$SelectList, newBefore, newSel, newAfter);
		}
	});
var $author$project$Page$Incident$tabToString = function (tab) {
	switch (tab.$) {
		case 1:
			return 'Diagnostics';
		case 0:
			return 'Files';
		case 2:
			return 'Extras';
		default:
			return 'Other Incidents';
	}
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Page$Incident$defaultModel = F5(
	function (accessToken, parsedIncident, editorModel, maybeTab, aliasAccessId) {
		var widgetSections = parsedIncident.gj.hT;
		var defaultTabList = A3(
			$author$project$SelectList$fromLists,
			_List_Nil,
			$author$project$Page$Incident$Diagnostics(
				$author$project$Page$Incident$defaultDiagnosticsSection(widgetSections)),
			_List_fromArray(
				[$author$project$Page$Incident$Files, $author$project$Page$Incident$PowerLiftStuff, $author$project$Page$Incident$OtherIncidents]));
		return {
			a: accessToken,
			bV: aliasAccessId,
			a8: $elm$core$Maybe$Nothing,
			P: A2($author$project$JsonTree$View$initExpandedToDepth, 2, parsedIncident.ac),
			M: editorModel,
			f$: _List_Nil,
			N: false,
			y: A2($author$project$Page$Incident$makeNavigator, widgetSections, parsedIncident),
			z: parsedIncident,
			aY: false,
			aw: function () {
				if (!maybeTab.$) {
					var tabName = maybeTab.a;
					return A2(
						$author$project$SelectList$select,
						function (tab) {
							return _Utils_eq(
								$elm$core$String$toLower(
									$author$project$Page$Incident$tabToString(tab)),
								$elm$core$String$toLower(tabName));
						},
						defaultTabList);
				} else {
					return defaultTabList;
				}
			}(),
			hT: widgetSections
		};
	});
var $author$project$Data$Locker$WidgetCollectionEntity = 0;
var $author$project$Data$Incident$Incident = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Incident$SwitchTenant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Incident$TenantMembershipNeeded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Incident$ComboIncident = F7(
	function (analyzedIncident, highlights, logMetas, issue, otherIncidents, widgetSections, formattedPrescriptionLog) {
		return {fp: analyzedIncident, f8: formattedPrescriptionLog, gh: highlights, gt: issue, ep: logMetas, g3: otherIncidents, hT: widgetSections};
	});
var $author$project$Data$Highlight$Highlight = F4(
	function (label, classifierId, classifierVersion, matches) {
		return {fG: classifierId, fI: classifierVersion, eo: label, gI: matches};
	});
var $author$project$Data$Highlight$Match = F2(
	function (keyPath, value) {
		return {gy: keyPath, hR: value};
	});
var $author$project$Data$Highlight$matchDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'keyPath',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Highlight$Match)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Data$Highlight$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'matches',
	$elm$json$Json$Decode$list($author$project$Data$Highlight$matchDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['classifierId', 'version']),
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['classifierId', 'id']),
			$author$project$UUID$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Highlight$Highlight)))));
var $author$project$Data$Issue$Body = function (messages) {
	return {gL: messages};
};
var $author$project$Data$Issue$Issue = F5(
	function (id, domain, title, createdAt, body) {
		return {bX: body, dT: createdAt, cK: domain, bj: id, bO: title};
	});
var $author$project$Data$Issue$baseIssueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'createdAt',
	$author$project$Util$JsonDecode$posixTime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['id', 'domain']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['id', 'id']),
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Data$Issue$Issue)))));
var $author$project$Data$Issue$Message = F3(
	function (body, createdAt, author) {
		return {fu: author, bX: body, dT: createdAt};
	});
var $author$project$Data$Issue$messageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'author',
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createdAt',
		$author$project$Util$JsonDecode$posixTime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'body',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Issue$Message))));
var $author$project$Data$Issue$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'messages',
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Issue$Body,
		$elm$json$Json$Decode$list($author$project$Data$Issue$messageDecoder)),
	$author$project$Data$Issue$baseIssueDecoder);
var $author$project$Data$Incident$AnalyzedIncident = F3(
	function (meta, analysis, json) {
		return {dA: analysis, gx: json, er: meta};
	});
var $author$project$Data$Incident$Analysis = F4(
	function (id, createdAt, classifications, remedy) {
		return {dL: classifications, dT: createdAt, bj: id, hd: remedy};
	});
var $author$project$Data$Incident$Classification = F2(
	function (id, label) {
		return {bj: id, eo: label};
	});
var $author$project$Data$Incident$classificationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$UUID$decoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$Classification)));
var $author$project$Data$Incident$PrescribedRemedy = F3(
	function (id, version, title) {
		return {bj: id, bO: title, dx: version};
	});
var $author$project$Data$Incident$prescribedRemedyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'version',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$UUID$decoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Incident$PrescribedRemedy))));
var $author$project$Data$Incident$analysisDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'remedy',
	$elm$json$Json$Decode$nullable($author$project$Data$Incident$prescribedRemedyDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classifications',
		$elm$json$Json$Decode$list($author$project$Data$Incident$classificationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			$author$project$Util$JsonDecode$posixTime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$UUID$decoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Incident$Analysis)))));
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Data$Incident$dataAndMetaDecoder = function () {
	var reassemble = F2(
		function (meta, data) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('meta', meta),
						_Utils_Tuple2('data', data)
					]));
		});
	return A3(
		$elm$json$Json$Decode$map2,
		reassemble,
		A2($elm$json$Json$Decode$field, 'meta', $elm$json$Json$Decode$value),
		A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value));
}();
var $author$project$Data$Incident$IncidentMeta = function (id) {
	return function (tenantId) {
		return function (createdAt) {
			return function (installId) {
				return function (easyId) {
					return function (sessionId) {
						return function (platform) {
							return function (application) {
								return function (clientVersion) {
									return function (lang) {
										return function (clientCapabilities) {
											return function (ingestedAt) {
												return function (purgeCompletedAt) {
													return function (dataBoundary) {
														return {fr: application, fK: clientCapabilities, fL: clientVersion, dT: createdAt, dU: dataBoundary, b9: easyId, bj: id, ek: ingestedAt, ce: installId, gB: lang, g6: platform, eM: purgeCompletedAt, hp: sessionId, hz: tenantId};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Util$JsonDecode$setOf = function (d) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Set$fromList,
		$elm$json$Json$Decode$list(d));
};
var $author$project$Data$Incident$incidentMetaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dataBoundary',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'purgeCompletedAt',
		$elm$json$Json$Decode$nullable($author$project$Util$JsonDecode$posixTime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ingestedAt',
			$author$project$Util$JsonDecode$posixTime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clientCapabilities',
				$author$project$Util$JsonDecode$setOf($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lang',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'clientVersion',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'application',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'platform',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sessionId',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'easyId',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'installId',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'createdAt',
												$author$project$Util$JsonDecode$posixTime,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'tenantId',
													$author$project$UUID$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$UUID$decoder,
														$elm$json$Json$Decode$succeed($author$project$Data$Incident$IncidentMeta)))))))))))))));
var $author$project$Data$Incident$fullDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Data$Incident$dataAndMetaDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'analysis',
		$author$project$Data$Incident$analysisDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Data$Incident$incidentMetaDecoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Incident$AnalyzedIncident))));
var $author$project$Data$Incident$LogMeta = function (name) {
	return function (url) {
		return function (size) {
			return function (createdAt) {
				return function (tags) {
					return function (incidentId) {
						return function (fileId) {
							return function (classifications) {
								return function (displayFancyViewer) {
									return function (dataBoundary) {
										return {dL: classifications, dT: createdAt, dU: dataBoundary, fY: displayFancyViewer, f5: fileId, cZ: incidentId, ev: name, e$: size, e8: tags, hQ: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Incident$logMetaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dataBoundary',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'displayFancyViewer',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'classifications',
			$elm$json$Json$Decode$list($author$project$Data$Incident$classificationDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'incidentId',
					$author$project$UUID$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tags',
						$author$project$Util$JsonDecode$setOf($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$author$project$Util$JsonDecode$posixTime,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'size',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Incident$LogMeta)))))))))));
var $author$project$Data$Incident$SearchResult = F2(
	function (incident, issueBrief) {
		return {gj: incident, gu: issueBrief};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Data$Issue$briefDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, 0, $author$project$Data$Issue$baseIssueDecoder);
var $author$project$Data$Incident$AnalyzedIncidentLite = F2(
	function (meta, analysis) {
		return {dA: analysis, er: meta};
	});
var $author$project$Data$Incident$liteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'analysis',
	$author$project$Data$Incident$analysisDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Data$Incident$incidentMetaDecoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$AnalyzedIncidentLite)));
var $author$project$Data$Incident$searchResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'issueBrief',
	$elm$json$Json$Decode$nullable($author$project$Data$Issue$briefDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'incident',
		$author$project$Data$Incident$liteDecoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$SearchResult)));
var $author$project$Data$Widget$AnyPlatform = {$: 0};
var $author$project$Data$Widget$WidgetCollection = function (sections) {
	return {hl: sections};
};
var $author$project$Data$Widget$DynamicListData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Widget$DynamicTableData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Widget$GenericData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Widget$StaticTableData = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Widget$DynamicList$Configuration = function (arrayKeyPath) {
	return {K: arrayKeyPath};
};
var $author$project$View$Widget$DynamicList$defaultModel = function (cfg) {
	return {b1: cfg, e2: 0};
};
var $author$project$View$Widget$DynamicList$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$View$Widget$DynamicList$defaultModel,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arrayKeyPath',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$View$Widget$DynamicList$Configuration)));
var $author$project$View$Widget$DynamicTable$Column = F2(
	function (name, lens) {
		return {al: lens, ev: name};
	});
var $author$project$View$Widget$DynamicTable$Configuration = F2(
	function (arrayKeyPath, columns) {
		return {K: arrayKeyPath, b0: columns};
	});
var $author$project$Data$Widget$Lens$Lens = F3(
	function (keyPath, isOptional, transform) {
		return {cf: isOptional, gy: keyPath, ay: transform};
	});
var $author$project$Data$Widget$Lens$ByteCountTransform = {$: 2};
var $author$project$Data$Widget$Lens$DateTransform = {$: 1};
var $author$project$Data$Widget$Lens$DefaultTransform = {$: 0};
var $author$project$Data$Widget$Lens$transformDecoderV0 = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'plain':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$DefaultTransform);
			case 'date':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$DateTransform);
			case 'byte_count':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$ByteCountTransform);
			default:
				return $elm$json$Json$Decode$fail('unknown transform type: \'' + (str + '\''));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Widget$Lens$decoderV0 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formatter',
	$author$project$Data$Widget$Lens$transformDecoderV0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isOptional',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'keyPath',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$Lens))));
var $author$project$Data$Widget$Lens$LinkTransform = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Widget$Lens$transformDecoderV1 = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'default':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$DefaultTransform);
			case 'date':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$DateTransform);
			case 'byte_count':
				return $elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$ByteCountTransform);
			case 'link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$LinkTransform));
			default:
				return $elm$json$Json$Decode$fail('unknown transform type: \'' + (str + '\''));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Data$Widget$Lens$decoderV1 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'transform',
	$author$project$Data$Widget$Lens$transformDecoderV1,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isOptional',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'keyPath',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Widget$Lens$Lens))));
var $author$project$Data$Widget$Lens$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Data$Widget$Lens$decoderV0, $author$project$Data$Widget$Lens$decoderV1]));
var $author$project$JsonTree$View$init = $author$project$JsonTree$View$fullyExpandedState;
var $author$project$View$Widget$DynamicTable$defaultModel = function (cfg) {
	return {
		b1: cfg,
		e2: {bd: $elm$core$Set$empty, cz: $author$project$JsonTree$View$init}
	};
};
var $author$project$View$Widget$DynamicTable$decoder = function () {
	var columnDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lens',
		$author$project$Data$Widget$Lens$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$View$Widget$DynamicTable$Column)));
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$View$Widget$DynamicTable$defaultModel,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'columns',
			$elm$json$Json$Decode$list(columnDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'arrayKeyPath',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$View$Widget$DynamicTable$Configuration))));
}();
var $author$project$View$Widget$Generic$Configuration = function (keyPath) {
	return {gy: keyPath};
};
var $author$project$View$Widget$Generic$defaultModel = function (cfg) {
	return {
		b1: cfg,
		e2: {cz: $author$project$JsonTree$View$init}
	};
};
var $author$project$View$Widget$Generic$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$View$Widget$Generic$defaultModel,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'keyPath',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$View$Widget$Generic$Configuration)));
var $author$project$View$Widget$StaticTable$Configuration = function (rows) {
	return {aW: rows};
};
var $author$project$View$Widget$StaticTable$Row = F2(
	function (label, value) {
		return {eo: label, hR: value};
	});
var $author$project$View$Widget$StaticTable$defaultModel = function (configuration) {
	return {b1: configuration, e2: 0};
};
var $author$project$View$Widget$StaticTable$decoder = function () {
	var rowDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lens',
		$author$project$Data$Widget$Lens$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$View$Widget$StaticTable$Row)));
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$View$Widget$StaticTable$defaultModel,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rows',
			$elm$json$Json$Decode$list(rowDecoder),
			$elm$json$Json$Decode$succeed($author$project$View$Widget$StaticTable$Configuration)));
}();
var $author$project$Data$Widget$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('unknown widget type: ' + str),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Data$Widget$Type$stringToType(str)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Widget$dataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 0:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Widget$StaticTableData,
					A2($elm$json$Json$Decode$field, 'config', $author$project$View$Widget$StaticTable$decoder));
			case 1:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Widget$DynamicListData,
					A2($elm$json$Json$Decode$field, 'config', $author$project$View$Widget$DynamicList$decoder));
			case 2:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Widget$DynamicTableData,
					A2($elm$json$Json$Decode$field, 'config', $author$project$View$Widget$DynamicTable$decoder));
			default:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Widget$GenericData,
					A2($elm$json$Json$Decode$field, 'config', $author$project$View$Widget$Generic$decoder));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $author$project$Data$Widget$typeDecoder));
var $author$project$Data$Widget$makeWidget = F3(
	function (id, title, data) {
		return {dC: $elm$core$Maybe$Nothing, b3: data, bj: id, bO: title};
	});
var $author$project$Data$Widget$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (data) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			data,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$UUID$decoder,
					$elm$json$Json$Decode$succeed($author$project$Data$Widget$makeWidget))));
	},
	$author$project$Data$Widget$dataDecoder);
var $author$project$Data$Widget$WidgetSection = F3(
	function (title, widgets, platform) {
		return {g6: platform, bO: title, cB: widgets};
	});
var $author$project$Data$Widget$SpecificPlatform = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Widget$platformDecoder = A2(
	$elm$json$Json$Decode$map,
	function (str) {
		if (str.$ === 1) {
			return $author$project$Data$Widget$AnyPlatform;
		} else {
			var s = str.a;
			return $author$project$Data$Widget$SpecificPlatform(s);
		}
	},
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string));
var $author$project$Data$Widget$sectionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'platform',
	$author$project$Data$Widget$platformDecoder,
	$author$project$Data$Widget$AnyPlatform,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'widgets',
		$elm$json$Json$Decode$list($author$project$Data$Widget$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Widget$WidgetSection))));
var $author$project$Data$Widget$collectionDecoder = function () {
	var widgetToSoloSection = function (widget) {
		return {
			g6: $author$project$Data$Widget$AnyPlatform,
			bO: widget.bO,
			cB: _List_fromArray(
				[widget])
		};
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (version) {
			switch (version) {
				case 0:
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'widgets',
						$elm$json$Json$Decode$list(
							A2($elm$json$Json$Decode$map, widgetToSoloSection, $author$project$Data$Widget$decoder)),
						$elm$json$Json$Decode$succeed($author$project$Data$Widget$WidgetCollection));
				case 1:
					return A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sections',
						$elm$json$Json$Decode$list($author$project$Data$Widget$sectionDecoder),
						$elm$json$Json$Decode$succeed($author$project$Data$Widget$WidgetCollection));
				default:
					return $elm$json$Json$Decode$fail(
						'Unknown widget collection serialization version ' + $elm$core$String$fromInt(version));
			}
		},
		A2($elm$json$Json$Decode$field, 'serializationVersion', $elm$json$Json$Decode$int));
}();
var $author$project$Data$Incident$widgetSectionsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.hR;
		},
		function ($) {
			return $.hl;
		}),
	$author$project$Data$Locker$decoder($author$project$Data$Widget$collectionDecoder));
var $author$project$Data$Incident$comboDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formattedPrescriptionLog',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lockerItem',
		$author$project$Data$Incident$widgetSectionsDecoder,
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'otherIncidents',
			$elm$json$Json$Decode$list($author$project$Data$Incident$searchResultDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issue',
				$elm$json$Json$Decode$nullable($author$project$Data$Issue$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'logMetas',
					$elm$json$Json$Decode$list($author$project$Data$Incident$logMetaDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'highlights',
						$elm$json$Json$Decode$list($author$project$Data$Highlight$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'analyzedIncident',
							$author$project$Data$Incident$fullDecoder,
							$elm$json$Json$Decode$succeed($author$project$Data$Incident$ComboIncident))))))));
var $author$project$Data$Incident$SwitchActiveTenantInfo = F2(
	function (tenantId, incidentId) {
		return {cZ: incidentId, hz: tenantId};
	});
var $author$project$Data$Incident$switchTenantDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'incidentId',
	$author$project$UUID$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tenantId',
		$author$project$UUID$decoder,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$SwitchActiveTenantInfo)));
var $author$project$Data$Incident$TenantMembershipInfo = F2(
	function (tenantName, groups) {
		return {gc: groups, hA: tenantName};
	});
var $author$project$Data$Incident$SecurityGroupInfo = F2(
	function (name, id) {
		return {bj: id, ev: name};
	});
var $author$project$Data$Incident$securityGroupInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$SecurityGroupInfo)));
var $author$project$Data$Incident$tenantMembershipInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'groups',
	$elm$json$Json$Decode$list($author$project$Data$Incident$securityGroupInfoDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tenantName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$TenantMembershipInfo)));
var $author$project$Data$Incident$comboApiResultDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Incident$Incident,
			A2($elm$json$Json$Decode$field, 'incident', $author$project$Data$Incident$comboDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Incident$SwitchTenant,
			A2($elm$json$Json$Decode$field, 'switchTenant', $author$project$Data$Incident$switchTenantDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Incident$TenantMembershipNeeded,
			A2($elm$json$Json$Decode$field, 'joinTenant', $author$project$Data$Incident$tenantMembershipInfoDecoder))
		]));
var $author$project$Request$Incident$get = F2(
	function (accessToken, incidentId) {
		var url = '/gym/combo/incident?id=' + (incidentId + ('&lockerEntity=' + $author$project$Data$Locker$entityToString(0)));
		var responseDecoder = $author$project$Data$Incident$comboApiResultDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Classifier$Editor$ChartNotNeeded = {$: 0};
var $author$project$Page$Classifier$Editor$Content = 1;
var $author$project$Page$Classifier$Editor$Drill2Content = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Classifier$Editor$ViewModeClickToClassify = 4;
var $author$project$Page$Classifier$Editor$Meta = 0;
var $author$project$Page$Classifier$Editor$NoModal = 0;
var $author$project$Page$Classifier$Editor$NotRunning = 0;
var $author$project$Page$Classifier$DisplayFilter$AnyPlatform = {$: 0};
var $author$project$Page$Classifier$DisplayFilter$default = {cR: false, g6: $author$project$Page$Classifier$DisplayFilter$AnyPlatform};
var $author$project$Page$Classifier$RunResults$init = {gD: $elm$core$Maybe$Nothing, gH: _List_Nil, gT: 0, gW: 0, gX: 0, gZ: 0, g_: 0, eQ: 0};
var $author$project$Page$Classifier$Editor$defaultModel = F9(
	function (accessToken, user, content, label, meta, chartStatus, viewMode, remedies, groups) {
		return {a: accessToken, fC: chartStatus, L: content, af: $author$project$Page$Classifier$DisplayFilter$default, f$: _List_Nil, gc: groups, aM: $krisajenkins$remotedata$RemoteData$NotAsked, eo: label, er: meta, S: 0, hc: remedies, t: $author$project$Page$Classifier$RunResults$init, h: 0, ab: $elm$core$Maybe$Nothing, av: 0, cv: false, az: user, u: viewMode};
	});
var $author$project$View$Classifier$Drill2$Editor$initEmpty = {a7: 0, i: true, de: _List_Nil};
var $author$project$Data$Classifier$newMeta = F2(
	function (inputSpec, id) {
		return {
			dy: '',
			dT: $elm$time$Time$millisToPosix(0),
			b6: '',
			cJ: false,
			d4: $elm$core$Maybe$Nothing,
			cM: true,
			bj: id,
			c_: inputSpec,
			eo: '',
			bO: '',
			dx: 0
		};
	});
var $author$project$Page$Classifier$Editor$initForClickToClassify = F3(
	function (accessToken, user, uuid) {
		var meta = A2($author$project$Data$Classifier$newMeta, $author$project$Data$Classifier$IncidentSpec, uuid);
		var prepForClickToClassify = function () {
			var model = A9(
				$author$project$Page$Classifier$Editor$defaultModel,
				accessToken,
				user,
				$author$project$Page$Classifier$Editor$Drill2Content($author$project$View$Classifier$Drill2$Editor$initEmpty),
				$elm$core$Maybe$Just(''),
				meta,
				$author$project$Page$Classifier$Editor$ChartNotNeeded,
				4,
				_List_Nil,
				_List_Nil);
			return _Utils_update(
				model,
				{a: accessToken, av: 1});
		}();
		return $elm$core$Task$succeed(prepForClickToClassify);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Data$Widget$isSectionRelevantToPlatform = F2(
	function (platformName, section) {
		var _v0 = section.g6;
		if (!_v0.$) {
			return true;
		} else {
			var s = _v0.a;
			return _Utils_eq(
				$elm$core$String$toLower(s),
				$elm$core$String$toLower(platformName));
		}
	});
var $author$project$JsonTree$allHighlights = function (node) {
	var rest = function () {
		var _v0 = node.hR;
		switch (_v0.$) {
			case 3:
				var children = _v0.a;
				return A2($elm$core$List$concatMap, $author$project$JsonTree$allHighlights, children);
			case 4:
				var children = _v0.a;
				return A2(
					$elm$core$List$concatMap,
					$author$project$JsonTree$allHighlights,
					$elm$core$Dict$values(children));
			case 0:
				return _List_Nil;
			case 1:
				return _List_Nil;
			case 2:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	}();
	return _Utils_ap(node.gh, rest);
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$JsonTree$Resolver$evaluate = F2(
	function (tree, keyPath) {
		var _v0 = _Utils_Tuple2(keyPath, tree.hR);
		if (!_v0.a.b) {
			return $elm$core$Result$Ok(tree);
		} else {
			if (!_v0.a.a.$) {
				if (_v0.b.$ === 4) {
					var _v1 = _v0.a;
					var name = _v1.a.a;
					var rest = _v1.b;
					var dict = _v0.b.a;
					return A2(
						$elm$core$Result$andThen,
						function (subTree) {
							return A2($author$project$JsonTree$Resolver$evaluate, subTree, rest);
						},
						A2(
							$elm$core$Result$fromMaybe,
							'field \'' + (name + '\' not found'),
							A2($elm$core$Dict$get, name, dict)));
				} else {
					var _v2 = _v0.a;
					return $elm$core$Result$Err('cannot lookup field on non-object node');
				}
			} else {
				if (_v0.b.$ === 3) {
					var _v3 = _v0.a;
					var index = _v3.a.a;
					var rest = _v3.b;
					var values = _v0.b.a;
					return A2(
						$elm$core$Result$andThen,
						function (subTree) {
							return A2($author$project$JsonTree$Resolver$evaluate, subTree, rest);
						},
						A2(
							$elm$core$Result$fromMaybe,
							'index \'' + ($elm$core$String$fromInt(index) + '\' not found'),
							A2($elm_community$list_extra$List$Extra$getAt, index, values)));
				} else {
					var _v4 = _v0.a;
					return $elm$core$Result$Err('cannot lookup index on non-array node');
				}
			}
		}
	});
var $author$project$JsonTree$KeyPathParser$errorsToText = function (deadEnds) {
	var problemToText = function (deadEnd) {
		var _v0 = deadEnd.g9;
		switch (_v0.$) {
			case 0:
				var str = _v0.a;
				return 'expecting: ' + str;
			case 1:
				return 'expecting int ';
			case 2:
				return 'expecting hex';
			case 3:
				return 'expecting octal';
			case 4:
				return 'expecting binary';
			case 5:
				return 'expecting float';
			case 6:
				return 'expecting number';
			case 7:
				return 'expecting variable';
			case 10:
				return 'expecting end';
			case 8:
				var str = _v0.a;
				return 'expecting symbol: ' + str;
			case 9:
				var str = _v0.a;
				return 'expecting keyword: ' + str;
			case 11:
				return 'unexpected char';
			case 12:
				var str = _v0.a;
				return 'problem: ' + str;
			default:
				return 'bad repeat';
		}
	};
	return 'failed to parse key-path: ' + A2(
		$elm$core$String$join,
		', ',
		A2($elm$core$List$map, problemToText, deadEnds));
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $author$project$JsonTree$FieldSegment = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dO: 1, f: s.f, g: s.g, c: s.c + 1, eU: s.eU + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dO: s.dO + 1, f: s.f, g: s.g, c: newOffset, eU: s.eU, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $author$project$JsonTree$KeyPathParser$fieldName = function () {
	var isFieldNameChar = function (c) {
		return (c !== '.') && (c !== '[');
	};
	return $elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf(isFieldNameChar)),
			$elm$parser$Parser$chompWhile(isFieldNameChar)));
}();
var $author$project$JsonTree$KeyPathParser$fieldSegment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($author$project$JsonTree$FieldSegment),
		$elm$parser$Parser$symbol('.')),
	$author$project$JsonTree$KeyPathParser$fieldName);
var $author$project$JsonTree$IndexSegment = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {dO: s.dO + (newOffset - s.c), f: s.f, g: s.g, c: newOffset, eU: s.eU, b: s.b};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$Problem, row, col, x, context));
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.b);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.eU, s.dO - (floatOffset + s.c), invalid, s.f));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.b));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.b)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gp,
				c.eh,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gp,
				c.ez,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gp,
				c.dD,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.b),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.gp,
				c.d9,
				c.em,
				c.eb,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.gp,
				c.d9,
				c.em,
				c.eb,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.b),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				dD: $elm$core$Result$Err(invalid),
				d9: expecting,
				eb: $elm$core$Result$Err(invalid),
				eh: $elm$core$Result$Err(invalid),
				em: $elm$core$Result$Ok($elm$core$Basics$identity),
				gp: invalid,
				ez: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $author$project$JsonTree$KeyPathParser$indexSegment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($author$project$JsonTree$IndexSegment),
		$elm$parser$Parser$symbol('[')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$int,
		$elm$parser$Parser$symbol(']')));
var $author$project$JsonTree$KeyPathParser$segmentParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$JsonTree$KeyPathParser$fieldSegment, $author$project$JsonTree$KeyPathParser$indexSegment]));
var $author$project$JsonTree$KeyPathParser$zeroOrMoreSegments = function (revSegments) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					function (segment) {
						return $elm$parser$Parser$Loop(
							A2($elm$core$List$cons, segment, revSegments));
					}),
				$author$project$JsonTree$KeyPathParser$segmentParser),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Done(
						$elm$core$List$reverse(revSegments));
				},
				$elm$parser$Parser$succeed(0))
			]));
};
var $author$project$JsonTree$KeyPathParser$parser = A2(
	$elm$parser$Parser$keeper,
	$elm$parser$Parser$succeed($elm$core$Basics$identity),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$loop, _List_Nil, $author$project$JsonTree$KeyPathParser$zeroOrMoreSegments),
		$elm$parser$Parser$end));
var $author$project$JsonTree$KeyPathParser$parse = function (text) {
	return (text === '.') ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$core$Result$mapError,
		$author$project$JsonTree$KeyPathParser$errorsToText,
		A2($elm$parser$Parser$run, $author$project$JsonTree$KeyPathParser$parser, text));
};
var $author$project$JsonTree$Resolver$resolve = F2(
	function (rawKeyPath, tree) {
		return A2(
			$elm$core$Result$andThen,
			$author$project$JsonTree$Resolver$evaluate(tree),
			$author$project$JsonTree$KeyPathParser$parse(rawKeyPath));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$Widget$badgeCount = F2(
	function (tree, keyPath) {
		var countHighlights = function (subTree) {
			return $elm$core$List$length(
				$author$project$JsonTree$allHighlights(subTree));
		};
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Util$Numbers$toMaybe,
			A2(
				$elm$core$Maybe$map,
				countHighlights,
				$elm$core$Result$toMaybe(
					A2($author$project$JsonTree$Resolver$resolve, keyPath, tree))));
	});
var $author$project$View$Widget$DynamicList$badgeCount = F2(
	function (tree, configuration) {
		return A2($author$project$View$Widget$badgeCount, tree, configuration.K);
	});
var $author$project$View$Widget$DynamicTable$badgeCount = F2(
	function (tree, configuration) {
		return A2($author$project$View$Widget$badgeCount, tree, configuration.K);
	});
var $author$project$View$Widget$Generic$badgeCount = F2(
	function (tree, configuration) {
		return A2($author$project$View$Widget$badgeCount, tree, configuration.gy);
	});
var $author$project$View$Widget$StaticTable$badgeCount = F2(
	function (tree, configuration) {
		var count = function (keyPath) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($author$project$View$Widget$badgeCount, tree, keyPath));
		};
		return $author$project$Util$Numbers$toMaybe(
			A3(
				$elm$core$List$foldl,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hR;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gy;
						},
						A2($elm$core$Basics$composeR, count, $elm$core$Basics$add))),
				0,
				configuration.aW));
	});
var $author$project$Page$Incident$widgetBadgeCount = F2(
	function (tree, widget) {
		var badgeCount = function () {
			var _v0 = widget.b3;
			switch (_v0.$) {
				case 0:
					var widgetModel = _v0.a;
					return A2($author$project$View$Widget$StaticTable$badgeCount, tree, widgetModel.b1);
				case 2:
					var widgetModel = _v0.a;
					return A2($author$project$View$Widget$DynamicList$badgeCount, tree, widgetModel.b1);
				case 1:
					var widgetModel = _v0.a;
					return A2($author$project$View$Widget$DynamicTable$badgeCount, tree, widgetModel.b1);
				default:
					var widgetModel = _v0.a;
					return A2($author$project$View$Widget$Generic$badgeCount, tree, widgetModel.b1);
			}
		}();
		return _Utils_update(
			widget,
			{dC: badgeCount});
	});
var $author$project$Page$Incident$makeParsedIncident = F2(
	function (comboIncident, tree) {
		var platform = comboIncident.fp.er.g6;
		var badge = function (section) {
			return _Utils_update(
				section,
				{
					cB: A2(
						$elm$core$List$map,
						$author$project$Page$Incident$widgetBadgeCount(tree),
						section.cB)
				});
		};
		var adjustedIncident = _Utils_update(
			comboIncident,
			{
				hT: A2(
					$elm$core$List$map,
					badge,
					A2(
						$elm$core$List$filter,
						$author$project$Data$Widget$isSectionRelevantToPlatform(platform),
						comboIncident.hT))
			});
		return {gj: adjustedIncident, ac: tree};
	});
var $author$project$JsonTree$TDict = function (a) {
	return {$: 4, a: a};
};
var $author$project$JsonTree$TList = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$JsonTree$annotate = F3(
	function (highlights, pathSoFar, node) {
		var makeNode = function (value) {
			return {
				gh: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, pathSoFar, highlights)),
				gy: pathSoFar,
				hR: value
			};
		};
		var annotateList = F2(
			function (index, val) {
				return A3(
					$author$project$JsonTree$annotate,
					highlights,
					pathSoFar + ('[' + ($elm$core$String$fromInt(index) + ']')),
					val);
			});
		var annotateDict = F2(
			function (fieldName, val) {
				return A3($author$project$JsonTree$annotate, highlights, pathSoFar + ('.' + fieldName), val);
			});
		var _v0 = node.hR;
		switch (_v0.$) {
			case 0:
				return makeNode(node.hR);
			case 1:
				return makeNode(node.hR);
			case 2:
				return makeNode(node.hR);
			case 5:
				return makeNode(node.hR);
			case 3:
				var values = _v0.a;
				return makeNode(
					$author$project$JsonTree$TList(
						A2($elm$core$List$indexedMap, annotateList, values)));
			default:
				var dict = _v0.a;
				return makeNode(
					$author$project$JsonTree$TDict(
						A2($elm$core$Dict$map, annotateDict, dict)));
		}
	});
var $author$project$JsonTree$TBool = function (a) {
	return {$: 2, a: a};
};
var $author$project$JsonTree$TFloat = function (a) {
	return {$: 1, a: a};
};
var $author$project$JsonTree$TNull = {$: 5};
var $author$project$JsonTree$TString = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$JsonTree$cyclic$coreDecoder() {
	var makeNode = function (value) {
		return {gh: _List_Nil, gy: '', hR: value};
	};
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, makeNode, $author$project$JsonTree$TString),
				$elm$json$Json$Decode$string),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, makeNode, $author$project$JsonTree$TFloat),
				$elm$json$Json$Decode$float),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, makeNode, $author$project$JsonTree$TBool),
				$elm$json$Json$Decode$bool),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, makeNode, $author$project$JsonTree$TList),
				$elm$json$Json$Decode$list(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$JsonTree$cyclic$coreDecoder();
						}))),
				A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, makeNode, $author$project$JsonTree$TDict),
				$elm$json$Json$Decode$dict(
					$elm$json$Json$Decode$lazy(
						function (_v1) {
							return $author$project$JsonTree$cyclic$coreDecoder();
						}))),
				$elm$json$Json$Decode$null(
				makeNode($author$project$JsonTree$TNull))
			]));
}
var $author$project$JsonTree$coreDecoder = $author$project$JsonTree$cyclic$coreDecoder();
$author$project$JsonTree$cyclic$coreDecoder = function () {
	return $author$project$JsonTree$coreDecoder;
};
var $author$project$Util$Dict$collect = F3(
	function (key, value, dict) {
		var merge = function (maybeValues) {
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					value,
					A2($elm$core$Maybe$withDefault, _List_Nil, maybeValues)));
		};
		return A3($elm$core$Dict$update, key, merge, dict);
	});
var $author$project$JsonTree$groupHighlightsByKeyPath = function (highlights) {
	var groupByKeyPath = A2(
		$elm$core$List$foldl,
		F2(
			function (_v0, acc) {
				var keyPath = _v0.a;
				var highlight = _v0.b;
				return A3($author$project$Util$Dict$collect, keyPath, highlight, acc);
			}),
		$elm$core$Dict$empty);
	var associateByKeyPath = function (highlight) {
		return A2(
			$elm$core$List$map,
			function (m) {
				return _Utils_Tuple2(m.gy, highlight);
			},
			highlight.gI);
	};
	return groupByKeyPath(
		A2($elm$core$List$concatMap, associateByKeyPath, highlights));
};
var $author$project$JsonTree$parse = F2(
	function (json, rawHighlights) {
		var rootKeyPath = '';
		var groupedHighlights = $author$project$JsonTree$groupHighlightsByKeyPath(rawHighlights);
		var annotatingDecoder = A2(
			$elm$json$Json$Decode$map,
			A2($author$project$JsonTree$annotate, groupedHighlights, rootKeyPath),
			$author$project$JsonTree$coreDecoder);
		return A2($elm$json$Json$Decode$decodeValue, annotatingDecoder, json);
	});
var $author$project$Page$Incident$init = F5(
	function (accessToken, user, incidentIdOrEasyId, maybeTab, freshUuid) {
		var onOkResponse = F2(
			function (apiResult, editorModel) {
				switch (apiResult.$) {
					case 0:
						var incident = apiResult.a;
						var analyzedIncident = incident.fp;
						var highlights = incident.gh;
						var _v1 = A2($author$project$JsonTree$parse, analyzedIncident.gx, highlights);
						if (!_v1.$) {
							var tree = _v1.a;
							return $author$project$Page$Incident$LoadOk(
								A5(
									$author$project$Page$Incident$defaultModel,
									accessToken,
									A2($author$project$Page$Incident$makeParsedIncident, incident, tree),
									editorModel,
									maybeTab,
									'dummy'));
						} else {
							var err = _v1.a;
							return $author$project$Page$Incident$LoadFailed(
								'failed to parse incident JSON tree: ' + $elm$json$Json$Decode$errorToString(err));
						}
					case 2:
						var info = apiResult.a;
						return $author$project$Page$Incident$SwitchActiveTenant(info);
					default:
						var info = apiResult.a;
						return $author$project$Page$Incident$NeedsToJoinTenant(info);
				}
			});
		var loadIncident = A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to get incident details'),
			$elm$http$Http$toTask(
				A2($author$project$Request$Incident$get, accessToken, incidentIdOrEasyId)));
		return A3(
			$elm$core$Task$map2,
			onOkResponse,
			loadIncident,
			A3($author$project$Page$Classifier$Editor$initForClickToClassify, accessToken, user, freshUuid));
	});
var $author$project$Data$Incident$ComboSearchResult = F2(
	function (results, labels) {
		return {gA: labels, hg: results};
	});
var $author$project$Data$Incident$ClassifierLabelStats = F3(
	function (classifierId, label, count) {
		return {fG: classifierId, fR: count, eo: label};
	});
var $author$project$Data$Incident$classifierLabelStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['id', 'classifier']),
			$author$project$UUID$decoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Incident$ClassifierLabelStats))));
var $author$project$Data$Incident$comboSearchResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'labels',
	$elm$json$Json$Decode$list($author$project$Data$Incident$classifierLabelStatsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'results',
		$elm$json$Json$Decode$list($author$project$Data$Incident$searchResultDecoder),
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$ComboSearchResult)));
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (d, f, m) {
		if (m.$ === 1) {
			return d;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Request$Incident$combo = F2(
	function (accessToken, maybeQuery) {
		var url = '/gym/combo/incidents' + A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (it) {
				return '?query=' + $elm$url$Url$percentEncode(it);
			},
			maybeQuery);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Data$Incident$comboSearchResultDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Incident$List$defaultModel = F3(
	function (accessToken, maybeQuery, result) {
		var _v0 = function () {
			if (!maybeQuery.$) {
				var query = maybeQuery.a;
				return _Utils_Tuple2(query, true);
			} else {
				return _Utils_Tuple2('', false);
			}
		}();
		var initialQuery = _v0.a;
		var showingSearch = _v0.b;
		return {a: accessToken, f$: _List_Nil, am: false, at: false, au: initialQuery, aX: result.hg, aZ: showingSearch};
	});
var $author$project$Page$Incident$List$init = F2(
	function (accessToken, maybeQuery) {
		var task = $elm$http$Http$toTask(
			A2($author$project$Request$Incident$combo, accessToken, maybeQuery));
		var onSearchFailed = function (error) {
			return A2($author$project$Page$Error$http, 'failed to search incidents', error);
		};
		return A2(
			$elm$core$Task$mapError,
			onSearchFailed,
			A2(
				$elm$core$Task$map,
				A2($author$project$Page$Incident$List$defaultModel, accessToken, maybeQuery),
				task));
	});
var $author$project$Page$LogFile$And = 0;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Page$LogFile$applyAllFilters = function (model) {
	var pickerMatches = F2(
		function (fields, picker) {
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, picker.be, fields);
			if (!_v1.$) {
				var a = _v1.a;
				return A2($elm$core$Set$member, a, picker.G);
			} else {
				return false;
			}
		});
	var combinerFn = function () {
		var _v0 = model.aS;
		if (!_v0) {
			return $elm$core$List$all;
		} else {
			return $elm$core$List$any;
		}
	}();
	var searchMatches = function (haystack) {
		return A2(
			combinerFn,
			function (q) {
				return A2($elm$core$String$contains, q, haystack);
			},
			model.de);
	};
	return A2(
		$elm$core$List$map,
		function (entry) {
			var satisfied = searchMatches(entry.cQ) && A2(
				$elm$core$List$all,
				pickerMatches(entry.cb),
				model.T);
			return _Utils_eq(satisfied, !entry.bh) ? entry : _Utils_update(
				entry,
				{bh: !satisfied});
		},
		model.aN);
};
var $author$project$Page$LogFile$applyFiltersAndCache = function (model) {
	return _Utils_update(
		model,
		{
			aN: $author$project$Page$LogFile$applyAllFilters(model)
		});
};
var $author$project$Page$LogFile$makeEntry = function (m) {
	return {
		cb: m,
		cQ: $elm$core$String$toLower(
			A2($elm$core$String$join, ' ', m)),
		bh: false
	};
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Page$LogFile$makePicker = F3(
	function (messages, idx, column) {
		if (column.fg === 1) {
			var possibleValues = $elm$core$Set$fromList(
				A2(
					$elm$core$List$filterMap,
					$elm_community$list_extra$List$Extra$getAt(idx),
					messages));
			return $elm$core$Maybe$Just(
				{
					be: idx,
					ai: false,
					ev: column.ev,
					bC: $elm$core$List$sort(
						$elm$core$Set$toList(possibleValues)),
					G: possibleValues
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$LogFile$defaultModel = F2(
	function (incidentId, _v0) {
		var errors = _v0.f$;
		var fileName = _v0.f6;
		var messages = _v0.gL;
		var configDef = _v0.fN;
		return $author$project$Page$LogFile$applyFiltersAndCache(
			{
				fM: configDef,
				f$: errors,
				f6: fileName,
				cZ: incidentId,
				aN: A2($elm$core$List$map, $author$project$Page$LogFile$makeEntry, messages),
				T: A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Page$LogFile$makePicker(messages),
						configDef.b0)),
				de: _List_Nil,
				U: '',
				aS: 0
			});
	});
var $author$project$Data$LogFile$LogFileContentsMeta = F4(
	function (errors, fileName, messages, configDef) {
		return {fN: configDef, f$: errors, f6: fileName, gL: messages};
	});
var $author$project$Data$LogFile$logFileContentsMetaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'configuration',
	$author$project$Data$LogFile$fullDefDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'logs',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fileName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'errors',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Data$LogFile$LogFileContentsMeta)))));
var $author$project$Request$LogFile$fetchFancy = F3(
	function (accessToken, incidentId, fileId) {
		var url = '/gym/incidents/logs/' + ($author$project$UUID$toString(incidentId) + ('/files/' + ($elm$url$Url$percentEncode(fileId) + '/fancy')));
		var responseDecoder = $author$project$Data$LogFile$logFileContentsMetaDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$LogFile$init = F3(
	function (accessToken, incidentId, fileId) {
		var loadLogFile = $elm$http$Http$toTask(
			A3($author$project$Request$LogFile$fetchFancy, accessToken, incidentId, fileId));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load log file'),
			A2(
				$elm$core$Task$map,
				$author$project$Page$LogFile$defaultModel(incidentId),
				loadLogFile));
	});
var $author$project$Page$News$allNewsItems = _List_fromArray(
	[
		{
		fT: $elm$time$Time$millisToPosix(1547625600000),
		fX: '\nPreviously, the PowerLift website and videos focused on how it can be used to deflect\ncustomer support issues. But PowerLift also has some **powerful features for developers\nthat make debugging support issues easier**. Today we released a new video specifically\nfor developers that demonstrates some of these features:\n\n- incident design\n- customizing how incidents are displayed\n- click-to-classify\n- log file viewer\n\n**[Watch it now!](https://aka.ms/powerlift-2019-developer-edition)** (14 min)\n',
		bO: 'New video for developers'
	},
		{
		fT: $elm$time$Time$millisToPosix(1545379200000),
		fX: '\nThe remedy editor has been completely redesigned to make it easier to create/modify remedies.\n\nIn addition to being more intuitive, the new editor has improved support for multi-screen remedies.\nYou can easily create a remedy that asks the user a series of questions in order to lead them to a\nsolution (or, at a minimum, provide additional context to the support agent).\n\n[Give it a try](/#/remedies/new) and let us know if you have any questions/feedback.\n',
		bO: 'Redesigned remedy editor'
	},
		{
		fT: $elm$time$Time$millisToPosix(1543392000000),
		fX: '\nIf you use Helpshift for customer support, we have a new way to browse/explore PowerLift incidents.\nTicket Topics is a way to group incidents based on topics that you define. A topic is a single word like\n"spam" or "attachments". You can also enter multiple words to combine topics. A topic like "login signup"\nwill add together all of the results from the "login" topic and all of the results from the "signup" topic.\n\nFor more details see [the Ticket Topics docs](/#/docs/topics).\n',
		bO: 'Group Helpshift tickets by topic'
	},
		{
		fT: $elm$time$Time$millisToPosix(1530860400000),
		fX: '\nWe have redesigned the incident page to make it easier to quickly scan your app\'s diagnostic information.\n\n##### Widget Sections\n- Widgets can now be grouped into sections\n- Each section will be shown in the incident\'s sidebar\n- Go to the [edit widgets](/#/admin/widgets/) page to create some sections (or create your first widget,\nif you haven\'t done so already).\n\n##### Platform-specific Sections\n- show a section only when the incident\'s `platform` equals a certain value\n- useful if your team has, say, both an iOS app an and Android app\n\n##### Quick Nav\n- press the \'t\' key when viewing an incident to bring up a navigation menu\n- use your keyboard to easily jump around your incident and log files\n',
		bO: 'Redesigned incident page'
	},
		{
		fT: $elm$time$Time$millisToPosix(1523343600000),
		fX: '\nHave you ever wanted to see if any customers are running into a rare error? Or have you wanted to label\nlog files based on whether they contain a certain error message? Now it\'s possible to do that using\nPowerLift\'s file classifiers. All you need to do is provide a regex that matches the log message you\'re\ninterested in finding, and we will search all of your apps logs in PowerLift to find it.\n\nTry it now by creating a [new file classifier](/#/classifiers/new/regex):\n\n- **Run** the classifier to perform an ad-hoc search\n- Optionally **save** the classifier so that all log files in the future will also try to be matched by it.\n',
		bO: 'Search and classify log files!'
	},
		{
		fT: $elm$time$Time$millisToPosix(1519632000000),
		fX: '\nWe\'ve made it easier to create a classifier that matches incidents based on version. If your app uses\na basic `x.y.z`-style version number, you can check whether a version is older (or newer) than a given version.\n\nThis makes it really easy to create a "version too old" classifier. If a customer running old software\ncontacts support, you might want to give them a remedy that asks them to upgrade their software first\nbefore talking to a support agent. You can do that easily by first creating a "version too old" classifier\n(using the new version comparison operators introduced today) and second creating a remedy which asks the\nuser to upgrade their app (and wiring it up so that it\'s "triggered" by the "version too old" classifier).\n',
		bO: 'Smart version comparison'
	},
		{
		fT: $elm$time$Time$millisToPosix(1512374400000),
		fX: '\nDespite our best efforts, bugs happen. And sometimes customer PII is accidentally included in log files.\nPowerLift now has a way to retroactively "scrub" your data. You can create your own scrubbers on the\n[manage scrubbers](/#/admin/scrubbers/) page. For more information, see [the scrubber docs](/#/docs/scrubbers/).\n',
		bO: 'Retroactively scrub PII'
	},
		{
		fT: $elm$time$Time$millisToPosix(1511251200000),
		fX: '\nRemedies can now be configured to invoke custom hooks in your application. Suppose that your customer\nsupport agents frequently give instructions to your app\'s users telling them how to reset the application\'s\ncached data. Instead of giving each user point-by-point instructions on clearing the cache, you can show them\na PowerLift remedy with a button that directly triggers your app\'s clear-cache functionality via the\ncapability hook.\n\nFor more information, see [the remedy capability docs](/#/docs/capabilities)\n',
		bO: 'Custom remedy hooks'
	}
	]);
var $author$project$Page$News$defaultModel = function (lastReadDate) {
	return {f$: _List_Nil, c2: lastReadDate, c8: $author$project$Page$News$allNewsItems};
};
var $author$project$Data$Locker$incrementVersion = function (item) {
	return _Utils_update(
		item,
		{dx: item.dx + 1});
};
var $author$project$Data$Locker$mapValue = F2(
	function (f, item) {
		return {
			ca: item.ca,
			hR: f(item.hR),
			dx: item.dx
		};
	});
var $author$project$Page$News$markNewsRead = F2(
	function (lockerItem, now) {
		return _Utils_Tuple2(
			$author$project$Data$Locker$incrementVersion(
				A2(
					$author$project$Data$Locker$mapValue,
					function (settings) {
						return _Utils_update(
							settings,
							{gC: now});
					},
					lockerItem)),
			lockerItem.hR.gC);
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Data$Locker$encode = F2(
	function (item, encodeContents) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'entity',
					$elm$json$Json$Encode$string(item.ca)),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(item.dx)),
					_Utils_Tuple2(
					'value',
					encodeContents(item.hR))
				]));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.dr, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dX: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		et: month,
		fj: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dX;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).et;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fj;
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Util$JsonEncode$posixTime = function (d) {
	return $elm$json$Json$Encode$string(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(d));
};
var $author$project$Data$User$encodeUserSettings = function (userSettings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lastReadNews',
				$author$project$Util$JsonEncode$posixTime(userSettings.gC))
			]));
};
var $elm$http$Http$Internal$StringBody = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		$elm$http$Http$Internal$StringBody,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Request$Locker$storeItem = F4(
	function (accessToken, body, owner, responseDecoder) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$jsonBody(body),
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: $author$project$Request$Locker$urlForOwner(owner),
				hU: false
			});
	});
var $author$project$Request$User$setUserSettingsTask = F2(
	function (accessToken, item) {
		var responseDecoder = $elm$json$Json$Decode$succeed(0);
		var body = A2($author$project$Data$Locker$encode, item, $author$project$Data$User$encodeUserSettings);
		return $elm$http$Http$toTask(
			A4($author$project$Request$Locker$storeItem, accessToken, body, 1, responseDecoder));
	});
var $author$project$Page$News$init = function (accessToken) {
	return A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('Failed to update user settings'),
		A2(
			$elm$core$Task$andThen,
			function (_v0) {
				var newSettings = _v0.a;
				var prevDate = _v0.b;
				return A2(
					$elm$core$Task$map,
					$elm$core$Basics$always(
						$author$project$Page$News$defaultModel(prevDate)),
					A2($author$project$Request$User$setUserSettingsTask, accessToken, newSettings));
			},
			A3(
				$elm$core$Task$map2,
				$author$project$Page$News$markNewsRead,
				$author$project$Request$User$userSettingsTask(accessToken),
				$elm$time$Time$now)));
};
var $author$project$Page$Onboarding$SelectTenantStep = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Onboarding$defaultModel = function (onboardingResponse) {
	return {
		cE: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hB;
				},
				onboardingResponse)),
		f$: _List_Nil,
		a$: $author$project$Page$Onboarding$SelectTenantStep($elm$core$Maybe$Nothing)
	};
};
var $author$project$Data$Home$OnboardingResponse = function (tenants) {
	return {hB: tenants};
};
var $author$project$Data$Home$Tenant = F2(
	function (name, securityGroups) {
		return {ev: name, hm: securityGroups};
	});
var $author$project$Data$Home$SecurityGroup = F2(
	function (name, canWrite) {
		return {fz: canWrite, ev: name};
	});
var $author$project$Data$Home$securityGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'canWrite',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Home$SecurityGroup)));
var $author$project$Data$Home$tenantDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'securityGroups',
	$elm$json$Json$Decode$list($author$project$Data$Home$securityGroupDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Home$Tenant)));
var $author$project$Data$Home$onboardingResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tenants',
	$elm$json$Json$Decode$list($author$project$Data$Home$tenantDecoder),
	$elm$json$Json$Decode$succeed($author$project$Data$Home$OnboardingResponse));
var $author$project$Request$Home$getOnboarding = function (accessToken) {
	var url = '/gym/combo/home/onboarding';
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	var decoder = $author$project$Data$Home$onboardingResponseDecoder;
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(decoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: url,
			hU: false
		});
};
var $author$project$Page$Onboarding$init = function (accessToken) {
	var loadOnboardingData = A2(
		$elm$core$Task$map,
		$elm$core$Maybe$Just,
		$elm$http$Http$toTask(
			$author$project$Request$Home$getOnboarding(accessToken)));
	var degradeGracefully = function (_v0) {
		return $elm$core$Task$succeed(
			$author$project$Page$Onboarding$defaultModel($elm$core$Maybe$Nothing));
	};
	return A2(
		$elm$core$Task$onError,
		degradeGracefully,
		A2($elm$core$Task$map, $author$project$Page$Onboarding$defaultModel, loadOnboardingData));
};
var $author$project$TimePeriod$LastWeek = 1;
var $author$project$Page$Remedy$History$Loading = {$: 0};
var $author$project$Page$Remedy$History$CompletedStatsLoad = function (a) {
	return {$: 3, a: a};
};
var $author$project$Remedy$Stats$RemedyStats = F5(
	function (startTime, endTime, timesShown, ticketsDeflected, deflectionChart) {
		return {d0: deflectionChart, d6: endTime, e1: startTime, hD: ticketsDeflected, hF: timesShown};
	});
var $author$project$Remedy$Stats$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deflectionChart',
	$author$project$Data$Chart$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ticketsDeflected',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timesShown',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'endTime',
				$author$project$Util$JsonDecode$posixTime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'startTime',
					$author$project$Util$JsonDecode$posixTime,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Stats$RemedyStats))))));
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Request$Remedy$getStats = F4(
	function (accessToken, id, startTime, endTime) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'remedies',
					$author$project$UUID$toString(id),
					'stats'
				]),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'start',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(startTime)),
					A2(
					$elm$url$Url$Builder$string,
					'end',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endTime))
				]));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Remedy$Stats$decoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Util$Date$adjustHours = F2(
	function (numHours, posix) {
		var base = $elm$time$Time$posixToMillis(posix);
		return $elm$time$Time$millisToPosix(base + (((1000 * 60) * 60) * numHours));
	});
var $author$project$TimePeriod$timeOffsetDays = F2(
	function (numDays, posix) {
		return A2($author$project$Util$Date$adjustHours, 24 * numDays, posix);
	});
var $author$project$TimePeriod$startAndEnd = F2(
	function (period, now) {
		switch (period) {
			case 0:
				return _Utils_Tuple2(
					A2($author$project$TimePeriod$timeOffsetDays, -2, now),
					now);
			case 1:
				return _Utils_Tuple2(
					A2($author$project$TimePeriod$timeOffsetDays, -7, now),
					now);
			case 2:
				return _Utils_Tuple2(
					A2($author$project$TimePeriod$timeOffsetDays, -30, now),
					now);
			default:
				return _Utils_Tuple2(
					A2($author$project$TimePeriod$timeOffsetDays, -365, now),
					now);
		}
	});
var $author$project$TimePeriod$resolve = function (timePeriod) {
	return A2(
		$elm$core$Task$map,
		$author$project$TimePeriod$startAndEnd(timePeriod),
		$elm$time$Time$now);
};
var $author$project$Page$Remedy$History$fetchRemedyStats = F3(
	function (accessToken, remedyId, timePeriod) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Page$Remedy$History$CompletedStatsLoad,
			A2(
				$elm$core$Task$mapError,
				function (_v1) {
					return $elm$http$Http$NetworkError;
				},
				A2(
					$elm$core$Task$andThen,
					function (_v0) {
						var start = _v0.a;
						var end = _v0.b;
						return $elm$http$Http$toTask(
							A4($author$project$Request$Remedy$getStats, accessToken, remedyId, start, end));
					},
					$author$project$TimePeriod$resolve(timePeriod))));
	});
var $author$project$Page$Remedy$History$defaultModel = F3(
	function (accessToken, remedyId, history) {
		return _Utils_Tuple2(
			{
				a: accessToken,
				f$: _List_Nil,
				aJ: $elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.dx;
						},
						history)),
				cq: remedyId,
				cu: false,
				hr: $author$project$Page$Remedy$History$Loading
			},
			A3($author$project$Page$Remedy$History$fetchRemedyStats, accessToken, remedyId, 1));
	});
var $author$project$Remedy$RemedyLite = function (id) {
	return function (remedyClientId) {
		return function (version) {
			return function (createdAt) {
				return function (title) {
					return function (description) {
						return function (actor) {
							return function (enabled) {
								return function (triggerLabel) {
									return function (triggerPriority) {
										return {dy: actor, dT: createdAt, b6: description, cM: enabled, bj: id, aa: remedyClientId, bO: title, hN: triggerLabel, fc: triggerPriority, dx: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Remedy$liteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['trigger', 'priority']),
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['trigger', 'classificationLabel']),
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'actor',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$author$project$Util$JsonDecode$posixTime,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'version',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'remedyClientId',
									$author$project$UUID$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$author$project$UUID$decoder,
										$elm$json$Json$Decode$succeed($author$project$Remedy$RemedyLite)))))))))));
var $author$project$Request$Remedy$getHistory = F2(
	function (accessToken, id) {
		var url = '/gym/remedies/' + ($author$project$UUID$toString(id) + '/history');
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(
					$elm$json$Json$Decode$list($author$project$Remedy$liteDecoder)),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Remedy$History$init = F2(
	function (accessToken, remedyId) {
		var loadHistory = $elm$http$Http$toTask(
			A2($author$project$Request$Remedy$getHistory, accessToken, remedyId));
		var handleLoadFailed = function (error) {
			return A2($author$project$Page$Error$http, 'failed to load remedy history', error);
		};
		return A2(
			$elm$core$Task$mapError,
			handleLoadFailed,
			A2(
				$elm$core$Task$map,
				A2($author$project$Page$Remedy$History$defaultModel, accessToken, remedyId),
				loadHistory));
	});
var $author$project$Request$Remedy$ActivityStat = function (averageOver30Days) {
	return {a5: averageOver30Days};
};
var $author$project$Page$Remedy$List$EnabledStatus = 1;
var $author$project$Page$Remedy$List$SortByMostActive = 0;
var $author$project$Page$Remedy$List$defaultModel = F2(
	function (accessToken, _v0) {
		var remedies = _v0.hc;
		var stats = _v0.hr;
		var orDummyStats = function (maybe) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Request$Remedy$ActivityStat(-1),
				maybe);
		};
		var enhance = function (r) {
			return {
				hd: r,
				hr: orDummyStats(
					A2(
						$elm$core$Dict$get,
						$author$project$UUID$toString(r.bj),
						stats))
			};
		};
		return {
			a: accessToken,
			f$: _List_Nil,
			aq: $elm$core$Maybe$Nothing,
			hc: A2($elm$core$List$map, enhance, remedies),
			bG: '',
			bJ: 0,
			bL: 1
		};
	});
var $author$project$Request$Remedy$RemediesResponse = F2(
	function (remedies, stats) {
		return {hc: remedies, hr: stats};
	});
var $author$project$Request$Remedy$list = function (accessToken) {
	var statDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'averageOver30Days',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Request$Remedy$ActivityStat));
	var responseDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stats',
		$elm$json$Json$Decode$dict(statDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'remedies',
			$elm$json$Json$Decode$list($author$project$Remedy$liteDecoder),
			$elm$json$Json$Decode$succeed($author$project$Request$Remedy$RemediesResponse)));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/remedies',
			hU: false
		});
};
var $author$project$Page$Remedy$List$init = function (accessToken) {
	var loadRemedies = $elm$http$Http$toTask(
		$author$project$Request$Remedy$list(accessToken));
	var handleLoadFailed = function (error) {
		return A2($author$project$Page$Error$http, 'failed to load remedies', error);
	};
	return A2(
		$elm$core$Task$mapError,
		handleLoadFailed,
		A2(
			$elm$core$Task$map,
			$author$project$Page$Remedy$List$defaultModel(accessToken),
			loadRemedies));
};
var $author$project$Request$Remedy$ComboRemedyView = F2(
	function (remedy, classifiers) {
		return {fJ: classifiers, hd: remedy};
	});
var $author$project$Remedy$Internals = function (id) {
	return function (remedyClientId) {
		return function (version) {
			return function (createdAt) {
				return function (title) {
					return function (actor) {
						return function (description) {
							return function (enabled) {
								return function (triggerLabel) {
									return function (triggerPriority) {
										return function (screens) {
											return function (localizedStrings) {
												return {dy: actor, dT: createdAt, b6: description, cM: enabled, bj: id, r: localizedStrings, aa: remedyClientId, V: screens, bO: title, hN: triggerLabel, fc: triggerPriority, dx: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Remedy$Remedy = $elm$core$Basics$identity;
var $author$project$Remedy$ScreenList$ScreenList = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Remedy$Screen$Internals = F3(
	function (id, title, elements) {
		return {d3: elements, bj: id, bO: title};
	});
var $author$project$Remedy$Screen$Screen = $elm$core$Basics$identity;
var $author$project$Remedy$ScreenId$ScreenId = $elm$core$Basics$identity;
var $author$project$Remedy$ScreenId$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Remedy$Screen$BulletedList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Remedy$Screen$Button = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Remedy$Screen$H1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$Screen$Img = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$Screen$P = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remedy$Screen$GoToScreen = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$Screen$GoToUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remedy$Screen$UseCapability = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$Capability$Custom = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Remedy$Capability$Dismiss = {$: 2};
var $author$project$Remedy$Capability$Feedback = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Remedy$Capability$GoToMarket = {$: 0};
var $author$project$Remedy$Capability$TalkToAgent = {$: 1};
var $author$project$Remedy$PropertyBag$fromJson = $elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string);
var $author$project$Remedy$Capability$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		switch (id) {
			case 'GO_TO_MARKET':
				return $elm$json$Json$Decode$succeed($author$project$Remedy$Capability$GoToMarket);
			case 'TALK_TO_AGENT':
				return $elm$json$Json$Decode$succeed($author$project$Remedy$Capability$TalkToAgent);
			case 'DISMISS':
				return $elm$json$Json$Decode$succeed($author$project$Remedy$Capability$Dismiss);
			case 'FEEDBACK':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'props',
					$author$project$Remedy$PropertyBag$fromJson,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'event',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Remedy$Capability$Feedback)));
			default:
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'props',
					$author$project$Remedy$PropertyBag$fromJson,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						id,
						$elm$json$Json$Decode$succeed($author$project$Remedy$Capability$Custom)));
		}
	},
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
var $author$project$Util$JsonDecode$url = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $elm$url$Url$fromString(str);
		if (!_v0.$) {
			var u = _v0.a;
			return $elm$json$Json$Decode$succeed(u);
		} else {
			return $elm$json$Json$Decode$fail('could not parse \'' + (str + '\' as a URL'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Remedy$Screen$actionDecoder = function () {
	var decodeRest = function (actionType) {
		switch (actionType) {
			case 'go_to_screen':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'screenId',
					$author$project$Remedy$ScreenId$decoder,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$GoToScreen));
			case 'go_to_url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$author$project$Util$JsonDecode$url,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$GoToUrl));
			case 'use_capability':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'capability',
					$author$project$Remedy$Capability$decoder,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$UseCapability));
			default:
				return $elm$json$Json$Decode$fail('unknown action type: \'' + (actionType + '\''));
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeRest,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}();
var $author$project$Remedy$LocStr$TextId = $elm$core$Basics$identity;
var $author$project$Remedy$LocStr$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Remedy$Screen$elementDecoder = function () {
	var decodeRest = function (elementTag) {
		switch (elementTag) {
			case 'h1':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'text',
					$author$project$Remedy$LocStr$decoder,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$H1));
			case 'p':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'text',
					$author$project$Remedy$LocStr$decoder,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$P));
			case 'img':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$author$project$Util$JsonDecode$url,
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$Img));
			case 'button':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'action',
					$author$project$Remedy$Screen$actionDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$author$project$Remedy$LocStr$decoder,
						$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$Button)));
			case 'bulleted-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'items',
					$elm$json$Json$Decode$list($author$project$Remedy$LocStr$decoder),
					$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$BulletedList));
			default:
				return $elm$json$Json$Decode$fail('unknown tag: \'' + (elementTag + '\''));
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeRest,
		A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
}();
var $author$project$Remedy$Screen$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elements',
		$elm$json$Json$Decode$list($author$project$Remedy$Screen$elementDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Remedy$ScreenId$decoder,
				$elm$json$Json$Decode$succeed($author$project$Remedy$Screen$Internals)))));
var $author$project$Remedy$ScreenList$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (screens) {
		if (!screens.b) {
			return $elm$json$Json$Decode$fail('Must have at least one screen');
		} else {
			var s = screens.a;
			var rest = screens.b;
			return $elm$json$Json$Decode$succeed(
				A2($author$project$Remedy$ScreenList$ScreenList, s, rest));
		}
	},
	$elm$json$Json$Decode$list($author$project$Remedy$Screen$decoder));
var $author$project$Remedy$Localization$Table = $elm$core$Basics$identity;
var $author$project$Remedy$Localization$TableItem = F2(
	function (locStr, translations) {
		return {an: locStr, I: translations};
	});
var $author$project$Remedy$Localization$LanguageTag = $elm$core$Basics$identity;
var $author$project$Remedy$Localization$fromLangTagString = function (str) {
	return ($elm$core$String$length(str) < 2) ? $elm$core$Result$Err('Expected at least a two-letter language code, but got \'' + (str + '\'')) : $elm$core$Result$Ok(str);
};
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$fromList = F2(
	function (f, xs) {
		return {
			e: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return _Utils_Tuple2(
							f(k),
							_Utils_Tuple2(k, v));
					},
					xs)),
			W: f
		};
	});
var $author$project$Remedy$Localization$tagToString = function (_v0) {
	var lang = _v0;
	return lang;
};
var $author$project$Remedy$Localization$translationsDictKeyFunction = $author$project$Remedy$Localization$tagToString;
var $author$project$Remedy$Localization$decodeTranslationsHelp = F2(
	function (accum, kvPairs) {
		decodeTranslationsHelp:
		while (true) {
			if (!kvPairs.b) {
				return $elm$json$Json$Decode$succeed(
					A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Remedy$Localization$translationsDictKeyFunction, accum));
			} else {
				var _v1 = kvPairs.a;
				var langStr = _v1.a;
				var translatedStr = _v1.b;
				var rest = kvPairs.b;
				var _v2 = $author$project$Remedy$Localization$fromLangTagString(langStr);
				if (!_v2.$) {
					var langCode = _v2.a;
					var $temp$accum = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(langCode, translatedStr),
						accum),
						$temp$kvPairs = rest;
					accum = $temp$accum;
					kvPairs = $temp$kvPairs;
					continue decodeTranslationsHelp;
				} else {
					var error = _v2.a;
					return $elm$json$Json$Decode$fail(error);
				}
			}
		}
	});
var $author$project$Remedy$Localization$itemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Remedy$Localization$decodeTranslationsHelp(_List_Nil),
		$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$author$project$Remedy$LocStr$decoder,
		$elm$json$Json$Decode$succeed($author$project$Remedy$Localization$TableItem)));
var $author$project$Remedy$Localization$tableDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list($author$project$Remedy$Localization$itemDecoder));
var $author$project$Remedy$decoderV1 = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'localizedStrings',
		$author$project$Remedy$Localization$tableDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['content', 'screens']),
			$author$project$Remedy$ScreenList$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['trigger', 'priority']),
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['trigger', 'classificationLabel']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'actor',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'createdAt',
										$author$project$Util$JsonDecode$posixTime,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'version',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'remedyClientId',
												$author$project$UUID$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$author$project$UUID$decoder,
													$elm$json$Json$Decode$succeed($author$project$Remedy$Internals))))))))))))));
var $author$project$Remedy$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (serializationVersion) {
		switch (serializationVersion) {
			case 0:
				return $elm$json$Json$Decode$fail('Serialization version 0 is no longer supported');
			case 1:
				return $author$project$Remedy$decoderV1;
			default:
				return $elm$json$Json$Decode$fail(
					'Unknown serialization version: ' + $elm$core$String$fromInt(serializationVersion));
		}
	},
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(0),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['content', 'serializationVersion']),
				$elm$json$Json$Decode$int))));
var $author$project$Request$Remedy$comboRemedyViewDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classifiers',
	$elm$json$Json$Decode$list($author$project$Data$Classifier$metaDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remedy',
		$author$project$Remedy$decoder,
		$elm$json$Json$Decode$succeed($author$project$Request$Remedy$ComboRemedyView)));
var $author$project$Request$Remedy$comboView = F3(
	function (accessToken, remedyId, version) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'combo',
					'remedies',
					$author$project$UUID$toString(remedyId),
					'version',
					$elm$core$String$fromInt(version)
				]),
			_List_Nil);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Request$Remedy$comboRemedyViewDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Remedy$Viewer$HeatMapLoaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Remedy$Viewer$HeatOff = 0;
var $author$project$Page$Remedy$Viewer$Loading = {$: 0};
var $author$project$Page$Remedy$Viewer$NoDialog = 0;
var $author$project$Remedy$Localization$defaultLanguageTag = 'en';
var $author$project$Remedy$ScreenList$first = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$Remedy$Screen$id = function (_v0) {
	var screen = _v0;
	return screen.bj;
};
var $author$project$Remedy$firstScreenId = function (_v0) {
	var remedy = _v0;
	return $author$project$Remedy$Screen$id(
		$author$project$Remedy$ScreenList$first(remedy.V));
};
var $author$project$Remedy$HeatMap$Histogram = function (buckets) {
	return {dF: buckets};
};
var $author$project$Remedy$HeatMap$Bucket = F6(
	function (screenId, buttonId, remedyVersion, lang, count, percentage) {
		return {dG: buttonId, fR: count, gB: lang, g5: percentage, hf: remedyVersion, hk: screenId};
	});
var $author$project$Remedy$ScreenId$decoderFromString = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $elm$core$String$toInt(str);
		if (!_v0.$) {
			var s = _v0.a;
			return $elm$json$Json$Decode$succeed(s);
		} else {
			return $elm$json$Json$Decode$fail('expected a numeric string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Remedy$Localization$languageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$Remedy$Localization$fromLangTagString(str);
		if (_v0.$ === 1) {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		} else {
			var lang = _v0.a;
			return $elm$json$Json$Decode$succeed(lang);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Remedy$HeatMap$bucketDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'percentage',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lang',
			$author$project$Remedy$Localization$languageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'remedyVersion',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'buttonKey',
					$author$project$Remedy$LocStr$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'screenId',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[$author$project$Remedy$ScreenId$decoder, $author$project$Remedy$ScreenId$decoderFromString])),
						$elm$json$Json$Decode$succeed($author$project$Remedy$HeatMap$Bucket)))))));
var $author$project$Remedy$HeatMap$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'buckets',
	$elm$json$Json$Decode$list($author$project$Remedy$HeatMap$bucketDecoder),
	$elm$json$Json$Decode$succeed($author$project$Remedy$HeatMap$Histogram));
var $author$project$Request$Remedy$getHeatMap = F3(
	function (accessToken, id, version) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'remedies',
					$author$project$UUID$toString(id),
					'version',
					$elm$core$String$fromInt(version),
					'heatmap'
				]),
			_List_Nil);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Remedy$HeatMap$decoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Remedy$id = function (_v0) {
	var remedy = _v0;
	return remedy.bj;
};
var $author$project$Remedy$version = function (_v0) {
	var remedy = _v0;
	return remedy.dx;
};
var $author$project$Page$Remedy$Viewer$defaultModel = F2(
	function (accessToken, _v0) {
		var remedy = _v0.hd;
		var classifiers = _v0.fJ;
		return _Utils_Tuple2(
			{
				a: accessToken,
				fJ: classifiers,
				aE: $author$project$Remedy$firstScreenId(remedy),
				b7: 0,
				f$: _List_Nil,
				bi: $author$project$Page$Remedy$Viewer$Loading,
				bo: false,
				gB: $author$project$Remedy$Localization$defaultLanguageTag,
				bw: 0,
				hd: remedy
			},
			A2(
				$elm$core$Task$attempt,
				$author$project$Page$Remedy$Viewer$HeatMapLoaded,
				$elm$http$Http$toTask(
					A3(
						$author$project$Request$Remedy$getHeatMap,
						accessToken,
						$author$project$Remedy$id(remedy),
						$author$project$Remedy$version(remedy)))));
	});
var $author$project$Page$Error$SimpleError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Error$simpleWithTitle = F2(
	function (context, title) {
		return A2($author$project$Page$Error$SimpleError, context, title);
	});
var $author$project$Page$Remedy$Viewer$init = F3(
	function (accessToken, remedyId, remedyVersion) {
		var loadComboRemedy = $elm$http$Http$toTask(
			A3($author$project$Request$Remedy$comboView, accessToken, remedyId, remedyVersion));
		var handleLoadFailed = function (error) {
			if (error.$ === 4) {
				var err = error.a;
				return A2($elm$core$String$contains, 'Serialization version 0 is no longer supported', err) ? A2($author$project$Page$Error$simpleWithTitle, 'failed to load remedy', 'Remedies saved before 2019-01-04 can no longer be viewed') : A2($author$project$Page$Error$http, 'failed to load remedy', error);
			} else {
				return A2($author$project$Page$Error$http, 'failed to load remedy', error);
			}
		};
		return A2(
			$elm$core$Task$mapError,
			handleLoadFailed,
			A2(
				$elm$core$Task$map,
				$author$project$Page$Remedy$Viewer$defaultModel(accessToken),
				loadComboRemedy));
	});
var $author$project$Page$Scrubber$List$defaultModel = function (scrubbers) {
	return {f$: _List_Nil, ct: scrubbers};
};
var $author$project$Data$Scrubber$ScrubberDef = F7(
	function (id, version, createdAt, actor, enabled, description, redactorConfigs) {
		return {dy: actor, dT: createdAt, b6: description, cM: enabled, bj: id, df: redactorConfigs, dx: version};
	});
var $author$project$Data$Scrubber$GenericStringRedactor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Scrubber$IncidentDataRedactor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Scrubber$JsonFileRedactor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Scrubber$PlaintextFileRedactor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Scrubber$GenericStringRedactorType = 0;
var $author$project$Data$Scrubber$IncidentDataRedactorType = 1;
var $author$project$Data$Scrubber$JsonFileRedactorType = 3;
var $author$project$Data$Scrubber$PlaintextFileRedactorType = 2;
var $author$project$Data$Scrubber$serializationIdToType = function (id) {
	switch (id) {
		case 'GENERIC_STRING_REDACTOR':
			return $elm$core$Maybe$Just(0);
		case 'INCIDENT_DATA_REDACTOR':
			return $elm$core$Maybe$Just(1);
		case 'PLAINTEXT_FILE_REDACTOR':
			return $elm$core$Maybe$Just(2);
		case 'JSON_FILE_REDACTOR':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Scrubber$configDecoder = function () {
	var decodeNullAsEmptyString = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(''),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (typeId) {
			var _v0 = $author$project$Data$Scrubber$serializationIdToType(typeId);
			if (!_v0.$) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Data$Scrubber$GenericStringRedactor,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redactionPattern',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed(
									function (rp) {
										return {B: rp};
									})));
					case 1:
						var _v2 = _v0.a;
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Data$Scrubber$IncidentDataRedactor,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redactionPattern',
								decodeNullAsEmptyString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'keyPath',
									decodeNullAsEmptyString,
									$elm$json$Json$Decode$succeed(
										F2(
											function (k, rp) {
												return {gy: k, B: rp};
											})))));
					case 2:
						var _v3 = _v0.a;
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Data$Scrubber$PlaintextFileRedactor,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redactionPattern',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fileNamePattern',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed(
										F2(
											function (fp, rp) {
												return {aH: fp, B: rp};
											})))));
					default:
						var _v4 = _v0.a;
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Data$Scrubber$JsonFileRedactor,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redactionPattern',
								decodeNullAsEmptyString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'keyPath',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fileNamePattern',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed(
											F3(
												function (fp, k, rp) {
													return {aH: fp, gy: k, B: rp};
												}))))));
				}
			} else {
				return $elm$json$Json$Decode$fail('unknown node type: ' + typeId);
			}
		},
		A2($elm$json$Json$Decode$field, '@type', $elm$json$Json$Decode$string));
}();
var $author$project$Data$Scrubber$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redactorConfigs',
	$elm$json$Json$Decode$list($author$project$Data$Scrubber$configDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'actor',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$author$project$Util$JsonDecode$posixTime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'version',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$author$project$UUID$decoder,
							$elm$json$Json$Decode$succeed($author$project$Data$Scrubber$ScrubberDef))))))));
var $author$project$Request$Scrubber$list = function (accessToken) {
	var responseDecoder = A2(
		$elm$json$Json$Decode$field,
		'currentDefinitions',
		$elm$json$Json$Decode$list($author$project$Data$Scrubber$decoder));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/scrubbers',
			hU: false
		});
};
var $author$project$Page$Scrubber$List$init = function (accessToken) {
	var loadScrubbers = $elm$http$Http$toTask(
		$author$project$Request$Scrubber$list(accessToken));
	return A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('list scrubbers failed'),
		A2($elm$core$Task$map, $author$project$Page$Scrubber$List$defaultModel, loadScrubbers));
};
var $author$project$Page$SdkList$ObjcTab = 0;
var $author$project$Page$SdkList$defaultModel = {f$: _List_Nil, av: 0};
var $author$project$Page$SdkList$init = $elm$core$Task$succeed($author$project$Page$SdkList$defaultModel);
var $author$project$Page$Tenant$NotShown = {$: 0};
var $author$project$Data$Tenant$TenantSettings = F2(
	function (apiKeys, securityGroups) {
		return {fq: apiKeys, hm: securityGroups};
	});
var $author$project$Data$Tenant$TenantApiKey = F9(
	function (key, publicId, active, canRead, canWrite, canAccessGym, description, createdAt, deactivatedAt) {
		return {aC: active, fy: canAccessGym, dJ: canRead, fz: canWrite, dT: createdAt, fU: deactivatedAt, b6: description, en: key, eL: publicId};
	});
var $author$project$Data$Tenant$tenantApiKeyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'deactivatedAt',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Util$JsonDecode$posixTime),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createdAt',
		$author$project$Util$JsonDecode$posixTime,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'description',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'canAccessGym',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'canWrite',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'canRead',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isActive',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'publicId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Data$Tenant$TenantApiKey))))))))));
var $author$project$Data$Tenant$TenantSecurityGroup = F6(
	function (aadId, displayName, active, canRead, canWrite, allowNonFte) {
		return {fl: aadId, aC: active, fo: allowNonFte, dJ: canRead, fz: canWrite, fZ: displayName};
	});
var $author$project$Data$Tenant$tenantSecurityGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'allowNonFte',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'canWrite',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'canRead',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'active',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'displayName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Tenant$TenantSecurityGroup)))))));
var $author$project$Data$Tenant$tenantSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'securityGroups',
	$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantSecurityGroupDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apiKeys',
		$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantApiKeyDecoder),
		$elm$json$Json$Decode$succeed($author$project$Data$Tenant$TenantSettings)));
var $author$project$Request$Tenant$get = function (accessToken) {
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson($author$project$Data$Tenant$tenantSettingsDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/tenant/settings',
			hU: false
		});
};
var $author$project$Page$Tenant$init = function (accessToken) {
	var makeModel = function (settings) {
		return {a: accessToken, f$: _List_Nil, j: $author$project$Page$Tenant$NotShown, bI: settings};
	};
	return A2(
		$elm$core$Task$map,
		makeModel,
		A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$HttpError('Tenant Settings'),
			$elm$http$Http$toTask(
				$author$project$Request$Tenant$get(accessToken))));
};
var $author$project$Page$Timeline$defaultModel = F2(
	function (installId, events) {
		return {cN: events, ce: installId};
	});
var $author$project$Data$Timeline$ConversationEvent = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Data$Timeline$IncidentEvent = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Data$Timeline$RemedyFeedbackEvent = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Data$Timeline$SupportTicketEvent = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Data$Incident$RemedyFeedback = F3(
	function (event, createdAt, properties) {
		return {dT: createdAt, f0: event, ha: properties};
	});
var $author$project$Data$Incident$remedyFeedbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'properties',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createdAt',
		$author$project$Util$JsonDecode$posixTime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'event',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Incident$RemedyFeedback))));
var $author$project$Data$Timeline$eventDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case '.IncidentEvent':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'logMetas',
					$elm$json$Json$Decode$list($author$project$Data$Incident$logMetaDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'analyzedIncident',
						$author$project$Data$Incident$liteDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Util$JsonDecode$posixTime,
							$elm$json$Json$Decode$succeed($author$project$Data$Timeline$IncidentEvent))));
			case '.SupportTicketEvent':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'incidentId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'issueBrief',
						$author$project$Data$Issue$briefDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Util$JsonDecode$posixTime,
							$elm$json$Json$Decode$succeed($author$project$Data$Timeline$SupportTicketEvent))));
			case '.ConversationEvent':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message',
					$author$project$Data$Issue$messageDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'endUser',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Util$JsonDecode$posixTime,
							$elm$json$Json$Decode$succeed($author$project$Data$Timeline$ConversationEvent))));
			case '.RemedyFeedbackEvent':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'feedback',
					$author$project$Data$Incident$remedyFeedbackDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'remedy',
						$author$project$Data$Incident$prescribedRemedyDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Util$JsonDecode$posixTime,
							$elm$json$Json$Decode$succeed($author$project$Data$Timeline$RemedyFeedbackEvent))));
			default:
				return $elm$json$Json$Decode$fail('unknown event type: ' + eventType);
		}
	},
	A2($elm$json$Json$Decode$field, '@class', $elm$json$Json$Decode$string));
var $author$project$Request$Timeline$get = F2(
	function (accessToken, installId) {
		var url = '/gym/combo/timeline/' + installId;
		var responseDecoder = A2(
			$elm$json$Json$Decode$field,
			'events',
			$elm$json$Json$Decode$list($author$project$Data$Timeline$eventDecoder));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Timeline$init = F2(
	function (accessToken, installId) {
		var loadTimeline = $elm$http$Http$toTask(
			A2($author$project$Request$Timeline$get, accessToken, installId));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load timeline'),
			A2(
				$elm$core$Task$map,
				$author$project$Page$Timeline$defaultModel(installId),
				loadTimeline));
	});
var $author$project$Page$Widget$CollectionEditor$defaultModel = F2(
	function (accessToken, lockerItem) {
		return {a: accessToken, f$: _List_Nil, cg: false, bv: lockerItem.dx, aQ: $elm$core$Maybe$Nothing, hl: lockerItem.hR.hl};
	});
var $author$project$Data$Locker$Team = 0;
var $author$project$Data$Widget$defaultWidgetCollection = {hl: _List_Nil};
var $author$project$Request$WidgetCollection$getTask = function (accessToken) {
	var entityName = $author$project$Data$Locker$entityToString(0);
	var onLoadFailed = function (error) {
		return $author$project$Util$Http$isResourceNotFound(error) ? $elm$core$Task$succeed(
			A3($author$project$Data$Locker$LockerItem, entityName, 0, $author$project$Data$Widget$defaultWidgetCollection)) : $elm$core$Task$fail(error);
	};
	return A2(
		$elm$core$Task$onError,
		onLoadFailed,
		$elm$http$Http$toTask(
			A4($author$project$Request$Locker$fetchItem, accessToken, entityName, 0, $author$project$Data$Widget$collectionDecoder)));
};
var $author$project$Page$Widget$CollectionEditor$init = function (accessToken) {
	var loadSectionEditor = $author$project$Request$WidgetCollection$getTask(accessToken);
	var handleHttpError = $author$project$Page$Error$http('widget list network failure');
	return A2(
		$elm$core$Task$mapError,
		handleHttpError,
		A2(
			$elm$core$Task$map,
			$author$project$Page$Widget$CollectionEditor$defaultModel(accessToken),
			loadSectionEditor));
};
var $author$project$Page$Widget$SectionEditor$defaultModel = F3(
	function (accessToken, sectionIndex, _v0) {
		var lockerVersion = _v0.a;
		var sections = _v0.b;
		return {a: accessToken, f$: _List_Nil, cg: false, ak: false, bv: lockerVersion, aR: $elm$core$Maybe$Nothing, F: sectionIndex, hl: sections};
	});
var $author$project$Page$Error$simple = function (context) {
	return A2($author$project$Page$Error$SimpleError, context, 'Something Went Wrong');
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Page$Widget$SectionEditor$init = F2(
	function (accessToken, sectionIndex) {
		var selectSection = function (sections) {
			var _v2 = A2($elm_community$list_extra$List$Extra$splitAt, sectionIndex, sections);
			var pre = _v2.a;
			var post = _v2.b;
			var mySection = $elm$core$List$head(post);
			if (!mySection.$) {
				var section = mySection.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$SelectList$fromLists,
						pre,
						section,
						A2($elm$core$List$drop, 1, post)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var selectSectionTask = function (_v1) {
			var version = _v1.dx;
			var value = _v1.hR;
			var _v0 = selectSection(value.hl);
			if (!_v0.$) {
				var sections = _v0.a;
				return $elm$core$Task$succeed(
					_Utils_Tuple2(version, sections));
			} else {
				return $elm$core$Task$fail(
					$author$project$Page$Error$simple(
						'failed to find section at ' + $elm$core$String$fromInt(sectionIndex)));
			}
		};
		var loadCollectionEditor = A2(
			$elm$core$Task$andThen,
			selectSectionTask,
			A2(
				$elm$core$Task$mapError,
				$author$project$Page$Error$http('failed to get widgets'),
				$author$project$Request$WidgetCollection$getTask(accessToken)));
		return A2(
			$elm$core$Task$map,
			A2($author$project$Page$Widget$SectionEditor$defaultModel, accessToken, sectionIndex),
			loadCollectionEditor);
	});
var $author$project$Page$Classifier$Editor$ViewModeClone = 3;
var $author$project$Page$Classifier$Editor$ViewModeEdit = 2;
var $author$project$Page$Classifier$Editor$ChartLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$ComboClassifier$ComboClassifier = F4(
	function (classifier, chart, remedies, groups) {
		return {fC: chart, fE: classifier, gc: groups, hc: remedies};
	});
var $author$project$Data$ComboClassifier$ComboClassifierGroup = F3(
	function (group, isMember, tenants) {
		return {gb: group, gq: isMember, hB: tenants};
	});
var $author$project$Data$Group$Group = F3(
	function (id, name, description) {
		return {b6: description, bj: id, ev: name};
	});
var $author$project$Data$Group$groupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$UUID$decoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Group$Group))));
var $author$project$Data$ComboClassifier$groupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tenants',
	$elm$json$Json$Decode$list($author$project$Data$Tenant$tenantLiteDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'member',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'group',
			$author$project$Data$Group$groupDecoder,
			$elm$json$Json$Decode$succeed($author$project$Data$ComboClassifier$ComboClassifierGroup))));
var $author$project$Data$ComboClassifier$comboDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'groups',
	$elm$json$Json$Decode$list($author$project$Data$ComboClassifier$groupDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remedies',
		$elm$json$Json$Decode$list($author$project$Remedy$liteDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'chart',
			$author$project$Data$Chart$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'classifier',
				$author$project$Data$Classifier$decoder,
				$elm$json$Json$Decode$succeed($author$project$Data$ComboClassifier$ComboClassifier)))));
var $author$project$Request$ComboClassifier$getComboClassifier = F4(
	function (accessToken, id, startTime, endTime) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'combo',
					'classifier',
					$author$project$UUID$toString(id)
				]),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'start',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(startTime)),
					A2(
					$elm$url$Url$Builder$string,
					'end',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endTime))
				]));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Data$ComboClassifier$comboDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Classifier$Editor$FileRegexContent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Classifier$Editor$JavascriptContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Classifier$Editor$RandomContent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Classifier$Editor$UnknownContent = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$View$Classifier$Drill2$Editor$ObjectQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$PrimitiveQuery = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$StringType = 1;
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$View$Classifier$Drill2$Editor$ArraySizeType = 4;
var $author$project$View$Classifier$Drill2$Editor$BoolType = 2;
var $author$project$View$Classifier$Drill2$Editor$NumberType = 0;
var $author$project$View$Classifier$Drill2$Editor$VersionType = 3;
var $author$project$View$Classifier$Drill2$Editor$decodeDataType = function (dataType) {
	switch (dataType) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$View$Classifier$Drill2$Editor$Eq = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$Gt = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$IsNull = {$: 3};
var $author$project$View$Classifier$Drill2$Editor$Lt = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$MultiEq = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$MultiSubstr = function (a) {
	return {$: 6, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$Substring = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$decodeOperand = F3(
	function (combiner, op, values) {
		if ($elm$core$List$length(values) > 1) {
			switch (op) {
				case 0:
					return $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$MultiEq(
							_Utils_ap(
								values,
								_List_fromArray(
									['']))));
				case 4:
					if (combiner === 1) {
						return $elm$core$Result$Ok(
							$author$project$View$Classifier$Drill2$Editor$MultiSubstr(
								_Utils_ap(
									values,
									_List_fromArray(
										['']))));
					} else {
						return $elm$core$Result$Ok(
							$author$project$View$Classifier$Drill2$Editor$MultiSubstr(
								_Utils_ap(
									values,
									_List_fromArray(
										['']))));
					}
				default:
					return $elm$core$Result$Err('multiple values only supported for equals and substring');
			}
		} else {
			var val = A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(values));
			switch (op) {
				case 0:
					return $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$Eq(val));
				case 1:
					return $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$Lt(val));
				case 2:
					return $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$Gt(val));
				case 3:
					return $elm$core$Result$Ok($author$project$View$Classifier$Drill2$Editor$IsNull);
				default:
					return $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$Substring(val));
			}
		}
	});
var $author$project$View$Classifier$Drill2$Editor$decodeDrillCondition = F3(
	function (isObjQuery, root, cond) {
		var path = isObjQuery ? cond.en : root;
		var maybeOp = A3($author$project$View$Classifier$Drill2$Editor$decodeOperand, cond.a7, cond.eB, cond.fe);
		return A2(
			$elm$core$Result$map,
			function (op) {
				return {
					a7: cond.a7,
					dW: $author$project$View$Classifier$Drill2$Editor$decodeDataType(cond.dW),
					ew: cond.ew,
					eB: op,
					eF: path
				};
			},
			maybeOp);
	});
var $author$project$View$Classifier$Drill2$Editor$defaultOp = function (dataType) {
	if (dataType === 2) {
		return $author$project$View$Classifier$Drill2$Editor$Eq('true');
	} else {
		return $author$project$View$Classifier$Drill2$Editor$Eq('');
	}
};
var $author$project$View$Classifier$Drill2$Editor$defaultQueryDetails = F4(
	function (path, dataType, op, combiner) {
		return {
			a7: combiner,
			dW: dataType,
			ew: false,
			eB: A2(
				$elm$core$Maybe$withDefault,
				$author$project$View$Classifier$Drill2$Editor$defaultOp(dataType),
				op),
			eF: path
		};
	});
var $author$project$View$Classifier$Drill2$Editor$defaultQuery = F2(
	function (path, dataType) {
		if (dataType === 5) {
			return A2(
				$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
				path,
				_List_fromArray(
					[
						A4($author$project$View$Classifier$Drill2$Editor$defaultQueryDetails, '', 1, $elm$core$Maybe$Nothing, 1)
					]));
		} else {
			return $author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(
				A4($author$project$View$Classifier$Drill2$Editor$defaultQueryDetails, path, dataType, $elm$core$Maybe$Nothing, 1));
		}
	});
var $author$project$View$Classifier$Drill2$Editor$decodeDrillQuery = function (_v0) {
	var path = _v0.eF;
	var conditions = _v0.dQ;
	var validateDecodedConditions = F2(
		function (isObjQuery, decodedConditions) {
			if (!decodedConditions.b) {
				return $elm$core$Result$Ok(
					A2($author$project$View$Classifier$Drill2$Editor$defaultQuery, path, 1));
			} else {
				if (!decodedConditions.b.b) {
					var cond = decodedConditions.a;
					return isObjQuery ? $elm$core$Result$Ok(
						A2(
							$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
							path,
							_List_fromArray(
								[cond]))) : $elm$core$Result$Ok(
						$author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(cond));
				} else {
					var conds = decodedConditions;
					return isObjQuery ? $elm$core$Result$Ok(
						A2($author$project$View$Classifier$Drill2$Editor$ObjectQuery, path, conds)) : $elm$core$Result$Err('multiple conditions are only supported for objects');
				}
			}
		});
	var condsWithKeysCount = A2(
		$elm_community$list_extra$List$Extra$count,
		function (c) {
			return !$elm$core$String$isEmpty(c.en);
		},
		conditions);
	var condsCount = $elm$core$List$length(conditions);
	var isObjQueryResult = ((condsWithKeysCount > 0) && (_Utils_cmp(condsWithKeysCount, condsCount) < 0)) ? $elm$core$Result$Err('query has mixed empty and non-empty keys') : (((!condsWithKeysCount) && (condsCount > 1)) ? $elm$core$Result$Err('query has multiple conditions without keys') : ((!condsWithKeysCount) ? $elm$core$Result$Ok(false) : $elm$core$Result$Ok(true)));
	return A2(
		$elm$core$Result$andThen,
		function (isObjQuery) {
			return A2(
				$elm$core$Result$andThen,
				validateDecodedConditions(isObjQuery),
				$elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						A2($author$project$View$Classifier$Drill2$Editor$decodeDrillCondition, isObjQuery, path),
						conditions)));
		},
		isObjQueryResult);
};
var $author$project$View$Classifier$Drill2$Editor$init = F2(
	function (config, editable) {
		var makeModel = function (queries) {
			return _Utils_Tuple2(
				{a7: config.eq.a7, i: editable, de: queries},
				config.eo);
		};
		return A2(
			$elm$core$Result$map,
			makeModel,
			$elm_community$result_extra$Result$Extra$combine(
				A2($elm$core$List$map, $author$project$View$Classifier$Drill2$Editor$decodeDrillQuery, config.eq.de)));
	});
var $author$project$View$Classifier$FileRegex$Editor$init = F2(
	function (config, editable) {
		return _Utils_Tuple2(
			{cG: config.cG, i: editable, db: config.db, cv: false},
			config.eo);
	});
var $author$project$View$Classifier$Javascript$Editor$init = F2(
	function (config, editable) {
		return {i: editable, bs: config, cv: false};
	});
var $author$project$View$Classifier$Random$Editor$init = F2(
	function (config, editable) {
		return _Utils_Tuple2(
			{i: editable, dc: config.dc, cv: false},
			config.eo);
	});
var $author$project$Page$Classifier$Editor$isEditable = function (viewMode) {
	if (viewMode === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Page$Classifier$Editor$createContentModel = F2(
	function (classifierConfig, viewMode) {
		var editable = $author$project$Page$Classifier$Editor$isEditable(viewMode);
		switch (classifierConfig.$) {
			case 0:
				var config = classifierConfig.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Page$Classifier$Editor$JavascriptContent(
							A2($author$project$View$Classifier$Javascript$Editor$init, config, editable)),
						$elm$core$Maybe$Nothing));
			case 1:
				var config = classifierConfig.a;
				return A2(
					$elm$core$Result$map,
					A2($elm$core$Tuple$mapBoth, $author$project$Page$Classifier$Editor$Drill2Content, $elm$core$Maybe$Just),
					A2($author$project$View$Classifier$Drill2$Editor$init, config, editable));
			case 2:
				var config = classifierConfig.a;
				return $elm$core$Result$Ok(
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Page$Classifier$Editor$RandomContent,
						$elm$core$Maybe$Just,
						A2($author$project$View$Classifier$Random$Editor$init, config, editable)));
			case 3:
				var config = classifierConfig.a;
				return $elm$core$Result$Ok(
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Page$Classifier$Editor$FileRegexContent,
						$elm$core$Maybe$Just,
						A2($author$project$View$Classifier$FileRegex$Editor$init, config, editable)));
			default:
				var config = classifierConfig.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Page$Classifier$Editor$UnknownContent(config),
						$elm$core$Maybe$Nothing));
		}
	});
var $author$project$Page$Classifier$Editor$makeModel = function (info) {
	var _v0 = A2($author$project$Page$Classifier$Editor$createContentModel, info.fE.fM, info.u);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var content = _v1.a;
		var label = _v1.b;
		return $elm$core$Task$succeed(
			A9($author$project$Page$Classifier$Editor$defaultModel, info.a, info.az, content, label, info.fE.er, info.b_, info.u, info.hc, info.gc));
	} else {
		var e = _v0.a;
		return $elm$core$Task$fail(
			$author$project$Page$Error$simple(e));
	}
};
var $author$project$Page$Classifier$Editor$initForViewOrEdit = F4(
	function (accessToken, user, id, viewMode) {
		var makeModelInput = function (combo) {
			return {
				a: accessToken,
				b_: $author$project$Page$Classifier$Editor$ChartLoaded(combo.fC),
				fE: combo.fE,
				gc: combo.gc,
				hc: combo.hc,
				az: user,
				u: viewMode
			};
		};
		var loadCombo = function (_v0) {
			var startTime = _v0.a;
			var endTime = _v0.b;
			return $elm$http$Http$toTask(
				A4($author$project$Request$ComboClassifier$getComboClassifier, accessToken, id, startTime, endTime));
		};
		var handleLoadFailed = function (error) {
			return A2($author$project$Page$Error$http, 'failed to get classifier', error);
		};
		return A2(
			$elm$core$Task$andThen,
			$author$project$Page$Classifier$Editor$makeModel,
			A2(
				$elm$core$Task$mapError,
				handleLoadFailed,
				A2(
					$elm$core$Task$map,
					makeModelInput,
					A2(
						$elm$core$Task$andThen,
						loadCombo,
						$author$project$TimePeriod$resolve(1)))));
	});
var $author$project$Page$Classifier$Editor$initForEdit = F3(
	function (accessToken, user, id) {
		return A4($author$project$Page$Classifier$Editor$initForViewOrEdit, accessToken, user, id, 2);
	});
var $author$project$Page$Classifier$Editor$initForClone = F4(
	function (accessToken, user, originalUuid, newUuid) {
		var cleanSlate = function (meta) {
			return _Utils_update(
				meta,
				{dy: '', bj: newUuid, bO: meta.bO + '-COPY', dx: 0});
		};
		var prepareClone = function (model) {
			return _Utils_update(
				model,
				{
					a: accessToken,
					fC: $author$project$Page$Classifier$Editor$ChartNotNeeded,
					er: cleanSlate(model.er),
					u: 3
				});
		};
		return A2(
			$elm$core$Task$map,
			prepareClone,
			A3($author$project$Page$Classifier$Editor$initForEdit, accessToken, user, originalUuid));
	});
var $author$project$Remedy$clone = F2(
	function (newRemedyId, _v0) {
		var remedy = _v0;
		return _Utils_update(
			remedy,
			{dy: '', bj: newRemedyId, aa: $author$project$UUID$nil, bO: remedy.bO + '-COPY', dx: 0});
	});
var $author$project$Request$Remedy$ComboRemedyEdit = F4(
	function (remedy, triggerSuggestions, capabilities, isAutoTranslateEnabled) {
		return {bY: capabilities, aK: isAutoTranslateEnabled, hd: remedy, a2: triggerSuggestions};
	});
var $author$project$Remedy$Editor$Trigger$TriggerSuggestion = F4(
	function (label, classifierTitle, classifierDescription, classifierId) {
		return {fF: classifierDescription, fG: classifierId, fH: classifierTitle, eo: label};
	});
var $author$project$Remedy$Editor$Trigger$suggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['classifierId', 'id']),
	$author$project$UUID$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classifierDescription',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'classifierTitle',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Remedy$Editor$Trigger$TriggerSuggestion)))));
var $author$project$Request$Remedy$comboRemedyEditDecoder = function (optionalRemedyDecoder) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isAutoTranslateEnabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'capabilities',
			$elm$json$Json$Decode$list($author$project$Remedy$CustomCapability$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'labelSuggestions',
				$elm$json$Json$Decode$list($author$project$Remedy$Editor$Trigger$suggestionDecoder),
				optionalRemedyDecoder(
					$elm$json$Json$Decode$succeed($author$project$Request$Remedy$ComboRemedyEdit)))));
};
var $author$project$Request$Remedy$comboEdit = F2(
	function (accessToken, remedyId) {
		var responseDecoder = $author$project$Request$Remedy$comboRemedyEditDecoder(
			A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remedy', $author$project$Remedy$decoder));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/combo/remedies/edit/' + $author$project$UUID$toString(remedyId),
				hU: false
			});
	});
var $author$project$Page$Remedy$Editor$MetaTab = 0;
var $author$project$Page$Remedy$Editor$NoModal = {$: 0};
var $author$project$Remedy$Editor$Form$Form = $elm$core$Basics$identity;
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Remedy$ScreenId$next = function (ids) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$add(1),
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0;
						return id;
					},
					ids))));
};
var $author$project$Remedy$ScreenList$toList = function (_v0) {
	var s = _v0.a;
	var rest = _v0.b;
	return A2($elm$core$List$cons, s, rest);
};
var $author$project$Remedy$Editor$Form$nextAvailableId = function (screenList) {
	return $author$project$Remedy$ScreenId$next(
		A2(
			$elm$core$List$map,
			$author$project$Remedy$Screen$id,
			$author$project$Remedy$ScreenList$toList(screenList)));
};
var $author$project$Remedy$Editor$Form$BulletedList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Remedy$Editor$Form$Button = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Remedy$Editor$Form$H1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$Editor$Form$Img = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$Editor$Form$P = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remedy$Editor$Form$GoToScreen = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$Editor$Form$GoToUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remedy$Editor$Form$UseCustomCapability = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Remedy$Editor$Form$UseDismiss = {$: 4};
var $author$project$Remedy$Editor$Form$UseGoToMarket = {$: 3};
var $author$project$Remedy$Editor$Form$UseTalkToAgent = {$: 2};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.eK;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ed,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.hb,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.eH,
					_Utils_ap(http, url.ei)),
				url.eF)));
};
var $author$project$Remedy$Editor$Form$actionToRaw = function (action) {
	switch (action.$) {
		case 1:
			var url = action.a;
			return $elm$core$Maybe$Just(
				$author$project$Remedy$Editor$Form$GoToUrl(
					$elm$url$Url$toString(url)));
		case 0:
			var screenId = action.a;
			return $elm$core$Maybe$Just(
				$author$project$Remedy$Editor$Form$GoToScreen(screenId));
		default:
			var capability = action.a;
			switch (capability.$) {
				case 1:
					return $elm$core$Maybe$Just($author$project$Remedy$Editor$Form$UseTalkToAgent);
				case 0:
					return $elm$core$Maybe$Just($author$project$Remedy$Editor$Form$UseGoToMarket);
				case 2:
					return $elm$core$Maybe$Just($author$project$Remedy$Editor$Form$UseDismiss);
				case 4:
					var id = capability.a;
					var props = capability.b;
					return $elm$core$Maybe$Just(
						A2($author$project$Remedy$Editor$Form$UseCustomCapability, id, props));
				default:
					return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$Remedy$LocStr$english = function (_v0) {
	var englishText = _v0;
	return englishText;
};
var $author$project$Remedy$Editor$Form$packBulletedList = function (items) {
	return '- ' + A2(
		$elm$core$String$join,
		'\n- ',
		A2($elm$core$List$map, $author$project$Remedy$LocStr$english, items));
};
var $author$project$Remedy$Editor$Form$elementToRaw = function (element) {
	switch (element.$) {
		case 0:
			var str = element.a;
			return $author$project$Remedy$Editor$Form$H1(
				$author$project$Remedy$LocStr$english(str));
		case 1:
			var str = element.a;
			return $author$project$Remedy$Editor$Form$P(
				$author$project$Remedy$LocStr$english(str));
		case 4:
			var items = element.a;
			return $author$project$Remedy$Editor$Form$BulletedList(
				$author$project$Remedy$Editor$Form$packBulletedList(items));
		case 2:
			var url = element.a;
			return $author$project$Remedy$Editor$Form$Img(
				$elm$url$Url$toString(url));
		default:
			var title = element.a;
			var action = element.b;
			return A2(
				$author$project$Remedy$Editor$Form$Button,
				$author$project$Remedy$LocStr$english(title),
				$author$project$Remedy$Editor$Form$actionToRaw(action));
	}
};
var $author$project$Remedy$Screen$elements = function (_v0) {
	var screen = _v0;
	return screen.d3;
};
var $author$project$Remedy$Screen$title = function (_v0) {
	var screen = _v0;
	return screen.bO;
};
var $author$project$Remedy$Editor$Form$screenToRaw = function (screen) {
	return {
		d3: A2(
			$elm$core$List$map,
			$author$project$Remedy$Editor$Form$elementToRaw,
			$author$project$Remedy$Screen$elements(screen)),
		f7: $elm$core$Maybe$Nothing,
		bj: $author$project$Remedy$Screen$id(screen),
		bO: $author$project$Remedy$Screen$title(screen)
	};
};
var $author$project$Remedy$ScreenList$uncons = function (_v0) {
	var s = _v0.a;
	var rest = _v0.b;
	return _Utils_Tuple2(s, rest);
};
var $author$project$Remedy$Editor$Form$fromScreenList = function (screenList) {
	var _v0 = $author$project$Remedy$ScreenList$uncons(screenList);
	var first = _v0.a;
	var others = _v0.b;
	return {
		n: $author$project$Remedy$Editor$Form$screenToRaw(first),
		J: A2($elm$core$List$map, $author$project$Remedy$Editor$Form$screenToRaw, others),
		D: _List_Nil,
		bx: $author$project$Remedy$Editor$Form$nextAvailableId(screenList)
	};
};
var $author$project$Remedy$Editor$Form$allScreens = function (form) {
	return _Utils_ap(
		form.D,
		_Utils_ap(
			_List_fromArray(
				[form.n]),
			form.J));
};
var $elm$core$String$trim = _String_trim;
var $author$project$Remedy$LocStr$new = function (englishText) {
	return $elm$core$String$trim(englishText);
};
var $author$project$Remedy$Editor$Form$bulletDelimiter = '- ';
var $author$project$Remedy$Editor$Form$bulletListRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{fA: false, gO: true},
		'^- '));
var $elm$regex$Regex$split = _Regex_splitAtMost(_Regex_infinity);
var $author$project$Remedy$Editor$Form$unpackBulletedList = function (str) {
	return (!A2($elm$core$String$startsWith, $author$project$Remedy$Editor$Form$bulletDelimiter, str)) ? _List_Nil : A2(
		$elm$core$List$drop,
		1,
		A2($elm$regex$Regex$split, $author$project$Remedy$Editor$Form$bulletListRegex, str));
};
var $author$project$Remedy$Editor$Form$localizableStringsForElement = function (rawElement) {
	switch (rawElement.$) {
		case 0:
			var str = rawElement.a;
			return _List_fromArray(
				[
					$author$project$Remedy$LocStr$new(str)
				]);
		case 1:
			var str = rawElement.a;
			return _List_fromArray(
				[
					$author$project$Remedy$LocStr$new(str)
				]);
		case 2:
			return _List_Nil;
		case 4:
			var items = rawElement.a;
			return A2(
				$elm$core$List$map,
				$author$project$Remedy$LocStr$new,
				$author$project$Remedy$Editor$Form$unpackBulletedList(items));
		default:
			var str = rawElement.a;
			return _List_fromArray(
				[
					$author$project$Remedy$LocStr$new(str)
				]);
	}
};
var $author$project$Remedy$Editor$Form$localizableStringsForScreen = function (screen) {
	return A2($elm$core$List$concatMap, $author$project$Remedy$Editor$Form$localizableStringsForElement, screen.d3);
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Remedy$Editor$Form$localizableStrings = function (_v0) {
	var form = _v0;
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		$author$project$Remedy$LocStr$english,
		A2(
			$elm$core$List$concatMap,
			$author$project$Remedy$Editor$Form$localizableStringsForScreen,
			$author$project$Remedy$Editor$Form$allScreens(form)));
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {e: $elm$core$Dict$empty, W: toKey};
};
var $author$project$Remedy$Localization$newItem = function (locStr) {
	return A2(
		$author$project$Remedy$Localization$TableItem,
		locStr,
		$turboMaCk$any_dict$Dict$Any$empty($author$project$Remedy$Localization$translationsDictKeyFunction));
};
var $author$project$Remedy$Localization$sync = F2(
	function (activeStrings, _v0) {
		var existingItems = _v0;
		var carryOver = function (locStr) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Remedy$Localization$newItem(locStr),
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (item) {
						return _Utils_eq(item.an, locStr);
					},
					existingItems));
		};
		return A2($elm$core$List$map, carryOver, activeStrings);
	});
var $author$project$Page$Remedy$Editor$syncLocalizedStrings = function (model) {
	return _Utils_update(
		model,
		{
			r: A2(
				$author$project$Remedy$Localization$sync,
				$author$project$Remedy$Editor$Form$localizableStrings(model.d),
				model.r)
		});
};
var $author$project$Remedy$unpack = function (_v0) {
	var remedy = _v0;
	return _Utils_Tuple3(
		{dy: remedy.dy, dT: remedy.dT, b6: remedy.b6, cM: remedy.cM, bj: remedy.bj, aa: remedy.aa, bO: remedy.bO, hN: remedy.hN, fc: remedy.fc, dx: remedy.dx},
		remedy.r,
		remedy.V);
};
var $author$project$Page$Remedy$Editor$defaultModel = F2(
	function (accessToken, comboRemedy) {
		var _v0 = $author$project$Remedy$unpack(comboRemedy.hd);
		var meta = _v0.a;
		var localizedStrings = _v0.b;
		var screens = _v0.c;
		return $author$project$Page$Remedy$Editor$syncLocalizedStrings(
			{
				a: accessToken,
				a9: 0,
				aF: comboRemedy.bY,
				f$: _List_Nil,
				d: $author$project$Remedy$Editor$Form$fromScreenList(screens),
				bm: false,
				aK: comboRemedy.aK,
				cg: false,
				aj: false,
				r: localizedStrings,
				S: $author$project$Page$Remedy$Editor$NoModal,
				hd: meta,
				ax: $author$project$Remedy$Localization$defaultLanguageTag,
				a2: comboRemedy.a2
			});
	});
var $author$project$Page$Remedy$Editor$pageFailed = function (error) {
	return A2($author$project$Page$Error$http, 'remedy editor network failure', error);
};
var $author$project$Page$Remedy$Editor$initForClone = F3(
	function (accessToken, originalUuid, newUuid) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Remedy$Editor$pageFailed,
			A2(
				$elm$core$Task$map,
				function (combo) {
					return A2(
						$author$project$Page$Remedy$Editor$defaultModel,
						accessToken,
						_Utils_update(
							combo,
							{
								hd: A2($author$project$Remedy$clone, newUuid, combo.hd)
							}));
				},
				$elm$http$Http$toTask(
					A2($author$project$Request$Remedy$comboEdit, accessToken, originalUuid))));
	});
var $author$project$Page$Capability$Editor$defaultModel = F2(
	function (accessToken, capability) {
		return {a: accessToken, aD: capability, f$: _List_Nil, bn: false, cg: false};
	});
var $author$project$Remedy$CustomCapability$new = {
	dy: '',
	dT: $elm$time$Time$millisToPosix(0),
	b6: '',
	bj: '',
	bB: _List_Nil,
	dx: 0
};
var $author$project$Page$Capability$Editor$initForCreate = function (accessToken) {
	var model = A2($author$project$Page$Capability$Editor$defaultModel, accessToken, $author$project$Remedy$CustomCapability$new);
	return $elm$core$Task$succeed(
		_Utils_update(
			model,
			{bn: true}));
};
var $author$project$Page$Classifier$Editor$ViewModeCreate = 0;
var $author$project$Data$Classifier$RandomClassifier$default = {eo: '', dc: 50};
var $author$project$Data$Classifier$RegexClassifier$default = {cG: 100, eo: '', db: ''};
var $author$project$Data$Classifier$Drill2$defaultConfig = A2(
	$author$project$Data$Classifier$Drill2$Config,
	'',
	{
		a7: 0,
		de: _List_fromArray(
			[
				A2(
				$author$project$Data$Classifier$Drill2$Query,
				'',
				_List_fromArray(
					[
						A6($author$project$Data$Classifier$Drill2$Condition, '', 1, 0, false, 1, _List_Nil)
					]))
			])
	});
var $author$project$Data$Classifier$new = F2(
	function (desiredType, id) {
		var _v0 = function () {
			switch (desiredType) {
				case 0:
					return _Utils_Tuple2(
						$author$project$Data$Classifier$Javascript(''),
						$author$project$Data$Classifier$IncidentSpec);
				case 1:
					return _Utils_Tuple2(
						$author$project$Data$Classifier$Drill2($author$project$Data$Classifier$Drill2$defaultConfig),
						$author$project$Data$Classifier$IncidentSpec);
				case 3:
					return _Utils_Tuple2(
						$author$project$Data$Classifier$RandomClassifier($author$project$Data$Classifier$RandomClassifier$default),
						$author$project$Data$Classifier$IncidentSpec);
				default:
					return _Utils_Tuple2(
						$author$project$Data$Classifier$RegexClassifier($author$project$Data$Classifier$RegexClassifier$default),
						$author$project$Data$Classifier$FileSpec(''));
			}
		}();
		var config = _v0.a;
		var inputSpec = _v0.b;
		var meta = A2($author$project$Data$Classifier$newMeta, inputSpec, id);
		return A2($author$project$Data$Classifier$Classifier, meta, config);
	});
var $author$project$Page$Classifier$Editor$initForCreate = F4(
	function (accessToken, user, classifierType, uuid) {
		var makeModelInput = F2(
			function (classifier, remedies) {
				return {a: accessToken, b_: $author$project$Page$Classifier$Editor$ChartNotNeeded, fE: classifier, gc: _List_Nil, hc: remedies, az: user, u: 0};
			});
		var loadRemedies = A2(
			$elm$core$Task$map,
			function ($) {
				return $.hc;
			},
			$elm$http$Http$toTask(
				$author$project$Request$Remedy$list(accessToken)));
		var handleLoadFailed = function (error) {
			return A2($author$project$Page$Error$http, 'failed to ', error);
		};
		var classifierNew = A2($author$project$Data$Classifier$new, classifierType, uuid);
		return A2(
			$elm$core$Task$andThen,
			$author$project$Page$Classifier$Editor$makeModel,
			A2(
				$elm$core$Task$mapError,
				handleLoadFailed,
				A2(
					$elm$core$Task$map,
					makeModelInput(classifierNew),
					loadRemedies)));
	});
var $author$project$Page$Configuration$Editor$NoDialog = 0;
var $author$project$Page$Configuration$Editor$NotAsked = {$: 0};
var $author$project$Page$Configuration$Editor$PreviewInputTab = 0;
var $author$project$Page$Configuration$Editor$defaultModel = F3(
	function (accessToken, isNew, def) {
		return {
			a: accessToken,
			dy: def.dy,
			b0: def.b0,
			dT: def.dT,
			b4: def.b4,
			b6: def.b6,
			b7: 0,
			f$: _List_Nil,
			d8: _List_Nil,
			bf: A2($elm$core$String$join, ',', def.cc),
			bj: def.bj,
			bn: isNew,
			bp: def.cM,
			cg: false,
			g6: A2($elm$core$String$join, ',', def.cn),
			v: $author$project$Page$Configuration$Editor$NotAsked,
			bD: 0,
			cp: def.cp,
			dx: def.dx
		};
	});
var $author$project$Data$LogFile$newConfig = function (id) {
	return {
		dy: '',
		b0: _List_Nil,
		dT: $elm$time$Time$millisToPosix(0),
		b4: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'+0000\'',
		b6: '',
		cM: true,
		cc: _List_Nil,
		bj: id,
		cn: _List_Nil,
		cp: '',
		dx: 0
	};
};
var $author$project$Page$Configuration$Editor$initForCreate = F2(
	function (accessToken, uuid) {
		return $elm$core$Task$succeed(
			A3(
				$author$project$Page$Configuration$Editor$defaultModel,
				accessToken,
				true,
				$author$project$Data$LogFile$newConfig(uuid)));
	});
var $author$project$Request$Remedy$comboCreate = function (accessToken) {
	var responseDecoder = $author$project$Request$Remedy$comboRemedyEditDecoder(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded(0));
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/combo/remedies/create',
			hU: false
		});
};
var $author$project$Remedy$Screen$blank = function (screenId) {
	return {d3: _List_Nil, bj: screenId, bO: 'Untitled'};
};
var $author$project$Remedy$ScreenId$fromInt = function (id) {
	return id;
};
var $author$project$Remedy$Localization$emptyTable = _List_Nil;
var $author$project$Remedy$ScreenList$initSolo = function (s) {
	return A2($author$project$Remedy$ScreenList$ScreenList, s, _List_Nil);
};
var $author$project$Remedy$newInternal = F2(
	function (remedyId, screen) {
		return {
			dy: '',
			dT: $elm$time$Time$millisToPosix(0),
			b6: '',
			cM: false,
			bj: remedyId,
			r: $author$project$Remedy$Localization$emptyTable,
			aa: $author$project$UUID$nil,
			V: $author$project$Remedy$ScreenList$initSolo(screen),
			bO: '',
			hN: '',
			fc: 100,
			dx: 0
		};
	});
var $author$project$Remedy$new = function (remedyId) {
	return A2(
		$author$project$Remedy$newInternal,
		remedyId,
		$author$project$Remedy$Screen$blank(
			$author$project$Remedy$ScreenId$fromInt(0)));
};
var $author$project$Page$Remedy$Editor$initForCreate = F2(
	function (accessToken, uuid) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Remedy$Editor$pageFailed,
			A2(
				$elm$core$Task$map,
				function (combo) {
					return A2(
						$author$project$Page$Remedy$Editor$defaultModel,
						accessToken,
						{
							bY: combo.bY,
							aK: combo.aK,
							hd: $author$project$Remedy$new(uuid),
							a2: combo.a2
						});
				},
				$elm$http$Http$toTask(
					$author$project$Request$Remedy$comboCreate(accessToken))));
	});
var $author$project$Page$Scrubber$Editor$defaultModel = F4(
	function (accessToken, isNew, scrubber, incidentKeyPaths) {
		var maybeDataObjectKeyPath = function (keyPath) {
			var dataObjectPrefix = '.data';
			return A2($elm$core$String$startsWith, dataObjectPrefix, keyPath) ? $elm$core$Maybe$Just(
				A2(
					$elm$core$String$dropLeft,
					$elm$core$String$length(dataObjectPrefix),
					keyPath)) : $elm$core$Maybe$Nothing;
		};
		return {
			a: accessToken,
			cI: A2($elm$core$List$filterMap, maybeDataObjectKeyPath, incidentKeyPaths),
			f$: _List_Nil,
			bk: '',
			bn: isNew,
			aL: false,
			cg: false,
			aV: $krisajenkins$remotedata$RemoteData$NotAsked,
			E: scrubber
		};
	});
var $author$project$Request$Incident$getKeyPaths = function (accessToken) {
	var responseDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$string);
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$http$Http$request(
		{
			bX: $elm$http$Http$emptyBody,
			f1: $elm$http$Http$expectJson(responseDecoder),
			ge: headers,
			gM: 'GET',
			hE: $elm$core$Maybe$Nothing,
			hQ: '/gym/incidents/keypaths',
			hU: false
		});
};
var $author$project$Data$Scrubber$defaultRedactorType = 0;
var $author$project$Data$Scrubber$newRedactor = function (redactorType) {
	switch (redactorType) {
		case 0:
			return $author$project$Data$Scrubber$GenericStringRedactor(
				{B: ''});
		case 1:
			return $author$project$Data$Scrubber$IncidentDataRedactor(
				{gy: '', B: ''});
		case 2:
			return $author$project$Data$Scrubber$PlaintextFileRedactor(
				{aH: '', B: ''});
		default:
			return $author$project$Data$Scrubber$JsonFileRedactor(
				{aH: '', gy: '', B: ''});
	}
};
var $author$project$Data$Scrubber$new = function (id) {
	return {
		dy: '',
		dT: $elm$time$Time$millisToPosix(0),
		b6: '',
		cM: true,
		bj: id,
		df: _List_fromArray(
			[
				$author$project$Data$Scrubber$newRedactor($author$project$Data$Scrubber$defaultRedactorType)
			]),
		dx: 0
	};
};
var $author$project$Page$Scrubber$Editor$initForCreate = F2(
	function (accessToken, uuid) {
		var loadKeyPaths = $elm$http$Http$toTask(
			$author$project$Request$Incident$getKeyPaths(accessToken));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load keypaths'),
			A2(
				$elm$core$Task$map,
				A3(
					$author$project$Page$Scrubber$Editor$defaultModel,
					accessToken,
					true,
					$author$project$Data$Scrubber$new(uuid)),
				loadKeyPaths));
	});
var $author$project$Page$Widget$Editor$AppendWidget = 0;
var $author$project$Page$Widget$Editor$NoDialog = {$: 0};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$JsonTree$KeyPathExtractor$rawKeyPaths = function (node) {
	var _v0 = node.hR;
	switch (_v0.$) {
		case 3:
			var children = _v0.a;
			return A2(
				$elm$core$List$cons,
				node.gy + '[]',
				A2($elm$core$List$concatMap, $author$project$JsonTree$KeyPathExtractor$rawKeyPaths, children));
		case 4:
			var dict = _v0.a;
			return A2(
				$elm$core$List$cons,
				node.gy,
				A2(
					$elm$core$List$concatMap,
					$author$project$JsonTree$KeyPathExtractor$rawKeyPaths,
					$elm$core$Dict$values(dict)));
		default:
			return _List_fromArray(
				[node.gy]);
	}
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Util$Regex$replace = F3(
	function (pattern, func, haystack) {
		return A3(
			$elm$regex$Regex$replace,
			$author$project$Util$Regex$regex(pattern),
			func,
			haystack);
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$JsonTree$KeyPathExtractor$extractKeyPaths = F2(
	function (showListBrackets, node) {
		return $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Util$Regex$replace,
					'\\[\\d*\\]',
					showListBrackets ? $elm$core$Basics$always('[]') : $elm$core$Basics$always('')),
				$author$project$JsonTree$KeyPathExtractor$rawKeyPaths(node)));
	});
var $author$project$Page$Widget$Editor$parseIncident = function (incident) {
	var jsonBundle = function (node) {
		return {
			aM: A2($author$project$JsonTree$KeyPathExtractor$extractKeyPaths, false, node),
			cr: node
		};
	};
	return A2(
		$elm$core$Result$map,
		jsonBundle,
		A2(
			$elm$core$Result$mapError,
			$elm$json$Json$Decode$errorToString,
			A2($author$project$JsonTree$parse, incident.gx, _List_Nil)));
};
var $author$project$Page$Widget$Editor$defaultModel = F6(
	function (accessToken, status, sectionIndex, widget, lockerItem, maybeIncident) {
		return {
			a: accessToken,
			b7: $author$project$Page$Widget$Editor$NoDialog,
			f$: _List_Nil,
			bk: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.er;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bj;
							},
							$author$project$UUID$toString)),
					maybeIncident)),
			cg: false,
			ch: lockerItem,
			ck: sectionIndex,
			bF: $krisajenkins$remotedata$RemoteData$fromResult(
				A2(
					$elm$core$Result$andThen,
					$author$project$Page$Widget$Editor$parseIncident,
					A2($elm$core$Result$fromMaybe, 'no incident found', maybeIncident))),
			F: sectionIndex,
			e3: status,
			fg: widget
		};
	});
var $author$project$App$SearchParams$default = {b$: $elm$core$Maybe$Nothing, b9: $elm$core$Maybe$Nothing, ce: $elm$core$Maybe$Nothing};
var $author$project$Request$Incident$getBasic = F2(
	function (accessToken, incidentId) {
		var url = '/gym/incidents/' + $author$project$UUID$toString(incidentId);
		var responseDecoder = $author$project$Data$Incident$fullDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Request$Incident$searchResponseDecoder = A2(
	$elm$json$Json$Decode$field,
	'results',
	$elm$json$Json$Decode$list($author$project$Data$Incident$searchResultDecoder));
var $author$project$Request$Incident$searchInternal = F2(
	function (accessToken, body) {
		var url = '/gym/incidents/search';
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$jsonBody(body),
				f1: $elm$http$Http$expectJson($author$project$Request$Incident$searchResponseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$UUID$encode = function (_v0) {
	var uuid = _v0;
	return $elm$json$Json$Encode$string(uuid);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$App$SearchParams$nullOr = F2(
	function (f, m) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, f, m));
	});
var $author$project$App$SearchParams$toJson = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'installId',
				A2($author$project$App$SearchParams$nullOr, $elm$json$Json$Encode$string, params.ce)),
				_Utils_Tuple2(
				'easyId',
				A2($author$project$App$SearchParams$nullOr, $elm$json$Json$Encode$string, params.b9)),
				_Utils_Tuple2(
				'classifierIds',
				A2(
					$author$project$App$SearchParams$nullOr,
					$elm$json$Json$Encode$list($author$project$UUID$encode),
					params.b$))
			]));
};
var $author$project$Request$Incident$search = F2(
	function (accessToken, params) {
		return A2(
			$author$project$Request$Incident$searchInternal,
			accessToken,
			$author$project$App$SearchParams$toJson(params));
	});
var $author$project$Page$Widget$Editor$getMostRecentIncidentTask = function (accessToken) {
	var getRecentIdsTask = A2(
		$elm$core$Task$mapError,
		$author$project$Page$Error$http('failed to get incident list for preview'),
		A2(
			$elm$core$Task$map,
			$elm$core$List$map(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gj;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.er;
						},
						function ($) {
							return $.bj;
						}))),
			$elm$http$Http$toTask(
				A2($author$project$Request$Incident$search, accessToken, $author$project$App$SearchParams$default))));
	var getFirstIncidentTask = function (ids) {
		var _v0 = $elm$core$List$head(ids);
		if (!_v0.$) {
			var id = _v0.a;
			return A2(
				$elm$core$Task$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$core$Task$mapError,
					$author$project$Page$Error$http('failed to get incident for preview'),
					$elm$http$Http$toTask(
						A2($author$project$Request$Incident$getBasic, accessToken, id))));
		} else {
			return $elm$core$Task$succeed($elm$core$Maybe$Nothing);
		}
	};
	return A2($elm$core$Task$andThen, getFirstIncidentTask, getRecentIdsTask);
};
var $author$project$View$Widget$DynamicList$init = function (keyPath) {
	return $author$project$View$Widget$DynamicList$defaultModel(
		{K: keyPath});
};
var $author$project$View$Widget$DynamicTable$init = F2(
	function (keyPath, columns) {
		return $author$project$View$Widget$DynamicTable$defaultModel(
			{K: keyPath, b0: columns});
	});
var $author$project$View$Widget$Generic$init = function (keyPath) {
	return $author$project$View$Widget$Generic$defaultModel(
		{gy: keyPath});
};
var $author$project$Data$Widget$Lens$new = function (keyPath) {
	return {cf: false, gy: keyPath, ay: $author$project$Data$Widget$Lens$DefaultTransform};
};
var $author$project$View$Widget$StaticTable$rowFromPair = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return {
		eo: a,
		hR: $author$project$Data$Widget$Lens$new(b)
	};
};
var $author$project$View$Widget$StaticTable$init = function (pairs) {
	return $author$project$View$Widget$StaticTable$defaultModel(
		{
			aW: A2($elm$core$List$map, $author$project$View$Widget$StaticTable$rowFromPair, pairs)
		});
};
var $author$project$Data$Widget$new = F2(
	function (desiredType, uuid) {
		var defaultConfig = function () {
			switch (desiredType) {
				case 0:
					return $author$project$Data$Widget$StaticTableData(
						$author$project$View$Widget$StaticTable$init(_List_Nil));
				case 1:
					return $author$project$Data$Widget$DynamicListData(
						$author$project$View$Widget$DynamicList$init(''));
				case 2:
					return $author$project$Data$Widget$DynamicTableData(
						A2($author$project$View$Widget$DynamicTable$init, '', _List_Nil));
				default:
					return $author$project$Data$Widget$GenericData(
						$author$project$View$Widget$Generic$init(''));
			}
		}();
		return A3($author$project$Data$Widget$makeWidget, uuid, '', defaultConfig);
	});
var $author$project$Page$Widget$Editor$initForCreate = F4(
	function (accessToken, sectionIndex, widgetType, uuid) {
		var widget = A2($author$project$Data$Widget$new, widgetType, uuid);
		return A3(
			$elm$core$Task$map2,
			F2(
				function (incident, lockerItem) {
					return A6($author$project$Page$Widget$Editor$defaultModel, accessToken, 0, sectionIndex, widget, lockerItem, incident);
				}),
			$author$project$Page$Widget$Editor$getMostRecentIncidentTask(accessToken),
			A2(
				$elm$core$Task$mapError,
				$author$project$Page$Error$http('failed to get widgets'),
				$author$project$Request$WidgetCollection$getTask(accessToken)));
	});
var $author$project$Request$CustomCapability$get = F2(
	function (accessToken, id) {
		var responseDecoder = $author$project$Remedy$CustomCapability$decoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/remedies/capabilities/' + $elm$url$Url$percentEncode(id),
				hU: false
			});
	});
var $author$project$Page$Capability$Editor$initForEdit = F2(
	function (accessToken, capabilityId) {
		var loadCapability = $elm$http$Http$toTask(
			A2($author$project$Request$CustomCapability$get, accessToken, capabilityId));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load capability'),
			A2(
				$elm$core$Task$map,
				$author$project$Page$Capability$Editor$defaultModel(accessToken),
				loadCapability));
	});
var $author$project$Request$LogFile$getConfig = F2(
	function (accessToken, id) {
		var responseDecoder = $author$project$Data$LogFile$fullDefDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/logs/configurations/' + $author$project$UUID$toString(id),
				hU: false
			});
	});
var $author$project$Page$Configuration$Editor$initForEdit = F2(
	function (accessToken, configId) {
		var loadConfig = $elm$http$Http$toTask(
			A2($author$project$Request$LogFile$getConfig, accessToken, configId));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load configuration'),
			A2(
				$elm$core$Task$map,
				A2($author$project$Page$Configuration$Editor$defaultModel, accessToken, false),
				loadConfig));
	});
var $author$project$Page$Remedy$Editor$initForEdit = F2(
	function (accessToken, id) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Remedy$Editor$pageFailed,
			A2(
				$elm$core$Task$map,
				$author$project$Page$Remedy$Editor$defaultModel(accessToken),
				$elm$http$Http$toTask(
					A2($author$project$Request$Remedy$comboEdit, accessToken, id))));
	});
var $author$project$Request$Scrubber$get = F2(
	function (accessToken, id) {
		var responseDecoder = $author$project$Data$Scrubber$decoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/scrubbers/' + $author$project$UUID$toString(id),
				hU: false
			});
	});
var $author$project$Page$Scrubber$Editor$initForEdit = F2(
	function (accessToken, scrubberId) {
		var loadScrubber = $elm$http$Http$toTask(
			A2($author$project$Request$Scrubber$get, accessToken, scrubberId));
		var loadKeyPaths = $elm$http$Http$toTask(
			$author$project$Request$Incident$getKeyPaths(accessToken));
		return A2(
			$elm$core$Task$mapError,
			$author$project$Page$Error$http('failed to load scrubber or keyPaths'),
			A3(
				$elm$core$Task$map2,
				A2($author$project$Page$Scrubber$Editor$defaultModel, accessToken, false),
				loadScrubber,
				loadKeyPaths));
	});
var $author$project$Page$Widget$Editor$ReplaceWidget = 1;
var $author$project$Page$Widget$Editor$initForEdit = F3(
	function (accessToken, sectionIndex, widgetId) {
		var findWidgetAndMetadata = function (lockerItem) {
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, sectionIndex, lockerItem.hR.hl);
			if (!_v1.$) {
				var section = _v1.a;
				var _v2 = A2(
					$elm_community$list_extra$List$Extra$find,
					function (w) {
						return _Utils_eq(w.bj, widgetId);
					},
					section.cB);
				if (!_v2.$) {
					var widget = _v2.a;
					return $elm$core$Task$succeed(
						_Utils_Tuple2(widget, lockerItem));
				} else {
					return $elm$core$Task$fail(
						$author$project$Page$Error$simple(
							'no widget found with id ' + $author$project$UUID$toString(widgetId)));
				}
			} else {
				return $elm$core$Task$fail(
					$author$project$Page$Error$simple(
						'no section found at index ' + $elm$core$String$fromInt(sectionIndex)));
			}
		};
		return A3(
			$elm$core$Task$map2,
			F2(
				function (incident, _v0) {
					var widget = _v0.a;
					var lockerItem = _v0.b;
					return A6($author$project$Page$Widget$Editor$defaultModel, accessToken, 1, sectionIndex, widget, lockerItem, incident);
				}),
			$author$project$Page$Widget$Editor$getMostRecentIncidentTask(accessToken),
			A2(
				$elm$core$Task$andThen,
				findWidgetAndMetadata,
				A2(
					$elm$core$Task$mapError,
					$author$project$Page$Error$http('failed to get widgets'),
					$author$project$Request$WidgetCollection$getTask(accessToken))));
	});
var $author$project$Page$Classifier$Editor$ViewModeView = 1;
var $author$project$Page$Classifier$Editor$initForView = F3(
	function (accessToken, user, id) {
		return A4($author$project$Page$Classifier$Editor$initForViewOrEdit, accessToken, user, id, 1);
	});
var $author$project$Data$User$activeTenant = function (user) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.aC;
			},
			user.hB));
};
var $author$project$UUID$unsafeFromString = function (str) {
	return str;
};
var $author$project$Data$User$powerLiftSystemTenantUuid = $author$project$UUID$unsafeFromString('4003e119-8e08-4534-8f8b-ed592679606a');
var $author$project$Data$User$isActingOnEntireSystem = function (user) {
	var _v0 = $author$project$Data$User$activeTenant(user);
	if (!_v0.$) {
		var id = _v0.a.bj;
		return _Utils_eq(id, $author$project$Data$User$powerLiftSystemTenantUuid);
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$App$Main$isSystemTenant = function (userRemote) {
	var _v0 = $krisajenkins$remotedata$RemoteData$toMaybe(userRemote);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Data$User$isActingOnEntireSystem(user);
	} else {
		return false;
	}
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$App$Main$popUuid = function (model) {
	return _Utils_update(
		model,
		{
			aA: A2($elm$core$List$drop, 1, model.aA)
		});
};
var $author$project$App$Main$setRouteHelper = F2(
	function (route, model) {
		var maybeUser = $krisajenkins$remotedata$RemoteData$toMaybe(model.Y);
		var immediateTransition = function (newPage) {
			return _Utils_update(
				model,
				{
					l: $author$project$App$Main$Loaded(newPage)
				});
		};
		var asyncTransition = _Utils_update(
			model,
			{
				l: $author$project$App$Main$TransitioningFrom(
					$author$project$App$Main$getPage(model.l))
			});
		var loadPageAndUuid = F2(
			function (loadedMsg, pageTask) {
				var _v1 = $elm$core$List$head(model.aA);
				if (!_v1.$) {
					var nextUuid = _v1.a;
					return _Utils_Tuple2(
						$author$project$App$Main$popUuid(asyncTransition),
						A2(
							$elm$core$Task$attempt,
							loadedMsg,
							pageTask(nextUuid)));
				} else {
					return _Utils_Tuple2(
						immediateTransition(
							$author$project$App$Main$Error(
								$author$project$Page$Error$simple('Exhausted UUID pool. Please reload.'))),
						$elm$core$Platform$Cmd$none);
				}
			});
		switch (route.$) {
			case 29:
				return _Utils_Tuple2(
					immediateTransition($author$project$App$Main$NotFound),
					$elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$HomeLoaded,
						$author$project$Page$Home$init(model.a)));
			case 2:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$AdvancedSearchLoaded,
						$author$project$Page$AdvancedSearch$init(model.a)));
			case 1:
				var maybeQuery = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$SearchIncidentsLoaded,
						A2($author$project$Page$Incident$List$init, model.a, maybeQuery)));
			case 3:
				var id = route.a;
				var maybeTab = route.b;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$IncidentLoaded,
					A4(
						$author$project$Page$Incident$init,
						model.a,
						maybeUser,
						$author$project$UUID$toString(id),
						maybeTab));
			case 4:
				var id = route.a;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$IncidentLoaded,
					A4($author$project$Page$Incident$init, model.a, maybeUser, id, $elm$core$Maybe$Nothing));
			case 33:
				var incidentId = route.a;
				var fileId = route.b;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$LogFileLoaded,
						A3($author$project$Page$LogFile$init, model.a, incidentId, fileId)));
			case 5:
				var installId = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$TimelineLoaded,
						A2($author$project$Page$Timeline$init, model.a, installId)));
			case 6:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ClassifiersLoaded,
						$author$project$Page$Classifier$List$init(model.a)));
			case 7:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ClassifierViewerLoaded,
						A3($author$project$Page$Classifier$Editor$initForView, model.a, maybeUser, id)));
			case 8:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ClassifierEditorLoaded,
						A3($author$project$Page$Classifier$Editor$initForEdit, model.a, maybeUser, id)));
			case 9:
				var id = route.a;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$ClassifierEditorLoaded,
					A3($author$project$Page$Classifier$Editor$initForClone, model.a, maybeUser, id));
			case 10:
				var type_ = route.a;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$ClassifierEditorLoaded,
					A3($author$project$Page$Classifier$Editor$initForCreate, model.a, maybeUser, type_));
			case 11:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$RemediesLoaded,
						$author$project$Page$Remedy$List$init(model.a)));
			case 12:
				var id = route.a;
				var version = route.b;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$RemedyViewerLoaded,
						A3($author$project$Page$Remedy$Viewer$init, model.a, id, version)));
			case 13:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$RemedyHistoryLoaded,
						A2($author$project$Page$Remedy$History$init, model.a, id)));
			case 14:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$RemedyEditorLoaded,
						A2($author$project$Page$Remedy$Editor$initForEdit, model.a, id)));
			case 15:
				var id = route.a;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$RemedyEditorLoaded,
					A2($author$project$Page$Remedy$Editor$initForClone, model.a, id));
			case 16:
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$RemedyEditorLoaded,
					$author$project$Page$Remedy$Editor$initForCreate(model.a));
			case 17:
				return _Utils_Tuple2(
					asyncTransition,
					A2($elm$core$Task$attempt, $author$project$App$Main$AdminLoaded, $author$project$Page$Admin$init));
			case 18:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$WidgetSectionsLoaded,
						$author$project$Page$Widget$CollectionEditor$init(model.a)));
			case 19:
				var sectionIndex = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$WidgetsLoaded,
						A2($author$project$Page$Widget$SectionEditor$init, model.a, sectionIndex)));
			case 20:
				var sectionIndex = route.a;
				var id = route.b;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$WidgetEditorLoaded,
						A3($author$project$Page$Widget$Editor$initForEdit, model.a, sectionIndex, id)));
			case 21:
				var sectionIndex = route.a;
				var widgetType = route.b;
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$WidgetEditorLoaded,
					A3($author$project$Page$Widget$Editor$initForCreate, model.a, sectionIndex, widgetType));
			case 22:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$CapabilitiesLoaded,
						$author$project$Page$Capability$List$init(model.a)));
			case 23:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$CapabilityEditorLoaded,
						A2($author$project$Page$Capability$Editor$initForEdit, model.a, id)));
			case 24:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$CapabilityEditorLoaded,
						$author$project$Page$Capability$Editor$initForCreate(model.a)));
			case 25:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ScrubbersLoaded,
						$author$project$Page$Scrubber$List$init(model.a)));
			case 26:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ScrubberEditorLoaded,
						A2($author$project$Page$Scrubber$Editor$initForEdit, model.a, id)));
			case 27:
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$ScrubberEditorLoaded,
					$author$project$Page$Scrubber$Editor$initForCreate(model.a));
			case 28:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$BasementLoaded,
						$author$project$Page$Basement$init(model.a)));
			case 30:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$OnboardingLoaded,
						$author$project$Page$Onboarding$init(model.a)));
			case 31:
				return _Utils_Tuple2(
					asyncTransition,
					A2($elm$core$Task$attempt, $author$project$App$Main$SdkListLoaded, $author$project$Page$SdkList$init));
			case 32:
				var maybeSection = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$DocsLoaded,
						$author$project$Page$Docs$init(maybeSection)));
			case 34:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$LogConfigsLoaded,
						$author$project$Page$Configuration$List$init(model.a)));
			case 35:
				return A2(
					loadPageAndUuid,
					$author$project$App$Main$LogConfigEditorLoaded,
					$author$project$Page$Configuration$Editor$initForCreate(model.a));
			case 36:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$LogConfigEditorLoaded,
						A2($author$project$Page$Configuration$Editor$initForEdit, model.a, id)));
			case 37:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$NewsLoaded,
						$author$project$Page$News$init(model.a)));
			case 38:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$TenantSettingsLoaded,
						$author$project$Page$Tenant$init(model.a)));
			case 39:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$ViewClassifierHistoryLoaded,
						A2($author$project$Page$Classifier$History$init, model.a, id)));
			case 40:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$GroupListLoaded,
						A2(
							$author$project$Page$Group$GroupList$init,
							model.a,
							$author$project$App$Main$isSystemTenant(model.Y))));
			case 41:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$GroupViewerLoaded,
						A3(
							$author$project$Page$Group$GroupViewer$init,
							model.a,
							$author$project$App$Main$isSystemTenant(model.Y),
							id)));
			case 42:
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$GroupCreatorLoaded,
						$author$project$Page$Group$GroupCreator$init(model.a)));
			default:
				var id = route.a;
				return _Utils_Tuple2(
					asyncTransition,
					A2(
						$elm$core$Task$attempt,
						$author$project$App$Main$GroupEditorLoaded,
						A2($author$project$Page$Group$GroupEditor$init, model.a, id)));
		}
	});
var $author$project$App$Ports$trackPageView = _Platform_outgoingPort(
	'trackPageView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string($.bO)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string($.hQ))
				]));
	});
var $author$project$App$Main$setRoute = F2(
	function (url, model) {
		var route = $author$project$App$Route$fromUrl(url);
		var _v0 = A2($author$project$App$Main$setRouteHelper, route, model);
		var modelAfterRouting = _v0.a;
		var routingCmd = _v0.b;
		return _Utils_Tuple2(
			modelAfterRouting,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$App$Ports$trackPageView(
						{
							bO: $author$project$App$Route$routeToBreadcrumb(route),
							hQ: $elm$url$Url$toString(url)
						}),
						routingCmd
					])));
	});
var $elm$http$Http$send = F2(
	function (resultToMessage, request_) {
		return A2(
			$elm$core$Task$attempt,
			resultToMessage,
			$elm$http$Http$toTask(request_));
	});
var $krisajenkins$remotedata$RemoteData$sendRequest = $elm$http$Http$send($krisajenkins$remotedata$RemoteData$fromResult);
var $author$project$Request$User$whoAmI = function (accessToken) {
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $krisajenkins$remotedata$RemoteData$sendRequest(
		$elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Data$User$decoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/whoami',
				hU: false
			}));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$App$Main$init = F3(
	function (flagsJson, url, navKey) {
		var flags = A2(
			$elm$core$Result$withDefault,
			A3($author$project$App$Main$Flags, $elm$core$Maybe$Nothing, _List_Nil, ''),
			A2($elm$json$Json$Decode$decodeValue, $author$project$App$Main$flagsDecoder, flagsJson));
		var _v0 = A2(
			$author$project$App$Main$setRoute,
			url,
			A2($author$project$App$Main$defaultModel, flags, navKey));
		var model = _v0.a;
		var routeCmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						routeCmd,
						$author$project$App$Ports$getAccessToken(0),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$App$Main$GetUserResponse,
						$author$project$Request$User$whoAmI(model.a)),
						$author$project$App$Main$getUserSettings(model.a)
					])));
	});
var $author$project$App$Main$ClassifierEditorMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$App$Main$ClassifierListMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$App$Main$GotAccessToken = function (a) {
	return {$: 46, a: a};
};
var $author$project$App$Main$HideUserDropdown = {$: 7};
var $author$project$App$Main$IncidentListMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Main$IncidentMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$App$Main$LogFileMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$Main$RemedyEditorMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$App$Main$RemedyListMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$App$Main$SectionEditorMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$App$Main$UpdatePage = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$App$Ports$receiveAccessToken = _Platform_incomingPort('receiveAccessToken', $elm$json$Json$Decode$string);
var $author$project$Page$Classifier$Editor$WindowScroll = function (a) {
	return {$: 17, a: a};
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$App$Ports$windowScroll = _Platform_incomingPort(
	'windowScroll',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int)));
var $author$project$Page$Classifier$Editor$subscriptions = function (_v0) {
	return $author$project$App$Ports$windowScroll($author$project$Page$Classifier$Editor$WindowScroll);
};
var $author$project$Page$Classifier$List$HideActionDropdown = {$: 4};
var $author$project$Page$Classifier$List$HideTypeDropdown = {$: 1};
var $author$project$Page$Classifier$List$actionDropdownId = 'action-dropdown';
var $author$project$Page$Classifier$List$newClassifierDropdownId = 'new-classifier-dropdown';
var $author$project$Util$JsonDecode$invertDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybe) {
			if (maybe.$ === 1) {
				return $elm$json$Json$Decode$succeed(0);
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		$elm$json$Json$Decode$maybe(decoder));
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {eG: pids, e6: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {f0: event, en: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.eG,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.en;
		var event = _v0.f0;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.e6);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Util$JsonDecode$succeedIfChildOf = function (predicate) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return predicate(id) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$Util$JsonDecode$succeedIfChildOf(predicate));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$Util$Browser$onClickOutside = F2(
	function (domIds, didClickOutsideMsg) {
		var clickOutsideDetector = A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always(didClickOutsideMsg),
			$author$project$Util$JsonDecode$invertDecoder(
				A2(
					$elm$json$Json$Decode$field,
					'target',
					$author$project$Util$JsonDecode$succeedIfChildOf(
						function (id) {
							return A2($elm$core$List$member, id, domIds);
						}))));
		return $elm$browser$Browser$Events$onClick(clickOutsideDetector);
	});
var $author$project$Page$Classifier$List$subscriptions = function (model) {
	return model.ak ? A2(
		$author$project$Util$Browser$onClickOutside,
		_List_fromArray(
			[$author$project$Page$Classifier$List$newClassifierDropdownId]),
		$author$project$Page$Classifier$List$HideTypeDropdown) : ((!_Utils_eq(model.ap, $elm$core$Maybe$Nothing)) ? A2(
		$author$project$Util$Browser$onClickOutside,
		_List_fromArray(
			[$author$project$Page$Classifier$List$actionDropdownId]),
		$author$project$Page$Classifier$List$HideActionDropdown) : $elm$core$Platform$Sub$none);
};
var $author$project$Page$Incident$GotDocumentURL = function (a) {
	return {$: 17, a: a};
};
var $author$project$Util$Keyboard$ArrowDown = {$: 6};
var $author$project$Util$Keyboard$ArrowLeft = {$: 4};
var $author$project$Util$Keyboard$ArrowRight = {$: 5};
var $author$project$Util$Keyboard$ArrowUp = {$: 7};
var $author$project$Util$Keyboard$Backspace = {$: 3};
var $author$project$Util$Keyboard$Character = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Keyboard$Enter = {$: 2};
var $author$project$Util$Keyboard$Escape = {$: 1};
var $author$project$Util$Keyboard$Unknown = function (a) {
	return {$: 8, a: a};
};
var $author$project$Util$Keyboard$toKey = function (string) {
	var _v0 = $elm$core$String$uncons(string);
	_v0$8:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.b) {
				case '':
					var _v1 = _v0.a;
					var _char = _v1.a;
					return $author$project$Util$Keyboard$Character(_char);
				case 'scape':
					if ('E' === _v0.a.a) {
						var _v2 = _v0.a;
						return $author$project$Util$Keyboard$Escape;
					} else {
						break _v0$8;
					}
				case 'nter':
					if ('E' === _v0.a.a) {
						var _v3 = _v0.a;
						return $author$project$Util$Keyboard$Enter;
					} else {
						break _v0$8;
					}
				case 'ackspace':
					if ('B' === _v0.a.a) {
						var _v4 = _v0.a;
						return $author$project$Util$Keyboard$Backspace;
					} else {
						break _v0$8;
					}
				case 'rrowLeft':
					if ('A' === _v0.a.a) {
						var _v5 = _v0.a;
						return $author$project$Util$Keyboard$ArrowLeft;
					} else {
						break _v0$8;
					}
				case 'rrowRight':
					if ('A' === _v0.a.a) {
						var _v6 = _v0.a;
						return $author$project$Util$Keyboard$ArrowRight;
					} else {
						break _v0$8;
					}
				case 'rrowUp':
					if ('A' === _v0.a.a) {
						var _v7 = _v0.a;
						return $author$project$Util$Keyboard$ArrowUp;
					} else {
						break _v0$8;
					}
				case 'rrowDown':
					if ('A' === _v0.a.a) {
						var _v8 = _v0.a;
						return $author$project$Util$Keyboard$ArrowDown;
					} else {
						break _v0$8;
					}
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return $author$project$Util$Keyboard$Unknown(string);
};
var $author$project$Util$Keyboard$keyDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Util$Keyboard$toKey,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$Util$Keyboard$filterMapDecoder = function (fn) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			var _v0 = fn(key);
			if (!_v0.$) {
				var msg = _v0.a;
				return $elm$json$Json$Decode$succeed(msg);
			} else {
				return $elm$json$Json$Decode$fail('not interested');
			}
		},
		$author$project$Util$Keyboard$keyDecoder);
};
var $author$project$Page$Incident$NavigateEnter = {$: 13};
var $author$project$Page$Incident$NavigateEscapePressed = {$: 16};
var $author$project$Page$Incident$ShowNavigator = {$: 15};
var $author$project$Page$Incident$keyPressToMsg = F2(
	function (model, key) {
		return _Utils_eq(key, $author$project$Util$Keyboard$Escape) ? $elm$core$Maybe$Just($author$project$Page$Incident$NavigateEscapePressed) : ((_Utils_eq(
			key,
			$author$project$Util$Keyboard$Character('t')) && (!model.aY)) ? $elm$core$Maybe$Just($author$project$Page$Incident$ShowNavigator) : (_Utils_eq(key, $author$project$Util$Keyboard$Enter) ? $elm$core$Maybe$Just($author$project$Page$Incident$NavigateEnter) : $elm$core$Maybe$Nothing));
	});
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
var $author$project$App$Ports$receiveDocumentURL = _Platform_incomingPort('receiveDocumentURL', $elm$json$Json$Decode$string);
var $author$project$Page$Incident$subscriptions = function (model) {
	var keyboardSub = model.N ? $elm$core$Platform$Sub$none : $elm$browser$Browser$Events$onKeyUp(
		$author$project$Util$Keyboard$filterMapDecoder(
			$author$project$Page$Incident$keyPressToMsg(model)));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				keyboardSub,
				$author$project$App$Ports$receiveDocumentURL($author$project$Page$Incident$GotDocumentURL)
			]));
};
var $author$project$Page$Incident$List$CloseDropdowns = {$: 3};
var $author$project$Page$Incident$List$searchDropdownId = 'search-dropdown';
var $author$project$Page$Incident$List$subscriptions = function (model) {
	return model.at ? A2(
		$author$project$Util$Browser$onClickOutside,
		_List_fromArray(
			[$author$project$Page$Incident$List$searchDropdownId]),
		$author$project$Page$Incident$List$CloseDropdowns) : $elm$core$Platform$Sub$none;
};
var $author$project$Page$LogFile$ShowHidePicker = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$LogFile$pickerDomId = function (fieldIndex) {
	return 'powerlift-picker-' + $elm$core$String$fromInt(fieldIndex);
};
var $author$project$Page$LogFile$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, p) {
						return p.ai ? $elm$core$Maybe$Just(
							A2(
								$author$project$Util$Browser$onClickOutside,
								_List_fromArray(
									[
										$author$project$Page$LogFile$pickerDomId(p.be)
									]),
								$author$project$Page$LogFile$ShowHidePicker(idx))) : $elm$core$Maybe$Nothing;
					}),
				model.T)));
};
var $author$project$Page$Remedy$Editor$ClickedOutsideEditor = {$: 29};
var $author$project$Page$Remedy$Editor$addElementToolbarDomId = 'powerlift-add-element-toolbar';
var $author$project$Remedy$Editor$Form$isFocused = function (_v0) {
	var form = _v0;
	return !_Utils_eq(form.n.f7, $elm$core$Maybe$Nothing);
};
var $author$project$Page$Remedy$Editor$EscapeKeyPressed = {$: 28};
var $author$project$Page$Remedy$Editor$keyPressToMsg = function (key) {
	return _Utils_eq(key, $author$project$Util$Keyboard$Escape) ? $elm$core$Maybe$Just($author$project$Page$Remedy$Editor$EscapeKeyPressed) : $elm$core$Maybe$Nothing;
};
var $author$project$Page$Remedy$Editor$remedyScreenDomId = 'powerlift-screen-editor';
var $author$project$Page$Remedy$Editor$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onKeyUp(
				$author$project$Util$Keyboard$filterMapDecoder($author$project$Page$Remedy$Editor$keyPressToMsg)),
				$author$project$Remedy$Editor$Form$isFocused(model.d) ? A2(
				$author$project$Util$Browser$onClickOutside,
				_List_fromArray(
					[$author$project$Page$Remedy$Editor$remedyScreenDomId, $author$project$Page$Remedy$Editor$addElementToolbarDomId]),
				$author$project$Page$Remedy$Editor$ClickedOutsideEditor) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Page$Remedy$List$HideActionDropdown = {$: 2};
var $author$project$Page$Remedy$List$actionDropdownId = 'remedy-action-dropdown';
var $author$project$Page$Remedy$List$subscriptions = function (model) {
	return (!_Utils_eq(model.aq, $elm$core$Maybe$Nothing)) ? A2(
		$author$project$Util$Browser$onClickOutside,
		_List_fromArray(
			[$author$project$Page$Remedy$List$actionDropdownId]),
		$author$project$Page$Remedy$List$HideActionDropdown) : $elm$core$Platform$Sub$none;
};
var $author$project$Page$Widget$SectionEditor$HideTypeDropdown = {$: 4};
var $author$project$Page$Widget$SectionEditor$newWidgetDropdownId = 'new-widget-dropdown';
var $author$project$Page$Widget$SectionEditor$subscriptions = function (model) {
	return model.ak ? A2(
		$author$project$Util$Browser$onClickOutside,
		_List_fromArray(
			[$author$project$Page$Widget$SectionEditor$newWidgetDropdownId]),
		$author$project$Page$Widget$SectionEditor$HideTypeDropdown) : $elm$core$Platform$Sub$none;
};
var $author$project$View$NavBar$tenantDropdownId = 'nav-bar-dropdown';
var $author$project$View$NavBar$subscriptions = F2(
	function (userDropdownExpanded, closeDropdownMsg) {
		return userDropdownExpanded ? A2(
			$author$project$Util$Browser$onClickOutside,
			_List_fromArray(
				[$author$project$View$NavBar$tenantDropdownId]),
			closeDropdownMsg) : $elm$core$Platform$Sub$none;
	});
var $author$project$App$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$View$NavBar$subscriptions, model.X, $author$project$App$Main$HideUserDropdown),
				$author$project$App$Ports$receiveAccessToken($author$project$App$Main$GotAccessToken),
				function () {
				var _v0 = $author$project$App$Main$getPage(model.l);
				switch (_v0.$) {
					case 4:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$IncidentListMsg),
							$author$project$Page$Incident$List$subscriptions(pageModel));
					case 5:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$IncidentMsg),
							$author$project$Page$Incident$subscriptions(pageModel));
					case 8:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$ClassifierListMsg),
							$author$project$Page$Classifier$List$subscriptions(pageModel));
					case 10:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$ClassifierEditorMsg),
							$author$project$Page$Classifier$Editor$subscriptions(pageModel));
					case 28:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$LogFileMsg),
							$author$project$Page$LogFile$subscriptions(pageModel));
					case 12:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$RemedyEditorMsg),
							$author$project$Page$Remedy$Editor$subscriptions(pageModel));
					case 11:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$RemedyListMsg),
							$author$project$Page$Remedy$List$subscriptions(pageModel));
					case 16:
						var pageModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$SectionEditorMsg),
							$author$project$Page$Widget$SectionEditor$subscriptions(pageModel));
					default:
						return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$App$Main$Admin = function (a) {
	return {$: 15, a: a};
};
var $author$project$App$Main$AdvancedSearch = function (a) {
	return {$: 23, a: a};
};
var $author$project$App$Main$Basement = function (a) {
	return {$: 24, a: a};
};
var $author$project$App$Main$CapabilityEditor = function (a) {
	return {$: 20, a: a};
};
var $author$project$App$Main$CapabilityList = function (a) {
	return {$: 19, a: a};
};
var $author$project$App$Main$ClassifierEditor = function (a) {
	return {$: 10, a: a};
};
var $author$project$App$Main$ClassifierList = function (a) {
	return {$: 8, a: a};
};
var $author$project$App$Main$ClassifierViewer = function (a) {
	return {$: 9, a: a};
};
var $author$project$App$Main$Docs = function (a) {
	return {$: 27, a: a};
};
var $author$project$App$Main$GroupCreator = function (a) {
	return {$: 36, a: a};
};
var $author$project$App$Main$GroupEditor = function (a) {
	return {$: 37, a: a};
};
var $author$project$App$Main$GroupList = function (a) {
	return {$: 34, a: a};
};
var $author$project$App$Main$GroupViewer = function (a) {
	return {$: 35, a: a};
};
var $author$project$App$Main$Home = function (a) {
	return {$: 3, a: a};
};
var $author$project$App$Main$Incident = function (a) {
	return {$: 5, a: a};
};
var $author$project$App$Main$IncidentList = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$Main$JoinTenantHelp = function (a) {
	return {$: 6, a: a};
};
var $author$project$App$Main$LogConfigEditor = function (a) {
	return {$: 29, a: a};
};
var $author$project$App$Main$LogConfigList = function (a) {
	return {$: 30, a: a};
};
var $author$project$App$Main$LogFile = function (a) {
	return {$: 28, a: a};
};
var $author$project$App$Main$LogOutResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$App$Main$News = function (a) {
	return {$: 31, a: a};
};
var $author$project$App$Main$Onboarding = function (a) {
	return {$: 25, a: a};
};
var $author$project$App$Main$RemedyEditor = function (a) {
	return {$: 12, a: a};
};
var $author$project$App$Main$RemedyHistory = function (a) {
	return {$: 14, a: a};
};
var $author$project$App$Main$RemedyHistoryMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$App$Main$RemedyList = function (a) {
	return {$: 11, a: a};
};
var $author$project$App$Main$RemedyViewer = function (a) {
	return {$: 13, a: a};
};
var $author$project$App$Main$RemedyViewerMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$App$Main$ScrubberEditor = function (a) {
	return {$: 22, a: a};
};
var $author$project$App$Main$ScrubberList = function (a) {
	return {$: 21, a: a};
};
var $author$project$App$Main$SdkList = function (a) {
	return {$: 26, a: a};
};
var $author$project$App$Main$SectionEditor = function (a) {
	return {$: 16, a: a};
};
var $author$project$App$Main$SelectTenant = function (a) {
	return {$: 8, a: a};
};
var $author$project$App$Main$SelectTenantResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$App$Main$TenantSettings = function (a) {
	return {$: 32, a: a};
};
var $author$project$App$Main$Timeline = function (a) {
	return {$: 7, a: a};
};
var $author$project$App$Main$ViewClassifierHistory = function (a) {
	return {$: 33, a: a};
};
var $author$project$App$Main$WidgetCollectionEditor = function (a) {
	return {$: 17, a: a};
};
var $author$project$App$Main$WidgetEditor = function (a) {
	return {$: 18, a: a};
};
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$App$Main$finalizeFullPageReload = F2(
	function (response, model) {
		if (response.$ === 3) {
			return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aU: false}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$Main$handleLoadResult = F3(
	function (result, model, toPage) {
		var _v0 = _Utils_Tuple2(model.l, result);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var subModel = _v0.b.a;
				return _Utils_update(
					model,
					{
						l: $author$project$App$Main$Loaded(
							toPage(subModel))
					});
			} else {
				var err = _v0.b.a;
				return _Utils_update(
					model,
					{
						l: $author$project$App$Main$Loaded(
							$author$project$App$Main$Error(err))
					});
			}
		} else {
			return model;
		}
	});
var $author$project$Page$JoinTenantHelp$defaultModel = function (tenantInfo) {
	return {f$: _List_Nil, dt: tenantInfo};
};
var $author$project$Page$JoinTenantHelp$init = function (tenantInfo) {
	return $author$project$Page$JoinTenantHelp$defaultModel(tenantInfo);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Request$User$cacheUser = _Platform_outgoingPort('cacheUser', $elm$core$Basics$identity);
var $author$project$Util$Http$deleteAndIgnoreWithHeaders = F2(
	function (headers, url) {
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectStringResponse(
					function (_v0) {
						return $elm$core$Result$Ok(0);
					}),
				ge: headers,
				gM: 'DELETE',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Request$User$logOut = function (accessToken) {
	var headers = _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$krisajenkins$remotedata$RemoteData$sendRequest(
				A2($author$project$Util$Http$deleteAndIgnoreWithHeaders, headers, '/gym/logout')),
				$author$project$Request$User$cacheUser($elm$json$Json$Encode$null)
			]));
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Util$Http$putWithHeaders = F3(
	function (headers, url, body) {
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectStringResponse(
					function (_v0) {
						return $elm$core$Result$Ok(0);
					}),
				ge: headers,
				gM: 'PUT',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Request$User$selectTenant = F2(
	function (accessToken, id) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$author$project$UUID$encode(id))
					])));
		return $krisajenkins$remotedata$RemoteData$sendRequest(
			A3($author$project$Util$Http$putWithHeaders, headers, '/gym/activeTenant', body));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Data$Tenant$encodeTenant = function (tenant) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$UUID$encode(tenant.bj)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(tenant.ev)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(tenant.aC)),
				_Utils_Tuple2(
				'read',
				$elm$json$Json$Encode$bool(tenant.eN)),
				_Utils_Tuple2(
				'write',
				$elm$json$Json$Encode$bool(tenant.fi))
			]));
};
var $author$project$Data$User$encode = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'upn',
				$elm$json$Json$Encode$string(user.fd)),
				_Utils_Tuple2(
				'tenants',
				A2($elm$json$Json$Encode$list, $author$project$Data$Tenant$encodeTenant, user.hB))
			]));
};
var $author$project$Request$User$storeUser = function (user) {
	return $author$project$Request$User$cacheUser(
		$author$project$Data$User$encode(user));
};
var $author$project$App$Main$updateLoadingBar = F2(
	function (now, pageState) {
		if (pageState.$ === 1) {
			var page = pageState.a;
			return $author$project$App$Main$TransitioningFrom(page);
		} else {
			return pageState;
		}
	});
var $author$project$App$Main$AdminMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$App$Main$AdvancedSearchMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Main$BasementMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$App$Main$CapabilityEditorMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$App$Main$CapabilityListMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$App$Main$ClassifierViewerMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$App$Main$DocsMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$App$Main$GroupCreatorMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$App$Main$GroupEditorMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$App$Main$GroupListMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$App$Main$GroupViewerMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$App$Main$HomeMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$App$Main$JoinTenantHelpMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$App$Main$LogConfigEditorMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$App$Main$LogConfigListMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$App$Main$NewsMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$App$Main$OnboardingMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$App$Main$ScrubberEditorMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$App$Main$ScrubberListMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$App$Main$SdkListMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$App$Main$TenantSettingsMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$App$Main$TimelineMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$App$Main$WidgetCollectionEditorMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$App$Main$WidgetEditorMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Admin$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$AdvancedSearch$CompletedSearch = function (a) {
	return {$: 3, a: a};
};
var $author$project$Util$appendErrors = F2(
	function (model, errors) {
		return _Utils_update(
			model,
			{
				f$: _Utils_ap(model.f$, errors)
			});
	});
var $author$project$Util$clearErrors = function (model) {
	return _Utils_update(
		model,
		{f$: _List_Nil});
};
var $author$project$Util$Http$PowerLiftMessage = F2(
	function (message, details) {
		return {fX: details, c6: message};
	});
var $author$project$Util$Http$tryDecodeErrorMessage = function (responseBody) {
	var messageDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'details',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'message',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Util$Http$PowerLiftMessage)));
	var _v0 = A2($elm$json$Json$Decode$decodeString, messageDecoder, responseBody);
	if (!_v0.$) {
		var value = _v0.a;
		return $elm$core$String$isEmpty(value.fX) ? value.c6 : (value.c6 + (': ' + value.fX));
	} else {
		return responseBody;
	}
};
var $author$project$Util$Http$errorToString = function (error) {
	switch (error.$) {
		case 1:
			return 'timeout';
		case 2:
			return 'network error';
		case 0:
			var url = error.a;
			return 'invalid url: \'' + (url + '\'');
		case 4:
			var err = error.a;
			return 'bad response payload: \'' + (err + '\'');
		default:
			var response = error.a;
			return 'bad response status code ' + ($elm$core$String$fromInt(response.e3.dN) + (': ' + $author$project$Util$Http$tryDecodeErrorMessage(response.bX)));
	}
};
var $author$project$Request$Search$searchInstallIds = F2(
	function (accessToken, installIds) {
		var url = '/gym/incidents/forInstallIds';
		var responseDecoder = $elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($author$project$UUID$decoder));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, installIds));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$AdvancedSearch$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: str}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$AdvancedSearch$CompletedSearch,
						$elm$http$Http$toTask(
							A2(
								$author$project$Request$Search$searchInstallIds,
								model.a,
								A2($elm$core$String$split, '\n', model.bE)))));
			default:
				var result = msg.a;
				if (!result.$) {
					var dict = result.a;
					return _Utils_Tuple2(
						$author$project$Util$clearErrors(
							_Utils_update(
								model,
								{
									hg: $elm$core$Maybe$Just(dict)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							model,
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(err)
								])),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Basement$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Capability$Editor$addNewParameter = function (oldCapability) {
	var newParam = {cf: false, ev: ''};
	return _Utils_update(
		oldCapability,
		{
			bB: _Utils_ap(
				oldCapability.bB,
				_List_fromArray(
					[newParam]))
		});
};
var $author$project$Data$Classifier$Type$typeToString = function (classifierType) {
	switch (classifierType) {
		case 0:
			return 'javascript';
		case 1:
			return 'drill2';
		case 2:
			return 'regex';
		default:
			return 'random';
	}
};
var $author$project$Data$Widget$Type$typeToString = function (widgetType) {
	switch (widgetType) {
		case 0:
			return 'static_table';
		case 1:
			return 'dynamic_list';
		case 2:
			return 'dynamic_table';
		default:
			return 'generic_json';
	}
};
var $author$project$App$Route$routeToString = function (route) {
	switch (route.$) {
		case 0:
			return '/#/';
		case 29:
			return '/#/notFound';
		case 1:
			var maybeQuery = route.a;
			return '/#/incidents' + A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (it) {
					return '?query=' + $elm$url$Url$percentEncode(it);
				},
				maybeQuery);
		case 2:
			return '/#/search/advanced';
		case 3:
			var id = route.a;
			var maybeTab = route.b;
			return '/#/incidents/' + ($author$project$UUID$toString(id) + A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (it) {
					return '?tab=' + $elm$url$Url$percentEncode(it);
				},
				maybeTab));
		case 4:
			var id = route.a;
			return '/#/incidents/' + id;
		case 33:
			var incidentId = route.a;
			var fileId = route.b;
			return '/#/incidents/' + ($author$project$UUID$toString(incidentId) + ('/files/' + $elm$url$Url$percentEncode(fileId)));
		case 5:
			var installId = route.a;
			return '/#/timeline/' + installId;
		case 6:
			return '/#/classifiers';
		case 7:
			var id = route.a;
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						'#',
						'classifiers',
						$author$project$UUID$toString(id)
					]),
				_List_Nil);
		case 8:
			var id = route.a;
			return '/#/classifiers/edit/' + $author$project$UUID$toString(id);
		case 9:
			var id = route.a;
			return '/#/classifiers/clone/' + $author$project$UUID$toString(id);
		case 10:
			var classifierType = route.a;
			return '/#/classifiers/new/' + $author$project$Data$Classifier$Type$typeToString(classifierType);
		case 11:
			return '/#/remedies';
		case 13:
			var id = route.a;
			return '/#/remedies/' + $author$project$UUID$toString(id);
		case 12:
			var id = route.a;
			var version = route.b;
			return '/#/remedies/' + ($author$project$UUID$toString(id) + ('/version/' + $elm$core$String$fromInt(version)));
		case 14:
			var id = route.a;
			return '/#/remedies/edit/' + $author$project$UUID$toString(id);
		case 15:
			var id = route.a;
			return '/#/remedies/clone/' + $author$project$UUID$toString(id);
		case 16:
			return '/#/remedies/new';
		case 17:
			return '/#/admin';
		case 18:
			return '/#/admin/widgets/';
		case 19:
			var sectionIndex = route.a;
			return '/#/admin/widgets/' + $elm$core$String$fromInt(sectionIndex);
		case 20:
			var sectionIndex = route.a;
			var widgetId = route.b;
			return '/#/admin/widgets/' + ($elm$core$String$fromInt(sectionIndex) + ('/' + $author$project$UUID$toString(widgetId)));
		case 21:
			var sectionIndex = route.a;
			var widgetType = route.b;
			return '/#/admin/widgets/' + ($elm$core$String$fromInt(sectionIndex) + ('/new/' + $author$project$Data$Widget$Type$typeToString(widgetType)));
		case 22:
			return '/#/admin/capabilities/';
		case 23:
			var id = route.a;
			return '/#/admin/capabilities/edit/' + id;
		case 24:
			return '/#/admin/capabilities/new/';
		case 25:
			return '/#/admin/scrubbers/';
		case 26:
			var id = route.a;
			return '/#/admin/scrubbers/edit/' + $author$project$UUID$toString(id);
		case 27:
			return '/#/admin/scrubbers/new/';
		case 28:
			return '/#/basement';
		case 30:
			return '/#/onboarding';
		case 31:
			return '/#/sdk';
		case 32:
			var sectionName = route.a;
			return '/#/docs' + function () {
				if (!sectionName.$) {
					var name = sectionName.a;
					return '/' + $author$project$Data$Docs$sectionToString(name);
				} else {
					return '';
				}
			}();
		case 34:
			return '/#/admin/configurations/';
		case 35:
			return '/#/admin/configurations/new/';
		case 36:
			var id = route.a;
			return '/#/admin/configurations/edit/' + $author$project$UUID$toString(id);
		case 37:
			return '/#/news';
		case 38:
			return '/#/tenant/settings';
		case 39:
			var id = route.a;
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						'#',
						'classifiers',
						'history',
						$author$project$UUID$toString(id)
					]),
				_List_Nil);
		case 40:
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					['#', 'groups']),
				_List_Nil);
		case 41:
			var id = route.a;
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						'#',
						'groups',
						$author$project$UUID$toString(id)
					]),
				_List_Nil);
		case 42:
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					['#', 'groups', 'new']),
				_List_Nil);
		default:
			var id = route.a;
			return A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						'#',
						'groups',
						'edit',
						$author$project$UUID$toString(id)
					]),
				_List_Nil);
	}
};
var $author$project$App$Route$pushUrlCmd = function (key) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$App$Route$routeToString,
		$elm$browser$Browser$Navigation$pushUrl(key));
};
var $author$project$Page$Capability$Editor$handleSaveResult = F3(
	function (model, httpResult, navKey) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil}),
				A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListCapabilities));
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Capability$Editor$updateCapability = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				aD: f(model.aD)
			});
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Page$Capability$Editor$updateParameter = F3(
	function (index, f, capability) {
		return _Utils_update(
			capability,
			{
				bB: A3($elm_community$list_extra$List$Extra$updateAt, index, f, capability.bB)
			});
	});
var $author$project$Page$Capability$Editor$SaveCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$CustomCapability$encodeParameter = function (parameter) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(parameter.ev)),
				_Utils_Tuple2(
				'optional',
				$elm$json$Json$Encode$bool(parameter.cf))
			]));
};
var $author$project$Remedy$CustomCapability$encode = function (capability) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(capability.bj)),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$int(capability.dx)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(capability.b6)),
				_Utils_Tuple2(
				'parameters',
				A2($elm$json$Json$Encode$list, $author$project$Remedy$CustomCapability$encodeParameter, capability.bB))
			]));
};
var $author$project$Request$CustomCapability$save = F2(
	function (accessToken, remedy) {
		var responseDecoder = $elm$json$Json$Decode$succeed(0);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Remedy$CustomCapability$encode(remedy));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/remedies/capabilities',
				hU: false
			});
	});
var $author$project$Page$Capability$Editor$save = function (model) {
	var capability = model.aD;
	var newCapability = _Utils_update(
		capability,
		{dx: capability.dx + 1});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{f$: _List_Nil, cg: true}),
		A2(
			$elm$core$Task$attempt,
			$author$project$Page$Capability$Editor$SaveCompleted,
			$elm$http$Http$toTask(
				A2($author$project$Request$CustomCapability$save, model.a, newCapability))));
};
var $author$project$Page$Capability$Editor$validateAndSave = function (model) {
	return $author$project$Page$Capability$Editor$save(model);
};
var $author$project$Page$Capability$Editor$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return $author$project$Page$Capability$Editor$validateAndSave(model);
			case 2:
				var result = msg.a;
				return A3($author$project$Page$Capability$Editor$handleSaveResult, model, result, navKey);
			case 3:
				var newId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Capability$Editor$updateCapability,
						function (c) {
							return _Utils_update(
								c,
								{bj: newId});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 4:
				var newDescription = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Capability$Editor$updateCapability,
						function (c) {
							return _Utils_update(
								c,
								{b6: newDescription});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 5:
				var index = msg.a;
				var newName = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Capability$Editor$updateCapability,
						function (c) {
							return A3(
								$author$project$Page$Capability$Editor$updateParameter,
								index,
								function (p) {
									return _Utils_update(
										p,
										{ev: newName});
								},
								c);
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					A2($author$project$Page$Capability$Editor$updateCapability, $author$project$Page$Capability$Editor$addNewParameter, model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Capability$List$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Classifier$Editor$AddToGroupCompleted = function (a) {
	return {$: 28, a: a};
};
var $author$project$Page$Classifier$Editor$ChartFailed = {$: 3};
var $author$project$Page$Classifier$Editor$ChartLoading = {$: 1};
var $author$project$Page$Classifier$Editor$ChooseGroupModal = 1;
var $author$project$Page$Classifier$Editor$CompletedChartLoad = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$Classifier$Editor$HelpModalForDiscardIncident = 2;
var $author$project$Page$Classifier$Editor$Loading = 1;
var $author$project$Page$Classifier$Editor$Results = 2;
var $author$project$Page$Classifier$Editor$RunPageCompleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Classifier$Editor$SaveCompleted = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Classifier$Editor$Saving = 2;
var $author$project$Request$Group$addClassifier = F3(
	function (accessToken, groupId, classifierId) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'classifierId',
						$author$project$UUID$encode(classifierId))
					])));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson($author$project$Data$Group$groupDetailResponseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/groups/' + ($author$project$UUID$toString(groupId) + '/classifiers'),
				hU: false
			});
	});
var $author$project$Data$Classifier$BatchTryClassifierResponse = F5(
	function (numMatched, numErrors, numTried, matchedItems, lastTriedAfterId) {
		return {gD: lastTriedAfterId, gH: matchedItems, gT: numErrors, gW: numMatched, gZ: numTried};
	});
var $author$project$Data$Classifier$FileTryResult = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Classifier$IncidentTryResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Classifier$FileResult = F3(
	function (meta, url, error) {
		return {d7: error, er: meta, hQ: url};
	});
var $author$project$Data$Incident$FileMeta = function (name) {
	return function (id) {
		return function (contentId) {
			return function (contentType) {
				return function (size) {
					return function (tags) {
						return function (application) {
							return function (createdAt) {
								return function (ingestedAt) {
									return function (incidentId) {
										return {fr: application, fO: contentId, fP: contentType, dT: createdAt, bj: id, cZ: incidentId, ek: ingestedAt, ev: name, e$: size, e8: tags};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Incident$fileMetaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'incidentId',
	$author$project$UUID$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ingestedAt',
		$author$project$Util$JsonDecode$posixTime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			$author$project$Util$JsonDecode$posixTime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'application',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tags',
					$author$project$Util$JsonDecode$setOf($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'size',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'contentType',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'contentId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Incident$FileMeta)))))))))));
var $author$project$Data$Classifier$fileTryResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Data$Incident$fileMetaDecoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Classifier$FileResult))));
var $author$project$Data$Classifier$IncidentResult = F3(
	function (incident, issueBrief, error) {
		return {d7: error, gj: incident, gu: issueBrief};
	});
var $author$project$Data$Classifier$incidentTryResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'issueBrief',
		$elm$json$Json$Decode$nullable($author$project$Data$Issue$briefDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'incident',
			$author$project$Data$Incident$liteDecoder,
			$elm$json$Json$Decode$succeed($author$project$Data$Classifier$IncidentResult))));
var $author$project$Data$Classifier$tryResultDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Data$Classifier$IncidentTryResult, $author$project$Data$Classifier$incidentTryResultDecoder),
			A2($elm$json$Json$Decode$map, $author$project$Data$Classifier$FileTryResult, $author$project$Data$Classifier$fileTryResultDecoder)
		]));
var $author$project$Data$Classifier$batchTryClassifierResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lastTriedAfterId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'triesWithData',
		$elm$json$Json$Decode$list($author$project$Data$Classifier$tryResultDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'numTried',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'numErrors',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'numMatched',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Data$Classifier$BatchTryClassifierResponse))))));
var $author$project$Data$Classifier$configToString = function (config) {
	switch (config.$) {
		case 0:
			return 'javascript';
		case 1:
			return 'drill2';
		case 3:
			return 'regex';
		case 2:
			return 'random';
		default:
			var s = config.a;
			return s;
	}
};
var $author$project$Data$Classifier$Drill2$encodeCombiner = function (combiner) {
	if (combiner === 1) {
		return $elm$json$Json$Encode$string('OR');
	} else {
		return $elm$json$Json$Encode$string('AND');
	}
};
var $author$project$Data$Classifier$Drill2$encodeOperand = function (operand) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (operand) {
				case 0:
					return 'EQ';
				case 1:
					return 'LT';
				case 2:
					return 'GT';
				case 3:
					return 'NULL';
				default:
					return 'SUBSTRING';
			}
		}());
};
var $author$project$Data$Classifier$Drill2$encodeOperandType = function (operandType) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (operandType) {
				case 0:
					return 'number';
				case 1:
					return 'string';
				case 2:
					return 'bool';
				case 3:
					return 'version';
				default:
					return 'array';
			}
		}());
};
var $author$project$Data$Classifier$Drill2$encodeCondition = function (condition) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'path',
				$elm$json$Json$Encode$string(condition.en)),
				_Utils_Tuple2(
				'type',
				$author$project$Data$Classifier$Drill2$encodeOperandType(condition.dW)),
				_Utils_Tuple2(
				'op',
				$author$project$Data$Classifier$Drill2$encodeOperand(condition.eB)),
				_Utils_Tuple2(
				'negate',
				$elm$json$Json$Encode$bool(condition.ew)),
				_Utils_Tuple2(
				'combiner',
				$author$project$Data$Classifier$Drill2$encodeCombiner(condition.a7)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, condition.fe))
			]));
};
var $author$project$Data$Classifier$Drill2$encodeQuery = function (_v0) {
	var path = _v0.eF;
	var conditions = _v0.dQ;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'path',
				$elm$json$Json$Encode$string(path)),
				_Utils_Tuple2(
				'conditions',
				A2($elm$json$Json$Encode$list, $author$project$Data$Classifier$Drill2$encodeCondition, conditions))
			]));
};
var $author$project$Data$Classifier$Drill2$encodeMatcher = function (_v0) {
	var combiner = _v0.a7;
	var queries = _v0.de;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'combiner',
				$author$project$Data$Classifier$Drill2$encodeCombiner(combiner)),
				_Utils_Tuple2(
				'queries',
				A2($elm$json$Json$Encode$list, $author$project$Data$Classifier$Drill2$encodeQuery, queries))
			]));
};
var $author$project$Data$Classifier$Drill2$encode = function (_v0) {
	var label = _v0.eo;
	var matcher = _v0.eq;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(label)),
				_Utils_Tuple2(
				'matcher',
				$author$project$Data$Classifier$Drill2$encodeMatcher(matcher))
			]));
};
var $author$project$Data$Classifier$RandomClassifier$encode = function (cfg) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'percentChance',
				$elm$json$Json$Encode$int(cfg.dc)),
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(cfg.eo))
			]));
};
var $author$project$Data$Classifier$RegexClassifier$encode = function (cfg) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pattern',
				$elm$json$Json$Encode$string(cfg.db)),
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(cfg.eo)),
				_Utils_Tuple2(
				'confidence',
				$elm$json$Json$Encode$int(cfg.cG))
			]));
};
var $author$project$Data$Classifier$encodeConfig = function (config) {
	switch (config.$) {
		case 0:
			var code = config.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'javaScript',
						$elm$json$Json$Encode$string(code))
					]));
		case 1:
			var cfg = config.a;
			return $author$project$Data$Classifier$Drill2$encode(cfg);
		case 2:
			var cfg = config.a;
			return $author$project$Data$Classifier$RandomClassifier$encode(cfg);
		case 3:
			var cfg = config.a;
			return $author$project$Data$Classifier$RegexClassifier$encode(cfg);
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'UNKNOWN_TYPE_SPECIFIC_FIELDS',
						$elm$json$Json$Encode$string('you must write code to handle this case'))
					]));
	}
};
var $author$project$Data$Classifier$encodeInputSpec = function (spec) {
	if (!spec.$) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'@type',
					$elm$json$Json$Encode$string('INCIDENT_SPEC'))
				]));
	} else {
		var filenamePattern = spec.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'@type',
					$elm$json$Json$Encode$string('FILE_SPEC')),
					_Utils_Tuple2(
					'filenamePattern',
					$elm$json$Json$Encode$string(filenamePattern))
				]));
	}
};
var $author$project$Data$Classifier$encode = F2(
	function (def, config) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$author$project$UUID$encode(def.bj)),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(def.dx)),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(def.bO)),
					_Utils_Tuple2(
					'enabled',
					$elm$json$Json$Encode$bool(def.cM)),
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string(def.b6)),
					_Utils_Tuple2(
					'inputSpec',
					$author$project$Data$Classifier$encodeInputSpec(def.c_)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(
						$author$project$Data$Classifier$configToString(config))),
					_Utils_Tuple2(
					'config',
					$author$project$Data$Classifier$encodeConfig(config)),
					_Utils_Tuple2(
					'discardIncidents',
					$elm$json$Json$Encode$bool(def.cJ))
				]));
	});
var $author$project$Request$Classifier$runPage = F4(
	function (accessToken, meta, config, maybeAfter) {
		var maxCount = '100';
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			A2($author$project$Data$Classifier$encode, meta, config));
		var after = function () {
			if (!maybeAfter.$) {
				var id = maybeAfter.a;
				return '&after=' + id;
			} else {
				return '';
			}
		}();
		var url = '/gym/classifiers/try?count=' + (maxCount + after);
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson($author$project$Data$Classifier$batchTryClassifierResponseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Classifier$Editor$classifyPageRequest = F4(
	function (accessToken, meta, config, lastTriedAfterId) {
		return A4($author$project$Request$Classifier$runPage, accessToken, meta, config, lastTriedAfterId);
	});
var $author$project$Request$Classifier$getChart = F4(
	function (accessToken, id, startTime, endTime) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					'gym',
					'classifiers',
					$author$project$UUID$toString(id),
					'stats'
				]),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'start',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(startTime)),
					A2(
					$elm$url$Url$Builder$string,
					'end',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endTime))
				]));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Data$Chart$decoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Classifier$Editor$fetchChart = F3(
	function (accessToken, classifierId, timePeriod) {
		return A2(
			$elm$core$Task$mapError,
			function (_v1) {
				return $elm$http$Http$NetworkError;
			},
			A2(
				$elm$core$Task$andThen,
				function (_v0) {
					var start = _v0.a;
					var end = _v0.b;
					return $elm$http$Http$toTask(
						A4($author$project$Request$Classifier$getChart, accessToken, classifierId, start, end));
				},
				$author$project$TimePeriod$resolve(timePeriod)));
	});
var $author$project$Page$Classifier$RunResults$add = F2(
	function (state, response) {
		return _Utils_update(
			state,
			{
				gD: response.gD,
				gH: _Utils_ap(state.gH, response.gH),
				gT: state.gT + response.gT,
				gW: state.gW + response.gW,
				gX: response.gW,
				gZ: state.gZ + response.gZ,
				g_: response.gZ,
				eQ: state.eQ + 1
			});
	});
var $author$project$Page$Classifier$Editor$maxRequestCount = 100;
var $elm$core$Process$sleep = _Process_sleep;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$View$Classifier$Drill2$Editor$encodePath = function (path) {
	var trimmed = $elm$core$String$trim(path);
	var containsEmptySegments = A2(
		$elm$core$List$any,
		function (s) {
			return $elm$core$String$isEmpty(s) || (s === '[]');
		},
		A2(
			$elm$core$List$drop,
			1,
			A2($elm$core$String$split, '.', trimmed)));
	return $elm$core$String$isEmpty(trimmed) ? $elm$core$Result$Err('Cannot have an empty key path') : ((!A2($elm$core$String$startsWith, '.', path)) ? $elm$core$Result$Err('Paths must start with a \'.\'') : (containsEmptySegments ? $elm$core$Result$Err('Paths cannot contain empty segments') : $elm$core$Result$Ok(trimmed)));
};
var $author$project$View$Classifier$Drill2$Editor$encodeDataType = function (dataType) {
	switch (dataType) {
		case 0:
			return $elm$core$Result$Ok(0);
		case 1:
			return $elm$core$Result$Ok(1);
		case 2:
			return $elm$core$Result$Ok(2);
		case 3:
			return $elm$core$Result$Ok(3);
		case 4:
			return $elm$core$Result$Ok(4);
		default:
			return $elm$core$Result$Err('can\'t encode an object operand type');
	}
};
var $author$project$View$Classifier$Drill2$Editor$encodeOp = function (op) {
	switch (op.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 0;
		default:
			return 4;
	}
};
var $author$project$View$Classifier$Drill2$Editor$validBoolValues = _List_fromArray(
	['true', 'false']);
var $author$project$View$Classifier$Drill2$Editor$encodeQueryValues = F2(
	function (dataType, op) {
		var validateNumber = function (val) {
			return A2($author$project$Util$Regex$contains, '^-?\\d+(\\.\\d+)?$', val) ? $elm$core$Result$Ok(val) : $elm$core$Result$Err(val + ' is not a valid number');
		};
		var validate = function (val) {
			switch (dataType) {
				case 0:
					return validateNumber(val);
				case 1:
					return $elm$core$String$isEmpty(val) ? $elm$core$Result$Err('All queries must have values') : $elm$core$Result$Ok(val);
				case 2:
					return A2($elm$core$List$member, val, $author$project$View$Classifier$Drill2$Editor$validBoolValues) ? $elm$core$Result$Ok(val) : $elm$core$Result$Err(val + ' is not a boolean value');
				case 3:
					return A2($author$project$Util$Regex$contains, '^\\d+(\\.\\d+)+$', val) ? $elm$core$Result$Ok(val) : $elm$core$Result$Err(val + ' is not a valid version number');
				case 4:
					return validateNumber(val);
				default:
					return $elm$core$Result$Err('can\'t encode an object operand type');
			}
		};
		var validateSingle = function (val) {
			return A2(
				$elm$core$Result$map,
				$elm$core$List$singleton,
				validate(
					$elm$core$String$trim(val)));
		};
		var getMultiValues = function (list) {
			return A2(
				$elm$core$Result$andThen,
				function (l) {
					return $elm$core$List$isEmpty(l) ? $elm$core$Result$Err('All queries must have values') : $elm$core$Result$Ok(l);
				},
				$elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						validate,
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							A2($elm$core$List$map, $elm$core$String$trim, list)))));
		};
		switch (op.$) {
			case 0:
				var val = op.a;
				return validateSingle(val);
			case 1:
				var val = op.a;
				return validateSingle(val);
			case 2:
				var val = op.a;
				return validateSingle(val);
			case 3:
				return $elm$core$Result$Ok(_List_Nil);
			case 4:
				var val = op.a;
				return validateSingle(val);
			case 5:
				var vals = op.a;
				return getMultiValues(vals);
			default:
				var vals = op.a;
				return getMultiValues(vals);
		}
	});
var $author$project$View$Classifier$Drill2$Editor$encodeQueryDetails = F2(
	function (key, details) {
		var valuesResult = A2($author$project$View$Classifier$Drill2$Editor$encodeQueryValues, details.dW, details.eB);
		var dataTypeResult = $author$project$View$Classifier$Drill2$Editor$encodeDataType(details.dW);
		var conditionResult = F2(
			function (dataType, values) {
				return {
					a7: details.a7,
					dW: dataType,
					en: key,
					ew: details.ew,
					eB: $author$project$View$Classifier$Drill2$Editor$encodeOp(details.eB),
					fe: values
				};
			});
		return A3($elm$core$Result$map2, conditionResult, dataTypeResult, valuesResult);
	});
var $author$project$View$Classifier$Drill2$Editor$encodeDrillQuery = function (query) {
	var encodePrimitive = function (details) {
		return A3(
			$elm$core$Result$map2,
			F2(
				function (p, c) {
					return {
						dQ: _List_fromArray(
							[c]),
						eF: p
					};
				}),
			$author$project$View$Classifier$Drill2$Editor$encodePath(details.eF),
			A2($author$project$View$Classifier$Drill2$Editor$encodeQueryDetails, '', details));
	};
	if (!query.$) {
		var details = query.a;
		return encodePrimitive(details);
	} else {
		if (query.b.b && (!query.b.b.b)) {
			var root = query.a;
			var _v1 = query.b;
			var details = _v1.a;
			return encodePrimitive(
				_Utils_update(
					details,
					{
						eF: _Utils_ap(root, details.eF)
					}));
		} else {
			var root = query.a;
			var detailList = query.b;
			var conditionsResult = $elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					function (d) {
						return A2(
							$elm$core$Result$andThen,
							function (p) {
								return A2($author$project$View$Classifier$Drill2$Editor$encodeQueryDetails, p, d);
							},
							$author$project$View$Classifier$Drill2$Editor$encodePath(d.eF));
					},
					detailList));
			return A3(
				$elm$core$Result$map2,
				F2(
					function (p, cs) {
						return {dQ: cs, eF: p};
					}),
				$author$project$View$Classifier$Drill2$Editor$encodePath(root),
				conditionsResult);
		}
	}
};
var $author$project$View$Classifier$Drill2$Editor$operationIsEmpty = function (op) {
	switch (op.$) {
		case 0:
			var val = op.a;
			return $elm$core$String$isEmpty(val);
		case 1:
			var val = op.a;
			return $elm$core$String$isEmpty(val);
		case 2:
			var val = op.a;
			return $elm$core$String$isEmpty(val);
		case 3:
			return true;
		case 4:
			var val = op.a;
			return $elm$core$String$isEmpty(val);
		case 5:
			var vals = op.a;
			return A2($elm$core$List$all, $elm$core$String$isEmpty, vals);
		default:
			var vals = op.a;
			return A2($elm$core$List$all, $elm$core$String$isEmpty, vals);
	}
};
var $author$project$View$Classifier$Drill2$Editor$queryDetailsAreEmpty = function (details) {
	return $elm$core$String$isEmpty(details.eF) && $author$project$View$Classifier$Drill2$Editor$operationIsEmpty(details.eB);
};
var $author$project$View$Classifier$Drill2$Editor$queryIsEmpty = function (query) {
	if (!query.$) {
		var details = query.a;
		return $author$project$View$Classifier$Drill2$Editor$queryDetailsAreEmpty(details);
	} else {
		var path = query.a;
		var detailList = query.b;
		return $elm$core$String$isEmpty(path) && A2($elm$core$List$all, $author$project$View$Classifier$Drill2$Editor$queryDetailsAreEmpty, detailList);
	}
};
var $author$project$View$Classifier$Drill2$Editor$getConfig = F2(
	function (model, label) {
		var reqiuireNonEmpty = function (queries) {
			return $elm$core$List$isEmpty(queries) ? $elm$core$Result$Err('must provide a query') : $elm$core$Result$Ok(queries);
		};
		var config = function (queries) {
			return $author$project$Data$Classifier$Drill2(
				{
					eo: label,
					eq: {a7: model.a7, de: queries}
				});
		};
		return A2(
			$elm$core$Result$map,
			config,
			A2(
				$elm$core$Result$andThen,
				reqiuireNonEmpty,
				$elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						$author$project$View$Classifier$Drill2$Editor$encodeDrillQuery,
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$View$Classifier$Drill2$Editor$queryIsEmpty),
							model.de)))));
	});
var $author$project$View$Classifier$FileRegex$Editor$getConfig = F2(
	function (model, label) {
		return $author$project$Data$Classifier$RegexClassifier(
			{cG: model.cG, eo: label, db: model.db});
	});
var $author$project$View$Classifier$Javascript$Editor$getConfig = F2(
	function (model, _v0) {
		return $author$project$Data$Classifier$Javascript(model.bs);
	});
var $author$project$View$Classifier$Random$Editor$getConfig = F2(
	function (model, label) {
		return $author$project$Data$Classifier$RandomClassifier(
			{eo: label, dc: model.dc});
	});
var $author$project$Page$Classifier$Editor$getConfig = function (model) {
	var label = A2($elm$core$Maybe$withDefault, '', model.eo);
	var _v0 = model.L;
	switch (_v0.$) {
		case 0:
			var m = _v0.a;
			return $elm$core$Result$Ok(
				A2($author$project$View$Classifier$Javascript$Editor$getConfig, m, label));
		case 1:
			var m = _v0.a;
			return A2($author$project$View$Classifier$Drill2$Editor$getConfig, m, label);
		case 2:
			var m = _v0.a;
			return $elm$core$Result$Ok(
				A2($author$project$View$Classifier$Random$Editor$getConfig, m, label));
		case 3:
			var m = _v0.a;
			return $elm$core$Result$Ok(
				A2($author$project$View$Classifier$FileRegex$Editor$getConfig, m, label));
		default:
			var s = _v0.a;
			return $elm$core$Result$Ok(
				$author$project$Data$Classifier$Unknown(s));
	}
};
var $author$project$Page$Classifier$Editor$isFileInputSpecEmpty = function (_v0) {
	var meta = _v0.er;
	var _v1 = meta.c_;
	if (_v1.$ === 1) {
		var pattern = _v1.a;
		return $elm$core$String$isEmpty(pattern);
	} else {
		return false;
	}
};
var $author$project$Page$Classifier$Editor$isRegexClassifierWithEmptyPattern = function (_v0) {
	var content = _v0.L;
	if (content.$ === 3) {
		var pattern = content.a.db;
		return $elm$core$String$isEmpty(pattern);
	} else {
		return false;
	}
};
var $author$project$Page$Classifier$Editor$validateCore = function (model) {
	return $author$project$Page$Classifier$Editor$isFileInputSpecEmpty(model) ? $elm$core$Result$Err('The \'Filename Glob\' on the \'Meta\' tab must not be empty') : ($author$project$Page$Classifier$Editor$isRegexClassifierWithEmptyPattern(model) ? $elm$core$Result$Err('The regex \'Pattern\' on the \'Content\' tab must not be empty') : $author$project$Page$Classifier$Editor$getConfig(model));
};
var $author$project$Page$Classifier$Editor$validateBeforeRun = function (model) {
	return A2(
		$elm$core$Result$mapError,
		$elm$core$List$singleton,
		$author$project$Page$Classifier$Editor$validateCore(model));
};
var $author$project$Page$Classifier$Editor$handleRunPageCompleted = F2(
	function (res, model) {
		var numReturned = res.gW + res.gT;
		var newRunResults = A2($author$project$Page$Classifier$RunResults$add, model.t, res);
		var totalReturned = newRunResults.gW + newRunResults.gT;
		var shouldRequestAgain = (_Utils_cmp(newRunResults.eQ, $author$project$Page$Classifier$Editor$maxRequestCount) < 0) && ((res.gZ > 0) && ((!numReturned) || (totalReturned < 25)));
		var newOutput = function () {
			if (shouldRequestAgain) {
				var _v0 = $author$project$Page$Classifier$Editor$validateBeforeRun(model);
				if (!_v0.$) {
					var config = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f$: _List_Nil, t: newRunResults, h: 1}),
						A2(
							$elm$core$Task$attempt,
							$author$project$Page$Classifier$Editor$RunPageCompleted,
							A2(
								$elm$core$Task$andThen,
								function (_v1) {
									return $elm$http$Http$toTask(
										A4($author$project$Page$Classifier$Editor$classifyPageRequest, model.a, model.er, config, res.gD));
								},
								$elm$core$Process$sleep(100.0))));
				} else {
					var errors = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f$: errors, t: newRunResults, h: 0}),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{t: newRunResults, h: 0}),
					$elm$core$Platform$Cmd$none);
			}
		}();
		return (model.h === 1) ? newOutput : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$UUID$isEqual = F2(
	function (_this, that) {
		return _Utils_eq(
			$author$project$UUID$toString(_this),
			$author$project$UUID$toString(that));
	});
var $author$project$Page$Classifier$Editor$isRunning = function (model) {
	var _v0 = model.h;
	if (!_v0) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$Classifier$Editor$CompletedKeyPathsLoad = function (a) {
	return {$: 20, a: a};
};
var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
	if (!data.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Classifier$Editor$maybeLazyLoadKeyPaths = function (_v0) {
	var model = _v0.a;
	var msg = _v0.b;
	return $krisajenkins$remotedata$RemoteData$isNotAsked(model.aM) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{aM: $krisajenkins$remotedata$RemoteData$Loading}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$http$Http$send,
					$author$project$Page$Classifier$Editor$CompletedKeyPathsLoad,
					$author$project$Request$Incident$getKeyPaths(model.a)),
					msg
				]))) : _Utils_Tuple2(model, msg);
};
var $author$project$Request$Classifier$save = F3(
	function (accessToken, meta, config) {
		var responseDecoder = A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			A2($author$project$Data$Classifier$encode, meta, config));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/classifiers',
				hU: false
			});
	});
var $author$project$Page$Classifier$DisplayFilter$setHelpshiftOnly = F2(
	function (displayFilter, helpshiftOnly) {
		return _Utils_update(
			displayFilter,
			{cR: helpshiftOnly});
	});
var $author$project$Page$Classifier$DisplayFilter$setPlatform = F2(
	function (displayFilter, platform) {
		return _Utils_update(
			displayFilter,
			{g6: platform});
	});
var $author$project$Page$Classifier$Editor$Drill2Msg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Classifier$Editor$FileRegexMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Classifier$Editor$JavascriptMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Classifier$Editor$RandomMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateContent = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$ObjectType = 5;
var $author$project$View$Classifier$Drill2$Editor$gracefullyChangeDataType = F2(
	function (oldDetails, newDataType) {
		return _Utils_update(
			oldDetails,
			{
				dW: newDataType,
				eB: function () {
					if (newDataType === 2) {
						return A2(
							$elm$core$List$member,
							oldDetails.eB,
							A2($elm$core$List$map, $author$project$View$Classifier$Drill2$Editor$Eq, $author$project$View$Classifier$Drill2$Editor$validBoolValues)) ? oldDetails.eB : $author$project$View$Classifier$Drill2$Editor$defaultOp(2);
					} else {
						return oldDetails.eB;
					}
				}()
			});
	});
var $author$project$View$Classifier$Drill2$Editor$queryIndex = function (index) {
	if (!index.$) {
		var i = index.a;
		return i;
	} else {
		var i = index.a;
		return i;
	}
};
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var tail = $elm$core$List$tail(
				A2($elm$core$List$drop, index, l));
			var head = A2($elm$core$List$take, index, l);
			if (tail.$ === 1) {
				return l;
			} else {
				var t = tail.a;
				return A2($elm$core$List$append, head, t);
			}
		}
	});
var $author$project$View$Classifier$Drill2$Editor$update = F2(
	function (msg, model) {
		var updateQuery = F2(
			function (i, mapper) {
				return _Utils_update(
					model,
					{
						de: A3($elm_community$list_extra$List$Extra$updateAt, i, mapper, model.de)
					});
			});
		var updateObjectQuery = F2(
			function (i, mapper) {
				return A2(
					updateQuery,
					i,
					function (q) {
						if (q.$ === 1) {
							var p = q.a;
							var ds = q.b;
							return A2(
								$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
								p,
								mapper(ds));
						} else {
							var other = q;
							return other;
						}
					});
			});
		var updateDetails = F2(
			function (index, mapper) {
				return A2(
					updateQuery,
					$author$project$View$Classifier$Drill2$Editor$queryIndex(index),
					function (q) {
						var _v10 = _Utils_Tuple2(q, index);
						_v10$2:
						while (true) {
							if (!_v10.a.$) {
								if (!_v10.b.$) {
									var d = _v10.a.a;
									return $author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(
										mapper(d));
								} else {
									break _v10$2;
								}
							} else {
								if (_v10.b.$ === 1) {
									var _v11 = _v10.a;
									var path = _v11.a;
									var ds = _v11.b;
									var _v12 = _v10.b;
									var i = _v12.b;
									return A2(
										$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
										path,
										A3($elm_community$list_extra$List$Extra$updateAt, i, mapper, ds));
								} else {
									break _v10$2;
								}
							}
						}
						return q;
					});
			});
		var deleteValueFromList = F2(
			function (i, vals) {
				var trimmed = A2($elm_community$list_extra$List$Extra$removeAt, i, vals);
				return ($elm$core$List$length(trimmed) < 2) ? _Utils_ap(
					trimmed,
					_List_fromArray(
						[''])) : trimmed;
			});
		var deleteMultiValue = F2(
			function (i, op) {
				switch (op.$) {
					case 5:
						var vals = op.a;
						return $author$project$View$Classifier$Drill2$Editor$MultiEq(
							A2(deleteValueFromList, i, vals));
					case 6:
						var vals = op.a;
						return $author$project$View$Classifier$Drill2$Editor$MultiSubstr(
							A2(deleteValueFromList, i, vals));
					default:
						var o = op;
						return o;
				}
			});
		var defaultObjQueryDetails = _List_fromArray(
			[
				A4($author$project$View$Classifier$Drill2$Editor$defaultQueryDetails, '', 1, $elm$core$Maybe$Nothing, 1)
			]);
		switch (msg.$) {
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							de: _Utils_ap(
								model.de,
								_List_fromArray(
									[
										A2($author$project$View$Classifier$Drill2$Editor$defaultQuery, '', 1)
									]))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var index = msg.a;
				var queries = ($elm$core$List$length(model.de) <= 1) ? _List_fromArray(
					[
						A2($author$project$View$Classifier$Drill2$Editor$defaultQuery, '', 1)
					]) : A2($elm_community$list_extra$List$Extra$removeAt, index, model.de);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{de: queries}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				var path = msg.b;
				var trimmedPath = $elm$core$String$trim(path);
				var newPath = ($elm$core$String$isEmpty(trimmedPath) || A2($elm$core$String$startsWith, '.', trimmedPath)) ? trimmedPath : ('.' + trimmedPath);
				var newQuery = function (query) {
					var _v1 = _Utils_Tuple2(index, query);
					if (!_v1.a.$) {
						if (!_v1.b.$) {
							var d = _v1.b.a;
							return $author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(
								_Utils_update(
									d,
									{eF: newPath}));
						} else {
							var _v2 = _v1.b;
							var d = _v2.b;
							return A2($author$project$View$Classifier$Drill2$Editor$ObjectQuery, newPath, d);
						}
					} else {
						if (_v1.b.$ === 1) {
							var _v3 = _v1.a;
							var i = _v3.b;
							var _v4 = _v1.b;
							var p = _v4.a;
							var ds = _v4.b;
							return A2(
								$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
								p,
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									i,
									function (d) {
										return _Utils_update(
											d,
											{eF: newPath});
									},
									ds));
						} else {
							return query;
						}
					}
				};
				return _Utils_Tuple2(
					A2(
						updateQuery,
						$author$project$View$Classifier$Drill2$Editor$queryIndex(index),
						newQuery),
					$elm$core$Platform$Cmd$none);
			case 0:
				var combiner = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a7: combiner}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var index = msg.a;
				var dataType = msg.b;
				var updateTopLevelIndex = function (oldQuery) {
					if (dataType === 5) {
						if (!oldQuery.$) {
							var path = oldQuery.a.eF;
							return A2($author$project$View$Classifier$Drill2$Editor$defaultQuery, path, dataType);
						} else {
							return oldQuery;
						}
					} else {
						if (!oldQuery.$) {
							var d = oldQuery.a;
							return $author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(
								A2($author$project$View$Classifier$Drill2$Editor$gracefullyChangeDataType, d, dataType));
						} else {
							var path = oldQuery.a;
							return A2($author$project$View$Classifier$Drill2$Editor$defaultQuery, path, dataType);
						}
					}
				};
				var updateObjectIndex = function (d) {
					return _Utils_update(
						d,
						{dW: dataType});
				};
				var newModel = function () {
					if (!index.$) {
						var i = index.a;
						return A2(updateQuery, i, updateTopLevelIndex);
					} else {
						return A2(updateDetails, index, updateObjectIndex);
					}
				}();
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 5:
				var index = msg.a;
				var _v8 = msg.b;
				var op = _v8.a;
				var negate = _v8.b;
				var combiner = _v8.c;
				return _Utils_Tuple2(
					A2(
						updateDetails,
						index,
						function (d) {
							return _Utils_update(
								d,
								{a7: combiner, ew: negate, eB: op});
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var op = msg.b;
				return _Utils_Tuple2(
					A2(
						updateDetails,
						index,
						function (d) {
							return _Utils_update(
								d,
								{eB: op});
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var i = msg.b;
				return _Utils_Tuple2(
					A2(
						updateDetails,
						index,
						function (d) {
							return _Utils_update(
								d,
								{
									eB: A2(deleteMultiValue, i, d.eB)
								});
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var i = msg.a;
				return _Utils_Tuple2(
					A2(
						updateObjectQuery,
						i,
						function (ds) {
							return _Utils_ap(ds, defaultObjQueryDetails);
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var i = msg.a;
				var j = msg.b;
				return _Utils_Tuple2(
					A2(
						updateObjectQuery,
						i,
						function (l) {
							return ($elm$core$List$length(l) <= 1) ? defaultObjQueryDetails : A2($elm_community$list_extra$List$Extra$removeAt, j, l);
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$Classifier$FileRegex$Editor$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cv: !model.cv}),
				$elm$core$Platform$Cmd$none);
		} else {
			var pattern = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{db: pattern}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$Classifier$Javascript$Editor$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var jsCode = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bs: jsCode}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cv: !model.cv}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$Classifier$Random$Editor$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cv: !model.cv}),
				$elm$core$Platform$Cmd$none);
		} else {
			var percentChance = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dc: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(percentChance))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Classifier$Editor$updateContent = F2(
	function (msg, model) {
		var makeMsg = F5(
			function (contentType, toMsg, subUpdate, subMsg, subModel) {
				var _v1 = A2(subUpdate, subMsg, subModel);
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							L: contentType(newModel)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Page$Classifier$Editor$UpdateContent, toMsg),
						newCmd));
			});
		var _v0 = _Utils_Tuple2(msg, model.L);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(makeMsg, $author$project$Page$Classifier$Editor$JavascriptContent, $author$project$Page$Classifier$Editor$JavascriptMsg, $author$project$View$Classifier$Javascript$Editor$update, subMsg, subModel);
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(makeMsg, $author$project$Page$Classifier$Editor$Drill2Content, $author$project$Page$Classifier$Editor$Drill2Msg, $author$project$View$Classifier$Drill2$Editor$update, subMsg, subModel);
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(makeMsg, $author$project$Page$Classifier$Editor$RandomContent, $author$project$Page$Classifier$Editor$RandomMsg, $author$project$View$Classifier$Random$Editor$update, subMsg, subModel);
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 3) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(makeMsg, $author$project$Page$Classifier$Editor$FileRegexContent, $author$project$Page$Classifier$Editor$FileRegexMsg, $author$project$View$Classifier$FileRegex$Editor$update, subMsg, subModel);
					} else {
						break _v0$4;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Classifier$Editor$isLabelEmpty = function (model) {
	return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $elm$core$String$isEmpty, model.eo);
};
var $author$project$Page$Classifier$Editor$validateBeforeSave = function (model) {
	var errs = $elm$core$String$isEmpty(model.er.bO) ? _List_fromArray(
		['The \'Title\' on the \'Meta\' tab must not be empty']) : ($author$project$Page$Classifier$Editor$isLabelEmpty(model) ? _List_fromArray(
		['The \'Label\' on the \'Meta\' tab must not be empty']) : _List_Nil);
	return A2(
		$elm$core$Result$andThen,
		function (r) {
			return $elm$core$List$isEmpty(errs) ? $elm$core$Result$Ok(r) : $elm$core$Result$Err(errs);
		},
		A2(
			$elm$core$Result$mapError,
			function (e) {
				return A2($elm$core$List$cons, e, errs);
			},
			$author$project$Page$Classifier$Editor$validateCore(model)));
};
var $author$project$Page$Classifier$Editor$update = F3(
	function (navKey, msg, model) {
		var updateMeta = function (f) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						er: f(model.er)
					}),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var tab = msg.a;
				return $author$project$Page$Classifier$Editor$maybeLazyLoadKeyPaths(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{av: tab}),
						$elm$core$Platform$Cmd$none));
			case 5:
				var newTitle = msg.a;
				return updateMeta(
					function (def) {
						return _Utils_update(
							def,
							{bO: newTitle});
					});
			case 1:
				var newEnabled = msg.a;
				return updateMeta(
					function (def) {
						return _Utils_update(
							def,
							{cM: newEnabled});
					});
			case 2:
				var newDiscard = msg.a;
				return updateMeta(
					function (def) {
						return _Utils_update(
							def,
							{cJ: newDiscard});
					});
			case 7:
				var newDescription = msg.a;
				return updateMeta(
					function (def) {
						return _Utils_update(
							def,
							{b6: newDescription});
					});
			case 6:
				var newPattern = msg.a;
				return updateMeta(
					function (def) {
						return _Utils_update(
							def,
							{
								c_: $author$project$Data$Classifier$FileSpec(newPattern)
							});
					});
			case 8:
				var label = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eo: $elm$core$Maybe$Just(label)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var subMsg = msg.a;
				return $author$project$Page$Classifier$Editor$maybeLazyLoadKeyPaths(
					A2($author$project$Page$Classifier$Editor$updateContent, subMsg, model));
			case 10:
				if ($author$project$Page$Classifier$Editor$isRunning(model)) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v1 = $author$project$Page$Classifier$Editor$validateBeforeRun(model);
					if (!_v1.$) {
						var config = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{f$: _List_Nil, t: $author$project$Page$Classifier$RunResults$init, h: 1}),
							A2(
								$elm$http$Http$send,
								$author$project$Page$Classifier$Editor$RunPageCompleted,
								A4($author$project$Page$Classifier$Editor$classifyPageRequest, model.a, model.er, config, $elm$core$Maybe$Nothing)));
					} else {
						var errors = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{f$: errors}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 11:
				var httpResult = msg.a;
				if (!httpResult.$) {
					var res = httpResult.a;
					return A2($author$project$Page$Classifier$Editor$handleRunPageCompleted, res, model);
				} else {
					var e = httpResult.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							_Utils_update(
								model,
								{h: 0}),
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(e)
								])),
						$elm$core$Platform$Cmd$none);
				}
			case 12:
				var _v3 = $author$project$Page$Classifier$Editor$validateBeforeSave(model);
				if (!_v3.$) {
					var config = _v3.a;
					var oldMeta = model.er;
					var newMeta = _Utils_update(
						oldMeta,
						{dx: oldMeta.dx + 1});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f$: _List_Nil, h: 2}),
						A2(
							$elm$http$Http$send,
							$author$project$Page$Classifier$Editor$SaveCompleted,
							A3($author$project$Request$Classifier$save, model.a, newMeta, config)));
				} else {
					var errors = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f$: errors}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var httpResult = msg.a;
				var newModel = _Utils_update(
					model,
					{h: 0});
				if (!httpResult.$) {
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{f$: _List_Nil}),
						A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListClassifiers));
				} else {
					var error = httpResult.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							newModel,
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(error)
								])),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h: (model.h === 1) ? 0 : model.h
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cv: !model.cv}),
					$elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var _v5 = msg.a;
				var bottom = _v5.a;
				var height = _v5.b;
				var atBottom = _Utils_cmp(bottom, height) > -1;
				var shouldRequestPage = atBottom && ((model.t.gX > 0) && ((model.av === 2) && (!model.h)));
				if (shouldRequestPage) {
					var _v6 = $author$project$Page$Classifier$Editor$validateBeforeRun(model);
					if (!_v6.$) {
						var config = _v6.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{f$: _List_Nil, h: 1}),
							A2(
								$elm$http$Http$send,
								$author$project$Page$Classifier$Editor$RunPageCompleted,
								A4($author$project$Page$Classifier$Editor$classifyPageRequest, model.a, model.er, config, model.t.gD)));
					} else {
						var errors = _v6.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{f$: errors, h: 0}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 18:
				var timePeriod = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fC: $author$project$Page$Classifier$Editor$ChartLoading}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$Classifier$Editor$CompletedChartLoad,
						A3($author$project$Page$Classifier$Editor$fetchChart, model.a, model.er.bj, timePeriod)));
			case 19:
				if (!msg.a.$) {
					var chart = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fC: $author$project$Page$Classifier$Editor$ChartLoaded(chart)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fC: $author$project$Page$Classifier$Editor$ChartFailed}),
						$elm$core$Platform$Cmd$none);
				}
			case 20:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aM: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 21:
				var helpshiftOnly = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A2($author$project$Page$Classifier$DisplayFilter$setHelpshiftOnly, model.af, helpshiftOnly)
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var platform = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A2($author$project$Page$Classifier$DisplayFilter$setPlatform, model.af, platform)
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$App$Route$pushUrlCmd,
						navKey,
						$author$project$App$Route$EditClassifier(model.er.bj)));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: 2}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: 0}),
					$elm$core$Platform$Cmd$none);
			case 24:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: 1}),
					$elm$core$Platform$Cmd$none);
			case 25:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: 0, ab: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 26:
				var uuidString = msg.a;
				var groups = A2(
					$elm$core$List$map,
					function ($) {
						return $.gb;
					},
					model.gc);
				var group = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Maybe$Nothing,
					function (id) {
						return A2(
							$elm_community$list_extra$List$Extra$find,
							function (g) {
								return A2($author$project$UUID$isEqual, g.bj, id);
							},
							groups);
					},
					$author$project$UUID$fromString(uuidString));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ab: group}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var group = msg.a;
				var addToGroup = $elm$http$Http$toTask(
					A3($author$project$Request$Group$addClassifier, model.a, group.bj, model.er.bj));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h: 2}),
					A2($elm$core$Task$attempt, $author$project$Page$Classifier$Editor$AddToGroupCompleted, addToGroup));
			default:
				var result = msg.a;
				if (!result.$) {
					var value = result.a;
					var updatedGroups = A2(
						$elm$core$List$map,
						function (g) {
							return A2($author$project$UUID$isEqual, g.gb.bj, value.gb.bj) ? _Utils_update(
								g,
								{gq: true}) : g;
						},
						model.gc);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gc: updatedGroups, S: 0, h: 0, ab: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							_Utils_update(
								model,
								{h: 0}),
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(error)
								])),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Classifier$List$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 5:
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bL: filter}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bl: filter}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var sort = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bJ: sort}),
					$elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: !model.ak}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var classifierId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ap: function () {
								var _v1 = model.ap;
								if (!_v1.$) {
									var id = _v1.a;
									return _Utils_eq(id, classifierId) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(classifierId);
								} else {
									return $elm$core$Maybe$Just(classifierId);
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bG: text}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Configuration$Editor$Failed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Configuration$Editor$Loaded = function (a) {
	return {$: 3, a: a};
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Page$Configuration$Editor$adjustColumns = F2(
	function (groups, existingColumns) {
		var numExtra = $elm$core$List$length(existingColumns) - $elm$core$List$length(groups);
		return (numExtra > 0) ? A2(
			$elm$core$List$take,
			$elm$core$List$length(groups),
			existingColumns) : ((numExtra < 0) ? _Utils_ap(
			existingColumns,
			A2(
				$elm$core$List$repeat,
				-numExtra,
				{ev: '', fg: 2})) : existingColumns);
	});
var $author$project$Page$Configuration$Editor$DebounceTimerFired = {$: 15};
var $author$project$Page$Configuration$Editor$Loading = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Configuration$Editor$Waiting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Configuration$Editor$debounceMillis = 200;
var $author$project$Page$Configuration$Editor$debouncedRefreshPreview = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var startTimer = function (existingData) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					v: $author$project$Page$Configuration$Editor$Waiting(existingData)
				}),
			A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always($author$project$Page$Configuration$Editor$DebounceTimerFired),
				$elm$core$Process$sleep($author$project$Page$Configuration$Editor$debounceMillis)));
	};
	var nop = _Utils_Tuple2(model, cmd);
	var bufferAnotherRequest = F2(
		function (maybeExistingData, numBuffered) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						v: A2($author$project$Page$Configuration$Editor$Loading, maybeExistingData, numBuffered + 1)
					}),
				$elm$core$Platform$Cmd$none);
		});
	var _v1 = model.v;
	switch (_v1.$) {
		case 0:
			return startTimer($elm$core$Maybe$Nothing);
		case 1:
			return nop;
		case 2:
			var maybeExistingData = _v1.a;
			var numBuffered = _v1.b;
			return A2(bufferAnotherRequest, maybeExistingData, numBuffered);
		case 3:
			var existingData = _v1.a;
			return startTimer(
				$elm$core$Maybe$Just(existingData));
		default:
			return startTimer($elm$core$Maybe$Nothing);
	}
};
var $author$project$Page$Configuration$Editor$CaptureGroup = function (pattern) {
	return {db: pattern};
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm_community$string_extra$String$Extra$firstResultHelp = F2(
	function (_default, list) {
		firstResultHelp:
		while (true) {
			if (!list.b) {
				return _default;
			} else {
				if (!list.a.$) {
					var a = list.a.a;
					return a;
				} else {
					var _v1 = list.a;
					var rest = list.b;
					var $temp$default = _default,
						$temp$list = rest;
					_default = $temp$default;
					list = $temp$list;
					continue firstResultHelp;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$firstResult = function (list) {
	return A2($elm_community$string_extra$String$Extra$firstResultHelp, '', list);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$regexEscape = A2(
	$elm$regex$Regex$replace,
	$elm_community$string_extra$String$Extra$regexFromString('[-/\\^$*+?.()|[\\]{}]'),
	function (_v0) {
		var match = _v0.gG;
		return '\\' + match;
	});
var $elm_community$string_extra$String$Extra$leftOf = F2(
	function (pattern, string) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hs;
					},
					$elm_community$string_extra$String$Extra$firstResult),
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					$elm_community$string_extra$String$Extra$regexFromString(
						'^(.*?)' + $elm_community$string_extra$String$Extra$regexEscape(pattern)),
					string)));
	});
var $author$project$Page$Configuration$Editor$extractCaptureGroups = function (regex) {
	return A2(
		$elm$core$List$drop,
		1,
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$string_extra$String$Extra$leftOf(')'),
				$author$project$Page$Configuration$Editor$CaptureGroup),
			A2($elm$core$String$split, '(', regex)));
};
var $author$project$Page$Configuration$Editor$handleSaveResult = F3(
	function (model, httpResult, navKey) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil}),
				A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListLogConfigs));
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Configuration$Editor$PreviewCompleted = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Configuration$Editor$accessExistingData = function (previewState) {
	switch (previewState.$) {
		case 3:
			var response = previewState.a;
			return $elm$core$Maybe$Just(response);
		case 1:
			var maybeExistingData = previewState.a;
			return maybeExistingData;
		case 2:
			var maybeExistingData = previewState.a;
			return maybeExistingData;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$LogFile$TryConfigRequest = F2(
	function (def, exampleLines) {
		return {dZ: def, d8: exampleLines};
	});
var $author$project$Data$LogFile$encodeWidget = function (widget) {
	switch (widget) {
		case 0:
			return $elm$json$Json$Encode$string('time');
		case 1:
			return $elm$json$Json$Encode$string('dropdown');
		case 2:
			return $elm$json$Json$Encode$string('search');
		default:
			return $elm$json$Json$Encode$string('none');
	}
};
var $author$project$Data$LogFile$encodeColumn = function (column) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(column.ev)),
				_Utils_Tuple2(
				'widget',
				$author$project$Data$LogFile$encodeWidget(column.fg))
			]));
};
var $author$project$Data$LogFile$encodePartialDef = function (def) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$UUID$encode(def.bj)),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$int(def.dx)),
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(def.cM)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(def.b6)),
				_Utils_Tuple2(
				'filePatterns',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, def.cc)),
				_Utils_Tuple2(
				'platforms',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, def.cn)),
				_Utils_Tuple2(
				'columns',
				A2($elm$json$Json$Encode$list, $author$project$Data$LogFile$encodeColumn, def.b0)),
				_Utils_Tuple2(
				'regex',
				$elm$json$Json$Encode$string(def.cp)),
				_Utils_Tuple2(
				'dateFormat',
				$elm$json$Json$Encode$string(def.b4))
			]));
};
var $author$project$Data$LogFile$encodeTryRequest = function (_v0) {
	var def = _v0.dZ;
	var exampleLines = _v0.d8;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'def',
				$author$project$Data$LogFile$encodePartialDef(def)),
				_Utils_Tuple2(
				'exampleLogLines',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, exampleLines))
			]));
};
var $author$project$Data$LogFile$TryConfigResponse = function (parsedLines) {
	return {g4: parsedLines};
};
var $author$project$Data$LogFile$tryResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parsedLines',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$succeed($author$project$Data$LogFile$TryConfigResponse));
var $author$project$Request$LogFile$tryConfig = F3(
	function (accessToken, def, exampleLines) {
		var url = '/gym/logs/try/';
		var responseDecoder = $author$project$Data$LogFile$tryResponseDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$LogFile$encodeTryRequest(
				A2($author$project$Data$LogFile$TryConfigRequest, def, exampleLines)));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $elm_community$string_extra$String$Extra$isBlank = function (string) {
	return A2(
		$elm$regex$Regex$contains,
		$elm_community$string_extra$String$Extra$regexFromString('^\\s*$'),
		string);
};
var $author$project$Page$Configuration$Editor$validate = function (model) {
	var validationErrors = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm_community$string_extra$String$Extra$isBlank(model.cp) ? $elm$core$Maybe$Just('Regex cannot be blank') : $elm$core$Maybe$Nothing,
				_Utils_eq(
				$elm$regex$Regex$fromString(model.cp),
				$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Invalid regex') : $elm$core$Maybe$Nothing
			]));
	return $elm$core$List$isEmpty(validationErrors) ? $elm$core$Result$Ok(
		{
			b0: model.b0,
			b4: model.b4,
			b6: model.b6,
			cM: model.bp,
			cc: A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, ',', model.bf)),
			bj: model.bj,
			cn: A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, ',', model.g6)),
			cp: model.cp,
			dx: model.dx
		}) : $elm$core$Result$Err(
		A2($elm$core$String$join, '\n', validationErrors));
};
var $author$project$Page$Configuration$Editor$refreshPreviewNow = function (model) {
	var _v0 = $author$project$Page$Configuration$Editor$validate(model);
	if (!_v0.$) {
		var def = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					v: A2(
						$author$project$Page$Configuration$Editor$Loading,
						$author$project$Page$Configuration$Editor$accessExistingData(model.v),
						0)
				}),
			A2(
				$elm$http$Http$send,
				$author$project$Page$Configuration$Editor$PreviewCompleted,
				A3($author$project$Request$LogFile$tryConfig, model.a, def, model.d8)));
	} else {
		var error = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					v: $author$project$Page$Configuration$Editor$Failed('Preview is disabled until all validation errors have been fixed: ' + error)
				}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Page$Configuration$Editor$SaveCompleted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Request$LogFile$saveConfig = F2(
	function (accessToken, def) {
		var responseDecoder = $elm$json$Json$Decode$succeed(0);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$LogFile$encodePartialDef(def));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/logs/configurations',
				hU: false
			});
	});
var $author$project$Page$Configuration$Editor$save = F2(
	function (model, newConfig) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil, cg: true}),
			A2(
				$elm$core$Task$attempt,
				$author$project$Page$Configuration$Editor$SaveCompleted,
				$elm$http$Http$toTask(
					A2(
						$author$project$Request$LogFile$saveConfig,
						model.a,
						_Utils_update(
							newConfig,
							{dx: newConfig.dx + 1})))));
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Util$Regex$find = F2(
	function (pattern, haystack) {
		return A2(
			$elm$regex$Regex$find,
			$author$project$Util$Regex$regex(pattern),
			haystack);
	});
var $author$project$Page$Configuration$Editor$regexMatchesEntireLine = F2(
	function (regex, exampleLine) {
		var _v0 = $elm$core$List$head(
			A2($author$project$Util$Regex$find, regex, exampleLine));
		if (!_v0.$) {
			var match = _v0.a.gG;
			return _Utils_eq(match, exampleLine);
		} else {
			return false;
		}
	});
var $author$project$Page$Configuration$Editor$validateStrict = F2(
	function (exampleLines, def) {
		var validationErrors = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm_community$string_extra$String$Extra$isBlank(def.b6) ? $elm$core$Maybe$Just('The \'description\' must not be blank') : $elm$core$Maybe$Nothing,
					(!A2(
					$elm$core$List$all,
					$author$project$Page$Configuration$Editor$regexMatchesEntireLine(def.cp),
					exampleLines)) ? $elm$core$Maybe$Just('Your regex pattern must match the *entire* example log line') : $elm$core$Maybe$Nothing
				]));
		return $elm$core$List$isEmpty(validationErrors) ? $elm$core$Result$Ok(def) : $elm$core$Result$Err(
			A2($elm$core$String$join, '\n', validationErrors));
	});
var $author$project$Page$Configuration$Editor$validateAndSave = function (model) {
	var _v0 = A2(
		$elm$core$Result$andThen,
		$author$project$Page$Configuration$Editor$validateStrict(model.d8),
		$author$project$Page$Configuration$Editor$validate(model));
	if (!_v0.$) {
		var def = _v0.a;
		return A2($author$project$Page$Configuration$Editor$save, model, def);
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					f$: _List_fromArray(
						[e])
				}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Page$Configuration$Editor$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var dialog = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b7: dialog}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return $author$project$Page$Configuration$Editor$validateAndSave(model);
			case 3:
				var result = msg.a;
				return A3($author$project$Page$Configuration$Editor$handleSaveResult, model, result, navKey);
			case 4:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: str}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bf: str}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g6: str}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bp: bool}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var regex = msg.a;
				return $author$project$Page$Configuration$Editor$debouncedRefreshPreview(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								b0: A2(
									$author$project$Page$Configuration$Editor$adjustColumns,
									$author$project$Page$Configuration$Editor$extractCaptureGroups(regex),
									model.b0),
								cp: regex
							}),
						$elm$core$Platform$Cmd$none));
			case 9:
				var str = msg.a;
				return $author$project$Page$Configuration$Editor$debouncedRefreshPreview(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								d8: A2($elm$core$String$split, '\n', str)
							}),
						$elm$core$Platform$Cmd$none));
			case 12:
				var fmt = msg.a;
				return $author$project$Page$Configuration$Editor$debouncedRefreshPreview(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{b4: fmt}),
						$elm$core$Platform$Cmd$none));
			case 10:
				var idx = msg.a;
				var newName = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b0: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								idx,
								function (oldColumn) {
									return _Utils_update(
										oldColumn,
										{ev: newName});
								},
								model.b0)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var idx = msg.a;
				var newWidget = msg.b;
				return $author$project$Page$Configuration$Editor$debouncedRefreshPreview(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								b0: A3(
									$elm_community$list_extra$List$Extra$updateAt,
									idx,
									function (oldColumn) {
										return _Utils_update(
											oldColumn,
											{fg: newWidget});
									},
									model.b0)
							}),
						$elm$core$Platform$Cmd$none));
			case 13:
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bD: tab}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return $author$project$Page$Configuration$Editor$refreshPreviewNow(model);
			default:
				var result = msg.a;
				var numBufferedRequests = function () {
					var _v2 = model.v;
					if (_v2.$ === 2) {
						var numBuffered = _v2.b;
						return numBuffered;
					} else {
						return 0;
					}
				}();
				var newPreviewState = function () {
					if (!result.$) {
						var response = result.a;
						return $author$project$Page$Configuration$Editor$Loaded(response);
					} else {
						var error = result.a;
						return $author$project$Page$Configuration$Editor$Failed(
							$author$project$Util$Http$errorToString(error));
					}
				}();
				return (numBufferedRequests > 0) ? $author$project$Page$Configuration$Editor$refreshPreviewNow(
					_Utils_update(
						model,
						{v: newPreviewState})) : _Utils_Tuple2(
					_Utils_update(
						model,
						{v: newPreviewState}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Configuration$List$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bL: filter}),
					$elm$core$Platform$Cmd$none);
			default:
				var sort = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bJ: sort}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$App$Route$replaceUrlCmd = function (key) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$App$Route$routeToString,
		$elm$browser$Browser$Navigation$replaceUrl(key));
};
var $author$project$Page$Docs$update = F3(
	function (navKey, msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{f$: _List_Nil}),
				$elm$core$Platform$Cmd$none);
		} else {
			var section = msg.a;
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$App$Route$replaceUrlCmd,
					navKey,
					$author$project$App$Route$ViewDocs(
						$elm$core$Maybe$Just(section))));
		}
	});
var $author$project$Page$Group$GroupCreator$SaveCompleted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Request$Group$create = F3(
	function (accessToken, name, description) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					])));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson($author$project$Data$Group$groupDetailResponseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/groups',
				hU: false
			});
	});
var $author$project$Page$Group$GroupCreator$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ev: name}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var description = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: description}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var saveCmd = A2(
					$elm$http$Http$send,
					$author$project$Page$Group$GroupCreator$SaveCompleted,
					A3($author$project$Request$Group$create, model.a, model.ev, model.b6));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: true}),
					saveCmd);
			default:
				var result = msg.a;
				if (!result.$) {
					var value = result.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$App$Route$pushUrlCmd,
							navKey,
							$author$project$App$Route$ViewGroup(value.gb.bj)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cd: $elm$core$Maybe$Just(error),
								cg: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Group$GroupEditor$SaveCompleted = function (a) {
	return {$: 5, a: a};
};
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Request$Group$update = F5(
	function (accessToken, id, name, description, tenantsToAdd) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description)),
						_Utils_Tuple2(
						'tenantsToAdd',
						A2($elm$json$Json$Encode$list, $author$project$UUID$encode, tenantsToAdd))
					])));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson($author$project$Data$Group$groupDetailResponseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/groups/' + $author$project$UUID$toString(id),
				hU: false
			});
	});
var $author$project$Page$Group$GroupEditor$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ev: name}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var description = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: description}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var uuidString = msg.a;
				var _v1 = $author$project$UUID$fromString(uuidString);
				if (!_v1.$) {
					var value = _v1.a;
					var maybeTenant = A2(
						$elm_community$list_extra$List$Extra$find,
						function (t) {
							return A2($author$project$UUID$isEqual, t.eL, value);
						},
						model.bW);
					var tenants = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						model.H,
						function (t) {
							return _Utils_ap(
								model.H,
								_List_fromArray(
									[t]));
						},
						maybeTenant);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: tenants}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var tenant = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							H: A2($elm_community$list_extra$List$Extra$remove, tenant, model.H)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var saveCmd = A2(
					$elm$http$Http$send,
					$author$project$Page$Group$GroupEditor$SaveCompleted,
					A5(
						$author$project$Request$Group$update,
						model.a,
						model.gb.bj,
						model.ev,
						model.b6,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.eL;
							},
							model.H)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: true}),
					saveCmd);
			default:
				var result = msg.a;
				if (!result.$) {
					var value = result.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$App$Route$pushUrlCmd,
							navKey,
							$author$project$App$Route$ViewGroup(value.gb.bj)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cd: $elm$core$Maybe$Just(error),
								cg: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Group$GroupList$update = F2(
	function (msg, model) {
		if (msg === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						f$: _List_fromArray(
							['Email powerlifters@microsoft.com to add your tenant to this group'])
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{f$: _List_Nil}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Group$GroupViewer$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Home$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Incident$EditorMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Incident$ScrollToElementId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Incident$SelectTab = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$View$Classifier$Drill2$Editor$attemptMergeQueries = F2(
	function (queryMapper, queries) {
		var updatedQueries = A2($elm$core$List$map, queryMapper, queries);
		var didChange = A2($elm$core$List$any, $elm_community$maybe_extra$Maybe$Extra$isJust, updatedQueries);
		return _Utils_Tuple2(
			A3($elm$core$List$map2, $elm$core$Maybe$withDefault, queries, updatedQueries),
			didChange);
	});
var $elm_community$list_extra$List$Extra$init = function (items) {
	if (!items.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var nonEmptyList = items;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$List$reverse,
			$elm$core$List$tail(
				$elm$core$List$reverse(nonEmptyList)));
	}
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$View$Classifier$Drill2$Editor$splitPathTail = function (path) {
	return function (parts) {
		return _Utils_Tuple2(
			A2(
				$elm$core$String$join,
				'.',
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$list_extra$List$Extra$init(parts))),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				$elm$core$Basics$append('.'),
				$elm_community$list_extra$List$Extra$last(parts)));
	}(
		A2($elm$core$String$split, '.', path));
};
var $author$project$View$Classifier$Drill2$Editor$attemptPromote = F2(
	function (newD, oldD) {
		var _v0 = $author$project$View$Classifier$Drill2$Editor$splitPathTail(oldD.eF);
		var oldHead = _v0.a;
		var oldTail = _v0.b;
		var _v1 = $author$project$View$Classifier$Drill2$Editor$splitPathTail(newD.eF);
		var newHead = _v1.a;
		var newTail = _v1.b;
		var canPromote = _Utils_eq(newHead, oldHead) && A2($elm$core$String$contains, '[]', newHead);
		return canPromote ? $elm$core$Maybe$Just(
			A2(
				$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
				newHead,
				_List_fromArray(
					[
						_Utils_update(
						newD,
						{eF: newTail}),
						_Utils_update(
						oldD,
						{eF: oldTail})
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$View$Classifier$Drill2$Editor$attemptMergeQuery = F2(
	function (newDetails, oldQuery) {
		var _v0 = $author$project$View$Classifier$Drill2$Editor$splitPathTail(newDetails.eF);
		var newHead = _v0.a;
		var newTail = _v0.b;
		if (!oldQuery.$) {
			var oldDetails = oldQuery.a;
			return _Utils_eq(newDetails.eF, oldDetails.eF) ? (A2($elm$core$String$contains, '[]', newDetails.eF) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(newDetails))) : A2($author$project$View$Classifier$Drill2$Editor$attemptPromote, newDetails, oldDetails);
		} else {
			var oldPath = oldQuery.a;
			var oldDs = oldQuery.b;
			return _Utils_eq(newHead, oldPath) ? $elm$core$Maybe$Just(
				A2(
					$author$project$View$Classifier$Drill2$Editor$ObjectQuery,
					oldPath,
					A2(
						$elm$core$List$cons,
						_Utils_update(
							newDetails,
							{eF: newTail}),
						oldDs))) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$Classifier$Drill2$Editor$queryDetailsFromClickToClassify = F3(
	function (path, drillDataType, value) {
		var _v0 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2(1, $author$project$View$Classifier$Drill2$Editor$IsNull),
			function (t) {
				return _Utils_Tuple2(
					$author$project$View$Classifier$Drill2$Editor$decodeDataType(t),
					$author$project$View$Classifier$Drill2$Editor$Eq(value));
			},
			drillDataType);
		var dataType = _v0.a;
		var op = _v0.b;
		return A4(
			$author$project$View$Classifier$Drill2$Editor$defaultQueryDetails,
			path,
			dataType,
			$elm$core$Maybe$Just(op),
			1);
	});
var $author$project$View$Classifier$Drill2$Editor$mergeQuery = F4(
	function (path, drillDataType, value, model) {
		var queries = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$View$Classifier$Drill2$Editor$queryIsEmpty),
			model.de);
		var detailsToInsert = A3($author$project$View$Classifier$Drill2$Editor$queryDetailsFromClickToClassify, path, drillDataType, value);
		var _v0 = A2(
			$author$project$View$Classifier$Drill2$Editor$attemptMergeQueries,
			$author$project$View$Classifier$Drill2$Editor$attemptMergeQuery(detailsToInsert),
			queries);
		var updatedQueries = _v0.a;
		var didChange = _v0.b;
		return didChange ? _Utils_update(
			model,
			{de: updatedQueries}) : _Utils_update(
			model,
			{
				de: A2(
					$elm$core$List$cons,
					$author$project$View$Classifier$Drill2$Editor$PrimitiveQuery(detailsToInsert),
					queries)
			});
	});
var $author$project$Page$Classifier$Editor$mergeQuery = F4(
	function (path, dataType, value, model) {
		var _v0 = model.L;
		if (_v0.$ === 1) {
			var subModel = _v0.a;
			return _Utils_update(
				model,
				{
					L: $author$project$Page$Classifier$Editor$Drill2Content(
						A4($author$project$View$Classifier$Drill2$Editor$mergeQuery, path, dataType, value, subModel))
				});
		} else {
			return model;
		}
	});
var $author$project$Page$Incident$clickToClassify = F2(
	function (rawKeyPath, model) {
		var updateModel = function (result) {
			if (result.$ === 1) {
				var error = result.a;
				return A2(
					$author$project$Util$appendErrors,
					model,
					_List_fromArray(
						['Click-to-classify failed: ' + error]));
			} else {
				var newEditor = result.a;
				return _Utils_update(
					model,
					{M: newEditor});
			}
		};
		var dataTypeForString = function (s) {
			return (A2(
				$elm$core$String$contains,
				'version',
				$elm$core$String$toLower(rawKeyPath)) && A2($elm$core$String$contains, '.', s)) ? 3 : 1;
		};
		var makeMatcherCondition = function (node) {
			var _v2 = node.hR;
			switch (_v2.$) {
				case 0:
					var s = _v2.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							dataTypeForString(s)),
						s);
				case 1:
					var x = _v2.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(0),
						$elm$core$String$fromFloat(x));
				case 2:
					var b = _v2.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(2),
						b ? 'true' : 'false');
				case 5:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
				case 3:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(4),
						'');
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(1),
						'');
			}
		};
		var cleanKeyPath = A3(
			$author$project$Util$Regex$replace,
			'\\[\\d+\\]',
			function (_v1) {
				return '[]';
			},
			rawKeyPath);
		var insertCondition = function (_v0) {
			var dataType = _v0.a;
			var value = _v0.b;
			return A4($author$project$Page$Classifier$Editor$mergeQuery, cleanKeyPath, dataType, value, model.M);
		};
		return updateModel(
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, makeMatcherCondition, insertCondition),
				A2($author$project$JsonTree$Resolver$resolve, rawKeyPath, model.z.ac)));
	});
var $author$project$Page$Incident$applyWidgetMsgForParent = F2(
	function (msg, model) {
		var handle = function (msgForParent) {
			var keyPath = msgForParent;
			return A2($author$project$Page$Incident$clickToClassify, keyPath, model);
		};
		switch (msg.$) {
			case 0:
				var msgForParent = msg.a;
				return handle(msgForParent);
			case 1:
				var msgForParent = msg.a;
				return handle(msgForParent);
			case 2:
				if (msg.a.$ === 2) {
					var msgForParent = msg.a.a;
					return handle(msgForParent);
				} else {
					return model;
				}
			default:
				if (msg.a.$ === 1) {
					var msgForParent = msg.a.a;
					return handle(msgForParent);
				} else {
					return model;
				}
		}
	});
var $author$project$FocusList$allItems = function (fl) {
	return fl.R;
};
var $author$project$FocusList$reset = function (fl) {
	return $author$project$FocusList$fromList(
		$author$project$FocusList$allItems(fl));
};
var $author$project$View$Incident$Navigator$reset = function (model) {
	return {
		R: $author$project$FocusList$reset(model.R),
		hb: ''
	};
};
var $author$project$Page$Incident$clearNavigator = function (model) {
	return _Utils_update(
		model,
		{
			y: $author$project$View$Incident$Navigator$reset(model.y)
		});
};
var $author$project$FocusList$isVisible = F2(
	function (index, fl) {
		return A2($elm$core$List$member, index, fl.ae);
	});
var $author$project$FocusList$selected = function (fl) {
	return A2($author$project$FocusList$isVisible, fl.m, fl) ? A2($elm_community$list_extra$List$Extra$getAt, fl.m, fl.R) : $elm$core$Maybe$Nothing;
};
var $author$project$View$Incident$Navigator$currentLocation = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.bu;
		},
		$author$project$FocusList$selected(model.R));
};
var $author$project$View$NavBar$domID = 'powerlift-top-level-nav';
var $author$project$JsonTree$View$expandAll = function (_v0) {
	return $author$project$JsonTree$View$fullyExpandedState;
};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Page$Incident$findSectionOfWidget = F2(
	function (widgetId, widgetSections) {
		return A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (section) {
					return A2(
						$elm$core$List$any,
						function (w) {
							return _Utils_eq(w.bj, widgetId);
						},
						section.cB);
				},
				widgetSections));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$App$Ports$getDocumentURL = _Platform_outgoingPort(
	'getDocumentURL',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Page$Incident$hideNavigator = function (model) {
	return _Utils_update(
		model,
		{
			y: $author$project$View$Incident$Navigator$reset(model.y),
			aY: false
		});
};
var $author$project$View$Incident$Navigator$id = 'powerlift-navigator';
var $author$project$View$Incident$Navigator$isQueryEmpty = function (model) {
	return $elm$core$String$isEmpty(model.hb);
};
var $elm_community$list_extra$List$Extra$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				if (accAcc.b) {
					var acc = accAcc.a;
					return A2(
						$elm$core$List$cons,
						A2(f, x, acc),
						accAcc);
				} else {
					return _List_Nil;
				}
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				scan1,
				_List_fromArray(
					[b]),
				xs));
	});
var $author$project$JsonTree$View$ancestorsOfKeyPath = function (keyPath) {
	var combine = F2(
		function (segment, acc) {
			if (!segment.$) {
				var fieldName = segment.a;
				return acc + ('.' + fieldName);
			} else {
				var index = segment.a;
				return acc + ('[' + ($elm$core$String$fromInt(index) + ']'));
			}
		});
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		A3($elm_community$list_extra$List$Extra$scanl, combine, '', keyPath));
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$JsonTree$View$revealKeyPath = F2(
	function (keyPath, _v0) {
		var hiddenPaths = _v0;
		var newHiddenPaths = A3(
			$elm$core$List$foldl,
			$elm$core$Set$remove,
			hiddenPaths,
			$author$project$JsonTree$View$ancestorsOfKeyPath(keyPath));
		return newHiddenPaths;
	});
var $author$project$App$Ports$scrollIntoView = _Platform_outgoingPort('scrollIntoView', $elm$json$Json$Encode$string);
var $author$project$FocusList$select = F2(
	function (predicate, fl) {
		var _v0 = A2($elm_community$list_extra$List$Extra$findIndex, predicate, fl.R);
		if (!_v0.$) {
			var index = _v0.a;
			return _Utils_update(
				fl,
				{m: index});
		} else {
			return fl;
		}
	});
var $author$project$View$Incident$Navigator$select = F2(
	function (location, model) {
		return _Utils_update(
			model,
			{
				R: A2(
					$author$project$FocusList$select,
					function (item) {
						return _Utils_eq(item.bu, location);
					},
					model.R)
			});
	});
var $author$project$SelectList$map = F2(
	function (transform, _v0) {
		var beforeSel = _v0.a;
		var sel = _v0.b;
		var afterSel = _v0.c;
		return A3(
			$author$project$SelectList$SelectList,
			A2($elm$core$List$map, transform, beforeSel),
			transform(sel),
			A2($elm$core$List$map, transform, afterSel));
	});
var $author$project$Page$Incident$selectTab = F2(
	function (newTab, model) {
		return _Utils_update(
			model,
			{
				aw: A2(
					$author$project$SelectList$select,
					$elm$core$Basics$eq(newTab),
					A2(
						$author$project$SelectList$map,
						function (t) {
							return _Utils_eq(
								$author$project$Page$Incident$tabToString(t),
								$author$project$Page$Incident$tabToString(newTab)) ? newTab : t;
						},
						model.aw))
			});
	});
var $author$project$View$Widget$DynamicList$update = F2(
	function (msg, model) {
		return model;
	});
var $author$project$View$Widget$DynamicTable$update = F2(
	function (msg, model) {
		var oldState = model.e2;
		switch (msg.$) {
			case 2:
				return model;
			case 1:
				var s = msg.a;
				return _Utils_update(
					model,
					{
						e2: _Utils_update(
							oldState,
							{cz: s})
					});
			default:
				var index = msg.a;
				var oldRows = oldState.bd;
				var newRows = A2($elm$core$Set$member, index, oldRows) ? A2($elm$core$Set$remove, index, oldRows) : A2($elm$core$Set$insert, index, oldRows);
				return _Utils_update(
					model,
					{
						e2: _Utils_update(
							oldState,
							{bd: newRows})
					});
		}
	});
var $author$project$View$Widget$Generic$update = F2(
	function (msg, model) {
		var oldState = model.e2;
		if (msg.$ === 1) {
			return model;
		} else {
			var s = msg.a;
			return _Utils_update(
				model,
				{
					e2: _Utils_update(
						oldState,
						{cz: s})
				});
		}
	});
var $author$project$View$Widget$StaticTable$update = F2(
	function (msg, model) {
		return model;
	});
var $author$project$Page$Incident$applyWidgetMsg = F2(
	function (widgetMsg, widget) {
		var _v0 = _Utils_Tuple2(widgetMsg, widget.b3);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var subMsg = _v0.a.a;
					var widgetModel = _v0.b.a;
					return _Utils_update(
						widget,
						{
							b3: $author$project$Data$Widget$StaticTableData(
								A2($author$project$View$Widget$StaticTable$update, subMsg, widgetModel))
						});
				} else {
					return widget;
				}
			case 3:
				if (_v0.b.$ === 3) {
					var subMsg = _v0.a.a;
					var widgetModel = _v0.b.a;
					return _Utils_update(
						widget,
						{
							b3: $author$project$Data$Widget$GenericData(
								A2($author$project$View$Widget$Generic$update, subMsg, widgetModel))
						});
				} else {
					return widget;
				}
			case 1:
				if (_v0.b.$ === 2) {
					var subMsg = _v0.a.a;
					var widgetModel = _v0.b.a;
					return _Utils_update(
						widget,
						{
							b3: $author$project$Data$Widget$DynamicListData(
								A2($author$project$View$Widget$DynamicList$update, subMsg, widgetModel))
						});
				} else {
					return widget;
				}
			default:
				if (_v0.b.$ === 1) {
					var subMsg = _v0.a.a;
					var widgetModel = _v0.b.a;
					return _Utils_update(
						widget,
						{
							b3: $author$project$Data$Widget$DynamicTableData(
								A2($author$project$View$Widget$DynamicTable$update, subMsg, widgetModel))
						});
				} else {
					return widget;
				}
		}
	});
var $author$project$Page$Incident$updateWidgetSection = F3(
	function (widgetId, widgetMsg, section) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (w) {
				return _Utils_eq(w.bj, widgetId);
			},
			section.cB);
		if (!_v0.$) {
			var index = _v0.a;
			return _Utils_update(
				section,
				{
					cB: A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						$author$project$Page$Incident$applyWidgetMsg(widgetMsg),
						section.cB)
				});
		} else {
			return section;
		}
	});
var $author$project$Page$Incident$update = F3(
	function (navKey, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var tab = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$Incident$selectTab, tab, model),
						_Utils_eq(model.a8, $elm$core$Maybe$Nothing) ? $author$project$App$Ports$getDocumentURL(0) : $elm$core$Platform$Cmd$none);
				case 1:
					var elementId = msg.a;
					var _v1 = $author$project$JsonTree$KeyPathParser$parse(elementId);
					if (!_v1.$) {
						var keyPath = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									P: A2($author$project$JsonTree$View$revealKeyPath, keyPath, model.P)
								}),
							$author$project$App$Ports$scrollIntoView(elementId));
					} else {
						var err = _v1.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Util$appendErrors,
								model,
								_List_fromArray(
									['Cannot scroll to key-path: ' + err])),
							$elm$core$Platform$Cmd$none);
					}
				case 2:
					var elementId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$App$Ports$scrollIntoView(elementId));
				case 3:
					var selection = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$Incident$clickToClassify, selection, model),
						$elm$core$Platform$Cmd$none);
				case 4:
					var subMsg = msg.a;
					var _v2 = A3($author$project$Page$Classifier$Editor$update, navKey, subMsg, model.M);
					var newEditor = _v2.a;
					var newCmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{M: newEditor}),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Incident$EditorMsg, newCmd));
				case 5:
					var scrollTop = msg.a.eY;
					var contentHeight = msg.a.dS;
					var containerHeight = msg.a.dR;
					var _v3 = A3(
						$author$project$Page$Classifier$Editor$update,
						navKey,
						$author$project$Page$Classifier$Editor$WindowScroll(
							_Utils_Tuple2(scrollTop + containerHeight, contentHeight)),
						model.M);
					var newEditor = _v3.a;
					var newCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{M: newEditor}),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Incident$EditorMsg, newCmd));
				case 6:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f$: _List_Nil}),
						$elm$core$Platform$Cmd$none);
				case 7:
					var widgetId = msg.a;
					var widgetMsg = msg.b;
					var newModel = _Utils_update(
						model,
						{
							hT: A2(
								$elm$core$List$map,
								A2($author$project$Page$Incident$updateWidgetSection, widgetId, widgetMsg),
								model.hT)
						});
					return _Utils_Tuple2(
						A2($author$project$Page$Incident$applyWidgetMsgForParent, widgetMsg, newModel),
						$elm$core$Platform$Cmd$none);
				case 8:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{N: !model.N}),
						$elm$core$Platform$Cmd$none);
				case 9:
					var state = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{P: state}),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: $author$project$JsonTree$View$expandAll(model.P)
							}),
						$elm$core$Platform$Cmd$none);
				case 11:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: A2($author$project$JsonTree$View$initExpandedToDepth, 1, model.z.ac)
							}),
						$elm$core$Platform$Cmd$none);
				case 12:
					var navigatorModel = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{y: navigatorModel}),
						$elm$core$Platform$Cmd$none);
				case 13:
					var adjustedModel = $author$project$Page$Incident$hideNavigator(model);
					var _v4 = $author$project$View$Incident$Navigator$currentLocation(model.y);
					if (!_v4.$) {
						switch (_v4.a.$) {
							case 2:
								var _v5 = _v4.a;
								var $temp$navKey = navKey,
									$temp$msg = $author$project$Page$Incident$SelectTab(
									$author$project$Page$Incident$Diagnostics(
										$author$project$Page$Incident$defaultDiagnosticsSection(model.hT))),
									$temp$model = adjustedModel;
								navKey = $temp$navKey;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							case 4:
								var sectionIndex = _v4.a.a;
								var $temp$navKey = navKey,
									$temp$msg = $author$project$Page$Incident$SelectTab(
									$author$project$Page$Incident$Diagnostics(
										$author$project$Page$Incident$WidgetsSection(sectionIndex))),
									$temp$model = adjustedModel;
								navKey = $temp$navKey;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							case 3:
								var widgetId = _v4.a.a;
								var sectionIndex = A2($author$project$Page$Incident$findSectionOfWidget, widgetId, model.hT);
								var _v6 = A3(
									$author$project$Page$Incident$update,
									navKey,
									$author$project$Page$Incident$SelectTab(
										$author$project$Page$Incident$Diagnostics(
											$author$project$Page$Incident$WidgetsSection(sectionIndex))),
									adjustedModel);
								var newModel = _v6.a;
								var newCmd = _v6.b;
								return _Utils_Tuple2(
									newModel,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												newCmd,
												A2(
												$elm$core$Task$attempt,
												function (_v7) {
													return $author$project$Page$Incident$ScrollToElementId(
														$author$project$UUID$toString(widgetId));
												},
												$elm$core$Process$sleep(20.0))
											])));
							case 0:
								var _v8 = _v4.a;
								var $temp$navKey = navKey,
									$temp$msg = $author$project$Page$Incident$SelectTab($author$project$Page$Incident$Files),
									$temp$model = adjustedModel;
								navKey = $temp$navKey;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							default:
								var index = _v4.a.a;
								var _v9 = A2($elm_community$list_extra$List$Extra$getAt, index, model.z.gj.ep);
								if (!_v9.$) {
									var logMeta = _v9.a;
									return _Utils_Tuple2(
										model,
										$elm$browser$Browser$Navigation$load(logMeta.hQ));
								} else {
									return _Utils_Tuple2(
										A2(
											$author$project$Util$appendErrors,
											model,
											_List_fromArray(
												[
													'Could not find file at index ' + $elm$core$String$fromInt(index)
												])),
										$elm$core$Platform$Cmd$none);
								}
						}
					} else {
						return _Utils_Tuple2(
							A2(
								$author$project$Util$appendErrors,
								model,
								_List_fromArray(
									['Could not perform navigation because no location selected'])),
							$elm$core$Platform$Cmd$none);
					}
				case 14:
					var location = msg.a;
					var $temp$navKey = navKey,
						$temp$msg = $author$project$Page$Incident$NavigateEnter,
						$temp$model = _Utils_update(
						model,
						{
							y: A2($author$project$View$Incident$Navigator$select, location, model.y)
						});
					navKey = $temp$navKey;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 15:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aY: true}),
						A2(
							$elm$core$Task$attempt,
							function (_v10) {
								return $author$project$Page$Incident$ScrollToElementId($author$project$View$NavBar$domID);
							},
							$elm$core$Task$sequence(
								_List_fromArray(
									[
										$elm$core$Process$sleep(1.0),
										$elm$browser$Browser$Dom$focus($author$project$View$Incident$Navigator$id)
									]))));
				case 16:
					return _Utils_Tuple2(
						$author$project$View$Incident$Navigator$isQueryEmpty(model.y) ? $author$project$Page$Incident$hideNavigator(model) : $author$project$Page$Incident$clearNavigator(model),
						$elm$core$Platform$Cmd$none);
				default:
					var string = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a8: $elm$core$Maybe$Just(string)
							}),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Page$Incident$List$FilterList = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Request$Incident$fuzzySearch = F2(
	function (accessToken, query) {
		var url = '/gym/incidents/search?q=' + $elm$url$Url$percentEncode(query);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return $elm$http$Http$request(
			{
				bX: $elm$http$Http$emptyBody,
				f1: $elm$http$Http$expectJson($author$project$Request$Incident$searchResponseDecoder),
				ge: headers,
				gM: 'GET',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Incident$List$update = F3(
	function (navKey, msg, origModel) {
		var model = _Utils_update(
			origModel,
			{am: false});
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var route = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$App$Route$pushUrlCmd, navKey, route));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: !model.at}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: false}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var showingSearchResults = msg.a;
				var result = msg.b;
				return _Utils_Tuple2(
					function () {
						if (!result.$) {
							var searchResults = result.a;
							return _Utils_update(
								model,
								{f$: _List_Nil, aX: searchResults, aZ: showingSearchResults});
						} else {
							var err = result.a;
							return _Utils_update(
								model,
								{
									f$: _List_fromArray(
										[
											$author$project$Util$Http$errorToString(err)
										])
								});
						}
					}(),
					$elm$core$Platform$Cmd$none);
			case 5:
				return $elm$core$String$isEmpty(model.au) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{am: true}),
					A2(
						$elm$http$Http$send,
						$author$project$Page$Incident$List$FilterList(true),
						A2($author$project$Request$Incident$fuzzySearch, model.a, model.au)));
			case 6:
				var searchQuery = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							au: $elm$core$String$trim(searchQuery)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{am: true, au: ''}),
					A2(
						$elm$http$Http$send,
						$author$project$Page$Incident$List$FilterList(false),
						A2($author$project$Request$Incident$search, model.a, $author$project$App$SearchParams$default)));
		}
	});
var $author$project$Page$JoinTenantHelp$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Util$String$isBlank = function (string) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(string));
};
var $author$project$Page$LogFile$updatePicker = F3(
	function (model, pickerIdx, fn) {
		return _Utils_update(
			model,
			{
				T: A3($elm_community$list_extra$List$Extra$updateAt, pickerIdx, fn, model.T)
			});
	});
var $author$project$Page$LogFile$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						_Utils_update(
							model,
							{
								T: A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_update(
											p,
											{
												G: $elm$core$Set$fromList(p.bC)
											});
									},
									model.T),
								de: _List_Nil,
								U: '',
								aS: 0
							})),
					$elm$core$Platform$Cmd$none);
			case 2:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U: s}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return (!$author$project$Util$String$isBlank(model.U)) ? _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						_Utils_update(
							model,
							{
								de: _Utils_ap(
									model.de,
									_List_fromArray(
										[
											$elm$core$String$toLower(model.U)
										])),
								U: ''
							})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{U: ''}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var query = msg.a;
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						_Utils_update(
							model,
							{
								de: A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(query),
									model.de)
							})),
					$elm$core$Platform$Cmd$none);
			case 5:
				var combiner = msg.a;
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						_Utils_update(
							model,
							{aS: combiner})),
					$elm$core$Platform$Cmd$none);
			case 6:
				var idx = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Page$LogFile$updatePicker,
						model,
						idx,
						function (p) {
							return _Utils_update(
								p,
								{ai: !p.ai});
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var idx = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						A3(
							$author$project$Page$LogFile$updatePicker,
							model,
							idx,
							function (p) {
								return _Utils_update(
									p,
									{
										G: A2($elm$core$Set$member, val, p.G) ? A2($elm$core$Set$remove, val, p.G) : A2($elm$core$Set$insert, val, p.G)
									});
							})),
					$elm$core$Platform$Cmd$none);
			case 8:
				var idx = msg.a;
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						A3(
							$author$project$Page$LogFile$updatePicker,
							model,
							idx,
							function (p) {
								return _Utils_update(
									p,
									{
										G: $elm$core$Set$fromList(p.bC)
									});
							})),
					$elm$core$Platform$Cmd$none);
			default:
				var idx = msg.a;
				return _Utils_Tuple2(
					$author$project$Page$LogFile$applyFiltersAndCache(
						A3(
							$author$project$Page$LogFile$updatePicker,
							model,
							idx,
							function (p) {
								return _Utils_update(
									p,
									{G: $elm$core$Set$empty});
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$News$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Onboarding$SelectSecurityGroupStep = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Onboarding$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					$author$project$Util$clearErrors(model),
					$elm$core$Platform$Cmd$none);
			case 2:
				var maybeTenant = msg.a;
				if (!maybeTenant.$) {
					var tenant = maybeTenant.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: $author$project$Page$Onboarding$SelectSecurityGroupStep(tenant)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: $author$project$Page$Onboarding$SelectTenantStep($elm$core$Maybe$Nothing)
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var step = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a$: step}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Remedy$Editor$AutoTranslateResponse = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$Remedy$Editor$FocusedDomElement = {$: 20};
var $author$project$Page$Remedy$Editor$LangModal = {$: 3};
var $author$project$Remedy$Editor$Validation$LaxValidation = 1;
var $author$project$Page$Remedy$Editor$PreviewModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Remedy$Editor$SaveResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Remedy$Editor$Validation$StrictValidation = 0;
var $author$project$Util$List$FoundPivot = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Util$List$SearchingForPivot = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$List$partitionStateToMaybe = function (extractState) {
	if (!extractState.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var before = extractState.a;
		var pivot = extractState.b;
		var after = extractState.c;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				$elm$core$List$reverse(before),
				pivot,
				$elm$core$List$reverse(after)));
	}
};
var $author$project$Util$List$partition = F2(
	function (predicate, list) {
		return $author$project$Util$List$partitionStateToMaybe(
			A3(
				$elm$core$List$foldl,
				F2(
					function (x, state) {
						if (!state.$) {
							var beforePivot = state.a;
							return predicate(x) ? A3($author$project$Util$List$FoundPivot, beforePivot, x, _List_Nil) : $author$project$Util$List$SearchingForPivot(
								A2($elm$core$List$cons, x, beforePivot));
						} else {
							var beforePivot = state.a;
							var pivot = state.b;
							var afterPivot = state.c;
							return A3(
								$author$project$Util$List$FoundPivot,
								beforePivot,
								pivot,
								A2($elm$core$List$cons, x, afterPivot));
						}
					}),
				$author$project$Util$List$SearchingForPivot(_List_Nil),
				list));
	});
var $author$project$Remedy$Editor$Form$activateScreen = F2(
	function (screenId, _v0) {
		var form = _v0;
		var _v1 = A2(
			$author$project$Util$List$partition,
			function (s) {
				return _Utils_eq(s.bj, screenId);
			},
			_Utils_ap(
				form.D,
				_Utils_ap(
					_List_fromArray(
						[form.n]),
					form.J)));
		if (!_v1.$) {
			var _v2 = _v1.a;
			var preceding = _v2.a;
			var pivot = _v2.b;
			var following = _v2.c;
			return $elm$core$Maybe$Just(
				_Utils_update(
					form,
					{
						n: _Utils_update(
							pivot,
							{f7: $elm$core$Maybe$Nothing}),
						J: following,
						D: preceding
					}));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Util$List$insertAt = F3(
	function (index, item, items) {
		var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index, items);
		var before = _v0.a;
		var after = _v0.b;
		return _Utils_ap(
			before,
			A2($elm$core$List$cons, item, after));
	});
var $author$project$Remedy$Editor$Form$updateActiveScreen = F2(
	function (f, form) {
		return _Utils_update(
			form,
			{
				n: f(form.n)
			});
	});
var $author$project$Remedy$Editor$Form$addElementAt = F3(
	function (elementIndex, element, _v0) {
		var form = _v0;
		return A2(
			$author$project$Remedy$Editor$Form$updateActiveScreen,
			function (screen) {
				return _Utils_update(
					screen,
					{
						d3: A3($author$project$Util$List$insertAt, elementIndex, element, screen.d3)
					});
			},
			form);
	});
var $author$project$Remedy$Editor$Form$DomNodeNotFound = 0;
var $author$project$Remedy$Editor$Form$ElementNotFound = 1;
var $author$project$Remedy$Editor$Form$elementDomId = function (elementIndex) {
	return 'powerlift-element-' + $elm$core$String$fromInt(elementIndex);
};
var $author$project$Remedy$Editor$Form$focusOnElement = F2(
	function (elementIndex, _v0) {
		var form = _v0;
		return ((elementIndex < 0) || (_Utils_cmp(
			elementIndex,
			$elm$core$List$length(form.n.d3)) > -1)) ? _Utils_Tuple2(
			form,
			$elm$core$Task$fail(1)) : _Utils_Tuple2(
			A2(
				$author$project$Remedy$Editor$Form$updateActiveScreen,
				function (screen) {
					return _Utils_update(
						screen,
						{
							f7: $elm$core$Maybe$Just(elementIndex)
						});
				},
				form),
			A2(
				$elm$core$Task$mapError,
				$elm$core$Basics$always(0),
				$elm$browser$Browser$Dom$focus(
					$author$project$Remedy$Editor$Form$elementDomId(elementIndex))));
	});
var $author$project$Remedy$Editor$Form$addAndFocusElement = F2(
	function (element, remedyForm) {
		var form = remedyForm;
		var newElementIndex = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$List$length(form.n.d3),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$add(1),
				form.n.f7));
		return A2(
			$author$project$Remedy$Editor$Form$focusOnElement,
			newElementIndex,
			A3($author$project$Remedy$Editor$Form$addElementAt, newElementIndex, element, remedyForm));
	});
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				e: A3(
					$elm$core$Dict$insert,
					inner.W(k),
					_Utils_Tuple2(k, v),
					inner.e)
			});
	});
var $author$project$Remedy$Localization$addLanguage = F2(
	function (lang, _v0) {
		var items = _v0;
		var insertLang = function (item) {
			return _Utils_update(
				item,
				{
					I: A3($turboMaCk$any_dict$Dict$Any$insert, lang, '', item.I)
				});
		};
		return A2($elm$core$List$map, insertLang, items);
	});
var $author$project$Remedy$Editor$Form$addScreen = F2(
	function (title, _v0) {
		var form = _v0;
		var newScreen = {d3: _List_Nil, f7: $elm$core$Maybe$Nothing, bj: form.bx, bO: title};
		return _Utils_update(
			form,
			{
				n: newScreen,
				J: _List_Nil,
				D: $author$project$Remedy$Editor$Form$allScreens(form),
				bx: $author$project$Remedy$ScreenId$next(
					_List_fromArray(
						[form.bx]))
			});
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $turboMaCk$any_dict$Dict$Any$filter = F2(
	function (f, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				e: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v1, _v2) {
							var k = _v2.a;
							var v = _v2.b;
							return A2(f, k, v);
						}),
					inner.e)
			});
	});
var $author$project$Remedy$Localization$cleanup = function (item) {
	var shouldKeep = F2(
		function (_v0, translation) {
			return !$author$project$Util$String$isBlank(translation);
		});
	return _Utils_update(
		item,
		{
			I: A2($turboMaCk$any_dict$Dict$Any$filter, shouldKeep, item.I)
		});
};
var $author$project$Remedy$Localization$mapLangText = F3(
	function (lang, newText, item) {
		return _Utils_update(
			item,
			{
				I: A3($turboMaCk$any_dict$Dict$Any$insert, lang, newText, item.I)
			});
	});
var $author$project$Remedy$Localization$batchEdit = F3(
	function (lang, keysToTranslations, _v0) {
		var oldItems = _v0;
		var applyEdit = function (item) {
			var _v1 = A2(
				$elm_community$list_extra$List$Extra$find,
				function (_v2) {
					var locStr = _v2.a;
					return _Utils_eq(locStr, item.an);
				},
				keysToTranslations);
			if (!_v1.$) {
				var _v3 = _v1.a;
				var newTranslation = _v3.b;
				return A3($author$project$Remedy$Localization$mapLangText, lang, newTranslation, item);
			} else {
				return item;
			}
		};
		return A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, applyEdit, $author$project$Remedy$Localization$cleanup),
			oldItems);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $turboMaCk$any_dict$Dict$Any$get = F2(
	function (k, _v0) {
		var dict = _v0.e;
		var toKey = _v0.W;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $author$project$Remedy$Localization$fallbackLookup = F2(
	function (_v0, _v1) {
		var failedTag = _v0;
		var translations = _v1.I;
		var fallbackLang = function () {
			switch (failedTag) {
				case 'pt':
					return $elm$core$Maybe$Just('pt-BR');
				case 'zh':
					return $elm$core$Maybe$Just('zh-Hans');
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (!fallbackLang.$) {
			var lang = fallbackLang.a;
			return A2($turboMaCk$any_dict$Dict$Any$get, lang, translations);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 1) {
			return fma(0);
		} else {
			return mb;
		}
	});
var $author$project$Remedy$Localization$lookup = F2(
	function (lang, item) {
		var locStr = item.an;
		var translations = item.I;
		return _Utils_eq(lang, $author$project$Remedy$Localization$defaultLanguageTag) ? $elm$core$Maybe$Just(
			$author$project$Remedy$LocStr$english(locStr)) : A2(
			$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
			function (_v0) {
				return A2($author$project$Remedy$Localization$fallbackLookup, lang, item);
			},
			A2($turboMaCk$any_dict$Dict$Any$get, lang, translations));
	});
var $author$project$Remedy$Localization$batchTranslate = F2(
	function (_v0, lang) {
		var items = _v0;
		var makeTranslationPair = function (item) {
			return _Utils_Tuple2(
				item.an,
				A2($author$project$Remedy$Localization$lookup, lang, item));
		};
		return A2($elm$core$List$map, makeTranslationPair, items);
	});
var $author$project$Remedy$bumpVersion = function (_v0) {
	var remedy = _v0;
	return _Utils_update(
		remedy,
		{dx: remedy.dx + 1});
};
var $author$project$Remedy$Editor$Form$defocus = function (_v0) {
	var form = _v0;
	return A2(
		$author$project$Remedy$Editor$Form$updateActiveScreen,
		function (screen) {
			return _Utils_update(
				screen,
				{f7: $elm$core$Maybe$Nothing});
		},
		form);
};
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $elm_community$list_extra$List$Extra$unconsLast = function (list) {
	var _v0 = $elm$core$List$reverse(list);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var last_ = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				last_,
				$elm$core$List$reverse(rest)));
	}
};
var $author$project$Remedy$Editor$Form$deleteActiveScreen = function (remedyForm) {
	var form = remedyForm;
	var _v0 = _Utils_Tuple2(
		$elm_community$list_extra$List$Extra$unconsLast(form.D),
		$elm_community$list_extra$List$Extra$uncons(form.J));
	_v0$1:
	while (true) {
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return remedyForm;
			} else {
				break _v0$1;
			}
		} else {
			if (!_v0.b.$) {
				break _v0$1;
			} else {
				var _v4 = _v0.a.a;
				var prev = _v4.a;
				var rest = _v4.b;
				return _Utils_update(
					form,
					{n: prev, J: form.J, D: rest});
			}
		}
	}
	var _v3 = _v0.b.a;
	var next = _v3.a;
	var rest = _v3.b;
	return _Utils_update(
		form,
		{n: next, J: rest, D: form.D});
};
var $author$project$Remedy$Editor$Form$deleteFocusedElement = function (remedyForm) {
	var form = remedyForm;
	var _v0 = form.n.f7;
	if (_v0.$ === 1) {
		return remedyForm;
	} else {
		var idx = _v0.a;
		return A2(
			$author$project$Remedy$Editor$Form$updateActiveScreen,
			function (screen) {
				return _Utils_update(
					screen,
					{
						d3: A2($elm_community$list_extra$List$Extra$removeAt, idx, screen.d3),
						f7: $elm$core$Maybe$Nothing
					});
			},
			form);
	}
};
var $author$project$Remedy$Localization$edit = F4(
	function (locStr, lang, newTranslation, oldTable) {
		return A3(
			$author$project$Remedy$Localization$batchEdit,
			lang,
			_List_fromArray(
				[
					_Utils_Tuple2(locStr, newTranslation)
				]),
			oldTable);
	});
var $author$project$Page$Remedy$Editor$screenProblemToString = F2(
	function (screenName, problem) {
		switch (problem.$) {
			case 0:
				switch (problem.b.$) {
					case 0:
						var elementIndex = problem.a;
						var error = problem.b.a;
						return 'Invalid element on screen \'' + (screenName + ('\', element index ' + ($elm$core$String$fromInt(elementIndex) + (': ' + error))));
					case 1:
						var elementIndex = problem.a;
						var _v1 = problem.b;
						return 'The button on screen \'' + (screenName + ('\' at element index ' + ($elm$core$String$fromInt(elementIndex) + ' points to a screen that does not exist')));
					default:
						var elementIndex = problem.a;
						var _v2 = problem.b;
						return 'The button on screen \'' + (screenName + ('\' at element index ' + ($elm$core$String$fromInt(elementIndex) + ' points at a screen which would cause a loop')));
				}
			case 2:
				return 'Screen \'' + (screenName + '\' is not reachable');
			default:
				return 'Screen \'' + (screenName + '\' must not be empty');
		}
	});
var $author$project$Page$Remedy$Editor$screenTitle = F2(
	function (screenStubs, screenId) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.bO;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (stub) {
					return _Utils_eq(stub.bj, screenId);
				},
				screenStubs));
	});
var $author$project$Remedy$ScreenId$toString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Page$Remedy$Editor$contentProblemToString = F2(
	function (screenStubs, problem) {
		var screenName = function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				'???',
				A2($author$project$Page$Remedy$Editor$screenTitle, screenStubs, id));
		};
		switch (problem.$) {
			case 0:
				var screenId = problem.a;
				var screenProblem = problem.b;
				return A2(
					$author$project$Page$Remedy$Editor$screenProblemToString,
					screenName(screenId),
					screenProblem);
			case 1:
				return 'A remedy must have at least one screen';
			default:
				var badId = problem.a;
				return 'More than one screen has ID \'' + ($author$project$Remedy$ScreenId$toString(badId) + '\'. This is a bug in PowerLift!');
		}
	});
var $author$project$Page$Remedy$Editor$problemToString = F2(
	function (screenStubs, problem) {
		switch (problem.$) {
			case 0:
				var subProblem = problem.a;
				return A2($author$project$Page$Remedy$Editor$contentProblemToString, screenStubs, subProblem);
			case 1:
				var message = problem.a;
				return message;
			default:
				var message = problem.a;
				return message;
		}
	});
var $author$project$Remedy$Editor$Form$ScreenStub = F2(
	function (id, title) {
		return {bj: id, bO: title};
	});
var $author$project$Remedy$Editor$Form$screenStubs = function (_v0) {
	var form = _v0;
	return A2(
		$elm$core$List$map,
		function (screen) {
			return A2($author$project$Remedy$Editor$Form$ScreenStub, screen.bj, screen.bO);
		},
		$author$project$Remedy$Editor$Form$allScreens(form));
};
var $author$project$Util$setErrors = F2(
	function (model, errors) {
		return _Utils_update(
			model,
			{f$: errors});
	});
var $author$project$Page$Remedy$Editor$handleValidationErrors = F3(
	function (title, model, problems) {
		var screenStubs = $author$project$Remedy$Editor$Form$screenStubs(model.d);
		return _Utils_Tuple2(
			A2(
				$author$project$Util$setErrors,
				model,
				A2(
					$elm$core$List$cons,
					title,
					A2(
						$elm$core$List$map,
						$author$project$Page$Remedy$Editor$problemToString(screenStubs),
						problems))),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Remedy$Editor$addToPreviewConsole = F2(
	function (message, state) {
		return _Utils_update(
			state,
			{
				aO: A2($elm$core$List$cons, message, state.aO)
			});
	});
var $author$project$Remedy$Capability$serializationId = function (capability) {
	switch (capability.$) {
		case 0:
			return 'GO_TO_MARKET';
		case 1:
			return 'TALK_TO_AGENT';
		case 2:
			return 'DISMISS';
		case 3:
			return 'FEEDBACK';
		default:
			var id = capability.a;
			return id;
	}
};
var $author$project$Page$Remedy$Editor$updatePreview = F2(
	function (action, state) {
		switch (action.$) {
			case 0:
				var screenId = action.a;
				return _Utils_update(
					state,
					{aE: screenId});
			case 1:
				var url = action.a;
				return A2(
					$author$project$Page$Remedy$Editor$addToPreviewConsole,
					'Navigate to URL: ' + $elm$url$Url$toString(url),
					state);
			default:
				var capability = action.a;
				if (capability.$ === 3) {
					return state;
				} else {
					return A2(
						$author$project$Page$Remedy$Editor$addToPreviewConsole,
						'Use Capability: ' + $author$project$Remedy$Capability$serializationId(capability),
						state);
				}
		}
	});
var $author$project$Page$Remedy$Editor$invokePreviewAction = F2(
	function (action, model) {
		var _v0 = model.S;
		if (_v0.$ === 4) {
			var previewState = _v0.a;
			return _Utils_update(
				model,
				{
					S: $author$project$Page$Remedy$Editor$PreviewModal(
						A2($author$project$Page$Remedy$Editor$updatePreview, action, previewState))
				});
		} else {
			return model;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm_community$list_extra$List$Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$elm_community$list_extra$List$Extra$uncons(head2),
						$elm_community$list_extra$List$Extra$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Util$List$moveWithDetails = F3(
	function (index, direction, items) {
		var indexToSwap = function () {
			if (!direction) {
				return A2($elm$core$Basics$max, index - 1, 0);
			} else {
				return A2(
					$elm$core$Basics$min,
					index + 1,
					$elm$core$List$length(items) - 1);
			}
		}();
		return _Utils_Tuple2(
			A3($elm_community$list_extra$List$Extra$swapAt, index, indexToSwap, items),
			indexToSwap);
	});
var $author$project$Remedy$Editor$Form$moveFocusedElement = F2(
	function (direction, remedyForm) {
		var form = remedyForm;
		var _v0 = form.n.f7;
		if (_v0.$ === 1) {
			return remedyForm;
		} else {
			var idx = _v0.a;
			return A2(
				$author$project$Remedy$Editor$Form$updateActiveScreen,
				function (screen) {
					var _v1 = A3($author$project$Util$List$moveWithDetails, idx, direction, screen.d3);
					var newList = _v1.a;
					var newIndex = _v1.b;
					return _Utils_update(
						screen,
						{
							d3: newList,
							f7: $elm$core$Maybe$Just(newIndex)
						});
				},
				form);
		}
	});
var $author$project$Remedy$Editor$Form$firstScreen = function (_v0) {
	var form = _v0;
	var _v1 = $elm$core$List$head(form.D);
	if (!_v1.$) {
		var screen = _v1.a;
		return screen;
	} else {
		return form.n;
	}
};
var $author$project$Page$Remedy$Editor$newPreviewState = F2(
	function (remedy, model) {
		return {
			aE: $author$project$Remedy$Editor$Form$firstScreen(model.d).bj,
			gB: $author$project$Remedy$Localization$defaultLanguageTag,
			aO: _List_Nil,
			hd: remedy
		};
	});
var $author$project$Remedy$Editor$Form$renameActiveScreen = F2(
	function (str, _v0) {
		var form = _v0;
		return A2(
			$author$project$Remedy$Editor$Form$updateActiveScreen,
			function (oldScreen) {
				return _Utils_update(
					oldScreen,
					{bO: str});
			},
			form);
	});
var $author$project$Request$Remedy$SaveResponse = F2(
	function (remedyId, remedyClientId) {
		return {aa: remedyClientId, cq: remedyId};
	});
var $author$project$Remedy$encodeCapabilityIds = function (capabilities) {
	return A2(
		$elm$json$Json$Encode$list,
		A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Remedy$Capability$serializationId),
		capabilities);
};
var $author$project$Remedy$currentSerializationVersion = 1;
var $author$project$Remedy$ScreenId$encode = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Remedy$LocStr$encode = function (_v0) {
	var englishText = _v0;
	return $elm$json$Json$Encode$string(englishText);
};
var $author$project$Remedy$PropertyBag$empty = _List_Nil;
var $author$project$Remedy$PropertyBag$toJson = function (bag) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return _Utils_Tuple2(
					k,
					$elm$json$Json$Encode$string(v));
			},
			bag));
};
var $author$project$Remedy$Capability$encode = function (capability) {
	var enc = function (props) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Remedy$Capability$serializationId(capability))),
					_Utils_Tuple2(
					'props',
					$author$project$Remedy$PropertyBag$toJson(props))
				]));
	};
	switch (capability.$) {
		case 0:
			return enc($author$project$Remedy$PropertyBag$empty);
		case 1:
			return enc($author$project$Remedy$PropertyBag$empty);
		case 2:
			return enc($author$project$Remedy$PropertyBag$empty);
		case 3:
			var props = capability.b;
			return enc(props);
		default:
			var props = capability.b;
			return enc(props);
	}
};
var $author$project$Util$JsonEncode$url = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $elm$url$Url$toString);
var $author$project$Remedy$Screen$encodeAction = function (a) {
	switch (a.$) {
		case 0:
			var screenId = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('go_to_screen')),
						_Utils_Tuple2(
						'screenId',
						$author$project$Remedy$ScreenId$encode(screenId))
					]));
		case 1:
			var url = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('go_to_url')),
						_Utils_Tuple2(
						'url',
						$author$project$Util$JsonEncode$url(url))
					]));
		default:
			var capability = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('use_capability')),
						_Utils_Tuple2(
						'capability',
						$author$project$Remedy$Capability$encode(capability))
					]));
	}
};
var $author$project$Remedy$Screen$encodeElement = function (element) {
	switch (element.$) {
		case 0:
			var text = element.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('h1')),
						_Utils_Tuple2(
						'text',
						$author$project$Remedy$LocStr$encode(text))
					]));
		case 1:
			var text = element.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('p')),
						_Utils_Tuple2(
						'text',
						$author$project$Remedy$LocStr$encode(text))
					]));
		case 2:
			var url = element.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('img')),
						_Utils_Tuple2(
						'url',
						$author$project$Util$JsonEncode$url(url))
					]));
		case 3:
			var text = element.a;
			var action = element.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('button')),
						_Utils_Tuple2(
						'text',
						$author$project$Remedy$LocStr$encode(text)),
						_Utils_Tuple2(
						'action',
						$author$project$Remedy$Screen$encodeAction(action))
					]));
		default:
			var items = element.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('bulleted-list')),
						_Utils_Tuple2(
						'items',
						A2($elm$json$Json$Encode$list, $author$project$Remedy$LocStr$encode, items))
					]));
	}
};
var $author$project$Remedy$Screen$encode = function (_v0) {
	var screen = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Remedy$ScreenId$encode(screen.bj)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(screen.bO)),
				_Utils_Tuple2(
				'elements',
				A2($elm$json$Json$Encode$list, $author$project$Remedy$Screen$encodeElement, screen.d3))
			]));
};
var $author$project$Remedy$ScreenList$encode = function (_v0) {
	var s = _v0.a;
	var rest = _v0.b;
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$Remedy$Screen$encode,
		A2($elm$core$List$cons, s, rest));
};
var $author$project$Remedy$encodeContent = function (remedy) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'serializationVersion',
			$elm$json$Json$Encode$int($author$project$Remedy$currentSerializationVersion)),
			_Utils_Tuple2(
			'screens',
			$author$project$Remedy$ScreenList$encode(remedy.V))
		]);
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $turboMaCk$any_dict$Dict$Any$toDict = function (_v0) {
	var dict = _v0.e;
	return A2(
		$elm$core$Dict$map,
		$elm$core$Basics$always($elm$core$Tuple$second),
		dict);
};
var $author$project$Remedy$Localization$encodeItem = function (_v0) {
	var locStr = _v0.an;
	var translations = _v0.I;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$author$project$Remedy$LocStr$encode(locStr)),
				_Utils_Tuple2(
				'translations',
				A3(
					$elm$json$Json$Encode$dict,
					$elm$core$Basics$identity,
					$elm$json$Json$Encode$string,
					$turboMaCk$any_dict$Dict$Any$toDict(translations)))
			]));
};
var $author$project$Remedy$Localization$encodeTable = function (_v0) {
	var items = _v0;
	return A2($elm$json$Json$Encode$list, $author$project$Remedy$Localization$encodeItem, items);
};
var $author$project$Remedy$Screen$actionsUsed = function (_v0) {
	var screen = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (elem) {
			if (elem.$ === 3) {
				var action = elem.b;
				return $elm$core$Maybe$Just(action);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		screen.d3);
};
var $author$project$Remedy$Screen$capabilitiesUsed = function (screen) {
	return A2(
		$elm$core$List$filterMap,
		function (action) {
			switch (action.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Nothing;
				default:
					var capability = action.a;
					return $elm$core$Maybe$Just(capability);
			}
		},
		$author$project$Remedy$Screen$actionsUsed(screen));
};
var $author$project$Remedy$requiredHostCapabilities = function (remedy) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$Remedy$Screen$capabilitiesUsed,
		$author$project$Remedy$ScreenList$toList(remedy.V));
};
var $author$project$Remedy$encode = function (_v0) {
	var remedy = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$UUID$encode(remedy.bj)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(remedy.bO)),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$int(remedy.dx)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(remedy.b6)),
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(remedy.cM)),
				_Utils_Tuple2(
				'trigger',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'classificationLabel',
							$elm$json$Json$Encode$string(remedy.hN)),
							_Utils_Tuple2(
							'priority',
							$elm$json$Json$Encode$int(remedy.fc))
						]))),
				_Utils_Tuple2(
				'requiredHostCapabilities',
				$author$project$Remedy$encodeCapabilityIds(
					$author$project$Remedy$requiredHostCapabilities(remedy))),
				_Utils_Tuple2(
				'localizedStrings',
				$author$project$Remedy$Localization$encodeTable(remedy.r)),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$object(
					$author$project$Remedy$encodeContent(remedy)))
			]));
};
var $author$project$Request$Remedy$save = F2(
	function (accessToken, remedy) {
		var responseDecoder = A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'remedyClientId',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Request$Remedy$SaveResponse)));
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Remedy$encode(remedy));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/remedies',
				hU: false
			});
	});
var $author$project$Remedy$Editor$Form$updateScreenFocusedElement = F2(
	function (f, screen) {
		var _v0 = screen.f7;
		if (_v0.$ === 1) {
			return screen;
		} else {
			var elementIndex = _v0.a;
			return _Utils_update(
				screen,
				{
					d3: A3($elm_community$list_extra$List$Extra$updateAt, elementIndex, f, screen.d3)
				});
		}
	});
var $author$project$Remedy$Editor$Form$updateFocusedElement = F2(
	function (fn, form) {
		return A2(
			$author$project$Remedy$Editor$Form$updateActiveScreen,
			$author$project$Remedy$Editor$Form$updateScreenFocusedElement(fn),
			form);
	});
var $author$project$Remedy$Editor$Form$setFocusedButtonAction = F2(
	function (action, _v0) {
		var form = _v0;
		return A2(
			$author$project$Remedy$Editor$Form$updateFocusedElement,
			function (oldElement) {
				if (oldElement.$ === 3) {
					var str = oldElement.a;
					return A2($author$project$Remedy$Editor$Form$Button, str, action);
				} else {
					return oldElement;
				}
			},
			form);
	});
var $author$project$Remedy$PropertyBag$replace = F3(
	function (key, value, bag) {
		return A2(
			$elm$core$List$map,
			function (pair) {
				var k = pair.a;
				return _Utils_eq(k, key) ? _Utils_Tuple2(key, value) : pair;
			},
			bag);
	});
var $author$project$Remedy$Editor$Form$setFocusedButtonActionParameter = F3(
	function (paramName, newValue, _v0) {
		var form = _v0;
		return A2(
			$author$project$Remedy$Editor$Form$updateFocusedElement,
			function (oldElement) {
				if (((oldElement.$ === 3) && (!oldElement.b.$)) && (oldElement.b.a.$ === 5)) {
					var str = oldElement.a;
					var _v2 = oldElement.b.a;
					var capabilityId = _v2.a;
					var props = _v2.b;
					var newProps = A3($author$project$Remedy$PropertyBag$replace, paramName, newValue, props);
					return A2(
						$author$project$Remedy$Editor$Form$Button,
						str,
						$elm$core$Maybe$Just(
							A2($author$project$Remedy$Editor$Form$UseCustomCapability, capabilityId, newProps)));
				} else {
					return oldElement;
				}
			},
			form);
	});
var $author$project$Remedy$Editor$Form$setFocusedElementPrimaryText = F2(
	function (str, _v0) {
		var form = _v0;
		return A2(
			$author$project$Remedy$Editor$Form$updateFocusedElement,
			function (oldElement) {
				switch (oldElement.$) {
					case 0:
						return $author$project$Remedy$Editor$Form$H1(str);
					case 1:
						return $author$project$Remedy$Editor$Form$P(str);
					case 2:
						return $author$project$Remedy$Editor$Form$Img(str);
					case 3:
						var maybeAction = oldElement.b;
						return A2($author$project$Remedy$Editor$Form$Button, str, maybeAction);
					default:
						return $author$project$Remedy$Editor$Form$BulletedList(str);
				}
			},
			form);
	});
var $author$project$Request$Remedy$TranslationResponse = F2(
	function (targetLanguage, keysToTranslations) {
		return {gz: keysToTranslations, hx: targetLanguage};
	});
var $author$project$Remedy$Localization$encodeLanguage = function (_v0) {
	var str = _v0;
	return $elm$json$Json$Encode$string(str);
};
var $author$project$Request$Remedy$translate = F3(
	function (accessToken, lang, localizableStrings) {
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var englishStrings = A2($elm$core$List$map, $author$project$Remedy$LocStr$english, localizableStrings);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'targetLang',
						$author$project$Remedy$Localization$encodeLanguage(lang)),
						_Utils_Tuple2(
						'texts',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, englishStrings))
					])));
		var associateWithKeys = function (translations) {
			return $elm$json$Json$Decode$succeed(
				A3(
					$elm$core$List$map2,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					localizableStrings,
					translations));
		};
		var responseDecoder = A2(
			$elm$json$Json$Decode$map,
			$author$project$Request$Remedy$TranslationResponse(lang),
			A2(
				$elm$json$Json$Decode$andThen,
				associateWithKeys,
				A2(
					$elm$json$Json$Decode$field,
					'texts',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/translate',
				hU: false
			});
	});
var $author$project$Page$Remedy$Editor$updateDef = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hd: f(model.hd)
			});
	});
var $author$project$Remedy$Editor$Problem$ContentProblem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$pack = F3(
	function (lite, stringsTable, screenList) {
		return {dy: lite.dy, dT: lite.dT, b6: lite.b6, cM: lite.cM, bj: lite.bj, r: stringsTable, aa: lite.aa, V: screenList, bO: lite.bO, hN: lite.hN, fc: lite.fc, dx: lite.dx};
	});
var $author$project$Remedy$Editor$Problem$RequiresAtLeastOneScreen = {$: 1};
var $author$project$Remedy$Editor$Problem$ScreenListProblem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$Editor$Form$combineResults = function (results) {
	var combine = F2(
		function (result, _v2) {
			var accErrors = _v2.a;
			var accItems = _v2.b;
			if (!result.$) {
				var items = result.a;
				return _Utils_Tuple2(
					accErrors,
					_Utils_ap(accItems, items));
			} else {
				var errors = result.a;
				return _Utils_Tuple2(
					_Utils_ap(accErrors, errors),
					accItems);
			}
		});
	var _v0 = A3(
		$elm$core$List$foldl,
		combine,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		results);
	if (!_v0.a.b) {
		var items = _v0.b;
		return $elm$core$Result$Ok(items);
	} else {
		var errors = _v0.a;
		return $elm$core$Result$Err(errors);
	}
};
var $author$project$Remedy$ScreenList$DuplicateScreenId = $elm$core$Basics$identity;
var $author$project$Remedy$ScreenId$duplicates = function (ids) {
	var inc = function (maybeCount) {
		if (!maybeCount.$) {
			var n = maybeCount.a;
			return $elm$core$Maybe$Just(n + 1);
		} else {
			return $elm$core$Maybe$Just(1);
		}
	};
	var incrementCounter = F2(
		function (_v1, counts) {
			var id = _v1;
			return A3($elm$core$Dict$update, id, inc, counts);
		});
	return A2(
		$elm$core$List$map,
		$elm$core$Basics$identity,
		$elm$core$Dict$keys(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (_v0, count) {
						return count > 1;
					}),
				A3($elm$core$List$foldl, incrementCounter, $elm$core$Dict$empty, ids))));
};
var $author$project$Remedy$ScreenList$validate = function (screens) {
	var dupeKeys = $author$project$Remedy$ScreenId$duplicates(
		A2($elm$core$List$map, $author$project$Remedy$Screen$id, screens));
	return $elm$core$List$isEmpty(dupeKeys) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err(
		A2($elm$core$List$map, $elm$core$Basics$identity, dupeKeys));
};
var $author$project$Remedy$ScreenList$init = F2(
	function (s, rest) {
		var _v0 = $author$project$Remedy$ScreenList$validate(
			A2($elm$core$List$cons, s, rest));
		if (!_v0.$) {
			return $elm$core$Result$Ok(
				A2($author$project$Remedy$ScreenList$ScreenList, s, rest));
		} else {
			var err = _v0.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Remedy$Editor$Problem$ScreenIsEmpty = {$: 1};
var $author$project$Remedy$Editor$Problem$WithElement = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Remedy$Editor$Problem$WithScreen = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Remedy$Screen$build = F3(
	function (screenId, screenTitle, screenElements) {
		return {d3: screenElements, bj: screenId, bO: screenTitle};
	});
var $author$project$Remedy$Editor$Problem$InvalidElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Remedy$Editor$Form$rawToAction = function (action) {
	switch (action.$) {
		case 0:
			var targetScreenId = action.a;
			return $elm$core$Result$Ok(
				$author$project$Remedy$Screen$GoToScreen(targetScreenId));
		case 1:
			var str = action.a;
			var _v1 = $elm$url$Url$fromString(str);
			if (!_v1.$) {
				var url = _v1.a;
				return $elm$core$Result$Ok(
					$author$project$Remedy$Screen$GoToUrl(url));
			} else {
				return $elm$core$Result$Err(
					_List_fromArray(
						[
							$author$project$Remedy$Editor$Problem$InvalidElement('Invalid url')
						]));
			}
		case 2:
			return $elm$core$Result$Ok(
				$author$project$Remedy$Screen$UseCapability($author$project$Remedy$Capability$TalkToAgent));
		case 3:
			return $elm$core$Result$Ok(
				$author$project$Remedy$Screen$UseCapability($author$project$Remedy$Capability$GoToMarket));
		case 4:
			return $elm$core$Result$Ok(
				$author$project$Remedy$Screen$UseCapability($author$project$Remedy$Capability$Dismiss));
		default:
			var str = action.a;
			var props = action.b;
			return $elm$core$Result$Ok(
				$author$project$Remedy$Screen$UseCapability(
					A2($author$project$Remedy$Capability$Custom, str, props)));
	}
};
var $author$project$Remedy$Editor$Form$rawToElement = function (raw) {
	switch (raw.$) {
		case 0:
			var str = raw.a;
			return $author$project$Util$String$isBlank(str) ? $elm$core$Result$Err(
				_List_fromArray(
					[
						$author$project$Remedy$Editor$Problem$InvalidElement('The text must not be empty')
					])) : $elm$core$Result$Ok(
				$author$project$Remedy$Screen$H1(
					$author$project$Remedy$LocStr$new(str)));
		case 1:
			var str = raw.a;
			return $author$project$Util$String$isBlank(str) ? $elm$core$Result$Err(
				_List_fromArray(
					[
						$author$project$Remedy$Editor$Problem$InvalidElement('The text must not be empty')
					])) : $elm$core$Result$Ok(
				$author$project$Remedy$Screen$P(
					$author$project$Remedy$LocStr$new(str)));
		case 2:
			var str = raw.a;
			var _v1 = $elm$url$Url$fromString(str);
			if (_v1.$ === 1) {
				return $elm$core$Result$Err(
					_List_fromArray(
						[
							$author$project$Remedy$Editor$Problem$InvalidElement('Invalid image URL')
						]));
			} else {
				var url = _v1.a;
				return $elm$core$Result$Ok(
					$author$project$Remedy$Screen$Img(url));
			}
		case 4:
			var str = raw.a;
			var _v2 = $author$project$Remedy$Editor$Form$unpackBulletedList(str);
			if (!_v2.b) {
				return $elm$core$Result$Err(
					_List_fromArray(
						[
							$author$project$Remedy$Editor$Problem$InvalidElement('Each line in the list must start with \'- \'')
						]));
			} else {
				var items = _v2;
				return A2($elm$core$List$any, $author$project$Util$String$isBlank, items) ? $elm$core$Result$Err(
					_List_fromArray(
						[
							$author$project$Remedy$Editor$Problem$InvalidElement('List item text must not be empty')
						])) : $elm$core$Result$Ok(
					$author$project$Remedy$Screen$BulletedList(
						A2($elm$core$List$map, $author$project$Remedy$LocStr$new, items)));
			}
		default:
			var str = raw.a;
			var maybeAction = raw.b;
			var validatedActionResult = A2(
				$elm$core$Result$andThen,
				$author$project$Remedy$Editor$Form$rawToAction,
				A2(
					$elm$core$Result$fromMaybe,
					_List_fromArray(
						[
							$author$project$Remedy$Editor$Problem$InvalidElement('Must pick an action to perform')
						]),
					maybeAction));
			var buttonProblems = $author$project$Util$String$isBlank(str) ? _List_fromArray(
				[
					$author$project$Remedy$Editor$Problem$InvalidElement('The button text must not be empty')
				]) : _List_Nil;
			if (validatedActionResult.$ === 1) {
				var actionProblems = validatedActionResult.a;
				return $elm$core$Result$Err(
					_Utils_ap(buttonProblems, actionProblems));
			} else {
				var action = validatedActionResult.a;
				return $elm$core$List$isEmpty(buttonProblems) ? $elm$core$Result$Ok(
					A2(
						$author$project$Remedy$Screen$Button,
						$author$project$Remedy$LocStr$new(str),
						action)) : $elm$core$Result$Err(buttonProblems);
			}
	}
};
var $author$project$Remedy$Editor$Form$rawToScreen = function (screen) {
	return $elm$core$List$isEmpty(screen.d3) ? $elm$core$Result$Err(
		_List_fromArray(
			[
				A2($author$project$Remedy$Editor$Problem$WithScreen, screen.bj, $author$project$Remedy$Editor$Problem$ScreenIsEmpty)
			])) : A2(
		$elm$core$Result$map,
		A2($author$project$Remedy$Screen$build, screen.bj, screen.bO),
		$author$project$Remedy$Editor$Form$combineResults(
			A2(
				$elm$core$List$map,
				$elm$core$Result$map($elm$core$List$singleton),
				A2(
					$elm$core$List$indexedMap,
					function (idx) {
						return $elm$core$Result$mapError(
							$elm$core$List$map(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Remedy$Editor$Problem$WithScreen(screen.bj),
									$author$project$Remedy$Editor$Problem$WithElement(idx))));
					},
					A2($elm$core$List$map, $author$project$Remedy$Editor$Form$rawToElement, screen.d3)))));
};
var $author$project$Remedy$Editor$Form$toScreenList = function (_v0) {
	var form = _v0;
	var validatedScreensResult = $author$project$Remedy$Editor$Form$combineResults(
		A2(
			$elm$core$List$map,
			$elm$core$Result$map($elm$core$List$singleton),
			A2(
				$elm$core$List$map,
				$author$project$Remedy$Editor$Form$rawToScreen,
				$author$project$Remedy$Editor$Form$allScreens(form))));
	if (validatedScreensResult.$ === 1) {
		var problems = validatedScreensResult.a;
		return $elm$core$Result$Err(problems);
	} else {
		if (!validatedScreensResult.a.b) {
			return $elm$core$Result$Err(
				_List_fromArray(
					[$author$project$Remedy$Editor$Problem$RequiresAtLeastOneScreen]));
		} else {
			var _v2 = validatedScreensResult.a;
			var first = _v2.a;
			var others = _v2.b;
			return A2(
				$elm$core$Result$mapError,
				$elm$core$List$map($author$project$Remedy$Editor$Problem$ScreenListProblem),
				A2($author$project$Remedy$ScreenList$init, first, others));
		}
	}
};
var $author$project$Remedy$Editor$Problem$MetaProblem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$Editor$Validation$validateMeta = function (remedy) {
	var validPriority = function (p) {
		return (0 <= p) && (p <= 100);
	};
	return $elm$core$String$isEmpty(remedy.bO) ? _List_fromArray(
		[
			$author$project$Remedy$Editor$Problem$MetaProblem('Title must not be empty')
		]) : ((!validPriority(remedy.fc)) ? _List_fromArray(
		[
			$author$project$Remedy$Editor$Problem$MetaProblem('Priority must be between 0 and 100')
		]) : ((remedy.cM && $elm$core$String$isEmpty(remedy.hN)) ? _List_fromArray(
		[
			$author$project$Remedy$Editor$Problem$MetaProblem('Enabled remedies must also have a non-empty trigger')
		]) : _List_Nil));
};
var $author$project$Remedy$Editor$Problem$ScreenIsUnreachable = {$: 2};
var $author$project$Remedy$Editor$Problem$ScreenTargetCausesCycle = {$: 2};
var $author$project$Remedy$Editor$Problem$ScreenTargetNotFound = {$: 1};
var $author$project$Remedy$ScreenList$others = function (_v0) {
	var rest = _v0.b;
	return rest;
};
var $author$project$Remedy$Editor$Validation$TransitionCycle = 2;
var $author$project$Remedy$Editor$Validation$TransitionGoesNowhere = 1;
var $author$project$Remedy$Editor$Validation$TransitionOk = 0;
var $author$project$Remedy$ScreenList$find = F2(
	function (screenId, _v0) {
		var s = _v0.a;
		var rest = _v0.b;
		return _Utils_eq(
			$author$project$Remedy$Screen$id(s),
			screenId) ? $elm$core$Maybe$Just(s) : A2(
			$elm_community$list_extra$List$Extra$find,
			function (s2) {
				return _Utils_eq(
					$author$project$Remedy$Screen$id(s2),
					screenId);
			},
			rest);
	});
var $author$project$Remedy$Editor$Validation$collectScreenTransitions = F3(
	function (currentScreen, screens, idsSoFar) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				A3($author$project$Remedy$Editor$Validation$transitionsFromElement, currentScreen, screens, idsSoFar),
				$author$project$Remedy$Screen$elements(currentScreen)));
	});
var $author$project$Remedy$Editor$Validation$collectTransitionsHelper = F4(
	function (from, destScreenId, screens, idsSoFar) {
		var _v1 = A2($author$project$Remedy$ScreenList$find, destScreenId, screens);
		if (!_v1.$) {
			var targetScreen = _v1.a;
			return A2($elm$core$List$member, destScreenId, idsSoFar) ? _List_fromArray(
				[
					{bg: from, e3: 2, bP: destScreenId}
				]) : A2(
				$elm$core$List$cons,
				{bg: from, e3: 0, bP: destScreenId},
				A3(
					$author$project$Remedy$Editor$Validation$collectScreenTransitions,
					targetScreen,
					screens,
					A2($elm$core$List$cons, destScreenId, idsSoFar)));
		} else {
			return _List_fromArray(
				[
					{bg: from, e3: 1, bP: destScreenId}
				]);
		}
	});
var $author$project$Remedy$Editor$Validation$transitionsFromElement = F5(
	function (currentScreen, screens, idsSoFar, idx, elem) {
		if ((elem.$ === 3) && (!elem.b.$)) {
			var destScreenId = elem.b.a;
			return A4(
				$author$project$Remedy$Editor$Validation$collectTransitionsHelper,
				{
					d2: idx,
					eX: $author$project$Remedy$Screen$id(currentScreen)
				},
				destScreenId,
				screens,
				idsSoFar);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Remedy$Editor$Validation$validateTransitions = function (screens) {
	var firstScreen = $author$project$Remedy$ScreenList$first(screens);
	var transitions = A3(
		$author$project$Remedy$Editor$Validation$collectScreenTransitions,
		firstScreen,
		screens,
		_List_fromArray(
			[
				$author$project$Remedy$Screen$id(firstScreen)
			]));
	var filterByStatus = function (status) {
		return A2(
			$elm$core$List$filter,
			function (it) {
				return _Utils_eq(it.e3, status);
			},
			transitions);
	};
	return {
		cH: filterByStatus(2),
		cP: filterByStatus(1),
		dw: filterByStatus(0)
	};
};
var $author$project$Remedy$Editor$Validation$validateScreens = function (screens) {
	var transitionSummary = $author$project$Remedy$Editor$Validation$validateTransitions(screens);
	var reachableScreenIds = A2(
		$elm$core$List$map,
		function ($) {
			return $.bP;
		},
		transitionSummary.dw);
	var unreachableScreenIds = A2(
		$elm$core$List$filter,
		function (id) {
			return !A2($elm$core$List$member, id, reachableScreenIds);
		},
		A2(
			$elm$core$List$map,
			$author$project$Remedy$Screen$id,
			$author$project$Remedy$ScreenList$others(screens)));
	var makeTransitionProblem = F2(
		function (elemProblem, _v0) {
			var from = _v0.bg;
			return A2(
				$author$project$Remedy$Editor$Problem$WithScreen,
				from.eX,
				A2($author$project$Remedy$Editor$Problem$WithElement, from.d2, elemProblem));
		});
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			function (id) {
				return A2($author$project$Remedy$Editor$Problem$WithScreen, id, $author$project$Remedy$Editor$Problem$ScreenIsUnreachable);
			},
			unreachableScreenIds),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				makeTransitionProblem($author$project$Remedy$Editor$Problem$ScreenTargetNotFound),
				transitionSummary.cP),
			A2(
				$elm$core$List$map,
				makeTransitionProblem($author$project$Remedy$Editor$Problem$ScreenTargetCausesCycle),
				transitionSummary.cH)));
};
var $author$project$Remedy$Editor$Validation$validate = F4(
	function (mode, remedy, localizedStrings, form) {
		var remedyResult = function () {
			var _v2 = $author$project$Remedy$Editor$Form$toScreenList(form);
			if (_v2.$ === 1) {
				var problems = _v2.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$map, $author$project$Remedy$Editor$Problem$ContentProblem, problems));
			} else {
				var screenList = _v2.a;
				var _v3 = $author$project$Remedy$Editor$Validation$validateScreens(screenList);
				if (!_v3.b) {
					return $elm$core$Result$Ok(
						A3($author$project$Remedy$pack, remedy, localizedStrings, screenList));
				} else {
					var moreProblems = _v3;
					return $elm$core$Result$Err(
						A2($elm$core$List$map, $author$project$Remedy$Editor$Problem$ContentProblem, moreProblems));
				}
			}
		}();
		var metaProblems = function () {
			if (!mode) {
				return $author$project$Remedy$Editor$Validation$validateMeta(remedy);
			} else {
				return _List_Nil;
			}
		}();
		if (!remedyResult.$) {
			return $elm$core$List$isEmpty(metaProblems) ? remedyResult : $elm$core$Result$Err(metaProblems);
		} else {
			var problems = remedyResult.a;
			return $elm$core$Result$Err(
				_Utils_ap(metaProblems, problems));
		}
	});
var $author$project$Page$Remedy$Editor$validate = F2(
	function (mode, _v0) {
		var remedy = _v0.hd;
		var localizedStrings = _v0.r;
		var form = _v0.d;
		return A4($author$project$Remedy$Editor$Validation$validate, mode, remedy, localizedStrings, form);
	});
var $author$project$Page$Remedy$Editor$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a9: tab}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var screenId = msg.a;
				var _v1 = A2($author$project$Remedy$Editor$Form$activateScreen, screenId, model.d);
				if (!_v1.$) {
					var newForm = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d: newForm}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							model,
							_List_fromArray(
								['Screen not found'])),
						$elm$core$Platform$Cmd$none);
				}
			case 26:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: $author$project$Page$Remedy$Editor$LangModal}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: A2($author$project$Remedy$Localization$addLanguage, lang, model.r),
							S: $author$project$Page$Remedy$Editor$NoModal,
							ax: lang
						}),
					$elm$core$Platform$Cmd$none);
			case 33:
				var targetLang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aj: true}),
					A2(
						$elm$http$Http$send,
						$author$project$Page$Remedy$Editor$AutoTranslateResponse,
						A3(
							$author$project$Request$Remedy$translate,
							model.a,
							targetLang,
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								A2($author$project$Remedy$Localization$batchTranslate, model.r, $author$project$Remedy$Localization$defaultLanguageTag)))));
			case 34:
				var isAutoTranslateChecked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bm: isAutoTranslateChecked}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var newTitle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Remedy$Editor$updateDef,
						function (meta) {
							return _Utils_update(
								meta,
								{bO: newTitle});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 3:
				var str = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Remedy$Editor$updateDef,
						function (meta) {
							return _Utils_update(
								meta,
								{b6: str});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 4:
				var enabled = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Remedy$Editor$updateDef,
						function (meta) {
							return _Utils_update(
								meta,
								{cM: enabled});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 5:
				var str = msg.a;
				var priority = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(str));
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Remedy$Editor$updateDef,
						function (meta) {
							return _Utils_update(
								meta,
								{fc: priority});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 6:
				var label = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Remedy$Editor$updateDef,
						function (meta) {
							return _Utils_update(
								meta,
								{hN: label});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 7:
				var _v2 = A2($author$project$Page$Remedy$Editor$validate, 0, model);
				if (!_v2.$) {
					var remedy = _v2.a;
					return _Utils_Tuple2(
						$author$project$Util$clearErrors(
							_Utils_update(
								model,
								{cg: true})),
						A2(
							$elm$http$Http$send,
							$author$project$Page$Remedy$Editor$SaveResult,
							A2(
								$author$project$Request$Remedy$save,
								model.a,
								$author$project$Remedy$bumpVersion(remedy))));
				} else {
					var problems = _v2.a;
					return A3($author$project$Page$Remedy$Editor$handleValidationErrors, 'Cannot save: validation failed.', model, problems);
				}
			case 8:
				var result = msg.a;
				var newModel = _Utils_update(
					model,
					{cg: false});
				if (!result.$) {
					return _Utils_Tuple2(
						$author$project$Util$clearErrors(newModel),
						A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListRemedies));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$setErrors,
							newModel,
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(error)
								])),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				return _Utils_Tuple2(
					$author$project$Util$clearErrors(model),
					$elm$core$Platform$Cmd$none);
			case 12:
				var _v4 = A2($author$project$Page$Remedy$Editor$validate, 1, model);
				if (!_v4.$) {
					var remedy = _v4.a;
					return _Utils_Tuple2(
						$author$project$Util$clearErrors(
							_Utils_update(
								model,
								{
									S: $author$project$Page$Remedy$Editor$PreviewModal(
										A2($author$project$Page$Remedy$Editor$newPreviewState, remedy, model))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var problems = _v4.a;
					return A3($author$project$Page$Remedy$Editor$handleValidationErrors, 'Cannot preview the remedy: validation failed.', model, problems);
				}
			case 13:
				var _v5 = model.S;
				if (_v5.$ === 4) {
					var state = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								S: $author$project$Page$Remedy$Editor$PreviewModal(
									A2($author$project$Page$Remedy$Editor$newPreviewState, state.hd, model))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var lang = msg.a;
				var _v6 = model.S;
				if (_v6.$ === 4) {
					var previewState = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								S: $author$project$Page$Remedy$Editor$PreviewModal(
									_Utils_update(
										previewState,
										{gB: lang}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							model,
							_List_fromArray(
								['Cannot change preview language: modal is not active.'])),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ax: lang}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var actions = msg.a;
				return _Utils_Tuple2(
					A3($elm$core$List$foldl, $author$project$Page$Remedy$Editor$invokePreviewAction, model, actions),
					$elm$core$Platform$Cmd$none);
			case 15:
				var elementIndex = msg.a;
				var _v7 = A2($author$project$Remedy$Editor$Form$focusOnElement, elementIndex, model.d);
				var newForm = _v7.a;
				var focusTask = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d: newForm}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Page$Remedy$Editor$FocusedDomElement),
						focusTask));
			case 29:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d: $author$project$Remedy$Editor$Form$defocus(model.d)
						}),
					$elm$core$Platform$Cmd$none);
			case 28:
				return _Utils_eq(model.S, $author$project$Page$Remedy$Editor$NoModal) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d: $author$project$Remedy$Editor$Form$defocus(model.d)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{S: $author$project$Page$Remedy$Editor$NoModal}),
					$elm$core$Platform$Cmd$none);
			case 20:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 16:
				var str = msg.a;
				return _Utils_Tuple2(
					$author$project$Page$Remedy$Editor$syncLocalizedStrings(
						_Utils_update(
							model,
							{
								d: A2($author$project$Remedy$Editor$Form$setFocusedElementPrimaryText, str, model.d)
							})),
					$elm$core$Platform$Cmd$none);
			case 17:
				var choice = msg.a;
				var elem = function () {
					switch (choice) {
						case 1:
							return $author$project$Remedy$Editor$Form$P('');
						case 0:
							return $author$project$Remedy$Editor$Form$H1('');
						case 3:
							return $author$project$Remedy$Editor$Form$BulletedList('');
						case 2:
							return A2($author$project$Remedy$Editor$Form$Button, '', $elm$core$Maybe$Nothing);
						default:
							return $author$project$Remedy$Editor$Form$Img('');
					}
				}();
				var _v8 = A2($author$project$Remedy$Editor$Form$addAndFocusElement, elem, model.d);
				var newForm = _v8.a;
				var focusTask = _v8.b;
				return _Utils_Tuple2(
					$author$project$Page$Remedy$Editor$syncLocalizedStrings(
						_Utils_update(
							model,
							{d: newForm})),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Page$Remedy$Editor$FocusedDomElement),
						focusTask));
			case 21:
				return _Utils_Tuple2(
					$author$project$Page$Remedy$Editor$syncLocalizedStrings(
						_Utils_update(
							model,
							{
								d: $author$project$Remedy$Editor$Form$deleteFocusedElement(model.d)
							})),
					$elm$core$Platform$Cmd$none);
			case 22:
				var direction = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d: A2($author$project$Remedy$Editor$Form$moveFocusedElement, direction, model.d)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d: A2($author$project$Remedy$Editor$Form$setFocusedButtonAction, action, model.d)
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var paramName = msg.a;
				var newValue = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d: A3($author$project$Remedy$Editor$Form$setFocusedButtonActionParameter, paramName, newValue, model.d)
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				return _Utils_Tuple2(
					$author$project$Page$Remedy$Editor$syncLocalizedStrings(
						_Utils_update(
							model,
							{
								d: $author$project$Remedy$Editor$Form$deleteActiveScreen(model.d)
							})),
					$elm$core$Platform$Cmd$none);
			case 24:
				var modal = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: modal}),
					$elm$core$Platform$Cmd$none);
			case 25:
				return _Utils_Tuple2(
					function () {
						var _v10 = model.S;
						if (_v10.$ === 1) {
							var isNew = _v10.a.bq;
							var textFieldStorage = _v10.a.a0;
							return $author$project$Page$Remedy$Editor$syncLocalizedStrings(
								isNew ? _Utils_update(
									model,
									{
										d: A2($author$project$Remedy$Editor$Form$addScreen, textFieldStorage, model.d),
										S: $author$project$Page$Remedy$Editor$NoModal
									}) : _Utils_update(
									model,
									{
										d: A2($author$project$Remedy$Editor$Form$renameActiveScreen, textFieldStorage, model.d),
										S: $author$project$Page$Remedy$Editor$NoModal
									}));
						} else {
							return A2(
								$author$project$Util$appendErrors,
								model,
								_List_fromArray(
									['Invalid state: cannot commit because no screen modal is active.']));
						}
					}(),
					$elm$core$Platform$Cmd$none);
			case 30:
				var locStr = msg.a;
				var lang = msg.b;
				var newTranslation = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: A4($author$project$Remedy$Localization$edit, locStr, lang, newTranslation, model.r)
						}),
					$elm$core$Platform$Cmd$none);
			case 31:
				var targetLang = msg.a;
				var localizableStrings = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aj: true}),
					A2(
						$elm$http$Http$send,
						$author$project$Page$Remedy$Editor$AutoTranslateResponse,
						A3($author$project$Request$Remedy$translate, model.a, targetLang, localizableStrings)));
			default:
				var result = msg.a;
				return _Utils_Tuple2(
					function () {
						if (!result.$) {
							var targetLanguage = result.a.hx;
							var keysToTranslations = result.a.gz;
							return _Utils_update(
								model,
								{
									aj: false,
									r: A3($author$project$Remedy$Localization$batchEdit, targetLanguage, keysToTranslations, model.r)
								});
						} else {
							var error = result.a;
							return _Utils_update(
								model,
								{aj: false});
						}
					}(),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Remedy$History$Failed = {$: 2};
var $author$project$Page$Remedy$History$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Remedy$History$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cu: true}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var timePeriod = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hr: $author$project$Page$Remedy$History$Loading}),
					A3($author$project$Page$Remedy$History$fetchRemedyStats, model.a, model.cq, timePeriod));
			default:
				if (!msg.a.$) {
					var stats = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hr: $author$project$Page$Remedy$History$Loaded(stats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hr: $author$project$Page$Remedy$History$Failed}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Remedy$List$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bL: filter}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var sort = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bJ: sort}),
					$elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var remedyId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aq: function () {
								var _v1 = model.aq;
								if (!_v1.$) {
									var id = _v1.a;
									return _Utils_eq(id, remedyId) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(remedyId);
								} else {
									return $elm$core$Maybe$Just(remedyId);
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bG: text}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Remedy$Viewer$CompletedRemedyDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Remedy$Viewer$Failed = {$: 2};
var $author$project$Page$Remedy$Viewer$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Request$Remedy$delete = F2(
	function (accessToken, id) {
		var url = '/gym/remedies/' + $author$project$UUID$toString(id);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		return A2($author$project$Util$Http$deleteAndIgnoreWithHeaders, headers, url);
	});
var $author$project$Page$Remedy$Viewer$invoke = F2(
	function (action, model) {
		switch (action.$) {
			case 0:
				var screenId = action.a;
				return _Utils_update(
					model,
					{aE: screenId});
			case 1:
				return model;
			default:
				return model;
		}
	});
var $author$project$Page$Remedy$Viewer$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var actions = msg.a;
				return _Utils_Tuple2(
					A3($elm$core$List$foldl, $author$project$Page$Remedy$Viewer$invoke, model, actions),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aE: $author$project$Remedy$firstScreenId(model.hd)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gB: lang}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bw: mode}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bi: function () {
								if (!result.$) {
									var hist = result.a;
									return $author$project$Page$Remedy$Viewer$Loaded(hist);
								} else {
									return $author$project$Page$Remedy$Viewer$Failed;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var dialog = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b7: dialog}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var _v2 = model.b7;
				if (_v2 === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b7: 0, bo: true}),
						A2(
							$elm$http$Http$send,
							$author$project$Page$Remedy$Viewer$CompletedRemedyDelete,
							A2(
								$author$project$Request$Remedy$delete,
								model.a,
								$author$project$Remedy$id(model.hd))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var result = msg.a;
				if (!result.$) {
					return _Utils_Tuple2(
						model,
						A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListRemedies));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Util$appendErrors,
							_Utils_update(
								model,
								{bo: false}),
							_List_fromArray(
								[
									$author$project$Util$Http$errorToString(error)
								])),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Page$Scrubber$Editor$GotPreviewIncident = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Scrubber$Editor$addNewRedactor = function (oldScrubber) {
	return _Utils_update(
		oldScrubber,
		{
			df: _Utils_ap(
				oldScrubber.df,
				_List_fromArray(
					[
						$author$project$Data$Scrubber$newRedactor($author$project$Data$Scrubber$defaultRedactorType)
					]))
		});
};
var $author$project$Page$Scrubber$Editor$handleSaveResult = F3(
	function (model, httpResult, navKey) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil}),
				A2($author$project$App$Route$pushUrlCmd, navKey, $author$project$App$Route$ListScrubbers));
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Scrubber$Editor$makeTryState = function (tryResponse) {
	return A2(
		$elm$core$Result$mapError,
		$elm$json$Json$Decode$errorToString,
		A2(
			$elm$core$Result$map,
			function (parsedData) {
				return {gk: parsedData, ep: tryResponse.ep, cy: $author$project$JsonTree$View$init};
			},
			A2($author$project$JsonTree$parse, tryResponse.gk, _List_Nil)));
};
var $author$project$Data$Scrubber$configToType = function (redactorConfig) {
	switch (redactorConfig.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Data$Scrubber$configToSerializationId = function (redactorConfig) {
	var _v0 = $author$project$Data$Scrubber$configToType(redactorConfig);
	switch (_v0) {
		case 0:
			return 'GENERIC_STRING_REDACTOR';
		case 1:
			return 'INCIDENT_DATA_REDACTOR';
		case 2:
			return 'PLAINTEXT_FILE_REDACTOR';
		default:
			return 'JSON_FILE_REDACTOR';
	}
};
var $author$project$Data$Scrubber$encodeConfig = function (cfg) {
	var encodeStringOrNull = function (s) {
		return $elm$core$String$isEmpty(s) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(s);
	};
	switch (cfg.$) {
		case 0:
			var redactionPattern = cfg.a.B;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'@type',
						$elm$json$Json$Encode$string(
							$author$project$Data$Scrubber$configToSerializationId(cfg))),
						_Utils_Tuple2(
						'redactionPattern',
						$elm$json$Json$Encode$string(redactionPattern))
					]));
		case 1:
			var keyPath = cfg.a.gy;
			var redactionPattern = cfg.a.B;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'@type',
						$elm$json$Json$Encode$string(
							$author$project$Data$Scrubber$configToSerializationId(cfg))),
						_Utils_Tuple2(
						'keyPath',
						$elm$core$String$isEmpty(keyPath) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(keyPath)),
						_Utils_Tuple2(
						'redactionPattern',
						encodeStringOrNull(redactionPattern))
					]));
		case 2:
			var fileNamePattern = cfg.a.aH;
			var redactionPattern = cfg.a.B;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'@type',
						$elm$json$Json$Encode$string(
							$author$project$Data$Scrubber$configToSerializationId(cfg))),
						_Utils_Tuple2(
						'fileNamePattern',
						$elm$json$Json$Encode$string(fileNamePattern)),
						_Utils_Tuple2(
						'redactionPattern',
						$elm$json$Json$Encode$string(redactionPattern))
					]));
		default:
			var fileNamePattern = cfg.a.aH;
			var keyPath = cfg.a.gy;
			var redactionPattern = cfg.a.B;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'@type',
						$elm$json$Json$Encode$string(
							$author$project$Data$Scrubber$configToSerializationId(cfg))),
						_Utils_Tuple2(
						'fileNamePattern',
						$elm$json$Json$Encode$string(fileNamePattern)),
						_Utils_Tuple2(
						'keyPath',
						$elm$json$Json$Encode$string(keyPath)),
						_Utils_Tuple2(
						'redactionPattern',
						encodeStringOrNull(redactionPattern))
					]));
	}
};
var $author$project$Data$Scrubber$encode = function (def) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$UUID$encode(def.bj)),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$int(def.dx)),
				_Utils_Tuple2(
				'actor',
				$elm$json$Json$Encode$string(def.dy)),
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(def.cM)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(def.b6)),
				_Utils_Tuple2(
				'redactorConfigs',
				A2($elm$json$Json$Encode$list, $author$project$Data$Scrubber$encodeConfig, def.df))
			]));
};
var $author$project$Data$Incident$TryScrubberResponse = F2(
	function (incidentData, logMetas) {
		return {gk: incidentData, ep: logMetas};
	});
var $author$project$Data$Incident$tryScrubberDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'logMetas',
	$elm$json$Json$Decode$list($author$project$Data$Incident$logMetaDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'incidentData',
		$elm$json$Json$Decode$value,
		$elm$json$Json$Decode$succeed($author$project$Data$Incident$TryScrubberResponse)));
var $author$project$Request$Scrubber$try = F3(
	function (accessToken, scrubber, incidentId) {
		var responseDecoder = $author$project$Data$Incident$tryScrubberDecoder;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$Scrubber$encode(scrubber));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/scrubbers/try/incidents/' + $author$project$UUID$toString(incidentId),
				hU: false
			});
	});
var $author$project$Page$Scrubber$Editor$updateRedactor = F3(
	function (index, f, scrubber) {
		return _Utils_update(
			scrubber,
			{
				df: A3($elm_community$list_extra$List$Extra$updateAt, index, f, scrubber.df)
			});
	});
var $author$project$Page$Scrubber$Editor$updateScrubber = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				E: f(model.E)
			});
	});
var $author$project$Page$Scrubber$Editor$updateRedactorAndScrubber = F3(
	function (index, f, model) {
		return A2(
			$author$project$Page$Scrubber$Editor$updateScrubber,
			function (s) {
				return A3($author$project$Page$Scrubber$Editor$updateRedactor, index, f, s);
			},
			model);
	});
var $author$project$Page$Scrubber$Editor$configToRedactionPattern = function (config) {
	switch (config.$) {
		case 0:
			var redactionPattern = config.a.B;
			return redactionPattern;
		case 1:
			var redactionPattern = config.a.B;
			return redactionPattern;
		case 2:
			var redactionPattern = config.a.B;
			return redactionPattern;
		default:
			var redactionPattern = config.a.B;
			return redactionPattern;
	}
};
var $author$project$Page$Scrubber$Editor$redactionPatternStartsWithDotStar = function (config) {
	return A2(
		$elm$core$String$startsWith,
		'.*',
		$author$project$Page$Scrubber$Editor$configToRedactionPattern(config));
};
var $author$project$Page$Scrubber$Editor$SaveCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Request$Scrubber$save = F2(
	function (accessToken, scrubber) {
		var responseDecoder = $elm$json$Json$Decode$succeed(0);
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$Scrubber$encode(scrubber));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(responseDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: '/gym/scrubbers',
				hU: false
			});
	});
var $author$project$Page$Scrubber$Editor$save = function (model) {
	var scrubber = model.E;
	var newScrubber = _Utils_update(
		scrubber,
		{dx: scrubber.dx + 1});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{f$: _List_Nil, cg: true}),
		A2(
			$elm$core$Task$attempt,
			$author$project$Page$Scrubber$Editor$SaveCompleted,
			$elm$http$Http$toTask(
				A2($author$project$Request$Scrubber$save, model.a, newScrubber))));
};
var $author$project$Page$Scrubber$Editor$validateAndSave = function (model) {
	return A2($elm$core$List$any, $author$project$Page$Scrubber$Editor$redactionPatternStartsWithDotStar, model.E.df) ? _Utils_Tuple2(
		A2(
			$author$project$Util$setErrors,
			model,
			_List_fromArray(
				['Redaction pattern starts with \'.*\', which is inefficient and unnecessary. Please remove it.'])),
		$elm$core$Platform$Cmd$none) : $author$project$Page$Scrubber$Editor$save(model);
};
var $author$project$Page$Scrubber$Editor$update = F3(
	function (navKey, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return $author$project$Page$Scrubber$Editor$validateAndSave(model);
			case 2:
				var result = msg.a;
				return A3($author$project$Page$Scrubber$Editor$handleSaveResult, model, result, navKey);
			case 3:
				var newDescription = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Scrubber$Editor$updateScrubber,
						function (s) {
							return _Utils_update(
								s,
								{b6: newDescription});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 4:
				var newEnabled = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Scrubber$Editor$updateScrubber,
						function (s) {
							return _Utils_update(
								s,
								{cM: newEnabled});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					A2($author$project$Page$Scrubber$Editor$updateScrubber, $author$project$Page$Scrubber$Editor$addNewRedactor, model),
					$elm$core$Platform$Cmd$none);
			case 9:
				var index = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Scrubber$Editor$updateScrubber,
						function (s) {
							return _Utils_update(
								s,
								{
									df: A2($elm_community$list_extra$List$Extra$removeAt, index, s.df)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 5:
				var index = msg.a;
				var redactorType = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Page$Scrubber$Editor$updateRedactorAndScrubber,
						index,
						function (_v1) {
							return $author$project$Data$Scrubber$newRedactor(redactorType);
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var newKeyPath = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Page$Scrubber$Editor$updateRedactorAndScrubber,
						index,
						function (r) {
							switch (r.$) {
								case 1:
									var m = r.a;
									return $author$project$Data$Scrubber$IncidentDataRedactor(
										_Utils_update(
											m,
											{gy: newKeyPath}));
								case 3:
									var m = r.a;
									return $author$project$Data$Scrubber$JsonFileRedactor(
										_Utils_update(
											m,
											{gy: newKeyPath}));
								default:
									return r;
							}
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var newPattern = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Page$Scrubber$Editor$updateRedactorAndScrubber,
						index,
						function (r) {
							switch (r.$) {
								case 2:
									var m = r.a;
									return $author$project$Data$Scrubber$PlaintextFileRedactor(
										_Utils_update(
											m,
											{aH: newPattern}));
								case 3:
									var m = r.a;
									return $author$project$Data$Scrubber$JsonFileRedactor(
										_Utils_update(
											m,
											{aH: newPattern}));
								default:
									return r;
							}
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var index = msg.a;
				var newPattern = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Page$Scrubber$Editor$updateRedactorAndScrubber,
						index,
						function (r) {
							switch (r.$) {
								case 0:
									var m = r.a;
									return $author$project$Data$Scrubber$GenericStringRedactor(
										_Utils_update(
											m,
											{B: newPattern}));
								case 1:
									var m = r.a;
									return $author$project$Data$Scrubber$IncidentDataRedactor(
										_Utils_update(
											m,
											{B: newPattern}));
								case 2:
									var m = r.a;
									return $author$project$Data$Scrubber$PlaintextFileRedactor(
										_Utils_update(
											m,
											{B: newPattern}));
								default:
									var m = r.a;
									return $author$project$Data$Scrubber$JsonFileRedactor(
										_Utils_update(
											m,
											{B: newPattern}));
							}
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 11:
				var newId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bk: newId}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: true}),
					A2(
						$elm$http$Http$send,
						$author$project$Page$Scrubber$Editor$GotPreviewIncident,
						A3(
							$author$project$Request$Scrubber$try,
							model.a,
							model.E,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$UUID$nil,
								$author$project$UUID$fromString(model.bk)))));
			case 13:
				var result = msg.a;
				return _Utils_Tuple2(
					function () {
						var _v5 = A2(
							$elm$core$Result$andThen,
							$author$project$Page$Scrubber$Editor$makeTryState,
							A2($elm$core$Result$mapError, $author$project$Util$Http$errorToString, result));
						if (!_v5.$) {
							var tryState = _v5.a;
							return _Utils_update(
								model,
								{
									aL: false,
									aV: $krisajenkins$remotedata$RemoteData$succeed(tryState)
								});
						} else {
							var err = _v5.a;
							return function (m) {
								return _Utils_update(
									m,
									{aL: false});
							}(
								A2(
									$author$project$Util$appendErrors,
									model,
									_List_fromArray(
										[err])));
						}
					}(),
					$elm$core$Platform$Cmd$none);
			default:
				var newState = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aV: A2(
								$krisajenkins$remotedata$RemoteData$map,
								function (r) {
									return _Utils_update(
										r,
										{cy: newState});
								},
								model.aV)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Scrubber$List$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{f$: _List_Nil}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$SdkList$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{f$: _List_Nil}),
				$elm$core$Platform$Cmd$none);
		} else {
			var tab = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{av: tab}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Tenant$Creating = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Tenant$Editing = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Page$Tenant$SaveCompleted = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Tenant$Saving = {$: 3};
var $author$project$Data$Tenant$encodeTenantApiKeyCreateRequest = function (request) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(request.b6))
			]));
};
var $author$project$Request$Tenant$create = F2(
	function (accessToken, request) {
		var url = '/gym/tenant/settings/keys/';
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$Tenant$encodeTenantApiKeyCreateRequest(request));
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson($author$project$Data$Tenant$tenantSettingsDecoder),
				ge: headers,
				gM: 'POST',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Page$Tenant$setModalActiveCheckbox = F2(
	function (model, active) {
		return _Utils_update(
			model,
			{
				j: function () {
					var _v0 = model.j;
					if (_v0.$ === 1) {
						var id = _v0.a;
						var request = _v0.b;
						return A3(
							$author$project$Page$Tenant$Editing,
							id,
							_Utils_update(
								request,
								{aC: active}),
							$elm$core$Maybe$Nothing);
					} else {
						return model.j;
					}
				}()
			});
	});
var $author$project$Page$Tenant$setModalDescription = F2(
	function (model, description) {
		return _Utils_update(
			model,
			{
				j: function () {
					var _v0 = model.j;
					switch (_v0.$) {
						case 1:
							var id = _v0.a;
							var request = _v0.b;
							return A3(
								$author$project$Page$Tenant$Editing,
								id,
								_Utils_update(
									request,
									{b6: description}),
								$elm$core$Maybe$Nothing);
						case 2:
							var request = _v0.a;
							return A2(
								$author$project$Page$Tenant$Creating,
								_Utils_update(
									request,
									{b6: description}),
								$elm$core$Maybe$Nothing);
						default:
							return model.j;
					}
				}()
			});
	});
var $author$project$Page$Tenant$setModalError = F2(
	function (model, err) {
		return _Utils_update(
			model,
			{
				j: function () {
					var _v0 = model.j;
					switch (_v0.$) {
						case 1:
							var id = _v0.a;
							var request = _v0.b;
							return A3(
								$author$project$Page$Tenant$Editing,
								id,
								request,
								$elm$core$Maybe$Just(err));
						case 2:
							var request = _v0.a;
							return A2(
								$author$project$Page$Tenant$Creating,
								request,
								$elm$core$Maybe$Just(err));
						default:
							return model.j;
					}
				}()
			});
	});
var $author$project$Data$Tenant$encodeTenantApiKeyUpdateRequest = function (request) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(request.b6)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(request.aC))
			]));
};
var $author$project$Util$Http$patchWithHeaders = F4(
	function (headers, url, body, decoder) {
		return $elm$http$Http$request(
			{
				bX: body,
				f1: $elm$http$Http$expectJson(decoder),
				ge: headers,
				gM: 'PATCH',
				hE: $elm$core$Maybe$Nothing,
				hQ: url,
				hU: false
			});
	});
var $author$project$Request$Tenant$update = F3(
	function (accessToken, apiKeyPublicId, request) {
		var url = '/gym/tenant/settings/keys/' + apiKeyPublicId;
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
			]);
		var body = $elm$http$Http$jsonBody(
			$author$project$Data$Tenant$encodeTenantApiKeyUpdateRequest(request));
		return A4($author$project$Util$Http$patchWithHeaders, headers, url, body, $author$project$Data$Tenant$tenantSettingsDecoder);
	});
var $author$project$Page$Tenant$update = F2(
	function (msg, model) {
		var validateModal = F2(
			function (request, onSuccess) {
				return $elm$core$String$isEmpty(request.b6) ? _Utils_Tuple2(
					A2($author$project$Page$Tenant$setModalError, model, 'Enter a description'),
					$elm$core$Platform$Cmd$none) : onSuccess;
			});
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var values = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A3($author$project$Page$Tenant$Editing, id, values, $elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2(
								$author$project$Page$Tenant$Creating,
								{b6: ''},
								$elm$core$Maybe$Nothing)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var description = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Tenant$setModalDescription, model, description),
					$elm$core$Platform$Cmd$none);
			case 3:
				var active = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Tenant$setModalActiveCheckbox, model, active),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j: $author$project$Page$Tenant$NotShown}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var publicId = msg.a;
				var request = msg.b;
				return A2(
					validateModal,
					request,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{j: $author$project$Page$Tenant$Saving}),
						A2(
							$elm$http$Http$send,
							$author$project$Page$Tenant$SaveCompleted,
							A3($author$project$Request$Tenant$update, model.a, publicId, request))));
			case 5:
				var request = msg.a;
				return A2(
					validateModal,
					request,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{j: $author$project$Page$Tenant$Saving}),
						A2(
							$elm$http$Http$send,
							$author$project$Page$Tenant$SaveCompleted,
							A2($author$project$Request$Tenant$create, model.a, request))));
			case 7:
				var httpResult = msg.a;
				if (!httpResult.$) {
					var settings = httpResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{j: $author$project$Page$Tenant$NotShown, bI: settings}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = httpResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f$: _List_fromArray(
									[
										$author$project$Util$Http$errorToString(error)
									]),
								j: $author$project$Page$Tenant$NotShown
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Timeline$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Widget$makeSection = F2(
	function (title, widgets) {
		return {g6: $author$project$Data$Widget$AnyPlatform, bO: title, cB: widgets};
	});
var $author$project$Page$Widget$CollectionEditor$blankSection = A2($author$project$Data$Widget$makeSection, 'NEW SECTION', _List_Nil);
var $author$project$Page$Widget$CollectionEditor$handleSaveResult = F2(
	function (model, httpResult) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil, bv: model.bv + 1}),
				$elm$core$Platform$Cmd$none);
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Util$List$move = F3(
	function (index, direction, items) {
		return A3($author$project$Util$List$moveWithDetails, index, direction, items).a;
	});
var $author$project$Data$Widget$defaultMeta = A3(
	$author$project$Data$Widget$makeWidget,
	$author$project$UUID$nil,
	'Meta',
	$author$project$Data$Widget$StaticTableData(
		$author$project$View$Widget$StaticTable$init(
			_List_fromArray(
				[
					_Utils_Tuple2('Incident ID', '.meta.id'),
					_Utils_Tuple2('Created', '.meta.ingestedAt'),
					_Utils_Tuple2('Platform', '.meta.platform'),
					_Utils_Tuple2('Application', '.meta.application'),
					_Utils_Tuple2('Client Version', '.meta.clientVersion'),
					_Utils_Tuple2('Lang', '.meta.lang'),
					_Utils_Tuple2('Easy ID', '.meta.easyId'),
					_Utils_Tuple2('Session ID', '.meta.sessionId'),
					_Utils_Tuple2('Install ID', '.meta.installId')
				]))));
var $author$project$Page$Widget$CollectionEditor$starterSection = A2(
	$author$project$Data$Widget$makeSection,
	'Overview',
	_List_fromArray(
		[$author$project$Data$Widget$defaultMeta]));
var $author$project$Page$Widget$CollectionEditor$SaveCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Widget$dataToType = function (data) {
	switch (data.$) {
		case 0:
			return 0;
		case 2:
			return 1;
		case 1:
			return 2;
		default:
			return 3;
	}
};
var $author$project$View$Widget$DynamicList$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arrayKeyPath',
				$elm$json$Json$Encode$string(model.b1.K))
			]));
};
var $author$project$Data$Widget$Lens$encodeTransform = function (transform) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (transform.$) {
				case 0:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('default'))
						]);
				case 1:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('date'))
						]);
				case 2:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('byte_count'))
						]);
				default:
					var template = transform.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('link')),
							_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(template))
						]);
			}
		}());
};
var $author$project$Data$Widget$Lens$encode = function (lens) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'keyPath',
				$elm$json$Json$Encode$string(lens.gy)),
				_Utils_Tuple2(
				'isOptional',
				$elm$json$Json$Encode$bool(lens.cf)),
				_Utils_Tuple2(
				'transform',
				$author$project$Data$Widget$Lens$encodeTransform(lens.ay))
			]));
};
var $author$project$View$Widget$DynamicTable$encode = function (model) {
	var encodeColumn = function (_v0) {
		var name = _v0.ev;
		var lens = _v0.al;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'lens',
					$author$project$Data$Widget$Lens$encode(lens))
				]));
	};
	var cfg = model.b1;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arrayKeyPath',
				$elm$json$Json$Encode$string(cfg.K)),
				_Utils_Tuple2(
				'columns',
				A2($elm$json$Json$Encode$list, encodeColumn, cfg.b0))
			]));
};
var $author$project$View$Widget$Generic$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'keyPath',
				$elm$json$Json$Encode$string(model.b1.gy))
			]));
};
var $author$project$View$Widget$StaticTable$encode = function (model) {
	var encodeRow = function (_v0) {
		var label = _v0.eo;
		var value = _v0.hR;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string(label)),
					_Utils_Tuple2(
					'lens',
					$author$project$Data$Widget$Lens$encode(value))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rows',
				A2($elm$json$Json$Encode$list, encodeRow, model.b1.aW))
			]));
};
var $author$project$Data$Widget$encodeData = function (data) {
	switch (data.$) {
		case 0:
			var widgetModel = data.a;
			return $author$project$View$Widget$StaticTable$encode(widgetModel);
		case 2:
			var widgetModel = data.a;
			return $author$project$View$Widget$DynamicList$encode(widgetModel);
		case 1:
			var widgetModel = data.a;
			return $author$project$View$Widget$DynamicTable$encode(widgetModel);
		default:
			var widgetModel = data.a;
			return $author$project$View$Widget$Generic$encode(widgetModel);
	}
};
var $author$project$Data$Widget$encode = function (widget) {
	var typeString = $author$project$Data$Widget$Type$typeToString(
		$author$project$Data$Widget$dataToType(widget.b3));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$UUID$encode(widget.bj)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(widget.bO)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(typeString)),
				_Utils_Tuple2(
				'config',
				$author$project$Data$Widget$encodeData(widget.b3))
			]));
};
var $author$project$Data$Widget$encodePlatform = function (platformSpec) {
	if (!platformSpec.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var str = platformSpec.a;
		return $elm$json$Json$Encode$string(str);
	}
};
var $author$project$Data$Widget$encodeSection = function (section) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(section.bO)),
				_Utils_Tuple2(
				'widgets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Widget$encode, section.cB)),
				_Utils_Tuple2(
				'platform',
				$author$project$Data$Widget$encodePlatform(section.g6))
			]));
};
var $author$project$Data$Widget$serializationVersion = 1;
var $author$project$Data$Widget$encodeCollection = function (collection) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sections',
				A2($elm$json$Json$Encode$list, $author$project$Data$Widget$encodeSection, collection.hl)),
				_Utils_Tuple2(
				'serializationVersion',
				$elm$json$Json$Encode$int($author$project$Data$Widget$serializationVersion))
			]));
};
var $author$project$Request$WidgetCollection$postTask = F2(
	function (accessToken, item) {
		var responseDecoder = $elm$json$Json$Decode$succeed(0);
		var body = A2($author$project$Data$Locker$encode, item, $author$project$Data$Widget$encodeCollection);
		return $elm$http$Http$toTask(
			A4($author$project$Request$Locker$storeItem, accessToken, body, 0, responseDecoder));
	});
var $author$project$Page$Widget$CollectionEditor$save = function (model) {
	var newVersion = model.bv + 1;
	var newCollection = $author$project$Data$Widget$WidgetCollection(model.hl);
	var lockerItem = A3(
		$author$project$Data$Locker$LockerItem,
		$author$project$Data$Locker$entityToString(0),
		newVersion,
		newCollection);
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{f$: _List_Nil, cg: true}),
		A2(
			$elm$core$Task$attempt,
			$author$project$Page$Widget$CollectionEditor$SaveCompleted,
			A2($author$project$Request$WidgetCollection$postTask, model.a, lockerItem)));
};
var $author$project$Page$Widget$CollectionEditor$validateAndSave = function (model) {
	return $author$project$Page$Widget$CollectionEditor$save(model);
};
var $author$project$Page$Widget$CollectionEditor$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return $author$project$Page$Widget$CollectionEditor$validateAndSave(model);
			case 2:
				var result = msg.a;
				return A2($author$project$Page$Widget$CollectionEditor$handleSaveResult, model, result);
			case 3:
				return $author$project$Page$Widget$CollectionEditor$validateAndSave(
					_Utils_update(
						model,
						{
							hl: _Utils_ap(
								model.hl,
								_List_fromArray(
									[$author$project$Page$Widget$CollectionEditor$starterSection]))
						}));
			case 4:
				return $author$project$Page$Widget$CollectionEditor$validateAndSave(
					_Utils_update(
						model,
						{
							hl: _Utils_ap(
								model.hl,
								_List_fromArray(
									[$author$project$Page$Widget$CollectionEditor$blankSection]))
						}));
			case 5:
				var index = msg.a;
				var direction = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hl: A3($author$project$Util$List$move, index, direction, model.hl)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var details = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aQ: $elm$core$Maybe$Just(details)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var index = msg.a;
				return $author$project$Page$Widget$CollectionEditor$validateAndSave(
					_Utils_update(
						model,
						{
							aQ: $elm$core$Maybe$Nothing,
							hl: A2($elm_community$list_extra$List$Extra$removeAt, index, model.hl)
						}));
		}
	});
var $author$project$Page$Widget$Editor$EditDynamicTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Widget$Editor$EditLinkDialog = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Widget$Editor$EditLinkState = F2(
	function (template, toCommitMsg) {
		return {bM: template, e9: toCommitMsg};
	});
var $author$project$Page$Widget$Editor$EditStaticTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Widget$Editor$GotPreviewIncident = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Widget$Editor$SetColumnLinkTransformAt = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetRowLinkTransformAt = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$handleSaveResult = F3(
	function (model, httpResult, navKey) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil}),
				A2(
					$author$project$App$Route$pushUrlCmd,
					navKey,
					$author$project$App$Route$EditWidgetSection(model.F)));
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Widget$Lens$templateVariable = '$Variable$';
var $author$project$Page$Widget$Editor$isValidTemplate = function (template) {
	return A2($elm$core$String$contains, $author$project$Data$Widget$Lens$templateVariable, template);
};
var $author$project$Page$Widget$Editor$updateDynamicListWidget = F2(
	function (msg, config) {
		var newKeyPath = msg;
		return _Utils_update(
			config,
			{K: newKeyPath});
	});
var $elm$core$String$append = _String_append;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$humanize = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		$elm$core$String$toLower(
			$elm$core$String$trim(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'),
					$elm$core$Basics$always(' '),
					A3(
						$elm$regex$Regex$replace,
						$elm_community$string_extra$String$Extra$regexFromString('[A-Z]'),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gG;
							},
							$elm$core$String$append('-')),
						string)))));
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gG;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gG;
			},
			uppercaseMatch),
		ws);
};
var $author$project$Page$Widget$Editor$humanize = function (keyPath) {
	var normalizedKeyPath = A2($elm$core$String$startsWith, '.', keyPath) ? A2($elm$core$String$dropLeft, 1, keyPath) : keyPath;
	return $elm_community$string_extra$String$Extra$toTitleCase(
		$elm_community$string_extra$String$Extra$humanize(normalizedKeyPath));
};
var $author$project$View$Widget$DynamicTable$insertNewColumn = function (configuration) {
	return _Utils_update(
		configuration,
		{
			b0: _Utils_ap(
				configuration.b0,
				_List_fromArray(
					[
						A2(
						$author$project$View$Widget$DynamicTable$Column,
						'',
						$author$project$Data$Widget$Lens$new(''))
					]))
		});
};
var $author$project$Data$Widget$Lens$setLinkTransformTemplate = F2(
	function (newTemplate, lens) {
		var _v0 = lens.ay;
		if (_v0.$ === 3) {
			return _Utils_update(
				lens,
				{
					ay: $author$project$Data$Widget$Lens$LinkTransform(newTemplate)
				});
		} else {
			return lens;
		}
	});
var $author$project$Data$Widget$Lens$newTransform = function (transformType) {
	switch (transformType) {
		case 0:
			return $author$project$Data$Widget$Lens$DefaultTransform;
		case 1:
			return $author$project$Data$Widget$Lens$DateTransform;
		case 2:
			return $author$project$Data$Widget$Lens$ByteCountTransform;
		default:
			return $author$project$Data$Widget$Lens$LinkTransform('');
	}
};
var $author$project$Data$Widget$Lens$setTransformType = F2(
	function (transformType, lens) {
		return _Utils_update(
			lens,
			{
				ay: $author$project$Data$Widget$Lens$newTransform(transformType)
			});
	});
var $author$project$View$Widget$DynamicTable$updateColumnAt = F3(
	function (index, f, configuration) {
		var columns = configuration.b0;
		return _Utils_update(
			configuration,
			{
				b0: A3($elm_community$list_extra$List$Extra$updateAt, index, f, columns)
			});
	});
var $author$project$View$Widget$DynamicTable$updateLensAt = F3(
	function (index, f, configuration) {
		return A3(
			$author$project$View$Widget$DynamicTable$updateColumnAt,
			index,
			function (column) {
				return _Utils_update(
					column,
					{
						al: f(column.al)
					});
			},
			configuration);
	});
var $author$project$Page$Widget$Editor$updateDynamicTableWidget = F2(
	function (msg, config) {
		switch (msg.$) {
			case 0:
				var newKeyPath = msg.a;
				return _Utils_update(
					config,
					{K: newKeyPath});
			case 1:
				var index = msg.a;
				var newName = msg.b;
				return A3(
					$author$project$View$Widget$DynamicTable$updateColumnAt,
					index,
					function (column) {
						return _Utils_update(
							column,
							{ev: newName});
					},
					config);
			case 2:
				var index = msg.a;
				var newKeyPath = msg.b;
				var newInferredName = $author$project$Page$Widget$Editor$humanize(newKeyPath);
				var column = A2($elm_community$list_extra$List$Extra$getAt, index, config.b0);
				var columnName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function ($) {
						return $.ev;
					},
					column);
				var oldKeyPath = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function (col) {
						return col.al.gy;
					},
					column);
				var oldInferredName = $author$project$Page$Widget$Editor$humanize(oldKeyPath);
				var tmpConfig = ($elm_community$string_extra$String$Extra$isBlank(columnName) || _Utils_eq(columnName, oldInferredName)) ? A3(
					$author$project$View$Widget$DynamicTable$updateColumnAt,
					index,
					function (col) {
						return _Utils_update(
							col,
							{ev: newInferredName});
					},
					config) : config;
				return A3(
					$author$project$View$Widget$DynamicTable$updateLensAt,
					index,
					function (lens) {
						return _Utils_update(
							lens,
							{gy: newKeyPath});
					},
					tmpConfig);
			case 4:
				var index = msg.a;
				var newType = msg.b;
				return A3(
					$author$project$View$Widget$DynamicTable$updateLensAt,
					index,
					$author$project$Data$Widget$Lens$setTransformType(newType),
					config);
			case 5:
				var rowIndex = msg.a;
				var newTemplate = msg.b;
				return A3(
					$author$project$View$Widget$DynamicTable$updateLensAt,
					rowIndex,
					$author$project$Data$Widget$Lens$setLinkTransformTemplate(newTemplate),
					config);
			case 3:
				var index = msg.a;
				var isOptional = msg.b;
				return A3(
					$author$project$View$Widget$DynamicTable$updateLensAt,
					index,
					function (lens) {
						return _Utils_update(
							lens,
							{cf: isOptional});
					},
					config);
			case 6:
				return $author$project$View$Widget$DynamicTable$insertNewColumn(config);
			case 7:
				var index = msg.a;
				var direction = msg.b;
				return _Utils_update(
					config,
					{
						b0: A3($author$project$Util$List$move, index, direction, config.b0)
					});
			case 8:
				var index = msg.a;
				return _Utils_update(
					config,
					{
						b0: A2($elm_community$list_extra$List$Extra$removeAt, index, config.b0)
					});
			default:
				return config;
		}
	});
var $author$project$Page$Widget$Editor$updateGenericWidget = F2(
	function (msg, config) {
		var newKeyPath = msg;
		return _Utils_update(
			config,
			{gy: newKeyPath});
	});
var $author$project$View$Widget$StaticTable$insertNewRow = function (configuration) {
	return _Utils_update(
		configuration,
		{
			aW: _Utils_ap(
				configuration.aW,
				_List_fromArray(
					[
						A2(
						$author$project$View$Widget$StaticTable$Row,
						'',
						$author$project$Data$Widget$Lens$new(''))
					]))
		});
};
var $author$project$View$Widget$StaticTable$updateRowAt = F3(
	function (index, f, configuration) {
		var rows = configuration.aW;
		return _Utils_update(
			configuration,
			{
				aW: A3($elm_community$list_extra$List$Extra$updateAt, index, f, rows)
			});
	});
var $author$project$View$Widget$StaticTable$updateLensAt = F3(
	function (index, f, configuration) {
		return A3(
			$author$project$View$Widget$StaticTable$updateRowAt,
			index,
			function (row) {
				return _Utils_update(
					row,
					{
						hR: f(row.hR)
					});
			},
			configuration);
	});
var $author$project$Page$Widget$Editor$updateStaticTableWidget = F2(
	function (msg, config) {
		switch (msg.$) {
			case 0:
				var rowIndex = msg.a;
				var newLabel = msg.b;
				return A3(
					$author$project$View$Widget$StaticTable$updateRowAt,
					rowIndex,
					function (row) {
						return _Utils_update(
							row,
							{eo: newLabel});
					},
					config);
			case 1:
				var rowIndex = msg.a;
				var newValue = msg.b;
				return A3(
					$author$project$View$Widget$StaticTable$updateLensAt,
					rowIndex,
					function (lens) {
						return _Utils_update(
							lens,
							{gy: newValue});
					},
					config);
			case 2:
				var rowIndex = msg.a;
				var newValue = msg.b;
				return A3(
					$author$project$View$Widget$StaticTable$updateLensAt,
					rowIndex,
					function (lens) {
						return _Utils_update(
							lens,
							{cf: newValue});
					},
					config);
			case 3:
				var rowIndex = msg.a;
				var newType = msg.b;
				return A3(
					$author$project$View$Widget$StaticTable$updateLensAt,
					rowIndex,
					$author$project$Data$Widget$Lens$setTransformType(newType),
					config);
			case 4:
				var rowIndex = msg.a;
				var newTemplate = msg.b;
				return A3(
					$author$project$View$Widget$StaticTable$updateLensAt,
					rowIndex,
					$author$project$Data$Widget$Lens$setLinkTransformTemplate(newTemplate),
					config);
			case 5:
				return $author$project$View$Widget$StaticTable$insertNewRow(config);
			case 6:
				var index = msg.a;
				var direction = msg.b;
				return _Utils_update(
					config,
					{
						aW: A3($author$project$Util$List$move, index, direction, config.aW)
					});
			case 7:
				var index = msg.a;
				return _Utils_update(
					config,
					{
						aW: A2($elm_community$list_extra$List$Extra$removeAt, index, config.aW)
					});
			default:
				return config;
		}
	});
var $author$project$Page$Widget$Editor$updateWidget = F2(
	function (model, _function) {
		return _Utils_update(
			model,
			{
				fg: _function(model.fg)
			});
	});
var $author$project$Page$Widget$Editor$SaveCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Widget$Editor$allSections = function (model) {
	return model.ch.hR.hl;
};
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $elm_community$list_extra$List$Extra$updateIfIndex = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, x) {
					return predicate(i) ? update(x) : x;
				}),
			list);
	});
var $author$project$Page$Widget$Editor$save = function (model) {
	var upsertWidget = F2(
		function (widget, section) {
			var _v0 = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (w) {
					return _Utils_eq(w.bj, widget.bj);
				},
				section.cB);
			if (!_v0.$) {
				var index = _v0.a;
				return A3($elm_community$list_extra$List$Extra$setAt, index, widget, section.cB);
			} else {
				return _Utils_ap(
					section.cB,
					_List_fromArray(
						[widget]));
			}
		});
	var putWidgetInTheRightPlace = F2(
		function (widget, sections) {
			return (!_Utils_eq(model.F, model.ck)) ? A3(
				$elm_community$list_extra$List$Extra$updateIfIndex,
				$elm$core$Basics$eq(model.F),
				function (section) {
					return _Utils_update(
						section,
						{
							cB: _Utils_ap(
								section.cB,
								_List_fromArray(
									[widget]))
						});
				},
				A3(
					$elm_community$list_extra$List$Extra$updateIfIndex,
					$elm$core$Basics$eq(model.ck),
					function (section) {
						return _Utils_update(
							section,
							{
								cB: A2(
									$elm$core$List$filter,
									function (w) {
										return !_Utils_eq(w.bj, widget.bj);
									},
									section.cB)
							});
					},
					sections)) : A3(
				$elm_community$list_extra$List$Extra$updateIfIndex,
				$elm$core$Basics$eq(model.F),
				function (section) {
					return _Utils_update(
						section,
						{
							cB: A2(upsertWidget, widget, section)
						});
				},
				sections);
		});
	var newVersion = model.ch.dx + 1;
	var newCollection = $author$project$Data$Widget$WidgetCollection(
		A2(
			putWidgetInTheRightPlace,
			model.fg,
			$author$project$Page$Widget$Editor$allSections(model)));
	var newLockerItem = A3(
		$author$project$Data$Locker$LockerItem,
		$author$project$Data$Locker$entityToString(0),
		newVersion,
		newCollection);
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{f$: _List_Nil, cg: true}),
		A2(
			$elm$core$Task$attempt,
			$author$project$Page$Widget$Editor$SaveCompleted,
			A2($author$project$Request$WidgetCollection$postTask, model.a, newLockerItem)));
};
var $author$project$Page$Widget$Editor$validateWidgetData = function (data) {
	switch (data.$) {
		case 0:
			var configuration = data.a.b1;
			return $elm$core$List$isEmpty(configuration.aW) ? _List_fromArray(
				['At least one row must be added']) : _List_Nil;
		case 1:
			var configuration = data.a.b1;
			return $elm$core$List$isEmpty(configuration.b0) ? _List_fromArray(
				['At least one column must be added']) : (A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ev;
					},
					$elm$core$String$isEmpty),
				configuration.b0) ? _List_fromArray(
				['A column must not have an empty name']) : (A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.al;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gy;
						},
						$elm$core$String$isEmpty)),
				configuration.b0) ? _List_fromArray(
				['A column must not have an empty key-path']) : ($elm$core$String$isEmpty(configuration.K) ? _List_fromArray(
				['The array key-path must not be empty']) : _List_Nil)));
		case 2:
			var configuration = data.a.b1;
			return $elm$core$String$isEmpty(configuration.K) ? _List_fromArray(
				['The array key-path must not be empty']) : _List_Nil;
		default:
			var configuration = data.a.b1;
			return $elm$core$String$isEmpty(configuration.gy) ? _List_fromArray(
				['The key-path must not be empty']) : _List_Nil;
	}
};
var $author$project$Page$Widget$Editor$validateAndSave = function (model) {
	var widget = model.fg;
	var configErrors = $author$project$Page$Widget$Editor$validateWidgetData(widget.b3);
	return $elm$core$String$isEmpty(widget.bO) ? _Utils_Tuple2(
		A2(
			$author$project$Util$appendErrors,
			model,
			_List_fromArray(
				['Title cannot be empty'])),
		$elm$core$Platform$Cmd$none) : ((!$elm$core$List$isEmpty(configErrors)) ? _Utils_Tuple2(
		A2($author$project$Util$appendErrors, model, configErrors),
		$elm$core$Platform$Cmd$none) : $author$project$Page$Widget$Editor$save(model));
};
var $author$project$Page$Widget$Editor$update = F3(
	function (navKey, msg, model) {
		var updateWidgetData = function (newData) {
			return _Utils_Tuple2(
				A2(
					$author$project$Page$Widget$Editor$updateWidget,
					model,
					function (widget) {
						return _Utils_update(
							widget,
							{b3: newData});
					}),
				$elm$core$Platform$Cmd$none);
		};
		var noChange = _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return $author$project$Page$Widget$Editor$validateAndSave(model);
			case 2:
				var result = msg.a;
				return A3($author$project$Page$Widget$Editor$handleSaveResult, model, result, navKey);
			case 3:
				var newTitle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Widget$Editor$updateWidget,
						model,
						function (widget) {
							return _Utils_update(
								widget,
								{bO: newTitle});
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var newSectionIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F: newSectionIndex}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var newId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bk: newId}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var dialog = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b7: dialog}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var _v1 = model.b7;
				if (_v1.$ === 1) {
					var template = _v1.a.bM;
					var toCommitMsg = _v1.a.e9;
					return $author$project$Page$Widget$Editor$isValidTemplate(template) ? A3(
						$author$project$Page$Widget$Editor$update,
						navKey,
						toCommitMsg(template),
						_Utils_update(
							model,
							{b7: $author$project$Page$Widget$Editor$NoDialog})) : noChange;
				} else {
					return noChange;
				}
			case 11:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$http$Http$send,
						$author$project$Page$Widget$Editor$GotPreviewIncident,
						A2(
							$author$project$Request$Incident$getBasic,
							model.a,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$UUID$nil,
								$author$project$UUID$fromString(model.bk)))));
			case 12:
				var result = msg.a;
				return _Utils_Tuple2(
					function () {
						if (!result.$) {
							var incident = result.a;
							return _Utils_update(
								model,
								{
									bk: $author$project$UUID$toString(incident.er.bj),
									bF: $krisajenkins$remotedata$RemoteData$fromResult(
										$author$project$Page$Widget$Editor$parseIncident(incident))
								});
						} else {
							var err = result.a;
							return A2(
								$author$project$Util$appendErrors,
								model,
								_List_fromArray(
									[
										$author$project$Util$Http$errorToString(err)
									]));
						}
					}(),
					$elm$core$Platform$Cmd$none);
			case 5:
				if (msg.a.$ === 8) {
					var _v3 = msg.a;
					var rowIndex = _v3.a;
					var template = _v3.b;
					var onCommit = A2(
						$elm$core$Basics$composeL,
						$author$project$Page$Widget$Editor$EditStaticTable,
						$author$project$Page$Widget$Editor$SetRowLinkTransformAt(rowIndex));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b7: $author$project$Page$Widget$Editor$EditLinkDialog(
									A2($author$project$Page$Widget$Editor$EditLinkState, template, onCommit))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var subMsg = msg.a;
					var _v4 = model.fg.b3;
					if (!_v4.$) {
						var subModel = _v4.a;
						return updateWidgetData(
							$author$project$Data$Widget$StaticTableData(
								_Utils_update(
									subModel,
									{
										b1: A2($author$project$Page$Widget$Editor$updateStaticTableWidget, subMsg, subModel.b1)
									})));
					} else {
						return noChange;
					}
				}
			case 6:
				if (msg.a.$ === 9) {
					var _v5 = msg.a;
					var columnIndex = _v5.a;
					var template = _v5.b;
					var onCommit = A2(
						$elm$core$Basics$composeL,
						$author$project$Page$Widget$Editor$EditDynamicTable,
						$author$project$Page$Widget$Editor$SetColumnLinkTransformAt(columnIndex));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b7: $author$project$Page$Widget$Editor$EditLinkDialog(
									A2($author$project$Page$Widget$Editor$EditLinkState, template, onCommit))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var subMsg = msg.a;
					var _v6 = model.fg.b3;
					if (_v6.$ === 1) {
						var subModel = _v6.a;
						return updateWidgetData(
							$author$project$Data$Widget$DynamicTableData(
								_Utils_update(
									subModel,
									{
										b1: A2($author$project$Page$Widget$Editor$updateDynamicTableWidget, subMsg, subModel.b1)
									})));
					} else {
						return noChange;
					}
				}
			case 7:
				var subMsg = msg.a;
				var _v7 = model.fg.b3;
				if (_v7.$ === 2) {
					var subModel = _v7.a;
					return updateWidgetData(
						$author$project$Data$Widget$DynamicListData(
							_Utils_update(
								subModel,
								{
									b1: A2($author$project$Page$Widget$Editor$updateDynamicListWidget, subMsg, subModel.b1)
								})));
				} else {
					return noChange;
				}
			case 8:
				var subMsg = msg.a;
				var _v8 = model.fg.b3;
				if (_v8.$ === 3) {
					var subModel = _v8.a;
					return updateWidgetData(
						$author$project$Data$Widget$GenericData(
							_Utils_update(
								subModel,
								{
									b1: A2($author$project$Page$Widget$Editor$updateGenericWidget, subMsg, subModel.b1)
								})));
				} else {
					return noChange;
				}
			default:
				switch (msg.a.$) {
					case 0:
						var subMsg = msg.a.a;
						var _v9 = model.fg.b3;
						if (!_v9.$) {
							var subModel = _v9.a;
							return updateWidgetData(
								$author$project$Data$Widget$StaticTableData(
									A2($author$project$View$Widget$StaticTable$update, subMsg, subModel)));
						} else {
							return noChange;
						}
					case 1:
						var subMsg = msg.a.a;
						var _v10 = model.fg.b3;
						if (_v10.$ === 1) {
							var subModel = _v10.a;
							return updateWidgetData(
								$author$project$Data$Widget$DynamicTableData(
									A2($author$project$View$Widget$DynamicTable$update, subMsg, subModel)));
						} else {
							return noChange;
						}
					case 2:
						var subMsg = msg.a.a;
						var _v11 = model.fg.b3;
						if (_v11.$ === 2) {
							var subModel = _v11.a;
							return updateWidgetData(
								$author$project$Data$Widget$DynamicListData(
									A2($author$project$View$Widget$DynamicList$update, subMsg, subModel)));
						} else {
							return noChange;
						}
					default:
						var subMsg = msg.a.a;
						var _v12 = model.fg.b3;
						if (_v12.$ === 3) {
							var subModel = _v12.a;
							return updateWidgetData(
								$author$project$Data$Widget$GenericData(
									A2($author$project$View$Widget$Generic$update, subMsg, subModel)));
						} else {
							return noChange;
						}
				}
		}
	});
var $author$project$Page$Widget$SectionEditor$handleSaveResult = F2(
	function (model, httpResult) {
		var newModel = _Utils_update(
			model,
			{cg: false});
		if (!httpResult.$) {
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{f$: _List_Nil, bv: model.bv + 1}),
				$elm$core$Platform$Cmd$none);
		} else {
			var error = httpResult.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Util$appendErrors,
					newModel,
					_List_fromArray(
						[
							$author$project$Util$Http$errorToString(error)
						])),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$SelectList$Selected = 1;
var $author$project$SelectList$AfterSelected = 2;
var $author$project$SelectList$BeforeSelected = 0;
var $author$project$SelectList$mapBy = F2(
	function (transform, _v0) {
		var beforeSel = _v0.a;
		var sel = _v0.b;
		var afterSel = _v0.c;
		return A3(
			$author$project$SelectList$SelectList,
			A2(
				$elm$core$List$map,
				transform(0),
				beforeSel),
			A2(transform, 1, sel),
			A2(
				$elm$core$List$map,
				transform(2),
				afterSel));
	});
var $author$project$Page$Widget$SectionEditor$selectListMapCurrent = F2(
	function (_function, items) {
		return A2(
			$author$project$SelectList$mapBy,
			F2(
				function (pos, item) {
					return (pos === 1) ? _function(item) : item;
				}),
			items);
	});
var $author$project$Page$Widget$SectionEditor$updateSection = F2(
	function (f, model) {
		return _Utils_update(
			model,
			{
				hl: A2($author$project$Page$Widget$SectionEditor$selectListMapCurrent, f, model.hl)
			});
	});
var $author$project$Page$Widget$SectionEditor$updateWidgets = F2(
	function (f, model) {
		return A2(
			$author$project$Page$Widget$SectionEditor$updateSection,
			function (section) {
				return _Utils_update(
					section,
					{
						cB: f(section.cB)
					});
			},
			model);
	});
var $author$project$Page$Widget$SectionEditor$SaveCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$SelectList$toList = function (_v0) {
	var beforeSel = _v0.a;
	var sel = _v0.b;
	var afterSel = _v0.c;
	return _Utils_ap(
		beforeSel,
		A2($elm$core$List$cons, sel, afterSel));
};
var $author$project$Page$Widget$SectionEditor$save = function (model) {
	var newVersion = model.bv + 1;
	var newCollection = $author$project$Data$Widget$WidgetCollection(
		$author$project$SelectList$toList(model.hl));
	var lockerItem = A3(
		$author$project$Data$Locker$LockerItem,
		$author$project$Data$Locker$entityToString(0),
		newVersion,
		newCollection);
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{f$: _List_Nil, cg: true}),
		A2(
			$elm$core$Task$attempt,
			$author$project$Page$Widget$SectionEditor$SaveCompleted,
			A2($author$project$Request$WidgetCollection$postTask, model.a, lockerItem)));
};
var $author$project$SelectList$selected = function (_v0) {
	var sel = _v0.b;
	return sel;
};
var $author$project$Page$Widget$SectionEditor$validateAndSave = function (model) {
	var section = $author$project$SelectList$selected(model.hl);
	var badPlatformSpec = function () {
		var _v0 = section.g6;
		if (!_v0.$) {
			return false;
		} else {
			var s = _v0.a;
			return $elm$core$String$isEmpty(s);
		}
	}();
	return badPlatformSpec ? _Utils_Tuple2(
		A2(
			$author$project$Util$appendErrors,
			model,
			_List_fromArray(
				['Platform cannot be blank'])),
		$elm$core$Platform$Cmd$none) : $author$project$Page$Widget$SectionEditor$save(model);
};
var $author$project$Page$Widget$SectionEditor$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f$: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return $author$project$Page$Widget$SectionEditor$validateAndSave(model);
			case 2:
				var result = msg.a;
				return A2($author$project$Page$Widget$SectionEditor$handleSaveResult, model, result);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: !model.ak}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var newTitle = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Widget$SectionEditor$updateSection,
						function (section) {
							return _Utils_update(
								section,
								{bO: newTitle});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 6:
				var newPlatform = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Widget$SectionEditor$updateSection,
						function (section) {
							return _Utils_update(
								section,
								{g6: newPlatform});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var direction = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$Widget$SectionEditor$updateWidgets,
						A2($author$project$Util$List$move, index, direction),
						model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var details = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aR: $elm$core$Maybe$Just(details)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var index = msg.a;
				return $author$project$Page$Widget$SectionEditor$validateAndSave(
					A2(
						$author$project$Page$Widget$SectionEditor$updateWidgets,
						$elm_community$list_extra$List$Extra$removeAt(index),
						_Utils_update(
							model,
							{aR: $elm$core$Maybe$Nothing})));
		}
	});
var $author$project$App$Main$updatePage = F3(
	function (page, msg, model) {
		var toPage = F5(
			function (pageToGoTo, toMsg, subUpdate, subMsg, subModel) {
				var _v1 = A2(subUpdate, subMsg, subModel);
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: $author$project$App$Main$Loaded(
								pageToGoTo(newModel))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, toMsg),
						newCmd));
			});
		var navKey = model.cj;
		var _v0 = _Utils_Tuple2(msg, page);
		_v0$34:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (_v0.b.$ === 3) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$Home, $author$project$App$Main$HomeMsg, $author$project$Page$Home$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 1:
					if (_v0.b.$ === 23) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$AdvancedSearch, $author$project$App$Main$AdvancedSearchMsg, $author$project$Page$AdvancedSearch$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 5:
					if (_v0.b.$ === 6) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$JoinTenantHelp, $author$project$App$Main$JoinTenantHelpMsg, $author$project$Page$JoinTenantHelp$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 6:
					if (_v0.b.$ === 7) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$Timeline, $author$project$App$Main$TimelineMsg, $author$project$Page$Timeline$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 2:
					if (_v0.b.$ === 4) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$IncidentList,
							$author$project$App$Main$IncidentListMsg,
							$author$project$Page$Incident$List$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 3:
					if (_v0.b.$ === 5) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$Incident,
							$author$project$App$Main$IncidentMsg,
							$author$project$Page$Incident$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 4:
					if (_v0.b.$ === 28) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$LogFile, $author$project$App$Main$LogFileMsg, $author$project$Page$LogFile$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 7:
					if (_v0.b.$ === 8) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$ClassifierList, $author$project$App$Main$ClassifierListMsg, $author$project$Page$Classifier$List$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 8:
					if (_v0.b.$ === 9) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$ClassifierViewer,
							$author$project$App$Main$ClassifierViewerMsg,
							$author$project$Page$Classifier$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 9:
					if (_v0.b.$ === 10) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$ClassifierEditor,
							$author$project$App$Main$ClassifierEditorMsg,
							$author$project$Page$Classifier$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 10:
					if (_v0.b.$ === 11) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$RemedyList, $author$project$App$Main$RemedyListMsg, $author$project$Page$Remedy$List$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 11:
					if (_v0.b.$ === 12) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$RemedyEditor,
							$author$project$App$Main$RemedyEditorMsg,
							$author$project$Page$Remedy$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 12:
					if (_v0.b.$ === 13) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$RemedyViewer,
							$author$project$App$Main$RemedyViewerMsg,
							$author$project$Page$Remedy$Viewer$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 13:
					if (_v0.b.$ === 14) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$RemedyHistory, $author$project$App$Main$RemedyHistoryMsg, $author$project$Page$Remedy$History$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 14:
					if (_v0.b.$ === 15) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$Admin, $author$project$App$Main$AdminMsg, $author$project$Page$Admin$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 15:
					if (_v0.b.$ === 16) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$SectionEditor, $author$project$App$Main$SectionEditorMsg, $author$project$Page$Widget$SectionEditor$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 16:
					if (_v0.b.$ === 17) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$WidgetCollectionEditor, $author$project$App$Main$WidgetCollectionEditorMsg, $author$project$Page$Widget$CollectionEditor$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 17:
					if (_v0.b.$ === 18) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$WidgetEditor,
							$author$project$App$Main$WidgetEditorMsg,
							$author$project$Page$Widget$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 18:
					if (_v0.b.$ === 19) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$CapabilityList, $author$project$App$Main$CapabilityListMsg, $author$project$Page$Capability$List$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 19:
					if (_v0.b.$ === 20) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$CapabilityEditor,
							$author$project$App$Main$CapabilityEditorMsg,
							$author$project$Page$Capability$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 20:
					if (_v0.b.$ === 21) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$ScrubberList, $author$project$App$Main$ScrubberListMsg, $author$project$Page$Scrubber$List$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 21:
					if (_v0.b.$ === 22) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$ScrubberEditor,
							$author$project$App$Main$ScrubberEditorMsg,
							$author$project$Page$Scrubber$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 22:
					if (_v0.b.$ === 24) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$Basement, $author$project$App$Main$BasementMsg, $author$project$Page$Basement$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 23:
					if (_v0.b.$ === 25) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$Onboarding, $author$project$App$Main$OnboardingMsg, $author$project$Page$Onboarding$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 24:
					if (_v0.b.$ === 26) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$SdkList, $author$project$App$Main$SdkListMsg, $author$project$Page$SdkList$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 25:
					if (_v0.b.$ === 27) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$Docs,
							$author$project$App$Main$DocsMsg,
							$author$project$Page$Docs$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 26:
					if (_v0.b.$ === 30) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$LogConfigList, $author$project$App$Main$LogConfigListMsg, $author$project$Page$Configuration$List$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 27:
					if (_v0.b.$ === 29) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$LogConfigEditor,
							$author$project$App$Main$LogConfigEditorMsg,
							$author$project$Page$Configuration$Editor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				case 28:
					if (_v0.b.$ === 31) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$News, $author$project$App$Main$NewsMsg, $author$project$Page$News$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 29:
					if (_v0.b.$ === 32) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$TenantSettings, $author$project$App$Main$TenantSettingsMsg, $author$project$Page$Tenant$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 30:
					if (_v0.b.$ === 34) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$GroupList, $author$project$App$Main$GroupListMsg, $author$project$Page$Group$GroupList$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 31:
					if (_v0.b.$ === 35) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(toPage, $author$project$App$Main$GroupViewer, $author$project$App$Main$GroupViewerMsg, $author$project$Page$Group$GroupViewer$update, subMsg, subModel);
					} else {
						break _v0$34;
					}
				case 32:
					if (_v0.b.$ === 36) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$GroupCreator,
							$author$project$App$Main$GroupCreatorMsg,
							$author$project$Page$Group$GroupCreator$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
				default:
					if (_v0.b.$ === 37) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A5(
							toPage,
							$author$project$App$Main$GroupEditor,
							$author$project$App$Main$GroupEditorMsg,
							$author$project$Page$Group$GroupEditor$update(navKey),
							subMsg,
							subModel);
					} else {
						break _v0$34;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$App$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 1:
					var request = msg.a;
					if (!request.$) {
						var url = request.a;
						return (A2($elm$core$String$startsWith, '/gym/', url.eF) || A2($elm$core$String$startsWith, '/docs/', url.eF)) ? _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(
								$elm$url$Url$toString(url))) : _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.cj,
								$elm$url$Url$toString(url)));
					} else {
						var href = request.a;
						return (href === '') ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 2:
					var url = msg.a;
					return A2($author$project$App$Main$setRoute, url, model);
				case 0:
					var pageMsg = msg.a;
					var _v2 = model.l;
					if (!_v2.$) {
						var page = _v2.a;
						return A3($author$project$App$Main$updatePage, page, pageMsg, model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 3:
					var now = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: A2($author$project$App$Main$updateLoadingBar, now, model.l)
							}),
						$elm$core$Platform$Cmd$none);
				case 4:
					var newRemote = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Y: newRemote}),
						function () {
							if (newRemote.$ === 3) {
								var user = newRemote.a;
								return $author$project$Request$User$storeUser(user);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 5:
					var settingsResult = msg.a;
					if (!settingsResult.$) {
						var settings = settingsResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cA: $elm$core$Maybe$Just(settings)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = settingsResult.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 6:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{X: !model.X}),
						$elm$core$Platform$Cmd$none);
				case 7:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{X: false}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aU: true, X: false}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$App$Main$SelectTenantResponse,
							A2($author$project$Request$User$selectTenant, model.a, id)));
				case 9:
					var response = msg.a;
					return A2($author$project$App$Main$finalizeFullPageReload, response, model);
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aU: true, X: false}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$App$Main$LogOutResponse,
							$author$project$Request$User$logOut(model.a)));
				case 11:
					var response = msg.a;
					return A2($author$project$App$Main$finalizeFullPageReload, response, model);
				case 12:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Home),
						$elm$core$Platform$Cmd$none);
				case 13:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$AdvancedSearch),
						$elm$core$Platform$Cmd$none);
				case 14:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$IncidentList),
						$elm$core$Platform$Cmd$none);
				case 15:
					var result = msg.a;
					if (!result.$) {
						switch (result.a.$) {
							case 0:
								var pageModel = result.a.a;
								return _Utils_Tuple2(
									A3(
										$author$project$App$Main$handleLoadResult,
										$elm$core$Result$Ok(pageModel),
										model,
										$author$project$App$Main$Incident),
									$elm$core$Platform$Cmd$none);
							case 1:
								var error = result.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											l: $author$project$App$Main$Loaded(
												$author$project$App$Main$Error(
													$author$project$Page$Error$simple(error)))
										}),
									$elm$core$Platform$Cmd$none);
							case 2:
								var info = result.a.a;
								var $temp$msg = $author$project$App$Main$SelectTenant(info.hz),
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							default:
								var info = result.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											l: $author$project$App$Main$Loaded(
												$author$project$App$Main$JoinTenantHelp(
													$author$project$Page$JoinTenantHelp$init(info)))
										}),
									$elm$core$Platform$Cmd$none);
						}
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									l: $author$project$App$Main$Loaded(
										$author$project$App$Main$Error(err))
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 16:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$LogFile),
						$elm$core$Platform$Cmd$none);
				case 17:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Timeline),
						$elm$core$Platform$Cmd$none);
				case 18:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ClassifierList),
						$elm$core$Platform$Cmd$none);
				case 19:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ClassifierViewer),
						$elm$core$Platform$Cmd$none);
				case 20:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ClassifierEditor),
						$elm$core$Platform$Cmd$none);
				case 21:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$RemedyList),
						$elm$core$Platform$Cmd$none);
				case 22:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$RemedyEditor),
						$elm$core$Platform$Cmd$none);
				case 23:
					var result = msg.a;
					return _Utils_Tuple2(
						A3(
							$author$project$App$Main$handleLoadResult,
							result,
							model,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$App$Main$RemedyViewer)),
						function () {
							if (!result.$) {
								var _v7 = result.a;
								var subCmd = _v7.b;
								return A2(
									$elm$core$Platform$Cmd$map,
									A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$RemedyViewerMsg),
									subCmd);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 24:
					var result = msg.a;
					return _Utils_Tuple2(
						A3(
							$author$project$App$Main$handleLoadResult,
							result,
							model,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$App$Main$RemedyHistory)),
						function () {
							if (!result.$) {
								var _v9 = result.a;
								var subCmd = _v9.b;
								return A2(
									$elm$core$Platform$Cmd$map,
									A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, $author$project$App$Main$RemedyHistoryMsg),
									subCmd);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 25:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Admin),
						$elm$core$Platform$Cmd$none);
				case 26:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$SectionEditor),
						$elm$core$Platform$Cmd$none);
				case 27:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$WidgetCollectionEditor),
						$elm$core$Platform$Cmd$none);
				case 28:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$WidgetEditor),
						$elm$core$Platform$Cmd$none);
				case 29:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$CapabilityList),
						$elm$core$Platform$Cmd$none);
				case 30:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$CapabilityEditor),
						$elm$core$Platform$Cmd$none);
				case 31:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ScrubberList),
						$elm$core$Platform$Cmd$none);
				case 32:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ScrubberEditor),
						$elm$core$Platform$Cmd$none);
				case 33:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Basement),
						$elm$core$Platform$Cmd$none);
				case 34:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Onboarding),
						$elm$core$Platform$Cmd$none);
				case 35:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$SdkList),
						$elm$core$Platform$Cmd$none);
				case 36:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$Docs),
						$elm$core$Platform$Cmd$none);
				case 37:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$LogConfigList),
						$elm$core$Platform$Cmd$none);
				case 38:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$LogConfigEditor),
						$elm$core$Platform$Cmd$none);
				case 39:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$News),
						$author$project$App$Main$getUserSettings(model.a));
				case 40:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$TenantSettings),
						$elm$core$Platform$Cmd$none);
				case 41:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$ViewClassifierHistory),
						$elm$core$Platform$Cmd$none);
				case 42:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$GroupList),
						$elm$core$Platform$Cmd$none);
				case 43:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$GroupViewer),
						$elm$core$Platform$Cmd$none);
				case 44:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$GroupCreator),
						$elm$core$Platform$Cmd$none);
				case 45:
					var result = msg.a;
					return _Utils_Tuple2(
						A3($author$project$App$Main$handleLoadResult, result, model, $author$project$App$Main$GroupEditor),
						$elm$core$Platform$Cmd$none);
				default:
					var token = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a: token}),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Util$Bootstrap$centeredContainer = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-12')
							]),
						children)
					]))
			]));
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$App$Main$isLoading = function (pageState) {
	if (pageState.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$View$NavBar$AdminSection = 3;
var $author$project$View$NavBar$ClassifiersSection = 1;
var $author$project$View$NavBar$IncidentsSection = 0;
var $author$project$App$Main$LogOut = {$: 10};
var $author$project$View$NavBar$NewsSection = 4;
var $author$project$View$NavBar$RemediesSection = 2;
var $author$project$App$Main$ShowHideUserDropdown = {$: 6};
var $author$project$Page$News$dateOfMostRecentItem = A2(
	$elm$core$Maybe$withDefault,
	$elm$time$Time$millisToPosix(0),
	$elm$core$List$head(
		$elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				$elm$time$Time$posixToMillis,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.fT;
					},
					$author$project$Page$News$allNewsItems)))));
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$View$NavBar$filterSections = F3(
	function (hasWritePerm, isTenantLess, sections) {
		return isTenantLess ? _List_Nil : ((!hasWritePerm) ? _List_fromArray(
			[0]) : sections);
	});
var $author$project$Data$User$isTenantLess = function (user) {
	return $elm$core$List$isEmpty(user.hB);
};
var $author$project$App$UserUtil$hasNoTenant = function (userRemote) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		true,
		A2($krisajenkins$remotedata$RemoteData$map, $author$project$Data$User$isTenantLess, userRemote));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$View$NavBar$primarySections = _List_fromArray(
	[0, 1, 2]);
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Util$List$find = F2(
	function (predicate, items) {
		find:
		while (true) {
			if (!items.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = items.a;
				var rest = items.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$items = rest;
					predicate = $temp$predicate;
					items = $temp$items;
					continue find;
				}
			}
		}
	});
var $author$project$Data$User$isTenantWriteable = function (user) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (t) {
				return t.fi;
			},
			A2(
				$author$project$Util$List$find,
				function (t) {
					return t.aC && t.fi;
				},
				user.hB)));
};
var $author$project$App$UserUtil$userCanWriteToTenant = function (userRemote) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		false,
		A2($krisajenkins$remotedata$RemoteData$map, $author$project$Data$User$isTenantWriteable, userRemote));
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$App$Route$href = A2($elm$core$Basics$composeR, $author$project$App$Route$routeToString, $elm$html$Html$Attributes$href);
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$View$NavBar$sectionToRoute = function (section) {
	switch (section) {
		case 0:
			return $author$project$App$Route$SearchIncidents($elm$core$Maybe$Nothing);
		case 1:
			return $author$project$App$Route$ListClassifiers;
		case 2:
			return $author$project$App$Route$ListRemedies;
		case 3:
			return $author$project$App$Route$Admin;
		default:
			return $author$project$App$Route$ViewNews;
	}
};
var $author$project$View$NavBar$sectionToString = function (section) {
	switch (section) {
		case 0:
			return 'Incidents';
		case 1:
			return 'Classifiers';
		case 2:
			return 'Remedies';
		case 3:
			return 'Admin';
		default:
			return 'News';
	}
};
var $author$project$View$NavBar$viewSectionLink = F2(
	function (activeSection, section) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(
								activeSection,
								$elm$core$Maybe$Just(section)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(
							$author$project$View$NavBar$sectionToRoute(section))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$View$NavBar$sectionToString(section))
						]))
				]));
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Util$Html$role = function (name) {
	return A2($elm$html$Html$Attributes$attribute, 'role', name);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Util$Bootstrap$powerliftYellow = '#fff7af';
var $author$project$View$NavBar$viewNewsLink = F2(
	function (activeSection, hasFreshNews) {
		var textYellowDot = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'color', $author$project$Util$Bootstrap$powerliftYellow)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('●')
				]));
		var section = 4;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(
								activeSection,
								$elm$core$Maybe$Just(section)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(
							$author$project$View$NavBar$sectionToRoute(section))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$View$NavBar$sectionToString(section)),
							$elm$html$Html$text(' '),
							hasFreshNews ? textYellowDot : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$View$NavBar$viewUserDropdownContents = F4(
	function (user, activeSection, isOpen, config) {
		var tenantItem = function (_v0) {
			var id = _v0.bj;
			var name = _v0.ev;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								config.hn(id)),
								$author$project$Util$Html$role('button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		};
		var header = A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown-header')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(user.fd)
				]));
		var footer = _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$author$project$Util$Html$role('separator'),
						$elm$html$Html$Attributes$class('divider')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(config.gE),
								$author$project$Util$Html$role('button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Log Out')
							]))
					]))
			]);
		var activeTenantName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ev;
				},
				$author$project$Data$User$activeTenant(user)));
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav navbar-nav navbar-right')
				]),
			_List_fromArray(
				[
					$author$project$Data$User$isTenantWriteable(user) ? A2($author$project$View$NavBar$viewSectionLink, activeSection, 3) : $elm$html$Html$text(''),
					A2($author$project$View$NavBar$viewNewsLink, activeSection, config.gd),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'height', '60px'),
							A2($elm$html$Html$Attributes$style, 'width', '1px'),
							A2($elm$html$Html$Attributes$style, 'background-color', '#aaa'),
							A2($elm$html$Html$Attributes$style, 'margin', '0')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id($author$project$View$NavBar$tenantDropdownId),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('dropdown', true),
									_Utils_Tuple2('open', isOpen)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-toggle'),
									$author$project$Util$Html$role('button'),
									$elm$html$Html$Events$onClick(config.hL)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(activeTenantName),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('caret')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-menu')
								]),
							A2(
								$elm$core$List$cons,
								header,
								_Utils_ap(
									A2($elm$core$List$map, tenantItem, user.hB),
									footer)))
						]))
				]));
	});
var $author$project$View$NavBar$viewUserDropdown = F4(
	function (userData, activeSection, isOpen, config) {
		switch (userData.$) {
			case 0:
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			case 1:
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('fetching user...')
						]));
			case 2:
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('failed to get user')
						]));
			default:
				var user = userData.a;
				return A4($author$project$View$NavBar$viewUserDropdownContents, user, activeSection, isOpen, config);
		}
	});
var $author$project$View$NavBar$view = F4(
	function (activeSection, userRemote, userDropdownExpanded, config) {
		var mainSections = A3(
			$author$project$View$NavBar$filterSections,
			$author$project$App$UserUtil$userCanWriteToTenant(userRemote),
			$author$project$App$UserUtil$hasNoTenant(userRemote),
			$author$project$View$NavBar$primarySections);
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar navbar-default'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '0'),
					$elm$html$Html$Attributes$id($author$project$View$NavBar$domID)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('navbar-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('navbar-brand'),
											$elm$html$Html$Attributes$href('#')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('PowerLift')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('navbar-collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('nav navbar-nav')
										]),
									A2(
										$elm$core$List$map,
										$author$project$View$NavBar$viewSectionLink(activeSection),
										mainSections)),
									A4($author$project$View$NavBar$viewUserDropdown, userRemote, activeSection, userDropdownExpanded, config)
								]))
						]))
				]));
	});
var $author$project$App$Main$viewNav = function (model) {
	var hasFreshNews = function () {
		var _v1 = model.cA;
		if (!_v1.$) {
			var settings = _v1.a;
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(settings.gC),
				$elm$time$Time$posixToMillis($author$project$Page$News$dateOfMostRecentItem)) < 0;
		} else {
			return false;
		}
	}();
	var config = {gd: hasFreshNews, gE: $author$project$App$Main$LogOut, hn: $author$project$App$Main$SelectTenant, hL: $author$project$App$Main$ShowHideUserDropdown};
	var activeSection = function () {
		var _v0 = $author$project$App$Main$getPage(model.l);
		switch (_v0.$) {
			case 4:
				return $elm$core$Maybe$Just(0);
			case 5:
				return $elm$core$Maybe$Just(0);
			case 23:
				return $elm$core$Maybe$Just(0);
			case 28:
				return $elm$core$Maybe$Just(0);
			case 8:
				return $elm$core$Maybe$Just(1);
			case 9:
				return $elm$core$Maybe$Just(1);
			case 10:
				return $elm$core$Maybe$Just(1);
			case 11:
				return $elm$core$Maybe$Just(2);
			case 12:
				return $elm$core$Maybe$Just(2);
			case 13:
				return $elm$core$Maybe$Just(2);
			case 14:
				return $elm$core$Maybe$Just(2);
			case 15:
				return $elm$core$Maybe$Just(3);
			case 16:
				return $elm$core$Maybe$Just(3);
			case 17:
				return $elm$core$Maybe$Just(3);
			case 18:
				return $elm$core$Maybe$Just(3);
			case 19:
				return $elm$core$Maybe$Just(3);
			case 20:
				return $elm$core$Maybe$Just(3);
			case 21:
				return $elm$core$Maybe$Just(3);
			case 22:
				return $elm$core$Maybe$Just(3);
			case 30:
				return $elm$core$Maybe$Just(3);
			case 29:
				return $elm$core$Maybe$Just(3);
			case 32:
				return $elm$core$Maybe$Just(3);
			case 31:
				return $elm$core$Maybe$Just(4);
			case 33:
				return $elm$core$Maybe$Just(1);
			case 34:
				return $elm$core$Maybe$Just(3);
			case 35:
				return $elm$core$Maybe$Just(3);
			case 36:
				return $elm$core$Maybe$Just(3);
			case 37:
				return $elm$core$Maybe$Just(3);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	return A4($author$project$View$NavBar$view, activeSection, model.Y, model.X, config);
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$TitledHtml$map = F2(
	function (fn, _v0) {
		var title = _v0.bO;
		var body = _v0.bX;
		return {
			bX: A2($elm$html$Html$map, fn, body),
			bO: title
		};
	});
var $author$project$Page$Admin$DismissErrors = 0;
var $elm_explorations$markdown$Markdown$defaultOptions = {
	d$: $elm$core$Maybe$Nothing,
	ga: $elm$core$Maybe$Just(
		{fv: false, hw: false}),
	hj: true,
	hq: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Util$Glyphs$make = function (glyphClass) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('glyphicon ' + glyphClass)
			]),
		_List_Nil);
};
var $author$project$Util$Glyphs$x = $author$project$Util$Glyphs$make('glyphicon-remove');
var $author$project$View$Error$view = F2(
	function (errors, dismissErrors) {
		return $elm$core$List$isEmpty(errors) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-danger')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Error'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(dismissErrors),
									$elm$html$Html$Attributes$class('pull-right'),
									$author$project$Util$Html$role('button')
								]),
							_List_fromArray(
								[$author$project$Util$Glyphs$x]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-body')
						]),
					A2(
						$elm$core$List$map,
						function (err) {
							return A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						},
						errors))
				]));
	});
var $author$project$Page$Admin$Feature = F5(
	function (title, glyph, details, buttonText, route) {
		return {dH: buttonText, fX: details, ef: glyph, eT: route, bO: title};
	});
var $author$project$Util$Glyphs$grid = $author$project$Util$Glyphs$make('glyphicon-th');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Util$Glyphs$lightning = $author$project$Util$Glyphs$make('glyphicon-flash');
var $author$project$Util$Glyphs$list = $author$project$Util$Glyphs$make('glyphicon-list');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Util$Bootstrap$routeLinkButtonLight = F2(
	function (buttonText, route) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-default'),
					A2($elm$html$Html$Attributes$style, 'color', 'white'),
					$elm$html$Html$Attributes$type_('button'),
					$author$project$App$Route$href(route)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$Page$Admin$makeFeatureBox = function (feature) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								feature.ef,
								$elm$html$Html$text(' '),
								$elm$html$Html$text(feature.bO)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'min-height', '50px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(feature.fX)
							])),
						A2($author$project$Util$Bootstrap$routeLinkButtonLight, feature.dH, feature.eT)
					]))
			]));
};
var $author$project$Page$Admin$makeFeatureRow = F2(
	function (feature1, feature2) {
		var featureView = A2(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (f) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-6')
							]),
						_List_fromArray(
							[
								$author$project$Page$Admin$makeFeatureBox(f)
							]))
					]);
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_Utils_ap(
				featureView(feature1),
				featureView(feature2)));
	});
var $author$project$Util$Glyphs$scissors = $author$project$Util$Glyphs$make('glyphicon-scissors');
var $author$project$Page$Admin$viewTeamSettings = function () {
	var feature5 = A5($author$project$Page$Admin$Feature, 'Groups', $author$project$Util$Glyphs$grid, 'Manage groups of shared resources.', 'Manage', $author$project$App$Route$ListGroups);
	var feature4 = A5($author$project$Page$Admin$Feature, 'Log File Configuration', $author$project$Util$Glyphs$list, 'Enable enhanced log file viewer by telling us a little about how your logs are structured.', 'Manage', $author$project$App$Route$ListLogConfigs);
	var feature3 = A5($author$project$Page$Admin$Feature, 'Remedy Capabilities', $author$project$Util$Glyphs$lightning, 'Register hooks into your application that can be used from Remedy buttons.', 'Manage', $author$project$App$Route$ListCapabilities);
	var feature2 = A5($author$project$Page$Admin$Feature, 'Scrubbers', $author$project$Util$Glyphs$scissors, 'Register scrubbers to redact accidental PII in your incidents and log files.', 'Manage', $author$project$App$Route$ListScrubbers);
	var feature1 = A5($author$project$Page$Admin$Feature, 'Incident Display', $author$project$Util$Glyphs$grid, 'Customize how your incidents are displayed using widgets. Organize your diagnostics into groups and tables.', 'Manage', $author$project$App$Route$EditWidgetCollection);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Team Settings')
					])),
				A2(
				$author$project$Page$Admin$makeFeatureRow,
				$elm$core$Maybe$Just(feature1),
				$elm$core$Maybe$Just(feature2)),
				A2(
				$author$project$Page$Admin$makeFeatureRow,
				$elm$core$Maybe$Just(feature3),
				$elm$core$Maybe$Just(feature4)),
				A2(
				$author$project$Page$Admin$makeFeatureRow,
				$elm$core$Maybe$Just(feature5),
				$elm$core$Maybe$Nothing)
			]));
}();
var $author$project$Util$Glyphs$lock = $author$project$Util$Glyphs$make('glyphicon-lock');
var $author$project$Page$Admin$viewTenantSettings = function () {
	var tenantSettingsFeature = A5($author$project$Page$Admin$Feature, 'Tenant Settings', $author$project$Util$Glyphs$lock, 'View tenant related information.', 'View', $author$project$App$Route$TenantSettings);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Tenant Settings')
					])),
				A2(
				$author$project$Page$Admin$makeFeatureRow,
				$elm$core$Maybe$Just(tenantSettingsFeature),
				$elm$core$Maybe$Nothing)
			]));
}();
var $author$project$Page$Admin$warningMarkdown = '\nChanges that you make in the Admin screens affect how PowerLift works for __everyone on\nyour team__. This is advanced functionality that should only be edited by the main person\non your team responsible for configuring PowerLift. If you have any questions, please\nemail [powerlifters@microsoft.com](mailto:powerlifters@microsoft.com).\n';
var $author$project$Page$Admin$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, 0),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-warning')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Admin Zone')
								])),
							A2(
							$elm_explorations$markdown$Markdown$toHtml,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-body')
								]),
							$author$project$Page$Admin$warningMarkdown)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[$author$project$Page$Admin$viewTeamSettings, $author$project$Page$Admin$viewTenantSettings]))
				])),
		bO: 'Admin'
	};
};
var $author$project$Page$AdvancedSearch$DismissErrors = {$: 0};
var $author$project$Page$AdvancedSearch$ChangedInstallIdsText = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$AdvancedSearch$ClickedSearch = {$: 2};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Util$Bootstrap$button = F2(
	function (bootstrapClassName, attribs) {
		var mergedAttribs = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn ' + bootstrapClassName)
				]),
			attribs);
		return $elm$html$Html$button(mergedAttribs);
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$View$EmptyStates$view = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Page$AdvancedSearch$viewIncidentLink = function (incidentId) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$App$Route$href(
						$author$project$App$Route$viewIncident(incidentId)),
						$elm$html$Html$Attributes$class('trackedLink')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$UUID$toString(incidentId))
					]))
			]));
};
var $author$project$Page$AdvancedSearch$viewIncidentsForInstall = F2(
	function (installId, incidentIds) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(installId)
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Page$AdvancedSearch$viewIncidentLink, incidentIds))
				]));
	});
var $author$project$Page$AdvancedSearch$viewFindByInstallIds = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Find by Install IDs')
							])),
						A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('one ID per line')
							])),
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$rows(10),
								A2($elm$html$Html$Attributes$style, 'display', 'block'),
								$elm$html$Html$Attributes$value(model.bE),
								$elm$html$Html$Events$onInput($author$project$Page$AdvancedSearch$ChangedInstallIdsText)
							]),
						_List_Nil),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$AdvancedSearch$ClickedSearch),
								A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-9')
					]),
				function () {
					var _v0 = model.hg;
					if (_v0.$ === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$text('')
							]);
					} else {
						var results = _v0.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Results')
									])),
								$elm$core$Dict$isEmpty(results) ? $author$project$View$EmptyStates$view('Nothing found') : A2(
								$elm$html$Html$div,
								_List_Nil,
								$elm$core$Dict$values(
									A2($elm$core$Dict$map, $author$project$Page$AdvancedSearch$viewIncidentsForInstall, results)))
							]);
					}
				}())
			]));
};
var $author$project$Page$AdvancedSearch$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$AdvancedSearch$DismissErrors),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Advanced Search')
						])),
					$author$project$Page$AdvancedSearch$viewFindByInstallIds(model)
				])),
		bO: 'Advanced Search'
	};
};
var $author$project$Page$Basement$DismissErrors = 0;
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Data$Chart$encodeDataset = function (dataset) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(dataset.eo)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, dataset.fe))
			]));
};
var $author$project$Data$Chart$encode = function (chart) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(chart.bO)),
				_Utils_Tuple2(
				'timeStamps',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$int,
					A2($elm$core$List$map, $elm$time$Time$posixToMillis, chart.du))),
				_Utils_Tuple2(
				'dataSets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Chart$encodeDataset, chart.dV))
			]));
};
var $author$project$TimeChart$encodeAnnotation = function (_v0) {
	var date = _v0.a;
	var title = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Util$JsonEncode$posixTime(date)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(title))
			]));
};
var $author$project$TimeChart$encode = F3(
	function (chart, percentageFormat, timelineAnnotations) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'chart',
					$author$project$Data$Chart$encode(chart)),
					_Utils_Tuple2(
					'timelineAnnotations',
					A2($elm$json$Json$Encode$list, $author$project$TimeChart$encodeAnnotation, timelineAnnotations)),
					_Utils_Tuple2(
					'percentageFormat',
					$elm$json$Json$Encode$bool(percentageFormat))
				]));
	});
var $author$project$TimeChart$viewWithAnnotations = F3(
	function (chart, percentageFormat, timelineAnnotations) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('js-elm-chart'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-js-elm-chart',
							A2(
								$elm$json$Json$Encode$encode,
								0,
								A3($author$project$TimeChart$encode, chart, percentageFormat, timelineAnnotations)))
						]),
					_List_Nil)
				]));
	});
var $author$project$TimeChart$view = function (chart) {
	return A3($author$project$TimeChart$viewWithAnnotations, chart, false, _List_Nil);
};
var $author$project$Page$Basement$viewBasicChart = function (chart) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '30px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 0 8px 8px'),
				A2($elm$html$Html$Attributes$style, 'border', '1px solid #dddddd')
			]),
		_List_fromArray(
			[
				$author$project$TimeChart$view(chart)
			]));
};
var $author$project$Page$Basement$viewStats = function (_v0) {
	var remedyPerformanceChart = _v0.he;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$Basement$viewBasicChart(remedyPerformanceChart)
			]));
};
var $author$project$Page$Basement$view = function (_v0) {
	var statsResponse = _v0.ds;
	var errors = _v0.f$;
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, errors, 0),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Basement')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Miscellaneous junk that we can\'t bear to throw out... yet!')
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Charts')
						])),
					$author$project$Page$Basement$viewStats(statsResponse)
				])),
		bO: 'Basement'
	};
};
var $author$project$Page$Capability$Editor$DismissErrors = {$: 0};
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Util$Bootstrap$breadcrumbsCustom = function (segments) {
	var currentRoute = A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$second,
		$elm_community$list_extra$List$Extra$last(segments));
	var makeCrumb = function (_v0) {
		var name = _v0.a;
		var route = _v0.b;
		return _Utils_eq(
			currentRoute,
			$elm$core$Maybe$Just(route)) ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('active')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				])) : A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(route)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	};
	return A2(
		$elm$html$Html$ol,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('breadcrumb')
			]),
		A2($elm$core$List$map, makeCrumb, segments));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Util$Bootstrap$breadcrumbs = function (segments) {
	return $author$project$Util$Bootstrap$breadcrumbsCustom(
		A2(
			$elm_community$list_extra$List$Extra$zip,
			A2($elm$core$List$map, $author$project$App$Route$routeToBreadcrumb, segments),
			segments));
};
var $author$project$App$Route$docsHref = function (section) {
	return $author$project$App$Route$href(
		$author$project$App$Route$ViewDocs(
			$elm$core$Maybe$Just(section)));
};
var $author$project$Util$Glyphs$questionMark = $author$project$Util$Glyphs$make('glyphicon-question-sign');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$View$Docs$helpBox = function (section) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
			]),
		_List_fromArray(
			[
				$author$project$Util$Glyphs$questionMark,
				$elm$html$Html$text(' Check out the '),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$App$Route$docsHref(section),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('documentation')
					])),
				$elm$html$Html$text(' for more details')
			]));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Page$Capability$Editor$AddParameter = {$: 6};
var $author$project$Page$Capability$Editor$Save = {$: 1};
var $author$project$Page$Capability$Editor$SetDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Capability$Editor$SetId = function (a) {
	return {$: 3, a: a};
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {hG: toAmPm, hH: toMonthAbbreviation, hI: toMonthName, a1: toOrdinalSuffix, hJ: toWeekdayAbbreviation, hK: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.hG(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$Basics$round = _Basics_round;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.hH(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.hI(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.hJ(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.hK(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.a1(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Util$Date$formatDateAndTime = function (t) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed
			]),
		$elm$time$Time$utc,
		t);
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Util$Bootstrap$formField = F2(
	function (name, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 control-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-10')
						]),
					children)
				]));
	});
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Util$Bootstrap$textField = F4(
	function (attributes, msg, name, state) {
		return A2(
			$author$project$Util$Bootstrap$formField,
			name,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Events$onInput(msg),
								$elm$html$Html$Attributes$value(state)
							]),
						attributes),
					_List_Nil)
				]));
	});
var $author$project$Util$Bootstrap$textLabel = F2(
	function (name, state) {
		return A2(
			$author$project$Util$Bootstrap$formField,
			name,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control-static')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(state)
						]))
				]));
	});
var $author$project$Page$Capability$Editor$SetParameterName = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Util$Html$textFieldAdvanced = F3(
	function (moreAttributes, toMsg, textValue) {
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(toMsg),
						$elm$html$Html$Attributes$value(textValue)
					]),
				moreAttributes),
			_List_Nil);
	});
var $author$project$Util$Html$textField = F2(
	function (toMsg, textValue) {
		return A3($author$project$Util$Html$textFieldAdvanced, _List_Nil, toMsg, textValue);
	});
var $author$project$Page$Capability$Editor$viewEditParameter = F2(
	function (index, parameter) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Html$textField,
					$author$project$Page$Capability$Editor$SetParameterName(index),
					parameter.ev)
				]));
	});
var $author$project$Page$Capability$Editor$viewParametersTable = function (parameters) {
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$indexedMap, $author$project$Page$Capability$Editor$viewEditParameter, parameters));
};
var $author$project$Page$Capability$Editor$viewEdit = function (model) {
	var _v0 = model.aD;
	var id = _v0.bj;
	var actor = _v0.dy;
	var createdAt = _v0.dT;
	var version = _v0.dx;
	var description = _v0.b6;
	var parameters = _v0.bB;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Edit Capability: ' + id),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Capability$Editor$Save),
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-horizontal')
					]),
				_List_fromArray(
					[
						model.bn ? A4($author$project$Util$Bootstrap$textField, _List_Nil, $author$project$Page$Capability$Editor$SetId, 'ID', id) : A2($author$project$Util$Bootstrap$textLabel, 'ID', id),
						A4($author$project$Util$Bootstrap$textField, _List_Nil, $author$project$Page$Capability$Editor$SetDescription, 'Description', description),
						model.bn ? $elm$html$Html$text('') : A2(
						$author$project$Util$Bootstrap$textLabel,
						'Last Modified',
						$author$project$Util$Date$formatDateAndTime(createdAt) + (' by ' + actor)),
						A2(
						$author$project$Util$Bootstrap$textLabel,
						'Version',
						$elm$core$String$fromInt(version))
					])),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Parameters')
					])),
				$elm$core$List$isEmpty(parameters) ? A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No parameters')
					])) : $author$project$Page$Capability$Editor$viewParametersTable(parameters),
				A3(
				$author$project$Util$Bootstrap$button,
				'btn-primary',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Capability$Editor$AddParameter)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Parameter')
					]))
			]));
};
var $author$project$Page$Capability$Editor$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[
							$author$project$App$Route$Admin,
							$author$project$App$Route$ListCapabilities,
							$author$project$App$Route$EditCapability('')
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Capability$Editor$DismissErrors),
					$author$project$Page$Capability$Editor$viewEdit(model),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(7)
				])),
		bO: 'Edit Custom Capability'
	};
};
var $author$project$Page$Capability$List$DismissErrors = 0;
var $author$project$Util$Bootstrap$routeLinkButton = F2(
	function (buttonText, route) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-primary'),
					A2($elm$html$Html$Attributes$style, 'color', 'white'),
					$elm$html$Html$Attributes$type_('button'),
					$author$project$App$Route$href(route)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Util$Bootstrap$fixedWidthTable = F3(
	function (columnHeaders, viewRow, rowItems) {
		var totalWidth = $elm$core$List$sum(
			A2($elm$core$List$map, $elm$core$Tuple$second, columnHeaders));
		var headerCell = function (_v0) {
			var name = _v0.a;
			var width = _v0.b;
			return A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromInt(width) + '%')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]));
		};
		var header = A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2($elm$core$List$map, headerCell, columnHeaders));
		return (totalWidth !== 100) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Programmer Error')
						])),
					$elm$html$Html$text(
					'The widths of each column in a fixed-width table must add up to 100%' + (' (you provided a total width of ' + ($elm$core$String$fromInt(totalWidth) + '%)')))
				])) : A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered table-condensed'),
					A2($elm$html$Html$Attributes$style, 'table-layout', 'fixed'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[header])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2($elm$core$List$indexedMap, viewRow, rowItems))
				]));
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Util$Bootstrap$fixedWidthTextCell = F2(
	function (attributes, children) {
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')
					]),
				attributes),
			children);
	});
var $author$project$Page$Capability$List$viewRow = F2(
	function (_v0, capability) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$EditCapability(capability.bj))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(capability.bj)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(capability.dT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(capability.b6)
						]))
				]));
	});
var $author$project$Page$Capability$List$viewTable = function (capabilities) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Title', 25),
				_Utils_Tuple2('Last Modified', 15),
				_Utils_Tuple2('Description', 60)
			]),
		$author$project$Page$Capability$List$viewRow,
		capabilities);
};
var $author$project$Page$Capability$List$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[$author$project$App$Route$Admin, $author$project$App$Route$ListCapabilities])),
					A2($author$project$View$Error$view, model.f$, 0),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Capabilities'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Bootstrap$routeLinkButton, 'New Capability', $author$project$App$Route$NewCapability)
								]))
						])),
					$elm$core$List$isEmpty(model.bY) ? $author$project$View$EmptyStates$view('Your team hasn\'t registered any custom capabilities.') : $author$project$Page$Capability$List$viewTable(model.bY),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(7)
				])),
		bO: 'Custom Capabilities'
	};
};
var $author$project$Page$Classifier$Editor$DismissErrors = {$: 16};
var $author$project$View$Badge$AtLeast = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Classifier$Editor$Chart = 3;
var $author$project$View$Badge$Exactly = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Badge$None = {$: 0};
var $author$project$Page$Classifier$Editor$SelectTab = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Classifier$Editor$allTabs = _List_fromArray(
	[0, 1, 3, 2]);
var $author$project$Page$Classifier$Editor$navConfig = function (model) {
	var shouldShowTab = function (tab) {
		return ((tab === 2) && (!model.t.eQ)) ? false : (((tab === 3) && _Utils_eq(model.fC, $author$project$Page$Classifier$Editor$ChartNotNeeded)) ? false : true);
	};
	var badge = (model.t.g_ > 0) ? $author$project$View$Badge$AtLeast : $author$project$View$Badge$Exactly;
	var tabTitle = function (tab) {
		switch (tab) {
			case 0:
				return _Utils_Tuple2('Meta', $author$project$View$Badge$None);
			case 1:
				return _Utils_Tuple2('Content', $author$project$View$Badge$None);
			case 3:
				return _Utils_Tuple2('Chart', $author$project$View$Badge$None);
			default:
				return _Utils_Tuple2(
					'Results',
					badge(model.t.gW));
		}
	};
	return {
		R: A2($elm$core$List$filter, shouldShowTab, $author$project$Page$Classifier$Editor$allTabs),
		eA: $author$project$Page$Classifier$Editor$SelectTab,
		ho: model.av,
		hv: tabTitle
	};
};
var $author$project$Page$Classifier$Editor$shouldShowBreadcrumb = function (viewMode) {
	switch (viewMode) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$View$ProgressBar$roundedStyle = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'height', '12px'),
		A2($elm$html$Html$Attributes$style, 'margin', '2px 0 2px 0')
	]);
var $author$project$View$ProgressBar$viewInternal = function (customStyle) {
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('progress')
				]),
			customStyle),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('progress-bar progress-bar-info progress-bar-striped active'),
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				_List_Nil)
			]));
};
var $author$project$View$ProgressBar$view = $author$project$View$ProgressBar$viewInternal($author$project$View$ProgressBar$roundedStyle);
var $author$project$Page$Classifier$Editor$ClickedChartTimePeriod = function (a) {
	return {$: 18, a: a};
};
var $author$project$TimePeriod$Last48Hours = 0;
var $author$project$TimePeriod$LastMonth = 2;
var $author$project$TimePeriod$LastYear = 3;
var $author$project$Util$Bootstrap$horizontalButtonGroupCustom = F2(
	function (items, divExtraClassList) {
		var makeButton = function (_v0) {
			var titleText = _v0.a;
			var clickMsg = _v0.b;
			var btnExtraAttributes = _v0.c;
			return A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(clickMsg),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('btn btn-default'),
							btnExtraAttributes))),
				_List_fromArray(
					[
						$elm$html$Html$text(titleText)
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Util$Html$role('group'),
					$elm$html$Html$Attributes$classList(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('btn-group', true),
						divExtraClassList))
				]),
			A2($elm$core$List$map, makeButton, items));
	});
var $author$project$Util$Bootstrap$horizontalButtonGroup = function (items) {
	return A2(
		$author$project$Util$Bootstrap$horizontalButtonGroupCustom,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var s = _v0.a;
				var msg = _v0.b;
				return _Utils_Tuple3(s, msg, _List_Nil);
			},
			items),
		_List_Nil);
};
var $author$project$TimePeriod$viewTimeSelector = function (tagger) {
	return $author$project$Util$Bootstrap$horizontalButtonGroup(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Last 48 Hours',
				tagger(0)),
				_Utils_Tuple2(
				'Last 7 Days',
				tagger(1)),
				_Utils_Tuple2(
				'Last Month',
				tagger(2)),
				_Utils_Tuple2(
				'Last Year',
				tagger(3))
			]));
};
var $author$project$Page$Classifier$Editor$viewChart = F2(
	function (classifierId, chart) {
		var reportUrl = F2(
			function (numDays, granularity) {
				return '/gym/classifiers/' + ($author$project$UUID$toString(classifierId) + ('/csvReport?numDays=' + ($elm$core$String$fromInt(numDays) + ('&granularity=' + granularity))));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$TimePeriod$viewTimeSelector($author$project$Page$Classifier$Editor$ClickedChartTimePeriod),
					$author$project$TimeChart$view(chart),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Reports')
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													A2(reportUrl, 30, 'daily'))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('30-day CSV (daily)')
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													A2(reportUrl, 7, 'hourly'))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('7-day CSV (hourly)')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$View$Classifier$Drill2$Editor$AddQuery = {$: 1};
var $author$project$View$Classifier$Drill2$Editor$SetCombiner = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$allCombiners = _List_fromArray(
	[0, 1]);
var $author$project$View$Classifier$Drill2$Editor$combinerText = function (combiner) {
	if (combiner === 1) {
		return 'any';
	} else {
		return 'all';
	}
};
var $author$project$Util$Glyphs$plus = $author$project$Util$Glyphs$make('glyphicon-plus');
var $author$project$View$Classifier$Drill2$Editor$staticFormText = function (string) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control-static'),
				A2($elm$html$Html$Attributes$style, 'padding-left', '10px'),
				A2($elm$html$Html$Attributes$style, 'padding-right', '10px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$View$Classifier$Drill2$Editor$DeleteQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$TopLevelIndex = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Glyphs$remove = $author$project$Util$Glyphs$make('glyphicon-remove');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$Classifier$Drill2$Editor$AddObjectKeyQuery = function (a) {
	return {$: 8, a: a};
};
var $author$project$View$Classifier$Drill2$Editor$DeleteObjectKeyQuery = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$ObjectIndex = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$SetOpChoice = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$opChoicesForType = F2(
	function (dataType, op) {
		var negatedOps = function (o) {
			if (o.$ === 6) {
				var v = o.a;
				return _List_fromArray(
					[
						_Utils_Tuple3(
						$author$project$View$Classifier$Drill2$Editor$MultiSubstr(v),
						false,
						1),
						_Utils_Tuple3(
						$author$project$View$Classifier$Drill2$Editor$MultiSubstr(v),
						true,
						1),
						_Utils_Tuple3(
						$author$project$View$Classifier$Drill2$Editor$MultiSubstr(v),
						false,
						0),
						_Utils_Tuple3(
						$author$project$View$Classifier$Drill2$Editor$MultiSubstr(v),
						true,
						0)
					]);
			} else {
				var a = o;
				return _List_fromArray(
					[
						_Utils_Tuple3(a, false, 1),
						_Utils_Tuple3(a, true, 1)
					]);
			}
		};
		var multiChoices = function (vals) {
			if (!vals.b) {
				return _Utils_Tuple2(
					'',
					_List_fromArray(
						['', '']));
			} else {
				if (!vals.b.b) {
					var v = vals.a;
					return _Utils_Tuple2(
						v,
						_List_fromArray(
							[v, '']));
				} else {
					var v = vals.a;
					var vs = vals.b;
					return _Utils_Tuple2(
						v,
						A2($elm$core$List$cons, v, vs));
				}
			}
		};
		var _v0 = function () {
			switch (op.$) {
				case 0:
					var v = op.a;
					return _Utils_Tuple2(
						v,
						_List_fromArray(
							[v, '']));
				case 1:
					var v = op.a;
					return _Utils_Tuple2(
						v,
						_List_fromArray(
							[v, '']));
				case 2:
					var v = op.a;
					return _Utils_Tuple2(
						v,
						_List_fromArray(
							[v, '']));
				case 3:
					return _Utils_Tuple2(
						'',
						_List_fromArray(
							['', '']));
				case 4:
					var v = op.a;
					return _Utils_Tuple2(
						v,
						_List_fromArray(
							[v, '']));
				case 5:
					var vals = op.a;
					return multiChoices(vals);
				default:
					var vals = op.a;
					return multiChoices(vals);
			}
		}();
		var val = _v0.a;
		var multiVal = _v0.b;
		var ops = function () {
			switch (dataType) {
				case 0:
					return _List_fromArray(
						[
							$author$project$View$Classifier$Drill2$Editor$Eq(val),
							$author$project$View$Classifier$Drill2$Editor$Lt(val),
							$author$project$View$Classifier$Drill2$Editor$Gt(val),
							$author$project$View$Classifier$Drill2$Editor$IsNull,
							$author$project$View$Classifier$Drill2$Editor$MultiEq(multiVal)
						]);
				case 1:
					return _List_fromArray(
						[
							$author$project$View$Classifier$Drill2$Editor$Eq(val),
							$author$project$View$Classifier$Drill2$Editor$IsNull,
							$author$project$View$Classifier$Drill2$Editor$Substring(val),
							$author$project$View$Classifier$Drill2$Editor$MultiEq(multiVal),
							$author$project$View$Classifier$Drill2$Editor$MultiSubstr(multiVal)
						]);
				case 2:
					return _List_fromArray(
						[
							$author$project$View$Classifier$Drill2$Editor$Eq(val),
							$author$project$View$Classifier$Drill2$Editor$IsNull
						]);
				case 3:
					return _List_fromArray(
						[
							$author$project$View$Classifier$Drill2$Editor$Eq(val),
							$author$project$View$Classifier$Drill2$Editor$Lt(val),
							$author$project$View$Classifier$Drill2$Editor$Gt(val),
							$author$project$View$Classifier$Drill2$Editor$MultiEq(multiVal)
						]);
				case 4:
					return _List_fromArray(
						[
							$author$project$View$Classifier$Drill2$Editor$Eq(val),
							$author$project$View$Classifier$Drill2$Editor$Lt(val),
							$author$project$View$Classifier$Drill2$Editor$Gt(val)
						]);
				default:
					return _List_Nil;
			}
		}();
		return A2($elm$core$List$concatMap, negatedOps, ops);
	});
var $author$project$View$Classifier$Drill2$Editor$operationEq = F2(
	function (l, r) {
		var lop = l.a;
		var lneg = l.b;
		var rop = r.a;
		var rneg = r.b;
		switch (lop.$) {
			case 5:
				return _Utils_eq(l, r);
			case 6:
				return _Utils_eq(l, r);
			default:
				return _Utils_eq(lop, rop) && _Utils_eq(lneg, rneg);
		}
	});
var $author$project$View$Classifier$Drill2$Editor$operationText = function (_v0) {
	var operand = _v0.a;
	var negated = _v0.b;
	var combiner = _v0.c;
	var _v1 = _Utils_Tuple3(operand, negated, combiner);
	if (!_v1.b) {
		switch (_v1.a.$) {
			case 0:
				return 'equals';
			case 1:
				return 'is less than';
			case 2:
				return 'is greater than';
			case 3:
				var _v2 = _v1.a;
				return 'is null';
			case 4:
				return 'contains the substring';
			case 5:
				return 'is equal to any of';
			default:
				if (_v1.c === 1) {
					var _v4 = _v1.c;
					return 'contains any of the substrings';
				} else {
					var _v6 = _v1.c;
					return 'contains all of the substrings';
				}
		}
	} else {
		switch (_v1.a.$) {
			case 0:
				return 'does not equal';
			case 1:
				return 'is greater than or equal to';
			case 2:
				return 'is less than or equal to';
			case 3:
				var _v3 = _v1.a;
				return 'is not null';
			case 4:
				return 'does not contain the substring';
			case 5:
				return 'is not equal to any of';
			default:
				if (_v1.c === 1) {
					var _v5 = _v1.c;
					return 'does not contain any of the substrings';
				} else {
					var _v7 = _v1.c;
					return 'does not contain all of the substrings';
				}
		}
	}
};
var $author$project$View$Classifier$Drill2$Editor$DeleteMultiValue = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$SetOp = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$View$Classifier$Drill2$Editor$viewMultiOperation = F4(
	function (_v0, op, index, vals) {
		var editable = _v0.i;
		var addEmptyEntry = function (ls) {
			var needsEntry = !A2($elm$core$List$any, $elm$core$String$isEmpty, ls);
			return needsEntry ? _Utils_ap(
				ls,
				_List_fromArray(
					[''])) : ls;
		};
		var newMsg = F2(
			function (i, v) {
				return A2(
					$author$project$View$Classifier$Drill2$Editor$SetOp,
					index,
					op(
						addEmptyEntry(
							A3($elm_community$list_extra$List$Extra$setAt, i, v, vals))));
			});
		var viewVal = F2(
			function (i, v) {
				var btn = _Utils_eq(
					i,
					$elm$core$List$length(vals) - 1) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '30px'),
							A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
						]),
					_List_Nil) : A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
							$elm$html$Html$Events$onClick(
							A2($author$project$View$Classifier$Drill2$Editor$DeleteMultiValue, index, i)),
							A2($elm$html$Html$Attributes$style, 'margin-right', '6px'),
							$elm$html$Html$Attributes$title('Remove this value'),
							$elm$html$Html$Attributes$disabled(!editable)
						]),
					_List_fromArray(
						[$author$project$Util$Glyphs$remove]));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-inline'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							btn,
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$class('form-control input-sm'),
									$elm$html$Html$Events$onInput(
									newMsg(i)),
									$elm$html$Html$Attributes$value(v),
									A2($elm$html$Html$Attributes$style, 'width', '600px'),
									$elm$html$Html$Attributes$disabled(!editable)
								]),
							_List_Nil)
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$indexedMap, viewVal, vals));
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$core$String$trimLeft = _String_trimLeft;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{p: nodeList, k: nodeListSize, o: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Util$Html$onOptionIndexSelected = function (tagger) {
	var indexDecoder = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'selectedIndex']),
		$elm$json$Json$Decode$int);
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, indexDecoder));
};
var $author$project$Util$Html$onOptionSelected = F3(
	function (items, defaultItem, tagger) {
		var selectedItem = function (index) {
			return A2(
				$elm$core$Maybe$withDefault,
				defaultItem,
				A2(
					$elm$core$Array$get,
					index,
					$elm$core$Array$fromList(items)));
		};
		return $author$project$Util$Html$onOptionIndexSelected(
			A2($elm$core$Basics$composeL, tagger, selectedItem));
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$View$Classifier$Drill2$Editor$viewSelectControl = function (_v0) {
	var itemToString = _v0.gw;
	var currentItem = _v0.fS;
	var items = _v0.R;
	var onSelect = _v0.eA;
	var eq = _v0.bc;
	var editable = _v0.i;
	var makeOption = function (item) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					itemToString(item)),
					$elm$html$Html$Attributes$selected(
					A2(eq, item, currentItem))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					itemToString(item))
				]));
	};
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control input-sm'),
				A3($author$project$Util$Html$onOptionSelected, items, currentItem, onSelect),
				$elm$html$Html$Attributes$disabled(!editable)
			]),
		A2($elm$core$List$map, makeOption, items));
};
var $author$project$View$Classifier$Drill2$Editor$viewSingleOperation = F5(
	function (_v0, index, val, dataType, opConstructor) {
		var editable = _v0.i;
		var makeMsg = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trimLeft,
			A2(
				$elm$core$Basics$composeR,
				opConstructor,
				$author$project$View$Classifier$Drill2$Editor$SetOp(index)));
		var hint = function () {
			switch (dataType) {
				case 0:
					return '123';
				case 1:
					return 'value';
				case 2:
					return 'true';
				case 3:
					return '1.2.3';
				case 4:
					return '0';
				default:
					return '';
			}
		}();
		var inputControl = A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$class('form-control input-sm'),
					$elm$html$Html$Attributes$value(val),
					$elm$html$Html$Attributes$placeholder(hint),
					$elm$html$Html$Events$onInput(makeMsg),
					A2($elm$html$Html$Attributes$style, 'width', '600px'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '10px'),
					$elm$html$Html$Attributes$disabled(!editable)
				]),
			_List_Nil);
		var boolControl = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '600px'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '10px')
				]),
			_List_fromArray(
				[
					$author$project$View$Classifier$Drill2$Editor$viewSelectControl(
					{fS: val, i: editable, bc: $elm$core$Basics$eq, gw: $elm$core$Basics$identity, R: $author$project$View$Classifier$Drill2$Editor$validBoolValues, eA: makeMsg})
				]));
		return (dataType === 2) ? boolControl : inputControl;
	});
var $author$project$View$Classifier$Drill2$Editor$viewOperation = F4(
	function (context, index, dataType, op) {
		switch (op.$) {
			case 0:
				var val = op.a;
				return A5($author$project$View$Classifier$Drill2$Editor$viewSingleOperation, context, index, val, dataType, $author$project$View$Classifier$Drill2$Editor$Eq);
			case 1:
				var val = op.a;
				return A5($author$project$View$Classifier$Drill2$Editor$viewSingleOperation, context, index, val, dataType, $author$project$View$Classifier$Drill2$Editor$Lt);
			case 2:
				var val = op.a;
				return A5($author$project$View$Classifier$Drill2$Editor$viewSingleOperation, context, index, val, dataType, $author$project$View$Classifier$Drill2$Editor$Gt);
			case 3:
				return $elm$html$Html$text('');
			case 4:
				var val = op.a;
				return A5($author$project$View$Classifier$Drill2$Editor$viewSingleOperation, context, index, val, dataType, $author$project$View$Classifier$Drill2$Editor$Substring);
			case 5:
				var vals = op.a;
				return A4($author$project$View$Classifier$Drill2$Editor$viewMultiOperation, context, $author$project$View$Classifier$Drill2$Editor$MultiEq, index, vals);
			default:
				var vals = op.a;
				return A4($author$project$View$Classifier$Drill2$Editor$viewMultiOperation, context, $author$project$View$Classifier$Drill2$Editor$MultiSubstr, index, vals);
		}
	});
var $author$project$View$Classifier$Drill2$Editor$SetDataType = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$SetPath = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$View$Classifier$Drill2$Editor$allOperandTypes = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$View$Classifier$Drill2$Editor$allPrimitiveOperandTypes = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$View$Form$container = F2(
	function (isValid, elements) {
		var attributes = isValid ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('has-error')
			]);
		return A2($elm$html$Html$div, attributes, elements);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$View$Classifier$Drill2$Editor$isArrayPath = function (path) {
	return A2($elm$core$String$endsWith, '[]', path);
};
var $author$project$View$Classifier$Drill2$Editor$isTopLevelIndex = function (index) {
	if (!index.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$Classifier$Drill2$Editor$operandTypeText = function (operandType) {
	switch (operandType) {
		case 0:
			return 'number';
		case 1:
			return 'string';
		case 2:
			return 'boolean';
		case 3:
			return 'version string';
		case 4:
			return 'array';
		default:
			return 'object';
	}
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$list = _VirtualDom_attribute('list');
var $author$project$Util$String$caseInsensitiveEquality = F2(
	function (s1, s2) {
		return _Utils_eq(
			$elm$core$String$toLower(s1),
			$elm$core$String$toLower(s2));
	});
var $author$project$Util$String$caseInsensitiveStartsWith = F2(
	function (needle, haystack) {
		return A2(
			$elm$core$String$startsWith,
			$elm$core$String$toLower(needle),
			$elm$core$String$toLower(haystack));
	});
var $elm_community$string_extra$String$Extra$countOccurrences = F2(
	function (needle, haystack) {
		return ((!$elm$core$String$length(needle)) || (!$elm$core$String$length(haystack))) ? 0 : $elm$core$List$length(
			A2($elm$core$String$indexes, needle, haystack));
	});
var $author$project$View$KeyPathSuggestion$trimKeyPathComponents = F2(
	function (limit, list) {
		return A2(
			$elm$core$List$map,
			$elm$core$String$join('.'),
			A2(
				$elm$core$List$map,
				$elm$core$List$take(limit + 1),
				A2(
					$elm$core$List$filter,
					function (l) {
						return _Utils_cmp(
							$elm$core$List$length(l),
							limit) > 0;
					},
					A2(
						$elm$core$List$map,
						$elm$core$String$split('.'),
						list))));
	});
var $author$project$View$KeyPathSuggestion$suggest = F2(
	function (keyPaths, userInput) {
		var inputComponentCount = A2($elm_community$string_extra$String$Extra$countOccurrences, '.', userInput);
		return A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(userInput),
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$author$project$View$KeyPathSuggestion$trimKeyPathComponents,
					inputComponentCount,
					A2(
						$elm$core$List$filter,
						$author$project$Util$String$caseInsensitiveStartsWith(userInput),
						keyPaths))));
	});
var $author$project$View$KeyPathSuggestion$smartSuggestions = F2(
	function (keyPaths, userInput) {
		var suggestionsAsIs = A2($author$project$View$KeyPathSuggestion$suggest, keyPaths, userInput);
		var shouldContinueSuggestions = function (suggestions) {
			if (!$elm$core$List$length(suggestions)) {
				return true;
			} else {
				if ($elm$core$List$length(suggestions) === 1) {
					var _v0 = $elm$core$List$head(suggestions);
					if (!_v0.$) {
						var head = _v0.a;
						return A2($author$project$Util$String$caseInsensitiveEquality, head, userInput);
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		};
		return shouldContinueSuggestions(suggestionsAsIs) ? A2(
			$elm$core$List$append,
			suggestionsAsIs,
			A2($author$project$View$KeyPathSuggestion$suggest, keyPaths, userInput + '.')) : suggestionsAsIs;
	});
var $elm$html$Html$datalist = _VirtualDom_node('datalist');
var $author$project$View$KeyPathSuggestion$maxSuggestionsToDisplay = 50;
var $author$project$View$KeyPathSuggestion$viewDataList = F2(
	function (dataListId, suggestions) {
		var suggestionsToDisplay = A2($elm$core$List$take, $author$project$View$KeyPathSuggestion$maxSuggestionsToDisplay, suggestions);
		var listOption = function (s) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(s)
					]),
				_List_Nil);
		};
		return A2(
			$elm$html$Html$datalist,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(dataListId)
				]),
			A2($elm$core$List$map, listOption, suggestionsToDisplay));
	});
var $author$project$View$KeyPathSuggestion$view = F2(
	function (config, state) {
		var suggestions = A2($author$project$View$KeyPathSuggestion$smartSuggestions, state.aM, state.go);
		var dataListId = state.hO;
		var baseAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('text'),
				$elm$html$Html$Attributes$class(config.fD),
				$elm$html$Html$Attributes$placeholder(state.gn),
				$elm$html$Html$Attributes$value(state.go),
				$elm$html$Html$Attributes$autocomplete(false),
				A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
				$elm$html$Html$Events$onInput(config.g$),
				$elm$html$Html$Attributes$list(dataListId)
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_Utils_ap(baseAttributes, config.ft),
				_List_Nil),
				A2($author$project$View$KeyPathSuggestion$viewDataList, dataListId, suggestions)
			]);
	});
var $author$project$View$Classifier$Drill2$Editor$viewQueryPathAndType = F5(
	function (context, index, path, hint, currentItem) {
		var typeChoices = $author$project$View$Classifier$Drill2$Editor$isTopLevelIndex(index) ? $author$project$View$Classifier$Drill2$Editor$allOperandTypes : $author$project$View$Classifier$Drill2$Editor$allPrimitiveOperandTypes;
		var isText = $author$project$View$Classifier$Drill2$Editor$isArrayPath(path) ? ' contains a ' : ' is a ';
		var dataListId = function () {
			if (!index.$) {
				var row = index.a;
				return 'top-level-row-' + $elm$core$String$fromInt(row);
			} else {
				var row = index.a;
				var keyPath = index.b;
				return 'object-row-' + ($elm$core$String$fromInt(row) + ('-' + $elm$core$String$fromInt(keyPath)));
			}
		}();
		var state = {gn: hint, go: path, aM: context.aM, hO: dataListId};
		var config = function (idx) {
			return {
				ft: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'min-width', '400px'),
						A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
						A2($elm$html$Html$Attributes$style, 'font-weight', '600'),
						$elm$html$Html$Attributes$disabled(!context.i)
					]),
				fD: 'form-control input-sm',
				g$: $author$project$View$Classifier$Drill2$Editor$SetPath(idx)
			};
		};
		return _List_fromArray(
			[
				A2(
				$author$project$View$Form$container,
				true,
				A2(
					$author$project$View$KeyPathSuggestion$view,
					config(index),
					state)),
				$author$project$View$Classifier$Drill2$Editor$staticFormText(isText),
				$author$project$View$Classifier$Drill2$Editor$viewSelectControl(
				{
					fS: currentItem,
					i: context.i,
					bc: $elm$core$Basics$eq,
					gw: $author$project$View$Classifier$Drill2$Editor$operandTypeText,
					R: typeChoices,
					eA: $author$project$View$Classifier$Drill2$Editor$SetDataType(index)
				})
			]);
	});
var $author$project$View$Classifier$Drill2$Editor$viewPrimitiveQuery = F4(
	function (context, index, details, hint) {
		var thatText = (details.dW === 4) ? ' with length that ' : ' that ';
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-inline')
						]),
					_Utils_ap(
						A5($author$project$View$Classifier$Drill2$Editor$viewQueryPathAndType, context, index, details.eF, hint, details.dW),
						_List_fromArray(
							[
								$author$project$View$Classifier$Drill2$Editor$staticFormText(thatText),
								$author$project$View$Classifier$Drill2$Editor$viewSelectControl(
								{
									fS: _Utils_Tuple3(details.eB, details.ew, details.a7),
									i: context.i,
									bc: $author$project$View$Classifier$Drill2$Editor$operationEq,
									gw: $author$project$View$Classifier$Drill2$Editor$operationText,
									R: A2($author$project$View$Classifier$Drill2$Editor$opChoicesForType, details.dW, details.eB),
									eA: $author$project$View$Classifier$Drill2$Editor$SetOpChoice(index)
								})
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							A4($author$project$View$Classifier$Drill2$Editor$viewOperation, context, index, details.dW, details.eB)
						]))
				]));
	});
var $author$project$View$Classifier$Drill2$Editor$viewObjectQuery = F4(
	function (context, index, path, detailList) {
		var primitiveQueryKeyPaths = A2(
			$elm$core$List$map,
			$elm$core$String$dropLeft(
				$elm$core$String$length(path)),
			A2(
				$elm$core$List$filter,
				$elm$core$String$startsWith(path),
				context.aM));
		var subViewContext = {i: context.i, aM: primitiveQueryKeyPaths};
		var viewKeyQuery = F2(
			function (i, q) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
									$elm$html$Html$Events$onClick(
									A2($author$project$View$Classifier$Drill2$Editor$DeleteObjectKeyQuery, index, i)),
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'margin-top', '6px'),
									$elm$html$Html$Attributes$title('Remove this key')
								]),
							_List_fromArray(
								[$author$project$Util$Glyphs$remove])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', '30px')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$View$Classifier$Drill2$Editor$viewPrimitiveQuery,
									subViewContext,
									A2($author$project$View$Classifier$Drill2$Editor$ObjectIndex, index, i),
									q,
									'.key')
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-inline')
						]),
					_Utils_ap(
						A5(
							$author$project$View$Classifier$Drill2$Editor$viewQueryPathAndType,
							context,
							$author$project$View$Classifier$Drill2$Editor$TopLevelIndex(index),
							path,
							'.data.list[]',
							5),
						_List_fromArray(
							[
								$author$project$View$Classifier$Drill2$Editor$staticFormText(' with the following keys')
							]))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($elm$core$List$indexedMap, viewKeyQuery, detailList)),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-borderless btn-xs'),
							$elm$html$Html$Events$onClick(
							$author$project$View$Classifier$Drill2$Editor$AddObjectKeyQuery(index)),
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							$author$project$Util$Glyphs$plus,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Add key')
								]))
						]))
				]));
	});
var $author$project$View$Classifier$Drill2$Editor$viewQuery = F3(
	function (context, index, query) {
		var removeQueryElement = (!context.i) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-sm btn-borderless'),
					$elm$html$Html$Events$onClick(
					$author$project$View$Classifier$Drill2$Editor$DeleteQuery(index)),
					$elm$html$Html$Attributes$title('Remove this query')
				]),
			_List_fromArray(
				[$author$project$Util$Glyphs$remove]));
		var queryContent = function () {
			if (!query.$) {
				var details = query.a;
				return A4(
					$author$project$View$Classifier$Drill2$Editor$viewPrimitiveQuery,
					context,
					$author$project$View$Classifier$Drill2$Editor$TopLevelIndex(index),
					details,
					'.data.list[]');
			} else {
				var path = query.a;
				var detailList = query.b;
				return A4($author$project$View$Classifier$Drill2$Editor$viewObjectQuery, context, index, path, detailList);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'flex', '1 1 auto'),
									A2($elm$html$Html$Attributes$style, 'padding', '20px 20px 30px 20px')
								]),
							_List_fromArray(
								[queryContent])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'flex', 'none'),
									A2($elm$html$Html$Attributes$style, 'margin', '5px')
								]),
							_List_fromArray(
								[removeQueryElement]))
						]))
				]));
	});
var $author$project$View$Classifier$Drill2$Editor$view = F2(
	function (keyPaths, model) {
		var viewContext = {i: model.i, aM: keyPaths};
		var singleQueryHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding', '7px 10px'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This classifier matches if the following is true')
				]));
		var multiQueryHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					$author$project$View$Classifier$Drill2$Editor$staticFormText('This classifier matches if '),
					$author$project$View$Classifier$Drill2$Editor$viewSelectControl(
					{fS: model.a7, i: model.i, bc: $elm$core$Basics$eq, gw: $author$project$View$Classifier$Drill2$Editor$combinerText, R: $author$project$View$Classifier$Drill2$Editor$allCombiners, eA: $author$project$View$Classifier$Drill2$Editor$SetCombiner}),
					$author$project$View$Classifier$Drill2$Editor$staticFormText(' of the following are true')
				]));
		var header = ($elm$core$List$length(model.de) <= 1) ? singleQueryHeader : multiQueryHeader;
		var addQueryElement = (!model.i) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-borderless btn-sm pull-right'),
					$elm$html$Html$Events$onClick($author$project$View$Classifier$Drill2$Editor$AddQuery),
					A2($elm$html$Html$Attributes$style, 'margin-top', '2px')
				]),
			_List_fromArray(
				[
					$author$project$Util$Glyphs$plus,
					$elm$html$Html$text(' Add query')
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('clearfix'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '5px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-inline pull-left')
									]),
								_List_fromArray(
									[header])),
								addQueryElement
							]))
					]),
				A2(
					$elm$core$List$indexedMap,
					$author$project$View$Classifier$Drill2$Editor$viewQuery(viewContext),
					model.de)));
	});
var $author$project$View$Classifier$FileRegex$Editor$UpdatePattern = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Classifier$RegexClassifier$docsMarkdown = '\n#### Overview\nClassifies plaintext files by applying a regular expression to each line of the input.\n\n#### Fields\n- **Pattern**: the regex to be evaluated against the file\'s text contents\n   ([regex syntax](https://docs.oracle.com/javase/8/docs/api/java/util/regex/Pattern.html))\n- **Label**: the label to attach to the file when the regex pattern matches\n\nSince the regex operates line-by-line, the `^` and `$` characters match the beginning and\nend of the line, respectively.\n\n#### Examples\n\nInput Log File:\n```\n2018-04-01T20:01:26+00:00 app launched\n2018-04-01T20:01:27+00:00 showing login screen\n2018-04-01T20:01:28+00:00 begin login\n2018-04-01T20:01:29+00:00 UH-OH! error 9871\n2018-04-01T20:01:30+00:00 begin login\n2018-04-01T20:01:30+00:00 UH-OH! error 42\n2018-04-01T20:01:30+00:00 shutting down\n```\n\nRegex Patterns:\n- `error \\d+` will match two lines ("error 9871" and "error 42")\n- `^2018-\\d{2}-\\d{2}` will match all lines logged during the year 2018\n\n';
var $author$project$View$Classifier$FileRegex$Editor$ToggleHelp = {$: 1};
var $author$project$View$Classifier$FileRegex$Editor$viewHelp = F3(
	function (title, contentMarkdown, expanded) {
		return (!expanded) ? A3(
			$author$project$Util$Bootstrap$button,
			'btn-link',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$View$Classifier$FileRegex$Editor$ToggleHelp)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Show Help')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-link',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$View$Classifier$FileRegex$Editor$ToggleHelp)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Help')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm_explorations$markdown$Markdown$toHtml,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-body')
								]),
							contentMarkdown)
						]))
				]));
	});
var $author$project$View$Classifier$FileRegex$Editor$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-horizontal')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Util$Bootstrap$textField,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(!model.i)
							]),
						$author$project$View$Classifier$FileRegex$Editor$UpdatePattern,
						'Pattern',
						model.db)
					])),
				A3($author$project$View$Classifier$FileRegex$Editor$viewHelp, 'Regex help', $author$project$Data$Classifier$RegexClassifier$docsMarkdown, model.cv)
			]));
};
var $author$project$View$Classifier$Javascript$Editor$Update = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Classifier$Javascript$docsMarkdown = '\nThe `PowerLift` global object is the bridge API to the PowerLift server. It has three methods:\n\n    1. getIncident(): Incident\n    2. submitClassifications(List<Classification>): Void\n    3. newClassification(obj): Classification\n\nThe `Incident` is an object with 2 fields at the top-level:\n1. `meta` which has fields like `platform`, `clientVersion`, etc\n2. `data` which contains application-defined data\n\nThe `newClassification()` method takes a single JS object with 2 fields:\n1. `label` where the value is a String (the actual label you want to apply; please use a\n    \'pl_\' prefix)\n2. `confidence` where the value is in the range [0, 100]\n';
var $author$project$View$Classifier$Javascript$Editor$ToggleHelp = {$: 1};
var $author$project$View$Classifier$Javascript$Editor$viewHelp = F3(
	function (title, contentMarkdown, expanded) {
		return (!expanded) ? A3(
			$author$project$Util$Bootstrap$button,
			'btn-link',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$View$Classifier$Javascript$Editor$ToggleHelp)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Show Help')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-link',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$View$Classifier$Javascript$Editor$ToggleHelp)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Help')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm_explorations$markdown$Markdown$toHtml,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-body')
								]),
							contentMarkdown)
						]))
				]));
	});
var $author$project$View$Classifier$Javascript$Editor$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('JavaScript Code')
					])),
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$rows(20),
						$elm$html$Html$Attributes$class('form-control'),
						$elm$html$Html$Events$onInput($author$project$View$Classifier$Javascript$Editor$Update),
						$elm$html$Html$Attributes$value(model.bs),
						$elm$html$Html$Attributes$disabled(!model.i)
					]),
				_List_Nil),
				A3($author$project$View$Classifier$Javascript$Editor$viewHelp, 'JavaScript / PowerLift API', $author$project$Data$Classifier$Javascript$docsMarkdown, model.cv)
			]));
};
var $author$project$View$Classifier$Random$Editor$Update = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Classifier$RandomClassifier$docsMarkdown = '\n#### Overview\nEmits a classification label with a random probability.\n\n\n#### Fields\n- **Percent Chance**: the percentage chance (between 0 and 100) that a classification will be emitted.\n- **Label**: the label to attach to the incident\n';
var $author$project$View$Classifier$Random$Editor$ToggleHelp = {$: 1};
var $author$project$View$Classifier$Random$Editor$viewHelp = F3(
	function (title, contentMarkdown, expanded) {
		return (!expanded) ? A3(
			$author$project$Util$Bootstrap$button,
			'btn-link',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$View$Classifier$Random$Editor$ToggleHelp)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Show Help')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-link',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$View$Classifier$Random$Editor$ToggleHelp)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Help')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm_explorations$markdown$Markdown$toHtml,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-body')
								]),
							contentMarkdown)
						]))
				]));
	});
var $author$project$View$Classifier$Random$Editor$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-horizontal')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Util$Bootstrap$textField,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(!model.i)
							]),
						$author$project$View$Classifier$Random$Editor$Update,
						'Percent Chance',
						$elm$core$String$fromInt(model.dc))
					])),
				A3($author$project$View$Classifier$Random$Editor$viewHelp, 'Random help', $author$project$Data$Classifier$RandomClassifier$docsMarkdown, model.cv)
			]));
};
var $author$project$Page$Classifier$Editor$viewConfig = function (model) {
	var contentHelp = F3(
		function (subModel, toHtml, toPageMsg) {
			return A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Page$Classifier$Editor$UpdateContent, toPageMsg),
				toHtml(subModel));
		});
	var content = function () {
		var _v0 = model.L;
		switch (_v0.$) {
			case 0:
				var subModel = _v0.a;
				return A3(contentHelp, subModel, $author$project$View$Classifier$Javascript$Editor$view, $author$project$Page$Classifier$Editor$JavascriptMsg);
			case 1:
				var subModel = _v0.a;
				var keyPaths = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.aM);
				return A3(
					contentHelp,
					subModel,
					$author$project$View$Classifier$Drill2$Editor$view(keyPaths),
					$author$project$Page$Classifier$Editor$Drill2Msg);
			case 2:
				var subModel = _v0.a;
				return A3(contentHelp, subModel, $author$project$View$Classifier$Random$Editor$view, $author$project$Page$Classifier$Editor$RandomMsg);
			case 3:
				var subModel = _v0.a;
				return A3(contentHelp, subModel, $author$project$View$Classifier$FileRegex$Editor$view, $author$project$Page$Classifier$Editor$FileRegexMsg);
			default:
				var s = _v0.a;
				return $elm$html$Html$text('classifier type \'' + (s + '\' is not supported'));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[content]));
};
var $author$project$View$ProgressBar$emptyGap = function (customStyle) {
	return A2($elm$html$Html$div, customStyle, _List_Nil);
};
var $author$project$View$ProgressBar$viewIf = function (visible) {
	return visible ? $author$project$View$ProgressBar$view : $author$project$View$ProgressBar$emptyGap($author$project$View$ProgressBar$roundedStyle);
};
var $author$project$Page$Classifier$Editor$ShowHelpModalForDiscardIncident = {$: 3};
var $author$project$Page$Classifier$Editor$UpdateMetaDescription = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateMetaDiscard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateMetaEnabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateMetaFileInputPattern = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateMetaTitle = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Util$Bootstrap$checkbox = F4(
	function (attributes, msg, name, state) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-offset-2 col-sm-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_Utils_ap(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Events$onCheck(msg),
														$elm$html$Html$Attributes$checked(state)
													]),
												attributes),
											_List_Nil),
											$elm$html$Html$text(name)
										]))
								]))
						]))
				]));
	});
var $author$project$Util$Bootstrap$checkboxAdvanced = F5(
	function (attributes, msg, name, children, state) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-offset-2 col-sm-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_Utils_ap(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Events$onCheck(msg),
														$elm$html$Html$Attributes$checked(state)
													]),
												attributes),
											_List_Nil),
											$elm$html$Html$text(name)
										])),
								children))
						]))
				]));
	});
var $author$project$Page$Classifier$Editor$fileClassifierDocsMarkdown = '\nFile-based classifiers are very similar to the normal, incident-based classifiers in PowerLift.\nWhen a file is uploaded to PowerLift, each active classifier is given a chance to classify that\nfile and emit a label. The classifications are returned in the response to the file upload,\nand they are stored in PowerLift\'s database.\n\nHowever, there are some important differences. File classifiers...\n\n- cannot trigger a remedy\n- need a \'Filename Glob\' pattern to limit the files that it operates on\n\n#### Filename Glob Pattern\n\nWhen writing a file classifier, it\'s important that you restrict its operation to the smallest\nset of files possible. If an app uploads 2 different types of log files, `workout-log.txt`\nand `gains-log.txt`, and you are writing a classifier for the "workout" log, you would set\n"Filename Glob" to `workout-log.txt`.\n\nThe "Filename Glob" must match the entire filename. So if you want to match all files ending\nwith `.txt`, you need to use `*.txt`. You can also use a `?` to match any single character.\nSo the pattern `file?.txt` will match `file1.txt` and `file2.txt`, but not `file10.txt`.\n\n';
var $author$project$Util$Html$styleIf = F3(
	function (condition, attribute, value) {
		return condition ? A2($elm$html$Html$Attributes$style, attribute, value) : A2($elm$html$Html$Attributes$style, '', '');
	});
var $author$project$Page$Classifier$Editor$HideHelpModal = {$: 4};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Util$Bootstrap$viewModal = function (config) {
	var headerDiv = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('close'),
						$elm$html$Html$Events$onClick(config.dM)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('×')
					])),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.bO)
					]))
			]));
	var footerDiv = function (footer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-footer')
				]),
			_List_fromArray(
				[footer]));
	};
	var bodyDiv = function (body) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-body'),
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
					A2($elm$html$Html$Attributes$style, 'max-height', '80vh')
				]),
			_List_fromArray(
				[body]));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal in'),
						$elm$html$Html$Attributes$tabindex(-1),
						$author$project$Util$Html$role('dialog'),
						A2($elm$html$Html$Attributes$style, 'display', 'block')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog'),
								A2(
								$elm$core$Maybe$withDefault,
								A2($elm$html$Html$Attributes$style, '', ''),
								A2(
									$elm$core$Maybe$map,
									$elm$html$Html$Attributes$style('width'),
									config.fh))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-content'),
										$author$project$Util$Html$role('document')
									]),
								_List_fromArray(
									[
										headerDiv,
										A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$elm$html$Html$text(''),
										bodyDiv,
										config.bX),
										A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$elm$html$Html$text(''),
										footerDiv,
										config.ec)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-backdrop in')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Classifier$Editor$viewDiscardHelpModal = function (_v0) {
	var modal = _v0.S;
	var modalFooter = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Util$Bootstrap$button,
				'btn-primary',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$HideHelpModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('OK')
					]))
			]));
	var modalBody = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, '\n### WARNING!\n\nChecking the `Discard Incident` box will cause matching incidents to be **discarded instead of stored**.\nDiscarded incidents will not be able to be found in the PowerLift Gym, and any\nlog files associated with the incident will also be discarded.\n\n**This is almost certainly not what you want!**\n\nHowever, there are rare cases where you may need to use it:\n- your client app is accidentally sending sensitive data to PowerLift and you need to stop it\n- your client app is flooding PowerLift with too many incidents\n\nQuestions? Contact us at [powerlifters@microsoft.com](mailto:powerlifters@microsoft.com).\n')
			]));
	var config = {
		bX: $elm$core$Maybe$Just(modalBody),
		dM: $author$project$Page$Classifier$Editor$HideHelpModal,
		ec: $elm$core$Maybe$Just(modalFooter),
		bO: 'Help: Discard Incident',
		fh: $elm$core$Maybe$Nothing
	};
	return (modal === 2) ? $author$project$Util$Bootstrap$viewModal(config) : $elm$html$Html$text('');
};
var $author$project$Util$Bootstrap$linkPill = F7(
	function (route, newTarget, displayText, hoverText, colorClass, attributes, glyph) {
		var target = newTarget ? $elm$html$Html$Attributes$target('_blank') : $elm$html$Html$Attributes$target('_self');
		var body = function () {
			if (!glyph.$) {
				var value = glyph.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-right', '6px')
							]),
						_List_fromArray(
							[value])),
						$elm$html$Html$text(displayText)
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(displayText)
					]);
			}
		}();
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['btn', 'btn-xs', colorClass]))),
						A2($elm$html$Html$Attributes$style, 'margin', '2px'),
						A2($elm$html$Html$Attributes$style, 'border', 'none'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
						$elm$html$Html$Attributes$title(hoverText),
						$author$project$Util$Html$role('button'),
						$author$project$App$Route$href(route),
						target
					]),
				attributes),
			body);
	});
var $author$project$Util$Bootstrap$groupPill = F3(
	function (route, displayText, hoverText) {
		return A7($author$project$Util$Bootstrap$linkPill, route, true, displayText, hoverText, 'btn-subdued-neutral', _List_Nil, $elm$core$Maybe$Nothing);
	});
var $author$project$Page$Classifier$Editor$viewGroup = function (groups) {
	var groupViews = A2(
		$elm$core$List$map,
		function (g) {
			return A3(
				$author$project$Util$Bootstrap$groupPill,
				$author$project$App$Route$ViewGroup(g.bj),
				g.ev,
				g.b6);
		},
		groups);
	return $elm$core$List$isEmpty(groups) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '3px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('None')
			])) : A2($elm$html$Html$div, _List_Nil, groupViews);
};
var $author$project$Page$Classifier$Editor$AddToGroup = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$Classifier$Editor$HideGroupModal = {$: 25};
var $author$project$Util$Html$viewIf = F2(
	function (condition, content) {
		return condition ? content : $elm$html$Html$text('');
	});
var $author$project$Page$Classifier$Editor$viewGroupDetails = F3(
	function (maybeActiveTenant, groups, selectedGroup) {
		if (!selectedGroup.$) {
			var value = selectedGroup.a;
			var maybeSelectedGroup = A2(
				$elm_community$list_extra$List$Extra$find,
				function (g) {
					return A2($author$project$UUID$isEqual, g.gb.bj, value.bj);
				},
				groups);
			var activeTenantId = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$UUID$nil,
				function ($) {
					return $.bj;
				},
				maybeActiveTenant);
			var tenantNames = A2(
				$elm$core$List$map,
				function ($) {
					return $.ev;
				},
				A2(
					$elm$core$List$filter,
					function (t) {
						return !A2($author$project$UUID$isEqual, t.eL, activeTenantId);
					},
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function ($) {
							return $.hB;
						},
						maybeSelectedGroup)));
			return A2(
				$author$project$Util$Html$viewIf,
				!$elm$core$List$isEmpty(tenantNames),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-warning')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('By adding this classifier to \'' + (value.ev + '\', it will be added to and synced with the following tenants.')),
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (t) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(t)
													]));
										},
										tenantNames))
								]))
						])));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Classifier$Editor$UpdateSelectedGroup = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$Classifier$Editor$viewSelectGroupDropDown = F3(
	function (isSaving, selectedGroup, groups) {
		var viewSelectOption = function (g) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						$author$project$UUID$toString(g.bj))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(g.ev)
					]));
		};
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput($author$project$Page$Classifier$Editor$UpdateSelectedGroup),
					$elm$html$Html$Attributes$value(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'foo',
						function (g) {
							return $author$project$UUID$toString(g.bj);
						},
						selectedGroup)),
					A2($elm$html$Html$Attributes$style, 'margin-top', '10px'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '6px'),
					$elm$html$Html$Attributes$disabled(isSaving)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$value('foo'),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select a group')
						])),
				A2($elm$core$List$map, viewSelectOption, groups)));
	});
var $author$project$Page$Classifier$Editor$viewGroupModal = function (model) {
	var maybeActiveTenant = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Maybe$Nothing, $author$project$Data$User$activeTenant, model.az);
	var isSaving = model.h === 2;
	var modalFooter = function () {
		var _v0 = model.ab;
		if (!_v0.$) {
			var value = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$App$Route$href(
								$author$project$App$Route$ViewGroup(value.bj)),
								A2($elm$html$Html$Attributes$style, 'margin-right', '24px'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View Group')
							])),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Page$Classifier$Editor$AddToGroup(value)),
								$elm$html$Html$Attributes$disabled(isSaving)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add to \'' + (value.ev + '\''))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var classifierGroups = A2(
		$elm$core$List$map,
		function ($) {
			return $.gb;
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.gq;
			},
			model.gc));
	var candidateGroups = A2(
		$elm$core$List$map,
		function ($) {
			return $.gb;
		},
		A2(
			$elm$core$List$filter,
			function (g) {
				return !g.gq;
			},
			model.gc));
	var modalBody = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Current groups:'),
				$author$project$Page$Classifier$Editor$viewGroup(classifierGroups),
				$elm$html$Html$text('Add to group: '),
				A3($author$project$Page$Classifier$Editor$viewSelectGroupDropDown, isSaving, model.ab, candidateGroups),
				A3($author$project$Page$Classifier$Editor$viewGroupDetails, maybeActiveTenant, model.gc, model.ab)
			]));
	var config = {
		bX: $elm$core$Maybe$Just(modalBody),
		dM: $author$project$Page$Classifier$Editor$HideGroupModal,
		ec: $elm$core$Maybe$Just(modalFooter),
		bO: 'Add to group',
		fh: $elm$core$Maybe$Nothing
	};
	return A2(
		$author$project$Util$Html$viewIf,
		model.S === 1,
		$author$project$Util$Bootstrap$viewModal(config));
};
var $author$project$Page$Classifier$Editor$ShowGroupModal = {$: 24};
var $author$project$Page$Classifier$Editor$viewShowGroupModalButton = function (model) {
	var showGroupModalButton = A3(
		$author$project$Util$Bootstrap$button,
		'btn-link',
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$ShowGroupModal),
				A2($elm$html$Html$Attributes$style, 'padding', '0')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add to group')
			]));
	var isNotInGroup = !A2(
		$elm$core$List$any,
		function ($) {
			return $.gq;
		},
		model.gc);
	var isEditing = model.u === 2;
	return A2($author$project$Util$Html$viewIf, isEditing && isNotInGroup, showGroupModalButton);
};
var $author$project$Page$Classifier$Editor$viewGroups = function (model) {
	var tenantIsInAGroup = !$elm$core$List$isEmpty(model.gc);
	var shouldShowInViewMode = (model.u === 1) || (model.u === 2);
	var classifierGroup = A2(
		$elm$core$List$map,
		function ($) {
			return $.gb;
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.gq;
			},
			model.gc));
	return A2(
		$author$project$Util$Html$viewIf,
		tenantIsInAGroup && shouldShowInViewMode,
		A2(
			$author$project$Util$Bootstrap$formField,
			'Group',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
						]),
					_List_fromArray(
						[
							$author$project$Page$Classifier$Editor$viewGroup(classifierGroup),
							$author$project$Page$Classifier$Editor$viewShowGroupModalButton(model),
							$author$project$Page$Classifier$Editor$viewGroupModal(model)
						]))
				])));
};
var $author$project$Page$Classifier$Editor$UpdateLabel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Util$Glyphs$tag = $author$project$Util$Glyphs$make('glyphicon-tag');
var $author$project$Util$Bootstrap$remedyPill = F4(
	function (route, newTarget, displayText, hoverText) {
		return A7(
			$author$project$Util$Bootstrap$linkPill,
			route,
			newTarget,
			displayText,
			hoverText,
			'btn-subdued-green',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-weight', '700')
				]),
			$elm$core$Maybe$Just($author$project$Util$Glyphs$tag));
	});
var $author$project$Page$Classifier$Editor$viewLabelFormInput = F3(
	function (extraAttributes, maybeLabel, remedies) {
		if (!maybeLabel.$) {
			var label = maybeLabel.a;
			var remedyPills = A2(
				$elm$core$List$map,
				function (r) {
					return A4(
						$author$project$Util$Bootstrap$remedyPill,
						A2($author$project$App$Route$ViewRemedy, r.bj, r.dx),
						true,
						r.bO,
						r.b6);
				},
				A2(
					$elm$core$List$filter,
					function (r) {
						return _Utils_eq(r.hN, label) && (label !== '');
					},
					remedies));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-2 control-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Label')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-10')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$class('form-control'),
											$elm$html$Html$Events$onInput($author$project$Page$Classifier$Editor$UpdateLabel),
											$elm$html$Html$Attributes$value(label)
										]),
									extraAttributes),
								_List_Nil),
								($elm$core$List$length(remedyPills) > 0) ? A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('help-block')
									]),
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$text('Remedies with matching trigger: ')
										]),
									remedyPills)) : $elm$html$Html$text('')
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Classifier$Editor$viewMeta = function (model) {
	var disabledAttribute = $elm$html$Html$Attributes$disabled(
		(!$author$project$Page$Classifier$Editor$isEditable(model.u)) || (model.h === 2));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-horizontal')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A4(
					$author$project$Util$Bootstrap$textField,
					_List_fromArray(
						[disabledAttribute]),
					$author$project$Page$Classifier$Editor$UpdateMetaTitle,
					'Title',
					model.er.bO),
					A2(
					$author$project$Util$Bootstrap$formField,
					'Version',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control-static')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(model.er.dx) + ' '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$App$Route$href(
											$author$project$App$Route$ViewClassifierHistory(model.er.bj))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('(all versions)')
										]))
								]))
						])),
					A2($author$project$Util$Bootstrap$textLabel, 'Edited By', model.er.dy),
					A4(
					$author$project$Util$Bootstrap$checkbox,
					_List_fromArray(
						[disabledAttribute]),
					$author$project$Page$Classifier$Editor$UpdateMetaEnabled,
					'Enabled',
					model.er.cM),
					A4(
					$author$project$Util$Bootstrap$textField,
					_List_fromArray(
						[disabledAttribute]),
					$author$project$Page$Classifier$Editor$UpdateMetaDescription,
					'Description',
					model.er.b6),
					A3(
					$author$project$Page$Classifier$Editor$viewLabelFormInput,
					_List_fromArray(
						[disabledAttribute]),
					model.eo,
					model.hc),
					$author$project$Page$Classifier$Editor$viewGroups(model),
					A5(
					$author$project$Util$Bootstrap$checkboxAdvanced,
					_List_fromArray(
						[disabledAttribute]),
					$author$project$Page$Classifier$Editor$UpdateMetaDiscard,
					'Discard Incident',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Util$Html$role('button'),
									$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$ShowHelpModalForDiscardIncident)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' '),
									$author$project$Util$Glyphs$questionMark
								])),
							$author$project$Page$Classifier$Editor$viewDiscardHelpModal(model),
							A2(
							$author$project$Util$Html$viewIf,
							model.er.cJ,
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										A3($author$project$Util$Html$styleIf, model.er.cJ, 'color', 'var(--pl-danger-color)')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Incidents matching this classifier will be thrown away!')
									])))
						]),
					model.er.cJ)
				]),
			_Utils_ap(
				function () {
					var _v0 = model.er.c_;
					if (_v0.$ === 1) {
						var filenamePattern = _v0.a;
						return _List_fromArray(
							[
								A4(
								$author$project$Util$Bootstrap$textField,
								_List_fromArray(
									[disabledAttribute]),
								$author$project$Page$Classifier$Editor$UpdateMetaFileInputPattern,
								'Filename Glob',
								filenamePattern),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('panel panel-info')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('panel-heading')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('File Classifiers Help')
											])),
										A2(
										$elm_explorations$markdown$Markdown$toHtml,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('panel-body')
											]),
										$author$project$Page$Classifier$Editor$fileClassifierDocsMarkdown)
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_List_fromArray(
					[
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						$author$project$View$Docs$helpBox(4)
					]))));
};
var $author$project$View$Badge$view = function (badge) {
	switch (badge.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			var n = badge.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('badge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(n))
					]));
		default:
			var n = badge.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('badge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(n) + '+')
					]));
	}
};
var $author$project$Util$Navs$itemView = F2(
	function (_v0, item) {
		var tabTitle = _v0.hv;
		var selectedItem = _v0.ho;
		var onSelect = _v0.eA;
		var _v1 = tabTitle(item);
		var name = _v1.a;
		var badge = _v1.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(selectedItem, item))
						])),
					$author$project$Util$Html$role('presentation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							onSelect(item)),
							$author$project$Util$Html$role('button')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name),
									$elm$html$Html$text(' '),
									$author$project$View$Badge$view(badge)
								]))
						]))
				]));
	});
var $author$project$Util$Navs$viewPills = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav nav-pills')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Util$Navs$itemView(config),
					config.R))
			]));
};
var $author$project$Page$Classifier$Editor$filteredIncidents = F2(
	function (filter, allIncidents) {
		var platformPredicate = function (incident) {
			var _v0 = filter.g6;
			if (!_v0.$) {
				return true;
			} else {
				var platform = _v0.a;
				return _Utils_eq(platform, incident.gj.er.g6);
			}
		};
		var helpshiftPredicate = function (incident) {
			return filter.cR ? $elm_community$maybe_extra$Maybe$Extra$isJust(incident.gu) : true;
		};
		return A2(
			$elm$core$List$filter,
			platformPredicate,
			A2($elm$core$List$filter, helpshiftPredicate, allIncidents));
	});
var $author$project$Page$Classifier$Editor$viewMatchedFile = function (_v0) {
	var meta = _v0.er;
	var url = _v0.hQ;
	var error = _v0.d7;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$class('trackedLink'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(meta.ev)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$App$Route$href(
								$author$project$App$Route$viewIncident(meta.cZ)),
								$elm$html$Html$Attributes$class('trackedLink'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$UUID$toString(meta.cZ))
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', error))
					]))
			]));
};
var $author$project$Page$Classifier$Editor$viewMatchedFiles = function (files) {
	var header = A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Filename')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Incident')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Error')
					]))
			]));
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('table table-bordered')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[header])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Page$Classifier$Editor$viewMatchedFile, files))
			]));
};
var $author$project$Data$Issue$helpshiftUrl = function (issue) {
	var hostname = function () {
		var _v0 = issue.cK;
		if (_v0 === 'acompli') {
			return 'www.osupportweb.com';
		} else {
			return issue.cK + '.helpshift.com';
		}
	}();
	return 'https://' + (hostname + ('/admin/issue/' + $elm$core$String$fromInt(issue.bj)));
};
var $author$project$Page$Classifier$Editor$viewMatchedIncident = F2(
	function (_v0, _v1) {
		var incident = _v1.gj;
		var issueBrief = _v1.gu;
		var error = _v1.d7;
		var meta = incident.er;
		var incidentRoute = $author$project$App$Route$viewIncident(meta.bj);
		var helpshiftElement = function (maybeIssue) {
			var makeLink = function (issue) {
				return function (s) {
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(s),
								$elm$html$Html$Attributes$class('trackedLink'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(issue.bO)
							]));
				}(
					$author$project$Data$Issue$helpshiftUrl(issue));
			};
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$html$Html$text(''),
				makeLink,
				maybeIssue);
		};
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(incidentRoute),
									$elm$html$Html$Attributes$class('trackedLink'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$UUID$toString(meta.bj))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', error))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(meta.g6)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(meta.fL)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(meta.ce)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							helpshiftElement(issueBrief)
						]))
				]));
	});
var $author$project$Page$Classifier$Editor$viewMatchedIncidents = function (incidents) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Incident Id', 30),
				_Utils_Tuple2('Error', 10),
				_Utils_Tuple2('Platform', 15),
				_Utils_Tuple2('Client Version', 10),
				_Utils_Tuple2('Install Id', 15),
				_Utils_Tuple2('Helpshift', 20)
			]),
		$author$project$Page$Classifier$Editor$viewMatchedIncident,
		incidents);
};
var $author$project$Page$Classifier$DisplayFilter$OnlyPlatform = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateDisplayFilterHelpshift = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$Classifier$Editor$UpdateDisplayFilterPlatform = function (a) {
	return {$: 22, a: a};
};
var $author$project$Util$Html$checkbox = F2(
	function (msg, state) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('checkbox'),
					$elm$html$Html$Events$onCheck(msg),
					$elm$html$Html$Attributes$checked(state)
				]),
			_List_Nil);
	});
var $author$project$Util$Html$dropdownAdvanced = function (_v0) {
	var itemToString = _v0.gw;
	var currentItem = _v0.fS;
	var items = _v0.R;
	var onSelect = _v0.eA;
	var makeOption = function (item) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					itemToString(item)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item, currentItem))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					itemToString(item))
				]));
	};
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				A3($author$project$Util$Html$onOptionSelected, items, currentItem, onSelect)
			]),
		A2($elm$core$List$map, makeOption, items));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Page$Classifier$DisplayFilter$toString = function (platform) {
	if (!platform.$) {
		return 'Any';
	} else {
		var p = platform.a;
		return p;
	}
};
var $author$project$Page$Classifier$Editor$viewResultsDisplayFilter = F3(
	function (displayFilter, matchedIncidents, incidentsToDisplay) {
		var platforms = _Utils_ap(
			_List_fromArray(
				[$author$project$Page$Classifier$DisplayFilter$AnyPlatform]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Classifier$DisplayFilter$OnlyPlatform,
				$elm$core$List$sort(
					$elm_community$list_extra$List$Extra$unique(
						A2(
							$elm$core$List$map,
							function (i) {
								return i.gj.er.g6;
							},
							matchedIncidents)))));
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-inline'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Platform: '),
							$author$project$Util$Html$dropdownAdvanced(
							{fS: displayFilter.g6, gw: $author$project$Page$Classifier$DisplayFilter$toString, R: platforms, eA: $author$project$Page$Classifier$Editor$UpdateDisplayFilterPlatform})
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('With Helpshift: '),
							A2($author$project$Util$Html$checkbox, $author$project$Page$Classifier$Editor$UpdateDisplayFilterHelpshift, displayFilter.cR)
						])),
					A2(
					$author$project$Util$Html$viewIf,
					!_Utils_eq(displayFilter, $author$project$Page$Classifier$DisplayFilter$default),
					A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Found: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$elm$core$List$length(incidentsToDisplay)))
									]))
							])))
				]));
	});
var $author$project$Page$Classifier$Editor$viewResultsTable = F2(
	function (displayFilter, runResults) {
		var _v0 = A3(
			$elm$core$List$foldr,
			F2(
				function (x, _v1) {
					var incidents = _v1.a;
					var files = _v1.b;
					if (!x.$) {
						var result = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, result, incidents),
							files);
					} else {
						var result = x.a;
						return _Utils_Tuple2(
							incidents,
							A2($elm$core$List$cons, result, files));
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			runResults.gH);
		var matchedIncidents = _v0.a;
		var matchedFiles = _v0.b;
		var incidentsToDisplay = A2($author$project$Page$Classifier$Editor$filteredIncidents, displayFilter, matchedIncidents);
		return (!$elm$core$List$isEmpty(matchedIncidents)) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Page$Classifier$Editor$viewResultsDisplayFilter, displayFilter, matchedIncidents, incidentsToDisplay),
					$author$project$Page$Classifier$Editor$viewMatchedIncidents(incidentsToDisplay)
				])) : ((!$elm$core$List$isEmpty(matchedFiles)) ? $author$project$Page$Classifier$Editor$viewMatchedFiles(matchedFiles) : $elm$html$Html$text('No results'));
	});
var $author$project$Page$Classifier$Editor$viewSummaryTable = function (runResults) {
	var row = F2(
		function (label, num) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'font-size', '16px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'padding-right', '10px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(num))
							]))
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '16px')
					]),
				_List_fromArray(
					[
						A2(row, '# Matched', runResults.gW),
						A2(row, '# Errors', runResults.gT),
						A2(row, '# Tried', runResults.gZ)
					]))
			]));
};
var $author$project$Page$Classifier$Editor$viewResults = function (model) {
	return ($author$project$Page$Classifier$Editor$isRunning(model) && (!model.t.gZ)) ? $elm$html$Html$text('running...') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Results for '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-text-color-secondary)')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '?', model.eo))
							]))
					])),
				$author$project$Page$Classifier$Editor$viewSummaryTable(model.t),
				A2($author$project$Page$Classifier$Editor$viewResultsTable, model.af, model.t)
			]));
};
var $author$project$Page$Classifier$Editor$Run = {$: 10};
var $author$project$Page$Classifier$Editor$Save = {$: 12};
var $author$project$Page$Classifier$Editor$Stop = {$: 14};
var $author$project$Util$Html$disableIf = function (condition) {
	return $elm$html$Html$Attributes$disabled(condition);
};
var $author$project$Page$Classifier$Editor$viewToolbar = function (model) {
	var runButton = function () {
		var _v1 = model.h;
		if (_v1 === 1) {
			return A3(
				$author$project$Util$Bootstrap$button,
				'btn-default',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$Stop),
						A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Stop')
					]));
		} else {
			return A3(
				$author$project$Util$Bootstrap$button,
				'btn-default',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$Run),
						A2($elm$html$Html$Attributes$style, 'margin-right', '8px'),
						$author$project$Util$Html$disableIf(
						$author$project$Page$Classifier$Editor$isRunning(model))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Run')
					]));
		}
	}();
	var buttonGroup = function () {
		var _v0 = $author$project$Page$Classifier$Editor$isEditable(model.u);
		if (_v0) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pull-right')
					]),
				_List_fromArray(
					[
						runButton,
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Classifier$Editor$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pull-right')
					]),
				_List_fromArray(
					[
						runButton,
						A2(
						$author$project$Util$Bootstrap$routeLinkButton,
						'Edit',
						$author$project$App$Route$EditClassifier(model.er.bj))
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn-toolbar'),
				$author$project$Util$Html$role('toolbar')
			]),
		_List_fromArray(
			[buttonGroup]));
};
var $author$project$Page$Classifier$Editor$view = function (model) {
	var breadcrumb = $author$project$Page$Classifier$Editor$shouldShowBreadcrumb(model.u) ? $author$project$Util$Bootstrap$breadcrumbsCustom(
		_List_fromArray(
			[
				_Utils_Tuple2('Classifiers', $author$project$App$Route$ListClassifiers),
				_Utils_Tuple2(
				model.er.bO,
				$author$project$App$Route$ViewClassifierHistory(model.er.bj)),
				_Utils_Tuple2(
				'Version ' + $elm$core$String$fromInt(model.er.dx),
				$author$project$App$Route$ViewClassifier(model.er.bj))
			])) : $elm$html$Html$text('');
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Classifier$Editor$DismissErrors),
					breadcrumb,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-6')
								]),
							_List_fromArray(
								[
									$author$project$Util$Navs$viewPills(
									$author$project$Page$Classifier$Editor$navConfig(model))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-6')
								]),
							_List_fromArray(
								[
									$author$project$Page$Classifier$Editor$viewToolbar(model)
								]))
						])),
					$author$project$View$ProgressBar$viewIf(
					$author$project$Page$Classifier$Editor$isRunning(model)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding', '0 10px 0 10px')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.av;
							switch (_v0) {
								case 0:
									return $author$project$Page$Classifier$Editor$viewMeta(model);
								case 1:
									return $author$project$Page$Classifier$Editor$viewConfig(model);
								case 3:
									var _v1 = model.fC;
									switch (_v1.$) {
										case 0:
											return $elm$html$Html$text('No chart in this mode');
										case 1:
											return $author$project$View$ProgressBar$view;
										case 2:
											var chart = _v1.a;
											return A2($author$project$Page$Classifier$Editor$viewChart, model.er.bj, chart);
										default:
											return $elm$html$Html$text('Failed to load chart');
									}
								default:
									return $author$project$Page$Classifier$Editor$viewResults(model);
							}
						}()
						]))
				])),
		bO: 'Edit Classifier - ' + model.er.bO
	};
};
var $author$project$Page$Classifier$History$viewTableRow = F3(
	function (classifierId, index, meta) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(meta.dT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							(!index) ? A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$ViewClassifier(classifierId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(meta.dx))
								])) : $elm$html$Html$text(
							$elm$core$String$fromInt(meta.dx))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(meta.dy)
						]))
				]));
	});
var $author$project$Page$Classifier$History$viewHistoryTable = function (model) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Date', 25),
				_Utils_Tuple2('Version', 10),
				_Utils_Tuple2('Author', 65)
			]),
		$author$project$Page$Classifier$History$viewTableRow(model.bj),
		model.ci);
};
var $author$project$Page$Classifier$History$view = function (model) {
	var classifierTitle = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$author$project$UUID$toString(model.bj),
		function ($) {
			return $.bO;
		},
		$elm$core$List$head(model.ci));
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbsCustom(
					_List_fromArray(
						[
							_Utils_Tuple2('Classifiers', $author$project$App$Route$ListClassifiers),
							_Utils_Tuple2(
							classifierTitle,
							$author$project$App$Route$ViewClassifierHistory(model.bj))
						])),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Version History')
						])),
					$author$project$Page$Classifier$History$viewHistoryTable(model)
				])),
		bO: 'Classifier History - ' + classifierTitle
	};
};
var $author$project$Page$Classifier$List$DismissErrors = {$: 2};
var $author$project$Page$Classifier$List$ShowHideTypeDropdown = {$: 0};
var $author$project$Page$Classifier$List$newClassifierButtonDropdown = function (isOpen) {
	var viewItem = function (_v0) {
		var name = _v0.a;
		var classifierType = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(
							$author$project$App$Route$NewClassifier(classifierType))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	};
	var incidentClassifiers = _List_fromArray(
		[
			_Utils_Tuple2('Drill (recommended)', 1),
			_Utils_Tuple2('Random', 3)
		]);
	var fileClassifiers = _List_fromArray(
		[
			_Utils_Tuple2('Regex', 2)
		]);
	var dropdownVisibility = isOpen ? 'block' : 'none';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id($author$project$Page$Classifier$List$newClassifierDropdownId),
				$elm$html$Html$Attributes$class('btn-group pull-right')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$Bootstrap$routeLinkButton,
				'New Classifier',
				$author$project$App$Route$NewClassifier(1)),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('btn btn-primary dropdown-toggle'),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$title('Classifier Type Select'),
						$elm$html$Html$Events$onClick($author$project$Page$Classifier$List$ShowHideTypeDropdown)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('caret')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu'),
						A2($elm$html$Html$Attributes$style, 'display', dropdownVisibility)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Classify Incidents')
								]))
						]),
					_Utils_ap(
						A2($elm$core$List$map, viewItem, incidentClassifiers),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$author$project$Util$Html$role('separator'),
											$elm$html$Html$Attributes$class('divider')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Classify Files')
										]))
								]),
							A2($elm$core$List$map, viewItem, fileClassifiers)))))
			]));
};
var $author$project$Page$Classifier$List$applyInputSpecFilter = F2(
	function (filter, def) {
		var _v0 = _Utils_Tuple2(filter, def.c_);
		_v0$3:
		while (true) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return true;
				case 1:
					if (!_v0.b.$) {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$3;
					}
				default:
					if (_v0.b.$ === 1) {
						var _v4 = _v0.a;
						return true;
					} else {
						break _v0$3;
					}
			}
		}
		return false;
	});
var $author$project$Page$Classifier$List$applySearchTextFilter = F2(
	function (searchText, meta) {
		var match = F2(
			function (s1, s2) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toLower(s1),
					$elm$core$String$toLower(s2));
			});
		return ($elm$core$String$length(searchText) < 2) ? true : (A2(match, searchText, meta.bO) || (A2(match, searchText, meta.eo) || A2(match, searchText, meta.b6)));
	});
var $author$project$Util$Date$comparePosix = F2(
	function (a, b) {
		return A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(b));
	});
var $author$project$Page$Classifier$List$applySort = F3(
	function (sort, a, b) {
		var compareActivity = F2(
			function (a1, a2) {
				return A2(
					$elm$core$Basics$compare,
					A2($elm$core$Maybe$withDefault, -1.0, a1),
					A2($elm$core$Maybe$withDefault, -1.0, a2));
			});
		switch (sort) {
			case 0:
				return A2(compareActivity, b.d4, a.d4);
			case 1:
				return A2(compareActivity, a.d4, b.d4);
			case 2:
				return A2($author$project$Util$Date$comparePosix, b.dT, a.dT);
			case 3:
				return A2($author$project$Util$Date$comparePosix, a.dT, b.dT);
			case 4:
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a.bO),
					$elm$core$String$toLower(b.bO));
			default:
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a.eo),
					$elm$core$String$toLower(b.eo));
		}
	});
var $author$project$Page$Classifier$List$applyStatusFilter = F2(
	function (filter, def) {
		switch (filter) {
			case 0:
				return true;
			case 1:
				return def.cM;
			default:
				return !def.cM;
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Page$Classifier$List$SetSearchText = function (a) {
	return {$: 8, a: a};
};
var $author$project$Util$Html$classIf = F2(
	function (condition, c) {
		return condition ? $elm$html$Html$Attributes$class(c) : $elm$html$Html$Attributes$class('');
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$Util$Date$formatDateWithNamedMonth = function (t) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
				$ryan_haskell$date_format$DateFormat$text(', '),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]),
		$elm$time$Time$utc,
		t);
};
var $author$project$Util$Numbers$Unit = 0;
var $author$project$Util$Numbers$asMagnitude = F2(
	function (magnitude, value) {
		switch (magnitude) {
			case 0:
				return value;
			case 1:
				return value / 1000;
			case 2:
				return value / (1000 * 1000);
			case 3:
				return value / ((1000 * 1000) * 1000);
			case 4:
				return value / (((1000 * 1000) * 1000) * 1000);
			default:
				return value / ((((1000 * 1000) * 1000) * 1000) * 1000);
		}
	});
var $author$project$Util$Numbers$magnitudeDecimalChar = function (magnitude) {
	switch (magnitude) {
		case 0:
			return '';
		case 1:
			return 'k';
		case 2:
			return 'm';
		case 3:
			return 'b';
		case 4:
			return 't';
		default:
			return 'q';
	}
};
var $author$project$Util$Numbers$Giga = 3;
var $author$project$Util$Numbers$Kilo = 1;
var $author$project$Util$Numbers$Mega = 2;
var $author$project$Util$Numbers$Peta = 5;
var $author$project$Util$Numbers$Tera = 4;
var $author$project$Util$Numbers$magnitudeOf = function (number) {
	return (number < 1000) ? 0 : ((_Utils_cmp(number, 1000 * 1000) < 0) ? 1 : ((_Utils_cmp(number, (1000 * 1000) * 1000) < 0) ? 2 : ((_Utils_cmp(number, ((1000 * 1000) * 1000) * 1000) < 0) ? 3 : ((_Utils_cmp(number, (((1000 * 1000) * 1000) * 1000) * 1000) < 0) ? 4 : 5))));
};
var $cuducos$elm_format_number$Helpers$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {fW: decimals, c0: integers, eD: original, co: prefix, cx: suffix};
	});
var $cuducos$elm_format_number$Helpers$Negative = 2;
var $cuducos$elm_format_number$Helpers$Positive = 0;
var $cuducos$elm_format_number$Helpers$Zero = 1;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $cuducos$elm_format_number$Helpers$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.c0,
				$elm$core$List$singleton(
					A2($elm$core$Maybe$withDefault, '', formatted.fW)))));
	return onlyZeros ? 1 : ((formatted.eD < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$Helpers$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$Helpers$parse = F2(
	function (locale, original) {
		var parts = A2(
			$elm$core$String$split,
			'.',
			A2($myrho$elm_round$Round$round, locale.fW, original));
		var integers = $cuducos$elm_format_number$Helpers$splitThousands(
			A2(
				$elm$core$String$filter,
				$elm$core$Char$isDigit,
				A2(
					$elm$core$Maybe$withDefault,
					'0',
					$elm$core$List$head(parts))));
		var decimals = $elm$core$List$head(
			A2($elm$core$List$drop, 1, parts));
		var partial = A5($cuducos$elm_format_number$Helpers$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$Helpers$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{co: locale.gQ, cx: locale.gR});
			case 0:
				return _Utils_update(
					partial,
					{co: locale.g7, cx: locale.g8});
			default:
				return partial;
		}
	});
var $cuducos$elm_format_number$Helpers$stringfy = F2(
	function (locale, formatted) {
		var integers = A2($elm$core$String$join, locale.hC, formatted.c0);
		var decimals = function () {
			var _v0 = formatted.fW;
			if (!_v0.$) {
				var digits = _v0.a;
				return _Utils_ap(locale.fV, digits);
			} else {
				return '';
			}
		}();
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.co, integers, decimals, formatted.cx]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$Helpers$stringfy,
			locale,
			A2($cuducos$elm_format_number$Helpers$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Locale = F7(
	function (decimals, thousandSeparator, decimalSeparator, negativePrefix, negativeSuffix, positivePrefix, positiveSuffix) {
		return {fV: decimalSeparator, fW: decimals, gQ: negativePrefix, gR: negativeSuffix, g7: positivePrefix, g8: positiveSuffix, hC: thousandSeparator};
	});
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = A7($cuducos$elm_format_number$FormatNumber$Locales$Locale, 2, ',', '.', '−', '', '', '');
var $author$project$Util$Numbers$prettyFloat = F2(
	function (_v0, x) {
		var decimals = _v0.fW;
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
				{fW: decimals}),
			x);
	});
var $author$project$Util$Numbers$humanFloat = function (k) {
	var mag = $author$project$Util$Numbers$magnitudeOf(k);
	var mantissa = A2($author$project$Util$Numbers$asMagnitude, mag, k);
	var decimals = ((!mag) || ((mantissa <= 1) || (mantissa >= 10))) ? 0 : 1;
	var num = ((k > 0) && (k < 1)) ? '<1' : A2(
		$author$project$Util$Numbers$prettyFloat,
		{fW: decimals},
		mantissa);
	return _Utils_ap(
		num,
		$author$project$Util$Numbers$magnitudeDecimalChar(mag));
};
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Page$Classifier$List$Duplicate = 0;
var $author$project$Page$Classifier$List$ShowHideActionDropdown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Util$Glyphs$menuOverflow = $author$project$Util$Glyphs$make('glyphicon-option-vertical');
var $author$project$Page$Classifier$List$viewActionsDropdown = F2(
	function (_v0, classifier) {
		var openDropdownClassifierId = _v0.ap;
		var viewItem = function (_v2) {
			var name = _v2.a;
			var action = _v2.b;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$App$Route$href(
								$author$project$App$Route$CloneClassifier(classifier.bj))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		};
		var items = _List_fromArray(
			[
				_Utils_Tuple2('Duplicate', 0)
			]);
		var dropdownVisibility = _Utils_eq(
			$elm$core$Maybe$Just(classifier.bj),
			openDropdownClassifierId) ? 'block' : 'none';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id($author$project$Page$Classifier$List$actionDropdownId),
					$elm$html$Html$Attributes$class('dropdown')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-borderless btn-xs dropdown-toggle',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Classifier$List$ShowHideActionDropdown(classifier.bj)),
							A2($elm$html$Html$Attributes$style, 'font-size', '1.1em'),
							$elm$html$Html$Attributes$title('Duplicate this Classifier')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-muted')
								]),
							_List_fromArray(
								[$author$project$Util$Glyphs$menuOverflow]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							A2($elm$html$Html$Attributes$style, 'left', 'unset'),
							A2($elm$html$Html$Attributes$style, 'right', '0'),
							A2($elm$html$Html$Attributes$style, 'display', dropdownVisibility)
						]),
					A2($elm$core$List$map, viewItem, items))
				]));
	});
var $author$project$Util$Html$viewMaybe = F2(
	function (toHtml, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2($elm$core$Maybe$map, toHtml, maybe));
	});
var $author$project$Page$Classifier$List$viewRow = F2(
	function (model, classifier) {
		var viewTag = function (t) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label btn btn-info'),
						$elm$html$Html$Events$onClick(
						$author$project$Page$Classifier$List$SetSearchText(t)),
						A2($elm$html$Html$Attributes$style, 'padding-top', '.15em'),
						$elm$html$Html$Attributes$title('Classifier tag extracted from title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$dropRight,
							1,
							A2($elm$core$String$dropLeft, 1, t)))
					]));
		};
		var tagRegex = $author$project$Util$Regex$regex('^\\[[^\\]]+]');
		var tagText = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.gG;
			},
			$elm$core$List$head(
				A2($elm$regex$Regex$find, tagRegex, classifier.bO)));
		var titleText = A3(
			$elm$regex$Regex$replace,
			tagRegex,
			function (_v0) {
				return '';
			},
			classifier.bO);
		var titleLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$App$Route$href(
					$author$project$App$Route$ViewClassifier(classifier.bj)),
					A2($author$project$Util$Html$classIf, !classifier.cM, 'text-muted')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(titleText)
				]));
		var viewTitle = classifier.cM ? titleLink : A2(
			$elm$html$Html$s,
			_List_Nil,
			_List_fromArray(
				[titleLink]));
		var avgDailyActivityString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return $author$project$Util$Numbers$humanFloat(f) + ' / day';
				},
				classifier.d4));
		var usageText = (!classifier.cM) ? 'Disabled' : avgDailyActivityString;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item'),
							A2($author$project$Util$Html$classIf, !classifier.cM, 'text-muted')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'top', '5px'),
									A2($elm$html$Html$Attributes$style, 'right', '5px')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Classifier$List$viewActionsDropdown, model, classifier)
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-heading')
								]),
							_List_fromArray(
								[viewTitle])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Html$viewMaybe, viewTag, tagText),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label label-default'),
											$elm$html$Html$Attributes$title('Classifier label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(classifier.eo)
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									$elm$html$Html$Attributes$title(classifier.b6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(classifier.b6)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text clearfix')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-left')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Created on ' + $author$project$Util$Date$formatDateWithNamedMonth(classifier.dT))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right'),
													$elm$html$Html$Attributes$title('Average number of incidents matching this classifier per day')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(usageText)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Classifier$List$viewTable = F2(
	function (model, classifiers) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group'),
					A2($elm$html$Html$Attributes$style, 'list-style-type', 'none')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Classifier$List$viewRow(model),
				classifiers));
	});
var $author$project$Page$Classifier$List$viewContent = function (model) {
	var classifiers = A2(
		$elm$core$List$sortWith,
		$author$project$Page$Classifier$List$applySort(model.bJ),
		A2(
			$elm$core$List$filter,
			function (c) {
				return A2($author$project$Page$Classifier$List$applyStatusFilter, model.bL, c) && (A2($author$project$Page$Classifier$List$applyInputSpecFilter, model.bl, c) && A2($author$project$Page$Classifier$List$applySearchTextFilter, model.bG, c));
			},
			model.fJ));
	return $elm$core$List$isEmpty(classifiers) ? $author$project$View$EmptyStates$view('No matches') : A2($author$project$Page$Classifier$List$viewTable, model, classifiers);
};
var $author$project$Page$Classifier$List$SetInputSpecFilter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Classifier$List$SetSort = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Classifier$List$SetStatusFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Classifier$List$AnyInputSpec = 0;
var $author$project$Page$Classifier$List$FileInputSpec = 2;
var $author$project$Page$Classifier$List$allInputSpecFilters = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Classifier$List$SortByLabel = 5;
var $author$project$Page$Classifier$List$SortByLeastActive = 1;
var $author$project$Page$Classifier$List$SortByNewest = 2;
var $author$project$Page$Classifier$List$SortByOldest = 3;
var $author$project$Page$Classifier$List$SortByTitle = 4;
var $author$project$Page$Classifier$List$allSorts = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Page$Classifier$List$AnyStatus = 0;
var $author$project$Page$Classifier$List$DisabledStatus = 2;
var $author$project$Page$Classifier$List$allStatusFilters = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Classifier$List$inputSpecFilterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'Any';
		case 1:
			return 'Incident';
		default:
			return 'File';
	}
};
var $author$project$Page$Classifier$List$sortToString = function (sort) {
	switch (sort) {
		case 0:
			return 'Most Active';
		case 1:
			return 'Least Active';
		case 2:
			return 'Newest';
		case 3:
			return 'Oldest';
		case 4:
			return 'Title';
		default:
			return 'Label';
	}
};
var $author$project$Page$Classifier$List$statusFilterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'Any';
		case 1:
			return 'Enabled';
		default:
			return 'Disabled';
	}
};
var $author$project$Page$Classifier$List$viewFilters = function (model) {
	var viewFilter = function (_v0) {
		var name = _v0.ev;
		var itemToString = _v0.gw;
		var currentItem = _v0.fS;
		var items = _v0.R;
		var onSelect = _v0.eA;
		var makeOption = function (item) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						itemToString(item)),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(item, currentItem))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						itemToString(item))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '0 .5em')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control input-sm'),
							$elm$html$Html$Attributes$title('Classifiers Filter'),
							A3($author$project$Util$Html$onOptionSelected, items, currentItem, onSelect)
						]),
					A2($elm$core$List$map, makeOption, items))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-inline'),
				A2($elm$html$Html$Attributes$style, 'margin', '0')
			]),
		_List_fromArray(
			[
				viewFilter(
				{fS: model.bL, gw: $author$project$Page$Classifier$List$statusFilterToString, R: $author$project$Page$Classifier$List$allStatusFilters, ev: 'Status:', eA: $author$project$Page$Classifier$List$SetStatusFilter}),
				viewFilter(
				{fS: model.bl, gw: $author$project$Page$Classifier$List$inputSpecFilterToString, R: $author$project$Page$Classifier$List$allInputSpecFilters, ev: 'Input Type:', eA: $author$project$Page$Classifier$List$SetInputSpecFilter}),
				viewFilter(
				{fS: model.bJ, gw: $author$project$Page$Classifier$List$sortToString, R: $author$project$Page$Classifier$List$allSorts, ev: 'Sort:', eA: $author$project$Page$Classifier$List$SetSort})
			]));
};
var $author$project$Page$Classifier$List$viewSearchBox = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-control input-sm'),
						$elm$html$Html$Attributes$value(model.bG),
						$elm$html$Html$Attributes$placeholder('Filter by Title, Label, or Description'),
						$elm$html$Html$Events$onInput($author$project$Page$Classifier$List$SetSearchText)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Classifier$List$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Classifier$List$DismissErrors),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Classifiers')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'flex-end'),
							A2($elm$html$Html$Attributes$style, 'padding-bottom', '6px')
						]),
					_List_fromArray(
						[
							$author$project$Page$Classifier$List$viewFilters(model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', 'auto')
								]),
							_List_fromArray(
								[
									$author$project$Page$Classifier$List$newClassifierButtonDropdown(model.ak)
								]))
						])),
					$author$project$Page$Classifier$List$viewSearchBox(model),
					$elm$core$List$isEmpty(model.fJ) ? $author$project$View$EmptyStates$view('Your team hasn\'t created any classifiers yet') : $author$project$Page$Classifier$List$viewContent(model),
					$author$project$View$Docs$helpBox(4)
				])),
		bO: 'Classifiers'
	};
};
var $author$project$Page$Configuration$Editor$DismissErrors = {$: 0};
var $author$project$Page$Configuration$Editor$Save = {$: 2};
var $author$project$Util$Html$verticalSpacer = function (height) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'height', height)
			]),
		_List_Nil);
};
var $author$project$Page$Configuration$Editor$SetDialog = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$Bootstrap$dynamicWidthTable = F3(
	function (columnNames, viewRow, rowItems) {
		var headerCell = function (name) {
			return A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]));
		};
		var header = A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2($elm$core$List$map, headerCell, columnNames));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered table-condensed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[header])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2($elm$core$List$indexedMap, viewRow, rowItems))
				]));
	});
var $author$project$Page$Configuration$Editor$SetColumnName = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$Configuration$Editor$SetColumnWidget = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Page$Configuration$Editor$SetDateFormat = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$LogFile$allWidgets = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Page$Configuration$Editor$defaultDateFormats = _List_fromArray(
	['yyyy-MM-dd\'T\'HH:mm:ss.SSS\'+0000\'', 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS', 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS\'Z\'', 'yyyy-MM-dd HH:mm:ss-SSSS', 'yyyy-MM-dd HH:mm:ss.SSS', 'yyyy-MM-dd HH:mm:ss:SSS', 'MM/dd/yyyy HH:mm:ss.SSS']);
var $author$project$Util$Html$dropdown = F3(
	function (currentItem, items, onSelect) {
		var makeOption = function (item) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(item),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(item, currentItem))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(item)
					]));
		};
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A3($author$project$Util$Html$onOptionSelected, items, currentItem, onSelect)
				]),
			A2($elm$core$List$map, makeOption, items));
	});
var $author$project$Page$Configuration$Editor$widgetTitle = function (widgetType) {
	switch (widgetType) {
		case 0:
			return 'Time';
		case 1:
			return 'Categorical';
		case 2:
			return 'Text';
		default:
			return 'None';
	}
};
var $author$project$Page$Configuration$Editor$viewCustomizeColumn = F3(
	function (dateFormat, idx, _v0) {
		var captureGroup = _v0.a;
		var exampleMatch = _v0.b;
		var column = _v0.c;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(captureGroup.db)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'NOT FOUND', exampleMatch))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$class('form-control'),
									$elm$html$Html$Events$onInput(
									$author$project$Page$Configuration$Editor$SetColumnName(idx)),
									$elm$html$Html$Attributes$value(column.ev)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Util$Html$dropdownAdvanced(
							{
								fS: column.fg,
								gw: $author$project$Page$Configuration$Editor$widgetTitle,
								R: $author$project$Data$LogFile$allWidgets,
								eA: $author$project$Page$Configuration$Editor$SetColumnWidget(idx)
							}),
							A2(
							$author$project$Util$Html$viewIf,
							!column.fg,
							A3($author$project$Util$Html$dropdown, dateFormat, $author$project$Page$Configuration$Editor$defaultDateFormats, $author$project$Page$Configuration$Editor$SetDateFormat))
						]))
				]));
	});
var $elm$core$List$map3 = _List_map3;
var $elm_community$list_extra$List$Extra$triple = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $elm_community$list_extra$List$Extra$zip3 = $elm$core$List$map3($elm_community$list_extra$List$Extra$triple);
var $author$project$Page$Configuration$Editor$viewCustomizeColumnsTable = function (model) {
	var fields = $author$project$Page$Configuration$Editor$extractCaptureGroups(model.cp);
	var _v0 = $elm$regex$Regex$fromString(model.cp);
	if (!_v0.$) {
		var re = _v0.a;
		var _v1 = $elm$core$List$head(
			A2(
				$elm$regex$Regex$find,
				re,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(model.d8))));
		if (!_v1.$) {
			var submatches = _v1.a.hs;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Customize How Each Column is Displayed')
							])),
						A3(
						$author$project$Util$Bootstrap$dynamicWidthTable,
						_List_fromArray(
							['Pattern', 'Example', 'Display Name', 'Type']),
						$author$project$Page$Configuration$Editor$viewCustomizeColumn(model.b4),
						A3($elm_community$list_extra$List$Extra$zip3, fields, submatches, model.b0))
					]));
		} else {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-danger')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No example line matches your Regex pattern')
					]));
		}
	} else {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-danger')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Invalid regex')
				]));
	}
};
var $author$project$Page$Configuration$Editor$viewDialog = function (model) {
	var _v0 = model.b7;
	if (_v0 === 1) {
		return $author$project$Util$Bootstrap$viewModal(
			{
				bX: $elm$core$Maybe$Just(
					$author$project$Page$Configuration$Editor$viewCustomizeColumnsTable(model)),
				dM: $author$project$Page$Configuration$Editor$SetDialog(0),
				ec: $elm$core$Maybe$Just(
					A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Page$Configuration$Editor$SetDialog(0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('OK')
							]))),
				bO: 'Customize Columns',
				fh: $elm$core$Maybe$Just('90%')
			});
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Page$Configuration$Editor$SetRegex = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Configuration$Editor$viewInputRegex = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Log Line Regex')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Use capture groups to extract fields of data from a log message.')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$class('form-control'),
						$elm$html$Html$Events$onInput($author$project$Page$Configuration$Editor$SetRegex),
						$elm$html$Html$Attributes$value(model.cp)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Configuration$Editor$SetDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Configuration$Editor$SetEnabled = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Configuration$Editor$SetFilePattern = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Configuration$Editor$SetPlatform = function (a) {
	return {$: 6, a: a};
};
var $author$project$View$HorizontalForm$checkbox = F2(
	function (groupName, child) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-offset-2 col-sm-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											child,
											$elm$html$Html$text(groupName)
										]))
								]))
						]))
				]));
	});
var $author$project$View$HorizontalForm$container = F2(
	function (isValid, elements) {
		var attributes = isValid ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('has-error')
			]);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-horizontal'),
				attributes),
			elements);
	});
var $author$project$View$HorizontalForm$item = F2(
	function (groupName, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 control-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(groupName)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-10')
						]),
					children)
				]));
	});
var $author$project$Page$Configuration$Editor$viewMetaForm = function (model) {
	return A2(
		$author$project$View$HorizontalForm$container,
		true,
		_List_fromArray(
			[
				A2(
				$author$project$View$HorizontalForm$item,
				'Description',
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Events$onInput($author$project$Page$Configuration$Editor$SetDescription),
								$elm$html$Html$Attributes$value(model.b6),
								$elm$html$Html$Attributes$placeholder('Synopsis of the log files to which this applies')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$View$HorizontalForm$item,
				'Filename Pattern',
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Events$onInput($author$project$Page$Configuration$Editor$SetFilePattern),
								$elm$html$Html$Attributes$value(model.bf),
								$elm$html$Html$Attributes$placeholder('e.g. *.log')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('help-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Comma-separated list of filename wildcard patterns to which this config applies.')
							]))
					])),
				A2(
				$author$project$View$HorizontalForm$item,
				'Platform',
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Events$onInput($author$project$Page$Configuration$Editor$SetPlatform),
								$elm$html$Html$Attributes$value(model.g6),
								$elm$html$Html$Attributes$placeholder('e.g. iOS')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('help-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Optional. Comma-separated list of platforms to which this config applies.')
							]))
					])),
				A2(
				$author$project$Util$Html$viewIf,
				!model.bn,
				A2(
					$author$project$View$HorizontalForm$item,
					'Last Edited By',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control-static')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.dy + (' (' + ($author$project$Util$Date$formatDateAndTime(model.dT) + ')')))
								]))
						]))),
				A2(
				$author$project$View$HorizontalForm$checkbox,
				'Enabled',
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(model.bp),
							$elm$html$Html$Events$onCheck($author$project$Page$Configuration$Editor$SetEnabled)
						]),
					_List_Nil))
			]));
};
var $author$project$Page$Configuration$Editor$SelectPreviewTab = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Configuration$Editor$PreviewMatchesTab = 1;
var $author$project$Page$Configuration$Editor$PreviewTableTab = 2;
var $author$project$Page$Configuration$Editor$allPreviewTabs = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Configuration$Editor$isLoadingOrWaiting = function (previewState) {
	switch (previewState.$) {
		case 2:
			return true;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$Page$Configuration$Editor$tabTitle = function (tab) {
	switch (tab) {
		case 0:
			return 'Example Log Lines';
		case 1:
			return 'Matches';
		default:
			return 'Table View';
	}
};
var $author$project$Page$Configuration$Editor$SetExampleLines = function (a) {
	return {$: 9, a: a};
};
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$Page$Configuration$Editor$viewInputExampleLines = function (lines) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Provide a couple of example log lines:')
					])),
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$rows(3),
						$elm$html$Html$Attributes$class('form-control'),
						$elm$html$Html$Events$onInput($author$project$Page$Configuration$Editor$SetExampleLines),
						$elm$html$Html$Attributes$value(
						A2($elm$core$String$join, '\n', lines))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Configuration$Editor$viewOutputExampleLineRegionMatch = F2(
	function (regex, exampleLine) {
		var _v0 = $elm$core$List$head(
			A3($elm$regex$Regex$findAtMost, 1, regex, exampleLine));
		if (!_v0.$) {
			var match = _v0.a.gG;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-success')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(match)
							])),
						$elm$html$Html$text(
						A2(
							$elm$core$String$dropLeft,
							$elm$core$String$length(match),
							exampleLine))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(exampleLine)
					]));
		}
	});
var $author$project$Page$Configuration$Editor$viewOutputExampleLines = F2(
	function (lines, regex) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!regex.$) {
						var re = regex.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h6,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Matched portion is shown in green')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-unstyled'),
											A2($elm$html$Html$Attributes$style, 'font-family', 'monospace')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Page$Configuration$Editor$viewOutputExampleLineRegionMatch(re),
										lines))
								]));
					} else {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-warning')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invalid Regex')
								]));
					}
				}()
				]));
	});
var $author$project$Page$Configuration$Editor$CustomizeColumnsDialog = 1;
var $author$project$Data$LogFile$inferColor = function (logMessage) {
	var firstField = $elm$core$String$toLower(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm_community$list_extra$List$Extra$getAt, 0, logMessage)));
	var matchesAny = $elm$core$List$member(firstField);
	return matchesAny(
		_List_fromArray(
			['w', 'warn', 'warning'])) ? 'text-warning' : (matchesAny(
		_List_fromArray(
			['e', 'err', 'error'])) ? 'text-danger' : (matchesAny(
		_List_fromArray(
			['v', 'verbose'])) ? 'text-muted' : 'text-default'));
};
var $author$project$Page$Configuration$Editor$viewPreviewCell = function (field) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px 8px 4px 8px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(field)
			]));
};
var $author$project$Page$Configuration$Editor$viewPreviewRow = function (logMessage) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$author$project$Data$LogFile$inferColor(logMessage))
			]),
		A2($elm$core$List$map, $author$project$Page$Configuration$Editor$viewPreviewCell, logMessage));
};
var $author$project$Page$Configuration$Editor$viewPreviewTable = F2(
	function (logMessages, columns) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table table-bordered table-condensed')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '14px')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (it) {
											return A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(it.ev)
													]));
										},
										columns))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '12px')
								]),
							A2($elm$core$List$map, $author$project$Page$Configuration$Editor$viewPreviewRow, logMessages))
						])),
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-default',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Configuration$Editor$SetDialog(1))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Customize Columns')
						]))
				]));
	});
var $author$project$Page$Configuration$Editor$viewPreviewPanel = function (model) {
	var missingInputWarning = A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-warning')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('You must first enter some example log lines on the \'Input\' tab')
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'min-height', '350px'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '20px'),
				$elm$html$Html$Attributes$class('panel panel-primary')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Preview')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				_List_fromArray(
					[
						$author$project$Util$Navs$viewPills(
						{
							R: $author$project$Page$Configuration$Editor$allPreviewTabs,
							eA: $author$project$Page$Configuration$Editor$SelectPreviewTab,
							ho: model.bD,
							hv: function (tab) {
								return _Utils_Tuple2(
									$author$project$Page$Configuration$Editor$tabTitle(tab),
									$author$project$View$Badge$None);
							}
						}),
						$author$project$Util$Html$verticalSpacer('20px'),
						function () {
						var _v0 = model.bD;
						switch (_v0) {
							case 0:
								return $author$project$Page$Configuration$Editor$viewInputExampleLines(model.d8);
							case 1:
								return $elm$core$List$isEmpty(model.d8) ? missingInputWarning : A2(
									$author$project$Page$Configuration$Editor$viewOutputExampleLines,
									model.d8,
									$elm$regex$Regex$fromString(model.cp));
							default:
								return $elm$core$List$isEmpty(model.d8) ? missingInputWarning : A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$View$ProgressBar$viewIf(
											$author$project$Page$Configuration$Editor$isLoadingOrWaiting(model.v)),
											function () {
											var _v1 = model.v;
											switch (_v1.$) {
												case 0:
													return $elm$html$Html$text('Nothing to show yet');
												case 1:
													if (_v1.a.$ === 1) {
														var _v2 = _v1.a;
														return $elm$html$Html$text('');
													} else {
														var parsedLines = _v1.a.a.g4;
														return A2($author$project$Page$Configuration$Editor$viewPreviewTable, parsedLines, model.b0);
													}
												case 2:
													if (_v1.a.$ === 1) {
														var _v3 = _v1.a;
														return $elm$html$Html$text('');
													} else {
														var parsedLines = _v1.a.a.g4;
														return A2($author$project$Page$Configuration$Editor$viewPreviewTable, parsedLines, model.b0);
													}
												case 3:
													var parsedLines = _v1.a.g4;
													return A2($author$project$Page$Configuration$Editor$viewPreviewTable, parsedLines, model.b0);
												default:
													var error = _v1.a;
													return A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Error: ' + error)
															]));
											}
										}()
										]));
						}
					}()
					]))
			]));
};
var $author$project$Page$Configuration$Editor$view = function (model) {
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$centeredContainer(
					_List_fromArray(
						[
							$author$project$Page$Configuration$Editor$viewDialog(model),
							A2($author$project$View$Error$view, model.f$, $author$project$Page$Configuration$Editor$DismissErrors),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('clearfix')
								]),
							_List_fromArray(
								[
									model.bn ? $elm$html$Html$text('Create Log File Configuration') : $elm$html$Html$text('Edit Log File Configuration'),
									A3(
									$author$project$Util$Bootstrap$button,
									'btn-primary',
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Page$Configuration$Editor$Save),
											$elm$html$Html$Attributes$class('pull-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								])),
							$author$project$Page$Configuration$Editor$viewMetaForm(model),
							$author$project$Util$Html$verticalSpacer('20px'),
							$author$project$Page$Configuration$Editor$viewInputRegex(model),
							$author$project$Page$Configuration$Editor$viewPreviewPanel(model),
							$author$project$View$Docs$helpBox(5)
						]))
				])),
		bO: 'Edit Log Configuration'
	};
};
var $author$project$Page$Configuration$List$DismissErrors = {$: 0};
var $author$project$Page$Configuration$List$applySort = F3(
	function (sort, a, b) {
		if (!sort) {
			return A2($author$project$Util$Date$comparePosix, b.dT, a.dT);
		} else {
			return A2($author$project$Util$Date$comparePosix, a.dT, b.dT);
		}
	});
var $author$project$Page$Configuration$List$applyStatusFilter = F2(
	function (filter, def) {
		switch (filter) {
			case 0:
				return true;
			case 1:
				return def.cM;
			default:
				return !def.cM;
		}
	});
var $author$project$Page$Configuration$List$viewRow = F2(
	function (_v0, configuration) {
		var parsedPlatform = A2($elm$core$String$join, ',', configuration.cn);
		var parsedFilePattern = A2($elm$core$String$join, ',', configuration.cc);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$EditLogConfig(configuration.bj))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$UUID$toString(configuration.bj))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(configuration.dT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(configuration.b6)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							(parsedFilePattern === '') ? 'All' : parsedFilePattern)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							(parsedPlatform === '') ? 'All' : parsedPlatform)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							configuration.cM ? 'Yes' : 'No')
						]))
				]));
	});
var $author$project$Page$Configuration$List$viewTable = function (configurations) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Title', 25),
				_Utils_Tuple2('Last Modified', 15),
				_Utils_Tuple2('Description', 20),
				_Utils_Tuple2('File Pattern', 24),
				_Utils_Tuple2('Platform', 9),
				_Utils_Tuple2('Enabled', 7)
			]),
		$author$project$Page$Configuration$List$viewRow,
		configurations);
};
var $author$project$Page$Configuration$List$viewContent = function (model) {
	var configurations = A2(
		$elm$core$List$sortWith,
		$author$project$Page$Configuration$List$applySort(model.bJ),
		A2(
			$elm$core$List$filter,
			function (c) {
				return A2($author$project$Page$Configuration$List$applyStatusFilter, model.bL, c);
			},
			model.b2));
	return $elm$core$List$isEmpty(configurations) ? $author$project$View$EmptyStates$view('No matches') : $author$project$Page$Configuration$List$viewTable(configurations);
};
var $author$project$Page$Configuration$List$SetSort = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Configuration$List$SetStatusFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Configuration$List$SortByOldest = 1;
var $author$project$Page$Configuration$List$allSorts = _List_fromArray(
	[0, 1]);
var $author$project$Page$Configuration$List$AnyStatus = 0;
var $author$project$Page$Configuration$List$DisabledStatus = 2;
var $author$project$Page$Configuration$List$allStatusFilters = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Configuration$List$sortToString = function (sort) {
	if (!sort) {
		return 'Newest';
	} else {
		return 'Oldest';
	}
};
var $author$project$Page$Configuration$List$statusFilterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'Any';
		case 1:
			return 'Active';
		default:
			return 'Inactive';
	}
};
var $author$project$Page$Configuration$List$viewFilters = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-inline')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Status: '),
						$author$project$Util$Html$dropdownAdvanced(
						{fS: model.bL, gw: $author$project$Page$Configuration$List$statusFilterToString, R: $author$project$Page$Configuration$List$allStatusFilters, eA: $author$project$Page$Configuration$List$SetStatusFilter})
					])),
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Sort: '),
						$author$project$Util$Html$dropdownAdvanced(
						{fS: model.bJ, gw: $author$project$Page$Configuration$List$sortToString, R: $author$project$Page$Configuration$List$allSorts, eA: $author$project$Page$Configuration$List$SetSort})
					]))
			]));
};
var $author$project$Page$Configuration$List$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Configuration$List$DismissErrors),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Log File Configurations'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Bootstrap$routeLinkButton, 'New Configuration', $author$project$App$Route$NewLogConfig)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-9')
								]),
							_List_fromArray(
								[
									$author$project$Page$Configuration$List$viewFilters(model)
								]))
						])),
					$elm$core$List$isEmpty(model.b2) ? $author$project$View$EmptyStates$view('Your team hasn\'t defined any configurations') : $author$project$Page$Configuration$List$viewContent(model),
					$author$project$View$Docs$helpBox(5)
				])),
		bO: 'Log Configurations'
	};
};
var $author$project$Page$Docs$DismissErrors = {$: 0};
var $author$project$Util$Html$mailto = function (emailAddress) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('mailto:' + emailAddress)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(emailAddress)
			]));
};
var $author$project$App$Route$routeToMarkdownLink = F2(
	function (route, title) {
		return '[' + (title + ('](' + ($author$project$App$Route$routeToString(route) + ')')));
	});
var $author$project$Page$Docs$routeLink = F2(
	function (route, title) {
		return A2($author$project$App$Route$routeToMarkdownLink, route, title);
	});
var $author$project$Page$Docs$sectionLink = F2(
	function (section, title) {
		return A2(
			$author$project$Page$Docs$routeLink,
			$author$project$App$Route$ViewDocs(
				$elm$core$Maybe$Just(section)),
			title);
	});
var $author$project$Page$Docs$markdownForSection = function (tab) {
	switch (tab) {
		case 0:
			return '\nYou can use PowerLift to supercharge any customer support ticketing system (e.g. Helpshift, Zendesk). Most\ncustomer support systems allow you to attach metadata to the ticket. Unfortunately this metadata system is\noften unable to provide the data that your support team and engineers need to troubleshoot the issue.\nPowerLift solves this problem by being the storehouse for your app\'s log files as well as point-in-time snapshots\nof important app diagnostics. All of this data gets wrapped up into a single concept called an ' + (A2($author$project$Page$Docs$sectionLink, 1, 'incident') + '.\n\n### Integration\n\nIntegrating PowerLift with your support system is easy. When the user presses a \'Contact Support\' button\nin your app, instead of taking them directly into the support workflow, you post an incident\nto PowerLift. The PowerLift server will store and analyze the data you upload. The response will include a\nlist of classifications and possibly a remedy.\n\nIf the response has a remedy, you should use the PowerLift SDK to present the remedy instead of taking the user\ninto your normal support flow.\n\nIf the response _does not_ include a remedy, you should do the following:\n\n1. Create a ticket in your support system\n2. Add any classifications from the PowerLift response to the ticket metadata\n3. Add the PowerLift Gym URL to the ticket metadata, replacing the incident ID:\n   `https://powerlift.acompli.net/#/incidents/${THE_INCIDENT_ID}`\n\nSince this workflow puts PowerLift in the critical path of your support workflow, we recommend that you add your\nown timeout to guarantee that the user can get access to help quickly. For example, the Outlook Mobile app will\ngive up on waiting for PowerLift after 7 seconds and take the user directly into a conversation with a support\nagent.\n\n### Helpshift\nWhile PowerLift is agnostic to the support system that your team uses, PowerLift has special support\nfor [Helpshift](https://www.helpshift.com/). Features include:\n- GDPR compliance: PowerLift will listen to the Privacy Command Feed and act on your behalf to export/delete\nHelpshift data\n- link from the Helpshift ticket to the PowerLift Gym\n- link from the incident in the PowerLift Gym to the Helpshift ticket\n- group incidents into topics based on ticket text\n\nTo make this work, you need to do 2 things:\n1. Send your read-only Helpshift API key to [powerlifters@microsoft.com](mailto:powerlifters@microsoft.com)\n2. When creating the ticket using Helpshift\'s SDK, add two metadata entries: one for the incident ID and\nanother for the full link to the incident in the Gym.\n\nHere\'s an example of how to do it in Java using the Helpshift SDK\'s MetadataCallback:\n\n```java\nclass MetadataCallback implements Callable {\n    public HashMap call() {\n        HashMap map = new HashMap();\n\n        // Adds navigation to PowerLift from the Helpshift UI\n        String incidentId = "f9a7adee-41a5-49fe-bd51-7c01431cdcb9";  // for example\n        String installId = "PBMNwn0Oiz";  // for example\n        map.put("PowerLift Gym",\n                "https://powerlift.acompli.net/#/incidents/" + incidentId + "?installId=" + installId);\n\n        // Syncs Helpshift tickets back to PowerLift\n        map.put("PowerLift Incident", incidentId);\n        return map;\n    }\n}\n```\n\n');
		case 2:
			return '\n**Ticket Topics is a way to group incidents based on topics that you define.** A topic is a single\nword like "spam" or "attachments". You can also enter multiple words to combine topics. A topic\nlike "login signup" will add together all of the results from the "login" topic and all of the\nresults from the "signup" topic.\n\nThis feature is currently limited to PowerLift customers which are using Helpshift as their customer\nsupport ticket system. Email powerlifters@microsoft.com if you have any questions.\n\n### How it Works\n\nThe system works by looking at the customer support ticket text associated with each incident and\ndetermining which topic is most similar. The similarity is measured using semantic classification.\nSo a topic "spam" might match issues like "how do I block unwanted emails?" even though the exact\nword "spam" is not present in the text.\n\n### Recommendations\n\n#### Topic Coverage\n\nThere is no magic number for how many topics you should have. Instead, you should add as many topics\nas needed to broadly cover the types of customer support issues that you see. Keep looking at\nexamples and adding topics until all of your topics seem accurate. It\'s better to err on the side of\nhaving too many topics than having too few.\n\n#### Topic Quality\n\nYou should assess topic quality by looking at the examples within a topic. The topic is good if all\nof the tickets associated with that topic make sense. There are 3 ways of looking at the examples:\nmost similar, least similar, and random.\n\n- Most Similar: shows the examples which the ML system believes most closely matches the topic\n- Least Similar: the opposite of Most Similar\n- Random: shows a random subset of examples belonging to the topic\n\n**Sorting the examples by "Most Similar" may mislead you into thinking that the topic is performing\nbetter than it actually is.** Instead, sort by "Random" and browse through the examples. If they\nmake sense, then the topic is good.\n';
		case 1:
			return '\nAn incident is a point-in-time snapshot of your application state. Typically incidents are created when\na user contacts customer support, but you could also trigger it in other cases (e.g. when some hard-to-reproduce\nbug occurs). The incident includes basic metadata about the app/system/device as well as a property bag of\napplication-specific diagnostic data. For example, Outlook Mobile\'s diagnostic includes summaries of the\nuser\'s registered accounts, size of mail & calendar folders, etc.\n\n### Classification\n\nWhen PowerLift receives your incident, will run each ' + (A2($author$project$Page$Docs$sectionLink, 4, 'classifier') + ('\nthat is enabled. The classification results will be returned in the upload response. PowerLift will also\nuse the classification results to see if a ' + (A2($author$project$Page$Docs$sectionLink, 6, 'remedy') + ('\nshould be prescribed.\n\n### Tips for Good Incident Diagnostics\n\n- always scrub PII (the PowerLift SDK provides utility methods)\n- include any app-specific data which is helpful when orienting yourself during troubleshooting\n    - what types of account(s) does the user have\n    - how big is the client-side database\n    - etc.\n- always include the last N log messages\n- always include the last N log messages at the \'error\' severity level\n- try to include the last N request/response messages between your app and the API server\n- if your app uses flights/feature-flags, include them\n\nAs you add more and more diagnostic data, you should consider creating ' + (A2($author$project$Page$Docs$sectionLink, 8, 'widgets') + '\nto display the data nicely. Widgets allow you to surface the most useful and actionable data that\nwould otherwise be buried in the diagnostics.\n')))));
		case 3:
			return '\nAfter an ' + (A2($author$project$Page$Docs$sectionLink, 1, 'incident') + (' is created, your app can upload its log files\nto PowerLift for storage and analysis.\n\n- We support plaintext, JSON, and binary files\n- Our SDKs take care of compressing the data before upload\n- A file cannot be larger than 60MB (as of May 2018)\n- You can upload as many files as you want\n- It\'s your responsibility to make sure that logs do not contain PII\n\n### Classification\n\nWhen PowerLift receives your log file, PowerLift will run each ' + (A2($author$project$Page$Docs$sectionLink, 4, 'classifier') + '\nthat is compatible with the file. Compatibility is determined by the file type and whether the filename\nmatches the classifier\'s filename pattern. The classification results will be returned in the upload response.\n\nUnlike classification of incidents, file classification does not participate in the remedy system\ndue to technical limitations. Let us know if you want/need this feature.\n\n')));
		case 5:
			return '\nCreating a configuration for your team\'s log files causes a link to a "Fancy Viewer" to be displayed for those files in\nthe Files tab of each of your team\'s incident pages.  This link is displayed alongside the link to the plaintext view,\nwhich is not affected by configurations.  The Fancy Viewer displays a structured view of a log file as well as tools to\nfilter/search the displayed content (which you set in the Configurations Editor).\n\n### Creating a Configuration:\n\nConfigurations are managed in the [Admin section](/#/admin) of the Gym under the "Log File Configuration" section.\n\nWhen you create a new Configuration, you\'ll see a form with the following fields:\n\n#### **Description**:\nText that describes the configuration.\n\n#### **File Name Pattern and Platform**:\nThe File Name Pattern (a glob pattern) should match the full file name of any log files to which you want to apply the configuration.\n- For example, entering \'*.log\' causes the Fancy Viewer to be configured for all files with names ending in \'.log\'\n- Entering \'account.log\' configures the Fancy Viewer for log files named \'account.log\'\n- Separate multiple entries with commas\n\nThe Platform should match the platform name (iOS, Android, etc) of any log files you wish to view with this configuration.\n\nThese fields are optional and by default the configuration will be applied to all log files your team uses.\n\n#### **Enabled checkbox**:\nThis determines whether the configuration is active: whether the link to the Fancy Viewer appears for applicable log files.\n\n#### **Regex**:\nThis regex should match each individual log line from the files that are configured.\nThe characters between parentheses (the capture groups) in your regex will form the columns in the structured view of your log file.\n\n\nMatch your regex to normal log line cases only. The Fancy Viewer will automatically parse multiline log lines.\n\n**Try not to overfit your regex**; it\'s often possible to use whitespace-delimited columns as your capture groups (like in the below regex line)\n\nFor example, this regex, `(\\S)\\s+(\\S)\\s+(\\S+)\\s+(\\S+)\\s+(\\S+)\\s+(.*)`, will extract the fields\nof data from the following log message:\n```\nI  a  2018-05-14T22:02:06.654+0000  [main-thread]  Networking  refresh: accountID\n```\n\n\n#### **Previewing How it Looks**\n\nThe "Preview" section allows you to provide a couple example log lines and see how it will look in the Fancy Viewer.\n\nIf you are happy with the preview, save your configuration to enable it for your whole team.\n\n';
		case 8:
			return '\nA widget is a view of a subset of your incident data. We recommend that you create a\nwidget for each section of your incident that is generally useful when performing\nan investigation. Think of it as a way to surface the most relevant/actionable data\nto the top of the incident page in order to assist the investigating developer or\nsupport engineer.\n\nThe quickest way to learn more is to watch\n[this demo video](https://aka.ms/powerlift-video-custom-incident-display) (6 minutes).\n\n### Deciding How to Use Widgets\n\nWhich pieces of data you choose to surface depends on the nature of your application.\nAs an example, Outlook Mobile might create the following widgets:\n- **general** brings together various info like device, OS version, and deployment environment\n- **accounts** summarizes the account types the user has registered in the app\n- **email summary** summarizes the state of the app\'s email system (sync, # folders, etc)\n- **calendar summary** does the same thing for calendar data\n- **feature flags** shows which features are flighted on/off for this user\n- **network log** displays structured, scrubbed API traffic between client and server\n- **recent logs** shows N most-recent log lines from the app\'s main log file\n\nPlease note that you do not need to provide widgets that 100% cover your incident. Regardless\nof which widgets you have created, a person on your team can always view the full incident\ndata.\n\n### Types of Widgets\n\nThere are 4 different widget types that you can pick from:\n1. **Static Section** a 2-column table that presents labeled values from anywhere in your incident.\n2. **Dynamic Section** a multi-column table that presents an array of objects, where each\n   element of the array is a row and the properties of each element are transformed into\n   columns.\n3. **Dynamic List** a list of strings based on an array of strings in your incident. This\n    is primarily intended for presenting log messages included in your incident.\n4. **JSON** a generic JSON view of a sub-tree in your incident. This is useful when the\n    data that you want to present is too complex to be displayed using one of the simpler\n    widget types above.\n\n### Organizing your Widgets\n\nWidgets are grouped into sections. Each section has a name and shows up in the side-navigation\nof the incident page. The primary purpose of a section is to organize information\nand provide easy navigation. The secondary purpose is to allow presenting platform-specific information\nbased on the platform of the incident. So if your team has both an iOS and an Android app, you\ncan create special sections for each platform, and they will be shown only for incidents from that platform.\n';
		case 9:
			return '\nA scrubber allows you to retroactively redact PII that was accidentally leaked in the\nincident property bag or in log files uploaded to PowerLift.\n\nThis should only be used to respond to critical data leaks. The primary responsibility\nfor redacting PII belongs to your app. Ideally PII would never be uploaded to PowerLift.\nBut mistakes happen, and the PowerLift Scrubber can be used to mitigate the damage.\n\nA scrubber consists of one-or-more redactors. Each redactor is a rule to censor PII\nin an incident or a log file associated with an incident. The redacted data value will be\nreplaced with the string `REDACTED_BY_POWERLIFT`.\n\n### Redactor Types\n\n#### All Locations Redactor\n- Redacts strings in incident data as well as text files (i.e. logs, but also HTML files, etc.)\n- Specify a \'redaction pattern\' to control which part of a log line is redacted. It cannot\n  be empty. See section below for more details about Redaction Patterns.\n\n#### Incident Data Redactor\n- Operates on the property bag of custom values that you included when the incident was posted.\n- Specify the \'key-path\' where you want to redact/prune the tree. If no key-path is specified,\n  all strings in the incident data will be eligible for redaction.\n- Specify a \'redaction pattern\' to have more control over how string values are redacted.\n  If left blank, the entire string will be redacted. See section below for more details about Redaction Patterns.\n\n#### Text Files Redactor\n- Operates on normal, plaintext log files.\n- Specify the \'filename pattern\' regex to select which files to operate on (e.g. `.*\\.txt`).\n- Specify a \'redaction pattern\' to control which part of a log line is redacted. It cannot\nbe empty. See section below for more details about Redaction Patterns.\n\n\n#### JSON Files Redactor\n- Operates on JSON-structured log files, including streams of JSON objects.\n- Specify the \'filename pattern\' regex to select which files to operate on.\n- Specify the \'key-path\' where you want to redact/prune the tree. If no key-path is specified,\n  all strings in the JSON document will be eligible for redaction.\n- Specify an optional \'redaction pattern\' to have more control over how string values are\n  redacted. If left blank, the entire string will be redacted. See section below for more details about\n  Redaction Patterns.\n\n\n### Redaction Patterns\n\nRedaction patterns are regexes which describe the portion of a string that should be\nredacted. Your regex **must include a single capture group** to mark the substring that will\nbe redacted. For example, if the redaction pattern is `email=(.*) `, it will be replaced\nwith `email=REDACTED_BY_POWERLIFT`\n';
		case 4:
			return '\nA classifier analyzes an incident or file in order to label it. Typically classifiers are created to match\nerror conditions present in an incident\'s diagnostic data or log files. For example, Outlook Mobile\nhas a classifier for finding error status codes in the client\'s API traffic. When the classifier matches,\na label is applied to the incident/file. PowerLift will return the classification labels in the response\nto your app\'s upload incident/file request. It\'s up to you what to do with those classifications, although\nwe have some recommendations in the "Support Ticket Systems" docs.\n\nClassification labels play another role in PowerLift: each label can be used to "trigger" a remedy. See the ' + (A2($author$project$Page$Docs$sectionLink, 6, 'remedy docs') + ' for more details.\n\n**Note**: Log file classifiers cannot be used to trigger a remedy. This is a technical limitation which we\nmay fix in the future. Let us know if you want/need this feature.\n');
		case 6:
			return '\nA remedy is a self-service workflow which your app presents to the user in order to fix (or acknowledge)\na problem with your app/service. Far too many users contact customer support with the same issues\nthat have been seen over and over again. PowerLift\'s remedy system allows you to present a solution\nimmediately--no waiting for a customer support agent to reply. And unlike FAQs, remedies can consist of\nmultiple screens, stepping the user through the solution, and remedies can even invoke ' + (A2($author$project$Page$Docs$sectionLink, 7, 'hooks in your application') + '.\n\n### How PowerLift decides to show a remedy\n\nWhen your app uploads an incident to PowerLift, all enabled classifiers are run on the incident\nand the emitted labels are collected. PowerLift uses these labels (along with other conditions,\ndescribed below) to decide which remedy to prescribe to the user, if any.\n\nFor each remedy candidate, reject it if...\n- the trigger does not match any of the classification labels\n- the remedy has not been translated to the user\'s language/locale\n\nIf more than one remedy remains at this point, the remedy with\nthe highest priority will be chosen.\n');
		case 7:
			return '\nA capability is a hook exposed by your application which can be invoked\nfrom a ' + (A2($author$project$Page$Docs$sectionLink, 6, 'remedy') + ('. These hooks can be invoked with\nzero-or-more named arguments.\n\nSuppose that your customer support agents frequently give instructions to your app\'s users\ntelling them how to reset the application\'s cached data. Instead of giving each user\npoint-by-point instructions on clearing the cache, you can show them a PowerLift remedy\nwith a button that directly triggers your app\'s clear-cache functionality via the capability hook.\n\n### Integration Instructions\n\nThere are 3 steps to adding a new remedy capability:\n1. Register it on the PowerLift website\n2. Implement the hook in the client\n3. Create a remedy with a button that invokes the capability\n\n\n#### Step 1: Registration\n\nCapabilities are managed in the ' + (A2($author$project$Page$Docs$routeLink, $author$project$App$Route$Admin, 'Admin section') + ' of the Gym.\n\nWhen you create a new Capability, you\'ll see a form with the following fields:\n\n- **ID**: a string which identifies the capability/hook. This will be passed to your app\nwhen the capability is invoked via a remedy button being pressed.\n- **Description**: text intended to explain the capability to humans.\n- **Parameters**: zero-or-more parameter name declarations. The remedy editor will provide\nUI for associating a string value with each parameter. When the capability is invoked, these\nnamed parameters along with their values will be passed to your capability hook.\n\nFill out the form and save it.\n\n#### Step 2: Client Implementation\n\nImplementing the hook is different for each platform SDK. Please refer to the SDK code\nfor details (or email us for help).\n\n\n#### Step 3: Usage\n\nCreate a new remedy to test things out. Add a button, and configure it to use your new capability.\nSave the remedy and test it out in your app.\n\n\n### Compatibility\n\nWhen your app posts an incident to PowerLift for analysis, it also sends the names of all\ncapabilities that it supports. The PowerLift server knows which capabilities a remedy needs,\nand it will check the list of capabilities supported by the client to make sure that the client can properly\nshow that remedy. If the client does not support the capability, the remedy will not be prescribed.\n\n#### Caution!\n\nOnce a capability is created, you should be very careful about changing any aspect of it\n(with the only exception being the \'description\' field). The capability ID as well as\nthe parameter declarations must EXACTLY MATCH the implementation of the capability in your\napp. In order to maintain backwards compatibility with old clients, we recommend that you\nhandle capability versioning by just creating a new capability with a new ID.\n')));
		case 13:
			return '\nThe PowerLift service is fully GDPR compliant. When an end-user asks Microsoft to export (or delete) their data,\nwe export/delete the appropriate incidents/files. If you are a Helpshift user, we can also do export/delete\non Helpshift tickets (contact us for more details).\n\nIn order to provide this export/delete functionality, it\'s **absolutely critical** that you correctly identify\nthe user account(s) when creating an incident. See your platform\'s SDK documentation for more detail.\n\nAs a general matter of policy independent of GDPR, **we retain incidents/files for a max of 30 days**.\n';
		case 10:
			return '\nIntune-enabled mobile apps use PowerLift to put all of the log files  in the same place. The workflow is\ndocumented [here](/docs/mobile-diagnostic-flow.md.html).\n';
		case 11:
			return '\n**If you are interested in onboarding to Powerlift, please review, and ensure your application adheres to the following:**\n1.  Powerlift is compliant for support related data and all data collected should be from within a support\n    or self-help interaction within the client. Please ensure that data collected is from within the support funnel.\n2.  There should be no collection of customer data without consent. Work with your CELA\n    and Privacy representatives to ensure consents cover your collection of data.\n3.  Powerlift supports scrubbing of sensitive data before it is accessible on Gym portal,\n    this scrubbing method is not the sole responsibility on Powerlift as Powerlift relies on the scrubbers configured by client engineers.\n4.  In order to onboard to Powerlift, you must provide evidence of an approved privacy review.\n        ';
		case 12:
			return '\nCurrently only the iOS/macOS SDK has online documentation.\nBut the source code of each PowerLift SDK\'s public API is well-documented, so check out the source.\n\nMore details on our ' + (A2($author$project$Page$Docs$routeLink, $author$project$App$Route$ViewSDKs, 'SDKs page') + '.\n');
		case 14:
			return '\nWhen possible, a ' + (A2($author$project$Page$Docs$sectionLink, 12, 'PowerLift SDK') + ' should be used to integrate PowerLift into your application.\n\nIn other cases, documentation for the REST API can be found [here](/docs/integration-guide/powerlift-integration-guide.html). See [Swagger UI](/swagger) as well.');
		default:
			return 'A ' + (A2($author$project$Page$Docs$routeLink, $author$project$App$Route$ListGroups, 'group') + ' is a collection of resources shared among multiple teams/tenants in PowerLift. For instance, a classifier can be shared in a group, making it available to each tenant in the group. Any changes made to the classifier by one tenant will immediately be applied in the other tenants.\n\nOnce a resource has been added to a group, it cannot be removed. However, in the case of resources like a classifier, you can still disable it to prevent it from running anymore (both in your tenant and in the other tenants).\n\nAnyone may add or edit a resource in a group that they are a member of, however group creation and tenant membership requires a PowerLift admin. Please contact [powerlifters@microsoft.com](mailto:powerlifters@microsoft.com) if you\'d like to create a group or join one.\n            ');
	}
};
var $author$project$Page$Docs$markdownForTopLevel = '\nOne of the best ways to learn about PowerLift is watch the ' + (A2($author$project$Page$Docs$routeLink, $author$project$App$Route$Home, 'videos on the homepage') + '.\nFor detailed information about PowerLift concepts and features, click any of the links to the left.\n\nThere are 2 main parts to the PowerLift system:\n- FrontDesk\n- Gym\n\nThe **FrontDesk** is the service responsible for ingesting incidents and files. Your app uses the PowerLift SDK\nto talk to the FrontDesk API.\n\nThe **Gym** is the web-app that you\'re using right now. It allows your team to view incidents/files and\ncreate classifiers/remedies.\n');
var $author$project$Page$Docs$sectionToTitle = function (section) {
	switch (section) {
		case 0:
			return 'Support Ticket Systems';
		case 2:
			return 'Ticket Topics';
		case 1:
			return 'Incidents';
		case 3:
			return 'Log Files';
		case 4:
			return 'Classifiers';
		case 5:
			return 'Log File Configurations';
		case 6:
			return 'Remedies';
		case 7:
			return 'Capabilities';
		case 8:
			return 'Widgets';
		case 9:
			return 'Scrubbers';
		case 13:
			return 'GDPR';
		case 10:
			return 'Intune';
		case 11:
			return 'Onboarding Guidance';
		case 12:
			return 'SDKs';
		case 14:
			return 'REST API';
		default:
			return 'Groups';
	}
};
var $author$project$Page$Docs$viewMainPane = function (model) {
	var content = function () {
		var _v0 = model.bH;
		if (!_v0.$) {
			var section = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Page$Docs$sectionToTitle(section))
						])),
					A2(
					$elm_explorations$markdown$Markdown$toHtml,
					_List_Nil,
					$author$project$Page$Docs$markdownForSection(section))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Docs')
						])),
					A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, $author$project$Page$Docs$markdownForTopLevel)
				]);
		}
	}();
	return A2($elm$html$Html$div, _List_Nil, content);
};
var $author$project$Data$Docs$allSections = _List_fromArray(
	[0, 2, 1, 3, 5, 4, 6, 7, 8, 9, 13, 10, 15]);
var $author$project$Data$Docs$developerSections = _List_fromArray(
	[11, 12, 14]);
var $author$project$Page$Docs$SelectSection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Docs$viewSections = F2(
	function (tabs, selectedSection) {
		var navItem = F2(
			function (activeSection, section) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Docs$SelectSection(section)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list-group-item', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(
										activeSection,
										$elm$core$Maybe$Just(section)))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Page$Docs$sectionToTitle(section))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group')
						]),
					A2(
						$elm$core$List$map,
						navItem(selectedSection),
						tabs))
				]));
	});
var $author$project$Page$Docs$viewSidePane = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Page$Docs$viewSections, $author$project$Data$Docs$allSections, model.bH),
				A2($author$project$Page$Docs$viewSections, $author$project$Data$Docs$developerSections, model.bH)
			]));
};
var $author$project$Page$Docs$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[
							$author$project$App$Route$Home,
							$author$project$App$Route$ViewDocs($elm$core$Maybe$Nothing)
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Docs$DismissErrors),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-2')
								]),
							_List_fromArray(
								[
									$author$project$Page$Docs$viewSidePane(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-10')
								]),
							_List_fromArray(
								[
									$author$project$Page$Docs$viewMainPane(model)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-12')
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Questions? Email us at '),
											$author$project$Util$Html$mailto('powerlifters@microsoft.com')
										]))
								]))
						]))
				])),
		bO: 'Docs'
	};
};
var $author$project$Page$Error$footer = function (context) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#777'),
				A2($elm$html$Html$Attributes$style, 'margin', '16px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Context: '),
						$elm$html$Html$text(context)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Need help? Email '),
						$author$project$Util$Html$mailto('powerlifters@microsoft.com')
					]))
			]));
};
var $author$project$Page$Error$header = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel-heading')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(str)
					]))
			]));
};
var $author$project$Page$Error$panel = F2(
	function (alternative, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-' + alternative),
					A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
				]),
			children);
	});
var $author$project$Page$Error$panelRed = function (children) {
	return A2($author$project$Page$Error$panel, 'danger', children);
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Page$Error$panelBody = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel-body')
			]),
		children);
};
var $author$project$Page$Error$panelOrange = function (children) {
	return A2($author$project$Page$Error$panel, 'warning', children);
};
var $author$project$Page$Error$viewCreateBug = A2(
	$elm$html$Html$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('This is probably a bug in PowerLift. Please report to '),
			$author$project$Util$Html$mailto('powerlifters@microsoft.com')
		]));
var $author$project$Page$Error$viewHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return $author$project$Page$Error$panelRed(
				_List_fromArray(
					[
						$author$project$Page$Error$header('Invalid URL'),
						$author$project$Page$Error$panelBody(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\'' + (url + '\' is not valid.'))
									])),
								$author$project$Page$Error$viewCreateBug
							]))
					]));
		case 1:
			return $author$project$Page$Error$panelOrange(
				_List_fromArray(
					[
						$author$project$Page$Error$header('Timeout'),
						$author$project$Page$Error$panelBody(
						_List_fromArray(
							[
								$elm$html$Html$text('This took too long. Poor network connection?')
							]))
					]));
		case 2:
			return $author$project$Page$Error$panelOrange(
				_List_fromArray(
					[
						$author$project$Page$Error$header('Disconnected'),
						$author$project$Page$Error$panelBody(
						_List_fromArray(
							[
								$elm$html$Html$text('There\'s something wrong with the network.')
							]))
					]));
		case 3:
			var response = error.a;
			var _v1 = response.e3.dN;
			switch (_v1) {
				case 403:
					return $author$project$Page$Error$panelRed(
						_List_fromArray(
							[
								$author$project$Page$Error$header('Not Authorized'),
								$author$project$Page$Error$panelBody(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You do not have access to this resource. Sorry!')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('If you belong to multiple tenants in PowerLift, then you might '),
												$elm$html$Html$text('want to try picking a different tenant via the drop-down '),
												$elm$html$Html$text('on the top-right corner of this page.')
											]))
									]))
							]));
				case 404:
					return $author$project$Page$Error$panelOrange(
						_List_fromArray(
							[
								$author$project$Page$Error$header('Not Found'),
								$author$project$Page$Error$panelBody(
								_List_fromArray(
									[
										$elm$html$Html$text('The thing you are looking for does not exist. Was it deleted?')
									]))
							]));
				case 500:
					return $author$project$Page$Error$panelRed(
						_List_fromArray(
							[
								$author$project$Page$Error$header('Server Error'),
								$author$project$Page$Error$panelBody(
								_List_fromArray(
									[$author$project$Page$Error$viewCreateBug]))
							]));
				default:
					return $author$project$Page$Error$panelRed(
						_List_fromArray(
							[
								$author$project$Page$Error$header('Bad Response Status Code'),
								$author$project$Page$Error$panelBody(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												'HTTP Error ' + $elm$core$String$fromInt(response.e3.dN)),
												$author$project$Page$Error$viewCreateBug
											]))
									]))
							]));
			}
		default:
			var err = error.a;
			return $author$project$Page$Error$panelRed(
				_List_fromArray(
					[
						$author$project$Page$Error$header('Bad Response Payload'),
						$author$project$Page$Error$panelBody(
						_List_fromArray(
							[
								$author$project$Page$Error$viewCreateBug,
								A2(
								$elm$html$Html$h5,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Details')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]))
							]))
					]));
	}
};
var $author$project$Page$Error$view = function (error) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			function () {
				if (!error.$) {
					var context = error.a;
					var title = error.b;
					return _List_fromArray(
						[
							$author$project$Page$Error$panelRed(
							_List_fromArray(
								[
									$author$project$Page$Error$header(title)
								])),
							$author$project$Page$Error$footer(context)
						]);
				} else {
					var context = error.a;
					var httpError = error.b;
					return _List_fromArray(
						[
							$author$project$Page$Error$viewHttpError(httpError),
							$author$project$Page$Error$footer(context)
						]);
				}
			}()),
		bO: 'Error'
	};
};
var $author$project$Page$Group$GroupCreator$viewBreadcrumbs = $author$project$Util$Bootstrap$breadcrumbsCustom(
	_List_fromArray(
		[
			_Utils_Tuple2('Admin', $author$project$App$Route$Admin),
			_Utils_Tuple2('Groups', $author$project$App$Route$ListGroups),
			_Utils_Tuple2('New Group', $author$project$App$Route$CreateGroup)
		]));
var $author$project$Page$Group$GroupCreator$viewError = function (error) {
	return A2($author$project$Util$Html$viewMaybe, $author$project$Page$Error$viewHttpError, error);
};
var $author$project$Page$Group$GroupCreator$UpdatedDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Group$GroupCreator$UpdatedName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Group$GroupCreator$viewForm = function (_v0) {
	var isSaving = _v0.cg;
	var name = _v0.ev;
	var description = _v0.b6;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-horizontal')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Util$Bootstrap$textField,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(isSaving)
					]),
				$author$project$Page$Group$GroupCreator$UpdatedName,
				'Name',
				name),
				A4(
				$author$project$Util$Bootstrap$textField,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(isSaving)
					]),
				$author$project$Page$Group$GroupCreator$UpdatedDescription,
				'Description',
				description)
			]));
};
var $author$project$Page$Group$GroupCreator$Save = {$: 2};
var $author$project$Page$Group$GroupCreator$viewSaveButton = function (_v0) {
	var isSaving = _v0.cg;
	return A3(
		$author$project$Util$Bootstrap$button,
		'btn-primary',
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Page$Group$GroupCreator$Save),
				$elm$html$Html$Attributes$disabled(isSaving)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Create Group')
			]));
};
var $author$project$Page$Group$GroupCreator$viewMain = function (model) {
	return _List_fromArray(
		[
			$author$project$Page$Group$GroupCreator$viewError(model.cd),
			$author$project$Page$Group$GroupCreator$viewBreadcrumbs,
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Create Group')
				])),
			$author$project$Page$Group$GroupCreator$viewForm(model),
			$author$project$Page$Group$GroupCreator$viewSaveButton(model),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			$author$project$View$Docs$helpBox(15)
		]);
};
var $author$project$Page$Group$GroupCreator$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			$author$project$Page$Group$GroupCreator$viewMain(model)),
		bO: 'Create Group'
	};
};
var $author$project$Page$Group$GroupEditor$viewBreadcrumbs = function (group) {
	return $author$project$Util$Bootstrap$breadcrumbsCustom(
		_List_fromArray(
			[
				_Utils_Tuple2('Admin', $author$project$App$Route$Admin),
				_Utils_Tuple2('Groups', $author$project$App$Route$ListGroups),
				_Utils_Tuple2(
				group.ev,
				$author$project$App$Route$ViewGroup(group.bj)),
				_Utils_Tuple2(
				'Edit',
				$author$project$App$Route$EditGroup(group.bj))
			]));
};
var $author$project$Page$Group$GroupEditor$viewError = function (error) {
	return A2($author$project$Util$Html$viewMaybe, $author$project$Page$Error$viewHttpError, error);
};
var $author$project$Page$Group$GroupEditor$UpdatedDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Group$GroupEditor$UpdatedName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Group$GroupEditor$AddTenant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Group$GroupEditor$viewAddTenantDropDown = F2(
	function (tenants, _v0) {
		var isSaving = _v0.cg;
		var viewSelectOption = function (t) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						$author$project$UUID$toString(t.eL))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(t.ev)
					]));
		};
		var sortedTenants = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.ev;
			},
			tenants);
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput($author$project$Page$Group$GroupEditor$AddTenant),
					$elm$html$Html$Attributes$value('foo'),
					$elm$html$Html$Attributes$disabled(isSaving)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$value('foo'),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add a Tenant')
						])),
				A2($elm$core$List$map, viewSelectOption, sortedTenants)));
	});
var $author$project$Page$Group$GroupEditor$viewAddTenant = function (model) {
	var isToBeAdded = function (t) {
		return A2($elm$core$List$member, t, model.H);
	};
	var isInGroup = function (t) {
		return A2($elm$core$List$member, t, model.gb.hB);
	};
	var candidates = A2(
		$elm$core$List$filter,
		function (t) {
			return !(isInGroup(t) || isToBeAdded(t));
		},
		model.bW);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Page$Group$GroupEditor$viewAddTenantDropDown, candidates, model)
			]));
};
var $author$project$Page$Group$GroupEditor$viewClassifiersTable = function (model) {
	var viewClassifierRows = function (classifiers) {
		return A2(
			$elm$core$List$map,
			function (c) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(c.bO)
								]))
						]));
			},
			classifiers);
	};
	var sortedClassifiers = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.bO;
		},
		A2(
			$elm$core$List$filterMap,
			$elm$core$List$head,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fJ;
				},
				model.gb.fJ)));
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('table table-condensed table-bordered'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				viewClassifierRows(sortedClassifiers))
			]));
};
var $author$project$Page$Group$GroupEditor$RemoveTenant = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Group$GroupEditor$viewTenantsTable = function (model) {
	var viewTenantsToAddRows = A2(
		$elm$core$List$map,
		function (t) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(t.ev),
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-default btn-xs',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Page$Group$GroupEditor$RemoveTenant(t)),
										A2($elm$html$Html$Attributes$style, 'margin-left', '6px')
									]),
								_List_fromArray(
									[$author$project$Util$Glyphs$remove]))
							]))
					]));
		},
		model.H);
	var tenantsInGroup = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.ev;
		},
		model.gb.hB);
	var viewTenantsInGroupRows = A2(
		$elm$core$List$map,
		function (t) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(t.ev)
							]))
					]));
		},
		tenantsInGroup);
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('table table-condensed table-bordered'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				_Utils_ap(viewTenantsInGroupRows, viewTenantsToAddRows))
			]));
};
var $author$project$Page$Group$GroupEditor$viewForm = function (model) {
	var tenantsLabel = $elm$core$List$isEmpty(model.H) ? 'Tenants' : '* Tenants';
	var nameLabel = _Utils_eq(model.gb.ev, model.ev) ? 'Name' : '* Name';
	var descriptionLabel = _Utils_eq(model.gb.b6, model.b6) ? 'Description' : '* Description';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-horizontal')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Util$Bootstrap$textField,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(model.cg)
					]),
				$author$project$Page$Group$GroupEditor$UpdatedName,
				nameLabel,
				model.ev),
				A4(
				$author$project$Util$Bootstrap$textField,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(model.cg)
					]),
				$author$project$Page$Group$GroupEditor$UpdatedDescription,
				descriptionLabel,
				model.b6),
				A2(
				$author$project$Util$Bootstrap$formField,
				tenantsLabel,
				_List_fromArray(
					[
						$author$project$Page$Group$GroupEditor$viewTenantsTable(model),
						$author$project$Page$Group$GroupEditor$viewAddTenant(model)
					])),
				A2(
				$author$project$Util$Bootstrap$formField,
				'Classifiers',
				_List_fromArray(
					[
						$author$project$Page$Group$GroupEditor$viewClassifiersTable(model),
						A2(
						$elm$html$Html$h6,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('* Classifiers are added to groups via the classifier details page.')
							]))
					]))
			]));
};
var $author$project$Page$Group$GroupEditor$Save = {$: 4};
var $author$project$Page$Group$GroupEditor$viewHeader = function (model) {
	var saveButton = A3(
		$author$project$Util$Bootstrap$button,
		'btn-primary',
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Page$Group$GroupEditor$Save),
				$elm$html$Html$Attributes$disabled(model.cg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save')
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-12'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Group')
							])),
						saveButton
					]))
			]));
};
var $author$project$Page$Group$GroupEditor$viewMain = function (model) {
	return _List_fromArray(
		[
			$author$project$Page$Group$GroupEditor$viewError(model.cd),
			$author$project$Page$Group$GroupEditor$viewBreadcrumbs(model.gb),
			$author$project$Page$Group$GroupEditor$viewHeader(model),
			$author$project$Page$Group$GroupEditor$viewForm(model),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			$author$project$View$Docs$helpBox(15)
		]);
};
var $author$project$Page$Group$GroupEditor$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			$author$project$Page$Group$GroupEditor$viewMain(model)),
		bO: 'Edit Group'
	};
};
var $author$project$Page$Group$GroupList$DismissErrors = 0;
var $author$project$Page$Group$GroupList$JoinGroup = 1;
var $author$project$Page$Group$GroupList$viewGroups = F2(
	function (memberGroups, nonMemberGroups) {
		var viewMembership = function (group) {
			return A2($elm$core$List$member, group, memberGroups) ? $elm$html$Html$text('Joined') : A3(
				$author$project$Util$Bootstrap$button,
				'btn-link',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(1),
						A2($elm$html$Html$Attributes$style, 'border', '0'),
						A2($elm$html$Html$Attributes$style, 'padding', '0')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Join')
					]));
		};
		var viewRow = F2(
			function (_v0, group) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Util$Bootstrap$fixedWidthTextCell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$App$Route$href(
											$author$project$App$Route$ViewGroup(group.bj))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(group.ev)
										]))
								])),
							A2(
							$author$project$Util$Bootstrap$fixedWidthTextCell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(group.b6)
								])),
							A2(
							$author$project$Util$Bootstrap$fixedWidthTextCell,
							_List_Nil,
							_List_fromArray(
								[
									viewMembership(group)
								]))
						]));
			});
		var allGroups = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.ev;
			},
			_Utils_ap(memberGroups, nonMemberGroups));
		return $elm$core$List$isEmpty(allGroups) ? $author$project$View$EmptyStates$view('No groups yet') : A3(
			$author$project$Util$Bootstrap$fixedWidthTable,
			_List_fromArray(
				[
					_Utils_Tuple2('Name', 30),
					_Utils_Tuple2('Description', 55),
					_Utils_Tuple2('Membership', 15)
				]),
			viewRow,
			allGroups);
	});
var $author$project$Page$Group$GroupList$viewNewGroupButton = function (isSystemTenant) {
	return A2(
		$author$project$Util$Html$viewIf,
		isSystemTenant,
		A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-primary pull-right'),
					$author$project$App$Route$href($author$project$App$Route$CreateGroup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('New Group')
				])));
};
var $author$project$Page$Group$GroupList$viewHeader = function (isSystemTenant) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Groups')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						$author$project$Page$Group$GroupList$viewNewGroupButton(isSystemTenant)
					]))
			]));
};
var $author$project$Page$Group$GroupList$viewMain = function (model) {
	return _List_fromArray(
		[
			A2($author$project$View$Error$view, model.f$, 0),
			$author$project$Util$Bootstrap$breadcrumbs(
			_List_fromArray(
				[$author$project$App$Route$Admin, $author$project$App$Route$ListGroups])),
			$author$project$Page$Group$GroupList$viewHeader(model.c1),
			A2($author$project$Page$Group$GroupList$viewGroups, model.c5, model.c9),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			$author$project$View$Docs$helpBox(15)
		]);
};
var $author$project$Page$Group$GroupList$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			$author$project$Page$Group$GroupList$viewMain(model)),
		bO: 'Group List'
	};
};
var $author$project$Page$Group$GroupViewer$viewBreadcrumbs = function (group) {
	return $author$project$Util$Bootstrap$breadcrumbsCustom(
		_List_fromArray(
			[
				_Utils_Tuple2('Admin', $author$project$App$Route$Admin),
				_Utils_Tuple2('Groups', $author$project$App$Route$ListGroups),
				_Utils_Tuple2(
				group.ev,
				$author$project$App$Route$ViewGroup(group.bj))
			]));
};
var $author$project$Page$Group$GroupViewer$viewClassifiers = function (classifiers) {
	var sortedClassifiers = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.bO;
		},
		A2(
			$elm$core$List$filterMap,
			$elm$core$List$head,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fJ;
				},
				classifiers)));
	var row = F2(
		function (_v0, classifier) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Util$Bootstrap$fixedWidthTextCell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(classifier.bO)
							])),
						A2(
						$author$project$Util$Bootstrap$fixedWidthTextCell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(classifier.b6)
							]))
					]));
		});
	return $elm$core$List$isEmpty(classifiers) ? $author$project$View$EmptyStates$view('No classifiers in this group yet.') : A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Title', 40),
				_Utils_Tuple2('Description', 60)
			]),
		row,
		sortedClassifiers);
};
var $author$project$Page$Group$GroupViewer$viewError = function (error) {
	return A2($author$project$Util$Html$viewMaybe, $author$project$Page$Error$viewHttpError, error);
};
var $author$project$Page$Group$GroupViewer$viewEditButton = F2(
	function (isSystemTenant, groupId) {
		return A2(
			$author$project$Util$Html$viewIf,
			isSystemTenant,
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('btn btn-primary'),
						$author$project$App$Route$href(
						$author$project$App$Route$EditGroup(groupId))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Edit')
					])));
	});
var $author$project$Page$Group$GroupViewer$viewHeader = F2(
	function (isSystemTenant, group) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-md-12'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(group.ev)
										])),
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(group.b6)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$Group$GroupViewer$viewEditButton, isSystemTenant, group.bj)
								]))
						]))
				]));
	});
var $author$project$Page$Group$GroupViewer$viewTenants = function (tenants) {
	var sortedTenants = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.ev;
		},
		tenants);
	return $elm$core$List$isEmpty(tenants) ? $author$project$View$EmptyStates$view('No tenants in this group yet.') : A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (t) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(t.ev)
						]));
			},
			sortedTenants));
};
var $author$project$Page$Group$GroupViewer$viewMain = function (model) {
	return _List_fromArray(
		[
			$author$project$Page$Group$GroupViewer$viewError(model.cd),
			$author$project$Page$Group$GroupViewer$viewBreadcrumbs(model.gb),
			A2($author$project$Page$Group$GroupViewer$viewHeader, model.c1, model.gb),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Tenants')
				])),
			$author$project$Page$Group$GroupViewer$viewTenants(model.gb.hB),
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Classifiers')
				])),
			$author$project$Page$Group$GroupViewer$viewClassifiers(model.gb.fJ),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			$author$project$View$Docs$helpBox(15)
		]);
};
var $author$project$Page$Group$GroupViewer$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			$author$project$Page$Group$GroupViewer$viewMain(model)),
		bO: model.gb.ev
	};
};
var $author$project$Page$Home$css = {
	b5: 'var(--pl-page-bg-color)',
	d_: '1px solid #ccc',
	c4: 'var(--pl-page-bg-color-secondary)',
	dq: A2($elm$html$Html$Attributes$style, 'font-size', 'large'),
	bK: A2($elm$html$Html$Attributes$style, 'padding-bottom', '8px')
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Page$Home$viewFeatures = function () {
	var makeFeatureBox = function (_v0) {
		var title = _v0.a;
		var details = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-variant', 'small-caps')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toLower(title))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[$author$project$Page$Home$css.dq]),
					A2(
						$elm$core$List$map,
						function (detail) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[$author$project$Page$Home$css.bK]),
								_List_fromArray(
									[
										$elm$html$Html$text(detail)
									]));
						},
						details))
				]));
	};
	var makeRow = F2(
		function (f1, f2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-6')
							]),
						_List_fromArray(
							[
								makeFeatureBox(f1)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-6')
							]),
						_List_fromArray(
							[
								makeFeatureBox(f2)
							]))
					]));
		});
	var feature6 = _Utils_Tuple2(
		'Instant',
		_List_fromArray(
			['Create and deploy Classifiers and Remedies in seconds', 'Incidents and files are analyzed in seconds', 'Redact PII in seconds']));
	var feature5 = _Utils_Tuple2(
		'Scrubbers',
		_List_fromArray(
			['Accidentally shipped some PII?', 'Create a scrubber to retroactively redact logs and diagnostics']));
	var feature4 = _Utils_Tuple2(
		'Remedies',
		_List_fromArray(
			['Self-service troubleshooting workflows', 'Acknowledge known issues or outages', '... or lead users through multi-screen workflows', 'Custom buttons to invoke hooks in your app']));
	var feature3 = _Utils_Tuple2(
		'Classifiers',
		_List_fromArray(
			['Find and label interesting things in diagnostics and/or logs', 'Chart classifier performance', 'Provides the logic for when a remedy is shown']));
	var feature2 = _Utils_Tuple2(
		'Incident Diagnostics',
		_List_fromArray(
			['Capture the state of your app when user contacted supported', 'Arbitrary JSON data with custom views', 'Point-and-click creation of classifiers from your data']));
	var feature1 = _Utils_Tuple2(
		'Log Storage',
		_List_fromArray(
			['GDPR-compliant', '30-day retention', 'Plaintext, binary logs, JSON, etc.']));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '40px 0 40px 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Features')
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(makeRow, feature1, feature4),
				A2(makeRow, feature2, feature5),
				A2(makeRow, feature3, feature6)
			]));
}();
var $author$project$Util$Html$viewIfLazy = F2(
	function (condition, thunk) {
		return condition ? thunk(0) : $elm$html$Html$text('');
	});
var $author$project$Page$Home$viewOnboarding = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('center-block text-center'),
			A2($elm$html$Html$Attributes$style, 'background-color', $author$project$Util$Bootstrap$powerliftYellow),
			A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
			A2($elm$html$Html$Attributes$style, 'padding', '40px'),
			A2($elm$html$Html$Attributes$style, 'width', '350px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Get access to PowerLift')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You won\'t be able to see any data until you join (or create) a team in PowerLift.')
				])),
			A2($author$project$Util$Bootstrap$routeLinkButton, 'Join / Create', $author$project$App$Route$Onboarding)
		]));
var $author$project$Page$Home$viewFooter = function (showOnboarding) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '20px 0 20px 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('PowerLift')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$App$Route$href($author$project$App$Route$ViewSDKs)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SDKs')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$App$Route$href(
												$author$project$App$Route$ViewDocs($elm$core$Maybe$Nothing))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Docs')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://privacy.microsoft.com/en-US/data-privacy-notice')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Data Privacy Notice')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Questions? Email us at '),
								$author$project$Util$Html$mailto('powerlifters@microsoft.com')
							])),
						$author$project$Util$Html$verticalSpacer('15px'),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Copyright 2019, Microsoft Inc.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Util$Html$viewIfLazy,
						showOnboarding,
						function (_v0) {
							return $author$project$Page$Home$viewOnboarding;
						})
					]))
			]));
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Page$Home$viewHeader = function (showOnboarding) {
	var bigButton = F2(
		function (title, route) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('btn btn-default'),
						A2($elm$html$Html$Attributes$style, 'width', '120px'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '20px'),
						$elm$html$Html$Attributes$type_('button'),
						$author$project$App$Route$href(route)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row'),
				A2($elm$html$Html$Attributes$style, 'padding', '60px 0 60px 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-10 col-md-offset-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Util$Html$viewIfLazy,
								showOnboarding,
								function (_v0) {
									return $author$project$Page$Home$viewOnboarding;
								})
							])),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('PowerLift'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$small,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The best support for your users')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'padding', '10px 0 30px 0')
							]),
						_List_fromArray(
							[
								A2(bigButton, 'SDKs', $author$project$App$Route$ViewSDKs),
								A2(
								bigButton,
								'Docs',
								$author$project$App$Route$ViewDocs($elm$core$Maybe$Nothing))
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-unstyled'),
								$author$project$Page$Home$css.dq
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[$author$project$Page$Home$css.bK]),
								_List_fromArray(
									[
										$elm$html$Html$text('➝ Store, classify, and search app logs')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[$author$project$Page$Home$css.bK]),
								_List_fromArray(
									[
										$elm$html$Html$text('➝ Capture deep, application diagnostics')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[$author$project$Page$Home$css.bK]),
								_List_fromArray(
									[
										$elm$html$Html$text('➝ Automatically resolve user support issues')
									]))
							]))
					]))
			]));
};
var $author$project$Util$Numbers$magnitudeChar = function (magnitude) {
	switch (magnitude) {
		case 0:
			return '';
		case 1:
			return 'K';
		case 2:
			return 'M';
		case 3:
			return 'G';
		case 4:
			return 'T';
		default:
			return 'P';
	}
};
var $author$project$Util$Numbers$prettyMagnitude = F3(
	function (format, magnitude, number) {
		var magnifiedNumber = A2($author$project$Util$Numbers$asMagnitude, magnitude, number);
		var _char = $author$project$Util$Numbers$magnitudeChar(magnitude);
		return _Utils_ap(
			A2($author$project$Util$Numbers$prettyFloat, format, magnifiedNumber),
			_char);
	});
var $author$project$Page$Home$viewStat = F2(
	function (label, itemCount) {
		var count = itemCount;
		var statValue = A3(
			$author$project$Util$Numbers$prettyMagnitude,
			{fW: 1},
			$author$project$Util$Numbers$magnitudeOf(count),
			count);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('center-block text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(statValue)
						])),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(label))
						]))
				]));
	});
var $author$project$Page$Home$viewStats = function (stats) {
	var makeColumn = function (child) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-sm-4')
				]),
			_List_fromArray(
				[child]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '40px 0 40px 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-12 text-center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('In the last 30 days...')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						makeColumn(
						A2($author$project$Page$Home$viewStat, 'incidents created', stats.gU)),
						makeColumn(
						A2($author$project$Page$Home$viewStat, 'logs uploaded', stats.gV)),
						makeColumn(
						A2($author$project$Page$Home$viewStat, 'remedies issued', stats.gY))
					]))
			]));
};
var $author$project$Page$Home$viewMoreVideos = function () {
	var makeWhatsNewItem = F3(
		function (url, title, subtitle) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								$elm$html$Html$text(' - '),
								$elm$html$Html$text(subtitle)
							]))
					]));
		});
	var makeItem = F2(
		function (url, title) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									]))
							]))
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '50px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('More Videos')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(makeItem, 'https://aka.ms/powerlift-2019-developer-edition', 'PowerLift for Developers (2019)'),
						A2(makeItem, 'https://aka.ms/powerlift-video-custom-incident-display', 'Customizing Incident Display'),
						A2(makeItem, 'https://aka.ms/powerlift-video-live-site-issue-process', 'Using PowerLift to Mitigate a Live-Site Issue')
					])),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('What\'s New in the Gym')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A3(makeWhatsNewItem, 'https://msit.microsoftstream.com/video/00dc13ad-dc3c-4779-aaf4-80d60546396f', 'December 2018', 'Ticket Topics'),
						A3(makeWhatsNewItem, 'https://msit.microsoftstream.com/video/c5d73d59-3db8-4d0e-86ae-5e3d0e9dc68f', 'October 2018', 'Remedy Heatmap & Decision Trees'),
						A3(makeWhatsNewItem, 'https://aka.ms/powerlift-video-whats-new-2017', 'September 2017', 'Incident Widgets')
					]))
			]));
}();
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Page$Home$viewVideo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('embed-responsive embed-responsive-16by9')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$iframe,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('embed-responsive-item'),
					$elm$html$Html$Attributes$title('Powerlift Intro Video'),
					$elm$html$Html$Attributes$src('https://aka.ms/powerlift-video-embed'),
					A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true')
				]),
			_List_Nil)
		]));
var $author$project$Page$Home$viewVideos = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-md-7')
				]),
			_List_fromArray(
				[$author$project$Page$Home$viewVideo])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-md-5')
				]),
			_List_fromArray(
				[$author$project$Page$Home$viewMoreVideos]))
		]));
var $author$project$Page$Home$view = F2(
	function (isTenantLessUser, model) {
		var showOnboarding = isTenantLessUser;
		var rowSectionHelp = F3(
			function (child, bgColor, extraStylePairs) {
				return A2(
					$elm$html$Html$section,
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'background-color', bgColor),
						extraStylePairs),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-md-12')
												]),
											_List_fromArray(
												[child]))
										]))
								]))
						]));
			});
		var rowSection = F2(
			function (child, bgColor) {
				return A3(rowSectionHelp, child, bgColor, _List_Nil);
			});
		return {
			bX: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rowSection,
						$author$project$Page$Home$viewHeader(showOnboarding),
						$author$project$Page$Home$css.b5),
						A2(rowSection, $author$project$Page$Home$viewVideos, $author$project$Page$Home$css.c4),
						A2(rowSection, $author$project$Page$Home$viewFeatures, $author$project$Page$Home$css.b5),
						A2(
						$author$project$Util$Html$viewMaybe,
						function (stats) {
							return A2(
								rowSection,
								$author$project$Page$Home$viewStats(stats),
								$author$project$Page$Home$css.b5);
						},
						model.hr),
						A3(
						rowSectionHelp,
						$author$project$Page$Home$viewFooter(showOnboarding),
						$author$project$Page$Home$css.c4,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'border-top', $author$project$Page$Home$css.d_)
							]))
					])),
			bO: 'Home'
		};
	});
var $author$project$Page$Incident$NavigateTo = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Incident$SetNavigator = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$Incident$isPurged = function (incident) {
	var _v0 = incident.er.eM;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $elm_community$list_extra$List$Extra$findIndices = function (predicate) {
	var consIndexIf = F3(
		function (index, x, acc) {
			return predicate(x) ? A2($elm$core$List$cons, index, acc) : acc;
		});
	return A2($elm_community$list_extra$List$Extra$indexedFoldr, consIndexIf, _List_Nil);
};
var $author$project$FocusList$nextVisibleIndex = function (fl) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (i) {
				return _Utils_cmp(i, fl.m) > 0;
			},
			fl.ae));
};
var $author$project$FocusList$previousVisibleIndex = function (fl) {
	return $elm_community$list_extra$List$Extra$last(
		A2(
			$elm$core$List$filter,
			function (i) {
				return _Utils_cmp(i, fl.m) < 0;
			},
			fl.ae));
};
var $author$project$FocusList$selectClosestVisible = function (fl) {
	if (A2($author$project$FocusList$isVisible, fl.m, fl)) {
		return fl;
	} else {
		var _v0 = _Utils_Tuple2(
			$author$project$FocusList$previousVisibleIndex(fl),
			$author$project$FocusList$nextVisibleIndex(fl));
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return fl;
			} else {
				var _v4 = _v0.a;
				var next = _v0.b.a;
				return _Utils_update(
					fl,
					{m: next});
			}
		} else {
			if (_v0.b.$ === 1) {
				var prev = _v0.a.a;
				var _v3 = _v0.b;
				return _Utils_update(
					fl,
					{m: prev});
			} else {
				var prev = _v0.a.a;
				var next = _v0.b.a;
				return (_Utils_cmp(fl.m - prev, next - fl.m) < 0) ? _Utils_update(
					fl,
					{m: prev}) : _Utils_update(
					fl,
					{m: next});
			}
		}
	}
};
var $author$project$FocusList$adjustFocus = F2(
	function (shouldBeVisible, fl) {
		return $author$project$FocusList$selectClosestVisible(
			_Utils_update(
				fl,
				{
					ae: A2($elm_community$list_extra$List$Extra$findIndices, shouldBeVisible, fl.R)
				}));
	});
var $author$project$View$Incident$Navigator$matches = F2(
	function (query, item) {
		return (query === '') ? true : A2(
			$elm$core$String$contains,
			query,
			$elm$core$String$toLower(item.ev));
	});
var $author$project$View$Incident$Navigator$applyQuery = F2(
	function (query, model) {
		var q = $elm$core$String$toLower(query);
		return _Utils_update(
			model,
			{
				R: A2(
					$author$project$FocusList$adjustFocus,
					$author$project$View$Incident$Navigator$matches(q),
					model.R),
				hb: q
			});
	});
var $author$project$FocusList$selectNext = function (fl) {
	var _v0 = $author$project$FocusList$nextVisibleIndex(fl);
	if (!_v0.$) {
		var index = _v0.a;
		return _Utils_update(
			fl,
			{m: index});
	} else {
		return fl;
	}
};
var $author$project$View$Incident$Navigator$navDown = function (model) {
	return _Utils_update(
		model,
		{
			R: $author$project$FocusList$selectNext(model.R)
		});
};
var $author$project$FocusList$selectPrevious = function (fl) {
	var _v0 = $author$project$FocusList$previousVisibleIndex(fl);
	if (!_v0.$) {
		var index = _v0.a;
		return _Utils_update(
			fl,
			{m: index});
	} else {
		return fl;
	}
};
var $author$project$View$Incident$Navigator$navUp = function (model) {
	return _Utils_update(
		model,
		{
			R: $author$project$FocusList$selectPrevious(model.R)
		});
};
var $author$project$View$Incident$Navigator$handleKey = F2(
	function (model, key) {
		switch (key.$) {
			case 7:
				return $elm$core$Maybe$Just(
					$author$project$View$Incident$Navigator$navUp(model));
			case 6:
				return $elm$core$Maybe$Just(
					$author$project$View$Incident$Navigator$navDown(model));
			case 3:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$View$Incident$Navigator$applyQuery,
						A2($elm$core$String$dropRight, 1, model.hb),
						model));
			case 0:
				var _char = key.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$View$Incident$Navigator$applyQuery,
						_Utils_ap(
							model.hb,
							$elm$core$String$fromChar(_char)),
						model));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$Incident$Navigator$instructionsMarkdown = '\nCommands:\n\n- Arrow up/down: move selection up/down\n- Enter key: navigate to selected item\n- Escape key: exit the current mode\n- _all other keys_: filter the list based on substring match\n';
var $author$project$FocusList$isSelected = F2(
	function (index, fl) {
		return _Utils_eq(index, fl.m) && A2($author$project$FocusList$isVisible, index, fl);
	});
var $author$project$FocusList$mapItemList = F2(
	function (fn, fl) {
		return {
			R: fn(fl.R),
			m: fl.m,
			ae: fl.ae
		};
	});
var $author$project$FocusList$mapBy = F2(
	function (_function, fl) {
		return A2(
			$author$project$FocusList$mapItemList,
			$elm$core$List$indexedMap(
				F2(
					function (idx, item) {
						return _function(
							{
								gr: A2($author$project$FocusList$isSelected, idx, fl),
								gs: A2($author$project$FocusList$isVisible, idx, fl),
								gv: item
							});
					})),
			fl);
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Util$Keyboard$filterMapDecoderAdvanced = F2(
	function (tagger, _v0) {
		var stopPropagation = _v0.e4;
		var preventDefault = _v0.eI;
		return A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				var _v1 = tagger(key);
				if (!_v1.$) {
					var msg = _v1.a;
					return $elm$json$Json$Decode$succeed(
						{c6: msg, eI: preventDefault, e4: stopPropagation});
				} else {
					return $elm$json$Json$Decode$fail('not interested');
				}
			},
			$author$project$Util$Keyboard$keyDecoder);
	});
var $author$project$View$Incident$Navigator$onKeyDown = function (tagger) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$author$project$Util$Keyboard$filterMapDecoderAdvanced,
			tagger,
			{eI: true, e4: true}));
};
var $author$project$View$Incident$Navigator$BoldText = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Incident$Navigator$NormalText = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Incident$Navigator$tag = F2(
	function (query, text) {
		var queryLen = $elm$core$String$length(query);
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$String$indexes,
				query,
				$elm$core$String$toLower(text)));
		if (!_v0.$) {
			var queryStartIndex = _v0.a;
			return _Utils_ap(
				_List_fromArray(
					[
						$author$project$View$Incident$Navigator$NormalText(
						A3($elm$core$String$slice, 0, queryStartIndex, text)),
						$author$project$View$Incident$Navigator$BoldText(
						A3($elm$core$String$slice, queryStartIndex, queryStartIndex + queryLen, text))
					]),
				A2(
					$author$project$View$Incident$Navigator$tag,
					query,
					A2($elm$core$String$dropLeft, queryStartIndex + queryLen, text)));
		} else {
			return _List_fromArray(
				[
					$author$project$View$Incident$Navigator$NormalText(text)
				]);
		}
	});
var $author$project$View$Incident$Navigator$viewNavItem = F4(
	function (isSelected, config, model, item) {
		var markedUpParts = A2(
			$elm$core$List$map,
			function (taggedStr) {
				if (!taggedStr.$) {
					var s = taggedStr.a;
					return $elm$html$Html$text(s);
				} else {
					var s = taggedStr.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'background-color', 'lightgoldenrodyellow')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(s)
							]));
				}
			},
			A2($author$project$View$Incident$Navigator$tag, model.hb, item.ev));
		return A2(
			$elm$html$Html$li,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Util$Html$role('button'),
						$elm$html$Html$Events$onClick(
						config.gP(item.bu)),
						A2(
						$elm$html$Html$Events$on,
						'mouseover',
						$elm$json$Json$Decode$succeed(
							config.fa(
								A2($author$project$View$Incident$Navigator$select, item.bu, model)))),
						A2($elm$html$Html$Attributes$style, 'padding', '6px')
					]),
				isSelected ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-accent-bg-color-light)'),
						A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-info-color)')
					]) : _List_Nil),
			item.bb ? _List_fromArray(
				[
					A2($elm$html$Html$b, _List_Nil, markedUpParts)
				]) : markedUpParts);
	});
var $author$project$FocusList$visibleItems = function (fl) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var idx = _v0.a;
				return A2($author$project$FocusList$isVisible, idx, fl);
			},
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (a, b) {
						return _Utils_Tuple2(a, b);
					}),
				fl.R)));
};
var $author$project$View$Incident$Navigator$view = F2(
	function (model, config) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id($author$project$View$Incident$Navigator$id),
					$elm$html$Html$Attributes$tabindex(0),
					$author$project$View$Incident$Navigator$onKeyDown(
					function (key) {
						return A2(
							$elm$core$Maybe$map,
							config.fa,
							A2($author$project$View$Incident$Navigator$handleKey, model, key));
					}),
					A2($elm$html$Html$Attributes$style, 'outline', 'none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Use keyboard or mouse to quickly navigate between sections of data in this incident.')
						])),
					$elm$core$List$isEmpty(
					$author$project$FocusList$visibleItems(model.R)) ? A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('no matches for: '),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.hb)
								]))
						])) : A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-unstyled')
						]),
					$author$project$FocusList$visibleItems(
						A2(
							$author$project$FocusList$mapBy,
							function (_v0) {
								var isVisible = _v0.gs;
								var isSelected = _v0.gr;
								var item = _v0.gv;
								return isVisible ? A4($author$project$View$Incident$Navigator$viewNavItem, isSelected, config, model, item) : $elm$html$Html$text('');
							},
							model.R))),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm_explorations$markdown$Markdown$toHtml,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', '#777')
						]),
					$author$project$View$Incident$Navigator$instructionsMarkdown)
				]));
	});
var $author$project$Page$Incident$EditorScrolled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Classifier$Editor$isDrillEmpty = function (model) {
	var _v0 = model.L;
	if (_v0.$ === 1) {
		var subModel = _v0.a;
		return $elm$core$List$isEmpty(subModel.de);
	} else {
		return true;
	}
};
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Page$Incident$ScrollPos = F3(
	function (scrollTop, contentHeight, containerHeight) {
		return {dR: containerHeight, dS: contentHeight, eY: scrollTop};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Page$Incident$scrollPosDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Page$Incident$ScrollPos,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$int),
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Basics$max,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'offsetHeight']),
			$elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'clientHeight']),
			$elm$json$Json$Decode$int)));
var $author$project$Util$Bootstrap$fluidContainer = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container-fluid')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-12')
							]),
						children)
					]))
			]));
};
var $author$project$Page$Incident$ToggleClickToClassify = {$: 8};
var $author$project$Page$Incident$viewCreateWidgetInstructions = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('panel panel-default'),
			A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel-heading')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Customizing Incident Display')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm_explorations$markdown$Markdown$toHtml,
					_List_Nil,
					'As your incident data gets larger, it\'s useful to create ' + (A2(
						$author$project$App$Route$routeToMarkdownLink,
						$author$project$App$Route$ViewDocs(
							$elm$core$Maybe$Just(8)),
						'widgets') + (' to summarize the data. This makes it easier for your engineers and support team to ' + 'quickly scan for the info they need.'))),
					A2($author$project$Util$Bootstrap$routeLinkButtonLight, 'Manage Widgets', $author$project$App$Route$EditWidgetCollection)
				]))
		]));
var $author$project$Page$Incident$ClickToClassify = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Incident$DataTreeCollapseAll = {$: 11};
var $author$project$Page$Incident$DataTreeExpandAll = {$: 10};
var $author$project$Page$Incident$NewTreeViewState = function (a) {
	return {$: 9, a: a};
};
var $author$project$JsonTree$View$css = {
	dE: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-json-tree-bool)')
		]),
	dP: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
			A2($elm$html$Html$Attributes$style, 'top', '1px'),
			A2($elm$html$Html$Attributes$style, 'left', '-15px')
		]),
	ea: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
		]),
	c3: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'relative')
		]),
	ex: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-json-tree-null)')
		]),
	ey: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-json-tree-number)')
		]),
	eS: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'font-family', 'monospace'),
			A2($elm$html$Html$Attributes$style, 'white-space', 'pre')
		]),
	e5: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-json-tree-string)')
		]),
	dv: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'list-style-type', 'none'),
			A2($elm$html$Html$Attributes$style, 'margin-left', '26px'),
			A2($elm$html$Html$Attributes$style, 'padding-left', '0px')
		])
};
var $author$project$JsonTree$View$isCollapsed = F2(
	function (keyPath, _v0) {
		var hiddenPaths = _v0;
		return A2($elm$core$Set$member, keyPath, hiddenPaths);
	});
var $author$project$JsonTree$View$textEllipses = A2(
	$elm$html$Html$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('…')
		]));
var $author$project$Util$Bool$toString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$JsonTree$View$lazyStateChangeOnClick = F2(
	function (newStateThunk, toMsg) {
		var force = function (thunk) {
			return thunk(0);
		};
		return A2(
			$elm$html$Html$Events$on,
			'click',
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, force, toMsg),
				$elm$json$Json$Decode$succeed(newStateThunk)));
	});
var $author$project$JsonTree$View$viewCollapser = F4(
	function (depth, context, newStateThunk, displayText) {
		return (!depth) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$JsonTree$View$lazyStateChangeOnClick, newStateThunk, context.fa)
					]),
				$author$project$JsonTree$View$css.dP),
			_List_fromArray(
				[
					$elm$html$Html$text(displayText)
				]));
	});
var $author$project$JsonTree$View$viewCollapseButton = F4(
	function (depth, keyPath, context, state) {
		return A4(
			$author$project$JsonTree$View$viewCollapser,
			depth,
			context,
			function (_v0) {
				return A2($author$project$JsonTree$View$collapse, keyPath, state);
			},
			'-');
	});
var $author$project$JsonTree$View$expand = F2(
	function (keyPath, _v0) {
		var hiddenPaths = _v0;
		return A2($elm$core$Set$remove, keyPath, hiddenPaths);
	});
var $author$project$JsonTree$View$viewExpandButton = F4(
	function (depth, keyPath, context, state) {
		return A4(
			$author$project$JsonTree$View$viewCollapser,
			depth,
			context,
			function (_v0) {
				return A2($author$project$JsonTree$View$expand, keyPath, state);
			},
			'+');
	});
var $author$project$View$Highlight$labelButton = function (highlight) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$App$Route$href(
				$author$project$App$Route$EditClassifier(highlight.fG)),
				$elm$html$Html$Attributes$class('btn btn-xs btn-primary'),
				A2($elm$html$Html$Attributes$style, 'margin-left', '8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0px 5px 2px 5px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '1'),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(highlight.eo)
			]));
};
var $author$project$JsonTree$View$viewScalar = F4(
	function (someCss, str, node, context) {
		var attributes = function () {
			var _v0 = context.eA;
			if (!_v0.$) {
				var onSelect = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('clickToClassifyNode'),
						$elm$html$Html$Events$onClick(
						onSelect(node.gy))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$span,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(node.gy)
						]),
					_Utils_ap(someCss, attributes)),
				_List_fromArray(
					[
						$elm$html$Html$text(str)
					])),
			A2($elm$core$List$map, $author$project$View$Highlight$labelButton, node.gh));
	});
var $author$project$JsonTree$View$viewArray = F5(
	function (depth, nodes, keyPath, context, state) {
		var viewListItem = function (node) {
			return A2(
				$elm$html$Html$li,
				$author$project$JsonTree$View$css.c3,
				A2(
					$elm$core$List$append,
					A4($author$project$JsonTree$View$viewNode, depth + 1, context, node, state),
					_List_fromArray(
						[
							$elm$html$Html$text(',')
						])));
		};
		var innerContent = $elm$core$List$isEmpty(nodes) ? _List_Nil : (A2($author$project$JsonTree$View$isCollapsed, keyPath, state) ? _List_fromArray(
			[
				A4($author$project$JsonTree$View$viewExpandButton, depth, keyPath, context, state),
				$author$project$JsonTree$View$textEllipses
			]) : _List_fromArray(
			[
				A4($author$project$JsonTree$View$viewCollapseButton, depth, keyPath, context, state),
				A2(
				$elm$html$Html$ul,
				$author$project$JsonTree$View$css.dv,
				A2($elm$core$List$map, viewListItem, nodes))
			]));
		return _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$text('[')
				]),
			_Utils_ap(
				innerContent,
				_List_fromArray(
					[
						$elm$html$Html$text(']')
					])));
	});
var $author$project$JsonTree$View$viewDict = F5(
	function (depth, dict, keyPath, context, state) {
		var viewListItem = function (_v1) {
			var fieldName = _v1.a;
			var node = _v1.b;
			return A2(
				$elm$html$Html$li,
				$author$project$JsonTree$View$css.c3,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							$author$project$JsonTree$View$css.ea,
							_List_fromArray(
								[
									$elm$html$Html$text(fieldName)
								])),
							$elm$html$Html$text(': ')
						]),
					_Utils_ap(
						A4($author$project$JsonTree$View$viewNode, depth + 1, context, node, state),
						_List_fromArray(
							[
								$elm$html$Html$text(',')
							]))));
		};
		var innerContent = $elm$core$Dict$isEmpty(dict) ? _List_Nil : (A2($author$project$JsonTree$View$isCollapsed, keyPath, state) ? _List_fromArray(
			[
				A4($author$project$JsonTree$View$viewExpandButton, depth, keyPath, context, state),
				$author$project$JsonTree$View$textEllipses
			]) : _List_fromArray(
			[
				A4($author$project$JsonTree$View$viewCollapseButton, depth, keyPath, context, state),
				A2(
				$elm$html$Html$ul,
				$author$project$JsonTree$View$css.dv,
				A2(
					$elm$core$List$map,
					viewListItem,
					$elm$core$Dict$toList(dict)))
			]));
		return _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$text('{')
				]),
			_Utils_ap(
				innerContent,
				_List_fromArray(
					[
						$elm$html$Html$text('}')
					])));
	});
var $author$project$JsonTree$View$viewNode = F4(
	function (depth, context, node, state) {
		var _v0 = node.hR;
		switch (_v0.$) {
			case 0:
				var str = _v0.a;
				return A4($author$project$JsonTree$View$viewScalar, $author$project$JsonTree$View$css.e5, '\"' + (str + '\"'), node, context);
			case 1:
				var x = _v0.a;
				return A4(
					$author$project$JsonTree$View$viewScalar,
					$author$project$JsonTree$View$css.ey,
					$elm$core$String$fromFloat(x),
					node,
					context);
			case 2:
				var bool = _v0.a;
				return A4(
					$author$project$JsonTree$View$viewScalar,
					$author$project$JsonTree$View$css.dE,
					$author$project$Util$Bool$toString(bool),
					node,
					context);
			case 5:
				return A4($author$project$JsonTree$View$viewScalar, $author$project$JsonTree$View$css.ex, 'null', node, context);
			case 3:
				var nodes = _v0.a;
				return A5($author$project$JsonTree$View$viewArray, depth, nodes, node.gy, context, state);
			default:
				var dict = _v0.a;
				return A5($author$project$JsonTree$View$viewDict, depth, dict, node.gy, context, state);
		}
	});
var $author$project$JsonTree$View$viewCore = F3(
	function (node, context, state) {
		return A2(
			$elm$html$Html$div,
			$author$project$JsonTree$View$css.eS,
			A4($author$project$JsonTree$View$viewNode, 0, context, node, state));
	});
var $author$project$Page$Incident$ScrollToKeyPath = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Incident$viewHighlight = function (highlight) {
	var viewMatch = function (_v0) {
		var keyPath = _v0.gy;
		var value = _v0.hR;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-link'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$Incident$ScrollToKeyPath(keyPath))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(keyPath)
						])),
					$elm$html$Html$text(
					'= ' + A2($elm$json$Json$Encode$encode, 2, value))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Highlight$labelButton(highlight),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2($elm$core$List$map, viewMatch, highlight.gI))
			]));
};
var $author$project$Page$Incident$viewHighlights = function (highlights) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Highlights')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Highlights show the exact location of the data which contributed to a classification.')
						]))
				]),
			A2($elm$core$List$map, $author$project$Page$Incident$viewHighlight, highlights)));
};
var $author$project$Page$Incident$viewData = F4(
	function (aliasAccessId, _v0, isClickToClassifyActive, treeViewState) {
		var incident = _v0.gj;
		var tree = _v0.ac;
		var treeContext = {
			eA: isClickToClassifyActive ? $elm$core$Maybe$Just($author$project$Page$Incident$ClickToClassify) : $elm$core$Maybe$Nothing,
			fa: $author$project$Page$Incident$NewTreeViewState
		};
		var rawJsonUrl = '/gym/incidents/' + ($author$project$UUID$toString(incident.fp.er.bj) + ('/gymAid' + '?format=json'));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('All Incident Data'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' ('),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(rawJsonUrl)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('raw')
										])),
									$elm$html$Html$text(')')
								]))
						])),
					$author$project$Page$Incident$viewHighlights(incident.gh),
					A2(
					$author$project$Util$Bootstrap$horizontalButtonGroupCustom,
					_List_fromArray(
						[
							_Utils_Tuple3('Expand All', $author$project$Page$Incident$DataTreeExpandAll, _List_Nil),
							_Utils_Tuple3('Collapse All', $author$project$Page$Incident$DataTreeCollapseAll, _List_Nil)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2('pull-right', true)
						])),
					A3($author$project$JsonTree$View$viewCore, tree, treeContext, treeViewState)
				]));
	});
var $author$project$Page$Incident$viewDiagnosticsSideNav = F2(
	function (widgetSections, currentSubSection) {
		var viewItem = F2(
			function (index, widgetSection) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Incident$SelectTab(
								$author$project$Page$Incident$Diagnostics(
									$author$project$Page$Incident$WidgetsSection(index)))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list-group-item', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(
										$author$project$Page$Incident$WidgetsSection(index),
										currentSubSection))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(widgetSection.bO),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('badge')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Page$Incident$sectionBadgeCount(widgetSection))))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
				]),
			_List_fromArray(
				[
					$elm$core$List$isEmpty(widgetSections) ? $author$project$View$EmptyStates$view('No widgets') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-default')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group')
								]),
							A2($elm$core$List$indexedMap, viewItem, widgetSections))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-default')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Page$Incident$SelectTab(
												$author$project$Page$Incident$Diagnostics($author$project$Page$Incident$EntireIncidentSection))),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('list-group-item', true),
													_Utils_Tuple2(
													'active',
													_Utils_eq($author$project$Page$Incident$EntireIncidentSection, currentSubSection))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All Data')
										]))
								]))
						]))
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Page$Incident$DynamicListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Incident$DynamicTableMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Incident$GenericMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Incident$StaticTableMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Incident$WidgetMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$JsonTree$Resolver$runDecoder = F2(
	function (decoder, node) {
		var _v0 = decoder(node.hR);
		if (!_v0.$) {
			var newValue = _v0.a;
			return $elm$core$Result$Ok(
				{gh: node.gh, gy: node.gy, hR: newValue});
		} else {
			var err = _v0.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$JsonTree$Resolver$asListOf = F2(
	function (itemDecoder, node) {
		var combine = A2(
			$elm$core$List$foldr,
			$elm$core$Result$map2($elm$core$List$cons),
			$elm$core$Result$Ok(_List_Nil));
		if (node.$ === 3) {
			var items = node.a;
			return combine(
				A2(
					$elm$core$List$map,
					$author$project$JsonTree$Resolver$runDecoder(itemDecoder),
					items));
		} else {
			return $elm$core$Result$Err('not an array');
		}
	});
var $author$project$JsonTree$Resolver$asString = function (taggedValue) {
	if (!taggedValue.$) {
		var s = taggedValue.a;
		return $elm$core$Result$Ok(s);
	} else {
		return $elm$core$Result$Err('not a string');
	}
};
var $author$project$JsonTree$Resolver$resolveAs = F3(
	function (rawKeyPath, tree, decoder) {
		return A2(
			$elm$core$Result$andThen,
			$author$project$JsonTree$Resolver$runDecoder(decoder),
			A2($author$project$JsonTree$Resolver$resolve, rawKeyPath, tree));
	});
var $author$project$View$Widget$viewError = function (errorMessage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-danger')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(errorMessage)
					]))
			]));
};
var $author$project$View$Widget$DynamicList$External = $elm$core$Basics$identity;
var $author$project$View$Widget$SelectKeyPath = $elm$core$Basics$identity;
var $author$project$View$Widget$viewClickToClassifyNode = F3(
	function (clickable, onSelect, textValue) {
		return clickable ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('clickToClassifyNode'),
					$elm$html$Html$Events$onClick(onSelect)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(textValue)
				])) : $elm$html$Html$text(textValue);
	});
var $author$project$View$Widget$DynamicList$viewItem = F2(
	function (context, _v0) {
		var value = _v0.hR;
		var keyPath = _v0.gy;
		var highlights = _v0.gh;
		var fontColor = (A2($elm$core$String$startsWith, 'E\t', value) || A2($elm$core$String$startsWith, 'E ', value)) ? 'var(--pl-danger-color)' : ((A2($elm$core$String$startsWith, 'W\t', value) || A2($elm$core$String$startsWith, 'W ', value)) ? 'var(--pl-warning-color)' : 'inherit');
		var bgColor = $elm$core$List$isEmpty(highlights) ? 'inherit' : 'var(--pl-accent-bg-color-light)';
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-family', 'monospace'),
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
					A2($elm$html$Html$Attributes$style, 'background', bgColor),
					A2($elm$html$Html$Attributes$style, 'color', fontColor),
					A2($elm$html$Html$Attributes$style, 'font-size', '10pt'),
					A2($elm$html$Html$Attributes$style, 'line-height', '1.15')
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$View$Widget$viewClickToClassifyNode, context.N, keyPath, value),
				A2($elm$core$List$map, $author$project$View$Highlight$labelButton, highlights)));
	});
var $author$project$View$Widget$DynamicList$viewList = F2(
	function (resolvedValues, context) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-unstyled')
				]),
			A2(
				$elm$core$List$map,
				$author$project$View$Widget$DynamicList$viewItem(context),
				resolvedValues));
	});
var $author$project$View$Widget$DynamicList$view = F3(
	function (tree, model, context) {
		var listOfTextDecoder = $author$project$JsonTree$Resolver$asListOf($author$project$JsonTree$Resolver$asString);
		var resolve = function (keyPath) {
			return A3($author$project$JsonTree$Resolver$resolveAs, keyPath, tree, listOfTextDecoder);
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = resolve(model.b1.K);
					if (!_v0.$) {
						var value = _v0.a.hR;
						return A2($author$project$View$Widget$DynamicList$viewList, value, context);
					} else {
						var error = _v0.a;
						return $author$project$View$Widget$viewError(error);
					}
				}()
				]));
	});
var $author$project$JsonTree$Resolver$asIdentity = function (taggedValue) {
	return $elm$core$Result$Ok(taggedValue);
};
var $author$project$View$Widget$DynamicTable$External = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$Widget$DynamicTable$NewTreeViewState = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$View$Widget$DynamicTable$viewExpandedRow = F4(
	function (tree, numColumnsInTable, context, treeViewState) {
		var treeContext = {
			eA: context.N ? $elm$core$Maybe$Just(
				A2($elm$core$Basics$composeL, $author$project$View$Widget$DynamicTable$External, $elm$core$Basics$identity)) : $elm$core$Maybe$Nothing,
			fa: $author$project$View$Widget$DynamicTable$NewTreeViewState
		};
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(numColumnsInTable)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('JSON at \'' + (tree.gy + '\''))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '400px')
								]),
							_List_fromArray(
								[
									A3($author$project$JsonTree$View$viewCore, tree, treeContext, treeViewState)
								]))
						]))
				]));
	});
var $author$project$View$Widget$DynamicTable$rowStyle = function (node) {
	var bgColor = $elm$core$List$isEmpty(
		$author$project$JsonTree$allHighlights(node)) ? 'inherit' : 'var(--pl-accent-bg-color-light)';
	return A2($elm$html$Html$Attributes$style, 'background', bgColor);
};
var $author$project$Data$Widget$Lens$Matched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Widget$Lens$NotMatched = {$: 1};
var $author$project$Data$Widget$Lens$ResolveErr = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Widget$Lens$TextContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$JsonTree$Resolver$asAndThen = F2(
	function (func, decoder) {
		return A2(
			$elm$core$Basics$composeR,
			decoder,
			$elm$core$Result$andThen(func));
	});
var $author$project$JsonTree$Resolver$asFloat = function (taggedValue) {
	if (taggedValue.$ === 1) {
		var x = taggedValue.a;
		return $elm$core$Result$Ok(x);
	} else {
		return $elm$core$Result$Err('not convertible to float');
	}
};
var $author$project$JsonTree$Resolver$asMap = F2(
	function (func, decoder) {
		return A2(
			$elm$core$Basics$composeR,
			decoder,
			$elm$core$Result$map(func));
	});
var $author$project$JsonTree$Resolver$asText = function (taggedValue) {
	switch (taggedValue.$) {
		case 0:
			var s = taggedValue.a;
			return $elm$core$Result$Ok(s);
		case 1:
			var x = taggedValue.a;
			return $elm$core$Result$Ok(
				$elm$core$String$fromFloat(x));
		case 2:
			var b = taggedValue.a;
			return $elm$core$Result$Ok(
				$author$project$Util$Bool$toString(b));
		case 5:
			return $elm$core$Result$Ok('NULL');
		default:
			return $elm$core$Result$Err('not convertible to text');
	}
};
var $author$project$Data$Widget$Lens$LinkContent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Data$Widget$Lens$populateUrlTemplate = F2(
	function (urlTemplate, dataValue) {
		return A2(
			$author$project$Data$Widget$Lens$LinkContent,
			A3($elm$core$String$replace, $author$project$Data$Widget$Lens$templateVariable, dataValue, urlTemplate),
			dataValue);
	});
var $author$project$Util$Numbers$prettyByteCount = F2(
	function (format, number) {
		var magnitude = $author$project$Util$Numbers$magnitudeOf(number);
		var magnifiedNumber = A2($author$project$Util$Numbers$asMagnitude, magnitude, number);
		var _char = $author$project$Util$Numbers$magnitudeChar(magnitude);
		return A2($author$project$Util$Numbers$prettyFloat, format, magnifiedNumber) + (' ' + (_char + 'B'));
	});
var $author$project$Data$Widget$Lens$resolver = function (lens) {
	var posixFromString = function (str) {
		return A2(
			$elm$core$Result$mapError,
			function (_v1) {
				return 'invalid date format';
			},
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str));
	};
	var _v0 = lens.ay;
	switch (_v0.$) {
		case 0:
			return A2($author$project$JsonTree$Resolver$asMap, $author$project$Data$Widget$Lens$TextContent, $author$project$JsonTree$Resolver$asText);
		case 1:
			return A2(
				$author$project$JsonTree$Resolver$asMap,
				$author$project$Data$Widget$Lens$TextContent,
				A2(
					$author$project$JsonTree$Resolver$asMap,
					$author$project$Util$Date$formatDateAndTime,
					A2($author$project$JsonTree$Resolver$asAndThen, posixFromString, $author$project$JsonTree$Resolver$asText)));
		case 2:
			return A2(
				$author$project$JsonTree$Resolver$asMap,
				$author$project$Data$Widget$Lens$TextContent,
				A2(
					$author$project$JsonTree$Resolver$asMap,
					$author$project$Util$Numbers$prettyByteCount(
						{fW: 1}),
					$author$project$JsonTree$Resolver$asFloat));
		default:
			var template = _v0.a;
			return A2(
				$author$project$JsonTree$Resolver$asMap,
				$author$project$Data$Widget$Lens$populateUrlTemplate(template),
				$author$project$JsonTree$Resolver$asText);
	}
};
var $author$project$Data$Widget$Lens$resolve = F2(
	function (tree, lens) {
		var _v0 = A3(
			$author$project$JsonTree$Resolver$resolveAs,
			lens.gy,
			tree,
			$author$project$Data$Widget$Lens$resolver(lens));
		if (!_v0.$) {
			var node = _v0.a;
			return $author$project$Data$Widget$Lens$Matched(node);
		} else {
			var err = _v0.a;
			return (lens.cf && A2($elm$core$String$contains, 'not found', err)) ? $author$project$Data$Widget$Lens$NotMatched : $author$project$Data$Widget$Lens$ResolveErr(err);
		}
	});
var $author$project$View$Widget$DynamicTable$viewCellContent = F2(
	function (node, context) {
		var _v0 = node.hR;
		if (!_v0.$) {
			var str = _v0.a;
			return A3(
				$author$project$View$Widget$viewClickToClassifyNode,
				context.N,
				$author$project$View$Widget$DynamicTable$External(node.gy),
				str);
		} else {
			var url = _v0.a;
			var displayAs = _v0.b;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(displayAs)
					]));
		}
	});
var $author$project$View$Widget$viewErrorCell = function (errorMessage) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-danger-color)')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(errorMessage)
			]));
};
var $author$project$View$Widget$DynamicTable$viewCell = F3(
	function (context, node, column) {
		var _v0 = A2($author$project$Data$Widget$Lens$resolve, node, column.al);
		switch (_v0.$) {
			case 0:
				var childNode = _v0.a;
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$View$Widget$DynamicTable$viewCellContent, childNode, context),
						A2($elm$core$List$map, $author$project$View$Highlight$labelButton, childNode.gh)));
			case 1:
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			default:
				var error = _v0.a;
				return $author$project$View$Widget$viewErrorCell(error);
		}
	});
var $author$project$View$Widget$DynamicTable$ExpandCollapseRow = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Widget$DynamicTable$viewMoreCell = F2(
	function (index, isExpanded) {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-default btn-sm',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$View$Widget$DynamicTable$ExpandCollapseRow(index))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isExpanded ? 'x' : '...')
						]))
				]));
	});
var $author$project$View$Widget$DynamicTable$viewRow = F5(
	function (index, isExpanded, node, columns, context) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$author$project$View$Widget$DynamicTable$rowStyle(node)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2($author$project$View$Widget$DynamicTable$viewCell, context, node),
					columns),
				_List_fromArray(
					[
						A2($author$project$View$Widget$DynamicTable$viewMoreCell, index, isExpanded)
					])));
	});
var $author$project$View$Widget$DynamicTable$viewTable = F5(
	function (columns, rowNodes, expandedRows, context, treeViewState) {
		var isExpanded = function (index) {
			return A2($elm$core$Set$member, index, expandedRows);
		};
		var columnNames = _Utils_ap(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ev;
				},
				columns),
			_List_fromArray(
				['More']));
		var header = A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (x) {
					return A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(x)
							]));
				},
				columnNames));
		var row = F2(
			function (index, node) {
				return _List_fromArray(
					[
						A5(
						$author$project$View$Widget$DynamicTable$viewRow,
						index,
						isExpanded(index),
						node,
						columns,
						context),
						isExpanded(index) ? A4(
						$author$project$View$Widget$DynamicTable$viewExpandedRow,
						node,
						$elm$core$List$length(columnNames),
						context,
						treeViewState) : $elm$html$Html$text('')
					]);
			});
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered table-condensed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[header])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					$elm$core$List$concat(
						A2($elm$core$List$indexedMap, row, rowNodes)))
				]));
	});
var $author$project$View$Widget$DynamicTable$view = F3(
	function (tree, model, context) {
		var keyPath = model.b1.K;
		var resolvedList = A3(
			$author$project$JsonTree$Resolver$resolveAs,
			keyPath,
			tree,
			$author$project$JsonTree$Resolver$asListOf($author$project$JsonTree$Resolver$asIdentity));
		if (!resolvedList.$) {
			var node = resolvedList.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A5($author$project$View$Widget$DynamicTable$viewTable, model.b1.b0, node.hR, model.e2.bd, context, model.e2.cz)
					]));
		} else {
			var error = resolvedList.a;
			return $author$project$View$Widget$viewError(error);
		}
	});
var $author$project$View$Widget$Generic$External = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Widget$Generic$NewTreeViewState = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Widget$Generic$view = F3(
	function (tree, model, context) {
		var treeContext = {
			eA: context.N ? $elm$core$Maybe$Just(
				A2($elm$core$Basics$composeL, $author$project$View$Widget$Generic$External, $elm$core$Basics$identity)) : $elm$core$Maybe$Nothing,
			fa: $author$project$View$Widget$Generic$NewTreeViewState
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = A2($author$project$JsonTree$Resolver$resolve, model.b1.gy, tree);
					if (!_v0.$) {
						var subTree = _v0.a;
						return A3($author$project$JsonTree$View$viewCore, subTree, treeContext, model.e2.cz);
					} else {
						var error = _v0.a;
						return $author$project$View$Widget$viewError(error);
					}
				}()
				]));
	});
var $author$project$View$Widget$StaticTable$External = $elm$core$Basics$identity;
var $author$project$View$Widget$StaticTable$viewCellContent = F2(
	function (node, context) {
		var _v0 = node.hR;
		if (!_v0.$) {
			var str = _v0.a;
			return A2($elm$core$String$startsWith, 'http', str) ? A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(str),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(str)
					])) : A3($author$project$View$Widget$viewClickToClassifyNode, context.N, node.gy, str);
		} else {
			var url = _v0.a;
			var displayAs = _v0.b;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(displayAs)
					]));
		}
	});
var $author$project$View$Widget$StaticTable$viewCell = F2(
	function (context, rowResult) {
		switch (rowResult.$) {
			case 0:
				var childNode = rowResult.a;
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$View$Widget$StaticTable$viewCellContent, childNode, context),
						A2($elm$core$List$map, $author$project$View$Highlight$labelButton, childNode.gh)));
			case 1:
				return A2($elm$html$Html$td, _List_Nil, _List_Nil);
			default:
				var err = rowResult.a;
				return $author$project$View$Widget$viewErrorCell(err);
		}
	});
var $author$project$View$Widget$StaticTable$viewRow = F3(
	function (context, label, rowResult) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '30%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2($author$project$View$Widget$StaticTable$viewCell, context, rowResult)
				]));
	});
var $author$project$View$Widget$StaticTable$resolveAndViewRow = F3(
	function (context, tree, row) {
		return A3(
			$author$project$View$Widget$StaticTable$viewRow,
			context,
			row.eo,
			A2($author$project$Data$Widget$Lens$resolve, tree, row.hR));
	});
var $author$project$View$Widget$StaticTable$view = F3(
	function (tree, model, context) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered table-condensed'),
					A2($elm$html$Html$Attributes$style, 'table-layout', 'fixed'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$View$Widget$StaticTable$resolveAndViewRow, context, tree),
						model.b1.aW))
				]));
	});
var $author$project$Page$Incident$viewWidget = function (_v0) {
	var tree = _v0.a;
	var context = _v0.b;
	var widget = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id(
				$author$project$UUID$toString(widget.bj))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(widget.bO),
						$elm$html$Html$text(' '),
						function () {
						var _v1 = widget.dC;
						if (!_v1.$) {
							var badgeCount = _v1.a;
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('badge')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(badgeCount))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					])),
				function () {
				var _v2 = widget.b3;
				switch (_v2.$) {
					case 0:
						var model = _v2.a;
						return A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Page$Incident$WidgetMsg(widget.bj),
								$author$project$Page$Incident$StaticTableMsg),
							A3($author$project$View$Widget$StaticTable$view, tree, model, context));
					case 2:
						var model = _v2.a;
						return A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Page$Incident$WidgetMsg(widget.bj),
								$author$project$Page$Incident$DynamicListMsg),
							A3($author$project$View$Widget$DynamicList$view, tree, model, context));
					case 1:
						var model = _v2.a;
						return A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Page$Incident$WidgetMsg(widget.bj),
								$author$project$Page$Incident$DynamicTableMsg),
							A3($author$project$View$Widget$DynamicTable$view, tree, model, context));
					default:
						var model = _v2.a;
						return A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Page$Incident$WidgetMsg(widget.bj),
								$author$project$Page$Incident$GenericMsg),
							A3($author$project$View$Widget$Generic$view, tree, model, context));
				}
			}()
			]));
};
var $author$project$Page$Incident$viewDiagnosticsTabContent = F2(
	function (model, widgetSection) {
		var widgetContext = {N: model.N};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$isEmpty(widgetSection.cB) ? _List_fromArray(
				[
					$author$project$View$EmptyStates$view('There are no widgets in this section')
				]) : A2(
				$elm$core$List$map,
				function (widget) {
					return A2(
						$elm$html$Html$Lazy$lazy,
						$author$project$Page$Incident$viewWidget,
						_Utils_Tuple3(model.z.ac, widgetContext, widget));
				},
				widgetSection.cB));
	});
var $author$project$Page$Incident$viewDiagnostics = F2(
	function (model, subSection) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox pull-right'),
							A2($elm$html$Html$Attributes$style, 'margin-right', '15px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Events$onCheck(
											$elm$core$Basics$always($author$project$Page$Incident$ToggleClickToClassify)),
											$elm$html$Html$Attributes$checked(model.N)
										]),
									_List_Nil),
									$elm$html$Html$text('Click to Classify')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-2')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Incident$viewDiagnosticsSideNav, model.hT, subSection)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-10')
								]),
							_List_fromArray(
								[
									function () {
									if (!subSection.$) {
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$core$List$isEmpty(model.hT) ? $author$project$Page$Incident$viewCreateWidgetInstructions : $elm$html$Html$text(''),
													A4($author$project$Page$Incident$viewData, model.bV, model.z, model.N, model.P)
												]));
									} else {
										var index = subSection.a;
										var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.hT);
										if (!_v1.$) {
											var widgetSection = _v1.a;
											return A2($author$project$Page$Incident$viewDiagnosticsTabContent, model, widgetSection);
										} else {
											return $elm$html$Html$text(
												'Nothing found at widget section ' + $elm$core$String$fromInt(index));
										}
									}
								}()
								]))
						]))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.eU;
	var col = placement.dO;
	var isRight = placement.Q;
	var isUp = placement.br;
	return isRight ? _Utils_update(
		placement,
		{dO: col - 1, Q: false}) : (isUp ? _Utils_update(
		placement,
		{dO: col + 1, Q: true, eU: row - 1}) : _Utils_update(
		placement,
		{dO: col + 1, Q: true, eU: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return 1 === (1 & (_byte >> (7 - offset)));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.e$;
		var row = _v0.eU;
		var col = _v0.dO;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.e$;
			var row = placement.eU;
			var col = placement.dO;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{dO: col - 1, Q: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{dO: col - 2, Q: true, br: false, eU: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{dO: col - 2, Q: true, br: true, eU: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									return A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
										$pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										bytes,
										offset + 1,
										A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix));
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {dO: size + 1, Q: true, br: true, eU: size + 1, e$: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			p: _List_Nil,
			k: 0,
			o: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.k * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						p: A2($elm$core$List$cons, mappedLeaf, builder.p),
						k: builder.k + 1,
						o: builder.o
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return function (a) {
			return A2($elm$core$Array$indexedMap, a, matrix);
		}(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		var last = _v0.a;
		var partialScore = _v0.b;
		var score = _v0.c;
		if (!simplifiedList.b) {
			return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
		} else {
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			return _Utils_eq(last, head) ? A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				tail,
				_Utils_Tuple3(last, partialScore + 1, score)) : ((partialScore >= 5) ? A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				tail,
				_Utils_Tuple3(head, 0, (score + partialScore) - 2)) : A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				tail,
				_Utils_Tuple3(head, 0, score)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							return A4(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_,
								tail,
								tail2,
								$elm$core$Maybe$Just(head),
								score + 3);
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		if (list.b && list.b.b) {
			var head1 = list.a;
			var _v1 = list.b;
			var head2 = _v1.a;
			var tail = _v1.b;
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score,
				tail,
				score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0));
		} else {
			return score;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			function (a) {
				return a / 5;
			}(
				$elm$core$Basics$abs(
					function (a) {
						return a - 50;
					}(darkPerc + (5 - remOf5)))));
		var prevMult5 = $elm$core$Basics$round(
			function (a) {
				return a / 5;
			}(
				$elm$core$Basics$abs(
					function (a) {
						return a - 50;
					}(darkPerc - remOf5))));
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			return (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) ? helper(
				d_ ^ function (a) {
					return g15Int << a;
				}(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit)) : (g15Mask ^ (d_ | (formatInfoInt << 10)));
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		if (count < 15) {
			var isBlack = isBlackFn(count);
			var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
			var x2 = _v0.a;
			var y2 = _v0.b;
			var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
			var x1 = _v1.a;
			var y1 = _v1.b;
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
				size,
				isBlackFn,
				count + 1,
				A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix)));
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return 1 === (1 & (bits_ >> count));
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		return (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) ? helper(
			d_ ^ function (a) {
				return g18Int << a;
			}(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit)) : (d_ | (version << 12));
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		if (count < 18) {
			var topRight = _Utils_Tuple2(
				$elm$core$Basics$floor(count / 3),
				((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
			var isBlack = isBlackFn(count);
			var bottomLeft = _Utils_Tuple2(
				((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
				$elm$core$Basics$floor(count / 3));
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlackFn,
				count + 1,
				A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix)));
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return 1 === (1 & (bits_ >> count));
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return function (a) {
			return A3(
				$elm$core$List$foldl,
				function (b) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
				},
				a,
				range);
		}(
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.d1;
	var groupInfo = _v0.a.ah;
	var bytes = _v0.b;
	var version = groupInfo.dx;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		return _Utils_ap(
			bytes,
			((!A2($elm$core$Basics$modBy, 2, fillerLength)) ? $elm$core$Basics$identity : function (a) {
				return _Utils_ap(
					a,
					_List_fromArray(
						[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte]));
			})(
				$elm$core$List$concat(
					A2(
						$elm$core$List$repeat,
						(fillerLength / 2) | 0,
						_List_fromArray(
							[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			function (a) {
				return A2($elm$core$List$cons, a, _List_Nil);
			}(
				function (b) {
					return _Utils_Tuple2(0, b);
				}(
					A2($elm$core$Basics$min, 4, capacity - bitsCount))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	var _v1 = _v0.a;
	var bits = _v1.a;
	var length = _v1.b;
	var bytes = _v0.b;
	if (length >= 8) {
		var remLength = length - 8;
		var remBits = bits & function (a) {
			return a - 1;
		}(1 << remLength);
		var _byte = bits >> remLength;
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes)));
	} else {
		return _Utils_Tuple2(
			_Utils_Tuple2(bits, length),
			bytes);
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		var _v1 = _v0.a;
		var remBits = _v1.a;
		var remLength = _v1.b;
		var bytes = _v0.b;
		if (bits.b) {
			var head = bits.a;
			var tail = bits.b;
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
				tail,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes)));
		} else {
			return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
				function (a) {
					return A2($elm$core$List$cons, a, bytes);
				}(remBits << (8 - remLength)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.ah;
		var inputStr = _v0.c$;
		var mode = _v0.bw;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.dx);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return function (b) {
		return _Utils_Tuple2(model, b);
	}(
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.ah.bZ,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.ah.bZ,
					model.cF,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.bw),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return function (b) {
		return _Utils_Tuple2(model, b);
	}(
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $pablohirafuji$elm_qrcode$QRCode$Helpers$breaker = F3(
	function (width, string, acc) {
		breaker:
		while (true) {
			if (string === '') {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$string = A2($elm$core$String$dropLeft, width, string),
					$temp$acc = A2(
					$elm$core$List$cons,
					A3($elm$core$String$slice, 0, width, string),
					acc);
				width = $temp$width;
				string = $temp$string;
				acc = $temp$acc;
				continue breaker;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$breakStr = F2(
	function (width, string) {
		return ((!width) || (string === '')) ? _List_fromArray(
			[string]) : A3($pablohirafuji$elm_qrcode$QRCode$Helpers$breaker, width, string, _List_Nil);
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (str) {
	var _v0 = $elm$core$String$toList(str);
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					var firstChar = _v0.a;
					var _v1 = _v0.b;
					var secondChar = _v1.a;
					return A2(
						$elm$core$Result$map,
						function (a) {
							return _Utils_Tuple2(a, 11);
						},
						A2(
							$elm$core$Result$map,
							function (_v2) {
								var first = _v2.a;
								var second = _v2.b;
								return (first * 45) + second;
							},
							A2(
								$elm$core$Result$andThen,
								function (firstCode) {
									return A2(
										$elm$core$Result$map,
										function (b) {
											return _Utils_Tuple2(firstCode, b);
										},
										$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
								},
								$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar))));
				} else {
					break _v0$2;
				}
			} else {
				var _char = _v0.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
		$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
		_List_Nil,
		A2($pablohirafuji$elm_qrcode$QRCode$Helpers$breakStr, 2, str));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encodeHelp = F2(
	function (str, bytes) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var strTail = _v1.b;
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encodeHelp,
				strTail,
				function (a) {
					return A2($elm$core$List$cons, a, bytes);
				}(
					$elm$core$Char$toCode(_char)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(bytes));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return A2(
		$elm$core$Result$map,
		$elm$core$List$map(
			function (a) {
				return _Utils_Tuple2(a, 8);
			}),
		A2($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encodeHelp, str, _List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (str) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
		$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
		_List_Nil,
		A2($pablohirafuji$elm_qrcode$QRCode$Helpers$breakStr, 3, str));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63 = $elm$core$Bitwise$and(63);
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp = F2(
	function (str, list) {
		var _v2 = $elm$core$String$uncons(str);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var _char = _v3.a;
			var strTail = _v3.b;
			return A3(
				$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$utf8ToByte,
				list,
				strTail,
				$elm$core$Char$toCode(_char));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(list));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$utf8ToByte = F3(
	function (list, remainStr, charCode) {
		if (charCode < 128) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp,
				remainStr,
				A2($elm$core$List$cons, charCode, list));
		} else {
			if (charCode < 2048) {
				return A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp,
					remainStr,
					A2(
						$elm$core$List$cons,
						128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charCode),
						A2($elm$core$List$cons, 192 | (charCode >> 6), list)));
			} else {
				if ((charCode < 55296) || (charCode >= 57344)) {
					return A2(
						$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp,
						remainStr,
						A2(
							$elm$core$List$cons,
							128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charCode),
							A2(
								$elm$core$List$cons,
								128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charCode >> 6),
								A2($elm$core$List$cons, 224 | (charCode >> 12), list))));
				} else {
					var _v0 = $elm$core$String$uncons(remainStr);
					if (!_v0.$) {
						var _v1 = _v0.a;
						var _char = _v1.a;
						var strTail = _v1.b;
						var nextCharCode = $elm$core$Char$toCode(_char);
						var charC = 65536 + ((1023 & nextCharCode) | ((1023 & charCode) << 10));
						var byte4 = 128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charC);
						var byte3 = 128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charC >> 6);
						var byte2 = 128 | $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$and63(charC >> 12);
						var byte1 = 240 | (charC >> 18);
						return A2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp,
							strTail,
							A2(
								$elm$core$List$cons,
								byte4,
								A2(
									$elm$core$List$cons,
									byte3,
									A2(
										$elm$core$List$cons,
										byte2,
										A2($elm$core$List$cons, byte1, list)))));
					} else {
						return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char);
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	return A2(
		$elm$core$Result$map,
		$elm$core$List$map(
			function (a) {
				return _Utils_Tuple2(a, 8);
			}),
		A2($pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encodeHelp, str, _List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			return (_Utils_cmp(count, ecLength) < 0) ? A2(
				generate,
				count + 1,
				A2(
					$elm$core$Result$andThen,
					function (a) {
						return A2(
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
							a,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
								_List_fromArray(
									[
										1,
										$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
									]),
								0));
					},
					polyResult)) : polyResult;
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, rsPoly);
			}(
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1)));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.ah.f_, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{fA: false, gO: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{fA: false, gO: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{fA: false, gO: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.dx;
		var capacity = _v0.bZ;
		return function (length) {
			return _Utils_cmp(length, capacity) < 1;
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength);
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			bZ: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			f_: ecPerBlock,
			eg: group1,
			gJ: maybeGroup2,
			dx: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.bZ;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			cF: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.dx),
			d1: ecLevel,
			ah: groupInfo,
			c$: inputStr,
			bw: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		var times = _v0.a;
		var itemCount = _v0.b;
		var byteList = _v1.a;
		var progress = _v1.b;
		if (times > 0) {
			var remainList = A2($elm$core$List$drop, itemCount, byteList);
			var block = A2($elm$core$List$take, itemCount, byteList);
			return A3(
				$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
				checkFinish,
				_Utils_Tuple2(times - 1, itemCount),
				_Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress)));
		} else {
			if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
				return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
			} else {
				return $elm$core$Result$Ok(
					_Utils_Tuple2(byteList, progress));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.ah;
	var byteList = _v0.b;
	var _v1 = groupInfo.gJ;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.eg,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.eg,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$encodeWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$map,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Matrix$apply,
					A2(
						$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
						input,
						$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$encode = $pablohirafuji$elm_qrcode$QRCode$encodeWith(2);
var $author$project$Data$AppCenter$AppCenterInfo = F2(
	function (orgId, appId) {
		return {dB: appId, eC: orgId};
	});
var $author$project$Data$AppCenter$lookup = function (meta) {
	var olmOrg = 'olmobileleads-l4sg';
	var _v0 = _Utils_Tuple2(meta.fr, meta.g6);
	_v0$8:
	while (true) {
		if (!_v0.a.$) {
			switch (_v0.b) {
				case 'iOS':
					switch (_v0.a.a) {
						case 'com.microsoft.Office.Outlook':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook'));
						case 'com.microsoft.Office.Outlook-dev':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.dev'));
						case 'com.microsoft.Office.Outlook-stage':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.stage'));
						case 'com.microsoft.Office.Outlook-dogfood':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.dogfood'));
						default:
							break _v0$8;
					}
				case 'android':
					switch (_v0.a.a) {
						case 'com.microsoft.Office.Outlook':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook-01'));
						case 'com.microsoft.Office.Outlook-dev':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.dev-01'));
						case 'com.microsoft.Office.Outlook-stage':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.stage-01'));
						case 'com.microsoft.Office.Outlook-dogfood':
							return $elm$core$Maybe$Just(
								A2($author$project$Data$AppCenter$AppCenterInfo, olmOrg, 'Outlook.dogfood-01'));
						default:
							break _v0$8;
					}
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Data$AppCenter$searchCrashesLink = F2(
	function (_v0, incidentId) {
		var orgId = _v0.eC;
		var appId = _v0.dB;
		return 'https://appcenter.ms/orgs/' + (orgId + ('/apps/' + (appId + ('/crashes/search?searchType=unhandlederror&q=' + $author$project$UUID$toString(incidentId)))));
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$rectView = F2(
	function (row, col) {
		return A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromInt(row * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)),
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromInt(col * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)),
					$elm$svg$Svg$Attributes$fill('black')
				]),
			_List_Nil);
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleView = F4(
	function (quietZoneSize, rowIndex, colIndex, isDark) {
		return isDark ? $elm$core$Maybe$Just(
			A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$rectView, rowIndex + quietZoneSize, colIndex + quietZoneSize)) : $elm$core$Maybe$Nothing;
	});
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F2(
	function (quietZoneSize, matrix) {
		var quietZone = (2 * quietZoneSize) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
		var sizePx = $elm$core$String$fromInt(
			($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + quietZone);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(sizePx),
					$elm$svg$Svg$Attributes$height(sizePx),
					$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
					$elm$svg$Svg$Attributes$shapeRendering('crispEdges')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				$elm$core$List$concat(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (rowIndex, row) {
								return A2(
									$elm$core$List$indexedMap,
									A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleView, quietZoneSize, rowIndex),
									row);
							}),
						matrix))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewWithoutQuietZone = function (matrix) {
	return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase, 0, matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone = function (_v0) {
	var qrCode = _v0;
	return $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewWithoutQuietZone(qrCode);
};
var $author$project$Page$Incident$viewClassifications = function (classifications) {
	var listItem = function (classification) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-xs btn-primary'),
							A2($elm$html$Html$Attributes$style, 'color', 'white'),
							$elm$html$Html$Attributes$type_('button'),
							$author$project$App$Route$href(
							$author$project$App$Route$EditClassifier(classification.bj))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(classification.eo)
						]))
				]));
	};
	return $elm$core$List$isEmpty(classifications) ? $elm$html$Html$text('None') : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-inline')
			]),
		A2($elm$core$List$map, listItem, classifications));
};
var $author$project$Page$Incident$viewIssue = function (issue) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Helpshift Ticket: ')
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Data$Issue$helpshiftUrl(issue))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'#' + $elm$core$String$fromInt(issue.bj))
					]))
			]));
};
var $author$project$Page$Incident$viewPrescribedRemedy = function (remedy) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn btn-xs btn-primary'),
				A2($elm$html$Html$Attributes$style, 'color', 'white'),
				$elm$html$Html$Attributes$type_('button'),
				$author$project$App$Route$href(
				A2($author$project$App$Route$ViewRemedy, remedy.bj, remedy.dx))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(remedy.bO)
			]));
};
var $author$project$Page$Incident$viewExtrasTab = function (model) {
	var _v0 = model.z;
	var incident = _v0.gj;
	var tree = _v0.ac;
	var formattedPrescriptionLog = A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (line) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(line)
						]));
			},
			incident.f8));
	var _v1 = incident;
	var analyzedIncident = _v1.fp;
	var issue = _v1.gt;
	var _v2 = analyzedIncident;
	var meta = _v2.er;
	var analysis = _v2.dA;
	var viewAppCenter = function (appInfo) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('AppCenter ')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							A2($author$project$Data$AppCenter$searchCrashesLink, appInfo, meta.bj))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search for linked crash in AppCenter')
						]))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Misc PowerLift Stuff')
					])),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Classifications')
					])),
				$author$project$Page$Incident$viewClassifications(analysis.dL),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Remedy')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text('None'),
						A2($elm$core$Maybe$map, $author$project$Page$Incident$viewPrescribedRemedy, analysis.hd))
					])),
				formattedPrescriptionLog,
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				A2($author$project$Util$Html$viewMaybe, $author$project$Page$Incident$viewIssue, issue),
				A2(
				$author$project$Util$Html$viewMaybe,
				viewAppCenter,
				$author$project$Data$AppCenter$lookup(meta)),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				function () {
				var _v3 = model.a8;
				if (!_v3.$) {
					var url = _v3.a;
					return A2(
						$elm$core$Result$withDefault,
						$elm$html$Html$text('failed to generate QR code'),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone,
							$pablohirafuji$elm_qrcode$QRCode$encode(url)));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Page$Incident$viewConfigurationInformation = function (files) {
	var anyFancy = A2(
		$elm$core$List$any,
		function ($) {
			return $.fY;
		},
		files);
	return (!anyFancy) ? A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$App$Route$href($author$project$App$Route$ListLogConfigs),
				$elm$html$Html$Attributes$target('_blank')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enable enhanced log file viewer')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Page$Incident$viewFilesRow = F2(
	function (aliasAccessId, meta) {
		var showFancyViewer = meta.fY ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$App$Route$href(
					A2($author$project$App$Route$ViewLogFile, meta.cZ, meta.f5)),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$class('trackedLink')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(' (Fancy viewer)')
				])) : $elm$html$Html$text('');
		var metaUrl = meta.hQ + '/gymAid';
		var classifications = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.eo;
				},
				meta.dL));
		var cellStyle = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')
			]);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					cellStyle,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(metaUrl),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$class('trackedLink')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(meta.ev)
								])),
							$elm$html$Html$text(' '),
							showFancyViewer
						])),
					A2(
					$elm$html$Html$td,
					cellStyle,
					_List_fromArray(
						[
							function () {
							var _v0 = meta.dU;
							if (!_v0.$) {
								var dataBoundary = _v0.a;
								return $elm$html$Html$text(dataBoundary);
							} else {
								return $elm$html$Html$text('WW');
							}
						}()
						])),
					A2(
					$elm$html$Html$td,
					_Utils_ap(
						cellStyle,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$title(classifications)
							])),
					_List_fromArray(
						[
							$elm$html$Html$text(classifications)
						])),
					A2(
					$elm$html$Html$td,
					cellStyle,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(meta.dT))
						])),
					A2(
					$elm$html$Html$td,
					_Utils_ap(
						cellStyle,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-right')
							])),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Util$Numbers$prettyByteCount,
								{fW: 0},
								meta.e$))
						]))
				]));
	});
var $author$project$Page$Incident$viewFilesTable = F2(
	function (files, aliasAccessId) {
		var header = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '45%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '10%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Data Boundary')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '15%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Classifications')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '20%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Created At')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '10%'),
							$elm$html$Html$Attributes$class('text-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Size')
						]))
				]));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered'),
					A2($elm$html$Html$Attributes$style, 'table-layout', 'fixed'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[header])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Page$Incident$viewFilesRow(aliasAccessId),
						files))
				]));
	});
var $author$project$Page$Incident$viewFiles = F3(
	function (aliasAccessId, files, incident) {
		var downloadZipUrl = '/gym/incidents/' + ($author$project$UUID$toString(incident.bj) + ('/gymAid' + '/files.zip'));
		var _v0 = A2($author$project$Page$Incident$partitionFiles, files, incident.bj);
		var incidentFiles = _v0.cY;
		var otherFiles = _v0.eE;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Files for This Incident'),
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(downloadZipUrl)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Download files (.zip)')
										]))
								]))
						])),
					A2($author$project$Page$Incident$viewFilesTable, incidentFiles, aliasAccessId),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Other Files for This Install')
						])),
					A2($author$project$Page$Incident$viewFilesTable, otherFiles, aliasAccessId),
					$author$project$Page$Incident$viewConfigurationInformation(files)
				]));
	});
var $author$project$View$IncidentTable$viewClassifications = function (analysis) {
	return $elm$html$Html$text(
		A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.eo;
				},
				analysis.dL)));
};
var $author$project$View$IncidentTable$viewIncidentLink = function (meta) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$App$Route$href(
				$author$project$App$Route$viewIncident(meta.bj)),
				$elm$html$Html$Attributes$class('trackedLink')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$UUID$toString(meta.bj))
			]));
};
var $author$project$View$IncidentTable$viewIssue = function (issueBrief) {
	return $elm$html$Html$text(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bO;
				},
				issueBrief)));
};
var $author$project$View$IncidentTable$viewRowLite = F3(
	function (selectedIncidentId, _v0, searchResult) {
		var _v1 = searchResult;
		var incident = _v1.gj;
		var issueBrief = _v1.gu;
		var rowAttr = _Utils_eq(selectedIncidentId, incident.er.bj) ? $elm$html$Html$Attributes$class('info') : $elm$html$Html$Attributes$class('');
		var _v2 = incident;
		var meta = _v2.er;
		var analysis = _v2.dA;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[rowAttr]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(meta.dT))
						])),
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$IncidentTable$viewIncidentLink(meta)
						])),
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(meta.fL)
						])),
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$IncidentTable$viewClassifications(analysis)
						])),
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$IncidentTable$viewIssue(issueBrief)
						]))
				]));
	});
var $author$project$View$IncidentTable$viewLite = F2(
	function (selectedIncidentId, searchResults) {
		return A3(
			$author$project$Util$Bootstrap$fixedWidthTable,
			_List_fromArray(
				[
					_Utils_Tuple2('Date', 17),
					_Utils_Tuple2('ID', 10),
					_Utils_Tuple2('Version', 6),
					_Utils_Tuple2('Classifications', 40),
					_Utils_Tuple2('Issue', 27)
				]),
			$author$project$View$IncidentTable$viewRowLite(selectedIncidentId),
			searchResults);
	});
var $author$project$Page$Incident$viewOtherIncidents = function (_v0) {
	var analyzedIncident = _v0.fp;
	var otherIncidents = _v0.g3;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Other Incidents for Install ID: ' + analyzedIncident.er.ce)
					])),
				A2($author$project$View$IncidentTable$viewLite, analyzedIncident.er.bj, otherIncidents),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Currently selected incident is highlighted in blue.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Incidents are purged after 30 days. This list excludes purged incidents.')
					]))
			]));
};
var $author$project$Page$Incident$viewTabContent = F2(
	function (model, tab) {
		var _v0 = model.z.gj;
		var analyzedIncident = _v0.fp;
		var logMetas = _v0.ep;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				switch (tab.$) {
					case 1:
						var subSection = tab.a;
						return _List_fromArray(
							[
								$author$project$Util$Bootstrap$fluidContainer(
								_List_fromArray(
									[
										A2($author$project$Page$Incident$viewDiagnostics, model, subSection)
									]))
							]);
					case 0:
						return _List_fromArray(
							[
								$author$project$Util$Bootstrap$fluidContainer(
								_List_fromArray(
									[
										A3($author$project$Page$Incident$viewFiles, model.bV, logMetas, analyzedIncident.er)
									]))
							]);
					case 2:
						return _List_fromArray(
							[
								$author$project$Util$Bootstrap$fluidContainer(
								_List_fromArray(
									[
										$author$project$Page$Incident$viewExtrasTab(model)
									]))
							]);
					default:
						return _List_fromArray(
							[
								$author$project$Util$Bootstrap$fluidContainer(
								_List_fromArray(
									[
										$author$project$Page$Incident$viewOtherIncidents(model.z.gj)
									]))
							]);
				}
			}());
	});
var $author$project$Page$Incident$viewMainPane = function (model) {
	var showEditor = model.N && (!$author$project$Page$Classifier$Editor$isDrillEmpty(model.M));
	var editorHeight = '410px';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-bottom', editorHeight)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Page$Incident$viewTabContent,
				model,
				$author$project$SelectList$selected(model.aw)),
				showEditor ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'height', editorHeight),
						A2($elm$html$Html$Attributes$style, 'transition', 'height 0.25s'),
						A2($elm$html$Html$Attributes$style, 'bottom', '0'),
						A2($elm$html$Html$Attributes$style, 'left', '0'),
						A2($elm$html$Html$Attributes$style, 'right', '0'),
						A2($elm$html$Html$Attributes$style, 'padding-top', '10px'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-page-bg-color)'),
						A2($elm$html$Html$Attributes$style, 'border-top', '1px solid #777'),
						A2($elm$html$Html$Attributes$style, 'z-index', '5'),
						A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
						A2(
						$elm$html$Html$Attributes$map,
						$author$project$Page$Incident$EditorScrolled,
						A2(
							$elm$html$Html$Events$stopPropagationOn,
							'scroll',
							A2(
								$elm$json$Json$Decode$map,
								function (pos) {
									return _Utils_Tuple2(pos, true);
								},
								$author$project$Page$Incident$scrollPosDecoder)))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Page$Incident$EditorMsg,
						$author$project$Page$Classifier$Editor$view(model.M).bX)
					])) : $elm$html$Html$text('')
			]));
};
var $author$project$Util$Navs$viewTabs = F2(
	function (extraAttribs, config) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('nav nav-tabs')
							]),
						extraAttribs),
					A2(
						$elm$core$List$map,
						$author$project$Util$Navs$itemView(config),
						config.R))
				]));
	});
var $author$project$Page$Incident$viewTabs = function (model) {
	var numOtherIncidents = $elm$core$List$length(model.z.gj.g3) - 1;
	return A2(
		$author$project$Util$Navs$viewTabs,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
			]),
		{
			R: $author$project$SelectList$toList(model.aw),
			eA: $author$project$Page$Incident$SelectTab,
			ho: $author$project$SelectList$selected(model.aw),
			hv: function (tab) {
				return _Utils_Tuple2(
					$author$project$Page$Incident$tabToString(tab),
					_Utils_eq(tab, $author$project$Page$Incident$OtherIncidents) ? $author$project$View$Badge$Exactly(numOtherIncidents) : $author$project$View$Badge$None);
			}
		});
};
var $author$project$Page$Incident$viewContent = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$Incident$viewTabs(model),
				$author$project$Page$Incident$viewMainPane(model)
			]));
};
var $author$project$Page$Incident$DismissErrors = {$: 6};
var $author$project$Page$Incident$viewErrors = function (model) {
	return $author$project$Util$Bootstrap$fluidContainer(
		_List_fromArray(
			[
				A2($author$project$View$Error$view, model.f$, $author$project$Page$Incident$DismissErrors)
			]));
};
var $author$project$Util$Date$formatDate = function (t) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
			]),
		$elm$time$Time$utc,
		t);
};
var $author$project$Page$Incident$viewPurgedIncident = function (comboIncident) {
	var formattedDate = A2(
		$elm$core$Maybe$withDefault,
		'(unknown)',
		A2($elm$core$Maybe$map, $author$project$Util$Date$formatDate, comboIncident.fp.er.eM));
	return $author$project$Util$Bootstrap$centeredContainer(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-default')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Incident Has Been Purged')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-body')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This incident was purged for GDPR compliance on '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(formattedDate)
									])),
								$elm$html$Html$text('. PowerLift retains incident data for a maximum of 30 days.')
							]))
					])),
				$author$project$Page$Incident$viewOtherIncidents(comboIncident)
			]));
};
var $author$project$Page$Incident$view = function (model) {
	var comboIncident = model.z.gj;
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Incident$viewErrors(model),
					$author$project$Data$Incident$isPurged(comboIncident.fp) ? $author$project$Page$Incident$viewPurgedIncident(comboIncident) : (model.aY ? $author$project$Util$Bootstrap$centeredContainer(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Incident Navigator')
								])),
							A2(
							$author$project$View$Incident$Navigator$view,
							model.y,
							{gP: $author$project$Page$Incident$NavigateTo, fa: $author$project$Page$Incident$SetNavigator})
						])) : $author$project$Page$Incident$viewContent(model))
				])),
		bO: 'Incident - ' + $author$project$UUID$toString(comboIncident.fp.er.bj)
	};
};
var $author$project$Page$Incident$List$DismissErrors = {$: 0};
var $elm_community$string_extra$String$Extra$pluralize = F3(
	function (singular, plural, count) {
		return (count === 1) ? ('1 ' + singular) : ($elm$core$String$fromInt(count) + (' ' + plural));
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$Util$Glyphs$svgIkonIcon = $elm$svg$Svg$svg(
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
		]));
var $author$project$Util$Glyphs$android = $author$project$Util$Glyphs$svgIkonIcon(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('\n        M15.647 47.493c0 2.164 1.709 3.926 3.812 3.926h2.752a3.804 3.804 0 0 0-.144\n        1.031v7.848c0 2.052 1.618 3.718 3.612 3.718 1.995 0 3.613-1.666\n        3.613-3.718V52.45c0-.358-.053-.704-.144-1.031h6.708a3.804 3.804 0 0 0-.144 1.031v7.848c0 2.052\n        1.618 3.718 3.612 3.718s3.613-1.666 3.613-3.718V52.45c0-.358-.053-.704-.145-1.031h2.752c2.104 0\n        3.812-1.761 3.812-3.926v-27.26h-33.71v27.26zm-6.021-27.26c-1.995 0-3.612 1.664-3.612\n        3.717v15.901c0 2.053 1.617 3.717 3.612 3.717 1.994 0 3.612-1.664\n        3.612-3.717v-15.9c0-2.054-1.618-3.718-3.612-3.718zm45.749 0c-1.995 0-3.611 1.664-3.611\n        3.717v15.901c0 2.053 1.616 3.717 3.611 3.717s3.611-1.664\n        3.611-3.717v-15.9c0-2.054-1.616-3.718-3.611-3.718zM40.789\n        5.355l.678-1.047.668-1.032L43.637.958a.633.633 0 0 0-.166-.859.592.592 0 0 0-.837.172l-1.608\n        2.485-.678 1.045-.686 1.059A19.325 19.325 0 0 0 32.5 3.505a19.33 19.33 0 0 0-7.16 1.354L24.655\n        3.8l-.676-1.045L22.367.27a.592.592 0 0 0-.836-.172.631.631 0 0 0-.166.859l1.5 2.318.669\n        1.032.678 1.047c-5.109 2.449-8.566 7.089-8.566\n        12.4h33.708c.001-5.31-3.456-9.95-8.565-12.399zm-15.511 7.444c-.998\n        0-1.806-.833-1.806-1.859s.808-1.857 1.806-1.857c.997 0 1.806.831 1.806 1.857s-.809 1.859-1.806\n        1.859zm14.447 0c-.998 0-1.806-.833-1.806-1.859s.808-1.857 1.806-1.857 1.805.831 1.805 1.857-.807\n        1.859-1.805 1.859z\n    ')
				]),
			_List_Nil)
		]));
var $author$project$Util$Glyphs$apple = $author$project$Util$Glyphs$svgIkonIcon(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('\n        M42.111 10.214c2.4-2.709 4.021-6.473 3.58-10.221-3.459.13-7.647 2.14-10.131 4.846-2.225\n        2.401-4.17 6.226-3.65 9.906 3.86.28 7.798-1.827 10.201-4.531zm8.66 23.794c-.086-8.109\n        7.104-11.997 7.427-12.193-4.041-5.499-10.337-6.254-12.576-6.34-5.354-.506-10.451 2.935-13.169\n        2.935-2.711 0-6.906-2.861-11.346-2.788-5.84.081-11.222 3.161-14.228 8.028-6.065 9.793-1.552\n        24.307 4.359 32.256 2.89 3.886 6.335 8.257 10.855 8.097 4.357-.16 6.002-2.622 11.267-2.622 5.269\n        0 6.746 2.622 11.354 2.541 4.685-.079 7.655-3.959 10.522-7.859 3.318-4.514 4.683-8.886\n        4.765-9.106-.105-.047-9.136-3.268-9.23-12.949z\n    ')
				]),
			_List_Nil)
		]));
var $author$project$Util$Bootstrap$classifierPill = F4(
	function (route, newTarget, displayText, hoverText) {
		return A7($author$project$Util$Bootstrap$linkPill, route, newTarget, displayText, hoverText, 'btn-subdued-neutral', _List_Nil, $elm$core$Maybe$Nothing);
	});
var $author$project$Page$Incident$List$viewRow = function (_v0) {
	var incident = _v0.gj;
	var issueBrief = _v0.gu;
	var issueText = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.bO;
			},
			issueBrief));
	var hasIssue = !$elm$core$String$isEmpty(issueText);
	var issue = hasIssue ? A2(
		$elm$html$Html$h5,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Ticket title'),
				A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-text-color)'),
				A2($elm$html$Html$Attributes$style, 'margin', '0')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(issueText)
			])) : $elm$html$Html$text('');
	var _v1 = incident;
	var meta = _v1.er;
	var analysis = _v1.dA;
	var classificationBadges = A2(
		$elm$core$List$map,
		function (c) {
			return A4(
				$author$project$Util$Bootstrap$classifierPill,
				$author$project$App$Route$ViewClassifier(c.bj),
				false,
				c.eo,
				'Assigned classification');
		},
		analysis.dL);
	var remedyBadge = function () {
		var _v4 = analysis.hd;
		if (!_v4.$) {
			var remedy = _v4.a;
			return A4(
				$author$project$Util$Bootstrap$remedyPill,
				A2($author$project$App$Route$ViewRemedy, remedy.bj, remedy.dx),
				false,
				remedy.bO,
				'Prescribed remedy');
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var dataBoundaryText = function () {
		var _v3 = meta.dU;
		if (!_v3.$) {
			var value = _v3.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Data Boundary')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var installId = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Install ID')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(meta.ce)
			]));
	var platformBadge = function () {
		var svg = function (glyph) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '16px'),
						A2($elm$html$Html$Attributes$style, 'height', '16px'),
						A2($elm$html$Html$Attributes$style, 'fill', '#F5F5F5')
					]),
				_List_fromArray(
					[glyph]));
		};
		var content = function () {
			var _v2 = $elm$core$String$toLower(meta.g6);
			switch (_v2) {
				case 'android':
					return svg($author$project$Util$Glyphs$android);
				case 'ios':
					return svg($author$project$Util$Glyphs$apple);
				default:
					return $elm$html$Html$text(meta.g6);
			}
		}();
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('badge pull-left'),
					A2($elm$html$Html$Attributes$style, 'padding', '4px 8px'),
					A2($elm$html$Html$Attributes$style, 'margin', '4px 8px 0 0'),
					$elm$html$Html$Attributes$title('Platform: ' + meta.g6)
				]),
			_List_fromArray(
				[content]));
	}();
	var timestamp = $elm$html$Html$text(
		$author$project$Util$Date$formatDateAndTime(meta.dT));
	var version = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Version')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(meta.fL)
			]));
	var details = A2(
		$elm$html$Html$h5,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin', '0 auto 0 0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$small,
				_List_Nil,
				_List_fromArray(
					[
						timestamp,
						$elm$html$Html$text(' '),
						dataBoundaryText,
						$elm$html$Html$text(' ('),
						version,
						$elm$html$Html$text(')')
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[platformBadge])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
						A2($elm$html$Html$Attributes$style, 'flex-grow', '1'),
						$author$project$App$Route$href(
						$author$project$App$Route$viewIncident(meta.bj))
					]),
				_List_fromArray(
					[issue, details])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap'),
						A2($elm$html$Html$Attributes$style, 'flex-grow', '1'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-end'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center')
					]),
				_Utils_ap(
					classificationBadges,
					_List_fromArray(
						[remedyBadge])))
			]));
};
var $author$project$Page$Incident$List$viewIncidents = function (model) {
	var errorText = model.aZ ? 'No incidents match this search' : 'No incidents have been uploaded yet';
	var count = $elm$core$List$length(model.aX);
	var topicDesc = model.am ? '\u00A0' : (model.aZ ? (A3($elm_community$string_extra$String$Extra$pluralize, 'incident', 'incidents', count) + ' matched the search') : ($elm$core$String$fromInt(count) + ' most recent'));
	var body = $elm$core$List$isEmpty(model.aX) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel-body')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(errorText)
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group')
			]),
		A2($elm$core$List$map, $author$project$Page$Incident$List$viewRow, model.aX));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-primary')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading clearfix')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pull-left'),
								A2($elm$html$Html$Attributes$style, 'margin', '4px 0 0 0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Incidents'),
								A2(
								$elm$html$Html$h5,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin', '0')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$small,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(topicDesc)
											]))
									]))
							]))
					])),
				body
			]));
};
var $author$project$Page$Incident$List$ChangeSearch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Incident$List$ClearEverything = {$: 7};
var $author$project$Page$Incident$List$SubmitSearch = {$: 5};
var $author$project$Page$Incident$List$ToggleSearchDropdown = {$: 2};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Util$Html$visibleIf = function (condition) {
	return condition ? A2($elm$html$Html$Attributes$style, 'visibility', 'visible') : A2($elm$html$Html$Attributes$style, 'visibility', 'hidden');
};
var $author$project$Page$Incident$List$viewSearchForm = function (model) {
	var tooltip = 'Search for an incident ID, easy ID, install ID, session ID, organization ID, or account ID';
	var searchButtons = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id($author$project$Page$Incident$List$searchDropdownId),
				$elm$html$Html$Attributes$class('input-group-btn'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('open', model.at)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$class('btn btn-default'),
						$elm$html$Html$Attributes$title(tooltip)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Submit')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('btn btn-default dropdown-toggle'),
						$elm$html$Html$Attributes$title('Advanced Search'),
						$elm$html$Html$Events$onClick($author$project$Page$Incident$List$ToggleSearchDropdown)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('caret')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$App$Route$href($author$project$App$Route$AdvancedSearch)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Advanced search')
									]))
							]))
					]))
			]));
	var inputField = A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control'),
				$elm$html$Html$Attributes$type_('text'),
				$elm$html$Html$Attributes$placeholder('Search'),
				$elm$html$Html$Attributes$title(tooltip),
				$elm$html$Html$Attributes$value(model.au),
				$elm$html$Html$Events$onInput($author$project$Page$Incident$List$ChangeSearch),
				A2($elm$html$Html$Attributes$style, 'width', '300px')
			]),
		_List_Nil);
	var clearButton = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pull-right'),
				A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-text-color-secondary)'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
				$author$project$Util$Html$role('button'),
				$author$project$Util$Html$visibleIf(model.aZ),
				$elm$html$Html$Events$onClick($author$project$Page$Incident$List$ClearEverything)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('glyphicon glyphicon-remove-sign'),
						A2($elm$html$Html$Attributes$style, 'top', '2px')
					]),
				_List_Nil),
				$elm$html$Html$text(' Clear search query and filters')
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('clearfix')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-inline pull-left'),
						$author$project$Util$Html$role('search'),
						$elm$html$Html$Events$onSubmit($author$project$Page$Incident$List$SubmitSearch),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
						A2($elm$html$Html$Attributes$style, 'width', '60%')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input-group')
									]),
								_List_fromArray(
									[inputField, searchButtons]))
							]))
					])),
				clearButton
			]));
};
var $author$project$View$ProgressBar$squareStyle = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'height', '8px'),
		A2($elm$html$Html$Attributes$style, 'margin', '-21px 0 12px'),
		A2($elm$html$Html$Attributes$style, 'border-radius', '0')
	]);
var $author$project$View$ProgressBar$viewSquare = $author$project$View$ProgressBar$viewInternal($author$project$View$ProgressBar$squareStyle);
var $author$project$View$ProgressBar$viewSquareIf = function (visible) {
	return visible ? $author$project$View$ProgressBar$viewSquare : $author$project$View$ProgressBar$emptyGap($author$project$View$ProgressBar$squareStyle);
};
var $author$project$Page$Incident$List$view = function (model) {
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$ProgressBar$viewSquareIf(model.am),
					$author$project$Util$Bootstrap$centeredContainer(
					_List_fromArray(
						[
							A2($author$project$View$Error$view, model.f$, $author$project$Page$Incident$List$DismissErrors),
							$author$project$Page$Incident$List$viewSearchForm(model),
							$author$project$Page$Incident$List$viewIncidents(model),
							$author$project$View$Docs$helpBox(1)
						]))
				])),
		bO: 'Incidents'
	};
};
var $author$project$Page$JoinTenantHelp$DismissErrors = 0;
var $author$project$Util$IDWeb$joinGroupUrl = function (groupName) {
	return 'http://idwebelements/GroupManagement.aspx?Operation=join&Group=' + $elm$url$Url$percentEncode(groupName);
};
var $author$project$Page$JoinTenantHelp$viewTenantJoinInfo = function (info) {
	var joinGroupLink = function (groupName) {
		var url = $author$project$Util$IDWeb$joinGroupUrl(groupName);
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(url),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(groupName)
				]));
	};
	var joinGroupLinkList = function (names) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (name) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								joinGroupLink(name)
							]));
				},
				names));
	};
	var groupNames = A2(
		$elm$core$List$map,
		function ($) {
			return $.ev;
		},
		info.gc);
	var joinInstructions = _List_fromArray(
		[
			$elm$html$Html$text('For access, join one of the following security groups ' + '(corpnet and Internet Explorer required):'),
			joinGroupLinkList(groupNames)
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This incident is owned by another tenant.')
							])),
						A2($elm$html$Html$p, _List_Nil, joinInstructions)
					]))
			]));
};
var $author$project$Page$JoinTenantHelp$view = function (_v0) {
	var tenantInfo = _v0.dt;
	var errors = _v0.f$;
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, errors, 0),
					$author$project$Page$JoinTenantHelp$viewTenantJoinInfo(tenantInfo)
				])),
		bO: 'Join Tenant'
	};
};
var $author$project$Page$LogFile$DismissErrors = {$: 0};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Page$LogFile$viewHeader = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-9')
					]),
				_List_fromArray(
					[
						$author$project$Util$Bootstrap$breadcrumbsCustom(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Incident',
								A2($author$project$App$Route$ViewIncident, model.cZ, $elm$core$Maybe$Nothing)),
								_Utils_Tuple2(
								'Files',
								A2(
									$author$project$App$Route$ViewIncident,
									model.cZ,
									$elm$core$Maybe$Just('files'))),
								_Utils_Tuple2(
								model.f6,
								A2($author$project$App$Route$ViewLogFile, model.cZ, ''))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-muted text-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Configuration: '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$App$Route$href(
										$author$project$App$Route$EditLogConfig(model.fM.bj)),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.fM.b6)
									]))
							]))
					]))
			]));
};
var $author$project$Page$LogFile$ResetFilters = {$: 1};
var $author$project$Page$LogFile$DeselectAllForPicker = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$LogFile$Picked = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$LogFile$SelectAllForPicker = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$LogFile$viewPicker = F2(
	function (idx, picker) {
		var viewItem = function (severity) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding-left', '8px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('checkbox')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Attributes$checked(
												A2($elm$core$Set$member, severity, picker.G)),
												$elm$html$Html$Events$onCheck(
												$elm$core$Basics$always(
													A2($author$project$Page$LogFile$Picked, idx, severity)))
											]),
										_List_Nil),
										$elm$html$Html$text(severity)
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					$author$project$Page$LogFile$pickerDomId(picker.be))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropup'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('open', picker.ai)
								]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$LogFile$ShowHidePicker(idx))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(picker.ev),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('caret'),
											A2($elm$html$Html$Attributes$style, 'margin-left', '10px')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-menu'),
									A2($elm$html$Html$Attributes$style, 'height', 'auto'),
									A2($elm$html$Html$Attributes$style, 'max-height', '600px'),
									A2($elm$html$Html$Attributes$style, 'overflow-x', 'hidden')
								]),
							A2($elm$core$List$map, viewItem, picker.bC))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '4px'),
							$author$project$Util$Html$visibleIf(picker.ai)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary btn-xs',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '48%'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$LogFile$SelectAllForPicker(idx))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('all')
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary btn-xs',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '48%'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$LogFile$DeselectAllForPicker(idx))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('none')
								]))
						]))
				]));
	});
var $author$project$Page$LogFile$AddQuery = {$: 3};
var $author$project$Page$LogFile$Or = 1;
var $author$project$Page$LogFile$RemoveQuery = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$LogFile$SetQueryCombiner = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$LogFile$SetQueryText = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$LogFile$combinerToString = function (c) {
	if (!c) {
		return 'AND';
	} else {
		return 'OR';
	}
};
var $author$project$Page$LogFile$viewQueryEditor = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Page$LogFile$AddQuery)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Search'),
										$elm$html$Html$Attributes$value(model.U),
										$elm$html$Html$Events$onInput($author$project$Page$LogFile$SetQueryText),
										$elm$html$Html$Attributes$class('form-control')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pull-right'),
								A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
								$author$project$Util$Html$visibleIf(
								$elm$core$List$length(model.de) > 1)
							]),
						_List_fromArray(
							[
								$author$project$Util$Html$dropdownAdvanced(
								{
									fS: model.aS,
									gw: $author$project$Page$LogFile$combinerToString,
									R: _List_fromArray(
										[0, 1]),
									eA: $author$project$Page$LogFile$SetQueryCombiner
								})
							]))
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-unstyled'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '10px')
					]),
				A2(
					$elm$core$List$map,
					function (q) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label label-primary')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(q)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-borderless btn-xs'),
											$elm$html$Html$Events$onClick(
											$author$project$Page$LogFile$RemoveQuery(q))
										]),
									_List_fromArray(
										[$author$project$Util$Glyphs$x]))
								]));
					},
					model.de))
			]));
};
var $author$project$Page$LogFile$viewRibbon = F2(
	function (model, height) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
					A2($elm$html$Html$Attributes$style, 'bottom', '0'),
					A2($elm$html$Html$Attributes$style, 'left', '0'),
					A2($elm$html$Html$Attributes$style, 'right', '0'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromInt(height) + 'px'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-page-bg-color-secondary)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
							A2($elm$html$Html$Attributes$style, 'padding', '10px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-inline')
								]),
							A2($elm$core$List$indexedMap, $author$project$Page$LogFile$viewPicker, model.T)),
							$author$project$Page$LogFile$viewQueryEditor(model),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-md btn-primary'),
									$elm$html$Html$Events$onClick($author$project$Page$LogFile$ResetFilters)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reset')
								]))
						]))
				]));
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Page$LogFile$multilineSplit = function (contentLine) {
	return A2(
		$elm$core$List$intersperse,
		A2($elm$html$Html$br, _List_Nil, _List_Nil),
		A2(
			$elm$core$List$map,
			$elm$html$Html$text,
			A2($elm$core$String$split, '<br>', contentLine)));
};
var $author$project$Page$LogFile$viewCell = F2(
	function (entry, isMessageBodyField) {
		var commonAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '4px 8px 4px 8px')
			]);
		return isMessageBodyField ? A2(
			$elm$html$Html$td,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$style, 'white-space', 'wrap'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'max-width', '1000px'),
					commonAttributes)),
			$author$project$Page$LogFile$multilineSplit(entry)) : A2(
			$elm$html$Html$td,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				commonAttributes),
			_List_fromArray(
				[
					$elm$html$Html$text(entry)
				]));
	});
var $author$project$Page$LogFile$viewRow = function (_v0) {
	var fields = _v0.cb;
	var hidden = _v0.bh;
	return (!hidden) ? A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$author$project$Data$LogFile$inferColor(fields))
			]),
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, field) {
					return A2(
						$author$project$Page$LogFile$viewCell,
						field,
						_Utils_eq(
							idx,
							$elm$core$List$length(fields) - 1));
				}),
			fields)) : $elm$html$Html$text('');
};
var $author$project$Page$LogFile$viewTableHeader = function (columnList) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (column) {
				return A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(column.ev)
						]));
			},
			columnList));
};
var $author$project$Page$LogFile$viewTable = F3(
	function (logEntries, columns, ribbonHeight) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table table-bordered table-condensed'),
					A2(
					$elm$html$Html$Attributes$style,
					'margin-bottom',
					$elm$core$String$fromInt(ribbonHeight) + 'px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '14px')
						]),
					_List_fromArray(
						[
							$author$project$Page$LogFile$viewTableHeader(columns)
						])),
					A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '12px')
						]),
					A2($elm$core$List$map, $author$project$Page$LogFile$viewRow, logEntries))
				]));
	});
var $author$project$Page$LogFile$view = function (model) {
	var ribbonHeight = A2(
		$elm$core$Basics$max,
		90,
		$elm$core$List$length(model.de) * 30);
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$fluidContainer(
					_List_fromArray(
						[
							$author$project$Page$LogFile$viewHeader(model),
							A2($author$project$View$Error$view, model.f$, $author$project$Page$LogFile$DismissErrors),
							A2($author$project$Page$LogFile$viewRibbon, model, ribbonHeight),
							$elm$core$List$isEmpty(model.aN) ? $author$project$View$EmptyStates$view('No log messages') : A4($elm$html$Html$Lazy$lazy3, $author$project$Page$LogFile$viewTable, model.aN, model.fM.b0, ribbonHeight)
						]))
				])),
		bO: 'Log File - ' + model.f6
	};
};
var $author$project$Page$News$DismissErrors = 0;
var $author$project$Page$News$viewDate = function (date) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin', '20px 0 0 0'),
				A2($elm$html$Html$Attributes$style, 'color', '#777')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Util$Date$formatDate(date))
			]));
};
var $author$project$Page$News$viewHeadline = F2(
	function (title, isNew) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '22px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					$elm$html$Html$text(' '),
					isNew ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'background-color', $author$project$Util$Bootstrap$powerliftYellow),
							A2($elm$html$Html$Attributes$style, 'color', '#ff7700'),
							A2($elm$html$Html$Attributes$style, 'padding', '4px 8px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('New')
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$News$viewNewsItem = F2(
	function (lastReadDate, _v0) {
		var date = _v0.fT;
		var title = _v0.bO;
		var details = _v0.fX;
		var isNew = _Utils_cmp(
			$elm$time$Time$posixToMillis(date),
			$elm$time$Time$posixToMillis(lastReadDate)) > 0;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding-top', '10px'),
					A2($elm$html$Html$Attributes$style, 'padding-bottom', '30px'),
					A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #ddd')
				]),
			_List_fromArray(
				[
					$author$project$Page$News$viewDate(date),
					A2($author$project$Page$News$viewHeadline, title, isNew),
					A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, details)
				]));
	});
var $author$project$Page$News$viewContent = function (_v0) {
	var newsItems = _v0.c8;
	var lastReadDate = _v0.c2;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Latest News')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-unstyled')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Page$News$viewNewsItem(lastReadDate),
					newsItems))
			]));
};
var $author$project$Page$News$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, 0),
					$author$project$Page$News$viewContent(model)
				])),
		bO: 'News'
	};
};
var $author$project$Page$Onboarding$DismissErrors = {$: 0};
var $author$project$Page$Onboarding$FinalStep = {$: 4};
var $author$project$Page$Onboarding$SetStep = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Onboarding$viewCreateTenantInstructions = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('If your team is not yet using PowerLift')
				])),
			A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, '\nGetting your team signed up with PowerLift is free and easy.\n\n1. **Create 2 security groups** in IDWeb for PowerLift: one for full access to PowerLift and one for read-only access.\n2. **Email** the names of the new security groups to [powerlifters@microsoft.com](mailto:powerlifters@microsoft.com)\n3. We will get you setup in less than 24 hours.\n4. While you wait, **add the rest of your team to the security groups** that you created.\n'),
			A2($elm$html$Html$hr, _List_Nil, _List_Nil),
			A3(
			$author$project$Util$Bootstrap$button,
			'btn-default',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Page$Onboarding$SetStep($author$project$Page$Onboarding$FinalStep))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Final Steps')
				]))
		]));
var $author$project$Page$Onboarding$viewFinalWrapup = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Final Steps')
				])),
			A2(
			$elm$html$Html$ol,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Download the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href($author$project$App$Route$ViewSDKs)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('PowerLift SDK')
								])),
							$elm$html$Html$text(' for your platform')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Start building up your app diagnostics')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create incident widgets to surface your app\'s most important info')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create a classifier')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create a remedy')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Questions? Email us at '),
					$author$project$Util$Html$mailto('powerlifters@microsoft.com'),
					$elm$html$Html$text(' for help/guidance/etc.')
				]))
		]));
var $elm$html$Html$em = _VirtualDom_node('em');
var $author$project$Page$Onboarding$viewJoinSecurityGroup = function (group) {
	var url = $author$project$Util$IDWeb$joinGroupUrl(group.ev);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 1')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Open this link to join \'' + (group.ev + '\' in IDWeb'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('well')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(url)
							]))
					])),
				A2(
				$elm$html$Html$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('NOTE: IDWeb requires IE/Edge and corpnet')
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2')
					])),
				A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, '\nAfter joining the tenant\'s security group via IDWeb:\n1. Wait a few minutes (IDWeb/AAD sync is sometimes quite slow)\n2. Then \'log out\' of PowerLift using the dropdown in the **upper-right hand corner**\n')
			]));
};
var $author$project$Page$Onboarding$JoinSecurityGroupStep = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Onboarding$viewSecurityGroups = function (securityGroups) {
	var makeRow = function (group) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(group.ev)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							group.fz ? 'View & Create' : 'View')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$Onboarding$SetStep(
										$author$project$Page$Onboarding$JoinSecurityGroupStep(group)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Join...')
								]))
						]))
				]));
	};
	var header = A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Security Group')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Access Level')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Join a security group')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-default')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[header])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2($elm$core$List$map, makeRow, securityGroups))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('well')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Access Level')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\'View\' allows you to view incidents and log files')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\'Create\' allows you to save new classifiers & remedies as well as customize PowerLift for your team.')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Onboarding$CreateNewTenantStep = {$: 3};
var $author$project$Page$Onboarding$UserSelectedTenant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Onboarding$viewSignUp = F2(
	function (model, currentlySelectedTenant) {
		var tenantDropdown = $author$project$Util$Html$dropdownAdvanced(
			{
				fS: currentlySelectedTenant,
				gw: A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						function ($) {
							return $.ev;
						}),
					$elm$core$Maybe$withDefault('Choose Team...')),
				R: A2(
					$elm$core$List$cons,
					$elm$core$Maybe$Nothing,
					A2($elm$core$List$map, $elm$core$Maybe$Just, model.cE)),
				eA: $author$project$Page$Onboarding$UserSelectedTenant
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Is your team already using PowerLift?')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Join your team\'s PowerLift security group to get access:')
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					tenantDropdown,
					A2(
					$elm$html$Html$em,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' -or- ')
						])),
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-default',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Onboarding$SetStep($author$project$Page$Onboarding$CreateNewTenantStep))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('My team is not in the list')
						]))
				]));
	});
var $author$project$Page$Onboarding$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[$author$project$App$Route$Home, $author$project$App$Route$Onboarding])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Onboarding$DismissErrors),
					function () {
					var _v0 = model.a$;
					switch (_v0.$) {
						case 0:
							var currentSelection = _v0.a;
							return A2($author$project$Page$Onboarding$viewSignUp, model, currentSelection);
						case 1:
							var tenant = _v0.a;
							return $author$project$Page$Onboarding$viewSecurityGroups(tenant.hm);
						case 2:
							var group = _v0.a;
							return $author$project$Page$Onboarding$viewJoinSecurityGroup(group);
						case 3:
							return $author$project$Page$Onboarding$viewCreateTenantInstructions;
						default:
							return $author$project$Page$Onboarding$viewFinalWrapup;
					}
				}()
				])),
		bO: 'Onboarding'
	};
};
var $author$project$Page$Remedy$Editor$DismissErrors = {$: 11};
var $author$project$Page$Remedy$Editor$Save = {$: 7};
var $author$project$Page$Remedy$Editor$ShowPreviewDialog = {$: 12};
var $author$project$Page$Remedy$Editor$SelectTab = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Remedy$Editor$EditorTab = 1;
var $author$project$Page$Remedy$Editor$TranslationTab = 2;
var $author$project$Page$Remedy$Editor$allTabs = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Remedy$Editor$navConfig = function (model) {
	var tabTitle = function (tab) {
		switch (tab) {
			case 0:
				return 'Meta';
			case 1:
				return 'Content';
			default:
				return 'Translation';
		}
	};
	return {
		R: $author$project$Page$Remedy$Editor$allTabs,
		eA: $author$project$Page$Remedy$Editor$SelectTab,
		ho: model.a9,
		hv: A2(
			$elm$core$Basics$composeR,
			tabTitle,
			function (title) {
				return _Utils_Tuple2(title, $author$project$View$Badge$None);
			})
	};
};
var $author$project$Remedy$Editor$Form$activeScreen = function (_v0) {
	var form = _v0;
	return form.n;
};
var $author$project$Remedy$Editor$Problem$problemsByElementIndex = function (problems) {
	var groupByIndex = A2(
		$elm$core$List$foldl,
		F2(
			function (_v1, acc) {
				var idx = _v1.a;
				var problem = _v1.b;
				return A3($author$project$Util$Dict$collect, idx, problem, acc);
			}),
		$elm$core$Dict$empty);
	var assocByIndex = function (problem) {
		if (!problem.$) {
			var idx = problem.a;
			var prob = problem.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(idx, prob));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return groupByIndex(
		A2($elm$core$List$filterMap, assocByIndex, problems));
};
var $turboMaCk$any_dict$Dict$Any$update = F3(
	function (k, f, _v0) {
		var inner = _v0;
		var updateDict = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$map(
					function (b) {
						return _Utils_Tuple2(k, b);
					}),
				f),
			$elm$core$Maybe$map($elm$core$Tuple$second));
		return _Utils_update(
			inner,
			{
				e: A3(
					$elm$core$Dict$update,
					inner.W(k),
					updateDict,
					inner.e)
			});
	});
var $author$project$Util$AnyDict$collect = F3(
	function (key, value, dict) {
		var merge = function (maybeValues) {
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					value,
					A2($elm$core$Maybe$withDefault, _List_Nil, maybeValues)));
		};
		return A3($turboMaCk$any_dict$Dict$Any$update, key, merge, dict);
	});
var $author$project$Remedy$Editor$Problem$problemsByScreenId = function (problems) {
	var groupById = A2(
		$elm$core$List$foldl,
		F2(
			function (_v2, acc) {
				var screenId = _v2.a;
				var problem = _v2.b;
				return A3($author$project$Util$AnyDict$collect, screenId, problem, acc);
			}),
		$turboMaCk$any_dict$Dict$Any$empty($author$project$Remedy$ScreenId$toString));
	var assocById = function (problem) {
		if ((!problem.$) && (!problem.a.$)) {
			var _v1 = problem.a;
			var screenId = _v1.a;
			var prob = _v1.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(screenId, prob));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return groupById(
		A2($elm$core$List$filterMap, assocById, problems));
};
var $author$project$Page$Remedy$Editor$newEditorContext = function (model) {
	var form = model.d;
	var customCapabilities = model.aF;
	var allProblems = function () {
		var _v0 = A2($author$project$Page$Remedy$Editor$validate, 1, model);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			var errors = _v0.a;
			return errors;
		}
	}();
	var screenProblems = $author$project$Remedy$Editor$Problem$problemsByScreenId(allProblems);
	var activeScreenId = $author$project$Remedy$Editor$Form$activeScreen(form).bj;
	return {
		bU: activeScreenId,
		aF: customCapabilities,
		cL: $author$project$Remedy$Editor$Problem$problemsByElementIndex(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($turboMaCk$any_dict$Dict$Any$get, activeScreenId, screenProblems))),
		cO: $author$project$Remedy$Editor$Form$activeScreen(form).f7,
		di: screenProblems,
		as: $author$project$Remedy$Editor$Form$screenStubs(form)
	};
};
var $author$project$Page$Remedy$Editor$AddBulletedList = 3;
var $author$project$Page$Remedy$Editor$AddButton = 2;
var $author$project$Page$Remedy$Editor$AddHeadline = 0;
var $author$project$Page$Remedy$Editor$AddImage = 4;
var $author$project$Page$Remedy$Editor$AddParagraph = 1;
var $author$project$Page$Remedy$Editor$ClickedAddElement = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Remedy$Editor$viewElementSideControls = function (items) {
	var makeButton = function (_v0) {
		var childHtml = _v0.a;
		var clickMsg = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(clickMsg),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('btn btn-default btn-xs')
				]),
			_List_fromArray(
				[childHtml]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Util$Html$role('group'),
				$elm$html$Html$Attributes$class('btn-group')
			]),
		A2($elm$core$List$map, makeButton, items));
};
var $author$project$Page$Remedy$Editor$isFocused = F2(
	function (ctx, elementIndex) {
		return _Utils_eq(
			ctx.cO,
			$elm$core$Maybe$Just(elementIndex));
	});
var $author$project$Page$Remedy$Editor$ChangedElementText = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Remedy$Editor$ClickedElement = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Remedy$Editor$viewBulletedList = F3(
	function (ctx, idx, str) {
		var sharedAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'block'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0 0 10px 0')
			]);
		if (A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx)) {
			return A2(
				$elm$html$Html$textarea,
				_Utils_ap(
					sharedAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(str),
							$elm$html$Html$Attributes$placeholder('List of things, each starting with \"- \"'),
							$elm$html$Html$Attributes$id(
							$author$project$Remedy$Editor$Form$elementDomId(idx)),
							$elm$html$Html$Attributes$rows(4),
							$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$ChangedElementText)
						])),
				_List_Nil);
		} else {
			var items = $author$project$Remedy$Editor$Form$unpackBulletedList(str);
			return A2(
				$elm$html$Html$ul,
				_Utils_ap(
					sharedAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Remedy$Editor$ClickedElement(idx)),
							A2($elm$html$Html$Attributes$style, 'padding', '3px')
						])),
				A2(
					$elm$core$List$map,
					function (itemStr) {
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '16px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(itemStr)
								]));
					},
					items));
		}
	});
var $author$project$Page$Remedy$Editor$viewButtonElement = F3(
	function (ctx, idx, str) {
		var sharedAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'block'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'min-height', '44px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '36px'),
				A2($elm$html$Html$Attributes$style, 'margin', '8px auto'),
				A2($elm$html$Html$Attributes$style, 'border', '1px solid var(--pl-remedy-accent-color)'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
				A2($elm$html$Html$Attributes$style, 'font-size', '16px'),
				A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-remedy-accent-color)'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
				A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
			]);
		return A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx) ? A2(
			$elm$html$Html$input,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(str),
						$elm$html$Html$Attributes$placeholder('Button Text'),
						$elm$html$Html$Attributes$id(
						$author$project$Remedy$Editor$Form$elementDomId(idx)),
						$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$ChangedElementText)
					])),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Page$Remedy$Editor$ClickedElement(idx)),
						A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-remedy-bg-color)'),
						A2($elm$html$Html$Attributes$style, 'padding', '3px 0 3px 0')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Page$Remedy$Editor$SetFocusedButtonAction = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$Remedy$Editor$viewBasicCapabilityAction = F2(
	function (title, subtitle) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(title),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$small,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(subtitle)
						]))
				]));
	});
var $author$project$Page$Remedy$Editor$ChangedCustomCapabilityParameter = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Page$Remedy$Editor$viewCustomCapabilityAction = F2(
	function (capabilityId, props) {
		var viewProp = function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(key),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(value),
								$elm$html$Html$Events$onInput(
								$author$project$Page$Remedy$Editor$ChangedCustomCapabilityParameter(key))
							]),
						_List_Nil)
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(
							$author$project$App$Route$EditCapability(capabilityId)),
							$elm$html$Html$Attributes$target('_blank'),
							A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(capabilityId)
						])),
					A2(
					$author$project$Util$Html$viewIf,
					!$elm$core$List$isEmpty(props),
					A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2($elm$core$List$map, viewProp, props)))
				]));
	});
var $author$project$Page$Remedy$Editor$SelectScreen = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Remedy$Editor$viewGoToScreenAction = F2(
	function (ctx, targetScreenId) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Go to Screen: '),
					function () {
					var _v0 = A2(
						$elm_community$list_extra$List$Extra$find,
						function (stub) {
							return _Utils_eq(stub.bj, targetScreenId);
						},
						ctx.as);
					if (!_v0.$) {
						var targetStub = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Util$Html$role('button'),
									A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Remedy$Editor$SelectScreen(targetStub.bj))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(targetStub.bO)
								]));
					} else {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-danger')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('NOT FOUND!')
								]));
					}
				}()
				]));
	});
var $author$project$Page$Remedy$Editor$viewActionEditor = F2(
	function (ctx, action) {
		switch (action.$) {
			case 0:
				var screenId = action.a;
				return A2($author$project$Page$Remedy$Editor$viewGoToScreenAction, ctx, screenId);
			case 1:
				var str = action.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Go to: '),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Page$Remedy$Editor$SetFocusedButtonAction, $elm$core$Maybe$Just),
										$author$project$Remedy$Editor$Form$GoToUrl)),
									$elm$html$Html$Attributes$value(str),
									$elm$html$Html$Attributes$placeholder('URL'),
									A2($elm$html$Html$Attributes$style, 'width', '100%')
								]),
							_List_Nil)
						]));
			case 2:
				return A2($author$project$Page$Remedy$Editor$viewBasicCapabilityAction, 'Talk to Agent', 'start a customer support conversation (ticket)');
			case 3:
				return A2($author$project$Page$Remedy$Editor$viewBasicCapabilityAction, 'Go to App Store', 'update the app');
			case 4:
				return A2($author$project$Page$Remedy$Editor$viewBasicCapabilityAction, 'Dismiss', 'close the remedy');
			default:
				var capabilityId = action.a;
				var props = action.b;
				return A2($author$project$Page$Remedy$Editor$viewCustomCapabilityAction, capabilityId, props);
		}
	});
var $author$project$Page$Remedy$Editor$actionChoices = function (ctx) {
	var capabilityProps = function (capability) {
		return A2(
			$elm$core$List$map,
			function (param) {
				return _Utils_Tuple2(param.ev, '');
			},
			capability.bB);
	};
	return _Utils_ap(
		_List_fromArray(
			[
				$author$project$Remedy$Editor$Form$UseDismiss,
				$author$project$Remedy$Editor$Form$UseTalkToAgent,
				$author$project$Remedy$Editor$Form$UseGoToMarket,
				$author$project$Remedy$Editor$Form$GoToUrl('')
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Remedy$Editor$Form$GoToScreen,
					function ($) {
						return $.bj;
					}),
				A2(
					$elm$core$List$filter,
					function (stub) {
						return !_Utils_eq(stub.bj, ctx.bU);
					},
					ctx.as)),
			A2(
				$elm$core$List$map,
				function (it) {
					return A2(
						$author$project$Remedy$Editor$Form$UseCustomCapability,
						it.bj,
						capabilityProps(it));
				},
				ctx.aF)));
};
var $author$project$Util$Bootstrap$buttonListGroup = F3(
	function (items, toDisplayText, clickMsg) {
		var makeItem = function (item) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('btn btn-default'),
						$elm$html$Html$Events$onClick(
						clickMsg(item))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						toDisplayText(item))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn-group-vertical'),
					$author$project$Util$Html$role('group')
				]),
			A2($elm$core$List$map, makeItem, items));
	});
var $author$project$Page$Remedy$Editor$rawActionToString = F2(
	function (ctx, action) {
		switch (action.$) {
			case 4:
				return 'Dismiss Remedy';
			case 2:
				return 'Talk to Agent';
			case 3:
				return 'Go to App Store';
			case 0:
				var id = action.a;
				return 'Go to Screen: ' + A2(
					$elm$core$Maybe$withDefault,
					'?',
					A2($author$project$Page$Remedy$Editor$screenTitle, ctx.as, id));
			case 1:
				return 'Go to URL';
			default:
				var id = action.a;
				return 'Custom: ' + id;
		}
	});
var $author$project$Page$Remedy$Editor$viewActionPicker = function (ctx) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Pick an action:')
					])),
				A3(
				$author$project$Util$Bootstrap$buttonListGroup,
				$author$project$Page$Remedy$Editor$actionChoices(ctx),
				$author$project$Page$Remedy$Editor$rawActionToString(ctx),
				A2($elm$core$Basics$composeL, $author$project$Page$Remedy$Editor$SetFocusedButtonAction, $elm$core$Maybe$Just))
			]));
};
var $author$project$Page$Remedy$Editor$viewButtonElementSideEditor = F2(
	function (ctx, maybeAction) {
		if (!maybeAction.$) {
			var action = maybeAction.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-10')
							]),
						_List_fromArray(
							[
								A2($author$project$Page$Remedy$Editor$viewActionEditor, ctx, action)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-md-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
										$elm$html$Html$Events$onClick(
										$author$project$Page$Remedy$Editor$SetFocusedButtonAction($elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[$author$project$Util$Glyphs$remove]))
							]))
					]));
		} else {
			return $author$project$Page$Remedy$Editor$viewActionPicker(ctx);
		}
	});
var $author$project$Page$Remedy$Editor$viewHeadline = F3(
	function (ctx, idx, str) {
		var sharedAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'block'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'font-size', '20px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
				A2($elm$html$Html$Attributes$style, 'margin', '20px 0 10px 0')
			]);
		return A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx) ? A2(
			$elm$html$Html$input,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(str),
						$elm$html$Html$Attributes$placeholder('Headline Text'),
						$elm$html$Html$Attributes$id(
						$author$project$Remedy$Editor$Form$elementDomId(idx)),
						$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$ChangedElementText)
					])),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Page$Remedy$Editor$ClickedElement(idx)),
						A2($elm$html$Html$Attributes$style, 'padding', '3px 0 3px 0')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Page$Remedy$Editor$viewImageElement = F3(
	function (ctx, idx, url) {
		return A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx) ? A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(url),
					$elm$html$Html$Attributes$placeholder('Image URL'),
					$elm$html$Html$Attributes$id(
					$author$project$Remedy$Editor$Form$elementDomId(idx)),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$ChangedElementText)
				]),
			_List_Nil) : A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(url),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
					A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
					A2($elm$html$Html$Attributes$style, 'margin-right', 'auto'),
					A2($elm$html$Html$Attributes$style, 'max-width', '260px'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Remedy$Editor$ClickedElement(idx))
				]),
			_List_Nil);
	});
var $author$project$Page$Remedy$Editor$viewParagraph = F3(
	function (ctx, idx, str) {
		var sharedAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'block'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0 0 10px 0')
			]);
		return A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx) ? A2(
			$elm$html$Html$textarea,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(str),
						$elm$html$Html$Attributes$placeholder('Text'),
						$elm$html$Html$Attributes$id(
						$author$project$Remedy$Editor$Form$elementDomId(idx)),
						$elm$html$Html$Attributes$rows(4),
						$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$ChangedElementText)
					])),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_Utils_ap(
				sharedAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Page$Remedy$Editor$ClickedElement(idx)),
						A2($elm$html$Html$Attributes$style, 'padding', '3px')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Page$Remedy$Editor$viewElementDispatcher = F3(
	function (ctx, idx, element) {
		switch (element.$) {
			case 0:
				var str = element.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Remedy$Editor$viewHeadline, ctx, idx, str),
					$elm$core$Maybe$Nothing);
			case 1:
				var str = element.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Remedy$Editor$viewParagraph, ctx, idx, str),
					$elm$core$Maybe$Nothing);
			case 2:
				var str = element.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Remedy$Editor$viewImageElement, ctx, idx, str),
					$elm$core$Maybe$Nothing);
			case 4:
				var str = element.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Remedy$Editor$viewBulletedList, ctx, idx, str),
					$elm$core$Maybe$Nothing);
			default:
				var str = element.a;
				var maybeAction = element.b;
				return _Utils_Tuple2(
					A3($author$project$Page$Remedy$Editor$viewButtonElement, ctx, idx, str),
					$elm$core$Maybe$Just(
						A2($author$project$Page$Remedy$Editor$viewButtonElementSideEditor, ctx, maybeAction)));
		}
	});
var $author$project$Page$Remedy$Editor$DeleteFocusedElement = {$: 21};
var $author$project$Util$List$Down = 1;
var $author$project$Page$Remedy$Editor$MoveFocusedElement = function (a) {
	return {$: 22, a: a};
};
var $author$project$Util$List$Up = 0;
var $author$project$Util$Glyphs$triangleBottom = $author$project$Util$Glyphs$make('glyphicon-triangle-bottom');
var $author$project$Util$Glyphs$triangleTop = $author$project$Util$Glyphs$make('glyphicon-triangle-top');
var $author$project$Page$Remedy$Editor$viewFocusedElement = F4(
	function (ctx, idx, element, sharedAttributes) {
		var _v0 = A3($author$project$Page$Remedy$Editor$viewElementDispatcher, ctx, idx, element);
		var mainEditor = _v0.a;
		var sideEditor = _v0.b;
		var _v1 = function () {
			if (sideEditor.$ === 1) {
				return _Utils_Tuple2(
					$elm$html$Html$text(''),
					$elm$html$Html$text(''));
			} else {
				var sideEditorContent = sideEditor.a;
				return _Utils_Tuple2(
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'top', '50%'),
								A2($elm$html$Html$Attributes$style, 'right', '-20px'),
								A2($elm$html$Html$Attributes$style, 'width', '20px'),
								A2($elm$html$Html$Attributes$style, 'height', '1px'),
								A2($elm$html$Html$Attributes$style, 'background-color', '#aaaaaa')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'top', 'calc(50% - 20px)'),
								A2($elm$html$Html$Attributes$style, 'right', 'calc(-340px - 20px)'),
								A2($elm$html$Html$Attributes$style, 'width', '340px'),
								A2($elm$html$Html$Attributes$style, 'padding', '20px'),
								A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-text-color)'),
								A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-page-bg-color-secondary)'),
								A2($elm$html$Html$Attributes$style, 'border', '1px solid #aaaaaa'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
							]),
						_List_fromArray(
							[sideEditorContent])));
			}
		}();
		var rightConnector = _v1.a;
		var rightEditor = _v1.b;
		var _v3 = _Utils_Tuple2(
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', 'calc(50% - 10px)'),
						A2($elm$html$Html$Attributes$style, 'left', 'calc(-70px - 20px)'),
						A2($elm$html$Html$Attributes$style, 'height', '1px'),
						A2($elm$html$Html$Attributes$style, 'z-index', '1')
					]),
				_List_fromArray(
					[
						$author$project$Page$Remedy$Editor$viewElementSideControls(
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Util$Glyphs$x, $author$project$Page$Remedy$Editor$DeleteFocusedElement),
								_Utils_Tuple2(
								$author$project$Util$Glyphs$triangleTop,
								$author$project$Page$Remedy$Editor$MoveFocusedElement(0)),
								_Utils_Tuple2(
								$author$project$Util$Glyphs$triangleBottom,
								$author$project$Page$Remedy$Editor$MoveFocusedElement(1))
							]))
					])),
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '50%'),
						A2($elm$html$Html$Attributes$style, 'left', '-20px'),
						A2($elm$html$Html$Attributes$style, 'width', '20px'),
						A2($elm$html$Html$Attributes$style, 'height', '1px'),
						A2($elm$html$Html$Attributes$style, 'background-color', '#aaaaaa'),
						A2($elm$html$Html$Attributes$style, 'z-index', '0')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])));
		var leftButtonBar = _v3.a;
		var leftConnector = _v3.b;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'relative'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-accent-bg-color-light)')
					]),
				sharedAttributes),
			_List_fromArray(
				[leftButtonBar, leftConnector, mainEditor, rightConnector, rightEditor]));
	});
var $author$project$Util$Glyphs$exclamationSign = $author$project$Util$Glyphs$make('glyphicon-exclamation-sign');
var $author$project$Page$Remedy$Editor$viewValidationProblem = function (problem) {
	switch (problem.$) {
		case 0:
			var error = problem.a;
			return $elm$html$Html$text(error);
		case 1:
			return $elm$html$Html$text('This button wants to navigate to a screen that does not exist!');
		default:
			return $elm$html$Html$text('This button wants to navigate to a screen that would cause a loop');
	}
};
var $author$project$Page$Remedy$Editor$viewInvalidElement = F2(
	function (idx, problems) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert alert-danger'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Remedy$Editor$ClickedElement(idx))
				]),
			_List_fromArray(
				[
					$author$project$Util$Glyphs$exclamationSign,
					$elm$html$Html$text(' '),
					function () {
					if (problems.b && (!problems.b.b)) {
						var problem = problems.a;
						return $author$project$Page$Remedy$Editor$viewValidationProblem(problem);
					} else {
						return A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (problem) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Page$Remedy$Editor$viewValidationProblem(problem)
											]));
								},
								problems));
					}
				}()
				]));
	});
var $author$project$Page$Remedy$Editor$viewElement = F3(
	function (ctx, idx, element) {
		var sharedAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '4px 20px 4px 20px')
			]);
		return A2($author$project$Page$Remedy$Editor$isFocused, ctx, idx) ? A4($author$project$Page$Remedy$Editor$viewFocusedElement, ctx, idx, element, sharedAttributes) : A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('remedyEditorElement')
					]),
				sharedAttributes),
			_List_fromArray(
				[
					function () {
					var _v0 = A2($elm$core$Dict$get, idx, ctx.cL);
					if (_v0.$ === 1) {
						return A3($author$project$Page$Remedy$Editor$viewElementDispatcher, ctx, idx, element).a;
					} else {
						var problems = _v0.a;
						return A2($author$project$Page$Remedy$Editor$viewInvalidElement, idx, problems);
					}
				}()
				]));
	});
var $author$project$Page$Remedy$Editor$viewScreen = F2(
	function (ctx, screen) {
		return $elm$core$List$isEmpty(screen.d3) ? $author$project$View$EmptyStates$view('Empty Screen') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border', '1px solid var(--pl-primary-color)'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-remedy-bg-color)'),
					A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-remedy-text-color)'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'width', '300px'),
					A2($elm$html$Html$Attributes$style, 'padding', '20px 0 20px 0'),
					$elm$html$Html$Attributes$id($author$project$Page$Remedy$Editor$remedyScreenDomId)
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, element) {
						return A3($author$project$Page$Remedy$Editor$viewElement, ctx, idx, element);
					}),
				screen.d3));
	});
var $author$project$Page$Remedy$Editor$viewRemedyContent = F2(
	function (ctx, activeScreen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-height', '300px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '80px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Remedy Editor')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '300px')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id($author$project$Page$Remedy$Editor$addElementToolbarDomId)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('+ '),
											$author$project$Page$Remedy$Editor$viewElementSideControls(
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$html$Html$text('headline'),
													$author$project$Page$Remedy$Editor$ClickedAddElement(0)),
													_Utils_Tuple2(
													$elm$html$Html$text('text'),
													$author$project$Page$Remedy$Editor$ClickedAddElement(1)),
													_Utils_Tuple2(
													$elm$html$Html$text('list'),
													$author$project$Page$Remedy$Editor$ClickedAddElement(3)),
													_Utils_Tuple2(
													$elm$html$Html$text('image'),
													$author$project$Page$Remedy$Editor$ClickedAddElement(4)),
													_Utils_Tuple2(
													$elm$html$Html$text('button'),
													$author$project$Page$Remedy$Editor$ClickedAddElement(2))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding-left', '80px'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Remedy$Editor$viewScreen, ctx, activeScreen)
						]))
				]));
	});
var $author$project$Page$Remedy$Editor$ScreenModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Remedy$Editor$SetModal = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$Remedy$Editor$DeleteActiveScreen = {$: 23};
var $author$project$Page$Remedy$Editor$ErrorsModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Util$Html$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Util$Glyphs$pencil = $author$project$Util$Glyphs$make('glyphicon-pencil');
var $author$project$Page$Remedy$Editor$viewScreenNavItem = F3(
	function (ctx, isDeleteAllowed, screenStub) {
		var myProblems = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($turboMaCk$any_dict$Dict$Any$get, screenStub.bj, ctx.di));
		var validationErrorButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '4px'),
					$author$project$Util$Html$onClickStopPropagation(
					$author$project$Page$Remedy$Editor$SetModal(
						$author$project$Page$Remedy$Editor$ErrorsModal(
							{dd: myProblems, dh: screenStub.bO})))
				]),
			_List_fromArray(
				[$author$project$Util$Glyphs$exclamationSign]));
		var isActive = _Utils_eq(screenStub.bj, ctx.bU);
		var editButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
					$author$project$Util$Html$visibleIf(isActive),
					$author$project$Util$Html$onClickStopPropagation(
					$author$project$Page$Remedy$Editor$SetModal(
						$author$project$Page$Remedy$Editor$ScreenModal(
							{bq: false, a0: screenStub.bO})))
				]),
			_List_fromArray(
				[$author$project$Util$Glyphs$pencil]));
		var deleteButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-xs btn-borderless'),
					$author$project$Util$Html$disableIf(!isDeleteAllowed),
					$author$project$Util$Html$visibleIf(isActive),
					$author$project$Util$Html$onClickStopPropagation($author$project$Page$Remedy$Editor$DeleteActiveScreen)
				]),
			_List_fromArray(
				[$author$project$Util$Glyphs$remove]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group-item clearfix'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', isActive)
						])),
					$author$project$Util$Html$role('button'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Remedy$Editor$SelectScreen(screenStub.bj))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(screenStub.bO),
					($elm$core$List$length(myProblems) > 0) ? validationErrorButton : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pull-right')
						]),
					_List_fromArray(
						[deleteButton, editButton]))
				]));
	});
var $author$project$Page$Remedy$Editor$viewScreenNavigator = function (ctx) {
	var showModalMsg = $author$project$Page$Remedy$Editor$SetModal(
		$author$project$Page$Remedy$Editor$ScreenModal(
			{bq: true, a0: ''}));
	var isDeleteAllowed = $elm$core$List$length(ctx.as) >= 2;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Screens '),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-xs btn-default'),
								$elm$html$Html$Events$onClick(showModalMsg)
							]),
						_List_fromArray(
							[$author$project$Util$Glyphs$plus]))
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-group')
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Page$Remedy$Editor$viewScreenNavItem, ctx, isDeleteAllowed),
					ctx.as))
			]));
};
var $author$project$Page$Remedy$Editor$viewEditorTabContent = function (model) {
	var ctx = $author$project$Page$Remedy$Editor$newEditorContext(model);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-3')
					]),
				_List_fromArray(
					[
						$author$project$Page$Remedy$Editor$viewScreenNavigator(ctx)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-9')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Remedy$Editor$viewRemedyContent,
						ctx,
						$author$project$Remedy$Editor$Form$activeScreen(model.d))
					]))
			]));
};
var $author$project$Page$Remedy$Editor$UpdateDefDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Remedy$Editor$UpdateDefEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Remedy$Editor$UpdateDefTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Remedy$Editor$UpdateDefTriggerPriority = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Form$checkbox = F2(
	function (groupName, child) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('checkbox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							child,
							$elm$html$Html$text(groupName)
						]))
				]));
	});
var $author$project$View$Form$item = F2(
	function (groupName, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(groupName)
						])),
				children));
	});
var $author$project$Page$Remedy$Editor$UpdateDefTriggerLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Remedy$Editor$viewTriggerLabel = F2(
	function (triggerLabel, suggestions) {
		var datalistId = 'trigger-datalist';
		var classifierPills = A2(
			$elm$core$List$map,
			function (s) {
				return A4(
					$author$project$Util$Bootstrap$classifierPill,
					$author$project$App$Route$ViewClassifier(s.fG),
					true,
					s.fH,
					s.fF);
			},
			A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(s.eo, triggerLabel);
				},
				suggestions));
		var autocompleteSuggestions = A2(
			$elm$core$List$map,
			function (s) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(s)
						]),
					_List_Nil);
			},
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.eo;
					},
					suggestions)));
		return A2(
			$author$project$View$Form$item,
			'Trigger Label',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('form-control'),
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px'),
							$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$UpdateDefTriggerLabel),
							$elm$html$Html$Attributes$placeholder('A classifier label'),
							$elm$html$Html$Attributes$value(triggerLabel),
							$elm$html$Html$Attributes$list(datalistId),
							A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
							$elm$html$Html$Attributes$autocomplete(false)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$datalist,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(datalistId)
						]),
					autocompleteSuggestions),
					(!$elm$core$List$isEmpty(classifierPills)) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('help-block')
						]),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text('Associated Classifiers: '),
						classifierPills)) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('help-block text-warning')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Associated Classifiers: None')
						]))
				]));
	});
var $author$project$Page$Remedy$Editor$viewMetadataTabContent = function (model) {
	var remedy = model.hd;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Meta')
							])),
						A2(
						$author$project$View$Form$item,
						'Title',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-control'),
										$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$UpdateDefTitle),
										$elm$html$Html$Attributes$value(remedy.bO)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$View$Form$item,
						'Description',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-control'),
										$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$UpdateDefDescription),
										$elm$html$Html$Attributes$value(remedy.b6),
										$elm$html$Html$Attributes$rows(3)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$View$Form$item,
						'Version',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(remedy.dx))
									]))
							])),
						A2(
						$author$project$View$Form$item,
						'Edited By',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(remedy.dy)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-page-bg-color-secondary)'),
								A2($elm$html$Html$Attributes$style, 'padding', '20px'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Form$checkbox,
								'Enabled',
								A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Events$onCheck($author$project$Page$Remedy$Editor$UpdateDefEnabled),
											$elm$html$Html$Attributes$checked(remedy.cM)
										]),
									_List_Nil)),
								A2($author$project$Page$Remedy$Editor$viewTriggerLabel, remedy.hN, model.a2),
								A2(
								$author$project$View$Form$item,
								'Priority',
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-control'),
												$elm$html$Html$Events$onInput($author$project$Page$Remedy$Editor$UpdateDefTriggerPriority),
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(remedy.fc))
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Page$Remedy$Editor$SelectTextEntryLanguage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Remedy$Editor$ShowAddLanguageDialog = {$: 26};
var $author$project$Page$Remedy$Editor$UpdateAutoTranslateFlag = function (a) {
	return {$: 34, a: a};
};
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.e;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$keys = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$first),
	$turboMaCk$any_dict$Dict$Any$toList);
var $author$project$Remedy$Localization$langComparator = F2(
	function (_v0, _v1) {
		var lang1 = _v0;
		var lang2 = _v1;
		return A2($elm$core$Basics$compare, lang1, lang2);
	});
var $author$project$Remedy$Localization$languages = function (_v0) {
	var items = _v0;
	return A2(
		$elm$core$List$cons,
		$author$project$Remedy$Localization$defaultLanguageTag,
		A2(
			$elm$core$List$sortWith,
			$author$project$Remedy$Localization$langComparator,
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				$author$project$Remedy$Localization$tagToString,
				A2(
					$elm$core$List$concatMap,
					function (item) {
						return $turboMaCk$any_dict$Dict$Any$keys(item.I);
					},
					items))));
};
var $author$project$Remedy$Localization$viewSmallButton = F3(
	function (onClickMsg, statusClass, children) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(onClickMsg),
							$elm$html$Html$Attributes$class('btn btn-xs ' + statusClass),
							A2($elm$html$Html$Attributes$style, 'min-width', '28px'),
							A2($elm$html$Html$Attributes$style, 'height', '28px'),
							A2($elm$html$Html$Attributes$style, 'margin', '5px 0')
						]),
					children)
				]));
	});
var $author$project$Remedy$Localization$viewAddLangButton = function (addLangMsg) {
	return _List_fromArray(
		[
			A3(
			$author$project$Remedy$Localization$viewSmallButton,
			addLangMsg,
			'btn-default',
			_List_fromArray(
				[$author$project$Util$Glyphs$plus]))
		]);
};
var $author$project$Remedy$Localization$allLanguageTags = _List_fromArray(
	['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hi', 'he', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'nb-NO', 'nl', 'pl', 'pt-BR', 'ro', 'ru', 'sk', 'sl', 'sr-Latn-RS', 'sv', 'th', 'tr', 'uk', 'ur', 'vi', 'zh-Hans', 'zh-Hant']);
var $author$project$Remedy$Localization$isPseudoTranslation = function (str) {
	return A2($elm$core$String$startsWith, '[:', str) && A2($elm$core$String$endsWith, '.]', str);
};
var $author$project$Remedy$Localization$translationStatus = function (_v0) {
	var items = _v0;
	var numStringsInEnglish = $elm$core$List$length(items);
	var isTranslated = F2(
		function (lang, item) {
			var _v1 = A2($author$project$Remedy$Localization$lookup, lang, item);
			if (!_v1.$) {
				var str = _v1.a;
				return (!$author$project$Util$String$isBlank(str)) && (!$author$project$Remedy$Localization$isPseudoTranslation(str));
			} else {
				return false;
			}
		});
	var numStringsIn = function (lang) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (item) {
					return A2(isTranslated, lang, item) ? 1.0 : 0.0;
				},
				items));
	};
	var statusFor = function (lang) {
		return _Utils_eq(lang, $author$project$Remedy$Localization$defaultLanguageTag) ? 1.0 : (numStringsIn(lang) / numStringsInEnglish);
	};
	return A3(
		$elm$core$List$foldl,
		F2(
			function (lang, acc) {
				return A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					lang,
					statusFor(lang),
					acc);
			}),
		$turboMaCk$any_dict$Dict$Any$empty($author$project$Remedy$Localization$tagToString),
		$author$project$Remedy$Localization$allLanguageTags);
};
var $author$project$Remedy$Localization$viewPickLangButtons = F2(
	function (selectLangMsg, localizedStrings) {
		var status = $author$project$Remedy$Localization$translationStatus(localizedStrings);
		var statusClass = function (lang) {
			var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, lang, status);
			if (!_v0.$) {
				var amountCompleted = _v0.a;
				return (amountCompleted >= 1.0) ? 'btn-success' : 'btn-warning';
			} else {
				return 'btn-warning';
			}
		};
		var viewListItem = function (lang) {
			return A3(
				$author$project$Remedy$Localization$viewSmallButton,
				selectLangMsg(lang),
				statusClass(lang),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Remedy$Localization$tagToString(lang))
					]));
		};
		return A2(
			$elm$core$List$map,
			viewListItem,
			$author$project$Remedy$Localization$languages(localizedStrings));
	});
var $author$project$Remedy$Localization$viewLangButtons = F3(
	function (selectLangMsg, addLangMsg, localizedStrings) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-inline')
				]),
			_Utils_ap(
				A2($author$project$Remedy$Localization$viewPickLangButtons, selectLangMsg, localizedStrings),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Remedy$Localization$viewAddLangButton, addLangMsg))));
	});
var $author$project$Page$Remedy$Editor$AutoTranslate = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Page$Remedy$Editor$autoTranslateControl = function (_v0) {
	var localizedStrings = _v0.r;
	var textEntryLang = _v0.ax;
	var isTranslating = _v0.aj;
	var localizableStrings = A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2($author$project$Remedy$Localization$batchTranslate, localizedStrings, $author$project$Remedy$Localization$defaultLanguageTag));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Util$Bootstrap$button,
				'btn-success',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$Page$Remedy$Editor$AutoTranslate, textEntryLang, localizableStrings)),
						$author$project$Util$Html$disableIf(isTranslating)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Auto Translate')
					])),
				A2(
				$author$project$Util$Html$viewIf,
				isTranslating,
				$elm$html$Html$text(' translating...'))
			]));
};
var $author$project$Remedy$Localization$languageName = function (lang) {
	switch (lang) {
		case 'ar':
			return 'Arabic';
		case 'bg':
			return 'Bulgarian';
		case 'cs':
			return 'Czech';
		case 'da':
			return 'Danish';
		case 'de':
			return 'German';
		case 'el':
			return 'Greek';
		case 'en':
			return 'English';
		case 'es':
			return 'Spanish';
		case 'et':
			return 'Estonian';
		case 'fi':
			return 'Finnish';
		case 'fr':
			return 'French';
		case 'hi':
			return 'Hindi';
		case 'he':
			return 'Hebrew';
		case 'hr':
			return 'Croatian';
		case 'hu':
			return 'Hungarian';
		case 'id':
			return 'Indonesian';
		case 'it':
			return 'Italian';
		case 'ja':
			return 'Japanese';
		case 'ko':
			return 'Korean';
		case 'lt':
			return 'Lithuanian';
		case 'lv':
			return 'Latvian';
		case 'nb-NO':
			return 'Norwegian (Bokmål)';
		case 'nl':
			return 'Dutch';
		case 'pl':
			return 'Polish';
		case 'pt-BR':
			return 'Portuguese (Brazil)';
		case 'ro':
			return 'Romanian';
		case 'ru':
			return 'Russian';
		case 'sk':
			return 'Slovak';
		case 'sl':
			return 'Slovenian';
		case 'sr-Latn-RS':
			return 'Serbian (Latin, Serbia)';
		case 'sv':
			return 'Swedish';
		case 'th':
			return 'Thai';
		case 'tr':
			return 'Turkish';
		case 'uk':
			return 'Ukrainian';
		case 'ur':
			return 'Urdu';
		case 'vi':
			return 'Vietnamese';
		case 'zh-Hans':
			return 'Chinese (Simplified)';
		case 'zh-Hant':
			return 'Chinese (Traditional)';
		default:
			var str = lang;
			return 'Unknown (' + (str + ')');
	}
};
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Page$Remedy$Editor$EditTranslation = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Page$Remedy$Editor$viewTranslationRow = F2(
	function (textEntryLang, _v0) {
		var keyText = _v0.a;
		var rawText = _v0.b;
		var translatedText = A2($elm$core$Maybe$withDefault, '', rawText);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Remedy$LocStr$english(keyText))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(translatedText),
									$elm$html$Html$Events$onInput(
									A2($author$project$Page$Remedy$Editor$EditTranslation, keyText, textEntryLang)),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'bg-danger',
											$author$project$Util$String$isBlank(translatedText))
										]))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$Remedy$Editor$viewTranslationTable = function (model) {
	var localizedStrings = model.r;
	var textEntryLang = model.ax;
	var flatTable = A2($author$project$Remedy$Localization$batchTranslate, localizedStrings, textEntryLang);
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('table table-bordered')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '50%')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('English')
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '50%')
									]),
								_List_fromArray(
									[
										$author$project$Util$Html$dropdownAdvanced(
										{
											fS: textEntryLang,
											gw: $author$project$Remedy$Localization$languageName,
											R: A2(
												$elm_community$list_extra$List$Extra$remove,
												$author$project$Remedy$Localization$defaultLanguageTag,
												$author$project$Remedy$Localization$languages(localizedStrings)),
											eA: $author$project$Page$Remedy$Editor$SelectTextEntryLanguage
										})
									]))
							]))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Page$Remedy$Editor$viewTranslationRow(textEntryLang),
					flatTable)),
				A2(
				$elm$html$Html$tfoot,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$td, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Page$Remedy$Editor$autoTranslateControl(model)
									]))
							]))
					]))
			]));
};
var $author$project$Page$Remedy$Editor$viewTranslationTabContent = function (model) {
	var localizedStrings = model.r;
	var textEntryLang = model.ax;
	var languagesEligibleForTranslation = A2(
		$elm$core$List$filter,
		function (lang) {
			return !_Utils_eq(lang, $author$project$Remedy$Localization$defaultLanguageTag);
		},
		$author$project$Remedy$Localization$languages(localizedStrings));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Util$Html$viewIf,
				model.aK,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel-danger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Attention')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This remedy\'s translations are automatically being handled by ' + 'Microsoft\'s internal Touchdown/Fabric service.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Any changes that you make to the translations WILL BE REPLACED ' + 'the next time that we receive strings from Touchdown. ')
										]))
								]))
						]))),
				$elm$html$Html$text('Languages: '),
				A3(
				$author$project$Remedy$Localization$viewLangButtons,
				$author$project$Page$Remedy$Editor$SelectTextEntryLanguage,
				$elm$core$Maybe$Just($author$project$Page$Remedy$Editor$ShowAddLanguageDialog),
				localizedStrings),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Events$onCheck($author$project$Page$Remedy$Editor$UpdateAutoTranslateFlag),
								$elm$html$Html$Attributes$checked(model.bm)
							]),
						_List_Nil),
						$elm$html$Html$text('Auto Translate All')
					])),
				$elm$core$List$isEmpty(languagesEligibleForTranslation) ? $author$project$View$EmptyStates$view('You must add a language before you can translate/localize') : (_Utils_eq(textEntryLang, $author$project$Remedy$Localization$defaultLanguageTag) ? $author$project$View$EmptyStates$view('Please select a language other than English') : $author$project$Page$Remedy$Editor$viewTranslationTable(model))
			]));
};
var $author$project$Page$Remedy$Editor$viewMainPane = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.a9;
				switch (_v0) {
					case 0:
						return $author$project$Page$Remedy$Editor$viewMetadataTabContent(model);
					case 1:
						return $author$project$Page$Remedy$Editor$viewEditorTabContent(model);
					default:
						return $author$project$Page$Remedy$Editor$viewTranslationTabContent(model);
				}
			}()
			]));
};
var $author$project$Remedy$Localization$remainingLanguageChoices = function (localizedStrings) {
	var languagesInUse = $author$project$Remedy$Localization$languages(localizedStrings);
	return A2(
		$elm$core$List$filter,
		function (lang) {
			return !A2($elm$core$List$member, lang, languagesInUse);
		},
		$author$project$Remedy$Localization$allLanguageTags);
};
var $author$project$Page$Remedy$Editor$CommitScreenModal = {$: 25};
var $author$project$Page$Remedy$Editor$viewAddEditScreenModal = function (state) {
	var isNew = state.bq;
	var textFieldStorage = state.a0;
	var updateStateMessage = function (str) {
		return $author$project$Page$Remedy$Editor$SetModal(
			$author$project$Page$Remedy$Editor$ScreenModal(
				_Utils_update(
					state,
					{a0: str})));
	};
	var saveMessage = $author$project$Page$Remedy$Editor$CommitScreenModal;
	var isInvalidTitle = $author$project$Util$String$isBlank(textFieldStorage);
	var inputForm = A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit(saveMessage)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-group'),
						A2($elm$html$Html$Attributes$style, 'margin', '15px'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('has-error', isInvalidTitle)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Title')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$value(textFieldStorage),
								$elm$html$Html$Events$onInput(updateStateMessage)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Util$Html$visibleIf(isInvalidTitle),
								$elm$html$Html$Attributes$class('help-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Must not be blank')
							]))
					]))
			]));
	var closeMessage = $author$project$Page$Remedy$Editor$SetModal($author$project$Page$Remedy$Editor$NoModal);
	return $author$project$Util$Bootstrap$viewModal(
		{
			bX: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Set the screen\'s title.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The title will only be shown here in the remedy editor.')
								])),
							inputForm
						]))),
			dM: closeMessage,
			ec: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(closeMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(saveMessage),
									$author$project$Util$Html$disableIf(isInvalidTitle)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK')
								]))
						]))),
			bO: isNew ? 'New Screen' : 'Edit Screen',
			fh: $elm$core$Maybe$Nothing
		});
};
var $author$project$Page$Remedy$Editor$AutoTranslateAll = function (a) {
	return {$: 33, a: a};
};
var $author$project$Page$Remedy$Editor$CommitLanguageModal = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$Remedy$Editor$viewLanguageChoices = F2(
	function (languages, isAutoTranslateChecked) {
		return A3(
			$author$project$Util$Bootstrap$buttonListGroup,
			languages,
			function (lang) {
				return $author$project$Remedy$Localization$tagToString(lang) + (' - ' + $author$project$Remedy$Localization$languageName(lang));
			},
			isAutoTranslateChecked ? $author$project$Page$Remedy$Editor$AutoTranslateAll : $author$project$Page$Remedy$Editor$CommitLanguageModal);
	});
var $author$project$Page$Remedy$Editor$viewAddLanguageModal = F2(
	function (languages, isAutoTranslateChecked) {
		return $author$project$Util$Bootstrap$viewModal(
			{
				bX: $elm$core$Maybe$Just(
					A2($author$project$Page$Remedy$Editor$viewLanguageChoices, languages, isAutoTranslateChecked)),
				dM: $author$project$Page$Remedy$Editor$SetModal($author$project$Page$Remedy$Editor$NoModal),
				ec: $elm$core$Maybe$Nothing,
				bO: 'Add Language',
				fh: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Page$Remedy$Editor$viewErrorsModal = function (state) {
	return $author$project$Util$Bootstrap$viewModal(
		{
			bX: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (it) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Page$Remedy$Editor$screenProblemToString, state.dh, it))
									]));
						},
						state.dd))),
			dM: $author$project$Page$Remedy$Editor$SetModal($author$project$Page$Remedy$Editor$NoModal),
			ec: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$Remedy$Editor$SetModal($author$project$Page$Remedy$Editor$NoModal))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK')
								]))
						]))),
			bO: 'Validation Errors',
			fh: $elm$core$Maybe$Nothing
		});
};
var $author$project$Page$Remedy$Editor$InvokePreviewActions = function (a) {
	return {$: 14, a: a};
};
var $author$project$Remedy$HeatMap$Off = {$: 0};
var $elm$html$Html$Attributes$dir = $elm$html$Html$Attributes$stringProperty('dir');
var $author$project$Remedy$Localization$direction = function (lang) {
	switch (lang) {
		case 'ar':
			return 'rtl';
		case 'fa':
			return 'rtl';
		case 'he':
			return 'rtl';
		case 'ur':
			return 'rtl';
		default:
			return 'ltr';
	}
};
var $author$project$Remedy$ScreenList$findOrFirst = F2(
	function (screenId, screens) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Remedy$ScreenList$first(screens),
			A2($author$project$Remedy$ScreenList$find, screenId, screens));
	});
var $author$project$Remedy$Localization$translate = F3(
	function (lang, locStr, _v0) {
		var items = _v0;
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Remedy$Localization$lookup(lang),
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (item) {
					return _Utils_eq(item.an, locStr);
				},
				items));
	});
var $author$project$Remedy$Capability$interactionFeedback = F2(
	function (buttonTitle, screenId) {
		return A2(
			$author$project$Remedy$Capability$Feedback,
			'powerlift/interaction',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'screenId',
					$author$project$Remedy$ScreenId$toString(screenId)),
					_Utils_Tuple2(
					'buttonKey',
					$author$project$Remedy$LocStr$english(buttonTitle))
				]));
	});
var $author$project$Remedy$Screen$syntheticNavAction = F2(
	function (buttonTitle, screenId) {
		return $author$project$Remedy$Screen$UseCapability(
			A2($author$project$Remedy$Capability$interactionFeedback, buttonTitle, screenId));
	});
var $author$project$Remedy$HeatMap$lookup = F2(
	function (buttonId, _v0) {
		var buckets = _v0.dF;
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (b) {
				return _Utils_eq(b.dG, buttonId);
			},
			buckets);
	});
var $author$project$Util$Numbers$prettyPercent = F2(
	function (format, x) {
		return A2($author$project$Util$Numbers$prettyFloat, format, x * 100) + '%';
	});
var $author$project$Remedy$Screen$viewHeatText = function (str) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', 'orange')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Remedy$Screen$viewHeat = F2(
	function (heatMapMode, buttonId) {
		switch (heatMapMode.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var histogram = heatMapMode.a;
				var _v1 = A2($author$project$Remedy$HeatMap$lookup, buttonId, histogram);
				if (!_v1.$) {
					var bucket = _v1.a;
					return $author$project$Remedy$Screen$viewHeatText(
						$elm$core$String$fromInt(bucket.fR) + 'x');
				} else {
					return $author$project$Remedy$Screen$viewHeatText('no data');
				}
			default:
				var histogram = heatMapMode.a;
				var _v2 = A2($author$project$Remedy$HeatMap$lookup, buttonId, histogram);
				if (!_v2.$) {
					var bucket = _v2.a;
					return $author$project$Remedy$Screen$viewHeatText(
						A2(
							$author$project$Util$Numbers$prettyPercent,
							{fW: 0},
							bucket.g5));
				} else {
					return $author$project$Remedy$Screen$viewHeatText('no data');
				}
		}
	});
var $author$project$Remedy$Screen$viewLocalizedText = F2(
	function (ctx, locStr) {
		return $elm$html$Html$text(
			ctx.hM(locStr));
	});
var $author$project$Remedy$Screen$viewButton = F4(
	function (ctx, screenId, buttonTitle, action) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn-big'),
					$elm$html$Html$Events$onClick(
					ctx.fa(
						_List_fromArray(
							[
								A2($author$project$Remedy$Screen$syntheticNavAction, buttonTitle, screenId),
								action
							])))
				]),
			_List_fromArray(
				[
					A2($author$project$Remedy$Screen$viewLocalizedText, ctx, buttonTitle),
					$elm$html$Html$text(' '),
					A2($author$project$Remedy$Screen$viewHeat, ctx.gf, buttonTitle)
				]));
	});
var $author$project$Remedy$Screen$viewElement = F3(
	function (ctx, screenId, element) {
		switch (element.$) {
			case 0:
				var locStr = element.a;
				return A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Remedy$Screen$viewLocalizedText, ctx, locStr)
						]));
			case 1:
				var locStr = element.a;
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Remedy$Screen$viewLocalizedText, ctx, locStr)
						]));
			case 2:
				var url = element.a;
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$elm$url$Url$toString(url)),
							A2($elm$html$Html$Attributes$style, 'display', 'block'),
							A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
							A2($elm$html$Html$Attributes$style, 'margin-right', 'auto')
						]),
					_List_Nil);
			case 4:
				var items = element.a;
				return A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (locStr) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Remedy$Screen$viewLocalizedText, ctx, locStr)
									]));
						},
						items));
			default:
				var titleLocStr = element.a;
				var action = element.b;
				return A4($author$project$Remedy$Screen$viewButton, ctx, screenId, titleLocStr, action);
		}
	});
var $author$project$Remedy$Screen$view = F2(
	function (ctx, _v0) {
		var screen = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A2($author$project$Remedy$Screen$viewElement, ctx, screen.bj),
				screen.d3));
	});
var $author$project$Remedy$view = function (_v0) {
	var remedy = _v0.hd;
	var currentScreenId = _v0.aE;
	var actionsToMsg = _v0.fm;
	var lang = _v0.gB;
	var heatMapMode = _v0.gf;
	var r = remedy;
	var screenCtx = {
		gf: heatMapMode,
		fa: actionsToMsg,
		hM: function (locStr) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Remedy$LocStr$english(locStr),
				A3($author$project$Remedy$Localization$translate, lang, locStr, r.r));
		}
	};
	var currentScreen = A2($author$project$Remedy$ScreenList$findOrFirst, currentScreenId, r.V);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('remedy-container'),
				$elm$html$Html$Attributes$dir(
				$author$project$Remedy$Localization$direction(lang))
			]),
		_List_fromArray(
			[
				A2($author$project$Remedy$Screen$view, screenCtx, currentScreen)
			]));
};
var $author$project$Page$Remedy$Editor$viewPreviewConsole = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-default'),
				A2($elm$html$Html$Attributes$style, 'max-height', '150px'),
				A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll'),
				$author$project$Util$Html$visibleIf(
				!$elm$core$List$isEmpty(state.aO))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Action History')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				A2(
					$elm$core$List$map,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					},
					state.aO))
			]));
};
var $author$project$Page$Remedy$Editor$ResetPreviewDialog = {$: 13};
var $author$project$Page$Remedy$Editor$SelectPreviewLanguage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Remedy$localizedStrings = function (_v0) {
	var remedy = _v0;
	return remedy.r;
};
var $author$project$Page$Remedy$Editor$viewPreviewToolbar = function (state) {
	var firstScreenId = $author$project$Remedy$firstScreenId(state.hd);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('clearfix')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pull-left')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Remedy$Localization$viewLangButtons,
						$author$project$Page$Remedy$Editor$SelectPreviewLanguage,
						$elm$core$Maybe$Nothing,
						$author$project$Remedy$localizedStrings(state.hd))
					])),
				A3(
				$author$project$Util$Bootstrap$button,
				'btn-default pull-right',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Remedy$Editor$ResetPreviewDialog),
						$author$project$Util$Html$visibleIf(
						!_Utils_eq(state.aE, firstScreenId))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Start Over')
					]))
			]));
};
var $author$project$Page$Remedy$Editor$viewPreviewModal = function (state) {
	return $author$project$Util$Bootstrap$viewModal(
		{
			bX: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'border', '1px solid var(--pl-primary-color)'),
									A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-remedy-bg-color)'),
									A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-remedy-text-color)'),
									A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
									A2($elm$html$Html$Attributes$style, 'width', '300px'),
									A2($elm$html$Html$Attributes$style, 'padding', '20px'),
									A2($elm$html$Html$Attributes$style, 'min-height', '400px'),
									A2($elm$html$Html$Attributes$style, 'margin', 'auto')
								]),
							_List_fromArray(
								[
									$author$project$Remedy$view(
									{fm: $author$project$Page$Remedy$Editor$InvokePreviewActions, aE: state.aE, gf: $author$project$Remedy$HeatMap$Off, gB: state.gB, hd: state.hd})
								])),
							$author$project$Page$Remedy$Editor$viewPreviewConsole(state),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							$author$project$Page$Remedy$Editor$viewPreviewToolbar(state)
						]))),
			dM: $author$project$Page$Remedy$Editor$SetModal($author$project$Page$Remedy$Editor$NoModal),
			ec: $elm$core$Maybe$Nothing,
			bO: 'Remedy Preview',
			fh: $elm$core$Maybe$Nothing
		});
};
var $author$project$Page$Remedy$Editor$viewModal = function (model) {
	var _v0 = model.S;
	switch (_v0.$) {
		case 3:
			return A2(
				$author$project$Page$Remedy$Editor$viewAddLanguageModal,
				$author$project$Remedy$Localization$remainingLanguageChoices(model.r),
				model.bm);
		case 1:
			var state = _v0.a;
			return $author$project$Page$Remedy$Editor$viewAddEditScreenModal(state);
		case 4:
			var state = _v0.a;
			return $author$project$Page$Remedy$Editor$viewPreviewModal(state);
		case 2:
			var state = _v0.a;
			return $author$project$Page$Remedy$Editor$viewErrorsModal(state);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Page$Remedy$Editor$view = function (model) {
	var saveButton = function (_v0) {
		var isSaving = _v0.cg;
		return A3(
			$author$project$Util$Bootstrap$button,
			'btn-primary',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Page$Remedy$Editor$Save),
					$author$project$Util$Html$disableIf(isSaving)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					isSaving ? 'Saving...' : 'Save')
				]));
	};
	var previewButton = A3(
		$author$project$Util$Bootstrap$button,
		'btn-success',
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Page$Remedy$Editor$ShowPreviewDialog)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Preview')
			]));
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Remedy$Editor$viewModal(model),
					$author$project$Util$Bootstrap$fluidContainer(
					_List_fromArray(
						[
							$author$project$Util$Bootstrap$breadcrumbsCustom(
							_List_fromArray(
								[
									_Utils_Tuple2('Remedies', $author$project$App$Route$ListRemedies),
									_Utils_Tuple2(
									model.hd.bO,
									$author$project$App$Route$ViewRemedyHistory(model.hd.bj)),
									_Utils_Tuple2(
									'Edit',
									$author$project$App$Route$EditRemedy(model.hd.bj))
								])),
							A2($author$project$View$Error$view, model.f$, $author$project$Page$Remedy$Editor$DismissErrors),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-md-6')
										]),
									_List_fromArray(
										[
											$author$project$Util$Navs$viewPills(
											$author$project$Page$Remedy$Editor$navConfig(model))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-md-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right')
												]),
											_List_fromArray(
												[
													previewButton,
													$elm$html$Html$text(' '),
													saveButton(model)
												]))
										]))
								])),
							$author$project$Page$Remedy$Editor$viewMainPane(model),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							$author$project$View$Docs$helpBox(6)
						]))
				])),
		bO: 'Edit Remedy - ' + model.hd.bO
	};
};
var $author$project$Page$Remedy$History$mostRecentRemedy = function (model) {
	return $elm_community$list_extra$List$Extra$last(model.aJ);
};
var $author$project$Page$Remedy$History$ClickedDismissErrors = {$: 0};
var $author$project$Page$Remedy$History$ClickedStatsPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Remedy$History$currentTimeRangeDescription = function (status) {
	switch (status.$) {
		case 0:
			return '...';
		case 1:
			var startTime = status.a.e1;
			var endTime = status.a.d6;
			return $author$project$Util$Date$formatDate(startTime) + (' to ' + $author$project$Util$Date$formatDate(endTime));
		default:
			return '?';
	}
};
var $author$project$Data$Chart$isEmpty = function (chart) {
	return $elm$core$List$isEmpty(chart.du);
};
var $author$project$Util$Date$between = F2(
	function (a, _v0) {
		var low = _v0.gF;
		var high = _v0.gg;
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(low)) > -1) && (_Utils_cmp(
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(high)) < 1);
	});
var $author$project$Page$Remedy$History$versionAnnotation = function (_v0) {
	var version = _v0.dx;
	var createdAt = _v0.dT;
	return _Utils_Tuple2(
		createdAt,
		'v' + $elm$core$String$fromInt(version));
};
var $author$project$Page$Remedy$History$versionAnnotations = F3(
	function (remedies, startTime, endTime) {
		return A2(
			$elm$core$List$map,
			$author$project$Page$Remedy$History$versionAnnotation,
			A2(
				$elm$core$List$filter,
				function (r) {
					return A2(
						$author$project$Util$Date$between,
						r.dT,
						{gg: endTime, gF: startTime});
				},
				remedies));
	});
var $author$project$Page$Remedy$History$viewDeflectionChart = F2(
	function (stats, remedies) {
		return $author$project$Data$Chart$isEmpty(stats.d0) ? $author$project$View$EmptyStates$view('No remedy deflection data available') : A3(
			$author$project$TimeChart$viewWithAnnotations,
			stats.d0,
			false,
			A3($author$project$Page$Remedy$History$versionAnnotations, remedies, stats.e1, stats.d6));
	});
var $author$project$Page$Remedy$History$viewExplainDeflections = A2(
	$elm_explorations$markdown$Markdown$toHtml,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('well'),
			A2($elm$html$Html$Attributes$style, 'color', 'var(--pl-text-color-secondary)')
		]),
	'\n#### What is a Successful Deflection?\n\nA deflection is successful when:\n- a remedy is shown to a user\n- AND, for the next 24 hours, the user does not begin a chat with a human support agent\n');
var $author$project$Util$Numbers$prettyInt = F2(
	function (_v0, k) {
		var decimals = _v0.fW;
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
				{fW: decimals}),
			k);
	});
var $author$project$Page$Remedy$History$viewStat = F2(
	function (title, n) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('well'),
					$elm$html$Html$Attributes$class('text-center'),
					A2($elm$html$Html$Attributes$style, 'width', '180px'),
					A2($elm$html$Html$Attributes$style, 'height', '180px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Util$Numbers$prettyInt,
								{fW: 0},
								n))
						]))
				]));
	});
var $author$project$Page$Remedy$History$viewTotals = function (stats) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-3')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$Remedy$History$viewStat, '# of Times Shown', stats.hF)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-3')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$Remedy$History$viewStat, 'Successful Deflections', stats.hD)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-md-6')
					]),
				_List_fromArray(
					[$author$project$Page$Remedy$History$viewExplainDeflections]))
			]));
};
var $author$project$Page$Remedy$History$viewAnalyticsBody = function (model) {
	var _v0 = model.hr;
	switch (_v0.$) {
		case 0:
			return $author$project$View$ProgressBar$view;
		case 1:
			var stats = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Page$Remedy$History$viewTotals(stats),
						A2($author$project$Page$Remedy$History$viewDeflectionChart, stats, model.aJ)
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-warning')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-body')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Failed to load')
							]))
					]));
	}
};
var $author$project$Page$Remedy$History$viewAnalytics = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('clearfix')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Selected Time Period: ')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Page$Remedy$History$currentTimeRangeDescription(model.hr))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$author$project$TimePeriod$viewTimeSelector($author$project$Page$Remedy$History$ClickedStatsPeriod)
							]))
					])),
				$author$project$Page$Remedy$History$viewAnalyticsBody(model)
			]));
};
var $author$project$Page$Remedy$History$ClickedShowMoreVersions = {$: 1};
var $author$project$Page$Remedy$History$defaultNumVersionsToShow = 5;
var $author$project$Page$Remedy$History$viewVersionRow = F2(
	function (_v0, remedy) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(remedy.dT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									A2($author$project$App$Route$ViewRemedy, remedy.bj, remedy.dx))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(remedy.dx))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(remedy.dy)
						]))
				]));
	});
var $author$project$Page$Remedy$History$viewVersionTable = function (remedies) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Date', 20),
				_Utils_Tuple2('Version', 10),
				_Utils_Tuple2('Author', 70)
			]),
		$author$project$Page$Remedy$History$viewVersionRow,
		remedies);
};
var $author$project$Page$Remedy$History$viewVersionSection = function (model) {
	var numRemedies = $elm$core$List$length(model.aJ);
	var numToShow = model.cu ? numRemedies : $author$project$Page$Remedy$History$defaultNumVersionsToShow;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Version History'),
						(_Utils_cmp(numToShow, numRemedies) < 0) ? A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-link',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Remedy$History$ClickedShowMoreVersions)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Show all ' + ($elm$core$String$fromInt(numRemedies) + ' versions'))
									]))
							])) : $elm$html$Html$text('')
					])),
				$author$project$Page$Remedy$History$viewVersionTable(
				A2($elm$core$List$take, numToShow, model.aJ))
			]));
};
var $author$project$Page$Remedy$History$viewContent = F2(
	function (currentRemedy, model) {
		return $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbsCustom(
					_List_fromArray(
						[
							_Utils_Tuple2('Remedies', $author$project$App$Route$ListRemedies),
							_Utils_Tuple2(
							currentRemedy.bO,
							$author$project$App$Route$ViewRemedyHistory(model.cq))
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Remedy$History$ClickedDismissErrors),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(currentRemedy.bO),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(currentRemedy.b6)
								]))
						])),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$Page$Remedy$History$viewVersionSection(model),
					$author$project$Util$Html$verticalSpacer('10px'),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Analytics')
						])),
					$author$project$Page$Remedy$History$viewAnalytics(model),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(6)
				]));
	});
var $author$project$Page$Remedy$History$view = function (model) {
	var _v0 = $author$project$Page$Remedy$History$mostRecentRemedy(model);
	if (!_v0.$) {
		var remedy = _v0.a;
		return {
			bX: A2($author$project$Page$Remedy$History$viewContent, remedy, model),
			bO: 'Remedy History - ' + remedy.bO
		};
	} else {
		return {
			bX: A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Uh-oh, this remedy does not have any versions. That\'s a bug!')
					])),
			bO: 'Error'
		};
	}
};
var $author$project$Page$Remedy$List$DismissErrors = {$: 0};
var $author$project$Page$Remedy$List$applySearchTextFilter = F2(
	function (searchText, _v0) {
		var remedy = _v0.hd;
		var match = F2(
			function (s1, s2) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toLower(s1),
					$elm$core$String$toLower(s2));
			});
		return ($elm$core$String$length(searchText) < 2) ? true : (A2(match, searchText, remedy.bO) || (A2(match, searchText, remedy.b6) || A2(match, searchText, remedy.hN)));
	});
var $author$project$Page$Remedy$List$applySort = F3(
	function (sort, a, b) {
		switch (sort) {
			case 0:
				return A2($elm$core$Basics$compare, b.hr.a5, a.hr.a5);
			case 1:
				return A2($elm$core$Basics$compare, a.hr.a5, b.hr.a5);
			case 2:
				return A2($author$project$Util$Date$comparePosix, b.hd.dT, a.hd.dT);
			case 3:
				return A2($author$project$Util$Date$comparePosix, a.hd.dT, b.hd.dT);
			case 4:
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a.hd.bO),
					$elm$core$String$toLower(b.hd.bO));
			default:
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a.hd.hN),
					$elm$core$String$toLower(b.hd.hN));
		}
	});
var $author$project$Page$Remedy$List$applyStatusFilter = F2(
	function (filter, _v0) {
		var remedy = _v0.hd;
		switch (filter) {
			case 0:
				return true;
			case 1:
				return remedy.cM;
			default:
				return !remedy.cM;
		}
	});
var $author$project$Page$Remedy$List$SetSearchText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Remedy$List$Duplicate = 2;
var $author$project$Page$Remedy$List$ServeFrozenRemedy = 0;
var $author$project$Page$Remedy$List$ShowHideActionDropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Remedy$List$ShowJson = 1;
var $author$project$Request$Remedy$frozenRemedyUrl = function (remedy) {
	return '/gym/remedies/client/' + $author$project$UUID$toString(remedy.aa);
};
var $author$project$Request$Remedy$rawJsonDataUrl = function (remedy) {
	return '/gym/remedies/' + ($author$project$UUID$toString(remedy.bj) + '?format=json');
};
var $author$project$Page$Remedy$List$viewActionsDropdown = F2(
	function (_v0, remedy) {
		var accessToken = _v0.a;
		var openDropdownRemedyId = _v0.aq;
		var showUrl = $author$project$Request$Remedy$frozenRemedyUrl(remedy);
		var jsonUrl = $author$project$Request$Remedy$rawJsonDataUrl(remedy);
		var viewItem = function (_v2) {
			var name = _v2.a;
			var action = _v2.b;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						switch (action) {
							case 0:
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(showUrl)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]));
							case 1:
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(jsonUrl)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]));
							default:
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$App$Route$href(
											$author$project$App$Route$CloneRemedy(remedy.bj))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]));
						}
					}()
					]));
		};
		var items = _List_fromArray(
			[
				_Utils_Tuple2('Interactive Preview', 0),
				_Utils_Tuple2('Show Raw JSON', 1),
				_Utils_Tuple2('Duplicate', 2)
			]);
		var dropdownVisibility = _Utils_eq(
			$elm$core$Maybe$Just(remedy.bj),
			openDropdownRemedyId) ? 'block' : 'none';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id($author$project$Page$Remedy$List$actionDropdownId),
					$elm$html$Html$Attributes$class('dropdown')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-borderless btn-xs dropdown-toggle',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$Remedy$List$ShowHideActionDropdown(remedy.bj)),
							A2($elm$html$Html$Attributes$style, 'font-size', '1.1em'),
							$elm$html$Html$Attributes$title('Remedy Options')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-muted')
								]),
							_List_fromArray(
								[$author$project$Util$Glyphs$menuOverflow]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							A2($elm$html$Html$Attributes$style, 'left', 'unset'),
							A2($elm$html$Html$Attributes$style, 'right', '0'),
							A2($elm$html$Html$Attributes$style, 'display', dropdownVisibility)
						]),
					A2($elm$core$List$map, viewItem, items))
				]));
	});
var $author$project$Page$Remedy$List$viewRow = F2(
	function (model, _v0) {
		var remedy = _v0.hd;
		var stats = _v0.hr;
		var viewTag = function (t) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label btn btn-info'),
						$elm$html$Html$Events$onClick(
						$author$project$Page$Remedy$List$SetSearchText(t)),
						A2($elm$html$Html$Attributes$style, 'padding-top', '.15em'),
						$elm$html$Html$Attributes$title('Remedy tag extracted from title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$dropRight,
							1,
							A2($elm$core$String$dropLeft, 1, t)))
					]));
		};
		var usageText = (!remedy.cM) ? 'Disabled' : ($author$project$Util$Numbers$humanFloat(
			A2($elm$core$Basics$max, 0, stats.a5)) + ' / day');
		var tagRegex = $author$project$Util$Regex$regex('^\\[[^\\]]+]');
		var tagText = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.gG;
			},
			$elm$core$List$head(
				A2($elm$regex$Regex$find, tagRegex, remedy.bO)));
		var titleText = A3(
			$elm$regex$Regex$replace,
			tagRegex,
			function (_v1) {
				return '';
			},
			remedy.bO);
		var titleLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$App$Route$href(
					A2($author$project$App$Route$ViewRemedy, remedy.bj, remedy.dx)),
					A2($author$project$Util$Html$classIf, !remedy.cM, 'text-muted')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(titleText)
				]));
		var viewTitle = remedy.cM ? titleLink : A2(
			$elm$html$Html$s,
			_List_Nil,
			_List_fromArray(
				[titleLink]));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item'),
							A2($author$project$Util$Html$classIf, !remedy.cM, 'text-muted')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'top', '5px'),
									A2($elm$html$Html$Attributes$style, 'right', '5px')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Remedy$List$viewActionsDropdown, model, remedy)
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-heading')
								]),
							_List_fromArray(
								[viewTitle])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Html$viewMaybe, viewTag, tagText),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label label-default'),
											$elm$html$Html$Attributes$title('Classifier label trigger')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(remedy.hN)
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									$elm$html$Html$Attributes$title(remedy.b6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(remedy.b6)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text clearfix')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-left')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Created on ' + $author$project$Util$Date$formatDateWithNamedMonth(remedy.dT))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right'),
													$elm$html$Html$Attributes$title('Average number of remedy prescriptions per day.')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(usageText)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Remedy$List$viewTable = F2(
	function (remedies, model) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group'),
					A2($elm$html$Html$Attributes$style, 'list-style-type', 'none')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Remedy$List$viewRow(model),
				remedies));
	});
var $author$project$Page$Remedy$List$viewContent = function (model) {
	var remedies = A2(
		$elm$core$List$sortWith,
		$author$project$Page$Remedy$List$applySort(model.bJ),
		A2(
			$elm$core$List$filter,
			function (r) {
				return A2($author$project$Page$Remedy$List$applyStatusFilter, model.bL, r) && A2($author$project$Page$Remedy$List$applySearchTextFilter, model.bG, r);
			},
			model.hc));
	return $elm$core$List$isEmpty(remedies) ? $author$project$View$EmptyStates$view('No matches') : A2($author$project$Page$Remedy$List$viewTable, remedies, model);
};
var $author$project$Page$Remedy$List$SetSort = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Remedy$List$SetStatusFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Remedy$List$SortByLeastActive = 1;
var $author$project$Page$Remedy$List$SortByNewest = 2;
var $author$project$Page$Remedy$List$SortByOldest = 3;
var $author$project$Page$Remedy$List$SortByTitle = 4;
var $author$project$Page$Remedy$List$SortByTriggerLabel = 5;
var $author$project$Page$Remedy$List$allSorts = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Page$Remedy$List$AnyStatus = 0;
var $author$project$Page$Remedy$List$DisabledStatus = 2;
var $author$project$Page$Remedy$List$allStatusFilters = _List_fromArray(
	[0, 1, 2]);
var $author$project$Page$Remedy$List$sortToString = function (sort) {
	switch (sort) {
		case 0:
			return 'Most Active';
		case 1:
			return 'Least Active';
		case 2:
			return 'Newest';
		case 3:
			return 'Oldest';
		case 4:
			return 'Title';
		default:
			return 'Trigger';
	}
};
var $author$project$Page$Remedy$List$statusFilterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'Any';
		case 1:
			return 'Enabled';
		default:
			return 'Disabled';
	}
};
var $author$project$Page$Remedy$List$viewFilters = function (model) {
	var viewFilter = function (_v0) {
		var name = _v0.ev;
		var itemToString = _v0.gw;
		var currentItem = _v0.fS;
		var items = _v0.R;
		var onSelect = _v0.eA;
		var makeOption = function (item) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						itemToString(item)),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(item, currentItem))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						itemToString(item))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '0 .5em')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control input-sm'),
							$elm$html$Html$Attributes$title('Remedies Filter'),
							A3($author$project$Util$Html$onOptionSelected, items, currentItem, onSelect)
						]),
					A2($elm$core$List$map, makeOption, items))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-inline'),
				A2($elm$html$Html$Attributes$style, 'margin', '0')
			]),
		_List_fromArray(
			[
				viewFilter(
				{fS: model.bL, gw: $author$project$Page$Remedy$List$statusFilterToString, R: $author$project$Page$Remedy$List$allStatusFilters, ev: 'Status: ', eA: $author$project$Page$Remedy$List$SetStatusFilter}),
				viewFilter(
				{fS: model.bJ, gw: $author$project$Page$Remedy$List$sortToString, R: $author$project$Page$Remedy$List$allSorts, ev: 'Sort: ', eA: $author$project$Page$Remedy$List$SetSort})
			]));
};
var $author$project$Page$Remedy$List$viewSearchBox = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-control input-sm'),
						$elm$html$Html$Attributes$value(model.bG),
						$elm$html$Html$Attributes$placeholder('Filter by Title, Trigger, or Description'),
						$elm$html$Html$Events$onInput($author$project$Page$Remedy$List$SetSearchText)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Remedy$List$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Remedy$List$DismissErrors),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Remedies')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'flex-end'),
							A2($elm$html$Html$Attributes$style, 'padding-bottom', '6px')
						]),
					_List_fromArray(
						[
							$author$project$Page$Remedy$List$viewFilters(model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', 'auto')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Bootstrap$routeLinkButton, 'New Remedy', $author$project$App$Route$NewRemedy)
								]))
						])),
					$author$project$Page$Remedy$List$viewSearchBox(model),
					$elm$core$List$isEmpty(model.hc) ? $author$project$View$EmptyStates$view('Your team hasn\'t created any remedies yet') : $author$project$Page$Remedy$List$viewContent(model),
					$author$project$View$Docs$helpBox(6)
				])),
		bO: 'Remedies'
	};
};
var $author$project$Page$Remedy$Viewer$ClickedDismissErrors = {$: 0};
var $author$project$Remedy$title = function (_v0) {
	var remedy = _v0;
	return remedy.bO;
};
var $author$project$Page$Remedy$Viewer$ConfirmDeleteDialog = 1;
var $author$project$Page$Remedy$Viewer$SetDialog = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Remedy$Viewer$viewDeleteButton = function (deleting) {
	return deleting ? A3(
		$author$project$Util$Bootstrap$button,
		'btn-danger',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Deleting...')
			])) : A3(
		$author$project$Util$Bootstrap$button,
		'btn-danger',
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Page$Remedy$Viewer$SetDialog(1))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Delete')
			]));
};
var $author$project$Page$Remedy$Viewer$CommitDialog = {$: 7};
var $author$project$Page$Remedy$Viewer$viewDialog = function (model) {
	var _v0 = model.b7;
	if (_v0 === 1) {
		return $author$project$Util$Bootstrap$viewModal(
			{
				bX: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to delete this remedy?')
							]))),
				dM: $author$project$Page$Remedy$Viewer$SetDialog(0),
				ec: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-default',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Page$Remedy$Viewer$SetDialog(0))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-danger',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Remedy$Viewer$CommitDialog)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('DELETE!')
									]))
							]))),
				bO: 'Delete Remedy',
				fh: $elm$core$Maybe$Nothing
			});
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Remedy$createdAt = function (_v0) {
	var remedy = _v0;
	return remedy.dT;
};
var $author$project$Remedy$description = function (_v0) {
	var remedy = _v0;
	return remedy.b6;
};
var $author$project$Remedy$isEnabled = function (_v0) {
	var remedy = _v0;
	return remedy.cM;
};
var $author$project$Remedy$triggerLabel = function (_v0) {
	var remedy = _v0;
	return remedy.hN;
};
var $author$project$Remedy$triggerPriority = function (_v0) {
	var remedy = _v0;
	return remedy.fc;
};
var $author$project$Page$Remedy$Viewer$viewClassifiers = function (_v0) {
	var classifiers = _v0.fJ;
	var pill = function (c) {
		return A4(
			$author$project$Util$Bootstrap$classifierPill,
			$author$project$App$Route$ViewClassifier(c.bj),
			false,
			c.bO,
			c.b6);
	};
	return $elm$core$List$isEmpty(classifiers) ? $elm$html$Html$text('None') : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, pill, classifiers));
};
var $author$project$Page$Remedy$Viewer$viewMeta = function (model) {
	var viewPair = function (_v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(a),
							$elm$html$Html$text(': ')
						])),
					b
				]));
	};
	var r = model.hd;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Meta')
					])),
				viewPair(
				_Utils_Tuple2(
					'Description',
					$elm$html$Html$text(
						$author$project$Remedy$description(r)))),
				viewPair(
				_Utils_Tuple2(
					'Version',
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$author$project$Remedy$version(r))),
								$elm$html$Html$text(' '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$App$Route$href(
										$author$project$App$Route$ViewRemedyHistory(
											$author$project$Remedy$id(r)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('(all versions)')
									]))
							])))),
				viewPair(
				_Utils_Tuple2(
					'Created At',
					$elm$html$Html$text(
						$author$project$Util$Date$formatDateAndTime(
							$author$project$Remedy$createdAt(r))))),
				viewPair(
				_Utils_Tuple2(
					'Enabled',
					$elm$html$Html$text(
						$author$project$Util$Bool$toString(
							$author$project$Remedy$isEnabled(r))))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-default')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Trigger')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-body')
							]),
						_List_fromArray(
							[
								viewPair(
								_Utils_Tuple2(
									'Label',
									$elm$html$Html$text(
										$author$project$Remedy$triggerLabel(r)))),
								viewPair(
								_Utils_Tuple2(
									'Associated Classifiers',
									$author$project$Page$Remedy$Viewer$viewClassifiers(model))),
								viewPair(
								_Utils_Tuple2(
									'Priority',
									$elm$html$Html$text(
										$elm$core$String$fromInt(
											$author$project$Remedy$triggerPriority(r)))))
							]))
					]))
			]));
};
var $author$project$Page$Remedy$Viewer$EmittedRemedyActions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Remedy$HeatMap$Percentages = function (a) {
	return {$: 2, a: a};
};
var $author$project$Remedy$HeatMap$RawCounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Remedy$Viewer$histogramDataFor = F3(
	function (screenId, lang, histogram) {
		return _Utils_update(
			histogram,
			{
				dF: A2(
					$elm$core$List$filter,
					function (b) {
						return _Utils_eq(b.hk, screenId) && _Utils_eq(b.gB, lang);
					},
					histogram.dF)
			});
	});
var $author$project$Page$Remedy$Viewer$makeViewModel = function (model) {
	return {
		fm: $author$project$Page$Remedy$Viewer$EmittedRemedyActions,
		aE: model.aE,
		gf: function () {
			var _v0 = model.bi;
			if (_v0.$ === 1) {
				var hist = _v0.a;
				var _v1 = model.bw;
				switch (_v1) {
					case 1:
						return $author$project$Remedy$HeatMap$RawCounts(
							A3($author$project$Page$Remedy$Viewer$histogramDataFor, model.aE, model.gB, hist));
					case 2:
						return $author$project$Remedy$HeatMap$Percentages(
							A3($author$project$Page$Remedy$Viewer$histogramDataFor, model.aE, model.gB, hist));
					default:
						return $author$project$Remedy$HeatMap$Off;
				}
			} else {
				return $author$project$Remedy$HeatMap$Off;
			}
		}(),
		gB: model.gB,
		hd: model.hd
	};
};
var $author$project$Page$Remedy$Viewer$viewPreview = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Preview')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-success')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Language: ' + $author$project$Remedy$Localization$languageName(model.gB))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-body'),
								A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-remedy-bg-color)')
							]),
						_List_fromArray(
							[
								$author$project$Remedy$view(
								$author$project$Page$Remedy$Viewer$makeViewModel(model))
							]))
					]))
			]));
};
var $author$project$Page$Remedy$Viewer$ClickedGoToFirstScreen = {$: 2};
var $author$project$Page$Remedy$Viewer$ClickedLanguageButton = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Remedy$Viewer$ClickedMode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Remedy$Viewer$HeatCounts = 1;
var $author$project$Page$Remedy$Viewer$HeatPercentages = 2;
var $author$project$Page$Remedy$Viewer$modeText = function (mode) {
	switch (mode) {
		case 0:
			return 'Off';
		case 1:
			return '# Times Clicked';
		default:
			return '% Time Clicked';
	}
};
var $author$project$Page$Remedy$Viewer$viewModeDropdown = function (currentlySelectedMode) {
	return $author$project$Util$Html$dropdownAdvanced(
		{
			fS: currentlySelectedMode,
			gw: $author$project$Page$Remedy$Viewer$modeText,
			R: _List_fromArray(
				[0, 1, 2]),
			eA: $author$project$Page$Remedy$Viewer$ClickedMode
		});
};
var $author$project$Page$Remedy$Viewer$viewTools = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Tools')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Language: ')
							])),
						A3(
						$author$project$Remedy$Localization$viewLangButtons,
						$author$project$Page$Remedy$Viewer$ClickedLanguageButton,
						$elm$core$Maybe$Nothing,
						$author$project$Remedy$localizedStrings(model.hd))
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Heat Map: '),
						$author$project$Page$Remedy$Viewer$viewModeDropdown(model.bw),
						function () {
						var _v0 = model.bi;
						switch (_v0.$) {
							case 0:
								return $elm$html$Html$text('Loading...');
							case 2:
								return $elm$html$Html$text('Failed');
							default:
								return $elm$html$Html$text('');
						}
					}()
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				(!_Utils_eq(
				model.aE,
				$author$project$Remedy$firstScreenId(model.hd))) ? A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Remedy$Viewer$ClickedGoToFirstScreen)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Go to 1st Screen')
					])) : $elm$html$Html$text('')
			]));
};
var $author$project$Page$Remedy$Viewer$view = function (model) {
	var _v0 = _Utils_Tuple3(
		$author$project$Remedy$id(model.hd),
		$author$project$Remedy$version(model.hd),
		$author$project$Remedy$title(model.hd));
	var remedyId = _v0.a;
	var remedyVersion = _v0.b;
	var remedyTitle = _v0.c;
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Page$Remedy$Viewer$viewDialog(model),
					$author$project$Util$Bootstrap$breadcrumbsCustom(
					_List_fromArray(
						[
							_Utils_Tuple2('Remedies', $author$project$App$Route$ListRemedies),
							_Utils_Tuple2(
							remedyTitle,
							$author$project$App$Route$ViewRemedyHistory(remedyId)),
							_Utils_Tuple2(
							'Version ' + $elm$core$String$fromInt(remedyVersion),
							A2($author$project$App$Route$ViewRemedy, remedyId, remedyVersion))
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Remedy$Viewer$ClickedDismissErrors),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(remedyTitle),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									$author$project$Page$Remedy$Viewer$viewDeleteButton(model.bo),
									$elm$html$Html$text(' '),
									A2(
									$author$project$Util$Bootstrap$routeLinkButton,
									'Edit ',
									$author$project$App$Route$EditRemedy(remedyId))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-3')
								]),
							_List_fromArray(
								[
									$author$project$Page$Remedy$Viewer$viewMeta(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-6')
								]),
							_List_fromArray(
								[
									$author$project$Page$Remedy$Viewer$viewPreview(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-md-3')
								]),
							_List_fromArray(
								[
									$author$project$Page$Remedy$Viewer$viewTools(model)
								]))
						])),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(6)
				])),
		bO: 'Remedy - ' + remedyTitle
	};
};
var $author$project$Page$Scrubber$Editor$DismissErrors = {$: 0};
var $author$project$Page$Scrubber$Editor$AddRedactor = {$: 10};
var $author$project$Page$Scrubber$Editor$Save = {$: 1};
var $author$project$Page$Scrubber$Editor$SetDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Scrubber$Editor$SetEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Scrubber$Editor$DeleteRedactorAt = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Scrubber$Editor$SetRedactorFilenamePatternAt = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$Scrubber$Editor$SetRedactorKeyPathAt = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Scrubber$Editor$SetRedactorRedactionPatternAt = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Page$Scrubber$Editor$SetRedactorTypeAt = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Data$Scrubber$allRedactorTypes = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Page$Scrubber$Editor$notesLabelForKeyPath = function (keyPath) {
	return A2(
		$author$project$Util$Bootstrap$textLabel,
		'Notes',
		$elm$core$String$isEmpty(keyPath) ? 'All strings in the JSON are eligible for redaction' : ('Only the data located at key-path \'' + (keyPath + '\' will be redacted')));
};
var $author$project$Page$Scrubber$Editor$redactorTypeToString = function (type_) {
	switch (type_) {
		case 0:
			return 'All';
		case 1:
			return 'Incident Data';
		case 2:
			return 'Text Files';
		default:
			return 'JSON Files';
	}
};
var $author$project$Page$Scrubber$Editor$viewEditRedactor = F3(
	function (dataKeyPaths, index, redactor) {
		var deleteButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-default btn-xs pull-right'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Scrubber$Editor$DeleteRedactorAt(index))
				]),
			_List_fromArray(
				[$author$project$Util$Glyphs$x]));
		var typeField = A2(
			$author$project$Util$Bootstrap$formField,
			'Location',
			_List_fromArray(
				[
					$author$project$Util$Html$dropdownAdvanced(
					{
						fS: $author$project$Data$Scrubber$configToType(redactor),
						gw: $author$project$Page$Scrubber$Editor$redactorTypeToString,
						R: $author$project$Data$Scrubber$allRedactorTypes,
						eA: $author$project$Page$Scrubber$Editor$SetRedactorTypeAt(index)
					}),
					deleteButton
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
					A2($elm$html$Html$Attributes$style, 'padding', '10px'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'var(--pl-page-bg-color-secondary)'),
					$elm$html$Html$Attributes$class('form-horizontal')
				]),
			A2(
				$elm$core$List$cons,
				typeField,
				function () {
					switch (redactor.$) {
						case 0:
							var redactionPattern = redactor.a.B;
							return _List_fromArray(
								[
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorRedactionPatternAt(index),
									'Redaction Pattern',
									redactionPattern),
									A2($author$project$Util$Bootstrap$textLabel, 'Notes', 'Redacts strings in incident data and text files')
								]);
						case 1:
							var keyPath = redactor.a.gy;
							var redactionPattern = redactor.a.B;
							var state = {
								gn: '',
								go: keyPath,
								aM: dataKeyPaths,
								hO: 'incident-data-row' + $elm$core$String$fromInt(index)
							};
							var config = {
								ft: _List_Nil,
								fD: 'form-control',
								g$: $author$project$Page$Scrubber$Editor$SetRedactorKeyPathAt(index)
							};
							return _List_fromArray(
								[
									A2(
									$author$project$Util$Bootstrap$formField,
									'Key Path',
									A2($author$project$View$KeyPathSuggestion$view, config, state)),
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorRedactionPatternAt(index),
									'Redaction Pattern',
									redactionPattern),
									$author$project$Page$Scrubber$Editor$notesLabelForKeyPath(keyPath)
								]);
						case 2:
							var fileNamePattern = redactor.a.aH;
							var redactionPattern = redactor.a.B;
							return _List_fromArray(
								[
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorFilenamePatternAt(index),
									'Filename Pattern',
									fileNamePattern),
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorRedactionPatternAt(index),
									'Redaction Pattern',
									redactionPattern),
									A2($author$project$Util$Bootstrap$textLabel, 'Notes', 'Redacts lines of text from text files')
								]);
						default:
							var fileNamePattern = redactor.a.aH;
							var keyPath = redactor.a.gy;
							var redactionPattern = redactor.a.B;
							return _List_fromArray(
								[
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorFilenamePatternAt(index),
									'Filename Pattern',
									fileNamePattern),
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorKeyPathAt(index),
									'Key Path',
									keyPath),
									A4(
									$author$project$Util$Bootstrap$textField,
									_List_Nil,
									$author$project$Page$Scrubber$Editor$SetRedactorRedactionPatternAt(index),
									'Redaction Pattern',
									redactionPattern),
									$author$project$Page$Scrubber$Editor$notesLabelForKeyPath(keyPath)
								]);
					}
				}()));
	});
var $author$project$Page$Scrubber$Editor$viewRedactorsTable = F2(
	function (redactors, dataKeyPaths) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'list-style-type', 'none'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '0')
				]),
			A2(
				$elm$core$List$indexedMap,
				$author$project$Page$Scrubber$Editor$viewEditRedactor(dataKeyPaths),
				redactors));
	});
var $author$project$Page$Scrubber$Editor$viewEdit = function (model) {
	var _v0 = model.E;
	var id = _v0.bj;
	var actor = _v0.dy;
	var createdAt = _v0.dT;
	var version = _v0.dx;
	var description = _v0.b6;
	var redactorConfigs = _v0.df;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Edit Scrubber'),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Scrubber$Editor$Save),
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-horizontal')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Util$Bootstrap$textLabel,
						'ID',
						$author$project$UUID$toString(id)),
						A4($author$project$Util$Bootstrap$textField, _List_Nil, $author$project$Page$Scrubber$Editor$SetDescription, 'Description', description),
						model.bn ? $elm$html$Html$text('') : A2(
						$author$project$Util$Bootstrap$textLabel,
						'Last Modified',
						$author$project$Util$Date$formatDateAndTime(createdAt) + (' by ' + actor)),
						A2(
						$author$project$Util$Bootstrap$textLabel,
						'Version',
						$elm$core$String$fromInt(version)),
						A4($author$project$Util$Bootstrap$checkbox, _List_Nil, $author$project$Page$Scrubber$Editor$SetEnabled, 'Enabled', model.E.cM)
					])),
				A2($author$project$Page$Scrubber$Editor$viewRedactorsTable, redactorConfigs, model.cI),
				A3(
				$author$project$Util$Bootstrap$button,
				'btn-primary',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Page$Scrubber$Editor$AddRedactor)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add')
					]))
			]));
};
var $author$project$Page$Scrubber$Editor$LoadPreviewIncident = {$: 12};
var $author$project$Page$Scrubber$Editor$SetInputIncidentId = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Scrubber$Editor$UpdatePreviewTreeState = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Scrubber$Editor$viewFileItem = function (logMeta) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(logMeta.hQ)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(logMeta.ev)
					]))
			]));
};
var $author$project$Page$Scrubber$Editor$viewTryState = function (tryState) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Files')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Page$Scrubber$Editor$viewFileItem, tryState.ep)),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Incident Data')
					])),
				A3(
				$author$project$JsonTree$View$viewCore,
				tryState.gk,
				{eA: $elm$core$Maybe$Nothing, fa: $author$project$Page$Scrubber$Editor$UpdatePreviewTreeState},
				tryState.cy)
			]));
};
var $author$project$Page$Scrubber$Editor$viewPreview = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Preview')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Incident: '),
						A3(
						$author$project$Util$Html$textFieldAdvanced,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', '350px'),
								$elm$html$Html$Attributes$placeholder('UUID')
							]),
						$author$project$Page$Scrubber$Editor$SetInputIncidentId,
						model.bk),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Scrubber$Editor$LoadPreviewIncident)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Go')
							])),
						A2($author$project$Util$Html$viewIf, model.aL, $author$project$View$ProgressBar$view),
						function () {
						var _v0 = model.aV;
						switch (_v0.$) {
							case 3:
								var tryState = _v0.a;
								return $author$project$Page$Scrubber$Editor$viewTryState(tryState);
							case 1:
								return $elm$html$Html$text('loading...');
							case 0:
								return $elm$html$Html$text('');
							default:
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Failed to load preview')
										]));
						}
					}()
					]))
			]));
};
var $author$project$Page$Scrubber$Editor$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[
							$author$project$App$Route$Admin,
							$author$project$App$Route$ListScrubbers,
							$author$project$App$Route$EditScrubber(model.E.bj)
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Scrubber$Editor$DismissErrors),
					$author$project$Page$Scrubber$Editor$viewEdit(model),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$Page$Scrubber$Editor$viewPreview(model),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(9)
				])),
		bO: 'Edit Scrubber - ' + $author$project$UUID$toString(model.E.bj)
	};
};
var $author$project$Page$Scrubber$List$DismissErrors = 0;
var $author$project$Page$Scrubber$List$viewRow = F2(
	function (_v0, scrubber) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Bootstrap$fixedWidthTextCell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$EditScrubber(scrubber.bj)),
									$elm$html$Html$Attributes$class('trackedLink')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$UUID$toString(scrubber.bj))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Date$formatDateAndTime(scrubber.dT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(scrubber.b6)
						]))
				]));
	});
var $author$project$Page$Scrubber$List$viewTable = function (scrubbers) {
	return A3(
		$author$project$Util$Bootstrap$fixedWidthTable,
		_List_fromArray(
			[
				_Utils_Tuple2('Title', 25),
				_Utils_Tuple2('Last Modified', 15),
				_Utils_Tuple2('Description', 60)
			]),
		$author$project$Page$Scrubber$List$viewRow,
		scrubbers);
};
var $author$project$Page$Scrubber$List$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[$author$project$App$Route$Admin, $author$project$App$Route$ListScrubbers])),
					A2($author$project$View$Error$view, model.f$, 0),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('clearfix')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Scrubbers'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									A2($author$project$Util$Bootstrap$routeLinkButton, 'New Scrubber', $author$project$App$Route$NewScrubber)
								]))
						])),
					$elm$core$List$isEmpty(model.ct) ? $author$project$View$EmptyStates$view('Your team hasn\'t defined any scrubbers') : $author$project$Page$Scrubber$List$viewTable(model.ct),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$View$Docs$helpBox(9)
				])),
		bO: 'Scrubbers'
	};
};
var $author$project$Page$SdkList$DismissErrors = {$: 0};
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Page$SdkList$tabToString = function (tab) {
	switch (tab) {
		case 0:
			return 'iOS / macOS';
		case 1:
			return 'Android / Java';
		case 2:
			return '.NET';
		default:
			return 'Office Liblet';
	}
};
var $author$project$Page$SdkList$viewTabContent = function (tab) {
	var ddBig = $elm$html$Html$dd(
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px')
			]));
	var content = function () {
		switch (tab) {
			case 0:
				return {
					ba: $elm$core$Maybe$Just('docs/ios/index.html'),
					by: $elm$core$Maybe$Nothing,
					e3: 'Production',
					hQ: 'https://office.visualstudio.com/PowerLift/PowerLift%20Team/_git/powerlift-cocoa-sdk'
				};
			case 1:
				return {ba: $elm$core$Maybe$Nothing, by: $elm$core$Maybe$Nothing, e3: 'Production', hQ: 'https://office.visualstudio.com/PowerLift/PowerLift%20Team/_git/powerlift-android-sdk'};
			case 2:
				return {ba: $elm$core$Maybe$Nothing, by: $elm$core$Maybe$Nothing, e3: 'Production, but no support for remedies', hQ: 'https://office.visualstudio.com/PowerLift/PowerLift%20Team/_git/powerlift-net-sdk'};
			default:
				return {
					ba: $elm$core$Maybe$Nothing,
					by: $elm$core$Maybe$Just('Available via //devmain. Email us for more details'),
					e3: 'Production, but no support for remedies',
					hQ: 'https://aka.ms/powerlift-liblet-vsts-search'
				};
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Page$SdkList$tabToString(tab))
					])),
				A2(
				$elm$html$Html$dl,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dt,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Status')
								])),
							ddBig(
							_List_fromArray(
								[
									$elm$html$Html$text(content.e3)
								])),
							A2(
							$elm$html$Html$dt,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('URL')
								])),
							ddBig(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(content.hQ)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(content.hQ)
										]))
								]))
						]),
					_Utils_ap(
						function () {
							var _v0 = content.ba;
							if (!_v0.$) {
								var docsUrl = _v0.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$dt,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Docs')
											])),
										ddBig(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(docsUrl)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(docsUrl)
													]))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v1 = content.by;
							if (!_v1.$) {
								var notes = _v1.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$dt,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Notes')
											])),
										ddBig(
										_List_fromArray(
											[
												$elm$html$Html$text(notes)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}())))
			]));
};
var $author$project$Page$SdkList$viewMainPane = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Page$SdkList$viewTabContent(model.av)
			]));
};
var $author$project$Page$SdkList$DotNetTab = 2;
var $author$project$Page$SdkList$JavaTab = 1;
var $author$project$Page$SdkList$LibletTab = 3;
var $author$project$Page$SdkList$allTabs = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Page$SdkList$SelectTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$SdkList$viewTabs = F2(
	function (tabs, selectedTab) {
		var navItem = F2(
			function (activeTab, tab) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Page$SdkList$SelectTab(tab)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list-group-item', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(tab, activeTab))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Page$SdkList$tabToString(tab))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group')
						]),
					A2(
						$elm$core$List$map,
						navItem(selectedTab),
						tabs))
				]));
	});
var $author$project$Page$SdkList$viewSidePane = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Page$SdkList$viewTabs, $author$project$Page$SdkList$allTabs, model.av)
			]));
};
var $author$project$Page$SdkList$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[$author$project$App$Route$Home, $author$project$App$Route$ViewSDKs])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$SdkList$DismissErrors),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-2')
								]),
							_List_fromArray(
								[
									$author$project$Page$SdkList$viewSidePane(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-10')
								]),
							_List_fromArray(
								[
									$author$project$Page$SdkList$viewMainPane(model)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-12')
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Questions? Email us at '),
											$author$project$Util$Html$mailto('powerlifters@microsoft.com')
										]))
								]))
						]))
				])),
		bO: 'SDKs'
	};
};
var $author$project$Page$Tenant$DismissErrors = {$: 8};
var $author$project$Page$Tenant$ShowEditKeyModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Tenant$ShowNewKeyModal = {$: 1};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$Page$Tenant$isModalShowing = function (model) {
	var _v0 = model.j;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$Tenant$isSaving = function (model) {
	var _v0 = model.j;
	if (_v0.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Tenant$ChangeModalChecked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Tenant$ChangeModalInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Tenant$DismissModal = {$: 4};
var $author$project$Page$Tenant$SendCreateKeyRequest = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Tenant$SendSaveKeyRequest = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Page$Tenant$viewModal = function (state) {
	var viewModalWith = F6(
		function (title, submitLabel, description, error, submitMsg, body) {
			return $author$project$Util$Bootstrap$viewModal(
				{
					bX: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$form,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2 control-label'),
															$elm$html$Html$Attributes$for('inputDesc'),
															$elm$html$Html$Attributes$placeholder('API key description')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Description')
														])),
													A3(
													$author$project$Util$Html$textFieldAdvanced,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-control'),
															$elm$html$Html$Attributes$id('inputDesc')
														]),
													$author$project$Page$Tenant$ChangeModalInput,
													description)
												]))
										])),
									body,
									A2(
									$author$project$Util$Html$viewMaybe,
									function (e) {
										return A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-danger')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(e)
												]));
									},
									error)
								]))),
					dM: $author$project$Page$Tenant$DismissModal,
					ec: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Util$Bootstrap$button,
									'btn-default',
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Page$Tenant$DismissModal)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A3(
									$author$project$Util$Bootstrap$button,
									'btn-primary',
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(submitMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(submitLabel)
										]))
								]))),
					bO: title,
					fh: $elm$core$Maybe$Nothing
				});
		});
	switch (state.$) {
		case 1:
			var key = state.a;
			var values = state.b;
			var error = state.c;
			return A6(
				viewModalWith,
				'Edit API Key',
				'Save',
				values.b6,
				error,
				A2($author$project$Page$Tenant$SendSaveKeyRequest, key, values),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Util$Html$checkbox, $author$project$Page$Tenant$ChangeModalChecked, values.aC),
									$elm$html$Html$text('Active')
								]))
						])));
		case 2:
			var values = state.a;
			var error = state.b;
			return A6(
				viewModalWith,
				'Create New API Key',
				'Create',
				values.b6,
				error,
				$author$project$Page$Tenant$SendCreateKeyRequest(values),
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('help-block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create a new write-only key. This key can be used to upload incidents and files to PowerLift.' + (' Because it cannot be used to access data, it is safe to compile into your application.' + ' If you need an API key with read access, please contact us at ')),
							$author$project$Util$Html$mailto('powerlifters@microsoft.com'),
							$elm$html$Html$text('.')
						])));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Page$Tenant$view = function (model) {
	var accessDescription = F2(
		function (canRead, canWrite) {
			var _v2 = _Utils_Tuple2(canRead, canWrite);
			if (_v2.a) {
				if (_v2.b) {
					return 'Read/Write';
				} else {
					return 'Read only';
				}
			} else {
				if (_v2.b) {
					return 'Write only';
				} else {
					return 'None';
				}
			}
		});
	var viewKeyAccess = function (_v1) {
		var canRead = _v1.dJ;
		var canWrite = _v1.fz;
		var canAccessGym = _v1.fy;
		var gym = canAccessGym ? ' with Gym access' : '';
		return _Utils_ap(
			A2(accessDescription, canRead, canWrite),
			gym);
	};
	var viewApiKeyRow = function (key) {
		var keySuffixLength = $elm$core$String$length(key.en) - 4;
		var keySuffix = A2($elm$core$String$repeat, keySuffixLength, '*');
		var keyPrefix = A2($elm$core$String$left, 4, key.en);
		var viewApiKey = key.aC ? A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					_Utils_ap(keyPrefix, keySuffix))
				])) : A2(
			$elm$html$Html$small,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$s,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(keyPrefix, keySuffix))
						]))
				]));
		var disabledText = function () {
			var _v0 = _Utils_Tuple2(key.aC, key.fU);
			if ((!_v0.a) && (!_v0.b.$)) {
				var t = _v0.b.a;
				return ' — Deactivated on ' + $author$project$Util$Date$formatDateWithNamedMonth(t);
			} else {
				return '';
			}
		}();
		var description = A2($elm$core$Maybe$withDefault, '', key.b6);
		var viewButton = A3(
			$author$project$Util$Bootstrap$button,
			'btn-default btn-sm pull-right',
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$Tenant$ShowEditKeyModal,
						key.eL,
						{aC: key.aC, b6: description})),
					$elm$html$Html$Attributes$disabled(
					$author$project$Page$Tenant$isModalShowing(model))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit')
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group-item clearfix'),
					A2($author$project$Util$Html$classIf, !key.aC, 'text-muted')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pull-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text')
								]),
							_List_fromArray(
								[viewApiKey])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Added on ' + ($author$project$Util$Date$formatDateWithNamedMonth(key.dT) + disabledText))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											viewKeyAccess(key))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pull-right')
						]),
					_List_fromArray(
						[viewButton]))
				]));
	};
	var viewApiKeys = A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group')
			]),
		A2($elm$core$List$map, viewApiKeyRow, model.bI.fq));
	var viewSecurityGroupRow = function (securityGroup) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(securityGroup.fZ)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(securityGroup.fl)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Bool$toString(securityGroup.aC))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(accessDescription, securityGroup.dJ, securityGroup.fz))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Util$Bool$toString(securityGroup.fo))
						]))
				]));
	};
	var viewSecurityGroups = A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('table'),
				$elm$html$Html$Attributes$class('table-bordered')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Display Name')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('AAD ID')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Is Active?')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Access')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Allow Non-FTE?')
									]))
							]))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2($elm$core$List$map, viewSecurityGroupRow, model.bI.hm))
			]));
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Tenant$DismissErrors),
					$author$project$View$ProgressBar$viewIf(
					$author$project$Page$Tenant$isSaving(model)),
					$author$project$Page$Tenant$viewModal(model.j),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('clearfix')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pull-left')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('API Keys')
												]))
										])),
									A3(
									$author$project$Util$Bootstrap$button,
									'btn-borderless btn-sm pull-right',
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Page$Tenant$ShowNewKeyModal),
											A2($elm$html$Html$Attributes$style, 'margin-top', '26px')
										]),
									_List_fromArray(
										[$author$project$Util$Glyphs$plus]))
								])),
							viewApiKeys
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Security Groups')
								])),
							viewSecurityGroups
						]))
				])),
		bO: 'Tenant Settings'
	};
};
var $author$project$Page$Timeline$viewDate = function (date) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#777'),
				$elm$html$Html$Attributes$class('pull-right')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Util$Date$formatDateAndTime(date))
			]));
};
var $author$project$Page$Timeline$viewLabel = F2(
	function (modifier, str) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('label label-' + modifier),
					A2($elm$html$Html$Attributes$style, 'margin-right', '4px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Page$Timeline$viewFeedback = F3(
	function (date, _v0, feedback) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Timeline$viewDate(date),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Util$Glyphs$tag,
							$elm$html$Html$text(' '),
							$elm$html$Html$text('Remedy Feedback: '),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$Timeline$viewLabel, 'default', feedback.f0)
								]))
						]))
				]));
	});
var $author$project$Util$Glyphs$cloudUpload = $author$project$Util$Glyphs$make('glyphicon-cloud-upload');
var $author$project$Page$Timeline$viewLogMeta = function (_v0) {
	var name = _v0.ev;
	var url = _v0.hQ;
	var size = _v0.e$;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$class('trackedLink'),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]))
			]));
};
var $author$project$Page$Timeline$viewRouteLabel = F3(
	function (modifier, str, route) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('label label-' + modifier)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$App$Route$href(route),
							A2($elm$html$Html$Attributes$style, 'color', 'white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(str)
						]))
				]));
	});
var $author$project$Page$Timeline$viewIncident = F3(
	function (date, _v0, logMetas) {
		var meta = _v0.er;
		var analysis = _v0.dA;
		var viewRemedy = function () {
			var _v1 = analysis.hd;
			if (_v1.$ === 1) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('No remedy')
						]));
			} else {
				var remedy = _v1.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remedy: ')
								])),
							A3(
							$author$project$Page$Timeline$viewRouteLabel,
							'default',
							$author$project$UUID$toString(remedy.bj),
							$author$project$App$Route$EditRemedy(remedy.bj))
						]));
			}
		}();
		var viewClassifications = $elm$core$List$isEmpty(analysis.dL) ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No classifications')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('h4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Classifications: ')
							]))
					]),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Page$Timeline$viewLabel('default'),
						function ($) {
							return $.eo;
						}),
					analysis.dL)));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Timeline$viewDate(date),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Util$Glyphs$cloudUpload,
									$elm$html$Html$text(' '),
									$elm$html$Html$text('New Incident')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$viewIncident(meta.bj)),
									$elm$html$Html$Attributes$class('trackedLink')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$UUID$toString(meta.bj))
								]))
						])),
					viewClassifications,
					viewRemedy,
					$elm$core$List$isEmpty(logMetas) ? A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('No files')
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('well well-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (v) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Page$Timeline$viewLogMeta(v)
											]));
								},
								logMetas))
						]))
				]));
	});
var $author$project$Page$Timeline$viewMessage = F3(
	function (date, isEndUser, _v0) {
		var author = _v0.fu;
		var body = _v0.bX;
		var content = A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '70%'),
					A2($elm$html$Html$Attributes$style, 'padding', '6px'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '-6px'),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					isEndUser ? '#eef3ff' : 'white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(author)
						])),
					$elm$html$Html$text(': '),
					$elm$html$Html$text(body)
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Timeline$viewDate(date),
					content
				]));
	});
var $author$project$Page$Timeline$viewTicket = F3(
	function (date, issue, incidentId) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Timeline$viewDate(date),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Util$Glyphs$questionMark,
							$elm$html$Html$text(' '),
							$elm$html$Html$text('New Helpshift Ticket')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Helpshift: '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Data$Issue$helpshiftUrl(issue))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'#' + $elm$core$String$fromInt(issue.bj))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Incident ID: ' + incidentId)
						]))
				]));
	});
var $author$project$Page$Timeline$viewEvent = function (event) {
	switch (event.$) {
		case 0:
			var date = event.a;
			var liteIncident = event.b;
			var logMetas = event.c;
			return A3($author$project$Page$Timeline$viewIncident, date, liteIncident, logMetas);
		case 1:
			var date = event.a;
			var ticket = event.b;
			var incidentId = event.c;
			return A3($author$project$Page$Timeline$viewTicket, date, ticket, incidentId);
		case 2:
			var date = event.a;
			var isEndUser = event.b;
			var issueMessage = event.c;
			return A3($author$project$Page$Timeline$viewMessage, date, isEndUser, issueMessage);
		default:
			var date = event.a;
			var prescribedRemedy = event.b;
			var feedback = event.c;
			return A3($author$project$Page$Timeline$viewFeedback, date, prescribedRemedy, feedback);
	}
};
var $author$project$Page$Timeline$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Timeline '),
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('for install \'' + (model.ce + '\''))
										]))
								]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group')
						]),
					A2(
						$elm$core$List$map,
						function (evt) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group-item')
									]),
								_List_fromArray(
									[
										$author$project$Page$Timeline$viewEvent(evt)
									]));
						},
						model.cN))
				])),
		bO: 'Timeline'
	};
};
var $author$project$Page$Widget$CollectionEditor$DismissErrors = {$: 0};
var $author$project$Page$Widget$CollectionEditor$CreateBlankSection = {$: 4};
var $author$project$Page$Widget$CollectionEditor$CreateStarterSection = {$: 3};
var $author$project$Page$Widget$CollectionEditor$Save = {$: 1};
var $author$project$Page$Widget$CollectionEditor$MoveSection = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Widget$CollectionEditor$PromptToDeleteSection = function (a) {
	return {$: 6, a: a};
};
var $author$project$Util$Html$miniButtonBar = function (items) {
	var makeMiniButton = function (_v0) {
		var clickHandler = _v0.a;
		var content = _v0.b;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-default btn-xs'),
					$author$project$Util$Html$role('button'),
					$elm$html$Html$Events$onClick(clickHandler)
				]),
			_List_fromArray(
				[content]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn-group'),
				$author$project$Util$Html$role('group')
			]),
		A2($elm$core$List$map, makeMiniButton, items));
};
var $author$project$Page$Widget$CollectionEditor$viewRow = F2(
	function (index, section) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									$author$project$App$Route$EditWidgetSection(index))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(section.bO)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$elm$core$List$length(section.cB)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Util$Html$miniButtonBar(
							_List_fromArray(
								[
									_Utils_Tuple2(
									A2($author$project$Page$Widget$CollectionEditor$MoveSection, index, 0),
									$author$project$Util$Glyphs$triangleTop),
									_Utils_Tuple2(
									A2($author$project$Page$Widget$CollectionEditor$MoveSection, index, 1),
									$author$project$Util$Glyphs$triangleBottom),
									_Utils_Tuple2(
									$author$project$Page$Widget$CollectionEditor$PromptToDeleteSection(
										_Utils_Tuple2(index, section.bO)),
									$author$project$Util$Glyphs$x)
								]))
						]))
				]));
	});
var $author$project$Page$Widget$CollectionEditor$viewContent = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Incident Display'),
						model.cg ? A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' (saving...)')
							])) : $elm$html$Html$text(''),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Widget$CollectionEditor$Save),
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'max-width', '700px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('\nCustomize how your incidents are displayed in PowerLift. Each "section" that you add will be shown on\nthe incident page\'s sidebar. A section should contain at least one "widget". And each widget displays\nsome facet of your incident data.')
					])),
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sections')
					])),
				$elm$core$List$isEmpty(model.hl) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel panel-info')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No widgets yet')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Get started quickly by creating a widget.')
									])),
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-primary',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Widget$CollectionEditor$CreateStarterSection)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Starter Widget')
									])),
								$elm$html$Html$text(' '),
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-default',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Widget$CollectionEditor$CreateBlankSection)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Section')
									]))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '500px'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '15px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Util$Bootstrap$dynamicWidthTable,
						_List_fromArray(
							['Name', '# Widgets', 'Actions']),
						$author$project$Page$Widget$CollectionEditor$viewRow,
						model.hl),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Widget$CollectionEditor$CreateBlankSection)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('New Section')
							]))
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$View$Docs$helpBox(8)
			]));
};
var $author$project$Page$Widget$CollectionEditor$CancelPrompt = {$: 7};
var $author$project$Page$Widget$CollectionEditor$ConfirmDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Widget$CollectionEditor$viewDeletePrompt = F2(
	function (index, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-danger')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete?')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Are you sure you want to delete section \'' + (title + '\' and ALL of its widgets?'))
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Page$Widget$CollectionEditor$CancelPrompt)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-danger',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$Widget$CollectionEditor$ConfirmDelete(index)),
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Page$Widget$CollectionEditor$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[$author$project$App$Route$Admin, $author$project$App$Route$EditWidgetCollection])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Widget$CollectionEditor$DismissErrors),
					function () {
					var _v0 = model.aQ;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var index = _v1.a;
						var title = _v1.b;
						return A2($author$project$Page$Widget$CollectionEditor$viewDeletePrompt, index, title);
					} else {
						return $author$project$Page$Widget$CollectionEditor$viewContent(model);
					}
				}()
				])),
		bO: 'Widgets'
	};
};
var $author$project$Page$Widget$Editor$DismissErrors = {$: 0};
var $author$project$Page$Widget$Editor$CommitDialog = {$: 14};
var $author$project$Page$Widget$Editor$SetDialog = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Widget$Editor$viewTemplateEditorDialog = function (state) {
	var isInvalid = !$author$project$Page$Widget$Editor$isValidTemplate(state.bM);
	var inputForm = A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit($author$project$Page$Widget$Editor$CommitDialog)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-group'),
						A2($elm$html$Html$Attributes$style, 'margin', '15px'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('has-error', isInvalid)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Link / URL')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$value(state.bM),
								$elm$html$Html$Attributes$placeholder('http://example.com/search/' + $author$project$Data$Widget$Lens$templateVariable),
								$elm$html$Html$Events$onInput(
								function (newStr) {
									return $author$project$Page$Widget$Editor$SetDialog(
										$author$project$Page$Widget$Editor$EditLinkDialog(
											_Utils_update(
												state,
												{bM: newStr})));
								})
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Util$Html$visibleIf(isInvalid),
								$elm$html$Html$Attributes$class('help-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Must contain \'' + ($author$project$Data$Widget$Lens$templateVariable + '\''))
							]))
					]))
			]));
	var explanation = A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, '\nTransform the data value into a link/URL. For instance, if the current data value is "id-123"\nyou could transform it into a link to http://example.com/search/foo-123.\n\nThe special string `$Variable$` will be replaced by the current data value.\n');
	return $author$project$Util$Bootstrap$viewModal(
		{
			bX: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[explanation, inputForm]))),
			dM: $author$project$Page$Widget$Editor$SetDialog($author$project$Page$Widget$Editor$NoDialog),
			ec: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$Widget$Editor$SetDialog($author$project$Page$Widget$Editor$NoDialog))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Page$Widget$Editor$CommitDialog),
									$author$project$Util$Html$disableIf(isInvalid)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK')
								]))
						]))),
			bO: 'Edit Link Transform',
			fh: $elm$core$Maybe$Nothing
		});
};
var $author$project$Page$Widget$Editor$viewDialog = function (model) {
	var _v0 = model.b7;
	if (_v0.$ === 1) {
		var state = _v0.a;
		return $author$project$Page$Widget$Editor$viewTemplateEditorDialog(state);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Page$Widget$Editor$Save = {$: 1};
var $author$project$Page$Widget$Editor$SetTitle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Widget$Editor$inputField = function (_v0) {
	var str = _v0.cw;
	var placeholder = _v0.cm;
	var toMsg = _v0.fa;
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control input-sm'),
				$elm$html$Html$Attributes$value(str),
				$elm$html$Html$Attributes$placeholder(placeholder),
				$elm$html$Html$Events$onInput(toMsg)
			]),
		_List_Nil);
};
var $author$project$Page$Widget$Editor$EditDynamicList = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Widget$Editor$EditGeneric = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Widget$Editor$SetArrayKeyPath = $elm$core$Basics$identity;
var $author$project$JsonTree$isString = function (node) {
	var _v0 = node.hR;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$JsonTree$isListOfStrings = function (node) {
	var _v0 = node.hR;
	if (_v0.$ === 3) {
		var children = _v0.a;
		return A2($elm$core$List$all, $author$project$JsonTree$isString, children);
	} else {
		return false;
	}
};
var $author$project$Page$Widget$Editor$resolveNode = F2(
	function (jsonBundle, rawKeyPath) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Result$Err('Unable to resolve node'),
			function (bundle) {
				return A2($author$project$JsonTree$Resolver$resolve, rawKeyPath, bundle.cr);
			},
			jsonBundle);
	});
var $elm_community$result_extra$Result$Extra$unwrap = F3(
	function (defaultValue, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			return defaultValue;
		}
	});
var $author$project$Page$Widget$Editor$validateKeyPath = F3(
	function (jsonBundle, rawKeyPath, validate) {
		return A3(
			$elm_community$result_extra$Result$Extra$unwrap,
			false,
			validate,
			A2($author$project$Page$Widget$Editor$resolveNode, jsonBundle, rawKeyPath));
	});
var $author$project$Page$Widget$Editor$viewEditDynamicList = F2(
	function (cfg, jsonBundle) {
		var state = function (inputValue) {
			return {
				gn: '.data.myArray',
				go: inputValue,
				aM: A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function ($) {
						return $.aM;
					},
					jsonBundle),
				hO: 'dynamic-list'
			};
		};
		var isKeyPathValid = A3($author$project$Page$Widget$Editor$validateKeyPath, jsonBundle, cfg.K, $author$project$JsonTree$isListOfStrings);
		var config = {ft: _List_Nil, fD: 'form-control', g$: $elm$core$Basics$identity};
		return A2(
			$author$project$View$Form$container,
			isKeyPathValid,
			_List_fromArray(
				[
					A2(
					$author$project$View$Form$item,
					'Key-Path to Array of Strings',
					A2(
						$author$project$View$KeyPathSuggestion$view,
						config,
						state(cfg.K)))
				]));
	});
var $author$project$Page$Widget$Editor$AddColumn = {$: 6};
var $author$project$Page$Widget$Editor$ChangeColumnTransformTypeAt = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$DeleteColumn = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Widget$Editor$MoveColumn = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetColumnIsOptionalAt = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetColumnNameAt = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$ShowColumnLinkEditor = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Data$Widget$Lens$ByteCountTransformType = 2;
var $author$project$Data$Widget$Lens$DateTransformType = 1;
var $author$project$Data$Widget$Lens$DefaultTransformType = 0;
var $author$project$Data$Widget$Lens$LinkTransformType = 3;
var $author$project$Data$Widget$Lens$allTransformTypes = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$JsonTree$isKeyInDict = F2(
	function (key, dictNode) {
		var normalizedKey = A2($elm$core$String$startsWith, '.', key) ? A2($elm$core$String$dropLeft, 1, key) : key;
		var _v0 = dictNode.hR;
		if (_v0.$ === 4) {
			var items = _v0.a;
			return A2($elm$core$Dict$member, normalizedKey, items);
		} else {
			return false;
		}
	});
var $author$project$JsonTree$isKeyInDictList = F2(
	function (key, listNode) {
		var _v0 = listNode.hR;
		if (_v0.$ === 3) {
			var children = _v0.a;
			return A2(
				$elm$core$List$any,
				$author$project$JsonTree$isKeyInDict(key),
				children);
		} else {
			return false;
		}
	});
var $author$project$JsonTree$isDictionary = function (node) {
	var _v0 = node.hR;
	if (_v0.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$JsonTree$isListOfObjects = function (node) {
	var _v0 = node.hR;
	if (_v0.$ === 3) {
		var children = _v0.a;
		return A2($elm$core$List$all, $author$project$JsonTree$isDictionary, children);
	} else {
		return false;
	}
};
var $author$project$Data$Widget$Lens$toTransformType = function (transform) {
	switch (transform.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Page$Widget$Editor$transformName = function (tipe) {
	switch (tipe) {
		case 0:
			return 'Default';
		case 1:
			return 'Date';
		case 2:
			return 'Byte Count';
		default:
			return 'Link';
	}
};
var $author$project$Page$Widget$Editor$SetTableKeyPath = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Widget$Editor$viewEditDynamicTableBaseKeyPathInput = F2(
	function (arrayKeyPath, keyPaths) {
		var state = {gn: '.data.myArray', go: arrayKeyPath, aM: keyPaths, hO: 'dynamic-table-array'};
		var config = {ft: _List_Nil, fD: 'form-control', g$: $author$project$Page$Widget$Editor$SetTableKeyPath};
		return A2($author$project$View$KeyPathSuggestion$view, config, state);
	});
var $author$project$Page$Widget$Editor$SetColumnKeyPathAt = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$JsonTree$keysInDict = function (node) {
	var _v0 = node.hR;
	if (_v0.$ === 4) {
		var items = _v0.a;
		return $elm$core$Dict$keys(items);
	} else {
		return _List_Nil;
	}
};
var $author$project$JsonTree$keysInDictList = function (listNode) {
	var _v0 = listNode.hR;
	if (_v0.$ === 3) {
		var children = _v0.a;
		return $elm_community$list_extra$List$Extra$unique(
			A2($elm$core$List$concatMap, $author$project$JsonTree$keysInDict, children));
	} else {
		return _List_Nil;
	}
};
var $author$project$Page$Widget$Editor$dictionaryKeys = F2(
	function (jsonBundle, rawKeyPath) {
		var node = A2($author$project$Page$Widget$Editor$resolveNode, jsonBundle, rawKeyPath);
		return A3($elm_community$result_extra$Result$Extra$unwrap, _List_Nil, $author$project$JsonTree$keysInDictList, node);
	});
var $author$project$Page$Widget$Editor$viewEditDynamicTableRowInput = F4(
	function (jsonBundle, arrayKeyPath, dictionaryKey, index) {
		var state = {
			gn: '.data.foo.bar',
			go: dictionaryKey,
			aM: A2(
				$elm$core$List$map,
				$elm$core$Basics$append('.'),
				A2($author$project$Page$Widget$Editor$dictionaryKeys, jsonBundle, arrayKeyPath)),
			hO: 'dynamic-table-row-' + $elm$core$String$fromInt(index)
		};
		var config = {
			ft: _List_Nil,
			fD: 'form-control',
			g$: $author$project$Page$Widget$Editor$SetColumnKeyPathAt(index)
		};
		return A2($author$project$View$KeyPathSuggestion$view, config, state);
	});
var $author$project$Page$Widget$Editor$viewEditDynamicTable = F2(
	function (cfg, jsonBundle) {
		var isRelativeKeyPathValid = function (key) {
			return A3(
				$author$project$Page$Widget$Editor$validateKeyPath,
				jsonBundle,
				cfg.K,
				$author$project$JsonTree$isKeyInDictList(key));
		};
		var viewColumn = F2(
			function (index, column) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$View$Form$container,
									!$elm_community$string_extra$String$Extra$isBlank(column.ev),
									_List_fromArray(
										[
											$author$project$Page$Widget$Editor$inputField(
											{
												cm: '',
												cw: column.ev,
												fa: $author$project$Page$Widget$Editor$SetColumnNameAt(index)
											})
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$View$Form$container,
									isRelativeKeyPathValid(column.al.gy),
									A4($author$project$Page$Widget$Editor$viewEditDynamicTableRowInput, jsonBundle, cfg.K, column.al.gy, index))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									$author$project$Util$Html$dropdownAdvanced(
									{
										fS: $author$project$Data$Widget$Lens$toTransformType(column.al.ay),
										gw: $author$project$Page$Widget$Editor$transformName,
										R: $author$project$Data$Widget$Lens$allTransformTypes,
										eA: $author$project$Page$Widget$Editor$ChangeColumnTransformTypeAt(index)
									}),
									function () {
									var _v0 = column.al.ay;
									if (_v0.$ === 3) {
										var template = _v0.a;
										return A3(
											$author$project$Util$Bootstrap$button,
											'btn-link',
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													A2($author$project$Page$Widget$Editor$ShowColumnLinkEditor, index, template))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('edit')
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Util$Html$checkbox,
									$author$project$Page$Widget$Editor$SetColumnIsOptionalAt(index),
									column.al.cf)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									$author$project$Util$Html$miniButtonBar(
									_List_fromArray(
										[
											_Utils_Tuple2(
											A2($author$project$Page$Widget$Editor$MoveColumn, index, 0),
											$author$project$Util$Glyphs$triangleTop),
											_Utils_Tuple2(
											A2($author$project$Page$Widget$Editor$MoveColumn, index, 1),
											$author$project$Util$Glyphs$triangleBottom),
											_Utils_Tuple2(
											$author$project$Page$Widget$Editor$DeleteColumn(index),
											$author$project$Util$Glyphs$x)
										]))
								]))
						]));
			});
		var isBaseKeyPathValid = A3($author$project$Page$Widget$Editor$validateKeyPath, jsonBundle, cfg.K, $author$project$JsonTree$isListOfObjects);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$View$Form$container,
					isBaseKeyPathValid,
					A2(
						$author$project$Page$Widget$Editor$viewEditDynamicTableBaseKeyPathInput,
						cfg.K,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function ($) {
								return $.aM;
							},
							jsonBundle))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Columns')
								])),
							A3(
							$author$project$Util$Bootstrap$fixedWidthTable,
							_List_fromArray(
								[
									_Utils_Tuple2('Column Name', 20),
									_Utils_Tuple2('Relative Key-Path', 47),
									_Utils_Tuple2('Transform', 14),
									_Utils_Tuple2('Optional?', 9),
									_Utils_Tuple2('Actions', 10)
								]),
							viewColumn,
							cfg.b0),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-primary',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Page$Widget$Editor$AddColumn)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]))
						]))
				]));
	});
var $author$project$Page$Widget$Editor$SetKeyPath = $elm$core$Basics$identity;
var $author$project$Page$Widget$Editor$viewEditGeneric = F2(
	function (cfg, jsonBundle) {
		var state = function (inputValue) {
			return {
				gn: '.data.foo.bar',
				go: inputValue,
				aM: A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function ($) {
						return $.aM;
					},
					jsonBundle),
				hO: 'generic-json'
			};
		};
		var isKeyPathValid = A3(
			$author$project$Page$Widget$Editor$validateKeyPath,
			jsonBundle,
			cfg.gy,
			$elm$core$Basics$always(true));
		var config = {ft: _List_Nil, fD: 'form-control', g$: $elm$core$Basics$identity};
		return A2(
			$author$project$View$Form$container,
			isKeyPathValid,
			_List_fromArray(
				[
					A2(
					$author$project$View$Form$item,
					'KeyPath',
					A2(
						$author$project$View$KeyPathSuggestion$view,
						config,
						state(cfg.gy)))
				]));
	});
var $author$project$Page$Widget$Editor$AddRow = {$: 5};
var $author$project$Page$Widget$Editor$ChangeRowTransformTypeAt = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$DeleteRow = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Widget$Editor$MoveRow = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetLabelAt = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetRowIsOptionalAt = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$SetRowKeyPathAt = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Widget$Editor$ShowRowLinkEditor = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$JsonTree$isPrimitive = function (node) {
	var _v0 = node.hR;
	switch (_v0.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		default:
			return true;
	}
};
var $author$project$Page$Widget$Editor$viewEditStaticTable = F2(
	function (cfg, jsonBundle) {
		var state = F2(
			function (index, inputValue) {
				return {
					gn: '.data.foo.bar',
					go: inputValue,
					aM: A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function ($) {
							return $.aM;
						},
						jsonBundle),
					hO: 'static-table-row-' + $elm$core$String$fromInt(index)
				};
			});
		var isKeyPathValid = function (keyPath) {
			return A3($author$project$Page$Widget$Editor$validateKeyPath, jsonBundle, keyPath, $author$project$JsonTree$isPrimitive);
		};
		var config = function (index) {
			return {
				ft: _List_Nil,
				fD: 'form-control input-sm',
				g$: $author$project$Page$Widget$Editor$SetRowKeyPathAt(index)
			};
		};
		var viewRow = F2(
			function (index, row) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$View$Form$container,
									!$elm_community$string_extra$String$Extra$isBlank(row.eo),
									_List_fromArray(
										[
											$author$project$Page$Widget$Editor$inputField(
											{
												cm: '',
												cw: row.eo,
												fa: $author$project$Page$Widget$Editor$SetLabelAt(index)
											})
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$View$Form$container,
									isKeyPathValid(row.hR.gy),
									A2(
										$author$project$View$KeyPathSuggestion$view,
										config(index),
										A2(state, index, row.hR.gy)))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									$author$project$Util$Html$dropdownAdvanced(
									{
										fS: $author$project$Data$Widget$Lens$toTransformType(row.hR.ay),
										gw: $author$project$Page$Widget$Editor$transformName,
										R: $author$project$Data$Widget$Lens$allTransformTypes,
										eA: $author$project$Page$Widget$Editor$ChangeRowTransformTypeAt(index)
									}),
									function () {
									var _v0 = row.hR.ay;
									if (_v0.$ === 3) {
										var template = _v0.a;
										return A3(
											$author$project$Util$Bootstrap$button,
											'btn-link',
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													A2($author$project$Page$Widget$Editor$ShowRowLinkEditor, index, template))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('edit')
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Util$Html$checkbox,
									$author$project$Page$Widget$Editor$SetRowIsOptionalAt(index),
									row.hR.cf)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
								]),
							_List_fromArray(
								[
									$author$project$Util$Html$miniButtonBar(
									_List_fromArray(
										[
											_Utils_Tuple2(
											A2($author$project$Page$Widget$Editor$MoveRow, index, 0),
											$author$project$Util$Glyphs$triangleTop),
											_Utils_Tuple2(
											A2($author$project$Page$Widget$Editor$MoveRow, index, 1),
											$author$project$Util$Glyphs$triangleBottom),
											_Utils_Tuple2(
											$author$project$Page$Widget$Editor$DeleteRow(index),
											$author$project$Util$Glyphs$x)
										]))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rows')
						])),
					A3(
					$author$project$Util$Bootstrap$fixedWidthTable,
					_List_fromArray(
						[
							_Utils_Tuple2('Label', 20),
							_Utils_Tuple2('Key-Path to Value', 47),
							_Utils_Tuple2('Transform', 14),
							_Utils_Tuple2('Optional?', 9),
							_Utils_Tuple2('Actions', 10)
						]),
					viewRow,
					cfg.aW),
					A3(
					$author$project$Util$Bootstrap$button,
					'btn-primary',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Page$Widget$Editor$AddRow)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add')
						]))
				]));
	});
var $author$project$Page$Widget$Editor$viewEditData = function (model) {
	var remoteJsonBundle = $krisajenkins$remotedata$RemoteData$toMaybe(model.bF);
	var _v0 = model.fg.b3;
	switch (_v0.$) {
		case 0:
			var configuration = _v0.a.b1;
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Widget$Editor$EditStaticTable,
				A2($author$project$Page$Widget$Editor$viewEditStaticTable, configuration, remoteJsonBundle));
		case 2:
			var configuration = _v0.a.b1;
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Widget$Editor$EditDynamicList,
				A2($author$project$Page$Widget$Editor$viewEditDynamicList, configuration, remoteJsonBundle));
		case 1:
			var configuration = _v0.a.b1;
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Widget$Editor$EditDynamicTable,
				A2($author$project$Page$Widget$Editor$viewEditDynamicTable, configuration, remoteJsonBundle));
		default:
			var configuration = _v0.a.b1;
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Widget$Editor$EditGeneric,
				A2($author$project$Page$Widget$Editor$viewEditGeneric, configuration, remoteJsonBundle));
	}
};
var $author$project$Page$Widget$Editor$SetSection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Widget$Editor$currentSectionOf = function (model) {
	return A2(
		$elm_community$list_extra$List$Extra$getAt,
		model.F,
		$author$project$Page$Widget$Editor$allSections(model));
};
var $author$project$Page$Widget$Editor$viewEditSection = function (model) {
	var _v0 = $author$project$Page$Widget$Editor$currentSectionOf(model);
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No section found! This should never happen.')
				]));
	} else {
		var section = _v0.a;
		var items = A2(
			$elm$core$List$indexedMap,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			$author$project$Page$Widget$Editor$allSections(model));
		return $author$project$Util$Html$dropdownAdvanced(
			{
				fS: _Utils_Tuple2(model.F, section),
				gw: function (_v1) {
					var sec = _v1.b;
					return sec.bO;
				},
				R: items,
				eA: function (_v2) {
					var idx = _v2.a;
					return $author$project$Page$Widget$Editor$SetSection(idx);
				}
			});
	}
};
var $author$project$Page$Widget$Editor$viewEdit = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Widget Editor'),
						model.cg ? A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' (saving...)')
							])) : $elm$html$Html$text(''),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Widget$Editor$Save),
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'max-width', '350px')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$View$Form$item,
						'Title',
						_List_fromArray(
							[
								$author$project$Page$Widget$Editor$inputField(
								{cm: '', cw: model.fg.bO, fa: $author$project$Page$Widget$Editor$SetTitle})
							])),
						A2(
						$author$project$View$Form$item,
						'Section',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Page$Widget$Editor$viewEditSection(model)
									]))
							]))
					])),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$Page$Widget$Editor$viewEditData(model)
			]));
};
var $author$project$Page$Widget$Editor$LoadPreviewIncident = {$: 11};
var $author$project$Page$Widget$Editor$SetInputIncidentId = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Widget$Editor$PreviewDynamicList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Widget$Editor$PreviewDynamicTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Widget$Editor$PreviewGeneric = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Widget$Editor$PreviewMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Widget$Editor$PreviewStaticTable = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Widget$Editor$viewWidget = F3(
	function (tree, context, widget) {
		var _v0 = widget.b3;
		switch (_v0.$) {
			case 0:
				var subModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Page$Widget$Editor$PreviewMsg, $author$project$Page$Widget$Editor$PreviewStaticTable),
					A3($author$project$View$Widget$StaticTable$view, tree, subModel, context));
			case 1:
				var subModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Page$Widget$Editor$PreviewMsg, $author$project$Page$Widget$Editor$PreviewDynamicTable),
					A3($author$project$View$Widget$DynamicTable$view, tree, subModel, context));
			case 2:
				var subModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Page$Widget$Editor$PreviewMsg, $author$project$Page$Widget$Editor$PreviewDynamicList),
					A3($author$project$View$Widget$DynamicList$view, tree, subModel, context));
			default:
				var subModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Page$Widget$Editor$PreviewMsg, $author$project$Page$Widget$Editor$PreviewGeneric),
					A3($author$project$View$Widget$Generic$view, tree, subModel, context));
		}
	});
var $author$project$Page$Widget$Editor$widgetContext = {N: false};
var $author$project$Page$Widget$Editor$viewPreview = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel panel-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Preview')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Incident:'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-control'),
										A2($elm$html$Html$Attributes$style, 'display', 'inline'),
										$elm$html$Html$Attributes$value(model.bk),
										$elm$html$Html$Attributes$placeholder('UUID'),
										$elm$html$Html$Events$onInput($author$project$Page$Widget$Editor$SetInputIncidentId),
										A2($elm$html$Html$Attributes$style, 'margin', '0 10px 0 10px')
									]),
								_List_Nil),
								A3(
								$author$project$Util$Bootstrap$button,
								'btn-primary',
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Page$Widget$Editor$LoadPreviewIncident)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go')
									]))
							])),
						$author$project$Util$Html$verticalSpacer('30px'),
						function () {
						var _v0 = model.bF;
						switch (_v0.$) {
							case 3:
								var bundle = _v0.a;
								return A3($author$project$Page$Widget$Editor$viewWidget, bundle.cr, $author$project$Page$Widget$Editor$widgetContext, model.fg);
							case 1:
								return $elm$html$Html$text('loading...');
							case 0:
								return $elm$html$Html$text('');
							default:
								var error = _v0.a;
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(error)
										]));
						}
					}()
					]))
			]));
};
var $author$project$Page$Widget$Editor$view = function (model) {
	return {
		bX: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Widget$Editor$viewDialog(model),
					$author$project$Util$Bootstrap$centeredContainer(
					_List_fromArray(
						[
							$author$project$Util$Bootstrap$breadcrumbs(
							_List_fromArray(
								[
									$author$project$App$Route$Admin,
									$author$project$App$Route$EditWidgetCollection,
									$author$project$App$Route$EditWidgetSection(model.F),
									A2($author$project$App$Route$EditWidget, model.F, model.fg.bj)
								])),
							A2($author$project$View$Error$view, model.f$, $author$project$Page$Widget$Editor$DismissErrors),
							$author$project$Page$Widget$Editor$viewEdit(model),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							$author$project$Page$Widget$Editor$viewPreview(model),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							$author$project$View$Docs$helpBox(8)
						]))
				])),
		bO: 'Edit Widget - ' + model.fg.bO
	};
};
var $author$project$Page$Widget$SectionEditor$DismissErrors = {$: 0};
var $author$project$Page$Widget$SectionEditor$Save = {$: 1};
var $author$project$Page$Widget$SectionEditor$SetTitle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Widget$SectionEditor$ShowHideTypeDropdown = {$: 3};
var $author$project$Page$Widget$SectionEditor$newWidgetButtonDropdown = F2(
	function (sectionIndex, isOpen) {
		var viewItem = function (_v0) {
			var name = _v0.a;
			var widgetType = _v0.b;
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$App$Route$href(
								A2($author$project$App$Route$NewWidget, sectionIndex, widgetType))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		};
		var items = _List_fromArray(
			[
				_Utils_Tuple2('Static Table', 0),
				_Utils_Tuple2('Dynamic List', 1),
				_Utils_Tuple2('Dynamic Table', 2),
				_Utils_Tuple2('Generic JSON', 3)
			]);
		var dropdownVisibility = isOpen ? 'block' : 'none';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn-group'),
					$elm$html$Html$Attributes$id($author$project$Page$Widget$SectionEditor$newWidgetDropdownId)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-primary dropdown-toggle'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick($author$project$Page$Widget$SectionEditor$ShowHideTypeDropdown)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('New Widget'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('caret'),
									A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							A2($elm$html$Html$Attributes$style, 'display', dropdownVisibility)
						]),
					A2($elm$core$List$map, viewItem, items))
				]));
	});
var $author$project$Page$Widget$SectionEditor$SetPlatform = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Widget$SectionEditor$platformSpecToString = function (spec) {
	if (!spec.$) {
		return 'Any';
	} else {
		return 'Only...';
	}
};
var $author$project$Page$Widget$SectionEditor$viewPlatform = function (platformSpec) {
	var _v0 = function () {
		if (!platformSpec.$) {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$author$project$Data$Widget$AnyPlatform,
						$author$project$Data$Widget$SpecificPlatform('')
					]),
				$elm$html$Html$text(''));
		} else {
			var s = platformSpec.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[$author$project$Data$Widget$AnyPlatform, platformSpec]),
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(s),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$Page$Widget$SectionEditor$SetPlatform, $author$project$Data$Widget$SpecificPlatform))
						]),
					_List_Nil));
		}
	}();
	var items = _v0.a;
	var extra = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Util$Html$dropdownAdvanced(
				{fS: platformSpec, gw: $author$project$Page$Widget$SectionEditor$platformSpecToString, R: items, eA: $author$project$Page$Widget$SectionEditor$SetPlatform}),
				extra
			]));
};
var $author$project$Page$Widget$SectionEditor$MoveWidget = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$Widget$SectionEditor$PromptToDeleteWidget = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Widget$SectionEditor$viewRow = F3(
	function (sectionIndex, index, widget) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$App$Route$href(
									A2($author$project$App$Route$EditWidget, sectionIndex, widget.bj))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(widget.bO)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Util$Html$miniButtonBar(
							_List_fromArray(
								[
									_Utils_Tuple2(
									A2($author$project$Page$Widget$SectionEditor$MoveWidget, index, 0),
									$author$project$Util$Glyphs$triangleTop),
									_Utils_Tuple2(
									A2($author$project$Page$Widget$SectionEditor$MoveWidget, index, 1),
									$author$project$Util$Glyphs$triangleBottom),
									_Utils_Tuple2(
									$author$project$Page$Widget$SectionEditor$PromptToDeleteWidget(
										_Utils_Tuple2(index, widget.bO)),
									$author$project$Util$Glyphs$x)
								]))
						]))
				]));
	});
var $author$project$Page$Widget$SectionEditor$viewFormAndWidgets = F2(
	function (section, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '350px')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$View$Form$item,
					'Title',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control'),
									$elm$html$Html$Events$onInput($author$project$Page$Widget$SectionEditor$SetTitle),
									$elm$html$Html$Attributes$value(section.bO)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$View$Form$item,
					'Platform',
					_List_fromArray(
						[
							$author$project$Page$Widget$SectionEditor$viewPlatform(section.g6)
						])),
					$elm$core$List$isEmpty(section.cB) ? $author$project$View$EmptyStates$view('No widgets in this section yet') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '40px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Widgets')
								])),
							A3(
							$author$project$Util$Bootstrap$fixedWidthTable,
							_List_fromArray(
								[
									_Utils_Tuple2('Name', 65),
									_Utils_Tuple2('Actions', 35)
								]),
							$author$project$Page$Widget$SectionEditor$viewRow(model.F),
							section.cB)
						])),
					A2($author$project$Page$Widget$SectionEditor$newWidgetButtonDropdown, model.F, model.ak)
				]));
	});
var $author$project$Page$Widget$SectionEditor$viewContent = function (model) {
	var section = $author$project$SelectList$selected(model.hl);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Section'),
						model.cg ? A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' (saving...)')
							])) : $elm$html$Html$text(''),
						A3(
						$author$project$Util$Bootstrap$button,
						'btn-primary',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Page$Widget$SectionEditor$Save),
								$elm$html$Html$Attributes$class('pull-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					])),
				A2($author$project$Page$Widget$SectionEditor$viewFormAndWidgets, section, model),
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$View$Docs$helpBox(8)
			]));
};
var $author$project$Page$Widget$SectionEditor$CancelPrompt = {$: 9};
var $author$project$Page$Widget$SectionEditor$ConfirmDelete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Widget$SectionEditor$viewDeletePrompt = F2(
	function (index, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('panel panel-danger')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete Widget?')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Are you sure you want to delete widget \'' + (title + '\'?'))
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-default',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Page$Widget$SectionEditor$CancelPrompt)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Util$Bootstrap$button,
							'btn-danger',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Page$Widget$SectionEditor$ConfirmDelete(index)),
									$elm$html$Html$Attributes$class('pull-right')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Page$Widget$SectionEditor$view = function (model) {
	return {
		bX: $author$project$Util$Bootstrap$centeredContainer(
			_List_fromArray(
				[
					$author$project$Util$Bootstrap$breadcrumbs(
					_List_fromArray(
						[
							$author$project$App$Route$Admin,
							$author$project$App$Route$EditWidgetCollection,
							$author$project$App$Route$EditWidgetSection(model.F)
						])),
					A2($author$project$View$Error$view, model.f$, $author$project$Page$Widget$SectionEditor$DismissErrors),
					function () {
					var _v0 = model.aR;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var index = _v1.a;
						var title = _v1.b;
						return A2($author$project$Page$Widget$SectionEditor$viewDeletePrompt, index, title);
					} else {
						return $author$project$Page$Widget$SectionEditor$viewContent(model);
					}
				}()
				])),
		bO: 'Widget Section - ' + $elm$core$String$fromInt(model.F)
	};
};
var $author$project$App$Main$viewPage = F2(
	function (page, model) {
		var pageHelp = F3(
			function (subModel, toHtml, toPageMsg) {
				return A2(
					$author$project$TitledHtml$map,
					A2($elm$core$Basics$composeL, $author$project$App$Main$UpdatePage, toPageMsg),
					toHtml(subModel));
			});
		switch (page.$) {
			case 0:
				return {
					bX: $elm$html$Html$text(''),
					bO: ''
				};
			case 1:
				return {
					bX: $elm$html$Html$text('Page not found'),
					bO: 'Not Found'
				};
			case 2:
				var subModel = page.a;
				return $author$project$Page$Error$view(subModel);
			case 3:
				var subModel = page.a;
				return A3(
					pageHelp,
					subModel,
					$author$project$Page$Home$view(
						$author$project$App$UserUtil$hasNoTenant(model.Y)),
					$author$project$App$Main$HomeMsg);
			case 25:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Onboarding$view, $author$project$App$Main$OnboardingMsg);
			case 4:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Incident$List$view, $author$project$App$Main$IncidentListMsg);
			case 5:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Incident$view, $author$project$App$Main$IncidentMsg);
			case 28:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$LogFile$view, $author$project$App$Main$LogFileMsg);
			case 6:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$JoinTenantHelp$view, $author$project$App$Main$JoinTenantHelpMsg);
			case 7:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Timeline$view, $author$project$App$Main$TimelineMsg);
			case 8:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Classifier$List$view, $author$project$App$Main$ClassifierListMsg);
			case 9:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Classifier$Editor$view, $author$project$App$Main$ClassifierViewerMsg);
			case 10:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Classifier$Editor$view, $author$project$App$Main$ClassifierEditorMsg);
			case 11:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Remedy$List$view, $author$project$App$Main$RemedyListMsg);
			case 12:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Remedy$Editor$view, $author$project$App$Main$RemedyEditorMsg);
			case 13:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Remedy$Viewer$view, $author$project$App$Main$RemedyViewerMsg);
			case 14:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Remedy$History$view, $author$project$App$Main$RemedyHistoryMsg);
			case 15:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Admin$view, $author$project$App$Main$AdminMsg);
			case 16:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Widget$SectionEditor$view, $author$project$App$Main$SectionEditorMsg);
			case 17:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Widget$CollectionEditor$view, $author$project$App$Main$WidgetCollectionEditorMsg);
			case 18:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Widget$Editor$view, $author$project$App$Main$WidgetEditorMsg);
			case 19:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Capability$List$view, $author$project$App$Main$CapabilityListMsg);
			case 20:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Capability$Editor$view, $author$project$App$Main$CapabilityEditorMsg);
			case 21:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Scrubber$List$view, $author$project$App$Main$ScrubberListMsg);
			case 22:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Scrubber$Editor$view, $author$project$App$Main$ScrubberEditorMsg);
			case 23:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$AdvancedSearch$view, $author$project$App$Main$AdvancedSearchMsg);
			case 24:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Basement$view, $author$project$App$Main$BasementMsg);
			case 26:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$SdkList$view, $author$project$App$Main$SdkListMsg);
			case 27:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Docs$view, $author$project$App$Main$DocsMsg);
			case 30:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Configuration$List$view, $author$project$App$Main$LogConfigListMsg);
			case 29:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Configuration$Editor$view, $author$project$App$Main$LogConfigEditorMsg);
			case 31:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$News$view, $author$project$App$Main$NewsMsg);
			case 32:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Tenant$view, $author$project$App$Main$TenantSettingsMsg);
			case 33:
				var subModel = page.a;
				return $author$project$Page$Classifier$History$view(subModel);
			case 34:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Group$GroupList$view, $author$project$App$Main$GroupListMsg);
			case 35:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Group$GroupViewer$view, $author$project$App$Main$GroupViewerMsg);
			case 36:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Group$GroupCreator$view, $author$project$App$Main$GroupCreatorMsg);
			default:
				var subModel = page.a;
				return A3(pageHelp, subModel, $author$project$Page$Group$GroupEditor$view, $author$project$App$Main$GroupEditorMsg);
		}
	});
var $author$project$App$Main$viewProgressBarIfAny = function (shouldShow) {
	return $author$project$View$ProgressBar$viewSquareIf(shouldShow);
};
var $author$project$App$Main$view = function (model) {
	var inDangerZone = function () {
		var _v1 = $krisajenkins$remotedata$RemoteData$toMaybe(model.Y);
		if (!_v1.$) {
			var user = _v1.a;
			return $author$project$Data$User$isActingOnEntireSystem(user);
		} else {
			return false;
		}
	}();
	var _v0 = A2(
		$author$project$App$Main$viewPage,
		$author$project$App$Main$getPage(model.l),
		model);
	var title = _v0.bO;
	var body = _v0.bX;
	return {
		bX: $elm$core$List$singleton(
			model.aU ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('jumbotron')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Refreshing...')
									]))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$App$Main$viewNav(model),
						$author$project$App$Main$viewProgressBarIfAny(
						$author$project$App$Main$isLoading(model.l)),
						inDangerZone ? $author$project$Util$Bootstrap$centeredContainer(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('panel panel-warning')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('panel-heading')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('System Zone')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('panel-body')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You are now operating on system data that can affect all PowerLift customers/tenants. ' + 'Be careful out there!')
											]))
									]))
							])) : $elm$html$Html$text(''),
						body
					]))),
		bO: $elm$core$String$isEmpty(title) ? 'PowerLift' : ('PowerLift - ' + title)
	};
};
var $author$project$App$Main$main = $elm$browser$Browser$application(
	{gm: $author$project$App$Main$init, g0: $author$project$App$Main$ChangedUrl, g1: $author$project$App$Main$ClickedLink, ht: $author$project$App$Main$subscriptions, hP: $author$project$App$Main$update, hS: $author$project$App$Main$view});
_Platform_export({'App':{'Main':{'init':$author$project$App$Main$main($elm$json$Json$Decode$value)(0)}}});}(this));